
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree8ef"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree8ef"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2nzLi", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $1bb9784afa87e369$export$ffb0004e005737fa; }, function (v) { return $1bb9784afa87e369$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $1bb9784afa87e369$export$34b9dba7ce09269b; }, function (v) { return $1bb9784afa87e369$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $1bb9784afa87e369$export$25062201e9e25d76; }, function (v) { return $1bb9784afa87e369$export$25062201e9e25d76 = v; });
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1bb9784afa87e369$export$ffb0004e005737fa;
var $1bb9784afa87e369$export$34b9dba7ce09269b;
var $1bb9784afa87e369$export$25062201e9e25d76;
'use strict';
parcelRequire("013Yp");

var $7fPBF = parcelRequire("7fPBF");
var $1bb9784afa87e369$var$g = 60103;
$1bb9784afa87e369$export$ffb0004e005737fa = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var $1bb9784afa87e369$var$h = Symbol.for;
    $1bb9784afa87e369$var$g = $1bb9784afa87e369$var$h("react.element");
    $1bb9784afa87e369$export$ffb0004e005737fa = $1bb9784afa87e369$var$h("react.fragment");
}
var $1bb9784afa87e369$var$m = $7fPBF.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $1bb9784afa87e369$var$n = Object.prototype.hasOwnProperty, $1bb9784afa87e369$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1bb9784afa87e369$var$q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)$1bb9784afa87e369$var$n.call(a, b) && !$1bb9784afa87e369$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $1bb9784afa87e369$var$g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: $1bb9784afa87e369$var$m.current
    };
}
$1bb9784afa87e369$export$34b9dba7ce09269b = $1bb9784afa87e369$var$q;
$1bb9784afa87e369$export$25062201e9e25d76 = $1bb9784afa87e369$var$q;

});
parcelRegister("013Yp", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $00332d224329ec89$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $00332d224329ec89$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $00332d224329ec89$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $00332d224329ec89$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $00332d224329ec89$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $00332d224329ec89$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $00332d224329ec89$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($00332d224329ec89$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($00332d224329ec89$var$getOwnPropertySymbols) {
            symbols = $00332d224329ec89$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($00332d224329ec89$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("7fPBF", function(module, exports) {
'use strict';

module.exports = (parcelRequire("fSPLm"));

});
parcelRegister("fSPLm", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $b9040d2deeb360f4$export$ffb0004e005737fa; }, function (v) { return $b9040d2deeb360f4$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "StrictMode", function () { return $b9040d2deeb360f4$export$5f8d39834fd61797; }, function (v) { return $b9040d2deeb360f4$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Profiler", function () { return $b9040d2deeb360f4$export$e2c29f18771995cb; }, function (v) { return $b9040d2deeb360f4$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "Suspense", function () { return $b9040d2deeb360f4$export$74bf444e3cd11ea5; }, function (v) { return $b9040d2deeb360f4$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "Children", function () { return $b9040d2deeb360f4$export$dca3b0875bd9a954; }, function (v) { return $b9040d2deeb360f4$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $b9040d2deeb360f4$export$16fa2f45be04daa8; }, function (v) { return $b9040d2deeb360f4$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "PureComponent", function () { return $b9040d2deeb360f4$export$221d75b3f55bb0bd; }, function (v) { return $b9040d2deeb360f4$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b9040d2deeb360f4$export$ae55be85d98224ed; }, function (v) { return $b9040d2deeb360f4$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $b9040d2deeb360f4$export$e530037191fcd5d7; }, function (v) { return $b9040d2deeb360f4$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $b9040d2deeb360f4$export$fd42f52fd3ae1109; }, function (v) { return $b9040d2deeb360f4$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $b9040d2deeb360f4$export$c8a8987d4410bf2d; }, function (v) { return $b9040d2deeb360f4$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $b9040d2deeb360f4$export$d38cd72104c1f0e9; }, function (v) { return $b9040d2deeb360f4$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $b9040d2deeb360f4$export$7d1e3a5e95ceca43; }, function (v) { return $b9040d2deeb360f4$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $b9040d2deeb360f4$export$257a8862b851cb5b; }, function (v) { return $b9040d2deeb360f4$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $b9040d2deeb360f4$export$a8257692ac88316c; }, function (v) { return $b9040d2deeb360f4$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $b9040d2deeb360f4$export$488013bae63b21da; }, function (v) { return $b9040d2deeb360f4$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $b9040d2deeb360f4$export$7c73462e0d25e514; }, function (v) { return $b9040d2deeb360f4$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "useCallback", function () { return $b9040d2deeb360f4$export$35808ee640e87ca7; }, function (v) { return $b9040d2deeb360f4$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $b9040d2deeb360f4$export$fae74005e78b1a27; }, function (v) { return $b9040d2deeb360f4$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $b9040d2deeb360f4$export$dc8fbce3eb94dc1e; }, function (v) { return $b9040d2deeb360f4$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useEffect", function () { return $b9040d2deeb360f4$export$6d9c69b0de29b591; }, function (v) { return $b9040d2deeb360f4$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $b9040d2deeb360f4$export$d5a552a76deda3c2; }, function (v) { return $b9040d2deeb360f4$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $b9040d2deeb360f4$export$e5c5a5f917a5871c; }, function (v) { return $b9040d2deeb360f4$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $b9040d2deeb360f4$export$1538c33de8887b59; }, function (v) { return $b9040d2deeb360f4$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $b9040d2deeb360f4$export$13e3392192263954; }, function (v) { return $b9040d2deeb360f4$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $b9040d2deeb360f4$export$b8f5890fc79d6aca; }, function (v) { return $b9040d2deeb360f4$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $b9040d2deeb360f4$export$60241385465d0a34; }, function (v) { return $b9040d2deeb360f4$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "version", function () { return $b9040d2deeb360f4$export$83d89fbfd8236492; }, function (v) { return $b9040d2deeb360f4$export$83d89fbfd8236492 = v; });
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b9040d2deeb360f4$export$ffb0004e005737fa;
var $b9040d2deeb360f4$export$5f8d39834fd61797;
var $b9040d2deeb360f4$export$e2c29f18771995cb;
var $b9040d2deeb360f4$export$74bf444e3cd11ea5;
var $b9040d2deeb360f4$export$dca3b0875bd9a954;
var $b9040d2deeb360f4$export$16fa2f45be04daa8;
var $b9040d2deeb360f4$export$221d75b3f55bb0bd;
var $b9040d2deeb360f4$export$ae55be85d98224ed;
var $b9040d2deeb360f4$export$e530037191fcd5d7;
var $b9040d2deeb360f4$export$fd42f52fd3ae1109;
var $b9040d2deeb360f4$export$c8a8987d4410bf2d;
var $b9040d2deeb360f4$export$d38cd72104c1f0e9;
var $b9040d2deeb360f4$export$7d1e3a5e95ceca43;
var $b9040d2deeb360f4$export$257a8862b851cb5b;
var $b9040d2deeb360f4$export$a8257692ac88316c;
var $b9040d2deeb360f4$export$488013bae63b21da;
var $b9040d2deeb360f4$export$7c73462e0d25e514;
var $b9040d2deeb360f4$export$35808ee640e87ca7;
var $b9040d2deeb360f4$export$fae74005e78b1a27;
var $b9040d2deeb360f4$export$dc8fbce3eb94dc1e;
var $b9040d2deeb360f4$export$6d9c69b0de29b591;
var $b9040d2deeb360f4$export$d5a552a76deda3c2;
var $b9040d2deeb360f4$export$e5c5a5f917a5871c;
var $b9040d2deeb360f4$export$1538c33de8887b59;
var $b9040d2deeb360f4$export$13e3392192263954;
var $b9040d2deeb360f4$export$b8f5890fc79d6aca;
var $b9040d2deeb360f4$export$60241385465d0a34;
var $b9040d2deeb360f4$export$83d89fbfd8236492;
'use strict';

var $013Yp = parcelRequire("013Yp");
var $b9040d2deeb360f4$var$n = 60103, $b9040d2deeb360f4$var$p = 60106;
$b9040d2deeb360f4$export$ffb0004e005737fa = 60107;
$b9040d2deeb360f4$export$5f8d39834fd61797 = 60108;
$b9040d2deeb360f4$export$e2c29f18771995cb = 60114;
var $b9040d2deeb360f4$var$q = 60109, $b9040d2deeb360f4$var$r = 60110, $b9040d2deeb360f4$var$t = 60112;
$b9040d2deeb360f4$export$74bf444e3cd11ea5 = 60113;
var $b9040d2deeb360f4$var$u = 60115, $b9040d2deeb360f4$var$v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var $b9040d2deeb360f4$var$w = Symbol.for;
    $b9040d2deeb360f4$var$n = $b9040d2deeb360f4$var$w("react.element");
    $b9040d2deeb360f4$var$p = $b9040d2deeb360f4$var$w("react.portal");
    $b9040d2deeb360f4$export$ffb0004e005737fa = $b9040d2deeb360f4$var$w("react.fragment");
    $b9040d2deeb360f4$export$5f8d39834fd61797 = $b9040d2deeb360f4$var$w("react.strict_mode");
    $b9040d2deeb360f4$export$e2c29f18771995cb = $b9040d2deeb360f4$var$w("react.profiler");
    $b9040d2deeb360f4$var$q = $b9040d2deeb360f4$var$w("react.provider");
    $b9040d2deeb360f4$var$r = $b9040d2deeb360f4$var$w("react.context");
    $b9040d2deeb360f4$var$t = $b9040d2deeb360f4$var$w("react.forward_ref");
    $b9040d2deeb360f4$export$74bf444e3cd11ea5 = $b9040d2deeb360f4$var$w("react.suspense");
    $b9040d2deeb360f4$var$u = $b9040d2deeb360f4$var$w("react.memo");
    $b9040d2deeb360f4$var$v = $b9040d2deeb360f4$var$w("react.lazy");
}
var $b9040d2deeb360f4$var$x = "function" === typeof Symbol && Symbol.iterator;
function $b9040d2deeb360f4$var$y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b9040d2deeb360f4$var$x && a[$b9040d2deeb360f4$var$x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $b9040d2deeb360f4$var$z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $b9040d2deeb360f4$var$A = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $b9040d2deeb360f4$var$B = {};
function $b9040d2deeb360f4$var$C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $b9040d2deeb360f4$var$B;
    this.updater = c || $b9040d2deeb360f4$var$A;
}
$b9040d2deeb360f4$var$C.prototype.isReactComponent = {};
$b9040d2deeb360f4$var$C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($b9040d2deeb360f4$var$z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$b9040d2deeb360f4$var$C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $b9040d2deeb360f4$var$D() {}
$b9040d2deeb360f4$var$D.prototype = $b9040d2deeb360f4$var$C.prototype;
function $b9040d2deeb360f4$var$E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $b9040d2deeb360f4$var$B;
    this.updater = c || $b9040d2deeb360f4$var$A;
}
var $b9040d2deeb360f4$var$F = $b9040d2deeb360f4$var$E.prototype = new $b9040d2deeb360f4$var$D;
$b9040d2deeb360f4$var$F.constructor = $b9040d2deeb360f4$var$E;
$013Yp($b9040d2deeb360f4$var$F, $b9040d2deeb360f4$var$C.prototype);
$b9040d2deeb360f4$var$F.isPureReactComponent = !0;
var $b9040d2deeb360f4$var$G = {
    current: null
}, $b9040d2deeb360f4$var$H = Object.prototype.hasOwnProperty, $b9040d2deeb360f4$var$I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $b9040d2deeb360f4$var$J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$b9040d2deeb360f4$var$H.call(b, e) && !$b9040d2deeb360f4$var$I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: $b9040d2deeb360f4$var$n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: $b9040d2deeb360f4$var$G.current
    };
}
function $b9040d2deeb360f4$var$K(a, b) {
    return {
        $$typeof: $b9040d2deeb360f4$var$n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $b9040d2deeb360f4$var$L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $b9040d2deeb360f4$var$n;
}
function $b9040d2deeb360f4$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $b9040d2deeb360f4$var$M = /\/+/g;
function $b9040d2deeb360f4$var$N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $b9040d2deeb360f4$var$escape("" + a.key) : b.toString(36);
}
function $b9040d2deeb360f4$var$O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $b9040d2deeb360f4$var$n:
                case $b9040d2deeb360f4$var$p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + $b9040d2deeb360f4$var$N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace($b9040d2deeb360f4$var$M, "$&/") + "/"), $b9040d2deeb360f4$var$O(d, b, c, "", function(a) {
        return a;
    })) : null != d && ($b9040d2deeb360f4$var$L(d) && (d = $b9040d2deeb360f4$var$K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace($b9040d2deeb360f4$var$M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + $b9040d2deeb360f4$var$N(k, g);
        h += $b9040d2deeb360f4$var$O(k, b, c, f, d);
    }
    else if (f = $b9040d2deeb360f4$var$y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + $b9040d2deeb360f4$var$N(k, g++), h += $b9040d2deeb360f4$var$O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error($b9040d2deeb360f4$var$z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function $b9040d2deeb360f4$var$P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    $b9040d2deeb360f4$var$O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function $b9040d2deeb360f4$var$Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var $b9040d2deeb360f4$var$R = {
    current: null
};
function $b9040d2deeb360f4$var$S() {
    var a = $b9040d2deeb360f4$var$R.current;
    if (null === a) throw Error($b9040d2deeb360f4$var$z(321));
    return a;
}
var $b9040d2deeb360f4$var$T = {
    ReactCurrentDispatcher: $b9040d2deeb360f4$var$R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: $b9040d2deeb360f4$var$G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $013Yp
};
$b9040d2deeb360f4$export$dca3b0875bd9a954 = {
    map: $b9040d2deeb360f4$var$P,
    forEach: function(a, b, c) {
        $b9040d2deeb360f4$var$P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        $b9040d2deeb360f4$var$P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $b9040d2deeb360f4$var$P(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$b9040d2deeb360f4$var$L(a)) throw Error($b9040d2deeb360f4$var$z(143));
        return a;
    }
};
$b9040d2deeb360f4$export$16fa2f45be04daa8 = $b9040d2deeb360f4$var$C;
$b9040d2deeb360f4$export$221d75b3f55bb0bd = $b9040d2deeb360f4$var$E;
$b9040d2deeb360f4$export$ae55be85d98224ed = $b9040d2deeb360f4$var$T;
$b9040d2deeb360f4$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($b9040d2deeb360f4$var$z(267, a));
    var e = $013Yp({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $b9040d2deeb360f4$var$G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$b9040d2deeb360f4$var$H.call(b, f) && !$b9040d2deeb360f4$var$I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: $b9040d2deeb360f4$var$n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
$b9040d2deeb360f4$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $b9040d2deeb360f4$var$r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $b9040d2deeb360f4$var$q,
        _context: a
    };
    return a.Consumer = a;
};
$b9040d2deeb360f4$export$c8a8987d4410bf2d = $b9040d2deeb360f4$var$J;
$b9040d2deeb360f4$export$d38cd72104c1f0e9 = function(a) {
    var b = $b9040d2deeb360f4$var$J.bind(null, a);
    b.type = a;
    return b;
};
$b9040d2deeb360f4$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$b9040d2deeb360f4$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $b9040d2deeb360f4$var$t,
        render: a
    };
};
$b9040d2deeb360f4$export$a8257692ac88316c = $b9040d2deeb360f4$var$L;
$b9040d2deeb360f4$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $b9040d2deeb360f4$var$v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $b9040d2deeb360f4$var$Q
    };
};
$b9040d2deeb360f4$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $b9040d2deeb360f4$var$u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$b9040d2deeb360f4$export$35808ee640e87ca7 = function(a, b) {
    return $b9040d2deeb360f4$var$S().useCallback(a, b);
};
$b9040d2deeb360f4$export$fae74005e78b1a27 = function(a, b) {
    return $b9040d2deeb360f4$var$S().useContext(a, b);
};
$b9040d2deeb360f4$export$dc8fbce3eb94dc1e = function() {};
$b9040d2deeb360f4$export$6d9c69b0de29b591 = function(a, b) {
    return $b9040d2deeb360f4$var$S().useEffect(a, b);
};
$b9040d2deeb360f4$export$d5a552a76deda3c2 = function(a, b, c) {
    return $b9040d2deeb360f4$var$S().useImperativeHandle(a, b, c);
};
$b9040d2deeb360f4$export$e5c5a5f917a5871c = function(a, b) {
    return $b9040d2deeb360f4$var$S().useLayoutEffect(a, b);
};
$b9040d2deeb360f4$export$1538c33de8887b59 = function(a, b) {
    return $b9040d2deeb360f4$var$S().useMemo(a, b);
};
$b9040d2deeb360f4$export$13e3392192263954 = function(a, b, c) {
    return $b9040d2deeb360f4$var$S().useReducer(a, b, c);
};
$b9040d2deeb360f4$export$b8f5890fc79d6aca = function(a) {
    return $b9040d2deeb360f4$var$S().useRef(a);
};
$b9040d2deeb360f4$export$60241385465d0a34 = function(a) {
    return $b9040d2deeb360f4$var$S().useState(a);
};
$b9040d2deeb360f4$export$83d89fbfd8236492 = "17.0.2";

});



parcelRegister("6EA3T", function(module, exports) {
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $7fPBF = parcelRequire("7fPBF");

var $013Yp = parcelRequire("013Yp");

var $33s19 = parcelRequire("33s19");
function y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$7fPBF) throw Error(y(227));
var ba = new Set, ca = {};
function da(a, b) {
    ea(a, b);
    ea(a + "Capture", b);
}
function ea(a, b) {
    ca[a] = b;
    for(a = 0; a < b.length; a++)ba.add(b[a]);
}
var fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, ia = Object.prototype.hasOwnProperty, ja = {}, ka = {};
function la(a) {
    if (ia.call(ka, a)) return !0;
    if (ia.call(ja, a)) return !1;
    if (ha.test(a)) return ka[a] = !0;
    ja[a] = !0;
    return !1;
}
function ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    D[a] = new B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    D[b] = new B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    D[a] = new B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    D[a] = new B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    D[a] = new B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    D[a] = new B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    D[a] = new B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var oa = /[\-:]([a-z])/g;
function pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
D.xlinkHref = new B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function qa(a, b, c, d) {
    var e = D.hasOwnProperty(b) ? D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (na(b, c, e, d) && (c = null), d || null === e ? la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var ra = $7fPBF.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, sa = 60103, ta = 60106, ua = 60107, wa = 60108, xa = 60114, ya = 60109, za = 60110, Aa = 60112, Ba = 60113, Ca = 60120, Da = 60115, Ea = 60116, Fa = 60121, Ga = 60128, Ha = 60129, Ia = 60130, Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var E = Symbol.for;
    sa = E("react.element");
    ta = E("react.portal");
    ua = E("react.fragment");
    wa = E("react.strict_mode");
    xa = E("react.profiler");
    ya = E("react.provider");
    za = E("react.context");
    Aa = E("react.forward_ref");
    Ba = E("react.suspense");
    Ca = E("react.suspense_list");
    Da = E("react.memo");
    Ea = E("react.lazy");
    Fa = E("react.block");
    E("react.scope");
    Ga = E("react.opaque.id");
    Ha = E("react.debug_trace_mode");
    Ia = E("react.offscreen");
    Ja = E("react.legacy_hidden");
}
var Ka = "function" === typeof Symbol && Symbol.iterator;
function La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ka && a[Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var Ma;
function Na(a) {
    if (void 0 === Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        Ma = b && b[1] || "";
    }
    return "\n" + Ma + a;
}
var Oa = !1;
function Pa(a, b) {
    if (!a || Oa) return "";
    Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Na(a) : "";
}
function Qa(a) {
    switch(a.tag){
        case 5:
            return Na(a.type);
        case 16:
            return Na("Lazy");
        case 13:
            return Na("Suspense");
        case 19:
            return Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Pa(a.type, !1), a;
        case 11:
            return a = Pa(a.type.render, !1), a;
        case 22:
            return a = Pa(a.type._render, !1), a;
        case 1:
            return a = Pa(a.type, !0), a;
        default:
            return "";
    }
}
function Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ua:
            return "Fragment";
        case ta:
            return "Portal";
        case xa:
            return "Profiler";
        case wa:
            return "StrictMode";
        case Ba:
            return "Suspense";
        case Ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case za:
            return (a.displayName || "Context") + ".Consumer";
        case ya:
            return (a._context.displayName || "Context") + ".Provider";
        case Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case Da:
            return Ra(a.type);
        case Fa:
            return Ra(a._render);
        case Ea:
            b = a._payload;
            a = a._init;
            try {
                return Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return $013Yp({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a(a, b) {
    b = b.checked;
    null != b && qa(a, "checked", b, !1);
}
function ab(a, b) {
    $a(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function bb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function db(a) {
    var b = "";
    $7fPBF.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function eb(a, b) {
    a = $013Yp({
        children: void 0
    }, b);
    if (b = db(b.children)) a.children = b;
    return a;
}
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(y(91));
    return $013Yp({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var nb, ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        nb = nb || document.createElement("div");
        nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(qb).forEach(function(a) {
    rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        qb[b] = qb[a];
    });
});
function sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || qb.hasOwnProperty(a) && qb[a] ? ("" + b).trim() : b + "px";
}
function tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var ub = $013Yp({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function vb(a, b) {
    if (b) {
        if (ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(y(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(y(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(y(62));
    }
}
function wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(y(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ib() {}
var Jb = Gb, Kb = !1, Lb = !1;
function Mb() {
    if (null !== zb || null !== Ab) Ib(), Fb();
}
function Nb(a, b, c) {
    if (Lb) return a(b, c);
    Lb = !0;
    try {
        return Jb(a, b, c);
    } finally{
        Lb = !1, Mb();
    }
}
function Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(y(231, b, typeof c));
    return c;
}
var Pb = !1;
if (fa) try {
    var Qb = {};
    Object.defineProperty(Qb, "passive", {
        get: function() {
            Pb = !0;
        }
    });
    window.addEventListener("test", Qb, Qb);
    window.removeEventListener("test", Qb, Qb);
} catch (a) {
    Pb = !1;
}
function Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var Sb = !1, Tb = null, Ub = !1, Vb = null, Wb = {
    onError: function(a) {
        Sb = !0;
        Tb = a;
    }
};
function Xb(a, b, c, d, e, f, g, h, k) {
    Sb = !1;
    Tb = null;
    Rb.apply(Wb, arguments);
}
function Yb(a, b, c, d, e, f, g, h, k) {
    Xb.apply(this, arguments);
    if (Sb) {
        if (Sb) {
            var l = Tb;
            Sb = !1;
            Tb = null;
        } else throw Error(y(198));
        Ub || (Ub = !0, Vb = l);
    }
}
function Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function ac(a) {
    if (Zb(a) !== a) throw Error(y(188));
}
function bc(a) {
    var b = a.alternate;
    if (!b) {
        b = Zb(a);
        if (null === b) throw Error(y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return ac(e), a;
                if (f === d) return ac(e), b;
                f = f.sibling;
            }
            throw Error(y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(y(189));
            }
        }
        if (c.alternate !== d) throw Error(y(190));
    }
    if (3 !== c.tag) throw Error(y(188));
    return c.stateNode.current === c ? a : b;
}
function cc(a) {
    a = bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var ec, fc, gc, hc, ic = !1, jc = [], kc = null, lc = null, mc = null, nc = new Map, oc = new Map, pc = [], qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            kc = null;
            break;
        case "dragenter":
        case "dragleave":
            lc = null;
            break;
        case "mouseover":
        case "mouseout":
            mc = null;
            break;
        case "pointerover":
        case "pointerout":
            nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            oc.delete(b.pointerId);
    }
}
function tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = rc(b, c, d, e, f), null !== b && (b = Cb(b), null !== b && fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return kc = tc(kc, a, b, c, d, e), !0;
        case "dragenter":
            return lc = tc(lc, a, b, c, d, e), !0;
        case "mouseover":
            return mc = tc(mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            nc.set(f, tc(nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, oc.set(f, tc(oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function vc(a) {
    var b = wc(a.target);
    if (null !== b) {
        var c = Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b(c), null !== b) {
                    a.blockedOn = b;
                    hc(a.lanePriority, function() {
                        $33s19.unstable_runWithPriority(a.priority, function() {
                            gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = Cb(c), null !== b && fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function zc(a, b, c) {
    xc(a) && c.delete(b);
}
function Ac() {
    for(ic = !1; 0 < jc.length;){
        var a = jc[0];
        if (null !== a.blockedOn) {
            a = Cb(a.blockedOn);
            null !== a && ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && jc.shift();
    }
    null !== kc && xc(kc) && (kc = null);
    null !== lc && xc(lc) && (lc = null);
    null !== mc && xc(mc) && (mc = null);
    nc.forEach(zc);
    oc.forEach(zc);
}
function Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, ic || (ic = !0, $33s19.unstable_scheduleCallback($33s19.unstable_NormalPriority, Ac)));
}
function Cc(a) {
    function b(b) {
        return Bc(b, a);
    }
    if (0 < jc.length) {
        Bc(jc[0], a);
        for(var c = 1; c < jc.length; c++){
            var d = jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== kc && Bc(kc, a);
    null !== lc && Bc(lc, a);
    null !== mc && Bc(mc, a);
    nc.forEach(b);
    oc.forEach(b);
    for(c = 0; c < pc.length; c++)d = pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < pc.length && (c = pc[0], null === c.blockedOn);)vc(c), null === c.blockedOn && pc.shift();
}
function Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Ec = {
    animationend: Dc("Animation", "AnimationEnd"),
    animationiteration: Dc("Animation", "AnimationIteration"),
    animationstart: Dc("Animation", "AnimationStart"),
    transitionend: Dc("Transition", "TransitionEnd")
}, Fc = {}, Gc = {};
fa && (Gc = document.createElement("div").style, "AnimationEvent" in window || (delete Ec.animationend.animation, delete Ec.animationiteration.animation, delete Ec.animationstart.animation), "TransitionEvent" in window || delete Ec.transitionend.transition);
function Hc(a) {
    if (Fc[a]) return Fc[a];
    if (!Ec[a]) return a;
    var b = Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Gc) return Fc[a] = b[c];
    return a;
}
var Ic = Hc("animationend"), Jc = Hc("animationiteration"), Kc = Hc("animationstart"), Lc = Hc("transitionend"), Mc = new Map, Nc = new Map, Oc = [
    "abort",
    "abort",
    Ic,
    "animationEnd",
    Jc,
    "animationIteration",
    Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        Nc.set(d, b);
        Mc.set(d, e);
        da(e, [
            d
        ]);
    }
}
var Qc = $33s19.unstable_now;
Qc();
var F = 8;
function Rc(a) {
    if (0 !== (1 & a)) return F = 15, 1;
    if (0 !== (2 & a)) return F = 14, 2;
    if (0 !== (4 & a)) return F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return F = 12, b;
    if (0 !== (a & 32)) return F = 11, 32;
    b = 192 & a;
    if (0 !== b) return F = 10, b;
    if (0 !== (a & 256)) return F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return F = 8, b;
    if (0 !== (a & 4096)) return F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return F = 5, b;
    if (a & 67108864) return F = 4, 67108864;
    if (0 !== (a & 134217728)) return F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return F = 2, b;
    if (0 !== (1073741824 & a)) return F = 1, 1073741824;
    F = 8;
    return a;
}
function Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error(y(358, a));
    }
}
function Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = Rc(k), e = F) : (h &= f, 0 !== h && (d = Rc(h), e = F));
    } else f = c & ~g, 0 !== f ? (d = Rc(f), e = F) : 0 !== h && (d = Rc(h), e = F);
    if (0 === d) return 0;
    d = 31 - Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        Rc(b);
        if (e <= F) return b;
        F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = Yc(24 & ~b), 0 === a ? Xc(10, b) : a;
        case 10:
            return a = Yc(192 & ~b), 0 === a ? Xc(8, b) : a;
        case 8:
            return a = Yc(3584 & ~b), 0 === a && (a = Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error(y(358, a));
}
function Yc(a) {
    return a & -a;
}
function Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - Vc(b);
    a[b] = c;
}
var Vc = Math.clz32 ? Math.clz32 : ad, bd = Math.log, cd = Math.LN2;
function ad(a) {
    return 0 === a ? 32 : 31 - (bd(a) / cd | 0) | 0;
}
var dd = $33s19.unstable_UserBlockingPriority, ed = $33s19.unstable_runWithPriority, fd = !0;
function gd(a, b, c, d) {
    Kb || Ib();
    var e = hd, f = Kb;
    Kb = !0;
    try {
        Hb(e, a, b, c, d);
    } finally{
        (Kb = f) || Mb();
    }
}
function id(a, b, c, d) {
    ed(dd, hd.bind(null, a, b, c, d));
}
function hd(a, b, c, d) {
    if (fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < jc.length && -1 < qc.indexOf(a)) a = rc(null, a, b, c, d), jc.push(a);
        else {
            var f = yc(a, b, c, d);
            if (null === f) e && sc(a, d);
            else {
                if (e) {
                    if (-1 < qc.indexOf(a)) {
                        a = rc(f, a, b, c, d);
                        jc.push(a);
                        return;
                    }
                    if (uc(f, a, b, c, d)) return;
                    sc(a, d);
                }
                jd(a, b, d, null, c);
            }
        }
    }
}
function yc(a, b, c, d) {
    var e = xb(d);
    e = wc(e);
    if (null !== e) {
        var f = Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    jd(a, b, d, e, c);
    return null;
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    $013Yp(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = $013Yp({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = $013Yp({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = $013Yp({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = $013Yp({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = $013Yp({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = $013Yp({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = $013Yp({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = $013Yp({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = $013Yp({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = $013Yp({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = $013Yp({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = $013Yp({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = fa && "CompositionEvent" in window, be = null;
fa && "documentMode" in document && (be = document.documentMode);
var ce = fa && "TextEvent" in window && !be, de = fa && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (fa) {
    var xe;
    if (fa) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        a = re;
        if (Kb) a(b);
        else {
            Kb = !0;
            try {
                Gb(a, b);
            } finally{
                Kb = !1, Mb();
            }
        }
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge, Ie = Object.prototype.hasOwnProperty;
function Je(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!Ie.call(b, c[d]) || !He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Le(a, b) {
    var c = Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Ke(c);
    }
}
function Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Ne() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var Pe = fa && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Je(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
Pc(Oc, 2);
for(var Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), We = 0; We < Ve.length; We++)Nc.set(Ve[We], 0);
ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
        }
    }
    if (Ub) throw a = Vb, Ub = !1, Vb = null, a;
}
function G(a, b) {
    var c = $e(b), d = a + "__bubble";
    c.has(d) || (af(b, a, 2, !1), c.add(d));
}
var bf = "_reactListening" + Math.random().toString(36).slice(2);
function cf(a) {
    a[bf] || (a[bf] = !0, ba.forEach(function(b) {
        Ye.has(b) || df(b, !1, a, null);
        df(b, !0, a, null);
    }));
}
function df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), af(f, a, e, b), g.add(h));
}
function af(a, b, c, d) {
    var e = Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = gd;
            break;
        case 1:
            e = id;
            break;
        default:
            e = hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Nb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = Mc.get(a);
            if (void 0 !== h) {
                var k = td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case Ic:
                    case Jc:
                    case Kc:
                        k = Hd;
                        break;
                    case Lc:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = Ob(t, u), null != v && w.push(ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && (wc(x) || x[ff])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = d, x = x ? wc(x) : null, null !== x && (z = Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = d;
                    if (k !== x) {
                        w = Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : ue(k);
                        q = null == x ? h : ue(x);
                        h = new w(v, t + "leave", k, c, e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = gf(q))t++;
                            q = 0;
                            for(v = u; v; v = gf(v))q++;
                            for(; 0 < t - q;)w = gf(w), t--;
                            for(; 0 < q - t;)u = gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = gf(w);
                                u = gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && hf(g, h, k, w, !1);
                        null !== x && null !== z && hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = ve;
                else if (me(h)) {
                    if (we) J = Fe;
                    else {
                        J = De;
                        var K = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = Ee);
                if (J && (J = J(a, d))) {
                    ne(g, J, c, e);
                    break a;
                }
                K && K(a, h, d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && bb(h, "number", h.value);
            }
            K = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(K) || "true" === K.contentEditable) Qe = K, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var Q;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else ie ? ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && ie && (Q = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), K = oe(d, L), 0 < K.length && (L = new Ld(L, a, null, c, e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = he(c), null !== Q && (L.data = Q))));
            if (Q = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = Q);
        }
        se(g, b);
    });
}
function ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Ob(a, c), null != f && d.unshift(ef(a, f, e)), f = Ob(a, b), null != f && d.push(ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Ob(c, f), null != k && g.unshift(ef(c, k, h))) : e || (k = Ob(c, f), null != k && g.push(ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function jf() {}
var kf = null, lf = null;
function mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var of = "function" === typeof setTimeout ? setTimeout : void 0, pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var tf = 0;
function uf(a) {
    return {
        $$typeof: Ga,
        toString: a,
        valueOf: a
    };
}
var vf = Math.random().toString(36).slice(2), wf = "__reactFiber$" + vf, xf = "__reactProps$" + vf, ff = "__reactContainer$" + vf, yf = "__reactEvents$" + vf;
function wc(a) {
    var b = a[wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[ff] || c[wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = sf(a); null !== a;){
                if (c = a[wf]) return c;
                a = sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[wf] || a[ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(y(33));
}
function Db(a) {
    return a[xf] || null;
}
function $e(a) {
    var b = a[yf];
    void 0 === b && (b = a[yf] = new Set);
    return b;
}
var zf = [], Af = -1;
function Bf(a) {
    return {
        current: a
    };
}
function H(a) {
    0 > Af || (a.current = zf[Af], zf[Af] = null, Af--);
}
function I(a, b) {
    Af++;
    zf[Af] = a.current;
    a.current = b;
}
var Cf = {}, M = Bf(Cf), N = Bf(!1), Df = Cf;
function Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Gf() {
    H(N);
    H(M);
}
function Hf(a, b, c) {
    if (M.current !== Cf) throw Error(y(168));
    I(M, b);
    I(N, c);
}
function If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(y(108, Ra(b) || "Unknown", e));
    return $013Yp({}, c, d);
}
function Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Cf;
    Df = M.current;
    I(M, a);
    I(N, N.current);
    return !0;
}
function Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(y(169));
    c ? (a = If(a, b, Df), d.__reactInternalMemoizedMergedChildContext = a, H(N), H(M), I(M, a)) : H(N);
    I(N, c);
}
var Lf = null, Mf = null, Nf = $33s19.unstable_runWithPriority, Of = $33s19.unstable_scheduleCallback, Pf = $33s19.unstable_cancelCallback, Qf = $33s19.unstable_shouldYield, Rf = $33s19.unstable_requestPaint, Sf = $33s19.unstable_now, Tf = $33s19.unstable_getCurrentPriorityLevel, Uf = $33s19.unstable_ImmediatePriority, Vf = $33s19.unstable_UserBlockingPriority, Wf = $33s19.unstable_NormalPriority, Xf = $33s19.unstable_LowPriority, Yf = $33s19.unstable_IdlePriority, Zf = {}, $f = void 0 !== Rf ? Rf : function() {}, ag = null, bg = null, cg = !1, dg = Sf(), O = 1E4 > dg ? Sf : function() {
    return Sf() - dg;
};
function eg() {
    switch(Tf()){
        case Uf:
            return 99;
        case Vf:
            return 98;
        case Wf:
            return 97;
        case Xf:
            return 96;
        case Yf:
            return 95;
        default:
            throw Error(y(332));
    }
}
function fg(a) {
    switch(a){
        case 99:
            return Uf;
        case 98:
            return Vf;
        case 97:
            return Wf;
        case 96:
            return Xf;
        case 95:
            return Yf;
        default:
            throw Error(y(332));
    }
}
function gg(a, b) {
    a = fg(a);
    return Nf(a, b);
}
function hg(a, b, c) {
    a = fg(a);
    return Of(a, b, c);
}
function ig() {
    if (null !== bg) {
        var a = bg;
        bg = null;
        Pf(a);
    }
    jg();
}
function jg() {
    if (!cg && null !== ag) {
        cg = !0;
        var a = 0;
        try {
            var b = ag;
            gg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            ag = null;
        } catch (c) {
            throw null !== ag && (ag = ag.slice(a + 1)), Of(Uf, ig), c;
        } finally{
            cg = !1;
        }
    }
}
var kg = ra.ReactCurrentBatchConfig;
function lg(a, b) {
    if (a && a.defaultProps) {
        b = $013Yp({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var mg = Bf(null), ng = null, og = null, pg = null;
function qg() {
    pg = og = ng = null;
}
function rg(a) {
    var b = mg.current;
    H(mg);
    a.type._context._currentValue = b;
}
function sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function tg(a, b) {
    ng = a;
    pg = og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (ug = !0), a.firstContext = null);
}
function vg(a, b) {
    if (pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === og) {
            if (null === ng) throw Error(y(308));
            og = b;
            ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else og = og.next = b;
    }
    return a._currentValue;
}
var wg = !1;
function xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function Cg(a, b, c, d) {
    var e = a.updateQueue;
    wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = $013Yp({}, A, h);
                            break a;
                        case 2:
                            wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(y(191, e));
            e.call(d);
        }
    }
}
var Fg = (new $7fPBF.Component).refs;
function Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $013Yp({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Kg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Zb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = Hg(), d = Ig(a), e = zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        Ag(a, e);
        Jg(a, d, c);
    }
};
function Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Je(c, d) || !Je(e, f) : !0;
}
function Mg(a, b, c) {
    var d = !1, e = Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = vg(f) : (e = Ff(b) ? Df : M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Ef(a, e) : Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Kg.enqueueReplaceState(b, b.state, null);
}
function Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Fg;
    xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = vg(f) : (f = Ff(b) ? Df : M.current, e.context = Ef(a, f));
    Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Kg.enqueueReplaceState(e, e.state, null), Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var Pg = Array.isArray;
function Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Fg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(y(284));
        if (!c._owner) throw Error(y(290, a));
    }
    return a;
}
function Rg(a, b) {
    if ("textarea" !== a.type) throw Error(y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function Sg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Qg(a, b, c), d.return = a, d;
        d = Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Qg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case sa:
                    return c = Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = Qg(a, null, b), c.return = a, c;
                case ta:
                    return b = Wg(b, a.mode, c), b.return = a, b;
            }
            if (Pg(b) || La(b)) return b = Xg(b, a.mode, c, null), b.return = a, b;
            Rg(a, b);
        }
        return null;
    }
    function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case sa:
                    return c.key === e ? c.type === ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Pg(c) || La(c)) return null !== e ? null : n(a, b, c, d, null);
            Rg(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Pg(d) || La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            Rg(b, d);
        }
        return null;
    }
    function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function w(e, g, h, k) {
        var l = La(h);
        if ("function" !== typeof l) throw Error(y(150));
        h = l.call(h);
        if (null == h) throw Error(y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ua ? (d = Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if (Pg(f)) return x(a, d, f, h);
        if (La(f)) return w(a, d, f, h);
        l && Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error(y(152, Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var Yg = Sg(!0), Zg = Sg(!1), $g = {}, ah = Bf($g), bh = Bf($g), ch = Bf($g);
function dh(a) {
    if (a === $g) throw Error(y(174));
    return a;
}
function eh(a, b) {
    I(ch, b);
    I(bh, a);
    I(ah, $g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = mb(b, a);
    }
    H(ah);
    I(ah, b);
}
function fh() {
    H(ah);
    H(bh);
    H(ch);
}
function gh(a) {
    dh(ch.current);
    var b = dh(ah.current);
    var c = mb(b, a.type);
    b !== c && (I(bh, a), I(ah, c));
}
function hh(a) {
    bh.current === a && (H(ah), H(bh));
}
var P = Bf(0);
function ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var jh = null, kh = null, lh = !1;
function mh(a, b) {
    var c = nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function ph(a) {
    if (lh) {
        var b = kh;
        if (b) {
            var c = b;
            if (!oh(a, b)) {
                b = rf(c.nextSibling);
                if (!b || !oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    lh = !1;
                    jh = a;
                    return;
                }
                mh(jh, c);
            }
            jh = a;
            kh = rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, lh = !1, jh = a;
    }
}
function qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    jh = a;
}
function rh(a) {
    if (a !== jh) return !1;
    if (!lh) return qh(a), lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !nf(b, a.memoizedProps)) for(b = kh; b;)mh(a, b), b = rf(b.nextSibling);
    qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            kh = rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            kh = null;
        }
    } else kh = jh ? rf(a.stateNode.nextSibling) : null;
    return !0;
}
function sh() {
    kh = jh = null;
    lh = !1;
}
var th = [];
function uh() {
    for(var a = 0; a < th.length; a++)th[a]._workInProgressVersionPrimary = null;
    th.length = 0;
}
var vh = ra.ReactCurrentDispatcher, wh = ra.ReactCurrentBatchConfig, xh = 0, R = null, S = null, T = null, yh = !1, zh = !1;
function Ah() {
    throw Error(y(321));
}
function Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Ch(a, b, c, d, e, f) {
    xh = f;
    R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    vh.current = null === a || null === a.memoizedState ? Dh : Eh;
    a = c(d, e);
    if (zh) {
        f = 0;
        do {
            zh = !1;
            if (!(25 > f)) throw Error(y(301));
            f += 1;
            T = S = null;
            b.updateQueue = null;
            vh.current = Fh;
            a = c(d, e);
        }while (zh);
    }
    vh.current = Gh;
    b = null !== S && null !== S.next;
    xh = 0;
    T = S = R = null;
    yh = !1;
    if (b) throw Error(y(300));
    return a;
}
function Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === T ? R.memoizedState = T = a : T = T.next = a;
    return T;
}
function Ih() {
    if (null === S) {
        var a = R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = S.next;
    var b = null === T ? R.memoizedState : T.next;
    if (null !== b) T = b, S = a;
    else {
        if (null === a) throw Error(y(310));
        S = a;
        a = {
            memoizedState: S.memoizedState,
            baseState: S.baseState,
            baseQueue: S.baseQueue,
            queue: S.queue,
            next: null
        };
        null === T ? R.memoizedState = T = a : T = T.next = a;
    }
    return T;
}
function Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Kh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if ((xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                R.lanes |= l;
                Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        He(d, b.memoizedState) || (ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Lh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = (xh & a) === a) b._workInProgressVersionPrimary = d, th.push(b);
    if (a) return c(b._source);
    th.push(b);
    throw Error(y(350));
}
function Nh(a, b, c, d) {
    var e = U;
    if (null === e) throw Error(y(349));
    var f = b._getVersion, g = f(b._source), h = vh.current, k = h.useState(function() {
        return Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var a = f(b._source);
        if (!He(g, a)) {
            a = c(b._source);
            He(n, a) || (l(a), a = Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
            a = e.mutableReadLanes;
            e.entangledLanes |= a;
            for(var d = e.entanglements, h = a; 0 < h;){
                var k = 31 - Vc(h), v = 1 << k;
                d[k] |= a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var a = p.getSnapshot, c = p.setSnapshot;
            try {
                c(a(b._source));
                var d = Ig(w);
                e.mutableReadLanes |= d & e.pendingLanes;
            } catch (q) {
                c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    He(C, c) && He(x, b) && He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: n
    }, a.dispatch = l = Oh.bind(null, R, a), k.queue = a, k.baseQueue = null, n = Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function Ph(a, b, c) {
    var d = Ih();
    return Nh(d, a, b, c);
}
function Qh(a) {
    var b = Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: a
    };
    a = a.dispatch = Oh.bind(null, R, a);
    return [
        b.memoizedState,
        a
    ];
}
function Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Sh(a) {
    var b = Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function Th() {
    return Ih().memoizedState;
}
function Uh(a, b, c, d) {
    var e = Hh();
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function Vh(a, b, c, d) {
    var e = Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== S) {
        var g = S.memoizedState;
        f = g.destroy;
        if (null !== d && Bh(d, g.deps)) {
            Rh(b, c, f, d);
            return;
        }
    }
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, f, d);
}
function Wh(a, b) {
    return Uh(516, 4, a, b);
}
function Xh(a, b) {
    return Vh(516, 4, a, b);
}
function Yh(a, b) {
    return Vh(4, 2, a, b);
}
function Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Vh(4, 2, Zh.bind(null, b, a), c);
}
function ai() {}
function bi(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ci(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function di(a, b) {
    var c = eg();
    gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    gg(97 < c ? 97 : c, function() {
        var c = wh.transition;
        wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            wh.transition = c;
        }
    });
}
function Oh(a, b, c) {
    var d = Hg(), e = Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === R || null !== g && g === R) zh = yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if (He(k, h)) return;
        } catch (l) {} finally{}
        Jg(a, e, d);
    }
}
var Gh = {
    readContext: vg,
    useCallback: Ah,
    useContext: Ah,
    useEffect: Ah,
    useImperativeHandle: Ah,
    useLayoutEffect: Ah,
    useMemo: Ah,
    useReducer: Ah,
    useRef: Ah,
    useState: Ah,
    useDebugValue: Ah,
    useDeferredValue: Ah,
    useTransition: Ah,
    useMutableSource: Ah,
    useOpaqueIdentifier: Ah,
    unstable_isNewReconciler: !1
}, Dh = {
    readContext: vg,
    useCallback: function(a, b) {
        Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: vg,
    useEffect: Wh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Uh(4, 2, Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Uh(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = Oh.bind(null, R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: Sh,
    useState: Qh,
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Qh(a), c = b[0], d = b[1];
        Wh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Qh(!1), b = a[0];
        a = di.bind(null, a[1]);
        Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function(a, b, c) {
        var d = Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function() {
        if (lh) {
            var a = !1, b = uf(function() {
                a || (a = !0, c("r:" + (tf++).toString(36)));
                throw Error(y(355));
            }), c = Qh(b)[1];
            0 === (R.mode & 2) && (R.flags |= 516, Rh(5, function() {
                c("r:" + (tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + (tf++).toString(36);
        Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, Eh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Kh,
    useRef: Th,
    useState: function() {
        return Kh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Kh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Kh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Kh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, Fh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Lh,
    useRef: Th,
    useState: function() {
        return Lh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Lh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Lh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Lh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, ei = ra.ReactCurrentOwner, ug = !1;
function fi(a, b, c, d) {
    b.child = null === a ? Zg(b, null, c, d) : Yg(b, a.child, c, d);
}
function gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    tg(b, e);
    d = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, d, e);
    return b.child;
}
function ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ki(a, b, g, d, e, f);
        a = Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : Je, c(e, d) && a.ref === b.ref)) return hi(a, b, f);
    b.flags |= 1;
    a = Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ki(a, b, c, d, e, f) {
    if (null !== a && Je(a.memoizedProps, d) && a.ref === b.ref) {
        if (ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && (ug = !0);
        else return b.lanes = a.lanes, hi(a, b, f);
    }
    return li(a, b, c, d, f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, ni(b, d);
    fi(a, b, e, c);
    return b.child;
}
function oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function li(a, b, c, d, e) {
    var f = Ff(c) ? Df : M.current;
    f = Ef(b, f);
    tg(b, e);
    c = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, c, e);
    return b.child;
}
function pi(a, b, c, d, e) {
    if (Ff(c)) {
        var f = !0;
        Jf(b);
    } else f = !1;
    tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Mg(b, c, d), Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = vg(l) : (l = Ff(c) ? Df : M.current, l = Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ng(b, g, d, l);
        wg = !1;
        var p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || N.current || wg ? ("function" === typeof n && (Gg(b, c, n, d), k = b.memoizedState), (h = wg || Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = vg(k) : (k = Ff(c) ? Df : M.current, k = Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && Ng(b, g, d, k);
        wg = !1;
        p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || N.current || wg ? ("function" === typeof C && (Gg(b, c, C, d), x = b.memoizedState), (l = wg || Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return qi(a, b, c, d, f, e);
}
function qi(a, b, c, d, e, f) {
    oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && Kf(b, c, !1), hi(a, b, f);
    d = b.stateNode;
    ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Yg(b, a.child, null, f), b.child = Yg(b, null, h, f)) : fi(a, b, h, f);
    b.memoizedState = d.state;
    e && Kf(b, c, !0);
    return b.child;
}
function ri(a) {
    var b = a.stateNode;
    b.pendingContext ? Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Hf(a, b.context, !1);
    eh(a, b.containerInfo);
}
var si = {
    dehydrated: null,
    retryLane: 0
};
function ti(a, b, c) {
    var d = b.pendingProps, e = P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    I(P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, b.lanes = 33554432, a;
        c = vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
        c = xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
    c = xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = vi(b, e, 0, null);
    c = Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = Tg(g, h);
    null !== a ? d = Tg(a, d) : (d = Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    sg(a.return, b);
}
function zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    fi(a, b, d.children, c);
    d = P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && yi(a, c);
            else if (19 === a.tag) yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error(y(153));
        if (null !== b.child) {
            a = b.child;
            c = Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var Bi, Ci, Di, Ei;
Bi = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Ci = function() {};
Di = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        dh(ah.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "option":
                e = eb(a, e);
                d = eb(a, d);
                f = [];
                break;
            case "select":
                e = $013Yp({}, e, {
                    value: void 0
                });
                d = $013Yp({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = jf);
        }
        vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Ei = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Fi(a, b) {
    if (!lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return Ff(b.type) && Gf(), null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            Ci(b);
            return null;
        case 5:
            hh(b);
            var e = dh(ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(y(166));
                    return null;
                }
                a = dh(ah.current);
                if (rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[wf] = b;
                    d[xf] = f;
                    switch(c){
                        case "dialog":
                            G("cancel", d);
                            G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < Xe.length; a++)G(Xe[a], d);
                            break;
                        case "source":
                            G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", d);
                            G("load", d);
                            break;
                        case "details":
                            G("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            G("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), G("invalid", d);
                    }
                    vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : ca.hasOwnProperty(g) && null != e && "onScroll" === g && G("scroll", d));
                    switch(c){
                        case "input":
                            Va(d);
                            cb(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === kb.html && (a = lb(c));
                    a === kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[wf] = b;
                    a[xf] = d;
                    Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = wb(c, d);
                    switch(c){
                        case "dialog":
                            G("cancel", a);
                            G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < Xe.length; e++)G(Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", a);
                            G("load", a);
                            e = d;
                            break;
                        case "details":
                            G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            Za(a, d);
                            e = Ya(a, d);
                            G("invalid", a);
                            break;
                        case "option":
                            e = eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = $013Yp({}, d, {
                                value: void 0
                            });
                            G("invalid", a);
                            break;
                        case "textarea":
                            hb(a, d);
                            e = gb(a, d);
                            G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && pb(a, k) : "number" === typeof k && pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ca.hasOwnProperty(f) ? null != k && "onScroll" === f && G("scroll", a) : null != k && qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            Va(a);
                            cb(a, d, !1);
                            break;
                        case "textarea":
                            Va(a);
                            jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = jf);
                    }
                    mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(y(166));
                c = dh(ch.current);
                dh(ah.current);
                rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            H(P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (P.current & 1)) 0 === V && (V = 3);
                else {
                    if (0 === V || 3 === V) V = 4;
                    null === U || 0 === (Dg & 134217727) && 0 === (Hi & 134217727) || Ii(U, W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return fh(), Ci(b), null === a && cf(b.stateNode.containerInfo), null;
        case 10:
            return rg(b), null;
        case 17:
            return Ff(b.type) && Gf(), null;
        case 19:
            H(P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) Fi(d, !1);
                else {
                    if (0 !== V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            I(P, P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && O() > Ji && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * O() - d.renderingStartTime > Ji && 1073741824 !== c && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = O(), c.sibling = null, b = P.current, I(P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error(y(156, b.tag));
}
function Li(a) {
    switch(a.tag){
        case 1:
            Ff(a.type) && Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error(y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return hh(a), null;
        case 13:
            return H(P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return H(P), null;
        case 4:
            return fh(), null;
        case 10:
            return rg(a), null;
        case 23:
        case 24:
            return Ki(), null;
        default:
            return null;
    }
}
function Mi(a, b) {
    try {
        var c = "", d = b;
        do c += Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Oi = "function" === typeof WeakMap ? WeakMap : Map;
function Pi(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Qi || (Qi = !0, Ri = d);
        Ni(a, b);
    };
    return c;
}
function Si(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === Ti ? Ti = new Set([
            this
        ]) : Ti.add(this), Ni(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var Ui = "function" === typeof WeakSet ? WeakSet : Set;
function Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Wi(a, c);
        }
        else b.current = null;
    }
}
function Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(y(163));
}
function Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && (Zi(c, a), $i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error(y(163));
}
function aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function bj(a, b) {
    if (Mf && "function" === typeof Mf.onCommitFiberUnmount) try {
        Mf.onCommitFiberUnmount(Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                Wi(b, f);
            }
            break;
        case 5:
            Vi(b);
            break;
        case 4:
            cj(a, b);
    }
}
function dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (ej(b)) break a;
            b = b.return;
        }
        throw Error(y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(y(161));
    }
    c.flags & 16 && (pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? gj(a, c, b) : hj(a, c, b);
}
function gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = jf));
    else if (4 !== d && (a = a.child, null !== a)) for(gj(a, b, c), a = a.sibling; null !== a;)gj(a, b, c), a = a.sibling;
}
function hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(hj(a, b, c), a = a.sibling; null !== a;)hj(a, b, c), a = a.sibling;
}
function cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error(y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if (bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if (bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $a(c, d);
                    wb(a, e);
                    b = wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? tb(c, h) : "dangerouslySetInnerHTML" === g ? ob(c, h) : "children" === g ? pb(c, h) : qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            ab(c, d);
                            break;
                        case "textarea":
                            ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? fb(c, !!d.multiple, d.defaultValue, !0) : fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && (jj = O(), aj(b.child, !0));
            kj(b);
            return;
        case 19:
            kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            aj(b, null !== b.memoizedState);
            return;
    }
    throw Error(y(163));
}
function kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Ui);
        b.forEach(function(b) {
            var d = lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var nj = Math.ceil, oj = ra.ReactCurrentDispatcher, pj = ra.ReactCurrentOwner, X = 0, U = null, Y = null, W = 0, qj = 0, rj = Bf(0), V = 0, sj = null, tj = 0, Dg = 0, Hi = 0, uj = 0, vj = null, jj = 0, Ji = Infinity;
function wj() {
    Ji = O() + 500;
}
var Z = null, Qi = !1, Ri = null, Ti = null, xj = !1, yj = null, zj = 90, Aj = [], Bj = [], Cj = null, Dj = 0, Ej = null, Fj = -1, Gj = 0, Hj = 0, Ij = null, Jj = !1;
function Hg() {
    return 0 !== (X & 48) ? O() : -1 !== Fj ? Fj : Fj = O();
}
function Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === eg() ? 1 : 2;
    0 === Gj && (Gj = tj);
    if (0 !== kg.transition) {
        0 !== Hj && (Hj = null !== vj ? vj.pendingLanes : 0);
        a = Gj;
        var b = 4186112 & ~Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = eg();
    0 !== (X & 4) && 98 === a ? a = Xc(12, Gj) : (a = Sc(a), a = Xc(a, Gj));
    return a;
}
function Jg(a, b, c) {
    if (50 < Dj) throw Dj = 0, Ej = null, Error(y(185));
    a = Kj(a, b);
    if (null === a) return null;
    $c(a, b, c);
    a === U && (Hi |= b, 4 === V && Ii(a, W));
    var d = eg();
    1 === b ? 0 !== (X & 8) && 0 === (X & 48) ? Lj(a) : (Mj(a, c), 0 === X && (wj(), ig())) : (0 === (X & 4) || 98 !== d && 99 !== d || (null === Cj ? Cj = new Set([
        a
    ]) : Cj.add(a)), Mj(a, c));
    vj = a;
}
function Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                Rc(k);
                var n = F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = Uc(a, a === U ? W : 0);
    b = F;
    if (0 === d) null !== c && (c !== Zf && Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== Zf && Pf(c);
        }
        15 === b ? (c = Lj.bind(null, a), null === ag ? (ag = [
            c
        ], bg = Of(Uf, jg)) : ag.push(c), c = Zf) : 14 === b ? c = hg(99, Lj.bind(null, a)) : (c = Tc(b), c = hg(c, Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Nj(a) {
    Fj = -1;
    Hj = Gj = 0;
    if (0 !== (X & 48)) throw Error(y(327));
    var b = a.callbackNode;
    if (Oj() && a.callbackNode !== b) return null;
    var c = Uc(a, a === U ? W : 0);
    if (0 === c) return null;
    var d = c;
    var e = X;
    X |= 16;
    var f = Pj();
    if (U !== a || W !== d) wj(), Qj(a, d);
    for(;;)try {
        Rj();
        break;
    } catch (h) {
        Sj(a, h);
    }
    qg();
    oj.current = f;
    X = e;
    null !== Y ? d = 0 : (U = null, W = 0, d = V);
    if (0 !== (tj & Hi)) Qj(a, 0);
    else if (0 !== d) {
        2 === d && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), c = Wc(a), 0 !== c && (d = Tj(a, c)));
        if (1 === d) throw b = sj, Qj(a, 0), Ii(a, c), Mj(a, O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error(y(345));
            case 2:
                Uj(a);
                break;
            case 3:
                Ii(a, c);
                if ((c & 62914560) === c && (d = jj + 500 - O(), 10 < d)) {
                    if (0 !== Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = of(Uj.bind(null, a), d);
                    break;
                }
                Uj(a);
                break;
            case 4:
                Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = of(Uj.bind(null, a), c);
                    break;
                }
                Uj(a);
                break;
            case 5:
                Uj(a);
                break;
            default:
                throw Error(y(329));
        }
    }
    Mj(a, O());
    return a.callbackNode === b ? Nj.bind(null, a) : null;
}
function Ii(a, b) {
    b &= ~uj;
    b &= ~Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Lj(a) {
    if (0 !== (X & 48)) throw Error(y(327));
    Oj();
    if (a === U && 0 !== (a.expiredLanes & W)) {
        var b = W;
        var c = Tj(a, b);
        0 !== (tj & Hi) && (b = Uc(a, b), c = Tj(a, b));
    } else b = Uc(a, 0), c = Tj(a, b);
    0 !== a.tag && 2 === c && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), b = Wc(a), 0 !== b && (c = Tj(a, b)));
    if (1 === c) throw c = sj, Qj(a, 0), Ii(a, b), Mj(a, O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Uj(a);
    Mj(a, O());
    return null;
}
function Vj() {
    if (null !== Cj) {
        var a = Cj;
        Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            Mj(a, O());
        });
    }
    ig();
}
function Wj(a, b) {
    var c = X;
    X |= 1;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function Xj(a, b) {
    var c = X;
    X &= -2;
    X |= 8;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function ni(a, b) {
    I(rj, qj);
    qj |= b;
    tj |= b;
}
function Ki() {
    qj = rj.current;
    H(rj);
}
function Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, pf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Gf();
                break;
            case 3:
                fh();
                H(N);
                H(M);
                uh();
                break;
            case 5:
                hh(d);
                break;
            case 4:
                fh();
                break;
            case 13:
                H(P);
                break;
            case 19:
                H(P);
                break;
            case 10:
                rg(d);
                break;
            case 23:
            case 24:
                Ki();
        }
        c = c.return;
    }
    U = a;
    Y = Tg(a.current, null);
    W = qj = tj = b;
    V = 0;
    sj = null;
    uj = Hi = Dg = 0;
}
function Sj(a, b) {
    do {
        var c = Y;
        try {
            qg();
            vh.current = Gh;
            if (yh) {
                for(var d = R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                yh = !1;
            }
            xh = 0;
            T = S = R = null;
            zh = !1;
            pj.current = null;
            if (null === c || null === c.return) {
                V = 1;
                sj = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== (P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = zg(-1, 1);
                                        t.tag = 2;
                                        Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error((Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== V && (V = 2);
                k = Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = Pi(p, f, b);
                            Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === Ti || !Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = Si(p, f, b);
                                Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            Zj(c);
        } catch (va) {
            b = va;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Pj() {
    var a = oj.current;
    oj.current = Gh;
    return null === a ? Gh : a;
}
function Tj(a, b) {
    var c = X;
    X |= 16;
    var d = Pj();
    U === a && W === b || Qj(a, b);
    for(;;)try {
        ak();
        break;
    } catch (e) {
        Sj(a, e);
    }
    qg();
    X = c;
    oj.current = d;
    if (null !== Y) throw Error(y(261));
    U = null;
    W = 0;
    return V;
}
function ak() {
    for(; null !== Y;)bk(Y);
}
function Rj() {
    for(; null !== Y && !Qf();)bk(Y);
}
function bk(a) {
    var b = ck(a.alternate, a, qj);
    a.memoizedProps = a.pendingProps;
    null === b ? Zj(a) : Y = b;
    pj.current = null;
}
function Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = Gi(c, b, qj);
            if (null !== c) {
                Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== (qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = Li(b);
            if (null !== c) {
                c.flags &= 2047;
                Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === V && (V = 5);
}
function Uj(a) {
    var b = eg();
    gg(99, dk.bind(null, a, b));
    return null;
}
function dk(a, b) {
    do Oj();
    while (null !== yj);
    if (0 !== (X & 48)) throw Error(y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== Cj && 0 === (d & 24) && Cj.has(a) && Cj.delete(a);
    a === U && (Y = U = null, W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = X;
        X |= 32;
        pj.current = null;
        kf = fd;
        g = Ne();
        if (Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        lf = {
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Ij = null;
        Jj = !1;
        Z = d;
        do try {
            ek();
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Ij = null;
        Z = d;
        do try {
            for(g = a; null !== Z;){
                var t = Z.flags;
                t & 16 && pb(Z.stateNode, "");
                if (t & 128) {
                    var q = Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        fj(Z);
                        Z.flags &= -3;
                        break;
                    case 6:
                        fj(Z);
                        Z.flags &= -3;
                        ij(Z.alternate, Z);
                        break;
                    case 1024:
                        Z.flags &= -1025;
                        break;
                    case 1028:
                        Z.flags &= -1025;
                        ij(Z.alternate, Z);
                        break;
                    case 4:
                        ij(Z.alternate, Z);
                        break;
                    case 8:
                        h = Z;
                        cj(g, h);
                        var J = h.alternate;
                        dj(h);
                        null !== J && dj(J);
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        v = lf;
        q = Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && Me(t.ownerDocument.documentElement, t)) {
            null !== g && Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = Le(t, J), f = Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        fd = !!kf;
        lf = kf = null;
        a.current = c;
        Z = d;
        do try {
            for(t = a; null !== Z;){
                var K = Z.flags;
                K & 36 && Yi(t, Z.alternate, Z);
                if (K & 128) {
                    q = void 0;
                    var Q = Z.ref;
                    if (null !== Q) {
                        var L = Z.stateNode;
                        switch(Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Z = null;
        $f();
        X = e;
    } else a.current = c;
    if (xj) xj = !1, yj = a, zj = b;
    else for(Z = d; null !== Z;)b = Z.nextEffect, Z.nextEffect = null, Z.flags & 8 && (K = Z, K.sibling = null, K.stateNode = null), Z = b;
    d = a.pendingLanes;
    0 === d && (Ti = null);
    1 === d ? a === Ej ? Dj++ : (Dj = 0, Ej = a) : Dj = 0;
    c = c.stateNode;
    if (Mf && "function" === typeof Mf.onCommitFiberRoot) try {
        Mf.onCommitFiberRoot(Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    Mj(a, O());
    if (Qi) throw Qi = !1, a = Ri, Ri = null, a;
    if (0 !== (X & 8)) return null;
    ig();
    return null;
}
function ek() {
    for(; null !== Z;){
        var a = Z.alternate;
        Jj || null === Ij || (0 !== (Z.flags & 8) ? dc(Z, Ij) && (Jj = !0) : 13 === Z.tag && mj(a, Z) && dc(Z, Ij) && (Jj = !0));
        var b = Z.flags;
        0 !== (b & 256) && Xi(a, Z);
        0 === (b & 512) || xj || (xj = !0, hg(97, function() {
            Oj();
            return null;
        }));
        Z = Z.nextEffect;
    }
}
function Oj() {
    if (90 !== zj) {
        var a = 97 < zj ? 97 : zj;
        zj = 90;
        return gg(a, fk);
    }
    return !1;
}
function $i(a, b) {
    Aj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function Zi(a, b) {
    Bj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function fk() {
    if (null === yj) return !1;
    var a = yj;
    yj = null;
    if (0 !== (X & 48)) throw Error(y(331));
    var b = X;
    X |= 32;
    var c = Bj;
    Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    c = Aj;
    Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    X = b;
    ig();
    return !0;
}
function gk(a, b, c) {
    b = Mi(c, b);
    b = Pi(a, b, 1);
    Ag(a, b);
    b = Hg();
    a = Kj(a, 1);
    null !== a && ($c(a, 1, b), Mj(a, b));
}
function Wi(a, b) {
    if (3 === a.tag) gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) {
                a = Mi(b, a);
                var e = Si(c, a, 1);
                Ag(c, e);
                e = Hg();
                c = Kj(c, 1);
                if (null !== c) $c(c, 1, e), Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    U === a && (W & c) === c && (4 === V || 3 === V && (W & 62914560) === W && 500 > O() - jj ? Qj(a, 0) : uj |= c);
    Mj(a, b);
}
function lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === eg() ? 1 : 2 : (0 === Gj && (Gj = tj), b = Yc(62914560 & ~Gj), 0 === b && (b = 4194304)));
    c = Hg();
    a = Kj(a, b);
    null !== a && ($c(a, b, c), Mj(a, c));
}
var ck;
ck = function(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || N.current) ug = !0;
        else if (0 !== (c & d)) ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            ug = !1;
            switch(b.tag){
                case 3:
                    ri(b);
                    sh();
                    break;
                case 5:
                    gh(b);
                    break;
                case 1:
                    Ff(b.type) && Jf(b);
                    break;
                case 4:
                    eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    I(mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return ti(a, b, c);
                        I(P, P.current & 1);
                        b = hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    I(P, P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    I(P, P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, mi(a, b, c);
            }
            return hi(a, b, c);
        }
    } else ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = Ef(b, M.current);
            tg(b, c);
            e = Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (Ff(d)) {
                    var f = !0;
                    Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Gg(b, d, g, a);
                e.updater = Kg;
                b.stateNode = e;
                e._reactInternals = b;
                Og(b, d, a, c);
                b = qi(null, b, d, !0, f, c);
            } else b.tag = 0, fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = hk(e);
                a = lg(e, a);
                switch(f){
                    case 0:
                        b = li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ii(null, b, e, lg(e.type, a), d, c);
                        break a;
                }
                throw Error(y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), pi(a, b, d, e, c);
        case 3:
            ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            yg(a, b);
            Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) sh(), b = hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) kh = rf(b.stateNode.containerInfo.firstChild), jh = b, f = lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], th.push(f);
                    c = Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else fi(a, b, d, c), sh();
                b = b.child;
            }
            return b;
        case 5:
            return gh(b), null === a && ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, nf(d, e) ? g = null : null !== f && nf(d, f) && (b.flags |= 16), oi(a, b), fi(a, b, g, c), b.child;
        case 6:
            return null === a && ph(b), null;
        case 13:
            return ti(a, b, c);
        case 4:
            return eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Yg(b, null, d, c) : fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), gi(a, b, d, e, c);
        case 7:
            return fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !N.current) {
                            b = hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = zg(-1, c & -c), l.tag = 2, Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, tg(b, c), e = vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = lg(e, b.pendingProps), f = lg(e.type, f), ii(a, b, e, f, d, c);
        case 15:
            return ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Ff(d) ? (a = !0, Jf(b)) : a = !1, tg(b, c), Mg(b, d, e), Og(b, d, e, c), qi(null, b, d, !0, a, c);
        case 19:
            return Ai(a, b, c);
        case 23:
            return mi(a, b, c);
        case 24:
            return mi(a, b, c);
    }
    throw Error(y(156, b.tag));
};
function ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function nh(a, b, c, d) {
    return new ik(a, b, c, d);
}
function ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function hk(a) {
    if ("function" === typeof a) return ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Aa) return 11;
        if (a === Da) return 14;
    }
    return 2;
}
function Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ua:
            return Xg(c.children, e, f, b);
        case Ha:
            g = 8;
            e |= 16;
            break;
        case wa:
            g = 8;
            e |= 1;
            break;
        case xa:
            return a = nh(12, c, b, e | 8), a.elementType = xa, a.type = xa, a.lanes = f, a;
        case Ba:
            return a = nh(13, c, b, e), a.type = Ba, a.elementType = Ba, a.lanes = f, a;
        case Ca:
            return a = nh(19, c, b, e), a.elementType = Ca, a.lanes = f, a;
        case Ia:
            return vi(c, e, f, b);
        case Ja:
            return a = nh(24, c, b, e), a.elementType = Ja, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case ya:
                    g = 10;
                    break a;
                case za:
                    g = 9;
                    break a;
                case Aa:
                    g = 11;
                    break a;
                case Da:
                    g = 14;
                    break a;
                case Ea:
                    g = 16;
                    d = null;
                    break a;
                case Fa:
                    g = 22;
                    break a;
            }
            throw Error(y(130, null == a ? a : typeof a, ""));
    }
    b = nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Xg(a, b, c, d) {
    a = nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function vi(a, b, c, d) {
    a = nh(23, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    return a;
}
function Ug(a, b, c) {
    a = nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function Wg(a, b, c) {
    b = nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = Zc(0);
    this.expirationTimes = Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function lk(a, b, c, d) {
    var e = b.current, f = Hg(), g = Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if (Zb(c) !== c || 1 !== c.tag) throw Error(y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (Ff(k)) {
                c = If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    Ag(e, b);
    Jg(e, g, f);
    return g;
}
function mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function ok(a, b) {
    nk(a, b);
    (a = a.alternate) && nk(a, b);
}
function pk() {
    return null;
}
function qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new jk(a, b, null != c && !0 === c.hydrate);
    b = nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    xg(b);
    a[ff] = c.current;
    cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
qk.prototype.render = function(a) {
    lk(a, this._internalRoot, null, null);
};
qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    lk(null, a, null, function() {
        b[ff] = null;
    });
};
function rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = mk(g);
                h.call(a);
            };
        }
        lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = mk(g);
                k.call(a);
            };
        }
        Xj(function() {
            lk(b, g, a, e);
        });
    }
    return mk(g);
}
ec = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 4, b);
        ok(a, 4);
    }
};
fc = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 67108864, b);
        ok(a, 67108864);
    }
};
gc = function(a) {
    if (13 === a.tag) {
        var b = Hg(), c = Ig(a);
        Jg(a, c, b);
        ok(a, c);
    }
};
hc = function(a, b) {
    return b();
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(y(90));
                        Wa(d);
                        ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Wj;
Hb = function(a, b, c, d, e) {
    var f = X;
    X |= 4;
    try {
        return gg(98, a.bind(null, b, c, d, e));
    } finally{
        X = f, 0 === X && (wj(), ig());
    }
};
Ib = function() {
    0 === (X & 49) && (Vj(), Oj());
};
Jb = function(a, b) {
    var c = X;
    X |= 2;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
};
function uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!rk(b)) throw Error(y(200));
    return kk(a, b, null, c);
}
var vk = {
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Oj,
        {
            current: !1
        }
    ]
}, wk = {
    findFiberByHostInstance: wc,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
};
var xk = {
    bundleType: wk.bundleType,
    version: wk.version,
    rendererPackageName: wk.rendererPackageName,
    rendererConfig: wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: wk.findFiberByHostInstance || pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!yk.isDisabled && yk.supportsFiber) try {
        Lf = yk.inject(xk), Mf = yk;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = vk;
exports.createPortal = uk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(y(188));
        throw Error(y(268, Object.keys(a)));
    }
    a = cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    var c = X;
    if (0 !== (c & 48)) return a(b);
    X |= 1;
    try {
        if (a) return gg(99, a.bind(null, b));
    } finally{
        X = c, ig();
    }
};
exports.hydrate = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!rk(a)) throw Error(y(40));
    return a._reactRootContainer ? (Xj(function() {
        tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[ff] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Wj;
exports.unstable_createPortal = function(a, b) {
    return uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!rk(c)) throw Error(y(200));
    if (null == a || void 0 === a._reactInternals) throw Error(y(38));
    return tk(a, b, c, !1, d);
};
exports.version = "17.0.2";

});
parcelRegister("33s19", function(module, exports) {
'use strict';

module.exports = (parcelRequire("a0C75"));

});
parcelRegister("a0C75", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $749777fefd570b40$export$c4744153514ff05d; }, function (v) { return $749777fefd570b40$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $749777fefd570b40$export$b5836b71941fa3ed; }, function (v) { return $749777fefd570b40$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $749777fefd570b40$export$d66a1c1c77bd778b; }, function (v) { return $749777fefd570b40$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $749777fefd570b40$export$3e506c1ccc9cc1a7; }, function (v) { return $749777fefd570b40$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $749777fefd570b40$export$e26fe2ed2fa76875; }, function (v) { return $749777fefd570b40$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $749777fefd570b40$export$502329bbf4b505b1; }, function (v) { return $749777fefd570b40$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $749777fefd570b40$export$6e3807111c4874c4; }, function (v) { return $749777fefd570b40$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $749777fefd570b40$export$c27134553091fb3a; }, function (v) { return $749777fefd570b40$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $749777fefd570b40$export$33ee1acdc04fd2a2; }, function (v) { return $749777fefd570b40$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $749777fefd570b40$export$b00a404bbd5edef2; }, function (v) { return $749777fefd570b40$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $749777fefd570b40$export$8352ce38b91d0c62; }, function (v) { return $749777fefd570b40$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $749777fefd570b40$export$d3dfb8e4810cb555; }, function (v) { return $749777fefd570b40$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $749777fefd570b40$export$839f9183b0465a69; }, function (v) { return $749777fefd570b40$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $749777fefd570b40$export$72fdf0e06517287b; }, function (v) { return $749777fefd570b40$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $749777fefd570b40$export$4b844e58a3e414b4; }, function (v) { return $749777fefd570b40$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $749777fefd570b40$export$816d2913ae6b83b1; }, function (v) { return $749777fefd570b40$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $749777fefd570b40$export$61bcfe829111a1d0; }, function (v) { return $749777fefd570b40$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $749777fefd570b40$export$7ee8c9beb337bc3f; }, function (v) { return $749777fefd570b40$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $749777fefd570b40$export$cf845f2c119da08a; }, function (v) { return $749777fefd570b40$export$cf845f2c119da08a = v; });
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $749777fefd570b40$export$c4744153514ff05d;
var $749777fefd570b40$export$b5836b71941fa3ed;
var $749777fefd570b40$export$d66a1c1c77bd778b;
var $749777fefd570b40$export$3e506c1ccc9cc1a7;
var $749777fefd570b40$export$e26fe2ed2fa76875;
var $749777fefd570b40$export$502329bbf4b505b1;
var $749777fefd570b40$export$6e3807111c4874c4;
var $749777fefd570b40$export$c27134553091fb3a;
var $749777fefd570b40$export$33ee1acdc04fd2a2;
var $749777fefd570b40$export$b00a404bbd5edef2;
var $749777fefd570b40$export$8352ce38b91d0c62;
var $749777fefd570b40$export$d3dfb8e4810cb555;
var $749777fefd570b40$export$839f9183b0465a69;
var $749777fefd570b40$export$72fdf0e06517287b;
var $749777fefd570b40$export$4b844e58a3e414b4;
var $749777fefd570b40$export$816d2913ae6b83b1;
var $749777fefd570b40$export$61bcfe829111a1d0;
var $749777fefd570b40$export$7ee8c9beb337bc3f;
var $749777fefd570b40$export$cf845f2c119da08a;
'use strict';
var $749777fefd570b40$var$f, $749777fefd570b40$var$g, $749777fefd570b40$var$h, $749777fefd570b40$var$k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $749777fefd570b40$var$l = performance;
    $749777fefd570b40$export$c4744153514ff05d = function() {
        return $749777fefd570b40$var$l.now();
    };
} else {
    var $749777fefd570b40$var$p = Date, $749777fefd570b40$var$q = $749777fefd570b40$var$p.now();
    $749777fefd570b40$export$c4744153514ff05d = function() {
        return $749777fefd570b40$var$p.now() - $749777fefd570b40$var$q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $749777fefd570b40$var$t = null, $749777fefd570b40$var$u = null, $749777fefd570b40$var$w = function() {
        if (null !== $749777fefd570b40$var$t) try {
            var a = $749777fefd570b40$export$c4744153514ff05d();
            $749777fefd570b40$var$t(!0, a);
            $749777fefd570b40$var$t = null;
        } catch (b) {
            throw setTimeout($749777fefd570b40$var$w, 0), b;
        }
    };
    $749777fefd570b40$var$f = function(a) {
        null !== $749777fefd570b40$var$t ? setTimeout($749777fefd570b40$var$f, 0, a) : ($749777fefd570b40$var$t = a, setTimeout($749777fefd570b40$var$w, 0));
    };
    $749777fefd570b40$var$g = function(a, b) {
        $749777fefd570b40$var$u = setTimeout(a, b);
    };
    $749777fefd570b40$var$h = function() {
        clearTimeout($749777fefd570b40$var$u);
    };
    $749777fefd570b40$export$b5836b71941fa3ed = function() {
        return !1;
    };
    $749777fefd570b40$var$k = $749777fefd570b40$export$d66a1c1c77bd778b = function() {};
} else {
    var $749777fefd570b40$var$x = window.setTimeout, $749777fefd570b40$var$y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $749777fefd570b40$var$z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof $749777fefd570b40$var$z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var $749777fefd570b40$var$A = !1, $749777fefd570b40$var$B = null, $749777fefd570b40$var$C = -1, $749777fefd570b40$var$D = 5, $749777fefd570b40$var$E = 0;
    $749777fefd570b40$export$b5836b71941fa3ed = function() {
        return $749777fefd570b40$export$c4744153514ff05d() >= $749777fefd570b40$var$E;
    };
    $749777fefd570b40$var$k = function() {};
    $749777fefd570b40$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $749777fefd570b40$var$D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $749777fefd570b40$var$F = new MessageChannel, $749777fefd570b40$var$G = $749777fefd570b40$var$F.port2;
    $749777fefd570b40$var$F.port1.onmessage = function() {
        if (null !== $749777fefd570b40$var$B) {
            var a = $749777fefd570b40$export$c4744153514ff05d();
            $749777fefd570b40$var$E = a + $749777fefd570b40$var$D;
            try {
                $749777fefd570b40$var$B(!0, a) ? $749777fefd570b40$var$G.postMessage(null) : ($749777fefd570b40$var$A = !1, $749777fefd570b40$var$B = null);
            } catch (b) {
                throw $749777fefd570b40$var$G.postMessage(null), b;
            }
        } else $749777fefd570b40$var$A = !1;
    };
    $749777fefd570b40$var$f = function(a) {
        $749777fefd570b40$var$B = a;
        $749777fefd570b40$var$A || ($749777fefd570b40$var$A = !0, $749777fefd570b40$var$G.postMessage(null));
    };
    $749777fefd570b40$var$g = function(a, b) {
        $749777fefd570b40$var$C = $749777fefd570b40$var$x(function() {
            a($749777fefd570b40$export$c4744153514ff05d());
        }, b);
    };
    $749777fefd570b40$var$h = function() {
        $749777fefd570b40$var$y($749777fefd570b40$var$C);
        $749777fefd570b40$var$C = -1;
    };
}
function $749777fefd570b40$var$H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $749777fefd570b40$var$I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $749777fefd570b40$var$J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $749777fefd570b40$var$K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $749777fefd570b40$var$I(n, c)) void 0 !== r && 0 > $749777fefd570b40$var$I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $749777fefd570b40$var$I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $749777fefd570b40$var$I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $749777fefd570b40$var$L = [], $749777fefd570b40$var$M = [], $749777fefd570b40$var$N = 1, $749777fefd570b40$var$O = null, $749777fefd570b40$var$P = 3, $749777fefd570b40$var$Q = !1, $749777fefd570b40$var$R = !1, $749777fefd570b40$var$S = !1;
function $749777fefd570b40$var$T(a) {
    for(var b = $749777fefd570b40$var$J($749777fefd570b40$var$M); null !== b;){
        if (null === b.callback) $749777fefd570b40$var$K($749777fefd570b40$var$M);
        else if (b.startTime <= a) $749777fefd570b40$var$K($749777fefd570b40$var$M), b.sortIndex = b.expirationTime, $749777fefd570b40$var$H($749777fefd570b40$var$L, b);
        else break;
        b = $749777fefd570b40$var$J($749777fefd570b40$var$M);
    }
}
function $749777fefd570b40$var$U(a) {
    $749777fefd570b40$var$S = !1;
    $749777fefd570b40$var$T(a);
    if (!$749777fefd570b40$var$R) {
        if (null !== $749777fefd570b40$var$J($749777fefd570b40$var$L)) $749777fefd570b40$var$R = !0, $749777fefd570b40$var$f($749777fefd570b40$var$V);
        else {
            var b = $749777fefd570b40$var$J($749777fefd570b40$var$M);
            null !== b && $749777fefd570b40$var$g($749777fefd570b40$var$U, b.startTime - a);
        }
    }
}
function $749777fefd570b40$var$V(a, b) {
    $749777fefd570b40$var$R = !1;
    $749777fefd570b40$var$S && ($749777fefd570b40$var$S = !1, $749777fefd570b40$var$h());
    $749777fefd570b40$var$Q = !0;
    var c = $749777fefd570b40$var$P;
    try {
        $749777fefd570b40$var$T(b);
        for($749777fefd570b40$var$O = $749777fefd570b40$var$J($749777fefd570b40$var$L); null !== $749777fefd570b40$var$O && (!($749777fefd570b40$var$O.expirationTime > b) || a && !$749777fefd570b40$export$b5836b71941fa3ed());){
            var d = $749777fefd570b40$var$O.callback;
            if ("function" === typeof d) {
                $749777fefd570b40$var$O.callback = null;
                $749777fefd570b40$var$P = $749777fefd570b40$var$O.priorityLevel;
                var e = d($749777fefd570b40$var$O.expirationTime <= b);
                b = $749777fefd570b40$export$c4744153514ff05d();
                "function" === typeof e ? $749777fefd570b40$var$O.callback = e : $749777fefd570b40$var$O === $749777fefd570b40$var$J($749777fefd570b40$var$L) && $749777fefd570b40$var$K($749777fefd570b40$var$L);
                $749777fefd570b40$var$T(b);
            } else $749777fefd570b40$var$K($749777fefd570b40$var$L);
            $749777fefd570b40$var$O = $749777fefd570b40$var$J($749777fefd570b40$var$L);
        }
        if (null !== $749777fefd570b40$var$O) var m = !0;
        else {
            var n = $749777fefd570b40$var$J($749777fefd570b40$var$M);
            null !== n && $749777fefd570b40$var$g($749777fefd570b40$var$U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $749777fefd570b40$var$O = null, $749777fefd570b40$var$P = c, $749777fefd570b40$var$Q = !1;
    }
}
var $749777fefd570b40$var$W = $749777fefd570b40$var$k;
$749777fefd570b40$export$3e506c1ccc9cc1a7 = 5;
$749777fefd570b40$export$e26fe2ed2fa76875 = 1;
$749777fefd570b40$export$502329bbf4b505b1 = 4;
$749777fefd570b40$export$6e3807111c4874c4 = 3;
$749777fefd570b40$export$c27134553091fb3a = null;
$749777fefd570b40$export$33ee1acdc04fd2a2 = 2;
$749777fefd570b40$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$749777fefd570b40$export$8352ce38b91d0c62 = function() {
    $749777fefd570b40$var$R || $749777fefd570b40$var$Q || ($749777fefd570b40$var$R = !0, $749777fefd570b40$var$f($749777fefd570b40$var$V));
};
$749777fefd570b40$export$d3dfb8e4810cb555 = function() {
    return $749777fefd570b40$var$P;
};
$749777fefd570b40$export$839f9183b0465a69 = function() {
    return $749777fefd570b40$var$J($749777fefd570b40$var$L);
};
$749777fefd570b40$export$72fdf0e06517287b = function(a) {
    switch($749777fefd570b40$var$P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $749777fefd570b40$var$P;
    }
    var c = $749777fefd570b40$var$P;
    $749777fefd570b40$var$P = b;
    try {
        return a();
    } finally{
        $749777fefd570b40$var$P = c;
    }
};
$749777fefd570b40$export$4b844e58a3e414b4 = function() {};
$749777fefd570b40$export$816d2913ae6b83b1 = $749777fefd570b40$var$W;
$749777fefd570b40$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $749777fefd570b40$var$P;
    $749777fefd570b40$var$P = a;
    try {
        return b();
    } finally{
        $749777fefd570b40$var$P = c;
    }
};
$749777fefd570b40$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $749777fefd570b40$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $749777fefd570b40$var$N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $749777fefd570b40$var$H($749777fefd570b40$var$M, a), null === $749777fefd570b40$var$J($749777fefd570b40$var$L) && a === $749777fefd570b40$var$J($749777fefd570b40$var$M) && ($749777fefd570b40$var$S ? $749777fefd570b40$var$h() : $749777fefd570b40$var$S = !0, $749777fefd570b40$var$g($749777fefd570b40$var$U, c - d))) : (a.sortIndex = e, $749777fefd570b40$var$H($749777fefd570b40$var$L, a), $749777fefd570b40$var$R || $749777fefd570b40$var$Q || ($749777fefd570b40$var$R = !0, $749777fefd570b40$var$f($749777fefd570b40$var$V)));
    return a;
};
$749777fefd570b40$export$cf845f2c119da08a = function(a) {
    var b = $749777fefd570b40$var$P;
    return function() {
        var c = $749777fefd570b40$var$P;
        $749777fefd570b40$var$P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $749777fefd570b40$var$P = c;
        }
    };
};

});



parcelRegister("gAJjf", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $c14327a2287fdbb7$export$bf730a2d8bf68b42; }, function (v) { return $c14327a2287fdbb7$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c14327a2287fdbb7$export$bf730a2d8bf68b42;
"use strict";

var $7fPBF = parcelRequire("7fPBF");

var $hL6ll = parcelRequire("hL6ll");
function $c14327a2287fdbb7$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $c14327a2287fdbb7$var$objectIs = "function" === typeof Object.is ? Object.is : $c14327a2287fdbb7$var$is, $c14327a2287fdbb7$var$useSyncExternalStore = $hL6ll.useSyncExternalStore, $c14327a2287fdbb7$var$useRef = $7fPBF.useRef, $c14327a2287fdbb7$var$useEffect = $7fPBF.useEffect, $c14327a2287fdbb7$var$useMemo = $7fPBF.useMemo, $c14327a2287fdbb7$var$useDebugValue = $7fPBF.useDebugValue;
$c14327a2287fdbb7$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $c14327a2287fdbb7$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $c14327a2287fdbb7$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($c14327a2287fdbb7$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $c14327a2287fdbb7$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $c14327a2287fdbb7$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $c14327a2287fdbb7$var$useDebugValue(value);
    return value;
};

});
parcelRegister("hL6ll", function(module, exports) {
'use strict';

module.exports = (parcelRequire("a1Cvm"));

});
parcelRegister("a1Cvm", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $74c7dda075bc8f04$export$306c0aa65ff9ec16; }, function (v) { return $74c7dda075bc8f04$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $74c7dda075bc8f04$export$306c0aa65ff9ec16;
"use strict";

var $7fPBF = parcelRequire("7fPBF");
function $74c7dda075bc8f04$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $74c7dda075bc8f04$var$objectIs = "function" === typeof Object.is ? Object.is : $74c7dda075bc8f04$var$is, $74c7dda075bc8f04$var$useState = $7fPBF.useState, $74c7dda075bc8f04$var$useEffect = $7fPBF.useEffect, $74c7dda075bc8f04$var$useLayoutEffect = $7fPBF.useLayoutEffect, $74c7dda075bc8f04$var$useDebugValue = $7fPBF.useDebugValue;
function $74c7dda075bc8f04$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $74c7dda075bc8f04$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $74c7dda075bc8f04$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $74c7dda075bc8f04$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $74c7dda075bc8f04$var$useEffect(function() {
        $74c7dda075bc8f04$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $74c7dda075bc8f04$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $74c7dda075bc8f04$var$useDebugValue(value);
    return value;
}
function $74c7dda075bc8f04$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$74c7dda075bc8f04$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $74c7dda075bc8f04$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $74c7dda075bc8f04$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $74c7dda075bc8f04$var$useSyncExternalStore$1 : $74c7dda075bc8f04$var$useSyncExternalStore$2;
$74c7dda075bc8f04$export$306c0aa65ff9ec16 = void 0 !== $7fPBF.useSyncExternalStore ? $7fPBF.useSyncExternalStore : $74c7dda075bc8f04$var$shim;

});



parcelRegister("a04va", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");

var $6zjya = parcelRequire("6zjya");

var $8PZpp = parcelRequire("8PZpp");

var $5f6d7 = parcelRequire("5f6d7");

var $9X39E = parcelRequire("9X39E");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $747d656b899e6115$var$createInstance(defaultConfig) {
    var context = new $8PZpp(defaultConfig);
    var instance = $6zjya($8PZpp.prototype.request, context);
    // Copy axios.prototype to instance
    $adReO.extend(instance, $8PZpp.prototype, context);
    // Copy context to instance
    $adReO.extend(instance, context);
    return instance;
}
// Create the default instance to be exported
var $747d656b899e6115$var$axios = $747d656b899e6115$var$createInstance($9X39E);
// Expose Axios class to allow class inheritance
$747d656b899e6115$var$axios.Axios = $8PZpp;
// Factory for creating new instances
$747d656b899e6115$var$axios.create = function create(instanceConfig) {
    return $747d656b899e6115$var$createInstance($5f6d7($747d656b899e6115$var$axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
$747d656b899e6115$var$axios.Cancel = (parcelRequire("2W85d"));

$747d656b899e6115$var$axios.CancelToken = (parcelRequire("kZZD0"));

$747d656b899e6115$var$axios.isCancel = (parcelRequire("4IsRW"));
// Expose all/spread
$747d656b899e6115$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$747d656b899e6115$var$axios.spread = (parcelRequire("b676K"));

// Expose isAxiosError
$747d656b899e6115$var$axios.isAxiosError = (parcelRequire("kgiwQ"));
module.exports = $747d656b899e6115$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $747d656b899e6115$var$axios;

});
parcelRegister("adReO", function(module, exports) {
'use strict';

var $6zjya = parcelRequire("6zjya");
// utils is a library of generic helper functions non-specific to axios
var $77146a31cb578292$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $77146a31cb578292$var$isArray(val) {
    return $77146a31cb578292$var$toString.call(val) === '[object Array]';
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $77146a31cb578292$var$isUndefined(val) {
    return typeof val === 'undefined';
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $77146a31cb578292$var$isBuffer(val) {
    return val !== null && !$77146a31cb578292$var$isUndefined(val) && val.constructor !== null && !$77146a31cb578292$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $77146a31cb578292$var$isArrayBuffer(val) {
    return $77146a31cb578292$var$toString.call(val) === '[object ArrayBuffer]';
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $77146a31cb578292$var$isFormData(val) {
    return typeof FormData !== 'undefined' && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $77146a31cb578292$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $77146a31cb578292$var$isString(val) {
    return typeof val === 'string';
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $77146a31cb578292$var$isNumber(val) {
    return typeof val === 'number';
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $77146a31cb578292$var$isObject(val) {
    return val !== null && typeof val === 'object';
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $77146a31cb578292$var$isPlainObject(val) {
    if ($77146a31cb578292$var$toString.call(val) !== '[object Object]') return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $77146a31cb578292$var$isDate(val) {
    return $77146a31cb578292$var$toString.call(val) === '[object Date]';
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $77146a31cb578292$var$isFile(val) {
    return $77146a31cb578292$var$toString.call(val) === '[object File]';
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $77146a31cb578292$var$isBlob(val) {
    return $77146a31cb578292$var$toString.call(val) === '[object Blob]';
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $77146a31cb578292$var$isFunction(val) {
    return $77146a31cb578292$var$toString.call(val) === '[object Function]';
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $77146a31cb578292$var$isStream(val) {
    return $77146a31cb578292$var$isObject(val) && $77146a31cb578292$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $77146a31cb578292$var$isURLSearchParams(val) {
    return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $77146a31cb578292$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $77146a31cb578292$var$isStandardBrowserEnv() {
    if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) return false;
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $77146a31cb578292$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($77146a31cb578292$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $77146a31cb578292$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($77146a31cb578292$var$isPlainObject(result[key]) && $77146a31cb578292$var$isPlainObject(val)) result[key] = $77146a31cb578292$var$merge(result[key], val);
        else if ($77146a31cb578292$var$isPlainObject(val)) result[key] = $77146a31cb578292$var$merge({}, val);
        else if ($77146a31cb578292$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$77146a31cb578292$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $77146a31cb578292$var$extend(a, b, thisArg) {
    $77146a31cb578292$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === 'function') a[key] = $6zjya(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $77146a31cb578292$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: $77146a31cb578292$var$isArray,
    isArrayBuffer: $77146a31cb578292$var$isArrayBuffer,
    isBuffer: $77146a31cb578292$var$isBuffer,
    isFormData: $77146a31cb578292$var$isFormData,
    isArrayBufferView: $77146a31cb578292$var$isArrayBufferView,
    isString: $77146a31cb578292$var$isString,
    isNumber: $77146a31cb578292$var$isNumber,
    isObject: $77146a31cb578292$var$isObject,
    isPlainObject: $77146a31cb578292$var$isPlainObject,
    isUndefined: $77146a31cb578292$var$isUndefined,
    isDate: $77146a31cb578292$var$isDate,
    isFile: $77146a31cb578292$var$isFile,
    isBlob: $77146a31cb578292$var$isBlob,
    isFunction: $77146a31cb578292$var$isFunction,
    isStream: $77146a31cb578292$var$isStream,
    isURLSearchParams: $77146a31cb578292$var$isURLSearchParams,
    isStandardBrowserEnv: $77146a31cb578292$var$isStandardBrowserEnv,
    forEach: $77146a31cb578292$var$forEach,
    merge: $77146a31cb578292$var$merge,
    extend: $77146a31cb578292$var$extend,
    trim: $77146a31cb578292$var$trim,
    stripBOM: $77146a31cb578292$var$stripBOM
};

});
parcelRegister("6zjya", function(module, exports) {
'use strict';
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("8PZpp", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");

var $6nvAH = parcelRequire("6nvAH");

var $khPLX = parcelRequire("khPLX");

var $eystn = parcelRequire("eystn");

var $5f6d7 = parcelRequire("5f6d7");

var $2iR5D = parcelRequire("2iR5D");
var $66f2b8a41463d1e8$var$validators = $2iR5D.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $66f2b8a41463d1e8$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $khPLX(),
        response: new $khPLX()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $66f2b8a41463d1e8$var$Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === 'string') {
        config = arguments[1] || {};
        config.url = arguments[0];
    } else config = config || {};
    config = $5f6d7(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = 'get';
    var transitional = config.transitional;
    if (transitional !== undefined) $2iR5D.assertOptions(transitional, {
        silentJSONParsing: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean, '1.0.0'),
        forcedJSONParsing: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean, '1.0.0'),
        clarifyTimeoutError: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean, '1.0.0')
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $eystn,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $eystn(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$66f2b8a41463d1e8$var$Axios.prototype.getUri = function getUri(config) {
    config = $5f6d7(this.defaults, config);
    return $6nvAH(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};
// Provide aliases for supported request methods
$adReO.forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $66f2b8a41463d1e8$var$Axios.prototype[method] = function(url, config) {
        return this.request($5f6d7(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$adReO.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $66f2b8a41463d1e8$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($5f6d7(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $66f2b8a41463d1e8$var$Axios;

});
parcelRegister("6nvAH", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");
function $4a4d655613ae826e$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($adReO.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $adReO.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === 'undefined') return;
            if ($adReO.isArray(val)) key = key + '[]';
            else val = [
                val
            ];
            $adReO.forEach(val, function parseValue(v) {
                if ($adReO.isDate(v)) v = v.toISOString();
                else if ($adReO.isObject(v)) v = JSON.stringify(v);
                parts.push($4a4d655613ae826e$var$encode(key) + '=' + $4a4d655613ae826e$var$encode(v));
            });
        });
        serializedParams = parts.join('&');
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
};

});

parcelRegister("khPLX", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");
function $ec4d8e24b0699790$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $ec4d8e24b0699790$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $ec4d8e24b0699790$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $ec4d8e24b0699790$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $adReO.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $ec4d8e24b0699790$var$InterceptorManager;

});

parcelRegister("eystn", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");

var $15ANS = parcelRequire("15ANS");

var $4IsRW = parcelRequire("4IsRW");

var $9X39E = parcelRequire("9X39E");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $a98a53c8a75f9db0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $a98a53c8a75f9db0$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $15ANS.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $adReO.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $adReO.forEach([
        'delete',
        'get',
        'head',
        'post',
        'put',
        'patch',
        'common'
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $9X39E.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $a98a53c8a75f9db0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $15ANS.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$4IsRW(reason)) {
            $a98a53c8a75f9db0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $15ANS.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("15ANS", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");

var $9X39E = parcelRequire("9X39E");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $9X39E;
    /*eslint no-param-reassign:0*/ $adReO.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRegister("9X39E", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");

var $9y7wC = parcelRequire("9y7wC");

var $3leq5 = parcelRequire("3leq5");
var $73ec122cfcba4842$var$DEFAULT_CONTENT_TYPE = {
    'Content-Type': 'application/x-www-form-urlencoded'
};
function $73ec122cfcba4842$var$setContentTypeIfUnset(headers, value) {
    if (!$adReO.isUndefined(headers) && $adReO.isUndefined(headers['Content-Type'])) headers['Content-Type'] = value;
}

function $73ec122cfcba4842$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== 'undefined') // For browsers use XHR adapter
    adapter = (parcelRequire("3PMHb"));
    return adapter;
}
function $73ec122cfcba4842$var$stringifySafely(rawValue, parser, encoder) {
    if ($adReO.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $adReO.trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $73ec122cfcba4842$var$defaults = {
    transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false
    },
    adapter: $73ec122cfcba4842$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $9y7wC(headers, 'Accept');
            $9y7wC(headers, 'Content-Type');
            if ($adReO.isFormData(data) || $adReO.isArrayBuffer(data) || $adReO.isBuffer(data) || $adReO.isStream(data) || $adReO.isFile(data) || $adReO.isBlob(data)) return data;
            if ($adReO.isArrayBufferView(data)) return data.buffer;
            if ($adReO.isURLSearchParams(data)) {
                $73ec122cfcba4842$var$setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
                return data.toString();
            }
            if ($adReO.isObject(data) || headers && headers['Content-Type'] === 'application/json') {
                $73ec122cfcba4842$var$setContentTypeIfUnset(headers, 'application/json');
                return $73ec122cfcba4842$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';
            if (strictJSONParsing || forcedJSONParsing && $adReO.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === 'SyntaxError') throw $3leq5(e, this, 'E_JSON_PARSE');
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    }
};
$73ec122cfcba4842$var$defaults.headers = {
    common: {
        'Accept': 'application/json, text/plain, */*'
    }
};
$adReO.forEach([
    'delete',
    'get',
    'head'
], function forEachMethodNoData(method) {
    $73ec122cfcba4842$var$defaults.headers[method] = {};
});
$adReO.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    $73ec122cfcba4842$var$defaults.headers[method] = $adReO.merge($73ec122cfcba4842$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $73ec122cfcba4842$var$defaults;

});
parcelRegister("9y7wC", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $adReO.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("3leq5", function(module, exports) {
'use strict';
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code
        };
    };
    return error;
};

});

parcelRegister("3PMHb", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");

var $3PfpF = parcelRequire("3PfpF");

var $79n0f = parcelRequire("79n0f");

var $6nvAH = parcelRequire("6nvAH");

var $40T1q = parcelRequire("40T1q");

var $hMzvi = parcelRequire("hMzvi");

var $besJL = parcelRequire("besJL");

var $hHo9F = parcelRequire("hHo9F");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        if ($adReO.isFormData(requestData)) delete requestHeaders['Content-Type']; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || '';
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
            requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
        }
        var fullPath = $40T1q(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $6nvAH(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = 'getAllResponseHeaders' in request ? $hMzvi(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $3PfpF(resolve, reject, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($hHo9F('Request aborted', config, 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($hHo9F('Network Error', config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($hHo9F(timeoutErrorMessage, config, config.transitional && config.transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($adReO.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $besJL(fullPath)) && config.xsrfCookieName ? $79n0f.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ('setRequestHeader' in request) $adReO.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$adReO.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === 'function') request.addEventListener('progress', config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === 'function' && request.upload) request.upload.addEventListener('progress', config.onUploadProgress);
        if (config.cancelToken) // Handle cancellation
        config.cancelToken.promise.then(function onCanceled(cancel) {
            if (!request) return;
            request.abort();
            reject(cancel);
            // Clean up request
            request = null;
        });
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("3PfpF", function(module, exports) {
'use strict';

var $hHo9F = parcelRequire("hHo9F");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($hHo9F('Request failed with status code ' + response.status, response.config, null, response.request, response));
};

});
parcelRegister("hHo9F", function(module, exports) {
'use strict';

var $3leq5 = parcelRequire("3leq5");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $3leq5(error, config, code, request, response);
};

});


parcelRegister("79n0f", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");
module.exports = $adReO.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + '=' + encodeURIComponent(value));
            if ($adReO.isNumber(expires)) cookie.push('expires=' + new Date(expires).toGMTString());
            if ($adReO.isString(path)) cookie.push('path=' + path);
            if ($adReO.isString(domain)) cookie.push('domain=' + domain);
            if (secure === true) cookie.push('secure');
            document.cookie = cookie.join('; ');
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, '', Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("40T1q", function(module, exports) {
'use strict';

var $1yk63 = parcelRequire("1yk63");

var $l45Ly = parcelRequire("l45Ly");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$1yk63(requestedURL)) return $l45Ly(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("1yk63", function(module, exports) {
'use strict';
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

});

parcelRegister("l45Ly", function(module, exports) {
'use strict';
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

});


parcelRegister("hMzvi", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $cf2275aca40d6d88$var$ignoreDuplicateOf = [
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $adReO.forEach(headers.split('\n'), function parser(line) {
        i = line.indexOf(':');
        key = $adReO.trim(line.substr(0, i)).toLowerCase();
        val = $adReO.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $cf2275aca40d6d88$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === 'set-cookie') parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("besJL", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");
module.exports = $adReO.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute('href', href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute('href', href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $adReO.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});




parcelRegister("4IsRW", function(module, exports) {
'use strict';
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRegister("5f6d7", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    var valueFromConfig2Keys = [
        'url',
        'method',
        'data'
    ];
    var mergeDeepPropertiesKeys = [
        'headers',
        'auth',
        'proxy',
        'params'
    ];
    var defaultToConfig2Keys = [
        'baseURL',
        'transformRequest',
        'transformResponse',
        'paramsSerializer',
        'timeout',
        'timeoutMessage',
        'withCredentials',
        'adapter',
        'responseType',
        'xsrfCookieName',
        'xsrfHeaderName',
        'onUploadProgress',
        'onDownloadProgress',
        'decompress',
        'maxContentLength',
        'maxBodyLength',
        'maxRedirects',
        'transport',
        'httpAgent',
        'httpsAgent',
        'cancelToken',
        'socketPath',
        'responseEncoding'
    ];
    var directMergeKeys = [
        'validateStatus'
    ];
    function getMergedValue(target, source) {
        if ($adReO.isPlainObject(target) && $adReO.isPlainObject(source)) return $adReO.merge(target, source);
        else if ($adReO.isPlainObject(source)) return $adReO.merge({}, source);
        else if ($adReO.isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(prop) {
        if (!$adReO.isUndefined(config2[prop])) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (!$adReO.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    }
    $adReO.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
        if (!$adReO.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
    });
    $adReO.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
    $adReO.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
        if (!$adReO.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
        else if (!$adReO.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    $adReO.forEach(directMergeKeys, function merge(prop) {
        if (prop in config2) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);
    var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
        return axiosKeys.indexOf(key) === -1;
    });
    $adReO.forEach(otherKeys, mergeDeepProperties);
    return config;
};

});

parcelRegister("2iR5D", function(module, exports) {
'use strict';

var $30WzS = parcelRequire("30WzS");
var $1ad671c27810423e$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach(function(type, i) {
    $1ad671c27810423e$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
var $1ad671c27810423e$var$deprecatedWarnings = {};
var $1ad671c27810423e$var$currentVerArr = $30WzS.version.split('.');
/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */ function $1ad671c27810423e$var$isOlderVersion(version, thanVersion) {
    var pkgVersionArr = thanVersion ? thanVersion.split('.') : $1ad671c27810423e$var$currentVerArr;
    var destVer = version.split('.');
    for(var i = 0; i < 3; i++){
        if (pkgVersionArr[i] > destVer[i]) return true;
        else if (pkgVersionArr[i] < destVer[i]) return false;
    }
    return false;
}
/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */ $1ad671c27810423e$var$validators.transitional = function transitional(validator, version, message) {
    var isDeprecated = version && $1ad671c27810423e$var$isOlderVersion(version);
    function formatMessage(opt, desc) {
        return '[Axios v' + $30WzS.version + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new Error(formatMessage(opt, ' has been removed in ' + version));
        if (isDeprecated && !$1ad671c27810423e$var$deprecatedWarnings[opt]) {
            $1ad671c27810423e$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $1ad671c27810423e$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new TypeError('options must be an object');
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new TypeError('option ' + opt + ' must be ' + result);
            continue;
        }
        if (allowUnknown !== true) throw Error('Unknown option ' + opt);
    }
}
module.exports = {
    isOlderVersion: $1ad671c27810423e$var$isOlderVersion,
    assertOptions: $1ad671c27810423e$var$assertOptions,
    validators: $1ad671c27810423e$var$validators
};

});
parcelRegister("30WzS", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"axios\",\"version\":\"0.21.4\",\"description\":\"Promise based HTTP client for the browser and node.js\",\"main\":\"index.js\",\"scripts\":{\"test\":\"grunt test\",\"start\":\"node ./sandbox/server.js\",\"build\":\"NODE_ENV=production grunt build\",\"preversion\":\"npm test\",\"version\":\"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json\",\"postversion\":\"git push && git push --tags\",\"examples\":\"node ./examples/server.js\",\"coveralls\":\"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js\",\"fix\":\"eslint --fix lib/**/*.js\"},\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/axios/axios.git\"},\"keywords\":[\"xhr\",\"http\",\"ajax\",\"promise\",\"node\"],\"author\":\"Matt Zabriskie\",\"license\":\"MIT\",\"bugs\":{\"url\":\"https://github.com/axios/axios/issues\"},\"homepage\":\"https://axios-http.com\",\"devDependencies\":{\"coveralls\":\"^3.0.0\",\"es6-promise\":\"^4.2.4\",\"grunt\":\"^1.3.0\",\"grunt-banner\":\"^0.6.0\",\"grunt-cli\":\"^1.2.0\",\"grunt-contrib-clean\":\"^1.1.0\",\"grunt-contrib-watch\":\"^1.0.0\",\"grunt-eslint\":\"^23.0.0\",\"grunt-karma\":\"^4.0.0\",\"grunt-mocha-test\":\"^0.13.3\",\"grunt-ts\":\"^6.0.0-beta.19\",\"grunt-webpack\":\"^4.0.2\",\"istanbul-instrumenter-loader\":\"^1.0.0\",\"jasmine-core\":\"^2.4.1\",\"karma\":\"^6.3.2\",\"karma-chrome-launcher\":\"^3.1.0\",\"karma-firefox-launcher\":\"^2.1.0\",\"karma-jasmine\":\"^1.1.1\",\"karma-jasmine-ajax\":\"^0.1.13\",\"karma-safari-launcher\":\"^1.0.0\",\"karma-sauce-launcher\":\"^4.3.6\",\"karma-sinon\":\"^1.0.5\",\"karma-sourcemap-loader\":\"^0.3.8\",\"karma-webpack\":\"^4.0.2\",\"load-grunt-tasks\":\"^3.5.2\",\"minimist\":\"^1.2.0\",\"mocha\":\"^8.2.1\",\"sinon\":\"^4.5.0\",\"terser-webpack-plugin\":\"^4.2.3\",\"typescript\":\"^4.0.5\",\"url-search-params\":\"^0.10.0\",\"webpack\":\"^4.44.2\",\"webpack-dev-server\":\"^3.11.0\"},\"browser\":{\"./lib/adapters/http.js\":\"./lib/adapters/xhr.js\"},\"jsdelivr\":\"dist/axios.min.js\",\"unpkg\":\"dist/axios.min.js\",\"typings\":\"./index.d.ts\",\"dependencies\":{\"follow-redirects\":\"^1.14.0\"},\"bundlesize\":[{\"path\":\"./dist/axios.min.js\",\"threshold\":\"5kB\"}]}");

});



parcelRegister("2W85d", function(module, exports) {
'use strict';
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $223744b24e5d0b4c$var$Cancel(message) {
    this.message = message;
}
$223744b24e5d0b4c$var$Cancel.prototype.toString = function toString() {
    return 'Cancel' + (this.message ? ': ' + this.message : '');
};
$223744b24e5d0b4c$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $223744b24e5d0b4c$var$Cancel;

});

parcelRegister("kZZD0", function(module, exports) {
'use strict';

var $2W85d = parcelRequire("2W85d");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $f4994f37c883aea2$var$CancelToken(executor) {
    if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $2W85d(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $f4994f37c883aea2$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $f4994f37c883aea2$var$CancelToken.source = function source() {
    var cancel;
    var token = new $f4994f37c883aea2$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $f4994f37c883aea2$var$CancelToken;

});

parcelRegister("b676K", function(module, exports) {
'use strict';
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("kgiwQ", function(module, exports) {
'use strict';
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return typeof payload === 'object' && payload.isAxiosError === true;
};

});


parcelRegister("aqFA5", function(module, exports) {
var $797c963b369658b6$var$naiveFallback = function() {
    if (typeof self === "object" && self) return self;
    if (typeof window === "object" && window) return window;
    throw new Error("Unable to resolve global `this`");
};
module.exports = function() {
    if (this) return this;
    // Unexpected strict mode (may happen if e.g. bundled into ESM module)
    // Fallback to standard globalThis if available
    if (typeof globalThis === "object" && globalThis) return globalThis;
    // Thanks @mathiasbynens -> https://mathiasbynens.be/notes/globalthis
    // In all ES5+ engines global object inherits from Object.prototype
    // (if you approached one that doesn't please report)
    try {
        Object.defineProperty(Object.prototype, "__global__", {
            get: function() {
                return this;
            },
            configurable: true
        });
    } catch (error) {
        // Unfortunate case of updates to Object.prototype being restricted
        // via preventExtensions, seal or freeze
        return $797c963b369658b6$var$naiveFallback();
    }
    try {
        // Safari case (window.__global__ works, but __global__ does not)
        if (!__global__) return $797c963b369658b6$var$naiveFallback();
        return __global__;
    } finally{
        delete Object.prototype.__global__;
    }
}();

});

parcelRegister("7qKYm", function(module, exports) {
module.exports = JSON.parse('{"name":"websocket","description":"Websocket Client & Server Library implementing the WebSocket protocol as specified in RFC 6455.","keywords":["websocket","websockets","socket","networking","comet","push","RFC-6455","realtime","server","client"],"author":"Brian McKelvey <theturtle32@gmail.com> (https://github.com/theturtle32)","contributors":["I\xf1aki Baz Castillo <ibc@aliax.net> (http://dev.sipdoc.net)"],"version":"1.0.35","repository":{"type":"git","url":"https://github.com/theturtle32/WebSocket-Node.git"},"homepage":"https://github.com/theturtle32/WebSocket-Node","engines":{"node":">=4.0.0"},"dependencies":{"bufferutil":"^4.0.1","debug":"^2.2.0","es5-ext":"^0.10.63","typedarray-to-buffer":"^3.1.5","utf-8-validate":"^5.0.2","yaeti":"^0.0.6"},"devDependencies":{"buffer-equal":"^1.0.0","gulp":"^4.0.2","gulp-jshint":"^2.0.4","jshint-stylish":"^2.2.1","jshint":"^2.0.0","tape":"^4.9.1"},"config":{"verbose":false},"scripts":{"test":"tape test/unit/*.js","gulp":"gulp"},"main":"index","directories":{"lib":"./lib"},"browser":"lib/browser.js","license":"Apache-2.0"}');

});

parcelRegister("4Fkp4", function(module, exports) {
'use strict';

var $8INWH = parcelRequire("8INWH");

var $1RQEB = parcelRequire("1RQEB");
module.exports = $1RQEB;
$1RQEB.prototype.message = $365ad175729fa366$var$message;
$1RQEB.prototype.info = $365ad175729fa366$var$info;
$1RQEB.prototype.fail = $365ad175729fa366$var$fail;
// Create a message with `reason` at `position`.
// When an error is passed in as `reason`, copies the stack.
function $365ad175729fa366$var$message(reason, position, origin) {
    var message = new $8INWH(reason, position, origin);
    if (this.path) {
        message.name = this.path + ':' + message.name;
        message.file = this.path;
    }
    message.fatal = false;
    this.messages.push(message);
    return message;
}
// Fail: creates a vmessage, associates it with the file, and throws it.
function $365ad175729fa366$var$fail() {
    var message = this.message.apply(this, arguments);
    message.fatal = true;
    throw message;
}
// Info: creates a vmessage, associates it with the file, and marks the fatality
// as null.
function $365ad175729fa366$var$info() {
    var message = this.message.apply(this, arguments);
    message.fatal = null;
    return message;
}

});
parcelRegister("8INWH", function(module, exports) {
'use strict';

var $8Uubm = parcelRequire("8Uubm");
module.exports = $65992cfe6cf32be7$var$VMessage;
// Inherit from `Error#`.
function $65992cfe6cf32be7$var$VMessagePrototype() {}
$65992cfe6cf32be7$var$VMessagePrototype.prototype = Error.prototype;
$65992cfe6cf32be7$var$VMessage.prototype = new $65992cfe6cf32be7$var$VMessagePrototype();
// Message properties.
var $65992cfe6cf32be7$var$proto = $65992cfe6cf32be7$var$VMessage.prototype;
$65992cfe6cf32be7$var$proto.file = '';
$65992cfe6cf32be7$var$proto.name = '';
$65992cfe6cf32be7$var$proto.reason = '';
$65992cfe6cf32be7$var$proto.message = '';
$65992cfe6cf32be7$var$proto.stack = '';
$65992cfe6cf32be7$var$proto.fatal = null;
$65992cfe6cf32be7$var$proto.column = null;
$65992cfe6cf32be7$var$proto.line = null;
// Construct a new VMessage.
//
// Note: We cannot invoke `Error` on the created context, as that adds readonly
// `line` and `column` attributes on Safari 9, thus throwing and failing the
// data.
function $65992cfe6cf32be7$var$VMessage(reason, position, origin) {
    var parts;
    var range;
    var location;
    if (typeof position === 'string') {
        origin = position;
        position = null;
    }
    parts = $65992cfe6cf32be7$var$parseOrigin(origin);
    range = $8Uubm(position) || '1:1';
    location = {
        start: {
            line: null,
            column: null
        },
        end: {
            line: null,
            column: null
        }
    };
    // Node.
    if (position && position.position) position = position.position;
    if (position) {
        // Position.
        if (position.start) {
            location = position;
            position = position.start;
        } else // Point.
        location.start = position;
    }
    if (reason.stack) {
        this.stack = reason.stack;
        reason = reason.message;
    }
    this.message = reason;
    this.name = range;
    this.reason = reason;
    this.line = position ? position.line : null;
    this.column = position ? position.column : null;
    this.location = location;
    this.source = parts[0];
    this.ruleId = parts[1];
}
function $65992cfe6cf32be7$var$parseOrigin(origin) {
    var result = [
        null,
        null
    ];
    var index;
    if (typeof origin === 'string') {
        index = origin.indexOf(':');
        if (index === -1) result[1] = origin;
        else {
            result[0] = origin.slice(0, index);
            result[1] = origin.slice(index + 1);
        }
    }
    return result;
}

});
parcelRegister("8Uubm", function(module, exports) {
'use strict';
var $67caf745500375bb$var$own = {}.hasOwnProperty;
module.exports = $67caf745500375bb$var$stringify;
function $67caf745500375bb$var$stringify(value) {
    // Nothing.
    if (!value || typeof value !== 'object') return '';
    // Node.
    if ($67caf745500375bb$var$own.call(value, 'position') || $67caf745500375bb$var$own.call(value, 'type')) return $67caf745500375bb$var$position(value.position);
    // Position.
    if ($67caf745500375bb$var$own.call(value, 'start') || $67caf745500375bb$var$own.call(value, 'end')) return $67caf745500375bb$var$position(value);
    // Point.
    if ($67caf745500375bb$var$own.call(value, 'line') || $67caf745500375bb$var$own.call(value, 'column')) return $67caf745500375bb$var$point(value);
    // ?
    return '';
}
function $67caf745500375bb$var$point(point) {
    if (!point || typeof point !== 'object') point = {};
    return $67caf745500375bb$var$index(point.line) + ':' + $67caf745500375bb$var$index(point.column);
}
function $67caf745500375bb$var$position(pos) {
    if (!pos || typeof pos !== 'object') pos = {};
    return $67caf745500375bb$var$point(pos.start) + '-' + $67caf745500375bb$var$point(pos.end);
}
function $67caf745500375bb$var$index(value) {
    return value && typeof value === 'number' ? value : 1;
}

});


parcelRegister("1RQEB", function(module, exports) {
'use strict';

var $5rQ3s = parcelRequire("5rQ3s");

var $2IESQ = parcelRequire("2IESQ");

var $1KitT = parcelRequire("1KitT");
module.exports = $15c395a9a0da7bb5$var$VFile;
var $15c395a9a0da7bb5$var$own = {}.hasOwnProperty;
// Order of setting (least specific to most), we need this because otherwise
// `{stem: 'a', path: '~/b.js'}` would throw, as a path is needed before a
// stem can be set.
var $15c395a9a0da7bb5$var$order = [
    'history',
    'path',
    'basename',
    'stem',
    'extname',
    'dirname'
];
$15c395a9a0da7bb5$var$VFile.prototype.toString = $15c395a9a0da7bb5$var$toString;
// Access full path (`~/index.min.js`).
Object.defineProperty($15c395a9a0da7bb5$var$VFile.prototype, 'path', {
    get: $15c395a9a0da7bb5$var$getPath,
    set: $15c395a9a0da7bb5$var$setPath
});
// Access parent path (`~`).
Object.defineProperty($15c395a9a0da7bb5$var$VFile.prototype, 'dirname', {
    get: $15c395a9a0da7bb5$var$getDirname,
    set: $15c395a9a0da7bb5$var$setDirname
});
// Access basename (`index.min.js`).
Object.defineProperty($15c395a9a0da7bb5$var$VFile.prototype, 'basename', {
    get: $15c395a9a0da7bb5$var$getBasename,
    set: $15c395a9a0da7bb5$var$setBasename
});
// Access extname (`.js`).
Object.defineProperty($15c395a9a0da7bb5$var$VFile.prototype, 'extname', {
    get: $15c395a9a0da7bb5$var$getExtname,
    set: $15c395a9a0da7bb5$var$setExtname
});
// Access stem (`index.min`).
Object.defineProperty($15c395a9a0da7bb5$var$VFile.prototype, 'stem', {
    get: $15c395a9a0da7bb5$var$getStem,
    set: $15c395a9a0da7bb5$var$setStem
});
// Construct a new file.
function $15c395a9a0da7bb5$var$VFile(options) {
    var prop;
    var index;
    if (!options) options = {};
    else if (typeof options === 'string' || $1KitT(options)) options = {
        contents: options
    };
    else if ('message' in options && 'messages' in options) return options;
    if (!(this instanceof $15c395a9a0da7bb5$var$VFile)) return new $15c395a9a0da7bb5$var$VFile(options);
    this.data = {};
    this.messages = [];
    this.history = [];
    this.cwd = $2IESQ.cwd();
    // Set path related properties in the correct order.
    index = -1;
    while(++index < $15c395a9a0da7bb5$var$order.length){
        prop = $15c395a9a0da7bb5$var$order[index];
        if ($15c395a9a0da7bb5$var$own.call(options, prop)) this[prop] = options[prop];
    }
    // Set non-path related properties.
    for(prop in options)if ($15c395a9a0da7bb5$var$order.indexOf(prop) < 0) this[prop] = options[prop];
}
function $15c395a9a0da7bb5$var$getPath() {
    return this.history[this.history.length - 1];
}
function $15c395a9a0da7bb5$var$setPath(path) {
    $15c395a9a0da7bb5$var$assertNonEmpty(path, 'path');
    if (this.path !== path) this.history.push(path);
}
function $15c395a9a0da7bb5$var$getDirname() {
    return typeof this.path === 'string' ? $5rQ3s.dirname(this.path) : undefined;
}
function $15c395a9a0da7bb5$var$setDirname(dirname) {
    $15c395a9a0da7bb5$var$assertPath(this.path, 'dirname');
    this.path = $5rQ3s.join(dirname || '', this.basename);
}
function $15c395a9a0da7bb5$var$getBasename() {
    return typeof this.path === 'string' ? $5rQ3s.basename(this.path) : undefined;
}
function $15c395a9a0da7bb5$var$setBasename(basename) {
    $15c395a9a0da7bb5$var$assertNonEmpty(basename, 'basename');
    $15c395a9a0da7bb5$var$assertPart(basename, 'basename');
    this.path = $5rQ3s.join(this.dirname || '', basename);
}
function $15c395a9a0da7bb5$var$getExtname() {
    return typeof this.path === 'string' ? $5rQ3s.extname(this.path) : undefined;
}
function $15c395a9a0da7bb5$var$setExtname(extname) {
    $15c395a9a0da7bb5$var$assertPart(extname, 'extname');
    $15c395a9a0da7bb5$var$assertPath(this.path, 'extname');
    if (extname) {
        if (extname.charCodeAt(0) !== 46 /* `.` */ ) throw new Error('`extname` must start with `.`');
        if (extname.indexOf('.', 1) > -1) throw new Error('`extname` cannot contain multiple dots');
    }
    this.path = $5rQ3s.join(this.dirname, this.stem + (extname || ''));
}
function $15c395a9a0da7bb5$var$getStem() {
    return typeof this.path === 'string' ? $5rQ3s.basename(this.path, this.extname) : undefined;
}
function $15c395a9a0da7bb5$var$setStem(stem) {
    $15c395a9a0da7bb5$var$assertNonEmpty(stem, 'stem');
    $15c395a9a0da7bb5$var$assertPart(stem, 'stem');
    this.path = $5rQ3s.join(this.dirname || '', stem + (this.extname || ''));
}
// Get the value of the file.
function $15c395a9a0da7bb5$var$toString(encoding) {
    return (this.contents || '').toString(encoding);
}
// Assert that `part` is not a path (i.e., does not contain `p.sep`).
function $15c395a9a0da7bb5$var$assertPart(part, name) {
    if (part && part.indexOf($5rQ3s.sep) > -1) throw new Error('`' + name + '` cannot be a path: did not expect `' + $5rQ3s.sep + '`');
}
// Assert that `part` is not empty.
function $15c395a9a0da7bb5$var$assertNonEmpty(part, name) {
    if (!part) throw new Error('`' + name + '` cannot be empty');
}
// Assert `path` exists.
function $15c395a9a0da7bb5$var$assertPath(path, name) {
    if (!path) throw new Error('Setting `' + name + '` requires `path` to be set too');
}

});
parcelRegister("5rQ3s", function(module, exports) {

$parcel$export(module.exports, "basename", function () { return $3f77da5648f21d15$export$9bf319d8f74f51d1; }, function (v) { return $3f77da5648f21d15$export$9bf319d8f74f51d1 = v; });
$parcel$export(module.exports, "dirname", function () { return $3f77da5648f21d15$export$7f7b8152cc673abe; }, function (v) { return $3f77da5648f21d15$export$7f7b8152cc673abe = v; });
$parcel$export(module.exports, "extname", function () { return $3f77da5648f21d15$export$d0e86f3a75393fa3; }, function (v) { return $3f77da5648f21d15$export$d0e86f3a75393fa3 = v; });
$parcel$export(module.exports, "join", function () { return $3f77da5648f21d15$export$f7e2c8231c57a8bd; }, function (v) { return $3f77da5648f21d15$export$f7e2c8231c57a8bd = v; });
$parcel$export(module.exports, "sep", function () { return $3f77da5648f21d15$export$5aee1a5bd9743d8f; }, function (v) { return $3f77da5648f21d15$export$5aee1a5bd9743d8f = v; });
// A derivative work based on:
// <https://github.com/browserify/path-browserify>.
// Which is licensed:
//
// MIT License
//
// Copyright (c) 2013 James Halliday
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
// A derivative work based on:
//
// Parts of that are extracted from Node’s internal `path` module:
// <https://github.com/nodejs/node/blob/master/lib/path.js>.
// Which is licensed:
//
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
var $3f77da5648f21d15$export$9bf319d8f74f51d1;
var $3f77da5648f21d15$export$7f7b8152cc673abe;
var $3f77da5648f21d15$export$d0e86f3a75393fa3;
var $3f77da5648f21d15$export$f7e2c8231c57a8bd;
var $3f77da5648f21d15$export$5aee1a5bd9743d8f;
'use strict';
$3f77da5648f21d15$export$9bf319d8f74f51d1 = $3f77da5648f21d15$var$basename;
$3f77da5648f21d15$export$7f7b8152cc673abe = $3f77da5648f21d15$var$dirname;
$3f77da5648f21d15$export$d0e86f3a75393fa3 = $3f77da5648f21d15$var$extname;
$3f77da5648f21d15$export$f7e2c8231c57a8bd = $3f77da5648f21d15$var$join;
$3f77da5648f21d15$export$5aee1a5bd9743d8f = '/';
function $3f77da5648f21d15$var$basename(path, ext) {
    var start = 0;
    var end = -1;
    var index;
    var firstNonSlashEnd;
    var seenNonSlash;
    var extIndex;
    if (ext !== undefined && typeof ext !== 'string') throw new TypeError('"ext" argument must be a string');
    $3f77da5648f21d15$var$assertPath(path);
    index = path.length;
    if (ext === undefined || !ext.length || ext.length > path.length) {
        while(index--){
            if (path.charCodeAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            {
                if (seenNonSlash) {
                    start = index + 1;
                    break;
                }
            } else if (end < 0) {
                // We saw the first non-path separator, mark this as the end of our
                // path component.
                seenNonSlash = true;
                end = index + 1;
            }
        }
        return end < 0 ? '' : path.slice(start, end);
    }
    if (ext === path) return '';
    firstNonSlashEnd = -1;
    extIndex = ext.length - 1;
    while(index--){
        if (path.charCodeAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now.
        {
            if (seenNonSlash) {
                start = index + 1;
                break;
            }
        } else {
            if (firstNonSlashEnd < 0) {
                // We saw the first non-path separator, remember this index in case
                // we need it if the extension ends up not matching.
                seenNonSlash = true;
                firstNonSlashEnd = index + 1;
            }
            if (extIndex > -1) {
                // Try to match the explicit extension.
                if (path.charCodeAt(index) === ext.charCodeAt(extIndex--)) {
                    if (extIndex < 0) // We matched the extension, so mark this as the end of our path
                    // component
                    end = index;
                } else {
                    // Extension does not match, so our result is the entire path
                    // component
                    extIndex = -1;
                    end = firstNonSlashEnd;
                }
            }
        }
    }
    if (start === end) end = firstNonSlashEnd;
    else if (end < 0) end = path.length;
    return path.slice(start, end);
}
function $3f77da5648f21d15$var$dirname(path) {
    var end;
    var unmatchedSlash;
    var index;
    $3f77da5648f21d15$var$assertPath(path);
    if (!path.length) return '.';
    end = -1;
    index = path.length;
    // Prefix `--` is important to not run on `0`.
    while(--index){
        if (path.charCodeAt(index) === 47 /* `/` */ ) {
            if (unmatchedSlash) {
                end = index;
                break;
            }
        } else if (!unmatchedSlash) // We saw the first non-path separator
        unmatchedSlash = true;
    }
    return end < 0 ? path.charCodeAt(0) === 47 /* `/` */  ? '/' : '.' : end === 1 && path.charCodeAt(0) === 47 /* `/` */  ? '//' : path.slice(0, end);
}
function $3f77da5648f21d15$var$extname(path) {
    var startDot = -1;
    var startPart = 0;
    var end = -1;
    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find.
    var preDotState = 0;
    var unmatchedSlash;
    var code;
    var index;
    $3f77da5648f21d15$var$assertPath(path);
    index = path.length;
    while(index--){
        code = path.charCodeAt(index);
        if (code === 47 /* `/` */ ) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            if (unmatchedSlash) {
                startPart = index + 1;
                break;
            }
            continue;
        }
        if (end < 0) {
            // We saw the first non-path separator, mark this as the end of our
            // extension.
            unmatchedSlash = true;
            end = index + 1;
        }
        if (code === 46 /* `.` */ ) {
            // If this is our first dot, mark it as the start of our extension.
            if (startDot < 0) startDot = index;
            else if (preDotState !== 1) preDotState = 1;
        } else if (startDot > -1) // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension.
        preDotState = -1;
    }
    if (startDot < 0 || end < 0 || // We saw a non-dot character immediately before the dot.
    preDotState === 0 || // The (right-most) trimmed path component is exactly `..`.
    preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return '';
    return path.slice(startDot, end);
}
function $3f77da5648f21d15$var$join() {
    var index = -1;
    var joined;
    while(++index < arguments.length){
        $3f77da5648f21d15$var$assertPath(arguments[index]);
        if (arguments[index]) joined = joined === undefined ? arguments[index] : joined + '/' + arguments[index];
    }
    return joined === undefined ? '.' : $3f77da5648f21d15$var$normalize(joined);
}
// Note: `normalize` is not exposed as `path.normalize`, so some code is
// manually removed from it.
function $3f77da5648f21d15$var$normalize(path) {
    var absolute;
    var value;
    $3f77da5648f21d15$var$assertPath(path);
    absolute = path.charCodeAt(0) === 47 /* `/` */ ;
    // Normalize the path according to POSIX rules.
    value = $3f77da5648f21d15$var$normalizeString(path, !absolute);
    if (!value.length && !absolute) value = '.';
    if (value.length && path.charCodeAt(path.length - 1) === 47 /* / */ ) value += '/';
    return absolute ? '/' + value : value;
}
// Resolve `.` and `..` elements in a path with directory names.
function $3f77da5648f21d15$var$normalizeString(path, allowAboveRoot) {
    var result = '';
    var lastSegmentLength = 0;
    var lastSlash = -1;
    var dots = 0;
    var index = -1;
    var code;
    var lastSlashIndex;
    while(++index <= path.length){
        if (index < path.length) code = path.charCodeAt(index);
        else if (code === 47 /* `/` */ ) break;
        else code = 47 /* `/` */ ;
        if (code === 47 /* `/` */ ) {
            if (lastSlash === index - 1 || dots === 1) ;
            else if (lastSlash !== index - 1 && dots === 2) {
                if (result.length < 2 || lastSegmentLength !== 2 || result.charCodeAt(result.length - 1) !== 46 /* `.` */  || result.charCodeAt(result.length - 2) !== 46 /* `.` */ ) {
                    if (result.length > 2) {
                        lastSlashIndex = result.lastIndexOf('/');
                        /* istanbul ignore else - No clue how to cover it. */ if (lastSlashIndex !== result.length - 1) {
                            if (lastSlashIndex < 0) {
                                result = '';
                                lastSegmentLength = 0;
                            } else {
                                result = result.slice(0, lastSlashIndex);
                                lastSegmentLength = result.length - 1 - result.lastIndexOf('/');
                            }
                            lastSlash = index;
                            dots = 0;
                            continue;
                        }
                    } else if (result.length) {
                        result = '';
                        lastSegmentLength = 0;
                        lastSlash = index;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    result = result.length ? result + '/..' : '..';
                    lastSegmentLength = 2;
                }
            } else {
                if (result.length) result += '/' + path.slice(lastSlash + 1, index);
                else result = path.slice(lastSlash + 1, index);
                lastSegmentLength = index - lastSlash - 1;
            }
            lastSlash = index;
            dots = 0;
        } else if (code === 46 /* `.` */  && dots > -1) dots++;
        else dots = -1;
    }
    return result;
}
function $3f77da5648f21d15$var$assertPath(path) {
    if (typeof path !== 'string') throw new TypeError('Path must be a string. Received ' + JSON.stringify(path));
}

});

parcelRegister("2IESQ", function(module, exports) {

$parcel$export(module.exports, "cwd", function () { return $1faf6772e03c3c94$export$5f7bb87daeae59c1; }, function (v) { return $1faf6772e03c3c94$export$5f7bb87daeae59c1 = v; });
// Somewhat based on:
// <https://github.com/defunctzombie/node-process/blob/master/browser.js>.
// But I don’t think one tiny line of code can be copyrighted. 😅
var $1faf6772e03c3c94$export$5f7bb87daeae59c1;
'use strict';
$1faf6772e03c3c94$export$5f7bb87daeae59c1 = $1faf6772e03c3c94$var$cwd;
function $1faf6772e03c3c94$var$cwd() {
    return '/';
}

});

parcelRegister("1KitT", function(module, exports) {
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ module.exports = function isBuffer(obj) {
    return obj != null && obj.constructor != null && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
};

});



parcelRegister("l8YWZ", function(module, exports) {
'use strict';
module.exports = $f6499fcbf36d1abc$var$fromMarkdown;

var $dR9Gq = parcelRequire("dR9Gq");

var $jADl9 = parcelRequire("jADl9");

var $593jb = parcelRequire("593jb");

var $byQ4m = parcelRequire("byQ4m");

var $HOe7l = parcelRequire("HOe7l");

var $eG14y = parcelRequire("eG14y");

var $k993E = parcelRequire("k993E");

var $6KPiM = parcelRequire("6KPiM");

var $bI5dj = parcelRequire("bI5dj");

var $8Uubm = parcelRequire("8Uubm");
function $f6499fcbf36d1abc$var$fromMarkdown(value, encoding, options) {
    if (typeof encoding !== 'string') {
        options = encoding;
        encoding = undefined;
    }
    return $f6499fcbf36d1abc$var$compiler(options)($6KPiM($eG14y(options).document().write($k993E()(value, encoding, true))));
}
// Note this compiler only understand complete buffering, not streaming.
function $f6499fcbf36d1abc$var$compiler(options) {
    var settings = options || {};
    var config = $f6499fcbf36d1abc$var$configure({
        transforms: [],
        canContainEols: [
            'emphasis',
            'fragment',
            'heading',
            'paragraph',
            'strong'
        ],
        enter: {
            autolink: opener(link),
            autolinkProtocol: onenterdata,
            autolinkEmail: onenterdata,
            atxHeading: opener(heading),
            blockQuote: opener(blockQuote),
            characterEscape: onenterdata,
            characterReference: onenterdata,
            codeFenced: opener(codeFlow),
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: opener(codeFlow, buffer),
            codeText: opener(codeText, buffer),
            codeTextData: onenterdata,
            data: onenterdata,
            codeFlowValue: onenterdata,
            definition: opener(definition),
            definitionDestinationString: buffer,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: opener(emphasis),
            hardBreakEscape: opener(hardBreak),
            hardBreakTrailing: opener(hardBreak),
            htmlFlow: opener(html, buffer),
            htmlFlowData: onenterdata,
            htmlText: opener(html, buffer),
            htmlTextData: onenterdata,
            image: opener(image),
            label: buffer,
            link: opener(link),
            listItem: opener(listItem),
            listItemValue: onenterlistitemvalue,
            listOrdered: opener(list, onenterlistordered),
            listUnordered: opener(list),
            paragraph: opener(paragraph),
            reference: onenterreference,
            referenceString: buffer,
            resourceDestinationString: buffer,
            resourceTitleString: buffer,
            setextHeading: opener(heading),
            strong: opener(strong),
            thematicBreak: opener(thematicBreak)
        },
        exit: {
            atxHeading: closer(),
            atxHeadingSequence: onexitatxheadingsequence,
            autolink: closer(),
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: closer(),
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            codeFenced: closer(onexitcodefenced),
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onexitcodefencedfencemeta,
            codeFlowValue: onexitdata,
            codeIndented: closer(onexitcodeindented),
            codeText: closer(onexitcodetext),
            codeTextData: onexitdata,
            data: onexitdata,
            definition: closer(),
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: closer(),
            hardBreakEscape: closer(onexithardbreak),
            hardBreakTrailing: closer(onexithardbreak),
            htmlFlow: closer(onexithtmlflow),
            htmlFlowData: onexitdata,
            htmlText: closer(onexithtmltext),
            htmlTextData: onexitdata,
            image: closer(onexitimage),
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: closer(onexitlink),
            listItem: closer(),
            listOrdered: closer(),
            listUnordered: closer(),
            paragraph: closer(),
            referenceString: onexitreferencestring,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            resource: onexitresource,
            setextHeading: closer(onexitsetextheading),
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: closer(),
            thematicBreak: closer()
        }
    }, settings.mdastExtensions || []);
    var data = {};
    return compile;
    function compile(events) {
        var tree = {
            type: 'root',
            children: []
        };
        var stack = [
            tree
        ];
        var tokenStack = [];
        var listStack = [];
        var index = -1;
        var handler;
        var listStart;
        var context = {
            stack: stack,
            tokenStack: tokenStack,
            config: config,
            enter: enter,
            exit: exit,
            buffer: buffer,
            resume: resume,
            setData: setData,
            getData: getData
        };
        while(++index < events.length)// We preprocess lists to add `listItem` tokens, and to infer whether
        // items the list itself are spread out.
        if (events[index][1].type === 'listOrdered' || events[index][1].type === 'listUnordered') {
            if (events[index][0] === 'enter') listStack.push(index);
            else {
                listStart = listStack.pop(index);
                index = prepareList(events, listStart, index);
            }
        }
        index = -1;
        while(++index < events.length){
            handler = config[events[index][0]];
            if ($593jb.call(handler, events[index][1].type)) handler[events[index][1].type].call($jADl9({
                sliceSerialize: events[index][2].sliceSerialize
            }, context), events[index][1]);
        }
        if (tokenStack.length) throw new Error('Cannot close document, a token (`' + tokenStack[tokenStack.length - 1].type + '`, ' + $8Uubm({
            start: tokenStack[tokenStack.length - 1].start,
            end: tokenStack[tokenStack.length - 1].end
        }) + ') is still open');
        // Figure out `root` position.
        tree.position = {
            start: point(events.length ? events[0][1].start : {
                line: 1,
                column: 1,
                offset: 0
            }),
            end: point(events.length ? events[events.length - 2][1].end : {
                line: 1,
                column: 1,
                offset: 0
            })
        };
        index = -1;
        while(++index < config.transforms.length)tree = config.transforms[index](tree) || tree;
        return tree;
    }
    function prepareList(events, start, length) {
        var index = start - 1;
        var containerBalance = -1;
        var listSpread = false;
        var listItem;
        var tailIndex;
        var lineIndex;
        var tailEvent;
        var event;
        var firstBlankLineIndex;
        var atMarker;
        while(++index <= length){
            event = events[index];
            if (event[1].type === 'listUnordered' || event[1].type === 'listOrdered' || event[1].type === 'blockQuote') {
                if (event[0] === 'enter') containerBalance++;
                else containerBalance--;
                atMarker = undefined;
            } else if (event[1].type === 'lineEndingBlank') {
                if (event[0] === 'enter') {
                    if (listItem && !atMarker && !containerBalance && !firstBlankLineIndex) firstBlankLineIndex = index;
                    atMarker = undefined;
                }
            } else if (event[1].type === 'linePrefix' || event[1].type === 'listItemValue' || event[1].type === 'listItemMarker' || event[1].type === 'listItemPrefix' || event[1].type === 'listItemPrefixWhitespace') ;
            else atMarker = undefined;
            if (!containerBalance && event[0] === 'enter' && event[1].type === 'listItemPrefix' || containerBalance === -1 && event[0] === 'exit' && (event[1].type === 'listUnordered' || event[1].type === 'listOrdered')) {
                if (listItem) {
                    tailIndex = index;
                    lineIndex = undefined;
                    while(tailIndex--){
                        tailEvent = events[tailIndex];
                        if (tailEvent[1].type === 'lineEnding' || tailEvent[1].type === 'lineEndingBlank') {
                            if (tailEvent[0] === 'exit') continue;
                            if (lineIndex) {
                                events[lineIndex][1].type = 'lineEndingBlank';
                                listSpread = true;
                            }
                            tailEvent[1].type = 'lineEnding';
                            lineIndex = tailIndex;
                        } else if (tailEvent[1].type === 'linePrefix' || tailEvent[1].type === 'blockQuotePrefix' || tailEvent[1].type === 'blockQuotePrefixWhitespace' || tailEvent[1].type === 'blockQuoteMarker' || tailEvent[1].type === 'listItemIndent') ;
                        else break;
                    }
                    if (firstBlankLineIndex && (!lineIndex || firstBlankLineIndex < lineIndex)) listItem._spread = true;
                    // Fix position.
                    listItem.end = point(lineIndex ? events[lineIndex][1].start : event[1].end);
                    events.splice(lineIndex || index, 0, [
                        'exit',
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                }
                // Create a new list item.
                if (event[1].type === 'listItemPrefix') {
                    listItem = {
                        type: 'listItem',
                        _spread: false,
                        start: point(event[1].start)
                    };
                    events.splice(index, 0, [
                        'enter',
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                    firstBlankLineIndex = undefined;
                    atMarker = true;
                }
            }
        }
        events[start][1]._spread = listSpread;
        return length;
    }
    function setData(key, value) {
        data[key] = value;
    }
    function getData(key) {
        return data[key];
    }
    function point(d) {
        return {
            line: d.line,
            column: d.column,
            offset: d.offset
        };
    }
    function opener(create, and) {
        return open;
        function open(token) {
            enter.call(this, create(token), token);
            if (and) and.call(this, token);
        }
    }
    function buffer() {
        this.stack.push({
            type: 'fragment',
            children: []
        });
    }
    function enter(node, token) {
        this.stack[this.stack.length - 1].children.push(node);
        this.stack.push(node);
        this.tokenStack.push(token);
        node.position = {
            start: point(token.start)
        };
        return node;
    }
    function closer(and) {
        return close;
        function close(token) {
            if (and) and.call(this, token);
            exit.call(this, token);
        }
    }
    function exit(token) {
        var node = this.stack.pop();
        var open = this.tokenStack.pop();
        if (!open) throw new Error('Cannot close `' + token.type + '` (' + $8Uubm({
            start: token.start,
            end: token.end
        }) + "): it\u2019s not open");
        else if (open.type !== token.type) throw new Error('Cannot close `' + token.type + '` (' + $8Uubm({
            start: token.start,
            end: token.end
        }) + '): a different token (`' + open.type + '`, ' + $8Uubm({
            start: open.start,
            end: open.end
        }) + ') is open');
        node.position.end = point(token.end);
        return node;
    }
    function resume() {
        return $dR9Gq(this.stack.pop());
    }
    //
    // Handlers.
    //
    function onenterlistordered() {
        setData('expectingFirstListItemValue', true);
    }
    function onenterlistitemvalue(token) {
        if (getData('expectingFirstListItemValue')) {
            this.stack[this.stack.length - 2].start = parseInt(this.sliceSerialize(token), 10);
            setData('expectingFirstListItemValue');
        }
    }
    function onexitcodefencedfenceinfo() {
        var data = this.resume();
        this.stack[this.stack.length - 1].lang = data;
    }
    function onexitcodefencedfencemeta() {
        var data = this.resume();
        this.stack[this.stack.length - 1].meta = data;
    }
    function onexitcodefencedfence() {
        // Exit if this is the closing fence.
        if (getData('flowCodeInside')) return;
        this.buffer();
        setData('flowCodeInside', true);
    }
    function onexitcodefenced() {
        var data = this.resume();
        this.stack[this.stack.length - 1].value = data.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, '');
        setData('flowCodeInside');
    }
    function onexitcodeindented() {
        var data = this.resume();
        this.stack[this.stack.length - 1].value = data;
    }
    function onexitdefinitionlabelstring(token) {
        // Discard label, use the source content instead.
        var label = this.resume();
        this.stack[this.stack.length - 1].label = label;
        this.stack[this.stack.length - 1].identifier = $byQ4m(this.sliceSerialize(token)).toLowerCase();
    }
    function onexitdefinitiontitlestring() {
        var data = this.resume();
        this.stack[this.stack.length - 1].title = data;
    }
    function onexitdefinitiondestinationstring() {
        var data = this.resume();
        this.stack[this.stack.length - 1].url = data;
    }
    function onexitatxheadingsequence(token) {
        if (!this.stack[this.stack.length - 1].depth) this.stack[this.stack.length - 1].depth = this.sliceSerialize(token).length;
    }
    function onexitsetextheadingtext() {
        setData('setextHeadingSlurpLineEnding', true);
    }
    function onexitsetextheadinglinesequence(token) {
        this.stack[this.stack.length - 1].depth = this.sliceSerialize(token).charCodeAt(0) === 61 ? 1 : 2;
    }
    function onexitsetextheading() {
        setData('setextHeadingSlurpLineEnding');
    }
    function onenterdata(token) {
        var siblings = this.stack[this.stack.length - 1].children;
        var tail = siblings[siblings.length - 1];
        if (!tail || tail.type !== 'text') {
            // Add a new text node.
            tail = text();
            tail.position = {
                start: point(token.start)
            };
            this.stack[this.stack.length - 1].children.push(tail);
        }
        this.stack.push(tail);
    }
    function onexitdata(token) {
        var tail = this.stack.pop();
        tail.value += this.sliceSerialize(token);
        tail.position.end = point(token.end);
    }
    function onexitlineending(token) {
        var context = this.stack[this.stack.length - 1];
        // If we’re at a hard break, include the line ending in there.
        if (getData('atHardBreak')) {
            context.children[context.children.length - 1].position.end = point(token.end);
            setData('atHardBreak');
            return;
        }
        if (!getData('setextHeadingSlurpLineEnding') && config.canContainEols.indexOf(context.type) > -1) {
            onenterdata.call(this, token);
            onexitdata.call(this, token);
        }
    }
    function onexithardbreak() {
        setData('atHardBreak', true);
    }
    function onexithtmlflow() {
        var data = this.resume();
        this.stack[this.stack.length - 1].value = data;
    }
    function onexithtmltext() {
        var data = this.resume();
        this.stack[this.stack.length - 1].value = data;
    }
    function onexitcodetext() {
        var data = this.resume();
        this.stack[this.stack.length - 1].value = data;
    }
    function onexitlink() {
        var context = this.stack[this.stack.length - 1];
        // To do: clean.
        if (getData('inReference')) {
            context.type += 'Reference';
            context.referenceType = getData('referenceType') || 'shortcut';
            delete context.url;
            delete context.title;
        } else {
            delete context.identifier;
            delete context.label;
            delete context.referenceType;
        }
        setData('referenceType');
    }
    function onexitimage() {
        var context = this.stack[this.stack.length - 1];
        // To do: clean.
        if (getData('inReference')) {
            context.type += 'Reference';
            context.referenceType = getData('referenceType') || 'shortcut';
            delete context.url;
            delete context.title;
        } else {
            delete context.identifier;
            delete context.label;
            delete context.referenceType;
        }
        setData('referenceType');
    }
    function onexitlabeltext(token) {
        this.stack[this.stack.length - 2].identifier = $byQ4m(this.sliceSerialize(token)).toLowerCase();
    }
    function onexitlabel() {
        var fragment = this.stack[this.stack.length - 1];
        var value = this.resume();
        this.stack[this.stack.length - 1].label = value;
        // Assume a reference.
        setData('inReference', true);
        if (this.stack[this.stack.length - 1].type === 'link') this.stack[this.stack.length - 1].children = fragment.children;
        else this.stack[this.stack.length - 1].alt = value;
    }
    function onexitresourcedestinationstring() {
        var data = this.resume();
        this.stack[this.stack.length - 1].url = data;
    }
    function onexitresourcetitlestring() {
        var data = this.resume();
        this.stack[this.stack.length - 1].title = data;
    }
    function onexitresource() {
        setData('inReference');
    }
    function onenterreference() {
        setData('referenceType', 'collapsed');
    }
    function onexitreferencestring(token) {
        var label = this.resume();
        this.stack[this.stack.length - 1].label = label;
        this.stack[this.stack.length - 1].identifier = $byQ4m(this.sliceSerialize(token)).toLowerCase();
        setData('referenceType', 'full');
    }
    function onexitcharacterreferencemarker(token) {
        setData('characterReferenceType', token.type);
    }
    function onexitcharacterreferencevalue(token) {
        var data = this.sliceSerialize(token);
        var type = getData('characterReferenceType');
        var value;
        var tail;
        if (type) {
            value = $HOe7l(data, type === 'characterReferenceMarkerNumeric' ? 10 : 16);
            setData('characterReferenceType');
        } else value = $bI5dj(data);
        tail = this.stack.pop();
        tail.value += value;
        tail.position.end = point(token.end);
    }
    function onexitautolinkprotocol(token) {
        onexitdata.call(this, token);
        this.stack[this.stack.length - 1].url = this.sliceSerialize(token);
    }
    function onexitautolinkemail(token) {
        onexitdata.call(this, token);
        this.stack[this.stack.length - 1].url = 'mailto:' + this.sliceSerialize(token);
    }
    //
    // Creaters.
    //
    function blockQuote() {
        return {
            type: 'blockquote',
            children: []
        };
    }
    function codeFlow() {
        return {
            type: 'code',
            lang: null,
            meta: null,
            value: ''
        };
    }
    function codeText() {
        return {
            type: 'inlineCode',
            value: ''
        };
    }
    function definition() {
        return {
            type: 'definition',
            identifier: '',
            label: null,
            title: null,
            url: ''
        };
    }
    function emphasis() {
        return {
            type: 'emphasis',
            children: []
        };
    }
    function heading() {
        return {
            type: 'heading',
            depth: undefined,
            children: []
        };
    }
    function hardBreak() {
        return {
            type: 'break'
        };
    }
    function html() {
        return {
            type: 'html',
            value: ''
        };
    }
    function image() {
        return {
            type: 'image',
            title: null,
            url: '',
            alt: null
        };
    }
    function link() {
        return {
            type: 'link',
            title: null,
            url: '',
            children: []
        };
    }
    function list(token) {
        return {
            type: 'list',
            ordered: token.type === 'listOrdered',
            start: null,
            spread: token._spread,
            children: []
        };
    }
    function listItem(token) {
        return {
            type: 'listItem',
            spread: token._spread,
            checked: null,
            children: []
        };
    }
    function paragraph() {
        return {
            type: 'paragraph',
            children: []
        };
    }
    function strong() {
        return {
            type: 'strong',
            children: []
        };
    }
    function text() {
        return {
            type: 'text',
            value: ''
        };
    }
    function thematicBreak() {
        return {
            type: 'thematicBreak'
        };
    }
}
function $f6499fcbf36d1abc$var$configure(config, extensions) {
    var index = -1;
    while(++index < extensions.length)$f6499fcbf36d1abc$var$extension(config, extensions[index]);
    return config;
}
function $f6499fcbf36d1abc$var$extension(config, extension) {
    var key;
    var left;
    for(key in extension){
        left = $593jb.call(config, key) ? config[key] : config[key] = {};
        if (key === 'canContainEols' || key === 'transforms') config[key] = [].concat(left, extension[key]);
        else Object.assign(left, extension[key]);
    }
}

});
parcelRegister("dR9Gq", function(module, exports) {
'use strict';
module.exports = $a167bc7ee1d8d643$var$toString;
// Get the text content of a node.
// Prefer the node’s plain-text fields, otherwise serialize its children,
// and if the given value is an array, serialize the nodes in it.
function $a167bc7ee1d8d643$var$toString(node) {
    return node && (node.value || node.alt || node.title || 'children' in node && $a167bc7ee1d8d643$var$all(node.children) || 'length' in node && $a167bc7ee1d8d643$var$all(node)) || '';
}
function $a167bc7ee1d8d643$var$all(values) {
    var result = [];
    var index = -1;
    while(++index < values.length)result[index] = $a167bc7ee1d8d643$var$toString(values[index]);
    return result.join('');
}

});

parcelRegister("jADl9", function(module, exports) {
'use strict';
var $e42fe54387de29df$var$assign = Object.assign;
module.exports = $e42fe54387de29df$var$assign;

});

parcelRegister("593jb", function(module, exports) {
'use strict';
var $3bf05c04d94e156b$var$own = {}.hasOwnProperty;
module.exports = $3bf05c04d94e156b$var$own;

});

parcelRegister("byQ4m", function(module, exports) {
'use strict';
function $86ab428c9560124c$var$normalizeIdentifier(value) {
    return value // Collapse Markdown whitespace.
    .replace(/[\t\n\r ]+/g, ' ') // Trim.
    .replace(/^ | $/g, '') // Some characters are considered “uppercase”, but if their lowercase
    // counterpart is uppercased will result in a different uppercase
    // character.
    // Hence, to get that form, we perform both lower- and uppercase.
    // Upper case makes sure keys will not interact with default prototypal
    // methods: no object method is uppercase.
    .toLowerCase().toUpperCase();
}
module.exports = $86ab428c9560124c$var$normalizeIdentifier;

});

parcelRegister("HOe7l", function(module, exports) {
'use strict';

var $2hVyl = parcelRequire("2hVyl");
function $083afa3e68a6f99f$var$safeFromInt(value, base) {
    var code = parseInt(value, base);
    if (// C0 except for HT, LF, FF, CR, space
    code < 9 || code === 11 || code > 13 && code < 32 || // Control character (DEL) of the basic block and C1 controls.
    code > 126 && code < 160 || // Lone high surrogates and low surrogates.
    code > 55295 && code < 57344 || // Noncharacters.
    code > 64975 && code < 65008 || (code & 65535) === 65535 || (code & 65535) === 65534 || // Out of range
    code > 1114111) return '\uFFFD';
    return $2hVyl(code);
}
module.exports = $083afa3e68a6f99f$var$safeFromInt;

});
parcelRegister("2hVyl", function(module, exports) {
'use strict';
var $1aa9d0239b006761$var$fromCharCode = String.fromCharCode;
module.exports = $1aa9d0239b006761$var$fromCharCode;

});


parcelRegister("eG14y", function(module, exports) {
'use strict';

var $6CyGC = parcelRequire("6CyGC");

var $b5W3T = parcelRequire("b5W3T");

var $7ka6A = parcelRequire("7ka6A");

var $4iVBZ = parcelRequire("4iVBZ");

var $41SNJ = parcelRequire("41SNJ");

var $kWQ3a = parcelRequire("kWQ3a");

var $8u8Xq = parcelRequire("8u8Xq");

var $8aWKB = parcelRequire("8aWKB");
function $aaf5d1ea65bb36b8$var$parse(options) {
    var settings = options || {};
    var parser = {
        defined: [],
        constructs: $41SNJ([
            $8aWKB
        ].concat($8u8Xq(settings.extensions))),
        content: create($6CyGC),
        document: create($b5W3T),
        flow: create($7ka6A),
        string: create($4iVBZ.string),
        text: create($4iVBZ.text)
    };
    return parser;
    function create(initializer) {
        return creator;
        function creator(from) {
            return $kWQ3a(parser, initializer, from);
        }
    }
}
module.exports = $aaf5d1ea65bb36b8$var$parse;

});
parcelRegister("6CyGC", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $ifk0k = parcelRequire("ifk0k");

var $2BApW = parcelRequire("2BApW");
var $4d2132b2f6726bc0$var$tokenize = $4d2132b2f6726bc0$var$initializeContent;
function $4d2132b2f6726bc0$var$initializeContent(effects) {
    var contentStart = effects.attempt(this.parser.constructs.contentInitial, afterContentStartConstruct, paragraphInitial);
    var previous;
    return contentStart;
    function afterContentStartConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        return $2BApW(effects, contentStart, 'linePrefix');
    }
    function paragraphInitial(code) {
        effects.enter('paragraph');
        return lineStart(code);
    }
    function lineStart(code) {
        var token = effects.enter('chunkText', {
            contentType: 'text',
            previous: previous
        });
        if (previous) previous.next = token;
        previous = token;
        return data(code);
    }
    function data(code) {
        if (code === null) {
            effects.exit('chunkText');
            effects.exit('paragraph');
            effects.consume(code);
            return;
        }
        if ($ifk0k(code)) {
            effects.consume(code);
            effects.exit('chunkText');
            return lineStart;
        } // Data.
        effects.consume(code);
        return data;
    }
}
module.exports.tokenize = $4d2132b2f6726bc0$var$tokenize;

});
parcelRegister("ifk0k", function(module, exports) {
'use strict';
function $d489251f18347473$var$markdownLineEnding(code) {
    return code < -2;
}
module.exports = $d489251f18347473$var$markdownLineEnding;

});

parcelRegister("2BApW", function(module, exports) {
'use strict';

var $gOFfl = parcelRequire("gOFfl");
function $1e5b49359e31ed79$var$spaceFactory(effects, ok, type, max) {
    var limit = max ? max - 1 : Infinity;
    var size = 0;
    return start;
    function start(code) {
        if ($gOFfl(code)) {
            effects.enter(type);
            return prefix(code);
        }
        return ok(code);
    }
    function prefix(code) {
        if ($gOFfl(code) && size++ < limit) {
            effects.consume(code);
            return prefix;
        }
        effects.exit(type);
        return ok(code);
    }
}
module.exports = $1e5b49359e31ed79$var$spaceFactory;

});
parcelRegister("gOFfl", function(module, exports) {
'use strict';
function $c3e14f8f05bbf755$var$markdownSpace(code) {
    return code === -2 || code === -1 || code === 32;
}
module.exports = $c3e14f8f05bbf755$var$markdownSpace;

});



parcelRegister("b5W3T", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $ifk0k = parcelRequire("ifk0k");

var $2BApW = parcelRequire("2BApW");

var $aaKX3 = parcelRequire("aaKX3");
var $813d33374436079a$var$tokenize = $813d33374436079a$var$initializeDocument;
var $813d33374436079a$var$containerConstruct = {
    tokenize: $813d33374436079a$var$tokenizeContainer
};
var $813d33374436079a$var$lazyFlowConstruct = {
    tokenize: $813d33374436079a$var$tokenizeLazyFlow
};
function $813d33374436079a$var$initializeDocument(effects) {
    var self = this;
    var stack = [];
    var continued = 0;
    var inspectConstruct = {
        tokenize: tokenizeInspect,
        partial: true
    };
    var inspectResult;
    var childFlow;
    var childToken;
    return start;
    function start(code) {
        if (continued < stack.length) {
            self.containerState = stack[continued][1];
            return effects.attempt(stack[continued][0].continuation, documentContinue, documentContinued)(code);
        }
        return documentContinued(code);
    }
    function documentContinue(code) {
        continued++;
        return start(code);
    }
    function documentContinued(code) {
        // If we’re in a concrete construct (such as when expecting another line of
        // HTML, or we resulted in lazy content), we can immediately start flow.
        if (inspectResult && inspectResult.flowContinue) return flowStart(code);
        self.interrupt = childFlow && childFlow.currentConstruct && childFlow.currentConstruct.interruptible;
        self.containerState = {};
        return effects.attempt($813d33374436079a$var$containerConstruct, containerContinue, flowStart)(code);
    }
    function containerContinue(code) {
        stack.push([
            self.currentConstruct,
            self.containerState
        ]);
        self.containerState = undefined;
        return documentContinued(code);
    }
    function flowStart(code) {
        if (code === null) {
            exitContainers(0, true);
            effects.consume(code);
            return;
        }
        childFlow = childFlow || self.parser.flow(self.now());
        effects.enter('chunkFlow', {
            contentType: 'flow',
            previous: childToken,
            _tokenizer: childFlow
        });
        return flowContinue(code);
    }
    function flowContinue(code) {
        if (code === null) {
            continueFlow(effects.exit('chunkFlow'));
            return flowStart(code);
        }
        if ($ifk0k(code)) {
            effects.consume(code);
            continueFlow(effects.exit('chunkFlow'));
            return effects.check(inspectConstruct, documentAfterPeek);
        }
        effects.consume(code);
        return flowContinue;
    }
    function documentAfterPeek(code) {
        exitContainers(inspectResult.continued, inspectResult && inspectResult.flowEnd);
        continued = 0;
        return start(code);
    }
    function continueFlow(token) {
        if (childToken) childToken.next = token;
        childToken = token;
        childFlow.lazy = inspectResult && inspectResult.lazy;
        childFlow.defineSkip(token.start);
        childFlow.write(self.sliceStream(token));
    }
    function exitContainers(size, end) {
        var index = stack.length // Close the flow.
        ;
        if (childFlow && end) {
            childFlow.write([
                null
            ]);
            childToken = childFlow = undefined;
        } // Exit open containers.
        while(index-- > size){
            self.containerState = stack[index][1];
            stack[index][0].exit.call(self, effects);
        }
        stack.length = size;
    }
    function tokenizeInspect(effects, ok) {
        var subcontinued = 0;
        inspectResult = {};
        return inspectStart;
        function inspectStart(code) {
            if (subcontinued < stack.length) {
                self.containerState = stack[subcontinued][1];
                return effects.attempt(stack[subcontinued][0].continuation, inspectContinue, inspectLess)(code);
            } // If we’re continued but in a concrete flow, we can’t have more
            // containers.
            if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) {
                inspectResult.flowContinue = true;
                return inspectDone(code);
            }
            self.interrupt = childFlow.currentConstruct && childFlow.currentConstruct.interruptible;
            self.containerState = {};
            return effects.attempt($813d33374436079a$var$containerConstruct, inspectFlowEnd, inspectDone)(code);
        }
        function inspectContinue(code) {
            subcontinued++;
            return self.containerState._closeFlow ? inspectFlowEnd(code) : inspectStart(code);
        }
        function inspectLess(code) {
            if (childFlow.currentConstruct && childFlow.currentConstruct.lazy) {
                // Maybe another container?
                self.containerState = {};
                return effects.attempt($813d33374436079a$var$containerConstruct, inspectFlowEnd, effects.attempt($813d33374436079a$var$lazyFlowConstruct, inspectFlowEnd, effects.check($aaKX3, inspectFlowEnd, inspectLazy)))(code);
            } // Otherwise we’re interrupting.
            return inspectFlowEnd(code);
        }
        function inspectLazy(code) {
            // Act as if all containers are continued.
            subcontinued = stack.length;
            inspectResult.lazy = true;
            inspectResult.flowContinue = true;
            return inspectDone(code);
        } // We’re done with flow if we have more containers, or an interruption.
        function inspectFlowEnd(code) {
            inspectResult.flowEnd = true;
            return inspectDone(code);
        }
        function inspectDone(code) {
            inspectResult.continued = subcontinued;
            self.interrupt = self.containerState = undefined;
            return ok(code);
        }
    }
}
function $813d33374436079a$var$tokenizeContainer(effects, ok, nok) {
    return $2BApW(effects, effects.attempt(this.parser.constructs.document, ok, nok), 'linePrefix', this.parser.constructs.disable.null.indexOf('codeIndented') > -1 ? undefined : 4);
}
function $813d33374436079a$var$tokenizeLazyFlow(effects, ok, nok) {
    return $2BApW(effects, effects.lazy(this.parser.constructs.flow, ok, nok), 'linePrefix', this.parser.constructs.disable.null.indexOf('codeIndented') > -1 ? undefined : 4);
}
module.exports.tokenize = $813d33374436079a$var$tokenize;

});
parcelRegister("aaKX3", function(module, exports) {
'use strict';

var $ifk0k = parcelRequire("ifk0k");

var $2BApW = parcelRequire("2BApW");
var $767f42207347f820$var$partialBlankLine = {
    tokenize: $767f42207347f820$var$tokenizePartialBlankLine,
    partial: true
};
function $767f42207347f820$var$tokenizePartialBlankLine(effects, ok, nok) {
    return $2BApW(effects, afterWhitespace, 'linePrefix');
    function afterWhitespace(code) {
        return code === null || $ifk0k(code) ? ok(code) : nok(code);
    }
}
module.exports = $767f42207347f820$var$partialBlankLine;

});


parcelRegister("7ka6A", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $4iVy7 = parcelRequire("4iVy7");

var $2BApW = parcelRequire("2BApW");

var $aaKX3 = parcelRequire("aaKX3");
var $55523d5354c55992$var$tokenize = $55523d5354c55992$var$initializeFlow;
function $55523d5354c55992$var$initializeFlow(effects) {
    var self = this;
    var initial = effects.attempt(// Try to parse a blank line.
    $aaKX3, atBlankEnding, effects.attempt(this.parser.constructs.flowInitial, afterConstruct, $2BApW(effects, effects.attempt(this.parser.constructs.flow, afterConstruct, effects.attempt($4iVy7, afterConstruct)), 'linePrefix')));
    return initial;
    function atBlankEnding(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter('lineEndingBlank');
        effects.consume(code);
        effects.exit('lineEndingBlank');
        self.currentConstruct = undefined;
        return initial;
    }
    function afterConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        self.currentConstruct = undefined;
        return initial;
    }
}
module.exports.tokenize = $55523d5354c55992$var$tokenize;

});
parcelRegister("4iVy7", function(module, exports) {
'use strict';

var $ifk0k = parcelRequire("ifk0k");

var $1WU15 = parcelRequire("1WU15");

var $285TQ = parcelRequire("285TQ");

var $2BApW = parcelRequire("2BApW");
// No name because it must not be turned off.
var $32257bf63b268934$var$content = {
    tokenize: $32257bf63b268934$var$tokenizeContent,
    resolve: $32257bf63b268934$var$resolveContent,
    interruptible: true,
    lazy: true
};
var $32257bf63b268934$var$continuationConstruct = {
    tokenize: $32257bf63b268934$var$tokenizeContinuation,
    partial: true
} // Content is transparent: it’s parsed right now. That way, definitions are also
;
// parsed right now: before text in paragraphs (specifically, media) are parsed.
function $32257bf63b268934$var$resolveContent(events) {
    $285TQ(events);
    return events;
}
function $32257bf63b268934$var$tokenizeContent(effects, ok) {
    var previous;
    return start;
    function start(code) {
        effects.enter('content');
        previous = effects.enter('chunkContent', {
            contentType: 'content'
        });
        return data(code);
    }
    function data(code) {
        if (code === null) return contentEnd(code);
        if ($ifk0k(code)) return effects.check($32257bf63b268934$var$continuationConstruct, contentContinue, contentEnd)(code);
         // Data.
        effects.consume(code);
        return data;
    }
    function contentEnd(code) {
        effects.exit('chunkContent');
        effects.exit('content');
        return ok(code);
    }
    function contentContinue(code) {
        effects.consume(code);
        effects.exit('chunkContent');
        previous = previous.next = effects.enter('chunkContent', {
            contentType: 'content',
            previous: previous
        });
        return data;
    }
}
function $32257bf63b268934$var$tokenizeContinuation(effects, ok, nok) {
    var self = this;
    return startLookahead;
    function startLookahead(code) {
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        return $2BApW(effects, prefixed, 'linePrefix');
    }
    function prefixed(code) {
        if (code === null || $ifk0k(code)) return nok(code);
        if (self.parser.constructs.disable.null.indexOf('codeIndented') > -1 || $1WU15(self.events, 'linePrefix') < 4) return effects.interrupt(self.parser.constructs.flow, nok, ok)(code);
        return ok(code);
    }
}
module.exports = $32257bf63b268934$var$content;

});
parcelRegister("1WU15", function(module, exports) {
'use strict';

var $1NrKy = parcelRequire("1NrKy");
function $16b6a8f435e443be$var$prefixSize(events, type) {
    var tail = events[events.length - 1];
    if (!tail || tail[1].type !== type) return 0;
    return $1NrKy(tail[2].sliceStream(tail[1]));
}
module.exports = $16b6a8f435e443be$var$prefixSize;

});
parcelRegister("1NrKy", function(module, exports) {
'use strict';
// Counts tabs based on their expanded size, and CR+LF as one character.
function $14efe49712abd3de$var$sizeChunks(chunks) {
    var index = -1;
    var size = 0;
    while(++index < chunks.length)size += typeof chunks[index] === 'string' ? chunks[index].length : 1;
    return size;
}
module.exports = $14efe49712abd3de$var$sizeChunks;

});


parcelRegister("285TQ", function(module, exports) {
'use strict';

var $jADl9 = parcelRequire("jADl9");

var $3ekiO = parcelRequire("3ekiO");

var $5zKO5 = parcelRequire("5zKO5");
function $18d0e7ad5883cde9$var$subtokenize(events) {
    var jumps = {};
    var index = -1;
    var event;
    var lineIndex;
    var otherIndex;
    var otherEvent;
    var parameters;
    var subevents;
    var more;
    while(++index < events.length){
        while(index in jumps)index = jumps[index];
        event = events[index] // Add a hook for the GFM tasklist extension, which needs to know if text
        ;
        // is in the first content of a list item.
        if (index && event[1].type === 'chunkFlow' && events[index - 1][1].type === 'listItemPrefix') {
            subevents = event[1]._tokenizer.events;
            otherIndex = 0;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === 'lineEndingBlank') otherIndex += 2;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === 'content') while(++otherIndex < subevents.length){
                if (subevents[otherIndex][1].type === 'content') break;
                if (subevents[otherIndex][1].type === 'chunkText') {
                    subevents[otherIndex][1].isInFirstContentOfListItem = true;
                    otherIndex++;
                }
            }
        } // Enter.
        if (event[0] === 'enter') {
            if (event[1].contentType) {
                $jADl9(jumps, $18d0e7ad5883cde9$var$subcontent(events, index));
                index = jumps[index];
                more = true;
            }
        } else if (event[1]._container || event[1]._movePreviousLineEndings) {
            otherIndex = index;
            lineIndex = undefined;
            while(otherIndex--){
                otherEvent = events[otherIndex];
                if (otherEvent[1].type === 'lineEnding' || otherEvent[1].type === 'lineEndingBlank') {
                    if (otherEvent[0] === 'enter') {
                        if (lineIndex) events[lineIndex][1].type = 'lineEndingBlank';
                        otherEvent[1].type = 'lineEnding';
                        lineIndex = otherIndex;
                    }
                } else break;
            }
            if (lineIndex) {
                // Fix position.
                event[1].end = $5zKO5(events[lineIndex][1].start) // Switch container exit w/ line endings.
                ;
                parameters = events.slice(lineIndex, index);
                parameters.unshift(event);
                $3ekiO(events, lineIndex, index - lineIndex + 1, parameters);
            }
        }
    }
    return !more;
}
function $18d0e7ad5883cde9$var$subcontent(events, eventIndex) {
    var token = events[eventIndex][1];
    var context = events[eventIndex][2];
    var startPosition = eventIndex - 1;
    var startPositions = [];
    var tokenizer = token._tokenizer || context.parser[token.contentType](token.start);
    var childEvents = tokenizer.events;
    var jumps = [];
    var gaps = {};
    var stream;
    var previous;
    var index;
    var entered;
    var end;
    var adjust // Loop forward through the linked tokens to pass them in order to the
    ;
    // subtokenizer.
    while(token){
        // Find the position of the event for this token.
        while(events[++startPosition][1] !== token);
        startPositions.push(startPosition);
        if (!token._tokenizer) {
            stream = context.sliceStream(token);
            if (!token.next) stream.push(null);
            if (previous) tokenizer.defineSkip(token.start);
            if (token.isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = true;
            tokenizer.write(stream);
            if (token.isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = undefined;
        } // Unravel the next token.
        previous = token;
        token = token.next;
    } // Now, loop back through all events (and linked tokens), to figure out which
    // parts belong where.
    token = previous;
    index = childEvents.length;
    while(index--){
        // Make sure we’ve at least seen something (final eol is part of the last
        // token).
        if (childEvents[index][0] === 'enter') entered = true;
        else if (// Find a void token that includes a break.
        entered && childEvents[index][1].type === childEvents[index - 1][1].type && childEvents[index][1].start.line !== childEvents[index][1].end.line) {
            add(childEvents.slice(index + 1, end));
            // Help GC.
            token._tokenizer = token.next = undefined;
            token = token.previous;
            end = index + 1;
        }
    }
    // Help GC.
    tokenizer.events = token._tokenizer = token.next = undefined // Do head:
    ;
    add(childEvents.slice(0, end));
    index = -1;
    adjust = 0;
    while(++index < jumps.length){
        gaps[adjust + jumps[index][0]] = adjust + jumps[index][1];
        adjust += jumps[index][1] - jumps[index][0] - 1;
    }
    return gaps;
    function add(slice) {
        var start = startPositions.pop();
        jumps.unshift([
            start,
            start + slice.length - 1
        ]);
        $3ekiO(events, start, 2, slice);
    }
}
module.exports = $18d0e7ad5883cde9$var$subtokenize;

});
parcelRegister("3ekiO", function(module, exports) {
'use strict';

var $3jQdQ = parcelRequire("3jQdQ");
// causes a stack overflow in V8 when trying to insert 100k items for instance.
function $25a26d8b30a84dcd$var$chunkedSplice(list, start, remove, items) {
    var end = list.length;
    var chunkStart = 0;
    var parameters // Make start between zero and `end` (included).
    ;
    if (start < 0) start = -start > end ? 0 : end + start;
    else start = start > end ? end : start;
    remove = remove > 0 ? remove : 0 // No need to chunk the items if there’s only a couple (10k) items.
    ;
    if (items.length < 10000) {
        parameters = Array.from(items);
        parameters.unshift(start, remove);
        $3jQdQ.apply(list, parameters);
    } else {
        // Delete `remove` items starting from `start`
        if (remove) $3jQdQ.apply(list, [
            start,
            remove
        ]) // Insert the items in chunks to not cause stack overflows.
        ;
        while(chunkStart < items.length){
            parameters = items.slice(chunkStart, chunkStart + 10000);
            parameters.unshift(start, 0);
            $3jQdQ.apply(list, parameters);
            chunkStart += 10000;
            start += 10000;
        }
    }
}
module.exports = $25a26d8b30a84dcd$var$chunkedSplice;

});
parcelRegister("3jQdQ", function(module, exports) {
'use strict';
var $26aba7b4b75d179d$var$splice = [].splice;
module.exports = $26aba7b4b75d179d$var$splice;

});


parcelRegister("5zKO5", function(module, exports) {
'use strict';

var $jADl9 = parcelRequire("jADl9");
function $40f487809089283b$var$shallow(object) {
    return $jADl9({}, object);
}
module.exports = $40f487809089283b$var$shallow;

});




parcelRegister("4iVBZ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $jADl9 = parcelRequire("jADl9");

var $5zKO5 = parcelRequire("5zKO5");
var $322588576b955bdc$var$text = $322588576b955bdc$var$initializeFactory('text');
var $322588576b955bdc$var$string = $322588576b955bdc$var$initializeFactory('string');
var $322588576b955bdc$var$resolver = {
    resolveAll: $322588576b955bdc$var$createResolver()
};
function $322588576b955bdc$var$initializeFactory(field) {
    return {
        tokenize: initializeText,
        resolveAll: $322588576b955bdc$var$createResolver(field === 'text' ? $322588576b955bdc$var$resolveAllLineSuffixes : undefined)
    };
    function initializeText(effects) {
        var self = this;
        var constructs = this.parser.constructs[field];
        var text = effects.attempt(constructs, start, notText);
        return start;
        function start(code) {
            return atBreak(code) ? text(code) : notText(code);
        }
        function notText(code) {
            if (code === null) {
                effects.consume(code);
                return;
            }
            effects.enter('data');
            effects.consume(code);
            return data;
        }
        function data(code) {
            if (atBreak(code)) {
                effects.exit('data');
                return text(code);
            } // Data.
            effects.consume(code);
            return data;
        }
        function atBreak(code) {
            var list = constructs[code];
            var index = -1;
            if (code === null) return true;
            if (list) while(++index < list.length){
                if (!list[index].previous || list[index].previous.call(self, self.previous)) return true;
            }
        }
    }
}
function $322588576b955bdc$var$createResolver(extraResolver) {
    return resolveAllText;
    function resolveAllText(events, context) {
        var index = -1;
        var enter // A rather boring computation (to merge adjacent `data` events) which
        ;
        // improves mm performance by 29%.
        while(++index <= events.length){
            if (enter === undefined) {
                if (events[index] && events[index][1].type === 'data') {
                    enter = index;
                    index++;
                }
            } else if (!events[index] || events[index][1].type !== 'data') {
                // Don’t do anything if there is one data token.
                if (index !== enter + 2) {
                    events[enter][1].end = events[index - 1][1].end;
                    events.splice(enter + 2, index - enter - 2);
                    index = enter + 2;
                }
                enter = undefined;
            }
        }
        return extraResolver ? extraResolver(events, context) : events;
    }
} // A rather ugly set of instructions which again looks at chunks in the input
// stream.
// The reason to do this here is that it is *much* faster to parse in reverse.
// And that we can’t hook into `null` to split the line suffix before an EOF.
// To do: figure out if we can make this into a clean utility, or even in core.
// As it will be useful for GFMs literal autolink extension (and maybe even
// tables?)
function $322588576b955bdc$var$resolveAllLineSuffixes(events, context) {
    var eventIndex = -1;
    var chunks;
    var data;
    var chunk;
    var index;
    var bufferIndex;
    var size;
    var tabs;
    var token;
    while(++eventIndex <= events.length)if ((eventIndex === events.length || events[eventIndex][1].type === 'lineEnding') && events[eventIndex - 1][1].type === 'data') {
        data = events[eventIndex - 1][1];
        chunks = context.sliceStream(data);
        index = chunks.length;
        bufferIndex = -1;
        size = 0;
        tabs = undefined;
        while(index--){
            chunk = chunks[index];
            if (typeof chunk === 'string') {
                bufferIndex = chunk.length;
                while(chunk.charCodeAt(bufferIndex - 1) === 32){
                    size++;
                    bufferIndex--;
                }
                if (bufferIndex) break;
                bufferIndex = -1;
            } else if (chunk === -2) {
                tabs = true;
                size++;
            } else if (chunk === -1) ;
            else {
                // Replacement character, exit.
                index++;
                break;
            }
        }
        if (size) {
            token = {
                type: eventIndex === events.length || tabs || size < 2 ? 'lineSuffix' : 'hardBreakTrailing',
                start: {
                    line: data.end.line,
                    column: data.end.column - size,
                    offset: data.end.offset - size,
                    _index: data.start._index + index,
                    _bufferIndex: index ? bufferIndex : data.start._bufferIndex + bufferIndex
                },
                end: $5zKO5(data.end)
            };
            data.end = $5zKO5(token.start);
            if (data.start.offset === data.end.offset) $jADl9(data, token);
            else {
                events.splice(eventIndex, 0, [
                    'enter',
                    token,
                    context
                ], [
                    'exit',
                    token,
                    context
                ]);
                eventIndex += 2;
            }
        }
        eventIndex++;
    }
    return events;
}
module.exports.resolver = $322588576b955bdc$var$resolver;
module.exports.string = $322588576b955bdc$var$string;
module.exports.text = $322588576b955bdc$var$text;

});

parcelRegister("41SNJ", function(module, exports) {
'use strict';

var $593jb = parcelRequire("593jb");

var $3ekiO = parcelRequire("3ekiO");

var $8u8Xq = parcelRequire("8u8Xq");
function $2ef1c3c1937096e8$var$combineExtensions(extensions) {
    var all = {};
    var index = -1;
    while(++index < extensions.length)$2ef1c3c1937096e8$var$extension(all, extensions[index]);
    return all;
}
function $2ef1c3c1937096e8$var$extension(all, extension) {
    var hook;
    var left;
    var right;
    var code;
    for(hook in extension){
        left = $593jb.call(all, hook) ? all[hook] : all[hook] = {};
        right = extension[hook];
        for(code in right)left[code] = $2ef1c3c1937096e8$var$constructs($8u8Xq(right[code]), $593jb.call(left, code) ? left[code] : []);
    }
}
function $2ef1c3c1937096e8$var$constructs(list, existing) {
    var index = -1;
    var before = [];
    while(++index < list.length)(list[index].add === 'after' ? existing : before).push(list[index]);
    $3ekiO(existing, 0, 0, before);
    return existing;
}
module.exports = $2ef1c3c1937096e8$var$combineExtensions;

});
parcelRegister("8u8Xq", function(module, exports) {
'use strict';
function $62d812dd36e22e76$var$miniflat(value) {
    return value === null || value === undefined ? [] : 'length' in value ? value : [
        value
    ];
}
module.exports = $62d812dd36e22e76$var$miniflat;

});


parcelRegister("kWQ3a", function(module, exports) {
'use strict';

var $jADl9 = parcelRequire("jADl9");

var $ifk0k = parcelRequire("ifk0k");

var $3CXGo = parcelRequire("3CXGo");

var $3ekiO = parcelRequire("3ekiO");

var $8u8Xq = parcelRequire("8u8Xq");

var $3ROwI = parcelRequire("3ROwI");

var $cvKmv = parcelRequire("cvKmv");

var $5zKO5 = parcelRequire("5zKO5");

var $gLq83 = parcelRequire("gLq83");
// Create a tokenizer.
// Tokenizers deal with one type of data (e.g., containers, flow, text).
// The parser is the object dealing with it all.
// `initialize` works like other constructs, except that only its `tokenize`
// function is used, in which case it doesn’t receive an `ok` or `nok`.
// `from` can be given to set the point before the first character, although
// when further lines are indented, they must be set with `defineSkip`.
function $f401997731123a49$var$createTokenizer(parser, initialize, from) {
    var point = from ? $5zKO5(from) : {
        line: 1,
        column: 1,
        offset: 0
    };
    var columnStart = {};
    var resolveAllConstructs = [];
    var chunks = [];
    var stack = [];
    var effects = {
        consume: consume,
        enter: enter,
        exit: exit,
        attempt: constructFactory(onsuccessfulconstruct),
        check: constructFactory(onsuccessfulcheck),
        interrupt: constructFactory(onsuccessfulcheck, {
            interrupt: true
        }),
        lazy: constructFactory(onsuccessfulcheck, {
            lazy: true
        })
    } // State and tools for resolving and serializing.
    ;
    var context = {
        previous: null,
        events: [],
        parser: parser,
        sliceStream: sliceStream,
        sliceSerialize: sliceSerialize,
        now: now,
        defineSkip: skip,
        write: write
    } // The state function.
    ;
    var state = initialize.tokenize.call(context, effects) // Track which character we expect to be consumed, to catch bugs.
    ;
    if (initialize.resolveAll) resolveAllConstructs.push(initialize);
     // Store where we are in the input stream.
    point._index = 0;
    point._bufferIndex = -1;
    return context;
    function write(slice) {
        chunks = $3CXGo(chunks, slice);
        main() // Exit if we’re not done, resolve might change stuff.
        ;
        if (chunks[chunks.length - 1] !== null) return [];
        addResult(initialize, 0) // Otherwise, resolve, and exit.
        ;
        context.events = $3ROwI(resolveAllConstructs, context.events, context);
        return context.events;
    } //
    // Tools.
    //
    function sliceSerialize(token) {
        return $cvKmv(sliceStream(token));
    }
    function sliceStream(token) {
        return $gLq83(chunks, token);
    }
    function now() {
        return $5zKO5(point);
    }
    function skip(value) {
        columnStart[value.line] = value.column;
        accountForPotentialSkip();
    } //
    // State management.
    //
    // Main loop (note that `_index` and `_bufferIndex` in `point` are modified by
    // `consume`).
    // Here is where we walk through the chunks, which either include strings of
    // several characters, or numerical character codes.
    // The reason to do this in a loop instead of a call is so the stack can
    // drain.
    function main() {
        var chunkIndex;
        var chunk;
        while(point._index < chunks.length){
            chunk = chunks[point._index] // If we’re in a buffer chunk, loop through it.
            ;
            if (typeof chunk === 'string') {
                chunkIndex = point._index;
                if (point._bufferIndex < 0) point._bufferIndex = 0;
                while(point._index === chunkIndex && point._bufferIndex < chunk.length)go(chunk.charCodeAt(point._bufferIndex));
            } else go(chunk);
        }
    } // Deal with one code.
    function go(code) {
        state = state(code);
    } // Move a character forward.
    function consume(code) {
        if ($ifk0k(code)) {
            point.line++;
            point.column = 1;
            point.offset += code === -3 ? 2 : 1;
            accountForPotentialSkip();
        } else if (code !== -1) {
            point.column++;
            point.offset++;
        } // Not in a string chunk.
        if (point._bufferIndex < 0) point._index++;
        else {
            point._bufferIndex++ // At end of string chunk.
            ;
            if (point._bufferIndex === chunks[point._index].length) {
                point._bufferIndex = -1;
                point._index++;
            }
        } // Expose the previous character.
        context.previous = code // Mark as consumed.
        ;
    } // Start a token.
    function enter(type, fields) {
        var token = fields || {};
        token.type = type;
        token.start = now();
        context.events.push([
            'enter',
            token,
            context
        ]);
        stack.push(token);
        return token;
    } // Stop a token.
    function exit(type) {
        var token = stack.pop();
        token.end = now();
        context.events.push([
            'exit',
            token,
            context
        ]);
        return token;
    } // Use results.
    function onsuccessfulconstruct(construct, info) {
        addResult(construct, info.from);
    } // Discard results.
    function onsuccessfulcheck(construct, info) {
        info.restore();
    } // Factory to attempt/check/interrupt.
    function constructFactory(onreturn, fields) {
        return hook // Handle either an object mapping codes to constructs, a list of
        ;
        // constructs, or a single construct.
        function hook(constructs, returnState, bogusState) {
            var listOfConstructs;
            var constructIndex;
            var currentConstruct;
            var info;
            return constructs.tokenize || 'length' in constructs ? handleListOfConstructs($8u8Xq(constructs)) : handleMapOfConstructs;
            function handleMapOfConstructs(code) {
                if (code in constructs || null in constructs) return handleListOfConstructs(constructs.null ? /* c8 ignore next */ $8u8Xq(constructs[code]).concat($8u8Xq(constructs.null)) : constructs[code])(code);
                return bogusState(code);
            }
            function handleListOfConstructs(list) {
                listOfConstructs = list;
                constructIndex = 0;
                return handleConstruct(list[constructIndex]);
            }
            function handleConstruct(construct) {
                return start;
                function start(code) {
                    // To do: not nede to store if there is no bogus state, probably?
                    // Currently doesn’t work because `inspect` in document does a check
                    // w/o a bogus, which doesn’t make sense. But it does seem to help perf
                    // by not storing.
                    info = store();
                    currentConstruct = construct;
                    if (!construct.partial) context.currentConstruct = construct;
                    if (construct.name && context.parser.constructs.disable.null.indexOf(construct.name) > -1) return nok();
                    return construct.tokenize.call(fields ? $jADl9({}, context, fields) : context, effects, ok, nok)(code);
                }
            }
            function ok(code) {
                onreturn(currentConstruct, info);
                return returnState;
            }
            function nok(code) {
                info.restore();
                if (++constructIndex < listOfConstructs.length) return handleConstruct(listOfConstructs[constructIndex]);
                return bogusState;
            }
        }
    }
    function addResult(construct, from) {
        if (construct.resolveAll && resolveAllConstructs.indexOf(construct) < 0) resolveAllConstructs.push(construct);
        if (construct.resolve) $3ekiO(context.events, from, context.events.length - from, construct.resolve(context.events.slice(from), context));
        if (construct.resolveTo) context.events = construct.resolveTo(context.events, context);
    }
    function store() {
        var startPoint = now();
        var startPrevious = context.previous;
        var startCurrentConstruct = context.currentConstruct;
        var startEventsIndex = context.events.length;
        var startStack = Array.from(stack);
        return {
            restore: restore,
            from: startEventsIndex
        };
        function restore() {
            point = startPoint;
            context.previous = startPrevious;
            context.currentConstruct = startCurrentConstruct;
            context.events.length = startEventsIndex;
            stack = startStack;
            accountForPotentialSkip();
        }
    }
    function accountForPotentialSkip() {
        if (point.line in columnStart && point.column < 2) {
            point.column = columnStart[point.line];
            point.offset += columnStart[point.line] - 1;
        }
    }
}
module.exports = $f401997731123a49$var$createTokenizer;

});
parcelRegister("3CXGo", function(module, exports) {
'use strict';

var $3ekiO = parcelRequire("3ekiO");
function $2a43377506a4adfa$var$chunkedPush(list, items) {
    if (list.length) {
        $3ekiO(list, list.length, 0, items);
        return list;
    }
    return items;
}
module.exports = $2a43377506a4adfa$var$chunkedPush;

});

parcelRegister("3ROwI", function(module, exports) {
'use strict';
function $2d0d83df2915ccd7$var$resolveAll(constructs, events, context) {
    var called = [];
    var index = -1;
    var resolve;
    while(++index < constructs.length){
        resolve = constructs[index].resolveAll;
        if (resolve && called.indexOf(resolve) < 0) {
            events = resolve(events, context);
            called.push(resolve);
        }
    }
    return events;
}
module.exports = $2d0d83df2915ccd7$var$resolveAll;

});

parcelRegister("cvKmv", function(module, exports) {
'use strict';

var $2hVyl = parcelRequire("2hVyl");
function $91bc57ce430edf35$var$serializeChunks(chunks) {
    var index = -1;
    var result = [];
    var chunk;
    var value;
    var atTab;
    while(++index < chunks.length){
        chunk = chunks[index];
        if (typeof chunk === 'string') value = chunk;
        else if (chunk === -5) value = '\r';
        else if (chunk === -4) value = '\n';
        else if (chunk === -3) value = "\r\n";
        else if (chunk === -2) value = '\t';
        else if (chunk === -1) {
            if (atTab) continue;
            value = ' ';
        } else // Currently only replacement character.
        value = $2hVyl(chunk);
        atTab = chunk === -2;
        result.push(value);
    }
    return result.join('');
}
module.exports = $91bc57ce430edf35$var$serializeChunks;

});

parcelRegister("gLq83", function(module, exports) {
'use strict';
function $c3454dc81547445f$var$sliceChunks(chunks, token) {
    var startIndex = token.start._index;
    var startBufferIndex = token.start._bufferIndex;
    var endIndex = token.end._index;
    var endBufferIndex = token.end._bufferIndex;
    var view;
    if (startIndex === endIndex) view = [
        chunks[startIndex].slice(startBufferIndex, endBufferIndex)
    ];
    else {
        view = chunks.slice(startIndex, endIndex);
        if (startBufferIndex > -1) view[0] = view[0].slice(startBufferIndex);
        if (endBufferIndex > 0) view.push(chunks[endIndex].slice(0, endBufferIndex));
    }
    return view;
}
module.exports = $c3454dc81547445f$var$sliceChunks;

});


parcelRegister("8aWKB", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $4iVBZ = parcelRequire("4iVBZ");

var $li4tO = parcelRequire("li4tO");

var $dYqGN = parcelRequire("dYqGN");

var $656EE = parcelRequire("656EE");

var $2QSRT = parcelRequire("2QSRT");

var $fRehc = parcelRequire("fRehc");

var $ejEkV = parcelRequire("ejEkV");

var $43D6a = parcelRequire("43D6a");

var $aiIjI = parcelRequire("aiIjI");

var $6aIIA = parcelRequire("6aIIA");

var $gKoCv = parcelRequire("gKoCv");

var $9ubeb = parcelRequire("9ubeb");

var $dQpuu = parcelRequire("dQpuu");

var $iOek4 = parcelRequire("iOek4");

var $LZd67 = parcelRequire("LZd67");

var $47ffq = parcelRequire("47ffq");

var $8hIyI = parcelRequire("8hIyI");

var $74cf0 = parcelRequire("74cf0");

var $9GqMK = parcelRequire("9GqMK");

var $qMmWK = parcelRequire("qMmWK");

var $85DH0 = parcelRequire("85DH0");
var $5f3cd494ff15a2cf$var$document = {
    42: $9GqMK,
    // Asterisk
    43: $9GqMK,
    // Plus sign
    45: $9GqMK,
    // Dash
    48: $9GqMK,
    // 0
    49: $9GqMK,
    // 1
    50: $9GqMK,
    // 2
    51: $9GqMK,
    // 3
    52: $9GqMK,
    // 4
    53: $9GqMK,
    // 5
    54: $9GqMK,
    // 6
    55: $9GqMK,
    // 7
    56: $9GqMK,
    // 8
    57: $9GqMK,
    // 9
    62: $656EE // Greater than
};
var $5f3cd494ff15a2cf$var$contentInitial = {
    91: $6aIIA // Left square bracket
};
var $5f3cd494ff15a2cf$var$flowInitial = {
    '-2': $43D6a,
    // Horizontal tab
    '-1': $43D6a,
    // Virtual space
    32: $43D6a // Space
};
var $5f3cd494ff15a2cf$var$flow = {
    35: $9ubeb,
    // Number sign
    42: $85DH0,
    // Asterisk
    45: [
        $qMmWK,
        $85DH0
    ],
    // Dash
    60: $dQpuu,
    // Less than
    61: $qMmWK,
    // Equals to
    95: $85DH0,
    // Underscore
    96: $ejEkV,
    // Grave accent
    126: $ejEkV // Tilde
};
var $5f3cd494ff15a2cf$var$string = {
    38: $fRehc,
    // Ampersand
    92: $2QSRT // Backslash
};
var $5f3cd494ff15a2cf$var$text = {
    '-5': $74cf0,
    // Carriage return
    '-4': $74cf0,
    // Line feed
    '-3': $74cf0,
    // Carriage return + line feed
    33: $47ffq,
    // Exclamation mark
    38: $fRehc,
    // Ampersand
    42: $li4tO,
    // Asterisk
    60: [
        $dYqGN,
        $iOek4
    ],
    // Less than
    91: $8hIyI,
    // Left square bracket
    92: [
        $gKoCv,
        $2QSRT
    ],
    // Backslash
    93: $LZd67,
    // Right square bracket
    95: $li4tO,
    // Underscore
    96: $aiIjI // Grave accent
};
var $5f3cd494ff15a2cf$var$insideSpan = {
    null: [
        $li4tO,
        $4iVBZ.resolver
    ]
};
var $5f3cd494ff15a2cf$var$disable = {
    null: []
};
module.exports.contentInitial = $5f3cd494ff15a2cf$var$contentInitial;
module.exports.disable = $5f3cd494ff15a2cf$var$disable;
module.exports.document = $5f3cd494ff15a2cf$var$document;
module.exports.flow = $5f3cd494ff15a2cf$var$flow;
module.exports.flowInitial = $5f3cd494ff15a2cf$var$flowInitial;
module.exports.insideSpan = $5f3cd494ff15a2cf$var$insideSpan;
module.exports.string = $5f3cd494ff15a2cf$var$string;
module.exports.text = $5f3cd494ff15a2cf$var$text;

});
parcelRegister("li4tO", function(module, exports) {
'use strict';

var $3CXGo = parcelRequire("3CXGo");

var $3ekiO = parcelRequire("3ekiO");

var $bWc61 = parcelRequire("bWc61");

var $dSRWQ = parcelRequire("dSRWQ");

var $3ROwI = parcelRequire("3ROwI");

var $5zKO5 = parcelRequire("5zKO5");
var $f7fec101c7c50ba4$var$attention = {
    name: 'attention',
    tokenize: $f7fec101c7c50ba4$var$tokenizeAttention,
    resolveAll: $f7fec101c7c50ba4$var$resolveAllAttention
};
function $f7fec101c7c50ba4$var$resolveAllAttention(events, context) {
    var index = -1;
    var open;
    var group;
    var text;
    var openingSequence;
    var closingSequence;
    var use;
    var nextEvents;
    var offset // Walk through all events.
    ;
    //
    // Note: performance of this is fine on an mb of normal markdown, but it’s
    // a bottleneck for malicious stuff.
    while(++index < events.length)// Find a token that can close.
    if (events[index][0] === 'enter' && events[index][1].type === 'attentionSequence' && events[index][1]._close) {
        open = index // Now walk back to find an opener.
        ;
        while(open--)// Find a token that can open the closer.
        if (events[open][0] === 'exit' && events[open][1].type === 'attentionSequence' && events[open][1]._open && // If the markers are the same:
        context.sliceSerialize(events[open][1]).charCodeAt(0) === context.sliceSerialize(events[index][1]).charCodeAt(0)) {
            // If the opening can close or the closing can open,
            // and the close size *is not* a multiple of three,
            // but the sum of the opening and closing size *is* multiple of three,
            // then don’t match.
            if ((events[open][1]._close || events[index][1]._open) && (events[index][1].end.offset - events[index][1].start.offset) % 3 && !((events[open][1].end.offset - events[open][1].start.offset + events[index][1].end.offset - events[index][1].start.offset) % 3)) continue;
             // Number of markers to use from the sequence.
            use = events[open][1].end.offset - events[open][1].start.offset > 1 && events[index][1].end.offset - events[index][1].start.offset > 1 ? 2 : 1;
            openingSequence = {
                type: use > 1 ? 'strongSequence' : 'emphasisSequence',
                start: $dSRWQ($5zKO5(events[open][1].end), -use),
                end: $5zKO5(events[open][1].end)
            };
            closingSequence = {
                type: use > 1 ? 'strongSequence' : 'emphasisSequence',
                start: $5zKO5(events[index][1].start),
                end: $dSRWQ($5zKO5(events[index][1].start), use)
            };
            text = {
                type: use > 1 ? 'strongText' : 'emphasisText',
                start: $5zKO5(events[open][1].end),
                end: $5zKO5(events[index][1].start)
            };
            group = {
                type: use > 1 ? 'strong' : 'emphasis',
                start: $5zKO5(openingSequence.start),
                end: $5zKO5(closingSequence.end)
            };
            events[open][1].end = $5zKO5(openingSequence.start);
            events[index][1].start = $5zKO5(closingSequence.end);
            nextEvents = [] // If there are more markers in the opening, add them before.
            ;
            if (events[open][1].end.offset - events[open][1].start.offset) nextEvents = $3CXGo(nextEvents, [
                [
                    'enter',
                    events[open][1],
                    context
                ],
                [
                    'exit',
                    events[open][1],
                    context
                ]
            ]);
             // Opening.
            nextEvents = $3CXGo(nextEvents, [
                [
                    'enter',
                    group,
                    context
                ],
                [
                    'enter',
                    openingSequence,
                    context
                ],
                [
                    'exit',
                    openingSequence,
                    context
                ],
                [
                    'enter',
                    text,
                    context
                ]
            ]) // Between.
            ;
            nextEvents = $3CXGo(nextEvents, $3ROwI(context.parser.constructs.insideSpan.null, events.slice(open + 1, index), context)) // Closing.
            ;
            nextEvents = $3CXGo(nextEvents, [
                [
                    'exit',
                    text,
                    context
                ],
                [
                    'enter',
                    closingSequence,
                    context
                ],
                [
                    'exit',
                    closingSequence,
                    context
                ],
                [
                    'exit',
                    group,
                    context
                ]
            ]) // If there are more markers in the closing, add them after.
            ;
            if (events[index][1].end.offset - events[index][1].start.offset) {
                offset = 2;
                nextEvents = $3CXGo(nextEvents, [
                    [
                        'enter',
                        events[index][1],
                        context
                    ],
                    [
                        'exit',
                        events[index][1],
                        context
                    ]
                ]);
            } else offset = 0;
            $3ekiO(events, open - 1, index - open + 3, nextEvents);
            index = open + nextEvents.length - offset - 2;
            break;
        }
    }
     // Remove remaining sequences.
    index = -1;
    while(++index < events.length)if (events[index][1].type === 'attentionSequence') events[index][1].type = 'data';
    return events;
}
function $f7fec101c7c50ba4$var$tokenizeAttention(effects, ok) {
    var before = $bWc61(this.previous);
    var marker;
    return start;
    function start(code) {
        effects.enter('attentionSequence');
        marker = code;
        return sequence(code);
    }
    function sequence(code) {
        var token;
        var after;
        var open;
        var close;
        if (code === marker) {
            effects.consume(code);
            return sequence;
        }
        token = effects.exit('attentionSequence');
        after = $bWc61(code);
        open = !after || after === 2 && before;
        close = !before || before === 2 && after;
        token._open = marker === 42 ? open : open && (before || !close);
        token._close = marker === 42 ? close : close && (after || !open);
        return ok(code);
    }
}
module.exports = $f7fec101c7c50ba4$var$attention;

});
parcelRegister("bWc61", function(module, exports) {
'use strict';

var $ljjaa = parcelRequire("ljjaa");

var $c2qvq = parcelRequire("c2qvq");

var $dKCO2 = parcelRequire("dKCO2");
// Classify whether a character is unicode whitespace, unicode punctuation, or
// anything else.
// Used for attention (emphasis, strong), whose sequences can open or close
// based on the class of surrounding characters.
function $8b0e7e8112914546$var$classifyCharacter(code) {
    if (code === null || $ljjaa(code) || $dKCO2(code)) return 1;
    if ($c2qvq(code)) return 2;
}
module.exports = $8b0e7e8112914546$var$classifyCharacter;

});
parcelRegister("ljjaa", function(module, exports) {
'use strict';
function $f83a3caef6a827d0$var$markdownLineEndingOrSpace(code) {
    return code < 0 || code === 32;
}
module.exports = $f83a3caef6a827d0$var$markdownLineEndingOrSpace;

});

parcelRegister("c2qvq", function(module, exports) {
'use strict';

var $2gc7Z = parcelRequire("2gc7Z");

var $jk1EE = parcelRequire("jk1EE");
// In fact adds to the bundle size.
var $8c3a3b798c3bc528$var$unicodePunctuation = $jk1EE($2gc7Z);
module.exports = $8c3a3b798c3bc528$var$unicodePunctuation;

});
parcelRegister("2gc7Z", function(module, exports) {
'use strict';
// This module is generated by `script/`.
//
// CommonMark handles attention (emphasis, strong) markers based on what comes
// before or after them.
// One such difference is if those characters are Unicode punctuation.
// This script is generated from the Unicode data.
var $1a567bba3358a1b4$var$unicodePunctuation = /[!-\/:-@\[-`\{-~\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/;
module.exports = $1a567bba3358a1b4$var$unicodePunctuation;

});

parcelRegister("jk1EE", function(module, exports) {
'use strict';

var $2hVyl = parcelRequire("2hVyl");
function $e1112b243fda3f88$var$regexCheck(regex) {
    return check;
    function check(code) {
        return regex.test($2hVyl(code));
    }
}
module.exports = $e1112b243fda3f88$var$regexCheck;

});


parcelRegister("dKCO2", function(module, exports) {
'use strict';

var $jk1EE = parcelRequire("jk1EE");
var $a02dac5216dd6539$var$unicodeWhitespace = $jk1EE(/\s/);
module.exports = $a02dac5216dd6539$var$unicodeWhitespace;

});


parcelRegister("dSRWQ", function(module, exports) {
'use strict';
// chunks (replacement characters, tabs, or line endings).
function $a1ba2a75c188e5d8$var$movePoint(point, offset) {
    point.column += offset;
    point.offset += offset;
    point._bufferIndex += offset;
    return point;
}
module.exports = $a1ba2a75c188e5d8$var$movePoint;

});


parcelRegister("dYqGN", function(module, exports) {
'use strict';

var $cjSp3 = parcelRequire("cjSp3");

var $4jpoQ = parcelRequire("4jpoQ");

var $cWuvg = parcelRequire("cWuvg");

var $egeLq = parcelRequire("egeLq");
var $a2c594dda14126f6$var$autolink = {
    name: 'autolink',
    tokenize: $a2c594dda14126f6$var$tokenizeAutolink
};
function $a2c594dda14126f6$var$tokenizeAutolink(effects, ok, nok) {
    var size = 1;
    return start;
    function start(code) {
        effects.enter('autolink');
        effects.enter('autolinkMarker');
        effects.consume(code);
        effects.exit('autolinkMarker');
        effects.enter('autolinkProtocol');
        return open;
    }
    function open(code) {
        if ($cjSp3(code)) {
            effects.consume(code);
            return schemeOrEmailAtext;
        }
        return $cWuvg(code) ? emailAtext(code) : nok(code);
    }
    function schemeOrEmailAtext(code) {
        return code === 43 || code === 45 || code === 46 || $4jpoQ(code) ? schemeInsideOrEmailAtext(code) : emailAtext(code);
    }
    function schemeInsideOrEmailAtext(code) {
        if (code === 58) {
            effects.consume(code);
            return urlInside;
        }
        if ((code === 43 || code === 45 || code === 46 || $4jpoQ(code)) && size++ < 32) {
            effects.consume(code);
            return schemeInsideOrEmailAtext;
        }
        return emailAtext(code);
    }
    function urlInside(code) {
        if (code === 62) {
            effects.exit('autolinkProtocol');
            return end(code);
        }
        if (code === 32 || code === 60 || $egeLq(code)) return nok(code);
        effects.consume(code);
        return urlInside;
    }
    function emailAtext(code) {
        if (code === 64) {
            effects.consume(code);
            size = 0;
            return emailAtSignOrDot;
        }
        if ($cWuvg(code)) {
            effects.consume(code);
            return emailAtext;
        }
        return nok(code);
    }
    function emailAtSignOrDot(code) {
        return $4jpoQ(code) ? emailLabel(code) : nok(code);
    }
    function emailLabel(code) {
        if (code === 46) {
            effects.consume(code);
            size = 0;
            return emailAtSignOrDot;
        }
        if (code === 62) {
            // Exit, then change the type.
            effects.exit('autolinkProtocol').type = 'autolinkEmail';
            return end(code);
        }
        return emailValue(code);
    }
    function emailValue(code) {
        if ((code === 45 || $4jpoQ(code)) && size++ < 63) {
            effects.consume(code);
            return code === 45 ? emailValue : emailLabel;
        }
        return nok(code);
    }
    function end(code) {
        effects.enter('autolinkMarker');
        effects.consume(code);
        effects.exit('autolinkMarker');
        effects.exit('autolink');
        return ok;
    }
}
module.exports = $a2c594dda14126f6$var$autolink;

});
parcelRegister("cjSp3", function(module, exports) {
'use strict';

var $jk1EE = parcelRequire("jk1EE");
var $8f8175b535818e8d$var$asciiAlpha = $jk1EE(/[A-Za-z]/);
module.exports = $8f8175b535818e8d$var$asciiAlpha;

});

parcelRegister("4jpoQ", function(module, exports) {
'use strict';

var $jk1EE = parcelRequire("jk1EE");
var $323ca39b7f54429b$var$asciiAlphanumeric = $jk1EE(/[\dA-Za-z]/);
module.exports = $323ca39b7f54429b$var$asciiAlphanumeric;

});

parcelRegister("cWuvg", function(module, exports) {
'use strict';

var $jk1EE = parcelRequire("jk1EE");
var $96c29022edc459ba$var$asciiAtext = $jk1EE(/[#-'*+\--9=?A-Z^-~]/);
module.exports = $96c29022edc459ba$var$asciiAtext;

});

parcelRegister("egeLq", function(module, exports) {
'use strict';
// Note: EOF is seen as ASCII control here, because `null < 32 == true`.
function $a61e031ce9db4b1d$var$asciiControl(code) {
    return(// Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code < 32 || code === 127);
}
module.exports = $a61e031ce9db4b1d$var$asciiControl;

});


parcelRegister("656EE", function(module, exports) {
'use strict';

var $gOFfl = parcelRequire("gOFfl");

var $2BApW = parcelRequire("2BApW");
var $46d85f33885df999$var$blockQuote = {
    name: 'blockQuote',
    tokenize: $46d85f33885df999$var$tokenizeBlockQuoteStart,
    continuation: {
        tokenize: $46d85f33885df999$var$tokenizeBlockQuoteContinuation
    },
    exit: $46d85f33885df999$var$exit
};
function $46d85f33885df999$var$tokenizeBlockQuoteStart(effects, ok, nok) {
    var self = this;
    return start;
    function start(code) {
        if (code === 62) {
            if (!self.containerState.open) {
                effects.enter('blockQuote', {
                    _container: true
                });
                self.containerState.open = true;
            }
            effects.enter('blockQuotePrefix');
            effects.enter('blockQuoteMarker');
            effects.consume(code);
            effects.exit('blockQuoteMarker');
            return after;
        }
        return nok(code);
    }
    function after(code) {
        if ($gOFfl(code)) {
            effects.enter('blockQuotePrefixWhitespace');
            effects.consume(code);
            effects.exit('blockQuotePrefixWhitespace');
            effects.exit('blockQuotePrefix');
            return ok;
        }
        effects.exit('blockQuotePrefix');
        return ok(code);
    }
}
function $46d85f33885df999$var$tokenizeBlockQuoteContinuation(effects, ok, nok) {
    return $2BApW(effects, effects.attempt($46d85f33885df999$var$blockQuote, ok, nok), 'linePrefix', this.parser.constructs.disable.null.indexOf('codeIndented') > -1 ? undefined : 4);
}
function $46d85f33885df999$var$exit(effects) {
    effects.exit('blockQuote');
}
module.exports = $46d85f33885df999$var$blockQuote;

});

parcelRegister("2QSRT", function(module, exports) {
'use strict';

var $2xBks = parcelRequire("2xBks");
var $213affcf297d21f2$var$characterEscape = {
    name: 'characterEscape',
    tokenize: $213affcf297d21f2$var$tokenizeCharacterEscape
};
function $213affcf297d21f2$var$tokenizeCharacterEscape(effects, ok, nok) {
    return start;
    function start(code) {
        effects.enter('characterEscape');
        effects.enter('escapeMarker');
        effects.consume(code);
        effects.exit('escapeMarker');
        return open;
    }
    function open(code) {
        if ($2xBks(code)) {
            effects.enter('characterEscapeValue');
            effects.consume(code);
            effects.exit('characterEscapeValue');
            effects.exit('characterEscape');
            return ok;
        }
        return nok(code);
    }
}
module.exports = $213affcf297d21f2$var$characterEscape;

});
parcelRegister("2xBks", function(module, exports) {
'use strict';

var $jk1EE = parcelRequire("jk1EE");
var $1d9b9e9c126721d8$var$asciiPunctuation = $jk1EE(/[!-/:-@[-`{-~]/);
module.exports = $1d9b9e9c126721d8$var$asciiPunctuation;

});


parcelRegister("fRehc", function(module, exports) {
'use strict';

var $bI5dj = parcelRequire("bI5dj");

var $4jpoQ = parcelRequire("4jpoQ");

var $5XPTY = parcelRequire("5XPTY");

var $jvycl = parcelRequire("jvycl");
function $02fab10d6588b327$var$_interopDefaultLegacy(e) {
    return e && typeof e === 'object' && 'default' in e ? e : {
        default: e
    };
}
var $02fab10d6588b327$var$decodeEntity__default = /*#__PURE__*/ $02fab10d6588b327$var$_interopDefaultLegacy($bI5dj);
var $02fab10d6588b327$var$characterReference = {
    name: 'characterReference',
    tokenize: $02fab10d6588b327$var$tokenizeCharacterReference
};
function $02fab10d6588b327$var$tokenizeCharacterReference(effects, ok, nok) {
    var self = this;
    var size = 0;
    var max;
    var test;
    return start;
    function start(code) {
        effects.enter('characterReference');
        effects.enter('characterReferenceMarker');
        effects.consume(code);
        effects.exit('characterReferenceMarker');
        return open;
    }
    function open(code) {
        if (code === 35) {
            effects.enter('characterReferenceMarkerNumeric');
            effects.consume(code);
            effects.exit('characterReferenceMarkerNumeric');
            return numeric;
        }
        effects.enter('characterReferenceValue');
        max = 31;
        test = $4jpoQ;
        return value(code);
    }
    function numeric(code) {
        if (code === 88 || code === 120) {
            effects.enter('characterReferenceMarkerHexadecimal');
            effects.consume(code);
            effects.exit('characterReferenceMarkerHexadecimal');
            effects.enter('characterReferenceValue');
            max = 6;
            test = $jvycl;
            return value;
        }
        effects.enter('characterReferenceValue');
        max = 7;
        test = $5XPTY;
        return value(code);
    }
    function value(code) {
        var token;
        if (code === 59 && size) {
            token = effects.exit('characterReferenceValue');
            if (test === $4jpoQ && !$02fab10d6588b327$var$decodeEntity__default['default'](self.sliceSerialize(token))) return nok(code);
            effects.enter('characterReferenceMarker');
            effects.consume(code);
            effects.exit('characterReferenceMarker');
            effects.exit('characterReference');
            return ok;
        }
        if (test(code) && size++ < max) {
            effects.consume(code);
            return value;
        }
        return nok(code);
    }
}
module.exports = $02fab10d6588b327$var$characterReference;

});
parcelRegister("bI5dj", function(module, exports) {
'use strict';
/* eslint-env browser */ var $8867d917415e989c$var$el;
var $8867d917415e989c$var$semicolon = 59 //  ';'
;
module.exports = $8867d917415e989c$var$decodeEntity;
function $8867d917415e989c$var$decodeEntity(characters) {
    var entity = '&' + characters + ';';
    var char;
    $8867d917415e989c$var$el = $8867d917415e989c$var$el || document.createElement('i');
    $8867d917415e989c$var$el.innerHTML = entity;
    char = $8867d917415e989c$var$el.textContent;
    // Some entities do not require the closing semicolon (`&not` - for instance),
    // which leads to situations where parsing the assumed entity of &notit; will
    // result in the string `¬it;`.  When we encounter a trailing semicolon after
    // parsing and the entity to decode was not a semicolon (`&semi;`), we can
    // assume that the matching was incomplete
    if (char.charCodeAt(char.length - 1) === $8867d917415e989c$var$semicolon && characters !== 'semi') return false;
    // If the decoded string is equal to the input, the entity was not valid
    return char === entity ? false : char;
}

});

parcelRegister("5XPTY", function(module, exports) {
'use strict';

var $jk1EE = parcelRequire("jk1EE");
var $457ab90f246526fe$var$asciiDigit = $jk1EE(/\d/);
module.exports = $457ab90f246526fe$var$asciiDigit;

});

parcelRegister("jvycl", function(module, exports) {
'use strict';

var $jk1EE = parcelRequire("jk1EE");
var $e33b7094fac542a3$var$asciiHexDigit = $jk1EE(/[\dA-Fa-f]/);
module.exports = $e33b7094fac542a3$var$asciiHexDigit;

});


parcelRegister("ejEkV", function(module, exports) {
'use strict';

var $ifk0k = parcelRequire("ifk0k");

var $ljjaa = parcelRequire("ljjaa");

var $1WU15 = parcelRequire("1WU15");

var $2BApW = parcelRequire("2BApW");
var $a6c221014ba87810$var$codeFenced = {
    name: 'codeFenced',
    tokenize: $a6c221014ba87810$var$tokenizeCodeFenced,
    concrete: true
};
function $a6c221014ba87810$var$tokenizeCodeFenced(effects, ok, nok) {
    var self = this;
    var closingFenceConstruct = {
        tokenize: tokenizeClosingFence,
        partial: true
    };
    var initialPrefix = $1WU15(this.events, 'linePrefix');
    var sizeOpen = 0;
    var marker;
    return start;
    function start(code) {
        effects.enter('codeFenced');
        effects.enter('codeFencedFence');
        effects.enter('codeFencedFenceSequence');
        marker = code;
        return sequenceOpen(code);
    }
    function sequenceOpen(code) {
        if (code === marker) {
            effects.consume(code);
            sizeOpen++;
            return sequenceOpen;
        }
        effects.exit('codeFencedFenceSequence');
        return sizeOpen < 3 ? nok(code) : $2BApW(effects, infoOpen, 'whitespace')(code);
    }
    function infoOpen(code) {
        if (code === null || $ifk0k(code)) return openAfter(code);
        effects.enter('codeFencedFenceInfo');
        effects.enter('chunkString', {
            contentType: 'string'
        });
        return info(code);
    }
    function info(code) {
        if (code === null || $ljjaa(code)) {
            effects.exit('chunkString');
            effects.exit('codeFencedFenceInfo');
            return $2BApW(effects, infoAfter, 'whitespace')(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return info;
    }
    function infoAfter(code) {
        if (code === null || $ifk0k(code)) return openAfter(code);
        effects.enter('codeFencedFenceMeta');
        effects.enter('chunkString', {
            contentType: 'string'
        });
        return meta(code);
    }
    function meta(code) {
        if (code === null || $ifk0k(code)) {
            effects.exit('chunkString');
            effects.exit('codeFencedFenceMeta');
            return openAfter(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return meta;
    }
    function openAfter(code) {
        effects.exit('codeFencedFence');
        return self.interrupt ? ok(code) : content(code);
    }
    function content(code) {
        if (code === null) return after(code);
        if ($ifk0k(code)) {
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            return effects.attempt(closingFenceConstruct, after, initialPrefix ? $2BApW(effects, content, 'linePrefix', initialPrefix + 1) : content);
        }
        effects.enter('codeFlowValue');
        return contentContinue(code);
    }
    function contentContinue(code) {
        if (code === null || $ifk0k(code)) {
            effects.exit('codeFlowValue');
            return content(code);
        }
        effects.consume(code);
        return contentContinue;
    }
    function after(code) {
        effects.exit('codeFenced');
        return ok(code);
    }
    function tokenizeClosingFence(effects, ok, nok) {
        var size = 0;
        return $2BApW(effects, closingSequenceStart, 'linePrefix', this.parser.constructs.disable.null.indexOf('codeIndented') > -1 ? undefined : 4);
        function closingSequenceStart(code) {
            effects.enter('codeFencedFence');
            effects.enter('codeFencedFenceSequence');
            return closingSequence(code);
        }
        function closingSequence(code) {
            if (code === marker) {
                effects.consume(code);
                size++;
                return closingSequence;
            }
            if (size < sizeOpen) return nok(code);
            effects.exit('codeFencedFenceSequence');
            return $2BApW(effects, closingSequenceEnd, 'whitespace')(code);
        }
        function closingSequenceEnd(code) {
            if (code === null || $ifk0k(code)) {
                effects.exit('codeFencedFence');
                return ok(code);
            }
            return nok(code);
        }
    }
}
module.exports = $a6c221014ba87810$var$codeFenced;

});

parcelRegister("43D6a", function(module, exports) {
'use strict';

var $ifk0k = parcelRequire("ifk0k");

var $3ekiO = parcelRequire("3ekiO");

var $1WU15 = parcelRequire("1WU15");

var $2BApW = parcelRequire("2BApW");
var $2f45c55cfa3f73ba$var$codeIndented = {
    name: 'codeIndented',
    tokenize: $2f45c55cfa3f73ba$var$tokenizeCodeIndented,
    resolve: $2f45c55cfa3f73ba$var$resolveCodeIndented
};
var $2f45c55cfa3f73ba$var$indentedContentConstruct = {
    tokenize: $2f45c55cfa3f73ba$var$tokenizeIndentedContent,
    partial: true
};
function $2f45c55cfa3f73ba$var$resolveCodeIndented(events, context) {
    var code = {
        type: 'codeIndented',
        start: events[0][1].start,
        end: events[events.length - 1][1].end
    };
    $3ekiO(events, 0, 0, [
        [
            'enter',
            code,
            context
        ]
    ]);
    $3ekiO(events, events.length, 0, [
        [
            'exit',
            code,
            context
        ]
    ]);
    return events;
}
function $2f45c55cfa3f73ba$var$tokenizeCodeIndented(effects, ok, nok) {
    return effects.attempt($2f45c55cfa3f73ba$var$indentedContentConstruct, afterPrefix, nok);
    function afterPrefix(code) {
        if (code === null) return ok(code);
        if ($ifk0k(code)) return effects.attempt($2f45c55cfa3f73ba$var$indentedContentConstruct, afterPrefix, ok)(code);
        effects.enter('codeFlowValue');
        return content(code);
    }
    function content(code) {
        if (code === null || $ifk0k(code)) {
            effects.exit('codeFlowValue');
            return afterPrefix(code);
        }
        effects.consume(code);
        return content;
    }
}
function $2f45c55cfa3f73ba$var$tokenizeIndentedContent(effects, ok, nok) {
    var self = this;
    return $2BApW(effects, afterPrefix, 'linePrefix', 5);
    function afterPrefix(code) {
        if ($ifk0k(code)) {
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            return $2BApW(effects, afterPrefix, 'linePrefix', 5);
        }
        return $1WU15(self.events, 'linePrefix') < 4 ? nok(code) : ok(code);
    }
}
module.exports = $2f45c55cfa3f73ba$var$codeIndented;

});

parcelRegister("aiIjI", function(module, exports) {
'use strict';

var $ifk0k = parcelRequire("ifk0k");
var $77fdf642f5b9ed4e$var$codeText = {
    name: 'codeText',
    tokenize: $77fdf642f5b9ed4e$var$tokenizeCodeText,
    resolve: $77fdf642f5b9ed4e$var$resolveCodeText,
    previous: $77fdf642f5b9ed4e$var$previous
};
function $77fdf642f5b9ed4e$var$resolveCodeText(events) {
    var tailExitIndex = events.length - 4;
    var headEnterIndex = 3;
    var index;
    var enter // If we start and end with an EOL or a space.
    ;
    if ((events[headEnterIndex][1].type === 'lineEnding' || events[headEnterIndex][1].type === 'space') && (events[tailExitIndex][1].type === 'lineEnding' || events[tailExitIndex][1].type === 'space')) {
        index = headEnterIndex // And we have data.
        ;
        while(++index < tailExitIndex)if (events[index][1].type === 'codeTextData') {
            // Then we have padding.
            events[tailExitIndex][1].type = events[headEnterIndex][1].type = 'codeTextPadding';
            headEnterIndex += 2;
            tailExitIndex -= 2;
            break;
        }
    } // Merge adjacent spaces and data.
    index = headEnterIndex - 1;
    tailExitIndex++;
    while(++index <= tailExitIndex){
        if (enter === undefined) {
            if (index !== tailExitIndex && events[index][1].type !== 'lineEnding') enter = index;
        } else if (index === tailExitIndex || events[index][1].type === 'lineEnding') {
            events[enter][1].type = 'codeTextData';
            if (index !== enter + 2) {
                events[enter][1].end = events[index - 1][1].end;
                events.splice(enter + 2, index - enter - 2);
                tailExitIndex -= index - enter - 2;
                index = enter + 2;
            }
            enter = undefined;
        }
    }
    return events;
}
function $77fdf642f5b9ed4e$var$previous(code) {
    // If there is a previous code, there will always be a tail.
    return code !== 96 || this.events[this.events.length - 1][1].type === 'characterEscape';
}
function $77fdf642f5b9ed4e$var$tokenizeCodeText(effects, ok, nok) {
    var sizeOpen = 0;
    var size;
    var token;
    return start;
    function start(code) {
        effects.enter('codeText');
        effects.enter('codeTextSequence');
        return openingSequence(code);
    }
    function openingSequence(code) {
        if (code === 96) {
            effects.consume(code);
            sizeOpen++;
            return openingSequence;
        }
        effects.exit('codeTextSequence');
        return gap(code);
    }
    function gap(code) {
        // EOF.
        if (code === null) return nok(code);
         // Closing fence?
        // Could also be data.
        if (code === 96) {
            token = effects.enter('codeTextSequence');
            size = 0;
            return closingSequence(code);
        } // Tabs don’t work, and virtual spaces don’t make sense.
        if (code === 32) {
            effects.enter('space');
            effects.consume(code);
            effects.exit('space');
            return gap;
        }
        if ($ifk0k(code)) {
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            return gap;
        } // Data.
        effects.enter('codeTextData');
        return data(code);
    } // In code.
    function data(code) {
        if (code === null || code === 32 || code === 96 || $ifk0k(code)) {
            effects.exit('codeTextData');
            return gap(code);
        }
        effects.consume(code);
        return data;
    } // Closing fence.
    function closingSequence(code) {
        // More.
        if (code === 96) {
            effects.consume(code);
            size++;
            return closingSequence;
        } // Done!
        if (size === sizeOpen) {
            effects.exit('codeTextSequence');
            effects.exit('codeText');
            return ok(code);
        } // More or less accents: mark as data.
        token.type = 'codeTextData';
        return data(code);
    }
}
module.exports = $77fdf642f5b9ed4e$var$codeText;

});

parcelRegister("6aIIA", function(module, exports) {
'use strict';

var $ifk0k = parcelRequire("ifk0k");

var $ljjaa = parcelRequire("ljjaa");

var $byQ4m = parcelRequire("byQ4m");

var $hQtBr = parcelRequire("hQtBr");

var $iOr8z = parcelRequire("iOr8z");

var $2BApW = parcelRequire("2BApW");

var $fCQUF = parcelRequire("fCQUF");

var $6CAzF = parcelRequire("6CAzF");
var $47e65d52b7309291$var$definition = {
    name: 'definition',
    tokenize: $47e65d52b7309291$var$tokenizeDefinition
};
var $47e65d52b7309291$var$titleConstruct = {
    tokenize: $47e65d52b7309291$var$tokenizeTitle,
    partial: true
};
function $47e65d52b7309291$var$tokenizeDefinition(effects, ok, nok) {
    var self = this;
    var identifier;
    return start;
    function start(code) {
        effects.enter('definition');
        return $iOr8z.call(self, effects, labelAfter, nok, 'definitionLabel', 'definitionLabelMarker', 'definitionLabelString')(code);
    }
    function labelAfter(code) {
        identifier = $byQ4m(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1));
        if (code === 58) {
            effects.enter('definitionMarker');
            effects.consume(code);
            effects.exit('definitionMarker') // Note: blank lines can’t exist in content.
            ;
            return $fCQUF(effects, $hQtBr(effects, effects.attempt($47e65d52b7309291$var$titleConstruct, $2BApW(effects, after, 'whitespace'), $2BApW(effects, after, 'whitespace')), nok, 'definitionDestination', 'definitionDestinationLiteral', 'definitionDestinationLiteralMarker', 'definitionDestinationRaw', 'definitionDestinationString'));
        }
        return nok(code);
    }
    function after(code) {
        if (code === null || $ifk0k(code)) {
            effects.exit('definition');
            if (self.parser.defined.indexOf(identifier) < 0) self.parser.defined.push(identifier);
            return ok(code);
        }
        return nok(code);
    }
}
function $47e65d52b7309291$var$tokenizeTitle(effects, ok, nok) {
    return start;
    function start(code) {
        return $ljjaa(code) ? $fCQUF(effects, before)(code) : nok(code);
    }
    function before(code) {
        if (code === 34 || code === 39 || code === 40) return $6CAzF(effects, $2BApW(effects, after, 'whitespace'), nok, 'definitionTitle', 'definitionTitleMarker', 'definitionTitleString')(code);
        return nok(code);
    }
    function after(code) {
        return code === null || $ifk0k(code) ? ok(code) : nok(code);
    }
}
module.exports = $47e65d52b7309291$var$definition;

});
parcelRegister("hQtBr", function(module, exports) {
'use strict';

var $egeLq = parcelRequire("egeLq");

var $ljjaa = parcelRequire("ljjaa");

var $ifk0k = parcelRequire("ifk0k");
// eslint-disable-next-line max-params
function $cfde417fb4439324$var$destinationFactory(effects, ok, nok, type, literalType, literalMarkerType, rawType, stringType, max) {
    var limit = max || Infinity;
    var balance = 0;
    return start;
    function start(code) {
        if (code === 60) {
            effects.enter(type);
            effects.enter(literalType);
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            return destinationEnclosedBefore;
        }
        if ($egeLq(code) || code === 41) return nok(code);
        effects.enter(type);
        effects.enter(rawType);
        effects.enter(stringType);
        effects.enter('chunkString', {
            contentType: 'string'
        });
        return destinationRaw(code);
    }
    function destinationEnclosedBefore(code) {
        if (code === 62) {
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            effects.exit(literalType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        effects.enter('chunkString', {
            contentType: 'string'
        });
        return destinationEnclosed(code);
    }
    function destinationEnclosed(code) {
        if (code === 62) {
            effects.exit('chunkString');
            effects.exit(stringType);
            return destinationEnclosedBefore(code);
        }
        if (code === null || code === 60 || $ifk0k(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? destinationEnclosedEscape : destinationEnclosed;
    }
    function destinationEnclosedEscape(code) {
        if (code === 60 || code === 62 || code === 92) {
            effects.consume(code);
            return destinationEnclosed;
        }
        return destinationEnclosed(code);
    }
    function destinationRaw(code) {
        if (code === 40) {
            if (++balance > limit) return nok(code);
            effects.consume(code);
            return destinationRaw;
        }
        if (code === 41) {
            if (!balance--) {
                effects.exit('chunkString');
                effects.exit(stringType);
                effects.exit(rawType);
                effects.exit(type);
                return ok(code);
            }
            effects.consume(code);
            return destinationRaw;
        }
        if (code === null || $ljjaa(code)) {
            if (balance) return nok(code);
            effects.exit('chunkString');
            effects.exit(stringType);
            effects.exit(rawType);
            effects.exit(type);
            return ok(code);
        }
        if ($egeLq(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? destinationRawEscape : destinationRaw;
    }
    function destinationRawEscape(code) {
        if (code === 40 || code === 41 || code === 92) {
            effects.consume(code);
            return destinationRaw;
        }
        return destinationRaw(code);
    }
}
module.exports = $cfde417fb4439324$var$destinationFactory;

});

parcelRegister("iOr8z", function(module, exports) {
'use strict';

var $ifk0k = parcelRequire("ifk0k");

var $gOFfl = parcelRequire("gOFfl");
// eslint-disable-next-line max-params
function $db21f266a7c7928f$var$labelFactory(effects, ok, nok, type, markerType, stringType) {
    var self = this;
    var size = 0;
    var data;
    return start;
    function start(code) {
        effects.enter(type);
        effects.enter(markerType);
        effects.consume(code);
        effects.exit(markerType);
        effects.enter(stringType);
        return atBreak;
    }
    function atBreak(code) {
        if (code === null || code === 91 || code === 93 && !data || /* c8 ignore next */ code === 94 && /* c8 ignore next */ !size && /* c8 ignore next */ '_hiddenFootnoteSupport' in self.parser.constructs || size > 999) return nok(code);
        if (code === 93) {
            effects.exit(stringType);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        if ($ifk0k(code)) {
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            return atBreak;
        }
        effects.enter('chunkString', {
            contentType: 'string'
        });
        return label(code);
    }
    function label(code) {
        if (code === null || code === 91 || code === 93 || $ifk0k(code) || size++ > 999) {
            effects.exit('chunkString');
            return atBreak(code);
        }
        effects.consume(code);
        data = data || !$gOFfl(code);
        return code === 92 ? labelEscape : label;
    }
    function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return label;
        }
        return label(code);
    }
}
module.exports = $db21f266a7c7928f$var$labelFactory;

});

parcelRegister("fCQUF", function(module, exports) {
'use strict';

var $ifk0k = parcelRequire("ifk0k");

var $gOFfl = parcelRequire("gOFfl");

var $2BApW = parcelRequire("2BApW");
function $b603730498a60bb6$var$whitespaceFactory(effects, ok) {
    var seen;
    return start;
    function start(code) {
        if ($ifk0k(code)) {
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            seen = true;
            return start;
        }
        if ($gOFfl(code)) return $2BApW(effects, start, seen ? 'linePrefix' : 'lineSuffix')(code);
        return ok(code);
    }
}
module.exports = $b603730498a60bb6$var$whitespaceFactory;

});

parcelRegister("6CAzF", function(module, exports) {
'use strict';

var $ifk0k = parcelRequire("ifk0k");

var $2BApW = parcelRequire("2BApW");
function $4d22a98fa7220643$var$titleFactory(effects, ok, nok, type, markerType, stringType) {
    var marker;
    return start;
    function start(code) {
        effects.enter(type);
        effects.enter(markerType);
        effects.consume(code);
        effects.exit(markerType);
        marker = code === 40 ? 41 : code;
        return atFirstTitleBreak;
    }
    function atFirstTitleBreak(code) {
        if (code === marker) {
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        return atTitleBreak(code);
    }
    function atTitleBreak(code) {
        if (code === marker) {
            effects.exit(stringType);
            return atFirstTitleBreak(marker);
        }
        if (code === null) return nok(code);
         // Note: blank lines can’t exist in content.
        if ($ifk0k(code)) {
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            return $2BApW(effects, atTitleBreak, 'linePrefix');
        }
        effects.enter('chunkString', {
            contentType: 'string'
        });
        return title(code);
    }
    function title(code) {
        if (code === marker || code === null || $ifk0k(code)) {
            effects.exit('chunkString');
            return atTitleBreak(code);
        }
        effects.consume(code);
        return code === 92 ? titleEscape : title;
    }
    function titleEscape(code) {
        if (code === marker || code === 92) {
            effects.consume(code);
            return title;
        }
        return title(code);
    }
}
module.exports = $4d22a98fa7220643$var$titleFactory;

});


parcelRegister("gKoCv", function(module, exports) {
'use strict';

var $ifk0k = parcelRequire("ifk0k");
var $c3140a3db85cf1f4$var$hardBreakEscape = {
    name: 'hardBreakEscape',
    tokenize: $c3140a3db85cf1f4$var$tokenizeHardBreakEscape
};
function $c3140a3db85cf1f4$var$tokenizeHardBreakEscape(effects, ok, nok) {
    return start;
    function start(code) {
        effects.enter('hardBreakEscape');
        effects.enter('escapeMarker');
        effects.consume(code);
        return open;
    }
    function open(code) {
        if ($ifk0k(code)) {
            effects.exit('escapeMarker');
            effects.exit('hardBreakEscape');
            return ok(code);
        }
        return nok(code);
    }
}
module.exports = $c3140a3db85cf1f4$var$hardBreakEscape;

});

parcelRegister("9ubeb", function(module, exports) {
'use strict';

var $ifk0k = parcelRequire("ifk0k");

var $ljjaa = parcelRequire("ljjaa");

var $gOFfl = parcelRequire("gOFfl");

var $3ekiO = parcelRequire("3ekiO");

var $2BApW = parcelRequire("2BApW");
var $6e7f9ffa1346187e$var$headingAtx = {
    name: 'headingAtx',
    tokenize: $6e7f9ffa1346187e$var$tokenizeHeadingAtx,
    resolve: $6e7f9ffa1346187e$var$resolveHeadingAtx
};
function $6e7f9ffa1346187e$var$resolveHeadingAtx(events, context) {
    var contentEnd = events.length - 2;
    var contentStart = 3;
    var content;
    var text // Prefix whitespace, part of the opening.
    ;
    if (events[contentStart][1].type === 'whitespace') contentStart += 2;
     // Suffix whitespace, part of the closing.
    if (contentEnd - 2 > contentStart && events[contentEnd][1].type === 'whitespace') contentEnd -= 2;
    if (events[contentEnd][1].type === 'atxHeadingSequence' && (contentStart === contentEnd - 1 || contentEnd - 4 > contentStart && events[contentEnd - 2][1].type === 'whitespace')) contentEnd -= contentStart + 1 === contentEnd ? 2 : 4;
    if (contentEnd > contentStart) {
        content = {
            type: 'atxHeadingText',
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end
        };
        text = {
            type: 'chunkText',
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end,
            contentType: 'text'
        };
        $3ekiO(events, contentStart, contentEnd - contentStart + 1, [
            [
                'enter',
                content,
                context
            ],
            [
                'enter',
                text,
                context
            ],
            [
                'exit',
                text,
                context
            ],
            [
                'exit',
                content,
                context
            ]
        ]);
    }
    return events;
}
function $6e7f9ffa1346187e$var$tokenizeHeadingAtx(effects, ok, nok) {
    var self = this;
    var size = 0;
    return start;
    function start(code) {
        effects.enter('atxHeading');
        effects.enter('atxHeadingSequence');
        return fenceOpenInside(code);
    }
    function fenceOpenInside(code) {
        if (code === 35 && size++ < 6) {
            effects.consume(code);
            return fenceOpenInside;
        }
        if (code === null || $ljjaa(code)) {
            effects.exit('atxHeadingSequence');
            return self.interrupt ? ok(code) : headingBreak(code);
        }
        return nok(code);
    }
    function headingBreak(code) {
        if (code === 35) {
            effects.enter('atxHeadingSequence');
            return sequence(code);
        }
        if (code === null || $ifk0k(code)) {
            effects.exit('atxHeading');
            return ok(code);
        }
        if ($gOFfl(code)) return $2BApW(effects, headingBreak, 'whitespace')(code);
        effects.enter('atxHeadingText');
        return data(code);
    }
    function sequence(code) {
        if (code === 35) {
            effects.consume(code);
            return sequence;
        }
        effects.exit('atxHeadingSequence');
        return headingBreak(code);
    }
    function data(code) {
        if (code === null || code === 35 || $ljjaa(code)) {
            effects.exit('atxHeadingText');
            return headingBreak(code);
        }
        effects.consume(code);
        return data;
    }
}
module.exports = $6e7f9ffa1346187e$var$headingAtx;

});

parcelRegister("dQpuu", function(module, exports) {
'use strict';

var $cjSp3 = parcelRequire("cjSp3");

var $4jpoQ = parcelRequire("4jpoQ");

var $ifk0k = parcelRequire("ifk0k");

var $ljjaa = parcelRequire("ljjaa");

var $gOFfl = parcelRequire("gOFfl");

var $2hVyl = parcelRequire("2hVyl");

var $2AacE = parcelRequire("2AacE");

var $8hr3b = parcelRequire("8hr3b");

var $aaKX3 = parcelRequire("aaKX3");
var $a143e7a16246d8aa$var$htmlFlow = {
    name: 'htmlFlow',
    tokenize: $a143e7a16246d8aa$var$tokenizeHtmlFlow,
    resolveTo: $a143e7a16246d8aa$var$resolveToHtmlFlow,
    concrete: true
};
var $a143e7a16246d8aa$var$nextBlankConstruct = {
    tokenize: $a143e7a16246d8aa$var$tokenizeNextBlank,
    partial: true
};
function $a143e7a16246d8aa$var$resolveToHtmlFlow(events) {
    var index = events.length;
    while(index--){
        if (events[index][0] === 'enter' && events[index][1].type === 'htmlFlow') break;
    }
    if (index > 1 && events[index - 2][1].type === 'linePrefix') {
        // Add the prefix start to the HTML token.
        events[index][1].start = events[index - 2][1].start // Add the prefix start to the HTML line token.
        ;
        events[index + 1][1].start = events[index - 2][1].start // Remove the line prefix.
        ;
        events.splice(index - 2, 2);
    }
    return events;
}
function $a143e7a16246d8aa$var$tokenizeHtmlFlow(effects, ok, nok) {
    var self = this;
    var kind;
    var startTag;
    var buffer;
    var index;
    var marker;
    return start;
    function start(code) {
        effects.enter('htmlFlow');
        effects.enter('htmlFlowData');
        effects.consume(code);
        return open;
    }
    function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationStart;
        }
        if (code === 47) {
            effects.consume(code);
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            kind = 3 // While we’re in an instruction instead of a declaration, we’re on a `?`
            ;
            // right now, so we do need to search for `>`, similar to declarations.
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        if ($cjSp3(code)) {
            effects.consume(code);
            buffer = $2hVyl(code);
            startTag = true;
            return tagName;
        }
        return nok(code);
    }
    function declarationStart(code) {
        if (code === 45) {
            effects.consume(code);
            kind = 2;
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            kind = 5;
            buffer = 'CDATA[';
            index = 0;
            return cdataOpenInside;
        }
        if ($cjSp3(code)) {
            effects.consume(code);
            kind = 4;
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    function cdataOpenInside(code) {
        if (code === buffer.charCodeAt(index++)) {
            effects.consume(code);
            return index === buffer.length ? self.interrupt ? ok : continuation : cdataOpenInside;
        }
        return nok(code);
    }
    function tagCloseStart(code) {
        if ($cjSp3(code)) {
            effects.consume(code);
            buffer = $2hVyl(code);
            return tagName;
        }
        return nok(code);
    }
    function tagName(code) {
        if (code === null || code === 47 || code === 62 || $ljjaa(code)) {
            if (code !== 47 && startTag && $8hr3b.indexOf(buffer.toLowerCase()) > -1) {
                kind = 1;
                return self.interrupt ? ok(code) : continuation(code);
            }
            if ($2AacE.indexOf(buffer.toLowerCase()) > -1) {
                kind = 6;
                if (code === 47) {
                    effects.consume(code);
                    return basicSelfClosing;
                }
                return self.interrupt ? ok(code) : continuation(code);
            }
            kind = 7 // Do not support complete HTML when interrupting.
            ;
            return self.interrupt ? nok(code) : startTag ? completeAttributeNameBefore(code) : completeClosingTagAfter(code);
        }
        if (code === 45 || $4jpoQ(code)) {
            effects.consume(code);
            buffer += $2hVyl(code);
            return tagName;
        }
        return nok(code);
    }
    function basicSelfClosing(code) {
        if (code === 62) {
            effects.consume(code);
            return self.interrupt ? ok : continuation;
        }
        return nok(code);
    }
    function completeClosingTagAfter(code) {
        if ($gOFfl(code)) {
            effects.consume(code);
            return completeClosingTagAfter;
        }
        return completeEnd(code);
    }
    function completeAttributeNameBefore(code) {
        if (code === 47) {
            effects.consume(code);
            return completeEnd;
        }
        if (code === 58 || code === 95 || $cjSp3(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        if ($gOFfl(code)) {
            effects.consume(code);
            return completeAttributeNameBefore;
        }
        return completeEnd(code);
    }
    function completeAttributeName(code) {
        if (code === 45 || code === 46 || code === 58 || code === 95 || $4jpoQ(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        return completeAttributeNameAfter(code);
    }
    function completeAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        if ($gOFfl(code)) {
            effects.consume(code);
            return completeAttributeNameAfter;
        }
        return completeAttributeNameBefore(code);
    }
    function completeAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            marker = code;
            return completeAttributeValueQuoted;
        }
        if ($gOFfl(code)) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        marker = undefined;
        return completeAttributeValueUnquoted(code);
    }
    function completeAttributeValueQuoted(code) {
        if (code === marker) {
            effects.consume(code);
            return completeAttributeValueQuotedAfter;
        }
        if (code === null || $ifk0k(code)) return nok(code);
        effects.consume(code);
        return completeAttributeValueQuoted;
    }
    function completeAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 62 || code === 96 || $ljjaa(code)) return completeAttributeNameAfter(code);
        effects.consume(code);
        return completeAttributeValueUnquoted;
    }
    function completeAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || $gOFfl(code)) return completeAttributeNameBefore(code);
        return nok(code);
    }
    function completeEnd(code) {
        if (code === 62) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    function completeAfter(code) {
        if ($gOFfl(code)) {
            effects.consume(code);
            return completeAfter;
        }
        return code === null || $ifk0k(code) ? continuation(code) : nok(code);
    }
    function continuation(code) {
        if (code === 45 && kind === 2) {
            effects.consume(code);
            return continuationCommentInside;
        }
        if (code === 60 && kind === 1) {
            effects.consume(code);
            return continuationRawTagOpen;
        }
        if (code === 62 && kind === 4) {
            effects.consume(code);
            return continuationClose;
        }
        if (code === 63 && kind === 3) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        if (code === 93 && kind === 5) {
            effects.consume(code);
            return continuationCharacterDataInside;
        }
        if ($ifk0k(code) && (kind === 6 || kind === 7)) return effects.check($a143e7a16246d8aa$var$nextBlankConstruct, continuationClose, continuationAtLineEnding)(code);
        if (code === null || $ifk0k(code)) return continuationAtLineEnding(code);
        effects.consume(code);
        return continuation;
    }
    function continuationAtLineEnding(code) {
        effects.exit('htmlFlowData');
        return htmlContinueStart(code);
    }
    function htmlContinueStart(code) {
        if (code === null) return done(code);
        if ($ifk0k(code)) {
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            return htmlContinueStart;
        }
        effects.enter('htmlFlowData');
        return continuation(code);
    }
    function continuationCommentInside(code) {
        if (code === 45) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    function continuationRawTagOpen(code) {
        if (code === 47) {
            effects.consume(code);
            buffer = '';
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    function continuationRawEndTag(code) {
        if (code === 62 && $8hr3b.indexOf(buffer.toLowerCase()) > -1) {
            effects.consume(code);
            return continuationClose;
        }
        if ($cjSp3(code) && buffer.length < 8) {
            effects.consume(code);
            buffer += $2hVyl(code);
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    function continuationCharacterDataInside(code) {
        if (code === 93) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    function continuationDeclarationInside(code) {
        if (code === 62) {
            effects.consume(code);
            return continuationClose;
        }
        return continuation(code);
    }
    function continuationClose(code) {
        if (code === null || $ifk0k(code)) {
            effects.exit('htmlFlowData');
            return done(code);
        }
        effects.consume(code);
        return continuationClose;
    }
    function done(code) {
        effects.exit('htmlFlow');
        return ok(code);
    }
}
function $a143e7a16246d8aa$var$tokenizeNextBlank(effects, ok, nok) {
    return start;
    function start(code) {
        effects.exit('htmlFlowData');
        effects.enter('lineEndingBlank');
        effects.consume(code);
        effects.exit('lineEndingBlank');
        return effects.attempt($aaKX3, ok, nok);
    }
}
module.exports = $a143e7a16246d8aa$var$htmlFlow;

});
parcelRegister("2AacE", function(module, exports) {
'use strict';
// This module is copied from <https://spec.commonmark.org/0.29/#html-blocks>.
var $1e16dbafa4d2dcc3$var$basics = [
    'address',
    'article',
    'aside',
    'base',
    'basefont',
    'blockquote',
    'body',
    'caption',
    'center',
    'col',
    'colgroup',
    'dd',
    'details',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'frame',
    'frameset',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hr',
    'html',
    'iframe',
    'legend',
    'li',
    'link',
    'main',
    'menu',
    'menuitem',
    'nav',
    'noframes',
    'ol',
    'optgroup',
    'option',
    'p',
    'param',
    'section',
    'source',
    'summary',
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'title',
    'tr',
    'track',
    'ul'
];
module.exports = $1e16dbafa4d2dcc3$var$basics;

});

parcelRegister("8hr3b", function(module, exports) {
'use strict';
// This module is copied from <https://spec.commonmark.org/0.29/#html-blocks>.
var $6074e4e43f1f23bf$var$raws = [
    'pre',
    'script',
    'style',
    'textarea'
];
module.exports = $6074e4e43f1f23bf$var$raws;

});


parcelRegister("iOek4", function(module, exports) {
'use strict';

var $cjSp3 = parcelRequire("cjSp3");

var $4jpoQ = parcelRequire("4jpoQ");

var $ifk0k = parcelRequire("ifk0k");

var $ljjaa = parcelRequire("ljjaa");

var $gOFfl = parcelRequire("gOFfl");

var $2BApW = parcelRequire("2BApW");
var $db1801b2666a65d2$var$htmlText = {
    name: 'htmlText',
    tokenize: $db1801b2666a65d2$var$tokenizeHtmlText
};
function $db1801b2666a65d2$var$tokenizeHtmlText(effects, ok, nok) {
    var self = this;
    var marker;
    var buffer;
    var index;
    var returnState;
    return start;
    function start(code) {
        effects.enter('htmlText');
        effects.enter('htmlTextData');
        effects.consume(code);
        return open;
    }
    function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            return instruction;
        }
        if ($cjSp3(code)) {
            effects.consume(code);
            return tagOpen;
        }
        return nok(code);
    }
    function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            return commentOpen;
        }
        if (code === 91) {
            effects.consume(code);
            buffer = 'CDATA[';
            index = 0;
            return cdataOpen;
        }
        if ($cjSp3(code)) {
            effects.consume(code);
            return declaration;
        }
        return nok(code);
    }
    function commentOpen(code) {
        if (code === 45) {
            effects.consume(code);
            return commentStart;
        }
        return nok(code);
    }
    function commentStart(code) {
        if (code === null || code === 62) return nok(code);
        if (code === 45) {
            effects.consume(code);
            return commentStartDash;
        }
        return comment(code);
    }
    function commentStartDash(code) {
        if (code === null || code === 62) return nok(code);
        return comment(code);
    }
    function comment(code) {
        if (code === null) return nok(code);
        if (code === 45) {
            effects.consume(code);
            return commentClose;
        }
        if ($ifk0k(code)) {
            returnState = comment;
            return atLineEnding(code);
        }
        effects.consume(code);
        return comment;
    }
    function commentClose(code) {
        if (code === 45) {
            effects.consume(code);
            return end;
        }
        return comment(code);
    }
    function cdataOpen(code) {
        if (code === buffer.charCodeAt(index++)) {
            effects.consume(code);
            return index === buffer.length ? cdata : cdataOpen;
        }
        return nok(code);
    }
    function cdata(code) {
        if (code === null) return nok(code);
        if (code === 93) {
            effects.consume(code);
            return cdataClose;
        }
        if ($ifk0k(code)) {
            returnState = cdata;
            return atLineEnding(code);
        }
        effects.consume(code);
        return cdata;
    }
    function cdataClose(code) {
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    function cdataEnd(code) {
        if (code === 62) return end(code);
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    function declaration(code) {
        if (code === null || code === 62) return end(code);
        if ($ifk0k(code)) {
            returnState = declaration;
            return atLineEnding(code);
        }
        effects.consume(code);
        return declaration;
    }
    function instruction(code) {
        if (code === null) return nok(code);
        if (code === 63) {
            effects.consume(code);
            return instructionClose;
        }
        if ($ifk0k(code)) {
            returnState = instruction;
            return atLineEnding(code);
        }
        effects.consume(code);
        return instruction;
    }
    function instructionClose(code) {
        return code === 62 ? end(code) : instruction(code);
    }
    function tagCloseStart(code) {
        if ($cjSp3(code)) {
            effects.consume(code);
            return tagClose;
        }
        return nok(code);
    }
    function tagClose(code) {
        if (code === 45 || $4jpoQ(code)) {
            effects.consume(code);
            return tagClose;
        }
        return tagCloseBetween(code);
    }
    function tagCloseBetween(code) {
        if ($ifk0k(code)) {
            returnState = tagCloseBetween;
            return atLineEnding(code);
        }
        if ($gOFfl(code)) {
            effects.consume(code);
            return tagCloseBetween;
        }
        return end(code);
    }
    function tagOpen(code) {
        if (code === 45 || $4jpoQ(code)) {
            effects.consume(code);
            return tagOpen;
        }
        if (code === 47 || code === 62 || $ljjaa(code)) return tagOpenBetween(code);
        return nok(code);
    }
    function tagOpenBetween(code) {
        if (code === 47) {
            effects.consume(code);
            return end;
        }
        if (code === 58 || code === 95 || $cjSp3(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        if ($ifk0k(code)) {
            returnState = tagOpenBetween;
            return atLineEnding(code);
        }
        if ($gOFfl(code)) {
            effects.consume(code);
            return tagOpenBetween;
        }
        return end(code);
    }
    function tagOpenAttributeName(code) {
        if (code === 45 || code === 46 || code === 58 || code === 95 || $4jpoQ(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        return tagOpenAttributeNameAfter(code);
    }
    function tagOpenAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        if ($ifk0k(code)) {
            returnState = tagOpenAttributeNameAfter;
            return atLineEnding(code);
        }
        if ($gOFfl(code)) {
            effects.consume(code);
            return tagOpenAttributeNameAfter;
        }
        return tagOpenBetween(code);
    }
    function tagOpenAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            marker = code;
            return tagOpenAttributeValueQuoted;
        }
        if ($ifk0k(code)) {
            returnState = tagOpenAttributeValueBefore;
            return atLineEnding(code);
        }
        if ($gOFfl(code)) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        effects.consume(code);
        marker = undefined;
        return tagOpenAttributeValueUnquoted;
    }
    function tagOpenAttributeValueQuoted(code) {
        if (code === marker) {
            effects.consume(code);
            return tagOpenAttributeValueQuotedAfter;
        }
        if (code === null) return nok(code);
        if ($ifk0k(code)) {
            returnState = tagOpenAttributeValueQuoted;
            return atLineEnding(code);
        }
        effects.consume(code);
        return tagOpenAttributeValueQuoted;
    }
    function tagOpenAttributeValueQuotedAfter(code) {
        if (code === 62 || code === 47 || $ljjaa(code)) return tagOpenBetween(code);
        return nok(code);
    }
    function tagOpenAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 96) return nok(code);
        if (code === 62 || $ljjaa(code)) return tagOpenBetween(code);
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    } // We can’t have blank lines in content, so no need to worry about empty
    // tokens.
    function atLineEnding(code) {
        effects.exit('htmlTextData');
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        return $2BApW(effects, afterPrefix, 'linePrefix', self.parser.constructs.disable.null.indexOf('codeIndented') > -1 ? undefined : 4);
    }
    function afterPrefix(code) {
        effects.enter('htmlTextData');
        return returnState(code);
    }
    function end(code) {
        if (code === 62) {
            effects.consume(code);
            effects.exit('htmlTextData');
            effects.exit('htmlText');
            return ok;
        }
        return nok(code);
    }
}
module.exports = $db1801b2666a65d2$var$htmlText;

});

parcelRegister("LZd67", function(module, exports) {
'use strict';

var $ljjaa = parcelRequire("ljjaa");

var $3CXGo = parcelRequire("3CXGo");

var $3ekiO = parcelRequire("3ekiO");

var $byQ4m = parcelRequire("byQ4m");

var $3ROwI = parcelRequire("3ROwI");

var $5zKO5 = parcelRequire("5zKO5");

var $hQtBr = parcelRequire("hQtBr");

var $iOr8z = parcelRequire("iOr8z");

var $6CAzF = parcelRequire("6CAzF");

var $fCQUF = parcelRequire("fCQUF");
var $0903defb7fe810aa$var$labelEnd = {
    name: 'labelEnd',
    tokenize: $0903defb7fe810aa$var$tokenizeLabelEnd,
    resolveTo: $0903defb7fe810aa$var$resolveToLabelEnd,
    resolveAll: $0903defb7fe810aa$var$resolveAllLabelEnd
};
var $0903defb7fe810aa$var$resourceConstruct = {
    tokenize: $0903defb7fe810aa$var$tokenizeResource
};
var $0903defb7fe810aa$var$fullReferenceConstruct = {
    tokenize: $0903defb7fe810aa$var$tokenizeFullReference
};
var $0903defb7fe810aa$var$collapsedReferenceConstruct = {
    tokenize: $0903defb7fe810aa$var$tokenizeCollapsedReference
};
function $0903defb7fe810aa$var$resolveAllLabelEnd(events) {
    var index = -1;
    var token;
    while(++index < events.length){
        token = events[index][1];
        if (!token._used && (token.type === 'labelImage' || token.type === 'labelLink' || token.type === 'labelEnd')) {
            // Remove the marker.
            events.splice(index + 1, token.type === 'labelImage' ? 4 : 2);
            token.type = 'data';
            index++;
        }
    }
    return events;
}
function $0903defb7fe810aa$var$resolveToLabelEnd(events, context) {
    var index = events.length;
    var offset = 0;
    var group;
    var label;
    var text;
    var token;
    var open;
    var close;
    var media // Find an opening.
    ;
    while(index--){
        token = events[index][1];
        if (open) {
            // If we see another link, or inactive link label, we’ve been here before.
            if (token.type === 'link' || token.type === 'labelLink' && token._inactive) break;
             // Mark other link openings as inactive, as we can’t have links in
            // links.
            if (events[index][0] === 'enter' && token.type === 'labelLink') token._inactive = true;
        } else if (close) {
            if (events[index][0] === 'enter' && (token.type === 'labelImage' || token.type === 'labelLink') && !token._balanced) {
                open = index;
                if (token.type !== 'labelLink') {
                    offset = 2;
                    break;
                }
            }
        } else if (token.type === 'labelEnd') close = index;
    }
    group = {
        type: events[open][1].type === 'labelLink' ? 'link' : 'image',
        start: $5zKO5(events[open][1].start),
        end: $5zKO5(events[events.length - 1][1].end)
    };
    label = {
        type: 'label',
        start: $5zKO5(events[open][1].start),
        end: $5zKO5(events[close][1].end)
    };
    text = {
        type: 'labelText',
        start: $5zKO5(events[open + offset + 2][1].end),
        end: $5zKO5(events[close - 2][1].start)
    };
    media = [
        [
            'enter',
            group,
            context
        ],
        [
            'enter',
            label,
            context
        ]
    ] // Opening marker.
    ;
    media = $3CXGo(media, events.slice(open + 1, open + offset + 3)) // Text open.
    ;
    media = $3CXGo(media, [
        [
            'enter',
            text,
            context
        ]
    ]) // Between.
    ;
    media = $3CXGo(media, $3ROwI(context.parser.constructs.insideSpan.null, events.slice(open + offset + 4, close - 3), context)) // Text close, marker close, label close.
    ;
    media = $3CXGo(media, [
        [
            'exit',
            text,
            context
        ],
        events[close - 2],
        events[close - 1],
        [
            'exit',
            label,
            context
        ]
    ]) // Reference, resource, or so.
    ;
    media = $3CXGo(media, events.slice(close + 1)) // Media close.
    ;
    media = $3CXGo(media, [
        [
            'exit',
            group,
            context
        ]
    ]);
    $3ekiO(events, open, events.length, media);
    return events;
}
function $0903defb7fe810aa$var$tokenizeLabelEnd(effects, ok, nok) {
    var self = this;
    var index = self.events.length;
    var labelStart;
    var defined // Find an opening.
    ;
    while(index--)if ((self.events[index][1].type === 'labelImage' || self.events[index][1].type === 'labelLink') && !self.events[index][1]._balanced) {
        labelStart = self.events[index][1];
        break;
    }
    return start;
    function start(code) {
        if (!labelStart) return nok(code);
         // It’s a balanced bracket, but contains a link.
        if (labelStart._inactive) return balanced(code);
        defined = self.parser.defined.indexOf($byQ4m(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        }))) > -1;
        effects.enter('labelEnd');
        effects.enter('labelMarker');
        effects.consume(code);
        effects.exit('labelMarker');
        effects.exit('labelEnd');
        return afterLabelEnd;
    }
    function afterLabelEnd(code) {
        // Resource: `[asd](fgh)`.
        if (code === 40) return effects.attempt($0903defb7fe810aa$var$resourceConstruct, ok, defined ? ok : balanced)(code);
         // Collapsed (`[asd][]`) or full (`[asd][fgh]`) reference?
        if (code === 91) return effects.attempt($0903defb7fe810aa$var$fullReferenceConstruct, ok, defined ? effects.attempt($0903defb7fe810aa$var$collapsedReferenceConstruct, ok, balanced) : balanced)(code);
         // Shortcut reference: `[asd]`?
        return defined ? ok(code) : balanced(code);
    }
    function balanced(code) {
        labelStart._balanced = true;
        return nok(code);
    }
}
function $0903defb7fe810aa$var$tokenizeResource(effects, ok, nok) {
    return start;
    function start(code) {
        effects.enter('resource');
        effects.enter('resourceMarker');
        effects.consume(code);
        effects.exit('resourceMarker');
        return $fCQUF(effects, open);
    }
    function open(code) {
        if (code === 41) return end(code);
        return $hQtBr(effects, destinationAfter, nok, 'resourceDestination', 'resourceDestinationLiteral', 'resourceDestinationLiteralMarker', 'resourceDestinationRaw', 'resourceDestinationString', 3)(code);
    }
    function destinationAfter(code) {
        return $ljjaa(code) ? $fCQUF(effects, between)(code) : end(code);
    }
    function between(code) {
        if (code === 34 || code === 39 || code === 40) return $6CAzF(effects, $fCQUF(effects, end), nok, 'resourceTitle', 'resourceTitleMarker', 'resourceTitleString')(code);
        return end(code);
    }
    function end(code) {
        if (code === 41) {
            effects.enter('resourceMarker');
            effects.consume(code);
            effects.exit('resourceMarker');
            effects.exit('resource');
            return ok;
        }
        return nok(code);
    }
}
function $0903defb7fe810aa$var$tokenizeFullReference(effects, ok, nok) {
    var self = this;
    return start;
    function start(code) {
        return $iOr8z.call(self, effects, afterLabel, nok, 'reference', 'referenceMarker', 'referenceString')(code);
    }
    function afterLabel(code) {
        return self.parser.defined.indexOf($byQ4m(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1))) < 0 ? nok(code) : ok(code);
    }
}
function $0903defb7fe810aa$var$tokenizeCollapsedReference(effects, ok, nok) {
    return start;
    function start(code) {
        effects.enter('reference');
        effects.enter('referenceMarker');
        effects.consume(code);
        effects.exit('referenceMarker');
        return open;
    }
    function open(code) {
        if (code === 93) {
            effects.enter('referenceMarker');
            effects.consume(code);
            effects.exit('referenceMarker');
            effects.exit('reference');
            return ok;
        }
        return nok(code);
    }
}
module.exports = $0903defb7fe810aa$var$labelEnd;

});

parcelRegister("47ffq", function(module, exports) {
'use strict';

var $LZd67 = parcelRequire("LZd67");
var $2ff3a4c77bc4c120$var$labelStartImage = {
    name: 'labelStartImage',
    tokenize: $2ff3a4c77bc4c120$var$tokenizeLabelStartImage,
    resolveAll: $LZd67.resolveAll
};
function $2ff3a4c77bc4c120$var$tokenizeLabelStartImage(effects, ok, nok) {
    var self = this;
    return start;
    function start(code) {
        effects.enter('labelImage');
        effects.enter('labelImageMarker');
        effects.consume(code);
        effects.exit('labelImageMarker');
        return open;
    }
    function open(code) {
        if (code === 91) {
            effects.enter('labelMarker');
            effects.consume(code);
            effects.exit('labelMarker');
            effects.exit('labelImage');
            return after;
        }
        return nok(code);
    }
    function after(code) {
        /* c8 ignore next */ return code === 94 && /* c8 ignore next */ '_hiddenFootnoteSupport' in self.parser.constructs ? /* c8 ignore next */ nok(code) : ok(code);
    }
}
module.exports = $2ff3a4c77bc4c120$var$labelStartImage;

});

parcelRegister("8hIyI", function(module, exports) {
'use strict';

var $LZd67 = parcelRequire("LZd67");
var $608279c298c33376$var$labelStartLink = {
    name: 'labelStartLink',
    tokenize: $608279c298c33376$var$tokenizeLabelStartLink,
    resolveAll: $LZd67.resolveAll
};
function $608279c298c33376$var$tokenizeLabelStartLink(effects, ok, nok) {
    var self = this;
    return start;
    function start(code) {
        effects.enter('labelLink');
        effects.enter('labelMarker');
        effects.consume(code);
        effects.exit('labelMarker');
        effects.exit('labelLink');
        return after;
    }
    function after(code) {
        /* c8 ignore next */ return code === 94 && /* c8 ignore next */ '_hiddenFootnoteSupport' in self.parser.constructs ? /* c8 ignore next */ nok(code) : ok(code);
    }
}
module.exports = $608279c298c33376$var$labelStartLink;

});

parcelRegister("74cf0", function(module, exports) {
'use strict';

var $2BApW = parcelRequire("2BApW");
var $525266f2cc856952$var$lineEnding = {
    name: 'lineEnding',
    tokenize: $525266f2cc856952$var$tokenizeLineEnding
};
function $525266f2cc856952$var$tokenizeLineEnding(effects, ok) {
    return start;
    function start(code) {
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        return $2BApW(effects, ok, 'linePrefix');
    }
}
module.exports = $525266f2cc856952$var$lineEnding;

});

parcelRegister("9GqMK", function(module, exports) {
'use strict';

var $5XPTY = parcelRequire("5XPTY");

var $gOFfl = parcelRequire("gOFfl");

var $1WU15 = parcelRequire("1WU15");

var $1NrKy = parcelRequire("1NrKy");

var $2BApW = parcelRequire("2BApW");

var $aaKX3 = parcelRequire("aaKX3");

var $85DH0 = parcelRequire("85DH0");
var $70ccd05084b98b53$var$list = {
    name: 'list',
    tokenize: $70ccd05084b98b53$var$tokenizeListStart,
    continuation: {
        tokenize: $70ccd05084b98b53$var$tokenizeListContinuation
    },
    exit: $70ccd05084b98b53$var$tokenizeListEnd
};
var $70ccd05084b98b53$var$listItemPrefixWhitespaceConstruct = {
    tokenize: $70ccd05084b98b53$var$tokenizeListItemPrefixWhitespace,
    partial: true
};
var $70ccd05084b98b53$var$indentConstruct = {
    tokenize: $70ccd05084b98b53$var$tokenizeIndent,
    partial: true
};
function $70ccd05084b98b53$var$tokenizeListStart(effects, ok, nok) {
    var self = this;
    var initialSize = $1WU15(self.events, 'linePrefix');
    var size = 0;
    return start;
    function start(code) {
        var kind = self.containerState.type || (code === 42 || code === 43 || code === 45 ? 'listUnordered' : 'listOrdered');
        if (kind === 'listUnordered' ? !self.containerState.marker || code === self.containerState.marker : $5XPTY(code)) {
            if (!self.containerState.type) {
                self.containerState.type = kind;
                effects.enter(kind, {
                    _container: true
                });
            }
            if (kind === 'listUnordered') {
                effects.enter('listItemPrefix');
                return code === 42 || code === 45 ? effects.check($85DH0, nok, atMarker)(code) : atMarker(code);
            }
            if (!self.interrupt || code === 49) {
                effects.enter('listItemPrefix');
                effects.enter('listItemValue');
                return inside(code);
            }
        }
        return nok(code);
    }
    function inside(code) {
        if ($5XPTY(code) && ++size < 10) {
            effects.consume(code);
            return inside;
        }
        if ((!self.interrupt || size < 2) && (self.containerState.marker ? code === self.containerState.marker : code === 41 || code === 46)) {
            effects.exit('listItemValue');
            return atMarker(code);
        }
        return nok(code);
    }
    function atMarker(code) {
        effects.enter('listItemMarker');
        effects.consume(code);
        effects.exit('listItemMarker');
        self.containerState.marker = self.containerState.marker || code;
        return effects.check($aaKX3, self.interrupt ? nok : onBlank, effects.attempt($70ccd05084b98b53$var$listItemPrefixWhitespaceConstruct, endOfPrefix, otherPrefix));
    }
    function onBlank(code) {
        self.containerState.initialBlankLine = true;
        initialSize++;
        return endOfPrefix(code);
    }
    function otherPrefix(code) {
        if ($gOFfl(code)) {
            effects.enter('listItemPrefixWhitespace');
            effects.consume(code);
            effects.exit('listItemPrefixWhitespace');
            return endOfPrefix;
        }
        return nok(code);
    }
    function endOfPrefix(code) {
        self.containerState.size = initialSize + $1NrKy(self.sliceStream(effects.exit('listItemPrefix')));
        return ok(code);
    }
}
function $70ccd05084b98b53$var$tokenizeListContinuation(effects, ok, nok) {
    var self = this;
    self.containerState._closeFlow = undefined;
    return effects.check($aaKX3, onBlank, notBlank);
    function onBlank(code) {
        self.containerState.furtherBlankLines = self.containerState.furtherBlankLines || self.containerState.initialBlankLine // We have a blank line.
        ;
        // Still, try to consume at most the items size.
        return $2BApW(effects, ok, 'listItemIndent', self.containerState.size + 1)(code);
    }
    function notBlank(code) {
        if (self.containerState.furtherBlankLines || !$gOFfl(code)) {
            self.containerState.furtherBlankLines = self.containerState.initialBlankLine = undefined;
            return notInCurrentItem(code);
        }
        self.containerState.furtherBlankLines = self.containerState.initialBlankLine = undefined;
        return effects.attempt($70ccd05084b98b53$var$indentConstruct, ok, notInCurrentItem)(code);
    }
    function notInCurrentItem(code) {
        // While we do continue, we signal that the flow should be closed.
        self.containerState._closeFlow = true // As we’re closing flow, we’re no longer interrupting.
        ;
        self.interrupt = undefined;
        return $2BApW(effects, effects.attempt($70ccd05084b98b53$var$list, ok, nok), 'linePrefix', self.parser.constructs.disable.null.indexOf('codeIndented') > -1 ? undefined : 4)(code);
    }
}
function $70ccd05084b98b53$var$tokenizeIndent(effects, ok, nok) {
    var self = this;
    return $2BApW(effects, afterPrefix, 'listItemIndent', self.containerState.size + 1);
    function afterPrefix(code) {
        return $1WU15(self.events, 'listItemIndent') === self.containerState.size ? ok(code) : nok(code);
    }
}
function $70ccd05084b98b53$var$tokenizeListEnd(effects) {
    effects.exit(this.containerState.type);
}
function $70ccd05084b98b53$var$tokenizeListItemPrefixWhitespace(effects, ok, nok) {
    var self = this;
    return $2BApW(effects, afterPrefix, 'listItemPrefixWhitespace', self.parser.constructs.disable.null.indexOf('codeIndented') > -1 ? undefined : 5);
    function afterPrefix(code) {
        return $gOFfl(code) || !$1WU15(self.events, 'listItemPrefixWhitespace') ? nok(code) : ok(code);
    }
}
module.exports = $70ccd05084b98b53$var$list;

});
parcelRegister("85DH0", function(module, exports) {
'use strict';

var $ifk0k = parcelRequire("ifk0k");

var $gOFfl = parcelRequire("gOFfl");

var $2BApW = parcelRequire("2BApW");
var $5e3d94824eec7f16$var$thematicBreak = {
    name: 'thematicBreak',
    tokenize: $5e3d94824eec7f16$var$tokenizeThematicBreak
};
function $5e3d94824eec7f16$var$tokenizeThematicBreak(effects, ok, nok) {
    var size = 0;
    var marker;
    return start;
    function start(code) {
        effects.enter('thematicBreak');
        marker = code;
        return atBreak(code);
    }
    function atBreak(code) {
        if (code === marker) {
            effects.enter('thematicBreakSequence');
            return sequence(code);
        }
        if ($gOFfl(code)) return $2BApW(effects, atBreak, 'whitespace')(code);
        if (size < 3 || code !== null && !$ifk0k(code)) return nok(code);
        effects.exit('thematicBreak');
        return ok(code);
    }
    function sequence(code) {
        if (code === marker) {
            effects.consume(code);
            size++;
            return sequence;
        }
        effects.exit('thematicBreakSequence');
        return atBreak(code);
    }
}
module.exports = $5e3d94824eec7f16$var$thematicBreak;

});


parcelRegister("qMmWK", function(module, exports) {
'use strict';

var $ifk0k = parcelRequire("ifk0k");

var $5zKO5 = parcelRequire("5zKO5");

var $2BApW = parcelRequire("2BApW");
var $0507f2eb6a722fe9$var$setextUnderline = {
    name: 'setextUnderline',
    tokenize: $0507f2eb6a722fe9$var$tokenizeSetextUnderline,
    resolveTo: $0507f2eb6a722fe9$var$resolveToSetextUnderline
};
function $0507f2eb6a722fe9$var$resolveToSetextUnderline(events, context) {
    var index = events.length;
    var content;
    var text;
    var definition;
    var heading // Find the opening of the content.
    ;
    // It’ll always exist: we don’t tokenize if it isn’t there.
    while(index--)if (events[index][0] === 'enter') {
        if (events[index][1].type === 'content') {
            content = index;
            break;
        }
        if (events[index][1].type === 'paragraph') text = index;
    } else {
        if (events[index][1].type === 'content') // Remove the content end (if needed we’ll add it later)
        events.splice(index, 1);
        if (!definition && events[index][1].type === 'definition') definition = index;
    }
    heading = {
        type: 'setextHeading',
        start: $5zKO5(events[text][1].start),
        end: $5zKO5(events[events.length - 1][1].end)
    } // Change the paragraph to setext heading text.
    ;
    events[text][1].type = 'setextHeadingText' // If we have definitions in the content, we’ll keep on having content,
    ;
    // but we need move it.
    if (definition) {
        events.splice(text, 0, [
            'enter',
            heading,
            context
        ]);
        events.splice(definition + 1, 0, [
            'exit',
            events[content][1],
            context
        ]);
        events[content][1].end = $5zKO5(events[definition][1].end);
    } else events[content][1] = heading;
     // Add the heading exit at the end.
    events.push([
        'exit',
        heading,
        context
    ]);
    return events;
}
function $0507f2eb6a722fe9$var$tokenizeSetextUnderline(effects, ok, nok) {
    var self = this;
    var index = self.events.length;
    var marker;
    var paragraph // Find an opening.
    ;
    while(index--)// Skip enter/exit of line ending, line prefix, and content.
    // We can now either have a definition or a paragraph.
    if (self.events[index][1].type !== 'lineEnding' && self.events[index][1].type !== 'linePrefix' && self.events[index][1].type !== 'content') {
        paragraph = self.events[index][1].type === 'paragraph';
        break;
    }
    return start;
    function start(code) {
        if (!self.lazy && (self.interrupt || paragraph)) {
            effects.enter('setextHeadingLine');
            effects.enter('setextHeadingLineSequence');
            marker = code;
            return closingSequence(code);
        }
        return nok(code);
    }
    function closingSequence(code) {
        if (code === marker) {
            effects.consume(code);
            return closingSequence;
        }
        effects.exit('setextHeadingLineSequence');
        return $2BApW(effects, closingSequenceEnd, 'lineSuffix')(code);
    }
    function closingSequenceEnd(code) {
        if (code === null || $ifk0k(code)) {
            effects.exit('setextHeadingLine');
            return ok(code);
        }
        return nok(code);
    }
}
module.exports = $0507f2eb6a722fe9$var$setextUnderline;

});



parcelRegister("k993E", function(module, exports) {
'use strict';
var $eaabac98569eb874$var$search = /[\0\t\n\r]/g;
function $eaabac98569eb874$var$preprocess() {
    var start = true;
    var column = 1;
    var buffer = '';
    var atCarriageReturn;
    return preprocessor;
    function preprocessor(value, encoding, end) {
        var chunks = [];
        var match;
        var next;
        var startPosition;
        var endPosition;
        var code;
        value = buffer + value.toString(encoding);
        startPosition = 0;
        buffer = '';
        if (start) {
            if (value.charCodeAt(0) === 65279) startPosition++;
            start = undefined;
        }
        while(startPosition < value.length){
            $eaabac98569eb874$var$search.lastIndex = startPosition;
            match = $eaabac98569eb874$var$search.exec(value);
            endPosition = match ? match.index : value.length;
            code = value.charCodeAt(endPosition);
            if (!match) {
                buffer = value.slice(startPosition);
                break;
            }
            if (code === 10 && startPosition === endPosition && atCarriageReturn) {
                chunks.push(-3);
                atCarriageReturn = undefined;
            } else {
                if (atCarriageReturn) {
                    chunks.push(-5);
                    atCarriageReturn = undefined;
                }
                if (startPosition < endPosition) {
                    chunks.push(value.slice(startPosition, endPosition));
                    column += endPosition - startPosition;
                }
                if (code === 0) {
                    chunks.push(65533);
                    column++;
                } else if (code === 9) {
                    next = Math.ceil(column / 4) * 4;
                    chunks.push(-2);
                    while(column++ < next)chunks.push(-1);
                } else if (code === 10) {
                    chunks.push(-4);
                    column = 1;
                } else {
                    atCarriageReturn = true;
                    column = 1;
                }
            }
            startPosition = endPosition + 1;
        }
        if (end) {
            if (atCarriageReturn) chunks.push(-5);
            if (buffer) chunks.push(buffer);
            chunks.push(null);
        }
        return chunks;
    }
}
module.exports = $eaabac98569eb874$var$preprocess;

});

parcelRegister("6KPiM", function(module, exports) {
'use strict';

var $285TQ = parcelRequire("285TQ");
function $4eaed56bf7a83667$var$postprocess(events) {
    while(!$285TQ(events));
    return events;
}
module.exports = $4eaed56bf7a83667$var$postprocess;

});


parcelRegister("5N7qR", function(module, exports) {
'use strict';
module.exports = $43774b39a057500d$var$toHast;

var $fin0W = parcelRequire("fin0W");

var $6Ddhl = parcelRequire("6Ddhl");

var $lPHor = parcelRequire("lPHor");

var $5z15R = parcelRequire("5z15R");

var $4XgSs = parcelRequire("4XgSs");

var $kNiko = parcelRequire("kNiko");

var $8czcz = parcelRequire("8czcz");

var $jrsVt = parcelRequire("jrsVt");
var $43774b39a057500d$var$own = {}.hasOwnProperty;
var $43774b39a057500d$var$deprecationWarningIssued = false;
// Factory to transform.
function $43774b39a057500d$var$factory(tree, options) {
    var settings = options || {};
    // Issue a warning if the deprecated tag 'allowDangerousHTML' is used
    if (settings.allowDangerousHTML !== undefined && !$43774b39a057500d$var$deprecationWarningIssued) {
        $43774b39a057500d$var$deprecationWarningIssued = true;
        console.warn('mdast-util-to-hast: deprecation: `allowDangerousHTML` is nonstandard, use `allowDangerousHtml` instead');
    }
    var dangerous = settings.allowDangerousHtml || settings.allowDangerousHTML;
    var footnoteById = {};
    h.dangerous = dangerous;
    h.definition = $4XgSs(tree);
    h.footnoteById = footnoteById;
    h.footnoteOrder = [];
    h.augment = augment;
    h.handlers = Object.assign({}, $jrsVt, settings.handlers);
    h.unknownHandler = settings.unknownHandler;
    h.passThrough = settings.passThrough;
    $6Ddhl(tree, 'footnoteDefinition', onfootnotedefinition);
    return h;
    // Finalise the created `right`, a hast node, from `left`, an mdast node.
    function augment(left, right) {
        var data;
        var ctx;
        // Handle `data.hName`, `data.hProperties, `data.hChildren`.
        if (left && left.data) {
            data = left.data;
            if (data.hName) {
                if (right.type !== 'element') right = {
                    type: 'element',
                    tagName: '',
                    properties: {},
                    children: []
                };
                right.tagName = data.hName;
            }
            if (right.type === 'element' && data.hProperties) right.properties = Object.assign({}, right.properties, data.hProperties);
            if (right.children && data.hChildren) right.children = data.hChildren;
        }
        ctx = left && left.position ? left : {
            position: left
        };
        if (!$5z15R(ctx)) right.position = {
            start: $lPHor.start(ctx),
            end: $lPHor.end(ctx)
        };
        return right;
    }
    // Create an element for `node`.
    function h(node, tagName, props, children) {
        if ((children === undefined || children === null) && typeof props === 'object' && 'length' in props) {
            children = props;
            props = {};
        }
        return augment(node, {
            type: 'element',
            tagName: tagName,
            properties: props || {},
            children: children || []
        });
    }
    function onfootnotedefinition(definition) {
        var id = String(definition.identifier).toUpperCase();
        // Mimick CM behavior of link definitions.
        // See: <https://github.com/syntax-tree/mdast-util-definitions/blob/8290999/index.js#L26>.
        if (!$43774b39a057500d$var$own.call(footnoteById, id)) footnoteById[id] = definition;
    }
}
// Transform `tree`, which is an mdast node, to a hast node.
function $43774b39a057500d$var$toHast(tree, options) {
    var h = $43774b39a057500d$var$factory(tree, options);
    var node = $kNiko(h, tree);
    var foot = $8czcz(h);
    if (foot) node.children = node.children.concat($fin0W('text', '\n'), foot);
    return node;
}

});
parcelRegister("fin0W", function(module, exports) {
'use strict';
module.exports = $02dfa6c47bd57737$var$u;
function $02dfa6c47bd57737$var$u(type, props, value) {
    var node;
    if ((value === null || value === undefined) && (typeof props !== 'object' || Array.isArray(props))) {
        value = props;
        props = {};
    }
    node = Object.assign({
        type: String(type)
    }, props);
    if (Array.isArray(value)) node.children = value;
    else if (value !== null && value !== undefined) node.value = String(value);
    return node;
}

});

parcelRegister("6Ddhl", function(module, exports) {
'use strict';
module.exports = $013efa928a3e7e2e$var$visit;

var $epPD7 = parcelRequire("epPD7");
var $013efa928a3e7e2e$var$CONTINUE = $epPD7.CONTINUE;
var $013efa928a3e7e2e$var$SKIP = $epPD7.SKIP;
var $013efa928a3e7e2e$var$EXIT = $epPD7.EXIT;
$013efa928a3e7e2e$var$visit.CONTINUE = $013efa928a3e7e2e$var$CONTINUE;
$013efa928a3e7e2e$var$visit.SKIP = $013efa928a3e7e2e$var$SKIP;
$013efa928a3e7e2e$var$visit.EXIT = $013efa928a3e7e2e$var$EXIT;
function $013efa928a3e7e2e$var$visit(tree, test, visitor, reverse) {
    if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor;
        visitor = test;
        test = null;
    }
    $epPD7(tree, test, overload, reverse);
    function overload(node, parents) {
        var parent = parents[parents.length - 1];
        var index = parent ? parent.children.indexOf(node) : null;
        return visitor(node, index, parent);
    }
}

});
parcelRegister("epPD7", function(module, exports) {
'use strict';
module.exports = $a7eb732208be5189$var$visitParents;

var $arhvn = parcelRequire("arhvn");

var $di4Db = parcelRequire("di4Db");
var $a7eb732208be5189$var$CONTINUE = true;
var $a7eb732208be5189$var$SKIP = 'skip';
var $a7eb732208be5189$var$EXIT = false;
$a7eb732208be5189$var$visitParents.CONTINUE = $a7eb732208be5189$var$CONTINUE;
$a7eb732208be5189$var$visitParents.SKIP = $a7eb732208be5189$var$SKIP;
$a7eb732208be5189$var$visitParents.EXIT = $a7eb732208be5189$var$EXIT;
function $a7eb732208be5189$var$visitParents(tree, test, visitor, reverse) {
    var step;
    var is;
    if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor;
        visitor = test;
        test = null;
    }
    is = $arhvn(test);
    step = reverse ? -1 : 1;
    factory(tree, null, [])();
    function factory(node, index, parents) {
        var value = typeof node === 'object' && node !== null ? node : {};
        var name;
        if (typeof value.type === 'string') {
            name = typeof value.tagName === 'string' ? value.tagName : typeof value.name === 'string' ? value.name : undefined;
            visit.displayName = 'node (' + $di4Db(value.type + (name ? '<' + name + '>' : '')) + ')';
        }
        return visit;
        function visit() {
            var grandparents = parents.concat(node);
            var result = [];
            var subresult;
            var offset;
            if (!test || is(node, index, parents[parents.length - 1] || null)) {
                result = $a7eb732208be5189$var$toResult(visitor(node, parents));
                if (result[0] === $a7eb732208be5189$var$EXIT) return result;
            }
            if (node.children && result[0] !== $a7eb732208be5189$var$SKIP) {
                offset = (reverse ? node.children.length : -1) + step;
                while(offset > -1 && offset < node.children.length){
                    subresult = factory(node.children[offset], offset, grandparents)();
                    if (subresult[0] === $a7eb732208be5189$var$EXIT) return subresult;
                    offset = typeof subresult[1] === 'number' ? subresult[1] : offset + step;
                }
            }
            return result;
        }
    }
}
function $a7eb732208be5189$var$toResult(value) {
    if (value !== null && typeof value === 'object' && 'length' in value) return value;
    if (typeof value === 'number') return [
        $a7eb732208be5189$var$CONTINUE,
        value
    ];
    return [
        value
    ];
}

});
parcelRegister("arhvn", function(module, exports) {
'use strict';
module.exports = $799a0124a526ab0a$var$convert;
function $799a0124a526ab0a$var$convert(test) {
    if (test == null) return $799a0124a526ab0a$var$ok;
    if (typeof test === 'string') return $799a0124a526ab0a$var$typeFactory(test);
    if (typeof test === 'object') return 'length' in test ? $799a0124a526ab0a$var$anyFactory(test) : $799a0124a526ab0a$var$allFactory(test);
    if (typeof test === 'function') return test;
    throw new Error('Expected function, string, or object as test');
}
// Utility assert each property in `test` is represented in `node`, and each
// values are strictly equal.
function $799a0124a526ab0a$var$allFactory(test) {
    return all;
    function all(node) {
        var key;
        for(key in test){
            if (node[key] !== test[key]) return false;
        }
        return true;
    }
}
function $799a0124a526ab0a$var$anyFactory(tests) {
    var checks = [];
    var index = -1;
    while(++index < tests.length)checks[index] = $799a0124a526ab0a$var$convert(tests[index]);
    return any;
    function any() {
        var index = -1;
        while(++index < checks.length){
            if (checks[index].apply(this, arguments)) return true;
        }
        return false;
    }
}
// Utility to convert a string into a function which checks a given node’s type
// for said string.
function $799a0124a526ab0a$var$typeFactory(test) {
    return type;
    function type(node) {
        return Boolean(node && node.type === test);
    }
}
// Utility to return true.
function $799a0124a526ab0a$var$ok() {
    return true;
}

});

parcelRegister("di4Db", function(module, exports) {
module.exports = $9ad08c71aeb92699$var$identity;
function $9ad08c71aeb92699$var$identity(d) {
    return d;
}

});



parcelRegister("lPHor", function(module, exports) {
'use strict';
var $fe5005656d832329$var$start = $fe5005656d832329$var$factory('start');
var $fe5005656d832329$var$end = $fe5005656d832329$var$factory('end');
module.exports = $fe5005656d832329$var$position;
$fe5005656d832329$var$position.start = $fe5005656d832329$var$start;
$fe5005656d832329$var$position.end = $fe5005656d832329$var$end;
function $fe5005656d832329$var$position(node) {
    return {
        start: $fe5005656d832329$var$start(node),
        end: $fe5005656d832329$var$end(node)
    };
}
function $fe5005656d832329$var$factory(type) {
    point.displayName = type;
    return point;
    function point(node) {
        var point = node && node.position && node.position[type] || {};
        return {
            line: point.line || null,
            column: point.column || null,
            offset: isNaN(point.offset) ? null : point.offset
        };
    }
}

});

parcelRegister("5z15R", function(module, exports) {
'use strict';
module.exports = $40d111cecb1195fd$var$generated;
function $40d111cecb1195fd$var$generated(node) {
    return !node || !node.position || !node.position.start || !node.position.start.line || !node.position.start.column || !node.position.end || !node.position.end.line || !node.position.end.column;
}

});

parcelRegister("4XgSs", function(module, exports) {
'use strict';

var $6Ddhl = parcelRequire("6Ddhl");
module.exports = $39b9c396e4f5f121$var$getDefinitionFactory;
var $39b9c396e4f5f121$var$own = {}.hasOwnProperty;
// Get a definition in `node` by `identifier`.
function $39b9c396e4f5f121$var$getDefinitionFactory(node, options) {
    return $39b9c396e4f5f121$var$getterFactory($39b9c396e4f5f121$var$gather(node, options));
}
// Gather all definitions in `node`
function $39b9c396e4f5f121$var$gather(node) {
    var cache = {};
    if (!node || !node.type) throw new Error('mdast-util-definitions expected node');
    $6Ddhl(node, 'definition', ondefinition);
    return cache;
    function ondefinition(definition) {
        var id = $39b9c396e4f5f121$var$normalise(definition.identifier);
        if (!$39b9c396e4f5f121$var$own.call(cache, id)) cache[id] = definition;
    }
}
// Factory to get a node from the given definition-cache.
function $39b9c396e4f5f121$var$getterFactory(cache) {
    return getter;
    // Get a node from the bound definition-cache.
    function getter(identifier) {
        var id = identifier && $39b9c396e4f5f121$var$normalise(identifier);
        return id && $39b9c396e4f5f121$var$own.call(cache, id) ? cache[id] : null;
    }
}
function $39b9c396e4f5f121$var$normalise(identifier) {
    return identifier.toUpperCase();
}

});

parcelRegister("kNiko", function(module, exports) {
'use strict';
module.exports = $f23699c9af1f57e6$var$one;

var $fin0W = parcelRequire("fin0W");

var $jAJpN = parcelRequire("jAJpN");
var $f23699c9af1f57e6$var$own = {}.hasOwnProperty;
// Transform an unknown node.
function $f23699c9af1f57e6$var$unknown(h, node) {
    if ($f23699c9af1f57e6$var$text(node)) return h.augment(node, $fin0W('text', node.value));
    return h(node, 'div', $jAJpN(h, node));
}
// Visit a node.
function $f23699c9af1f57e6$var$one(h, node, parent) {
    var type = node && node.type;
    var fn;
    // Fail on non-nodes.
    if (!type) throw new Error('Expected node, got `' + node + '`');
    if ($f23699c9af1f57e6$var$own.call(h.handlers, type)) fn = h.handlers[type];
    else if (h.passThrough && h.passThrough.indexOf(type) > -1) fn = $f23699c9af1f57e6$var$returnNode;
    else fn = h.unknownHandler;
    return (typeof fn === 'function' ? fn : $f23699c9af1f57e6$var$unknown)(h, node, parent);
}
// Check if the node should be renderered as a text node.
function $f23699c9af1f57e6$var$text(node) {
    var data = node.data || {};
    if ($f23699c9af1f57e6$var$own.call(data, 'hName') || $f23699c9af1f57e6$var$own.call(data, 'hProperties') || $f23699c9af1f57e6$var$own.call(data, 'hChildren')) return false;
    return 'value' in node;
}
function $f23699c9af1f57e6$var$returnNode(h, node) {
    var clone;
    if (node.children) {
        clone = Object.assign({}, node);
        clone.children = $jAJpN(h, node);
        return clone;
    }
    return node;
}

});
parcelRegister("jAJpN", function(module, exports) {
'use strict';
module.exports = $e4349b9a3da8e9ff$var$all;

var $kNiko = parcelRequire("kNiko");
function $e4349b9a3da8e9ff$var$all(h, parent) {
    var nodes = parent.children || [];
    var length = nodes.length;
    var values = [];
    var index = -1;
    var result;
    var head;
    while(++index < length){
        result = $kNiko(h, nodes[index], parent);
        if (result) {
            if (index && nodes[index - 1].type === 'break') {
                if (result.value) result.value = result.value.replace(/^\s+/, '');
                head = result.children && result.children[0];
                if (head && head.value) head.value = head.value.replace(/^\s+/, '');
            }
            values = values.concat(result);
        }
    }
    return values;
}

});


parcelRegister("8czcz", function(module, exports) {
'use strict';
module.exports = $5f8ac0136b7180f6$var$generateFootnotes;

var $kcTu8 = parcelRequire("kcTu8");

var $a5thq = parcelRequire("a5thq");

var $8qamS = parcelRequire("8qamS");
function $5f8ac0136b7180f6$var$generateFootnotes(h) {
    var footnoteById = h.footnoteById;
    var footnoteOrder = h.footnoteOrder;
    var length = footnoteOrder.length;
    var index = -1;
    var listItems = [];
    var def;
    var backReference;
    var content;
    var tail;
    while(++index < length){
        def = footnoteById[footnoteOrder[index].toUpperCase()];
        if (!def) continue;
        content = def.children.concat();
        tail = content[content.length - 1];
        backReference = {
            type: 'link',
            url: '#fnref-' + def.identifier,
            data: {
                hProperties: {
                    className: [
                        'footnote-backref'
                    ]
                }
            },
            children: [
                {
                    type: 'text',
                    value: "\u21A9"
                }
            ]
        };
        if (!tail || tail.type !== 'paragraph') {
            tail = {
                type: 'paragraph',
                children: []
            };
            content.push(tail);
        }
        tail.children.push(backReference);
        listItems.push({
            type: 'listItem',
            data: {
                hProperties: {
                    id: 'fn-' + def.identifier
                }
            },
            children: content,
            position: def.position
        });
    }
    if (listItems.length === 0) return null;
    return h(null, 'div', {
        className: [
            'footnotes'
        ]
    }, $8qamS([
        $kcTu8(h),
        $a5thq(h, {
            type: 'list',
            ordered: true,
            children: listItems
        })
    ], true));
}

});
parcelRegister("kcTu8", function(module, exports) {
'use strict';
module.exports = $eb5ff7d2182720ae$var$thematicBreak;
function $eb5ff7d2182720ae$var$thematicBreak(h, node) {
    return h(node, 'hr');
}

});

parcelRegister("a5thq", function(module, exports) {
'use strict';
module.exports = $7581156d9e04fe28$var$list;

var $8qamS = parcelRequire("8qamS");

var $jAJpN = parcelRequire("jAJpN");
function $7581156d9e04fe28$var$list(h, node) {
    var props = {};
    var name = node.ordered ? 'ol' : 'ul';
    var items;
    var index = -1;
    var length;
    if (typeof node.start === 'number' && node.start !== 1) props.start = node.start;
    items = $jAJpN(h, node);
    length = items.length;
    // Like GitHub, add a class for custom styling.
    while(++index < length)if (items[index].properties.className && items[index].properties.className.indexOf('task-list-item') !== -1) {
        props.className = [
            'contains-task-list'
        ];
        break;
    }
    return h(node, name, props, $8qamS(items, true));
}

});
parcelRegister("8qamS", function(module, exports) {
'use strict';
module.exports = $6218cb52cb4f8618$var$wrap;

var $fin0W = parcelRequire("fin0W");
// Wrap `nodes` with line feeds between each entry.
// Optionally adds line feeds at the start and end.
function $6218cb52cb4f8618$var$wrap(nodes, loose) {
    var result = [];
    var index = -1;
    var length = nodes.length;
    if (loose) result.push($fin0W('text', '\n'));
    while(++index < length){
        if (index) result.push($fin0W('text', '\n'));
        result.push(nodes[index]);
    }
    if (loose && nodes.length > 0) result.push($fin0W('text', '\n'));
    return result;
}

});



parcelRegister("jrsVt", function(module, exports) {
'use strict';






















module.exports = {
    blockquote: (parcelRequire("2Kxye")),
    break: (parcelRequire("hqf8h")),
    code: (parcelRequire("fBuEP")),
    delete: (parcelRequire("cYYad")),
    emphasis: (parcelRequire("gxUCZ")),
    footnoteReference: (parcelRequire("7OeGk")),
    footnote: (parcelRequire("gkLjh")),
    heading: (parcelRequire("dllxn")),
    html: (parcelRequire("l5gQr")),
    imageReference: (parcelRequire("fpi3s")),
    image: (parcelRequire("3KIDg")),
    inlineCode: (parcelRequire("aeo2b")),
    linkReference: (parcelRequire("8zv1d")),
    link: (parcelRequire("ehMPg")),
    listItem: (parcelRequire("kdjYT")),
    list: (parcelRequire("a5thq")),
    paragraph: (parcelRequire("2Pzhc")),
    root: (parcelRequire("3GExI")),
    strong: (parcelRequire("cbHYy")),
    table: (parcelRequire("cyYph")),
    text: (parcelRequire("4lwD0")),
    thematicBreak: (parcelRequire("kcTu8")),
    toml: $e276fa0624fad11d$var$ignore,
    yaml: $e276fa0624fad11d$var$ignore,
    definition: $e276fa0624fad11d$var$ignore,
    footnoteDefinition: $e276fa0624fad11d$var$ignore
};
// Return nothing for nodes that are ignored.
function $e276fa0624fad11d$var$ignore() {
    return null;
}

});
parcelRegister("2Kxye", function(module, exports) {
'use strict';
module.exports = $2009e735e4920922$var$blockquote;

var $8qamS = parcelRequire("8qamS");

var $jAJpN = parcelRequire("jAJpN");
function $2009e735e4920922$var$blockquote(h, node) {
    return h(node, 'blockquote', $8qamS($jAJpN(h, node), true));
}

});

parcelRegister("hqf8h", function(module, exports) {
'use strict';
module.exports = $caf09a68931aae43$var$hardBreak;

var $fin0W = parcelRequire("fin0W");
function $caf09a68931aae43$var$hardBreak(h, node) {
    return [
        h(node, 'br'),
        $fin0W('text', '\n')
    ];
}

});

parcelRegister("fBuEP", function(module, exports) {
'use strict';
module.exports = $b5c217a518855008$var$code;

var $fin0W = parcelRequire("fin0W");
function $b5c217a518855008$var$code(h, node) {
    var value = node.value ? node.value + '\n' : '';
    // To do: next major, use `node.lang` w/o regex, the splitting’s been going
    // on for years in remark now.
    var lang = node.lang && node.lang.match(/^[^ \t]+(?=[ \t]|$)/);
    var props = {};
    var code;
    if (lang) props.className = [
        'language-' + lang
    ];
    code = h(node, 'code', props, [
        $fin0W('text', value)
    ]);
    if (node.meta) code.data = {
        meta: node.meta
    };
    return h(node.position, 'pre', [
        code
    ]);
}

});

parcelRegister("cYYad", function(module, exports) {
'use strict';
module.exports = $9739c1e1cf800b5e$var$strikethrough;

var $jAJpN = parcelRequire("jAJpN");
function $9739c1e1cf800b5e$var$strikethrough(h, node) {
    return h(node, 'del', $jAJpN(h, node));
}

});

parcelRegister("gxUCZ", function(module, exports) {
'use strict';
module.exports = $c0bba787c55d4212$var$emphasis;

var $jAJpN = parcelRequire("jAJpN");
function $c0bba787c55d4212$var$emphasis(h, node) {
    return h(node, 'em', $jAJpN(h, node));
}

});

parcelRegister("7OeGk", function(module, exports) {
'use strict';
module.exports = $5af8976c830555c1$var$footnoteReference;

var $fin0W = parcelRequire("fin0W");
function $5af8976c830555c1$var$footnoteReference(h, node) {
    var footnoteOrder = h.footnoteOrder;
    var identifier = String(node.identifier);
    if (footnoteOrder.indexOf(identifier) === -1) footnoteOrder.push(identifier);
    return h(node.position, 'sup', {
        id: 'fnref-' + identifier
    }, [
        h(node, 'a', {
            href: '#fn-' + identifier,
            className: [
                'footnote-ref'
            ]
        }, [
            $fin0W('text', node.label || identifier)
        ])
    ]);
}

});

parcelRegister("gkLjh", function(module, exports) {
'use strict';
module.exports = $be43365ab98ed9af$var$footnote;

var $7OeGk = parcelRequire("7OeGk");
function $be43365ab98ed9af$var$footnote(h, node) {
    var footnoteById = h.footnoteById;
    var footnoteOrder = h.footnoteOrder;
    var identifier = 1;
    while(identifier in footnoteById)identifier++;
    identifier = String(identifier);
    // No need to check if `identifier` exists in `footnoteOrder`, it’s guaranteed
    // to not exist because we just generated it.
    footnoteOrder.push(identifier);
    footnoteById[identifier] = {
        type: 'footnoteDefinition',
        identifier: identifier,
        children: [
            {
                type: 'paragraph',
                children: node.children
            }
        ],
        position: node.position
    };
    return $7OeGk(h, {
        type: 'footnoteReference',
        identifier: identifier,
        position: node.position
    });
}

});

parcelRegister("dllxn", function(module, exports) {
'use strict';
module.exports = $9b6df163a26bd000$var$heading;

var $jAJpN = parcelRequire("jAJpN");
function $9b6df163a26bd000$var$heading(h, node) {
    return h(node, 'h' + node.depth, $jAJpN(h, node));
}

});

parcelRegister("l5gQr", function(module, exports) {
'use strict';
module.exports = $f59721a0d8aa9c1f$var$html;

var $fin0W = parcelRequire("fin0W");
// Return either a `raw` node in dangerous mode, otherwise nothing.
function $f59721a0d8aa9c1f$var$html(h, node) {
    return h.dangerous ? h.augment(node, $fin0W('raw', node.value)) : null;
}

});

parcelRegister("fpi3s", function(module, exports) {
'use strict';
module.exports = $b377321b20712ea8$var$imageReference;

var $9W5Jt = parcelRequire("9W5Jt");

var $eVQ45 = parcelRequire("eVQ45");
function $b377321b20712ea8$var$imageReference(h, node) {
    var def = h.definition(node.identifier);
    var props;
    if (!def) return $eVQ45(h, node);
    props = {
        src: $9W5Jt(def.url || ''),
        alt: node.alt
    };
    if (def.title !== null && def.title !== undefined) props.title = def.title;
    return h(node, 'img', props);
}

});
parcelRegister("9W5Jt", function(module, exports) {
'use strict';
var $73bdfa2ac30cca42$var$encodeCache = {};
// Create a lookup array where anything but characters in `chars` string
// and alphanumeric chars is percent-encoded.
//
function $73bdfa2ac30cca42$var$getEncodeCache(exclude) {
    var i, ch, cache = $73bdfa2ac30cca42$var$encodeCache[exclude];
    if (cache) return cache;
    cache = $73bdfa2ac30cca42$var$encodeCache[exclude] = [];
    for(i = 0; i < 128; i++){
        ch = String.fromCharCode(i);
        if (/^[0-9a-z]$/i.test(ch)) // always allow unencoded alphanumeric characters
        cache.push(ch);
        else cache.push('%' + ('0' + i.toString(16).toUpperCase()).slice(-2));
    }
    for(i = 0; i < exclude.length; i++)cache[exclude.charCodeAt(i)] = exclude[i];
    return cache;
}
// Encode unsafe characters with percent-encoding, skipping already
// encoded sequences.
//
//  - string       - string to encode
//  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
//  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
//
function $73bdfa2ac30cca42$var$encode(string, exclude, keepEscaped) {
    var i, l, code, nextCode, cache, result = '';
    if (typeof exclude !== 'string') {
        // encode(string, keepEscaped)
        keepEscaped = exclude;
        exclude = $73bdfa2ac30cca42$var$encode.defaultChars;
    }
    if (typeof keepEscaped === 'undefined') keepEscaped = true;
    cache = $73bdfa2ac30cca42$var$getEncodeCache(exclude);
    for(i = 0, l = string.length; i < l; i++){
        code = string.charCodeAt(i);
        if (keepEscaped && code === 0x25 /* % */  && i + 2 < l) {
            if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
                result += string.slice(i, i + 3);
                i += 2;
                continue;
            }
        }
        if (code < 128) {
            result += cache[code];
            continue;
        }
        if (code >= 0xD800 && code <= 0xDFFF) {
            if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
                nextCode = string.charCodeAt(i + 1);
                if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
                    result += encodeURIComponent(string[i] + string[i + 1]);
                    i++;
                    continue;
                }
            }
            result += '%EF%BF%BD';
            continue;
        }
        result += encodeURIComponent(string[i]);
    }
    return result;
}
$73bdfa2ac30cca42$var$encode.defaultChars = ";/?:@&=+$,-_.!~*'()#";
$73bdfa2ac30cca42$var$encode.componentChars = "-_.!~*'()";
module.exports = $73bdfa2ac30cca42$var$encode;

});

parcelRegister("eVQ45", function(module, exports) {
'use strict';
module.exports = $adeec68f555ea12e$var$revert;

var $fin0W = parcelRequire("fin0W");

var $jAJpN = parcelRequire("jAJpN");
// Return the content of a reference without definition as Markdown.
function $adeec68f555ea12e$var$revert(h, node) {
    var subtype = node.referenceType;
    var suffix = ']';
    var contents;
    var head;
    var tail;
    if (subtype === 'collapsed') suffix += '[]';
    else if (subtype === 'full') suffix += '[' + (node.label || node.identifier) + ']';
    if (node.type === 'imageReference') return $fin0W('text', '![' + node.alt + suffix);
    contents = $jAJpN(h, node);
    head = contents[0];
    if (head && head.type === 'text') head.value = '[' + head.value;
    else contents.unshift($fin0W('text', '['));
    tail = contents[contents.length - 1];
    if (tail && tail.type === 'text') tail.value += suffix;
    else contents.push($fin0W('text', suffix));
    return contents;
}

});


parcelRegister("3KIDg", function(module, exports) {
'use strict';

var $9W5Jt = parcelRequire("9W5Jt");
module.exports = $2bb84a02d2957974$var$image;
function $2bb84a02d2957974$var$image(h, node) {
    var props = {
        src: $9W5Jt(node.url),
        alt: node.alt
    };
    if (node.title !== null && node.title !== undefined) props.title = node.title;
    return h(node, 'img', props);
}

});

parcelRegister("aeo2b", function(module, exports) {
'use strict';
module.exports = $772ddadd8e054087$var$inlineCode;

var $fin0W = parcelRequire("fin0W");
function $772ddadd8e054087$var$inlineCode(h, node) {
    var value = node.value.replace(/\r?\n|\r/g, ' ');
    return h(node, 'code', [
        $fin0W('text', value)
    ]);
}

});

parcelRegister("8zv1d", function(module, exports) {
'use strict';
module.exports = $63d9a7473ae80c48$var$linkReference;

var $9W5Jt = parcelRequire("9W5Jt");

var $eVQ45 = parcelRequire("eVQ45");

var $jAJpN = parcelRequire("jAJpN");
function $63d9a7473ae80c48$var$linkReference(h, node) {
    var def = h.definition(node.identifier);
    var props;
    if (!def) return $eVQ45(h, node);
    props = {
        href: $9W5Jt(def.url || '')
    };
    if (def.title !== null && def.title !== undefined) props.title = def.title;
    return h(node, 'a', props, $jAJpN(h, node));
}

});

parcelRegister("ehMPg", function(module, exports) {
'use strict';

var $9W5Jt = parcelRequire("9W5Jt");

var $jAJpN = parcelRequire("jAJpN");
module.exports = $a668870950e44a11$var$link;
function $a668870950e44a11$var$link(h, node) {
    var props = {
        href: $9W5Jt(node.url)
    };
    if (node.title !== null && node.title !== undefined) props.title = node.title;
    return h(node, 'a', props, $jAJpN(h, node));
}

});

parcelRegister("kdjYT", function(module, exports) {
'use strict';
module.exports = $eb748566f942a1fa$var$listItem;

var $fin0W = parcelRequire("fin0W");

var $jAJpN = parcelRequire("jAJpN");
function $eb748566f942a1fa$var$listItem(h, node, parent) {
    var result = $jAJpN(h, node);
    var head = result[0];
    var loose = parent ? $eb748566f942a1fa$var$listLoose(parent) : $eb748566f942a1fa$var$listItemLoose(node);
    var props = {};
    var wrapped = [];
    var length;
    var index;
    var child;
    if (typeof node.checked === 'boolean') {
        if (!head || head.tagName !== 'p') {
            head = h(null, 'p', []);
            result.unshift(head);
        }
        if (head.children.length > 0) head.children.unshift($fin0W('text', ' '));
        head.children.unshift(h(null, 'input', {
            type: 'checkbox',
            checked: node.checked,
            disabled: true
        }));
        // According to github-markdown-css, this class hides bullet.
        // See: <https://github.com/sindresorhus/github-markdown-css>.
        props.className = [
            'task-list-item'
        ];
    }
    length = result.length;
    index = -1;
    while(++index < length){
        child = result[index];
        // Add eols before nodes, except if this is a loose, first paragraph.
        if (loose || index !== 0 || child.tagName !== 'p') wrapped.push($fin0W('text', '\n'));
        if (child.tagName === 'p' && !loose) wrapped = wrapped.concat(child.children);
        else wrapped.push(child);
    }
    // Add a final eol.
    if (length && (loose || child.tagName !== 'p')) wrapped.push($fin0W('text', '\n'));
    return h(node, 'li', props, wrapped);
}
function $eb748566f942a1fa$var$listLoose(node) {
    var loose = node.spread;
    var children = node.children;
    var length = children.length;
    var index = -1;
    while(!loose && ++index < length)loose = $eb748566f942a1fa$var$listItemLoose(children[index]);
    return loose;
}
function $eb748566f942a1fa$var$listItemLoose(node) {
    var spread = node.spread;
    return spread === undefined || spread === null ? node.children.length > 1 : spread;
}

});

parcelRegister("2Pzhc", function(module, exports) {
'use strict';
module.exports = $20fbb56018958335$var$paragraph;

var $jAJpN = parcelRequire("jAJpN");
function $20fbb56018958335$var$paragraph(h, node) {
    return h(node, 'p', $jAJpN(h, node));
}

});

parcelRegister("3GExI", function(module, exports) {
'use strict';
module.exports = $2af4be4c3af73f2b$var$root;

var $fin0W = parcelRequire("fin0W");

var $8qamS = parcelRequire("8qamS");

var $jAJpN = parcelRequire("jAJpN");
function $2af4be4c3af73f2b$var$root(h, node) {
    return h.augment(node, $fin0W('root', $8qamS($jAJpN(h, node))));
}

});

parcelRegister("cbHYy", function(module, exports) {
'use strict';
module.exports = $8df89fc7fe3cfe9c$var$strong;

var $jAJpN = parcelRequire("jAJpN");
function $8df89fc7fe3cfe9c$var$strong(h, node) {
    return h(node, 'strong', $jAJpN(h, node));
}

});

parcelRegister("cyYph", function(module, exports) {
'use strict';
module.exports = $9257848335846de3$var$table;

var $lPHor = parcelRequire("lPHor");

var $8qamS = parcelRequire("8qamS");

var $jAJpN = parcelRequire("jAJpN");
function $9257848335846de3$var$table(h, node) {
    var rows = node.children;
    var index = rows.length;
    var align = node.align || [];
    var alignLength = align.length;
    var result = [];
    var pos;
    var row;
    var out;
    var name;
    var cell;
    while(index--){
        row = rows[index].children;
        name = index === 0 ? 'th' : 'td';
        pos = alignLength || row.length;
        out = [];
        while(pos--){
            cell = row[pos];
            out[pos] = h(cell, name, {
                align: align[pos]
            }, cell ? $jAJpN(h, cell) : []);
        }
        result[index] = h(rows[index], 'tr', $8qamS(out, true));
    }
    return h(node, 'table', $8qamS([
        h(result[0].position, 'thead', $8qamS([
            result[0]
        ], true))
    ].concat(result[1] ? h({
        start: $lPHor.start(result[1]),
        end: $lPHor.end(result[result.length - 1])
    }, 'tbody', $8qamS(result.slice(1), true)) : []), true));
}

});

parcelRegister("4lwD0", function(module, exports) {
'use strict';
module.exports = $32a26ed6da9265ed$var$text;

var $fin0W = parcelRequire("fin0W");
function $32a26ed6da9265ed$var$text(h, node) {
    return h.augment(node, $fin0W('text', String(node.value).replace(/[ \t]*(\r?\n|\r)[ \t]*/g, '$1')));
}

});



parcelRegister("iDep4", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $7KQqJ = parcelRequire("7KQqJ");
function $d9070abd96403449$var$emptyFunction() {}
function $d9070abd96403449$var$emptyFunctionWithReset() {}
$d9070abd96403449$var$emptyFunctionWithReset.resetWarningCache = $d9070abd96403449$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $7KQqJ) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $d9070abd96403449$var$emptyFunctionWithReset,
        resetWarningCache: $d9070abd96403449$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("7KQqJ", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $5a557fcd99e4c0a9$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $5a557fcd99e4c0a9$var$ReactPropTypesSecret;

});


parcelRegister("8TZ45", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $67b2d4006f55ffba$export$a7c73072b1a182ae; }, function (v) { return $67b2d4006f55ffba$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $67b2d4006f55ffba$export$9f27bc3417b4524d; }, function (v) { return $67b2d4006f55ffba$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $67b2d4006f55ffba$export$db77ccec0bb4ccac; }, function (v) { return $67b2d4006f55ffba$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $67b2d4006f55ffba$export$8392c0c9d3dcbd35; }, function (v) { return $67b2d4006f55ffba$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $67b2d4006f55ffba$export$ffb0004e005737fa; }, function (v) { return $67b2d4006f55ffba$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $67b2d4006f55ffba$export$b624eff549462981; }, function (v) { return $67b2d4006f55ffba$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $67b2d4006f55ffba$export$7897aa7841a5380c; }, function (v) { return $67b2d4006f55ffba$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $67b2d4006f55ffba$export$602eac185826482c; }, function (v) { return $67b2d4006f55ffba$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $67b2d4006f55ffba$export$e2c29f18771995cb; }, function (v) { return $67b2d4006f55ffba$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $67b2d4006f55ffba$export$5f8d39834fd61797; }, function (v) { return $67b2d4006f55ffba$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $67b2d4006f55ffba$export$74bf444e3cd11ea5; }, function (v) { return $67b2d4006f55ffba$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $67b2d4006f55ffba$export$92387174baf9b227; }, function (v) { return $67b2d4006f55ffba$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $67b2d4006f55ffba$export$ec112efeb987d9c6; }, function (v) { return $67b2d4006f55ffba$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $67b2d4006f55ffba$export$b706b080d889d2c9; }, function (v) { return $67b2d4006f55ffba$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $67b2d4006f55ffba$export$5be5a87408f70ddc; }, function (v) { return $67b2d4006f55ffba$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $67b2d4006f55ffba$export$45a5e7f76e0caa8d; }, function (v) { return $67b2d4006f55ffba$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $67b2d4006f55ffba$export$455c2e768291efa6; }, function (v) { return $67b2d4006f55ffba$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $67b2d4006f55ffba$export$9522e17588c12572; }, function (v) { return $67b2d4006f55ffba$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $67b2d4006f55ffba$export$2110ac352bb060b9; }, function (v) { return $67b2d4006f55ffba$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $67b2d4006f55ffba$export$56885ab8b9c456ab; }, function (v) { return $67b2d4006f55ffba$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $67b2d4006f55ffba$export$d927fcb6adf8f9de; }, function (v) { return $67b2d4006f55ffba$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $67b2d4006f55ffba$export$b82d16f27459e05a; }, function (v) { return $67b2d4006f55ffba$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $67b2d4006f55ffba$export$522c17b4f5e123e8; }, function (v) { return $67b2d4006f55ffba$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $67b2d4006f55ffba$export$1aabd8a0274ecfd6; }, function (v) { return $67b2d4006f55ffba$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $67b2d4006f55ffba$export$9b621391a187a31a; }, function (v) { return $67b2d4006f55ffba$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $67b2d4006f55ffba$export$f5bbd400c2f4426f; }, function (v) { return $67b2d4006f55ffba$export$f5bbd400c2f4426f = v; });
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $67b2d4006f55ffba$export$a7c73072b1a182ae;
var $67b2d4006f55ffba$export$9f27bc3417b4524d;
var $67b2d4006f55ffba$export$db77ccec0bb4ccac;
var $67b2d4006f55ffba$export$8392c0c9d3dcbd35;
var $67b2d4006f55ffba$export$ffb0004e005737fa;
var $67b2d4006f55ffba$export$b624eff549462981;
var $67b2d4006f55ffba$export$7897aa7841a5380c;
var $67b2d4006f55ffba$export$602eac185826482c;
var $67b2d4006f55ffba$export$e2c29f18771995cb;
var $67b2d4006f55ffba$export$5f8d39834fd61797;
var $67b2d4006f55ffba$export$74bf444e3cd11ea5;
var $67b2d4006f55ffba$export$92387174baf9b227;
var $67b2d4006f55ffba$export$ec112efeb987d9c6;
var $67b2d4006f55ffba$export$b706b080d889d2c9;
var $67b2d4006f55ffba$export$5be5a87408f70ddc;
var $67b2d4006f55ffba$export$45a5e7f76e0caa8d;
var $67b2d4006f55ffba$export$455c2e768291efa6;
var $67b2d4006f55ffba$export$9522e17588c12572;
var $67b2d4006f55ffba$export$2110ac352bb060b9;
var $67b2d4006f55ffba$export$56885ab8b9c456ab;
var $67b2d4006f55ffba$export$d927fcb6adf8f9de;
var $67b2d4006f55ffba$export$b82d16f27459e05a;
var $67b2d4006f55ffba$export$522c17b4f5e123e8;
var $67b2d4006f55ffba$export$1aabd8a0274ecfd6;
var $67b2d4006f55ffba$export$9b621391a187a31a;
var $67b2d4006f55ffba$export$f5bbd400c2f4426f;
'use strict';
var $67b2d4006f55ffba$var$b = 60103, $67b2d4006f55ffba$var$c = 60106, $67b2d4006f55ffba$var$d = 60107, $67b2d4006f55ffba$var$e = 60108, $67b2d4006f55ffba$var$f = 60114, $67b2d4006f55ffba$var$g = 60109, $67b2d4006f55ffba$var$h = 60110, $67b2d4006f55ffba$var$k = 60112, $67b2d4006f55ffba$var$l = 60113, $67b2d4006f55ffba$var$m = 60120, $67b2d4006f55ffba$var$n = 60115, $67b2d4006f55ffba$var$p = 60116, $67b2d4006f55ffba$var$q = 60121, $67b2d4006f55ffba$var$r = 60122, $67b2d4006f55ffba$var$u = 60117, $67b2d4006f55ffba$var$v = 60129, $67b2d4006f55ffba$var$w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $67b2d4006f55ffba$var$x = Symbol.for;
    $67b2d4006f55ffba$var$b = $67b2d4006f55ffba$var$x("react.element");
    $67b2d4006f55ffba$var$c = $67b2d4006f55ffba$var$x("react.portal");
    $67b2d4006f55ffba$var$d = $67b2d4006f55ffba$var$x("react.fragment");
    $67b2d4006f55ffba$var$e = $67b2d4006f55ffba$var$x("react.strict_mode");
    $67b2d4006f55ffba$var$f = $67b2d4006f55ffba$var$x("react.profiler");
    $67b2d4006f55ffba$var$g = $67b2d4006f55ffba$var$x("react.provider");
    $67b2d4006f55ffba$var$h = $67b2d4006f55ffba$var$x("react.context");
    $67b2d4006f55ffba$var$k = $67b2d4006f55ffba$var$x("react.forward_ref");
    $67b2d4006f55ffba$var$l = $67b2d4006f55ffba$var$x("react.suspense");
    $67b2d4006f55ffba$var$m = $67b2d4006f55ffba$var$x("react.suspense_list");
    $67b2d4006f55ffba$var$n = $67b2d4006f55ffba$var$x("react.memo");
    $67b2d4006f55ffba$var$p = $67b2d4006f55ffba$var$x("react.lazy");
    $67b2d4006f55ffba$var$q = $67b2d4006f55ffba$var$x("react.block");
    $67b2d4006f55ffba$var$r = $67b2d4006f55ffba$var$x("react.server.block");
    $67b2d4006f55ffba$var$u = $67b2d4006f55ffba$var$x("react.fundamental");
    $67b2d4006f55ffba$var$v = $67b2d4006f55ffba$var$x("react.debug_trace_mode");
    $67b2d4006f55ffba$var$w = $67b2d4006f55ffba$var$x("react.legacy_hidden");
}
function $67b2d4006f55ffba$var$y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case $67b2d4006f55ffba$var$b:
                switch(a = a.type, a){
                    case $67b2d4006f55ffba$var$d:
                    case $67b2d4006f55ffba$var$f:
                    case $67b2d4006f55ffba$var$e:
                    case $67b2d4006f55ffba$var$l:
                    case $67b2d4006f55ffba$var$m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $67b2d4006f55ffba$var$h:
                            case $67b2d4006f55ffba$var$k:
                            case $67b2d4006f55ffba$var$p:
                            case $67b2d4006f55ffba$var$n:
                            case $67b2d4006f55ffba$var$g:
                                return a;
                            default:
                                return t;
                        }
                }
            case $67b2d4006f55ffba$var$c:
                return t;
        }
    }
}
var $67b2d4006f55ffba$var$z = $67b2d4006f55ffba$var$g, $67b2d4006f55ffba$var$A = $67b2d4006f55ffba$var$b, $67b2d4006f55ffba$var$B = $67b2d4006f55ffba$var$k, $67b2d4006f55ffba$var$C = $67b2d4006f55ffba$var$d, $67b2d4006f55ffba$var$D = $67b2d4006f55ffba$var$p, $67b2d4006f55ffba$var$E = $67b2d4006f55ffba$var$n, $67b2d4006f55ffba$var$F = $67b2d4006f55ffba$var$c, $67b2d4006f55ffba$var$G = $67b2d4006f55ffba$var$f, $67b2d4006f55ffba$var$H = $67b2d4006f55ffba$var$e, $67b2d4006f55ffba$var$I = $67b2d4006f55ffba$var$l;
$67b2d4006f55ffba$export$a7c73072b1a182ae = $67b2d4006f55ffba$var$h;
$67b2d4006f55ffba$export$9f27bc3417b4524d = $67b2d4006f55ffba$var$z;
$67b2d4006f55ffba$export$db77ccec0bb4ccac = $67b2d4006f55ffba$var$A;
$67b2d4006f55ffba$export$8392c0c9d3dcbd35 = $67b2d4006f55ffba$var$B;
$67b2d4006f55ffba$export$ffb0004e005737fa = $67b2d4006f55ffba$var$C;
$67b2d4006f55ffba$export$b624eff549462981 = $67b2d4006f55ffba$var$D;
$67b2d4006f55ffba$export$7897aa7841a5380c = $67b2d4006f55ffba$var$E;
$67b2d4006f55ffba$export$602eac185826482c = $67b2d4006f55ffba$var$F;
$67b2d4006f55ffba$export$e2c29f18771995cb = $67b2d4006f55ffba$var$G;
$67b2d4006f55ffba$export$5f8d39834fd61797 = $67b2d4006f55ffba$var$H;
$67b2d4006f55ffba$export$74bf444e3cd11ea5 = $67b2d4006f55ffba$var$I;
$67b2d4006f55ffba$export$92387174baf9b227 = function() {
    return !1;
};
$67b2d4006f55ffba$export$ec112efeb987d9c6 = function() {
    return !1;
};
$67b2d4006f55ffba$export$b706b080d889d2c9 = function(a) {
    return $67b2d4006f55ffba$var$y(a) === $67b2d4006f55ffba$var$h;
};
$67b2d4006f55ffba$export$5be5a87408f70ddc = function(a) {
    return $67b2d4006f55ffba$var$y(a) === $67b2d4006f55ffba$var$g;
};
$67b2d4006f55ffba$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $67b2d4006f55ffba$var$b;
};
$67b2d4006f55ffba$export$455c2e768291efa6 = function(a) {
    return $67b2d4006f55ffba$var$y(a) === $67b2d4006f55ffba$var$k;
};
$67b2d4006f55ffba$export$9522e17588c12572 = function(a) {
    return $67b2d4006f55ffba$var$y(a) === $67b2d4006f55ffba$var$d;
};
$67b2d4006f55ffba$export$2110ac352bb060b9 = function(a) {
    return $67b2d4006f55ffba$var$y(a) === $67b2d4006f55ffba$var$p;
};
$67b2d4006f55ffba$export$56885ab8b9c456ab = function(a) {
    return $67b2d4006f55ffba$var$y(a) === $67b2d4006f55ffba$var$n;
};
$67b2d4006f55ffba$export$d927fcb6adf8f9de = function(a) {
    return $67b2d4006f55ffba$var$y(a) === $67b2d4006f55ffba$var$c;
};
$67b2d4006f55ffba$export$b82d16f27459e05a = function(a) {
    return $67b2d4006f55ffba$var$y(a) === $67b2d4006f55ffba$var$f;
};
$67b2d4006f55ffba$export$522c17b4f5e123e8 = function(a) {
    return $67b2d4006f55ffba$var$y(a) === $67b2d4006f55ffba$var$e;
};
$67b2d4006f55ffba$export$1aabd8a0274ecfd6 = function(a) {
    return $67b2d4006f55ffba$var$y(a) === $67b2d4006f55ffba$var$l;
};
$67b2d4006f55ffba$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $67b2d4006f55ffba$var$d || a === $67b2d4006f55ffba$var$f || a === $67b2d4006f55ffba$var$v || a === $67b2d4006f55ffba$var$e || a === $67b2d4006f55ffba$var$l || a === $67b2d4006f55ffba$var$m || a === $67b2d4006f55ffba$var$w || "object" === typeof a && null !== a && (a.$$typeof === $67b2d4006f55ffba$var$p || a.$$typeof === $67b2d4006f55ffba$var$n || a.$$typeof === $67b2d4006f55ffba$var$g || a.$$typeof === $67b2d4006f55ffba$var$h || a.$$typeof === $67b2d4006f55ffba$var$k || a.$$typeof === $67b2d4006f55ffba$var$u || a.$$typeof === $67b2d4006f55ffba$var$q || a[0] === $67b2d4006f55ffba$var$r) ? !0 : !1;
};
$67b2d4006f55ffba$export$f5bbd400c2f4426f = $67b2d4006f55ffba$var$y;

});

var $824c049f32d4395d$exports = {};
'use strict';

$824c049f32d4395d$exports = (parcelRequire("2nzLi"));



var $7fPBF = parcelRequire("7fPBF");
var $b4ba1c853f6e1116$exports = {};
'use strict';
function $b4ba1c853f6e1116$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($b4ba1c853f6e1116$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$b4ba1c853f6e1116$var$checkDCE();

$b4ba1c853f6e1116$exports = (parcelRequire("6EA3T"));




var $7fPBF = parcelRequire("7fPBF");
/**
 * React Router v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $7fPBF = parcelRequire("7fPBF");
/**
 * @remix-run/router v1.23.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $55100129ab36ed65$var$_extends() {
    $55100129ab36ed65$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $55100129ab36ed65$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $55100129ab36ed65$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($55100129ab36ed65$export$e19cd5f9376f8cee || ($55100129ab36ed65$export$e19cd5f9376f8cee = {}));
const $55100129ab36ed65$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $55100129ab36ed65$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $55100129ab36ed65$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $55100129ab36ed65$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $55100129ab36ed65$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $55100129ab36ed65$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $55100129ab36ed65$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $55100129ab36ed65$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $55100129ab36ed65$export$fe53371bee54353d(to);
    }
    return $55100129ab36ed65$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $55100129ab36ed65$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $55100129ab36ed65$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $55100129ab36ed65$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $55100129ab36ed65$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $55100129ab36ed65$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $55100129ab36ed65$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $55100129ab36ed65$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $55100129ab36ed65$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $55100129ab36ed65$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $55100129ab36ed65$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $55100129ab36ed65$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $55100129ab36ed65$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $55100129ab36ed65$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $55100129ab36ed65$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $55100129ab36ed65$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $55100129ab36ed65$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($55100129ab36ed65$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
        let location = $55100129ab36ed65$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $55100129ab36ed65$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $55100129ab36ed65$export$e19cd5f9376f8cee.Replace;
        let location = $55100129ab36ed65$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $55100129ab36ed65$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $55100129ab36ed65$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $55100129ab36ed65$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($55100129ab36ed65$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($55100129ab36ed65$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $55100129ab36ed65$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($55100129ab36ed65$var$ResultType || ($55100129ab36ed65$var$ResultType = {}));
const $55100129ab36ed65$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $55100129ab36ed65$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $55100129ab36ed65$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $55100129ab36ed65$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $55100129ab36ed65$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($55100129ab36ed65$var$isIndexRoute(route)) {
            let indexRoute = $55100129ab36ed65$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $55100129ab36ed65$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $55100129ab36ed65$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $55100129ab36ed65$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $55100129ab36ed65$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $55100129ab36ed65$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $55100129ab36ed65$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $55100129ab36ed65$var$flattenRoutes(routes);
    $55100129ab36ed65$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $55100129ab36ed65$export$30d21fd6d7295f52(pathname);
        matches = $55100129ab36ed65$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $55100129ab36ed65$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $55100129ab36ed65$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $55100129ab36ed65$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $55100129ab36ed65$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $55100129ab36ed65$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $55100129ab36ed65$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $55100129ab36ed65$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $55100129ab36ed65$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $55100129ab36ed65$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $55100129ab36ed65$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $55100129ab36ed65$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $55100129ab36ed65$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $55100129ab36ed65$var$paramRe = /^:[\w-]+$/;
const $55100129ab36ed65$var$dynamicSegmentValue = 3;
const $55100129ab36ed65$var$indexRouteValue = 2;
const $55100129ab36ed65$var$emptySegmentValue = 1;
const $55100129ab36ed65$var$staticSegmentValue = 10;
const $55100129ab36ed65$var$splatPenalty = -2;
const $55100129ab36ed65$var$isSplat = (s)=>s === "*";
function $55100129ab36ed65$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($55100129ab36ed65$var$isSplat)) initialScore += $55100129ab36ed65$var$splatPenalty;
    if (index) initialScore += $55100129ab36ed65$var$indexRouteValue;
    return segments.filter((s)=>!$55100129ab36ed65$var$isSplat(s)).reduce((score, segment)=>score + ($55100129ab36ed65$var$paramRe.test(segment) ? $55100129ab36ed65$var$dynamicSegmentValue : segment === "" ? $55100129ab36ed65$var$emptySegmentValue : $55100129ab36ed65$var$staticSegmentValue), initialScore);
}
function $55100129ab36ed65$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $55100129ab36ed65$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $55100129ab36ed65$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $55100129ab36ed65$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $55100129ab36ed65$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $55100129ab36ed65$export$a5c6d149b50c1d86($55100129ab36ed65$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $55100129ab36ed65$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $55100129ab36ed65$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $55100129ab36ed65$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $55100129ab36ed65$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $55100129ab36ed65$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $55100129ab36ed65$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $55100129ab36ed65$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $55100129ab36ed65$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $55100129ab36ed65$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $55100129ab36ed65$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $55100129ab36ed65$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
const $55100129ab36ed65$var$ABSOLUTE_URL_REGEX$1 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $55100129ab36ed65$var$isAbsoluteUrl = (url)=>$55100129ab36ed65$var$ABSOLUTE_URL_REGEX$1.test(url);
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $55100129ab36ed65$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        if ($55100129ab36ed65$var$isAbsoluteUrl(toPathname)) pathname = toPathname;
        else {
            if (toPathname.includes("//")) {
                let oldPathname = toPathname;
                toPathname = toPathname.replace(/\/\/+/g, "/");
                $55100129ab36ed65$export$c0e02632e14916fd(false, "Pathnames cannot have embedded double slashes - normalizing " + (oldPathname + " -> " + toPathname));
            }
            if (toPathname.startsWith("/")) pathname = $55100129ab36ed65$var$resolvePathname(toPathname.substring(1), "/");
            else pathname = $55100129ab36ed65$var$resolvePathname(toPathname, fromPathname);
        }
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $55100129ab36ed65$var$normalizeSearch(search),
        hash: $55100129ab36ed65$var$normalizeHash(hash)
    };
}
function $55100129ab36ed65$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $55100129ab36ed65$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $55100129ab36ed65$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $55100129ab36ed65$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $55100129ab36ed65$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $55100129ab36ed65$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $55100129ab36ed65$export$8ccf933b0513f8d0(toArg);
    else {
        to = $55100129ab36ed65$var$_extends({}, toArg);
        $55100129ab36ed65$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $55100129ab36ed65$var$getInvalidPathError("?", "pathname", "search", to));
        $55100129ab36ed65$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $55100129ab36ed65$var$getInvalidPathError("#", "pathname", "hash", to));
        $55100129ab36ed65$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $55100129ab36ed65$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $55100129ab36ed65$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $55100129ab36ed65$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $55100129ab36ed65$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $55100129ab36ed65$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $55100129ab36ed65$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $55100129ab36ed65$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $55100129ab36ed65$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $55100129ab36ed65$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $55100129ab36ed65$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $55100129ab36ed65$export$4051a07651545597(data, init) {
    return new $55100129ab36ed65$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $55100129ab36ed65$export$42a99a7a4bc0e76a extends Error {
}
class $55100129ab36ed65$export$61d759255b4eec65 {
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $55100129ab36ed65$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $55100129ab36ed65$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $55100129ab36ed65$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $55100129ab36ed65$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $55100129ab36ed65$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
}
function $55100129ab36ed65$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $55100129ab36ed65$var$unwrapTrackedPromise(value) {
    if (!$55100129ab36ed65$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $55100129ab36ed65$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $55100129ab36ed65$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $55100129ab36ed65$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $55100129ab36ed65$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $55100129ab36ed65$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $55100129ab36ed65$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $55100129ab36ed65$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $55100129ab36ed65$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $55100129ab36ed65$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $55100129ab36ed65$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $55100129ab36ed65$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $55100129ab36ed65$var$validMutationMethods = new Set($55100129ab36ed65$var$validMutationMethodsArr);
const $55100129ab36ed65$var$validRequestMethodsArr = [
    "get",
    ...$55100129ab36ed65$var$validMutationMethodsArr
];
const $55100129ab36ed65$var$validRequestMethods = new Set($55100129ab36ed65$var$validRequestMethodsArr);
const $55100129ab36ed65$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $55100129ab36ed65$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $55100129ab36ed65$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $55100129ab36ed65$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $55100129ab36ed65$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $55100129ab36ed65$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $55100129ab36ed65$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $55100129ab36ed65$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $55100129ab36ed65$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $55100129ab36ed65$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $55100129ab36ed65$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $55100129ab36ed65$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $55100129ab36ed65$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $55100129ab36ed65$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $55100129ab36ed65$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $55100129ab36ed65$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $55100129ab36ed65$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$55100129ab36ed65$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$55100129ab36ed65$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $55100129ab36ed65$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $55100129ab36ed65$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $55100129ab36ed65$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $55100129ab36ed65$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$55100129ab36ed65$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($55100129ab36ed65$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $55100129ab36ed65$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $55100129ab36ed65$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $55100129ab36ed65$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $55100129ab36ed65$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $55100129ab36ed65$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $55100129ab36ed65$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $55100129ab36ed65$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $55100129ab36ed65$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $55100129ab36ed65$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($55100129ab36ed65$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $55100129ab36ed65$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $55100129ab36ed65$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $55100129ab36ed65$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $55100129ab36ed65$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $55100129ab36ed65$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $55100129ab36ed65$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $55100129ab36ed65$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $55100129ab36ed65$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $55100129ab36ed65$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $55100129ab36ed65$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $55100129ab36ed65$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $55100129ab36ed65$var$findNearestBoundary(matches).route.id,
            {
                type: $55100129ab36ed65$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $55100129ab36ed65$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($55100129ab36ed65$var$isErrorResult(result) && $55100129ab36ed65$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $55100129ab36ed65$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $55100129ab36ed65$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $55100129ab36ed65$var$_extends({
            matches: updatedMatches || matches
        }, $55100129ab36ed65$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $55100129ab36ed65$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $55100129ab36ed65$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $55100129ab36ed65$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $55100129ab36ed65$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $55100129ab36ed65$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $55100129ab36ed65$var$ResultType.error,
            error: $55100129ab36ed65$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($55100129ab36ed65$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $55100129ab36ed65$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($55100129ab36ed65$var$isDeferredResult(result)) throw $55100129ab36ed65$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($55100129ab36ed65$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $55100129ab36ed65$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $55100129ab36ed65$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $55100129ab36ed65$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($55100129ab36ed65$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $55100129ab36ed65$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $55100129ab36ed65$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $55100129ab36ed65$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $55100129ab36ed65$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $55100129ab36ed65$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $55100129ab36ed65$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $55100129ab36ed65$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $55100129ab36ed65$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $55100129ab36ed65$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $55100129ab36ed65$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$55100129ab36ed65$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $55100129ab36ed65$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $55100129ab36ed65$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $55100129ab36ed65$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $55100129ab36ed65$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $55100129ab36ed65$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $55100129ab36ed65$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $55100129ab36ed65$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $55100129ab36ed65$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $55100129ab36ed65$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $55100129ab36ed65$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $55100129ab36ed65$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $55100129ab36ed65$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($55100129ab36ed65$var$isRedirectResult(actionResult) || $55100129ab36ed65$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $55100129ab36ed65$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($55100129ab36ed65$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $55100129ab36ed65$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $55100129ab36ed65$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($55100129ab36ed65$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($55100129ab36ed65$var$isDeferredResult(actionResult)) throw $55100129ab36ed65$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $55100129ab36ed65$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $55100129ab36ed65$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $55100129ab36ed65$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $55100129ab36ed65$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $55100129ab36ed65$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $55100129ab36ed65$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $55100129ab36ed65$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $55100129ab36ed65$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $55100129ab36ed65$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $55100129ab36ed65$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $55100129ab36ed65$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $55100129ab36ed65$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $55100129ab36ed65$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $55100129ab36ed65$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $55100129ab36ed65$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $55100129ab36ed65$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($55100129ab36ed65$var$isDeferredResult(result)) result = await $55100129ab36ed65$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $55100129ab36ed65$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($55100129ab36ed65$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $55100129ab36ed65$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($55100129ab36ed65$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $55100129ab36ed65$export$3e9cee6b33872309(!$55100129ab36ed65$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $55100129ab36ed65$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $55100129ab36ed65$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $55100129ab36ed65$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $55100129ab36ed65$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($55100129ab36ed65$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $55100129ab36ed65$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $55100129ab36ed65$export$e19cd5f9376f8cee.Replace : $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $55100129ab36ed65$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($55100129ab36ed65$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $55100129ab36ed65$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $55100129ab36ed65$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $55100129ab36ed65$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $55100129ab36ed65$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $55100129ab36ed65$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($55100129ab36ed65$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $55100129ab36ed65$var$ResultType.redirect,
                response: $55100129ab36ed65$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $55100129ab36ed65$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $55100129ab36ed65$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $55100129ab36ed65$var$ResultType.error,
                    error: $55100129ab36ed65$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $55100129ab36ed65$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $55100129ab36ed65$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $55100129ab36ed65$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $55100129ab36ed65$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $55100129ab36ed65$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $55100129ab36ed65$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $55100129ab36ed65$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $55100129ab36ed65$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $55100129ab36ed65$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $55100129ab36ed65$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $55100129ab36ed65$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $55100129ab36ed65$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $55100129ab36ed65$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $55100129ab36ed65$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$55100129ab36ed65$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $55100129ab36ed65$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $55100129ab36ed65$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $55100129ab36ed65$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $55100129ab36ed65$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $55100129ab36ed65$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $55100129ab36ed65$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $55100129ab36ed65$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $55100129ab36ed65$export$4d0306f8f6a4585b = Symbol("deferred");
function $55100129ab36ed65$export$3336b097a6fbc59a(routes, opts) {
    $55100129ab36ed65$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $55100129ab36ed65$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $55100129ab36ed65$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $55100129ab36ed65$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $55100129ab36ed65$var$createLocation("", $55100129ab36ed65$export$fe53371bee54353d(url), null, "default");
        let matches = $55100129ab36ed65$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$55100129ab36ed65$var$isValidMethod(method) && method !== "HEAD") {
            let error = $55100129ab36ed65$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $55100129ab36ed65$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $55100129ab36ed65$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $55100129ab36ed65$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($55100129ab36ed65$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $55100129ab36ed65$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $55100129ab36ed65$var$createLocation("", $55100129ab36ed65$export$fe53371bee54353d(url), null, "default");
        let matches = $55100129ab36ed65$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$55100129ab36ed65$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $55100129ab36ed65$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $55100129ab36ed65$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $55100129ab36ed65$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $55100129ab36ed65$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $55100129ab36ed65$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($55100129ab36ed65$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$55100129ab36ed65$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $55100129ab36ed65$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($55100129ab36ed65$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $55100129ab36ed65$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $55100129ab36ed65$var$isResponse(result) ? result : $55100129ab36ed65$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($55100129ab36ed65$var$isDataStrategyResult(e) && $55100129ab36ed65$var$isResponse(e.result)) {
                if (e.type === $55100129ab36ed65$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($55100129ab36ed65$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $55100129ab36ed65$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $55100129ab36ed65$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $55100129ab36ed65$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($55100129ab36ed65$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($55100129ab36ed65$var$isDeferredResult(result)) {
            let error = $55100129ab36ed65$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $55100129ab36ed65$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($55100129ab36ed65$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($55100129ab36ed65$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $55100129ab36ed65$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $55100129ab36ed65$var$_extends({}, context, {
                statusCode: $55100129ab36ed65$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $55100129ab36ed65$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $55100129ab36ed65$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $55100129ab36ed65$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $55100129ab36ed65$var$isErrorResult(pendingActionResult[1]) ? $55100129ab36ed65$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $55100129ab36ed65$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $55100129ab36ed65$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $55100129ab36ed65$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $55100129ab36ed65$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $55100129ab36ed65$var$callDataStrategyImpl(dataStrategy || $55100129ab36ed65$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($55100129ab36ed65$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $55100129ab36ed65$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($55100129ab36ed65$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $55100129ab36ed65$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $55100129ab36ed65$export$fec11da027c70692(routes, context, error) {
    let newContext = $55100129ab36ed65$var$_extends({}, context, {
        statusCode: $55100129ab36ed65$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $55100129ab36ed65$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $55100129ab36ed65$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $55100129ab36ed65$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $55100129ab36ed65$export$cae722b0cc860f13(to ? to : ".", $55100129ab36ed65$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $55100129ab36ed65$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $55100129ab36ed65$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $55100129ab36ed65$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $55100129ab36ed65$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $55100129ab36ed65$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$55100129ab36ed65$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$55100129ab36ed65$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $55100129ab36ed65$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $55100129ab36ed65$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $55100129ab36ed65$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$55100129ab36ed65$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$55100129ab36ed65$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $55100129ab36ed65$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $55100129ab36ed65$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $55100129ab36ed65$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $55100129ab36ed65$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $55100129ab36ed65$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($55100129ab36ed65$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $55100129ab36ed65$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $55100129ab36ed65$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $55100129ab36ed65$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $55100129ab36ed65$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $55100129ab36ed65$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $55100129ab36ed65$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $55100129ab36ed65$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $55100129ab36ed65$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $55100129ab36ed65$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $55100129ab36ed65$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($55100129ab36ed65$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $55100129ab36ed65$var$shouldRevalidateLoader(match, $55100129ab36ed65$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $55100129ab36ed65$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $55100129ab36ed65$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $55100129ab36ed65$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $55100129ab36ed65$var$shouldRevalidateLoader(fetcherMatch, $55100129ab36ed65$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $55100129ab36ed65$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $55100129ab36ed65$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $55100129ab36ed65$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $55100129ab36ed65$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $55100129ab36ed65$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $55100129ab36ed65$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$55100129ab36ed65$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $55100129ab36ed65$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $55100129ab36ed65$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$55100129ab36ed65$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $55100129ab36ed65$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $55100129ab36ed65$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $55100129ab36ed65$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$55100129ab36ed65$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $55100129ab36ed65$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $55100129ab36ed65$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $55100129ab36ed65$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $55100129ab36ed65$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $55100129ab36ed65$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $55100129ab36ed65$var$ResultType.data,
                result: undefined
            });
        };
        return $55100129ab36ed65$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $55100129ab36ed65$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $55100129ab36ed65$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $55100129ab36ed65$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $55100129ab36ed65$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $55100129ab36ed65$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $55100129ab36ed65$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $55100129ab36ed65$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($55100129ab36ed65$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $55100129ab36ed65$var$ResultType.error,
                error: e
            };
        }
        if (type === $55100129ab36ed65$var$ResultType.error) return {
            type: $55100129ab36ed65$var$ResultType.error,
            error: new $55100129ab36ed65$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $55100129ab36ed65$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $55100129ab36ed65$var$ResultType.error) {
        if ($55100129ab36ed65$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $55100129ab36ed65$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $55100129ab36ed65$var$ResultType.error,
                error: new $55100129ab36ed65$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $55100129ab36ed65$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $55100129ab36ed65$var$ResultType.error,
            error: result,
            statusCode: $55100129ab36ed65$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($55100129ab36ed65$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $55100129ab36ed65$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($55100129ab36ed65$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $55100129ab36ed65$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $55100129ab36ed65$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $55100129ab36ed65$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $55100129ab36ed65$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$55100129ab36ed65$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $55100129ab36ed65$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $55100129ab36ed65$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    // Match Chrome's behavior:
    // https://github.com/chromium/chromium/blob/216dbeb61db0c667e62082e5f5400a32d6983df3/content/public/common/url_utils.cc#L82
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($55100129ab36ed65$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $55100129ab36ed65$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $55100129ab36ed65$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($55100129ab36ed65$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $55100129ab36ed65$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $55100129ab36ed65$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $55100129ab36ed65$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $55100129ab36ed65$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $55100129ab36ed65$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $55100129ab36ed65$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $55100129ab36ed65$export$3e9cee6b33872309(!$55100129ab36ed65$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($55100129ab36ed65$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $55100129ab36ed65$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $55100129ab36ed65$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($55100129ab36ed65$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $55100129ab36ed65$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $55100129ab36ed65$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $55100129ab36ed65$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($55100129ab36ed65$var$isErrorResult(result)) {
            let boundaryMatch = $55100129ab36ed65$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $55100129ab36ed65$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($55100129ab36ed65$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $55100129ab36ed65$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($55100129ab36ed65$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $55100129ab36ed65$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $55100129ab36ed65$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $55100129ab36ed65$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $55100129ab36ed65$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $55100129ab36ed65$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $55100129ab36ed65$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $55100129ab36ed65$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $55100129ab36ed65$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $55100129ab36ed65$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $55100129ab36ed65$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $55100129ab36ed65$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($55100129ab36ed65$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $55100129ab36ed65$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(path) : path;
    return $55100129ab36ed65$export$fe53371bee54353d($55100129ab36ed65$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $55100129ab36ed65$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $55100129ab36ed65$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $55100129ab36ed65$var$ResultType.data || result.type === $55100129ab36ed65$var$ResultType.error);
}
function $55100129ab36ed65$var$isRedirectDataStrategyResultResult(result) {
    return $55100129ab36ed65$var$isResponse(result.result) && $55100129ab36ed65$var$redirectStatusCodes.has(result.result.status);
}
function $55100129ab36ed65$var$isDeferredResult(result) {
    return result.type === $55100129ab36ed65$var$ResultType.deferred;
}
function $55100129ab36ed65$var$isErrorResult(result) {
    return result.type === $55100129ab36ed65$var$ResultType.error;
}
function $55100129ab36ed65$var$isRedirectResult(result) {
    return (result && result.type) === $55100129ab36ed65$var$ResultType.redirect;
}
function $55100129ab36ed65$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $55100129ab36ed65$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $55100129ab36ed65$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $55100129ab36ed65$var$isRedirectResponse(result) {
    if (!$55100129ab36ed65$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $55100129ab36ed65$var$isValidMethod(method) {
    return $55100129ab36ed65$var$validRequestMethods.has(method.toLowerCase());
}
function $55100129ab36ed65$var$isMutationMethod(method) {
    return $55100129ab36ed65$var$validMutationMethods.has(method.toLowerCase());
}
async function $55100129ab36ed65$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$55100129ab36ed65$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($55100129ab36ed65$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $55100129ab36ed65$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $55100129ab36ed65$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($55100129ab36ed65$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $55100129ab36ed65$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $55100129ab36ed65$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $55100129ab36ed65$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $55100129ab36ed65$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $55100129ab36ed65$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $55100129ab36ed65$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $55100129ab36ed65$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $55100129ab36ed65$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $55100129ab36ed65$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $55100129ab36ed65$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $55100129ab36ed65$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $55100129ab36ed65$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $55100129ab36ed65$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $55100129ab36ed65$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $55100129ab36ed65$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $55100129ab36ed65$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $55100129ab36ed65$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($55100129ab36ed65$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $55100129ab36ed65$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($55100129ab36ed65$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $55100129ab36ed65$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}


function $d9fd026bfea79ab9$var$_extends() {
    $d9fd026bfea79ab9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d9fd026bfea79ab9$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $d9fd026bfea79ab9$export$3add0d5dce533e2e = /*#__PURE__*/ $7fPBF.createContext(null);
const $d9fd026bfea79ab9$export$145dfa71566a64dc = /*#__PURE__*/ $7fPBF.createContext(null);
const $d9fd026bfea79ab9$var$AwaitContext = /*#__PURE__*/ $7fPBF.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $d9fd026bfea79ab9$export$26749e8557646306 = /*#__PURE__*/ $7fPBF.createContext(null);
const $d9fd026bfea79ab9$export$c7914228fb69b0f5 = /*#__PURE__*/ $7fPBF.createContext(null);
const $d9fd026bfea79ab9$export$9072aa6dd1f93057 = /*#__PURE__*/ $7fPBF.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $d9fd026bfea79ab9$var$RouteErrorContext = /*#__PURE__*/ $7fPBF.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $d9fd026bfea79ab9$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $d9fd026bfea79ab9$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $55100129ab36ed65$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $d9fd026bfea79ab9$export$9c954a9d03d32f4a() {
    return $7fPBF.useContext($d9fd026bfea79ab9$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $d9fd026bfea79ab9$export$45d76561a5302f2b() {
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return $7fPBF.useContext($d9fd026bfea79ab9$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $d9fd026bfea79ab9$export$1b3f31771c5d07c() {
    return $7fPBF.useContext($d9fd026bfea79ab9$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $d9fd026bfea79ab9$export$6c330e8992e8a295(pattern) {
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    return $7fPBF.useMemo(()=>(0, $55100129ab36ed65$export$81336c211d5ff295)(pattern, (0, $55100129ab36ed65$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $d9fd026bfea79ab9$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $d9fd026bfea79ab9$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $7fPBF.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $d9fd026bfea79ab9$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $d9fd026bfea79ab9$var$useNavigateStable() : $d9fd026bfea79ab9$var$useNavigateUnstable();
}
function $d9fd026bfea79ab9$var$useNavigateUnstable() {
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let dataRouterContext = $7fPBF.useContext($d9fd026bfea79ab9$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306);
    let { matches: matches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $55100129ab36ed65$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $7fPBF.useRef(false);
    $d9fd026bfea79ab9$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $7fPBF.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $55100129ab36ed65$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $55100129ab36ed65$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $d9fd026bfea79ab9$var$OutletContext = /*#__PURE__*/ $7fPBF.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $d9fd026bfea79ab9$export$4138103a3ae699cc() {
    return $7fPBF.useContext($d9fd026bfea79ab9$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $d9fd026bfea79ab9$export$a3be3530d8e40d0b(context) {
    let outlet = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $d9fd026bfea79ab9$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $d9fd026bfea79ab9$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306);
    let { matches: matches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $55100129ab36ed65$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $7fPBF.useMemo(()=>(0, $55100129ab36ed65$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $d9fd026bfea79ab9$export$5d3fca4a98652595(routes, locationArg) {
    return $d9fd026bfea79ab9$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $d9fd026bfea79ab9$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306);
    let { matches: parentMatches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $55100129ab36ed65$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $55100129ab36ed65$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $d9fd026bfea79ab9$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $55100129ab36ed65$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $55100129ab36ed65$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $d9fd026bfea79ab9$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $55100129ab36ed65$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $d9fd026bfea79ab9$var$DefaultErrorComponent() {
    let error = $d9fd026bfea79ab9$export$ed527bf60f6e05f2();
    let message = (0, $55100129ab36ed65$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $7fPBF.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $7fPBF.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $d9fd026bfea79ab9$var$defaultErrorElement = /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$DefaultErrorComponent, null);
class $d9fd026bfea79ab9$var$RenderErrorBoundary extends $7fPBF.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
}
function $d9fd026bfea79ab9$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $7fPBF.useContext($d9fd026bfea79ab9$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $d9fd026bfea79ab9$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $d9fd026bfea79ab9$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $d9fd026bfea79ab9$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $7fPBF.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $d9fd026bfea79ab9$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($d9fd026bfea79ab9$var$DataRouterHook || {});
var $d9fd026bfea79ab9$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($d9fd026bfea79ab9$var$DataRouterStateHook || {});
function $d9fd026bfea79ab9$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $d9fd026bfea79ab9$var$useDataRouterContext(hookName) {
    let ctx = $7fPBF.useContext($d9fd026bfea79ab9$export$3add0d5dce533e2e);
    !ctx && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return ctx;
}
function $d9fd026bfea79ab9$var$useDataRouterState(hookName) {
    let state = $7fPBF.useContext($d9fd026bfea79ab9$export$145dfa71566a64dc);
    !state && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return state;
}
function $d9fd026bfea79ab9$var$useRouteContext(hookName) {
    let route = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    !route && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $d9fd026bfea79ab9$var$useCurrentRouteId(hookName) {
    let route = $d9fd026bfea79ab9$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $d9fd026bfea79ab9$export$5fc8298006ad9e58() {
    return $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $d9fd026bfea79ab9$export$d0fd4b7106de2769() {
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $d9fd026bfea79ab9$export$600dc272ed516c15() {
    let dataRouterContext = $d9fd026bfea79ab9$var$useDataRouterContext($d9fd026bfea79ab9$var$DataRouterHook.UseRevalidator);
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseRevalidator);
    return $7fPBF.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $d9fd026bfea79ab9$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseMatches);
    return $7fPBF.useMemo(()=>matches.map((m)=>(0, $55100129ab36ed65$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $d9fd026bfea79ab9$export$1448a5050d252c4d() {
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseLoaderData);
    let routeId = $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $d9fd026bfea79ab9$export$fd5d37484eab868d(routeId) {
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $d9fd026bfea79ab9$export$fdc00f3f26066d5e() {
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseActionData);
    let routeId = $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $d9fd026bfea79ab9$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $7fPBF.useContext($d9fd026bfea79ab9$var$RouteErrorContext);
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseRouteError);
    let routeId = $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $d9fd026bfea79ab9$export$78a72ddb39bdd145() {
    let value = $7fPBF.useContext($d9fd026bfea79ab9$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $d9fd026bfea79ab9$export$17f53340677d5831() {
    let value = $7fPBF.useContext($d9fd026bfea79ab9$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $d9fd026bfea79ab9$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $d9fd026bfea79ab9$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $d9fd026bfea79ab9$var$useDataRouterContext($d9fd026bfea79ab9$var$DataRouterHook.UseBlocker);
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $7fPBF.useState("");
    let blockerFunction = $7fPBF.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $d9fd026bfea79ab9$var$_extends({}, currentLocation, {
                pathname: (0, $55100129ab36ed65$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $d9fd026bfea79ab9$var$_extends({}, nextLocation, {
                pathname: (0, $55100129ab36ed65$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $7fPBF.useEffect(()=>{
        let key = String(++$d9fd026bfea79ab9$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $7fPBF.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $55100129ab36ed65$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $d9fd026bfea79ab9$var$useNavigateStable() {
    let { router: router } = $d9fd026bfea79ab9$var$useDataRouterContext($d9fd026bfea79ab9$var$DataRouterHook.UseNavigateStable);
    let id = $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $7fPBF.useRef(false);
    $d9fd026bfea79ab9$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $7fPBF.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $d9fd026bfea79ab9$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $d9fd026bfea79ab9$var$alreadyWarned$1 = {};
function $d9fd026bfea79ab9$var$warningOnce(key, cond, message) {
    if (!cond && !$d9fd026bfea79ab9$var$alreadyWarned$1[key]) $d9fd026bfea79ab9$var$alreadyWarned$1[key] = true;
}
const $d9fd026bfea79ab9$var$alreadyWarned = {};
function $d9fd026bfea79ab9$var$warnOnce(key, message) {}
const $d9fd026bfea79ab9$var$logDeprecation = (flag, msg, link)=>$d9fd026bfea79ab9$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $d9fd026bfea79ab9$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $d9fd026bfea79ab9$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $d9fd026bfea79ab9$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $d9fd026bfea79ab9$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $d9fd026bfea79ab9$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $d9fd026bfea79ab9$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $d9fd026bfea79ab9$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $d9fd026bfea79ab9$var$START_TRANSITION = "startTransition";
const $d9fd026bfea79ab9$var$startTransitionImpl = $7fPBF[$d9fd026bfea79ab9$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $d9fd026bfea79ab9$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $7fPBF.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        if (v7_startTransition && $d9fd026bfea79ab9$var$startTransitionImpl) $d9fd026bfea79ab9$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $7fPBF.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $7fPBF.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $7fPBF.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $7fPBF.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $7fPBF.useEffect(()=>$d9fd026bfea79ab9$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $d9fd026bfea79ab9$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $d9fd026bfea79ab9$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $d9fd026bfea79ab9$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $7fPBF.useRef();
    if (historyRef.current == null) historyRef.current = (0, $55100129ab36ed65$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        v7_startTransition && $d9fd026bfea79ab9$var$startTransitionImpl ? $d9fd026bfea79ab9$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $7fPBF.useEffect(()=>$d9fd026bfea79ab9$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $d9fd026bfea79ab9$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306);
    let { matches: matches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    let navigate = $d9fd026bfea79ab9$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $55100129ab36ed65$export$cae722b0cc860f13)(to, (0, $55100129ab36ed65$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $7fPBF.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $d9fd026bfea79ab9$export$910ae8079b2c2852(props) {
    return $d9fd026bfea79ab9$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $d9fd026bfea79ab9$export$e7b0ac011bb776c6(_props) {
    (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $d9fd026bfea79ab9$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $55100129ab36ed65$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $7fPBF.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $d9fd026bfea79ab9$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $55100129ab36ed65$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $7fPBF.useMemo(()=>{
        let trailingPathname = (0, $55100129ab36ed65$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $d9fd026bfea79ab9$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $d9fd026bfea79ab9$export$5d3fca4a98652595($d9fd026bfea79ab9$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $d9fd026bfea79ab9$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$ResolveAwait, null, children));
}
var $d9fd026bfea79ab9$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($d9fd026bfea79ab9$var$AwaitRenderStatus || {});
const $d9fd026bfea79ab9$var$neverSettledPromise = new Promise(()=>{});
class $d9fd026bfea79ab9$var$AwaitErrorBoundary extends $7fPBF.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $d9fd026bfea79ab9$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $d9fd026bfea79ab9$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $d9fd026bfea79ab9$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $d9fd026bfea79ab9$var$AwaitRenderStatus.error : "_data" in promise ? $d9fd026bfea79ab9$var$AwaitRenderStatus.success : $d9fd026bfea79ab9$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $d9fd026bfea79ab9$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $d9fd026bfea79ab9$var$AwaitRenderStatus.error && promise._error instanceof (0, $55100129ab36ed65$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $d9fd026bfea79ab9$var$neverSettledPromise;
        if (status === $d9fd026bfea79ab9$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $d9fd026bfea79ab9$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $d9fd026bfea79ab9$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $d9fd026bfea79ab9$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $d9fd026bfea79ab9$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $d9fd026bfea79ab9$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $7fPBF.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $7fPBF.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $7fPBF.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $d9fd026bfea79ab9$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $d9fd026bfea79ab9$export$e7b0ac011bb776c6) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $d9fd026bfea79ab9$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $d9fd026bfea79ab9$export$daf73786167a7f72(matches) {
    return $d9fd026bfea79ab9$var$_renderMatches(matches);
}
function $d9fd026bfea79ab9$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $7fPBF.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $7fPBF.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $7fPBF.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $d9fd026bfea79ab9$export$f30f7e456d254e83(routes, opts) {
    return (0, $55100129ab36ed65$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $d9fd026bfea79ab9$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $55100129ab36ed65$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $d9fd026bfea79ab9$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}

/**
 * React Router DOM v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $7fPBF = parcelRequire("7fPBF");



function $a0cf24fd73ae067c$var$_extends() {
    $a0cf24fd73ae067c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a0cf24fd73ae067c$var$_extends.apply(this, arguments);
}
function $a0cf24fd73ae067c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $a0cf24fd73ae067c$var$defaultMethod = "get";
const $a0cf24fd73ae067c$var$defaultEncType = "application/x-www-form-urlencoded";
function $a0cf24fd73ae067c$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $a0cf24fd73ae067c$var$isButtonElement(object) {
    return $a0cf24fd73ae067c$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $a0cf24fd73ae067c$var$isFormElement(object) {
    return $a0cf24fd73ae067c$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $a0cf24fd73ae067c$var$isInputElement(object) {
    return $a0cf24fd73ae067c$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $a0cf24fd73ae067c$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $a0cf24fd73ae067c$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$a0cf24fd73ae067c$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $a0cf24fd73ae067c$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $a0cf24fd73ae067c$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $a0cf24fd73ae067c$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $a0cf24fd73ae067c$var$_formDataSupportsSubmitter = null;
function $a0cf24fd73ae067c$var$isFormDataSubmitterSupported() {
    if ($a0cf24fd73ae067c$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $a0cf24fd73ae067c$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $a0cf24fd73ae067c$var$_formDataSupportsSubmitter = true;
    }
    return $a0cf24fd73ae067c$var$_formDataSupportsSubmitter;
}
const $a0cf24fd73ae067c$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $a0cf24fd73ae067c$var$getFormEncType(encType) {
    if (encType != null && !$a0cf24fd73ae067c$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $a0cf24fd73ae067c$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($a0cf24fd73ae067c$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $55100129ab36ed65$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $a0cf24fd73ae067c$var$defaultMethod;
        encType = $a0cf24fd73ae067c$var$getFormEncType(target.getAttribute("enctype")) || $a0cf24fd73ae067c$var$defaultEncType;
        formData = new FormData(target);
    } else if ($a0cf24fd73ae067c$var$isButtonElement(target) || $a0cf24fd73ae067c$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $55100129ab36ed65$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $a0cf24fd73ae067c$var$defaultMethod;
        encType = $a0cf24fd73ae067c$var$getFormEncType(target.getAttribute("formenctype")) || $a0cf24fd73ae067c$var$getFormEncType(form.getAttribute("enctype")) || $a0cf24fd73ae067c$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$a0cf24fd73ae067c$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($a0cf24fd73ae067c$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $a0cf24fd73ae067c$var$defaultMethod;
        action = null;
        encType = $a0cf24fd73ae067c$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $a0cf24fd73ae067c$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $a0cf24fd73ae067c$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $a0cf24fd73ae067c$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $a0cf24fd73ae067c$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $a0cf24fd73ae067c$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $a0cf24fd73ae067c$export$1f3f55432a00e06d(routes, opts) {
    return (0, $55100129ab36ed65$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $a0cf24fd73ae067c$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $55100129ab36ed65$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $a0cf24fd73ae067c$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $d9fd026bfea79ab9$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $a0cf24fd73ae067c$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $55100129ab36ed65$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $a0cf24fd73ae067c$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $55100129ab36ed65$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $a0cf24fd73ae067c$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $d9fd026bfea79ab9$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $a0cf24fd73ae067c$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $a0cf24fd73ae067c$var$_extends({}, state, {
        errors: $a0cf24fd73ae067c$var$deserializeErrors(state.errors)
    });
    return state;
}
function $a0cf24fd73ae067c$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $55100129ab36ed65$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $a0cf24fd73ae067c$export$7ad602f0e94e62d1 = /*#__PURE__*/ $7fPBF.createContext({
    isTransitioning: false
});
const $a0cf24fd73ae067c$export$148fd98d095596d4 = /*#__PURE__*/ $7fPBF.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $a0cf24fd73ae067c$var$START_TRANSITION = "startTransition";
const $a0cf24fd73ae067c$var$startTransitionImpl = $7fPBF[$a0cf24fd73ae067c$var$START_TRANSITION];
const $a0cf24fd73ae067c$var$FLUSH_SYNC = "flushSync";
const $a0cf24fd73ae067c$var$flushSyncImpl = $b4ba1c853f6e1116$exports[$a0cf24fd73ae067c$var$FLUSH_SYNC];
const $a0cf24fd73ae067c$var$USE_ID = "useId";
const $a0cf24fd73ae067c$var$useIdImpl = $7fPBF[$a0cf24fd73ae067c$var$USE_ID];
function $a0cf24fd73ae067c$var$startTransitionSafe(cb) {
    if ($a0cf24fd73ae067c$var$startTransitionImpl) $a0cf24fd73ae067c$var$startTransitionImpl(cb);
    else cb();
}
function $a0cf24fd73ae067c$var$flushSyncSafe(cb) {
    if ($a0cf24fd73ae067c$var$flushSyncImpl) $a0cf24fd73ae067c$var$flushSyncImpl(cb);
    else cb();
}
class $a0cf24fd73ae067c$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $a0cf24fd73ae067c$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $7fPBF.useState(router.state);
    let [pendingState, setPendingState] = $7fPBF.useState();
    let [vtContext, setVtContext] = $7fPBF.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $7fPBF.useState();
    let [transition, setTransition] = $7fPBF.useState();
    let [interruption, setInterruption] = $7fPBF.useState();
    let fetcherData = $7fPBF.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $7fPBF.useCallback((cb)=>{
        if (v7_startTransition) $a0cf24fd73ae067c$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $7fPBF.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $a0cf24fd73ae067c$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $a0cf24fd73ae067c$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $a0cf24fd73ae067c$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $a0cf24fd73ae067c$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $a0cf24fd73ae067c$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $7fPBF.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $7fPBF.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $a0cf24fd73ae067c$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $7fPBF.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $7fPBF.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $7fPBF.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $7fPBF.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $7fPBF.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $7fPBF.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $7fPBF.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $7fPBF.useEffect(()=>(0, $d9fd026bfea79ab9$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $a0cf24fd73ae067c$var$MemoizedDataRoutes = /*#__PURE__*/ $7fPBF.memo($a0cf24fd73ae067c$var$DataRoutes);
function $a0cf24fd73ae067c$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $d9fd026bfea79ab9$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $a0cf24fd73ae067c$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $7fPBF.useRef();
    if (historyRef.current == null) historyRef.current = (0, $55100129ab36ed65$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        v7_startTransition && $a0cf24fd73ae067c$var$startTransitionImpl ? $a0cf24fd73ae067c$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $7fPBF.useEffect(()=>(0, $d9fd026bfea79ab9$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $a0cf24fd73ae067c$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $7fPBF.useRef();
    if (historyRef.current == null) historyRef.current = (0, $55100129ab36ed65$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        v7_startTransition && $a0cf24fd73ae067c$var$startTransitionImpl ? $a0cf24fd73ae067c$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $7fPBF.useEffect(()=>(0, $d9fd026bfea79ab9$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $a0cf24fd73ae067c$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        v7_startTransition && $a0cf24fd73ae067c$var$startTransitionImpl ? $a0cf24fd73ae067c$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $7fPBF.useEffect(()=>(0, $d9fd026bfea79ab9$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $a0cf24fd73ae067c$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $a0cf24fd73ae067c$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $a0cf24fd73ae067c$export$a6c7ac8248d6e38a = /*#__PURE__*/ $7fPBF.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $a0cf24fd73ae067c$var$_objectWithoutPropertiesLoose(_ref7, $a0cf24fd73ae067c$var$_excluded);
    let { basename: basename } = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $a0cf24fd73ae067c$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($a0cf24fd73ae067c$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $55100129ab36ed65$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $d9fd026bfea79ab9$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $a0cf24fd73ae067c$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $7fPBF.createElement("a", $a0cf24fd73ae067c$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $a0cf24fd73ae067c$export$b0d92dbee9b5b60d = /*#__PURE__*/ $7fPBF.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $a0cf24fd73ae067c$var$_objectWithoutPropertiesLoose(_ref8, $a0cf24fd73ae067c$var$_excluded2);
    let path = (0, $d9fd026bfea79ab9$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    let routerState = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $a0cf24fd73ae067c$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $55100129ab36ed65$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$export$a6c7ac8248d6e38a, $a0cf24fd73ae067c$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $a0cf24fd73ae067c$export$a7fed597f4b8afd8 = /*#__PURE__*/ $7fPBF.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $a0cf24fd73ae067c$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $a0cf24fd73ae067c$var$_objectWithoutPropertiesLoose(_ref9, $a0cf24fd73ae067c$var$_excluded3);
    let submit = $a0cf24fd73ae067c$export$47c85c6e3a081d3();
    let formAction = $a0cf24fd73ae067c$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $7fPBF.createElement("form", $a0cf24fd73ae067c$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $a0cf24fd73ae067c$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $a0cf24fd73ae067c$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $a0cf24fd73ae067c$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($a0cf24fd73ae067c$var$DataRouterHook || ($a0cf24fd73ae067c$var$DataRouterHook = {}));
var $a0cf24fd73ae067c$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($a0cf24fd73ae067c$var$DataRouterStateHook || ($a0cf24fd73ae067c$var$DataRouterStateHook = {}));
// Internal hooks
function $a0cf24fd73ae067c$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $a0cf24fd73ae067c$var$useDataRouterContext(hookName) {
    let ctx = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$3add0d5dce533e2e));
    !ctx && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return ctx;
}
function $a0cf24fd73ae067c$var$useDataRouterState(hookName) {
    let state = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$145dfa71566a64dc));
    !state && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $a0cf24fd73ae067c$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    let path = (0, $d9fd026bfea79ab9$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $7fPBF.useCallback((event)=>{
        if ($a0cf24fd73ae067c$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $55100129ab36ed65$export$fe53371bee54353d)(location) === (0, $55100129ab36ed65$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $a0cf24fd73ae067c$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $7fPBF.useRef($a0cf24fd73ae067c$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $7fPBF.useRef(false);
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    let searchParams = $7fPBF.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $a0cf24fd73ae067c$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    let setSearchParams = $7fPBF.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $a0cf24fd73ae067c$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $a0cf24fd73ae067c$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $a0cf24fd73ae067c$var$fetcherId = 0;
let $a0cf24fd73ae067c$var$getUniqueFetcherId = ()=>"__" + String(++$a0cf24fd73ae067c$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $a0cf24fd73ae067c$export$47c85c6e3a081d3() {
    let { router: router } = $a0cf24fd73ae067c$var$useDataRouterContext($a0cf24fd73ae067c$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$26749e8557646306));
    let currentRouteId = (0, $d9fd026bfea79ab9$export$5fc8298006ad9e58)();
    return $7fPBF.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $a0cf24fd73ae067c$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $a0cf24fd73ae067c$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $a0cf24fd73ae067c$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $a0cf24fd73ae067c$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$26749e8557646306));
    let routeContext = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$9072aa6dd1f93057));
    !routeContext && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $a0cf24fd73ae067c$var$_extends({}, (0, $d9fd026bfea79ab9$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $55100129ab36ed65$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $55100129ab36ed65$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $a0cf24fd73ae067c$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $a0cf24fd73ae067c$var$useDataRouterContext($a0cf24fd73ae067c$var$DataRouterHook.UseFetcher);
    let state = $a0cf24fd73ae067c$var$useDataRouterState($a0cf24fd73ae067c$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $7fPBF.useContext($a0cf24fd73ae067c$export$148fd98d095596d4);
    let route = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    !route && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $a0cf24fd73ae067c$var$useIdImpl ? $a0cf24fd73ae067c$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $7fPBF.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($a0cf24fd73ae067c$var$getUniqueFetcherId());
    // Registration/cleanup
    $7fPBF.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $7fPBF.useCallback((href, opts)=>{
        !routeId && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $a0cf24fd73ae067c$export$47c85c6e3a081d3();
    let submit = $7fPBF.useCallback((target, opts)=>{
        submitImpl(target, $a0cf24fd73ae067c$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $7fPBF.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $7fPBF.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$export$a7fed597f4b8afd8, $a0cf24fd73ae067c$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $55100129ab36ed65$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $7fPBF.useMemo(()=>$a0cf24fd73ae067c$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $a0cf24fd73ae067c$export$fa996778a3a31087() {
    let state = $a0cf24fd73ae067c$var$useDataRouterState($a0cf24fd73ae067c$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $a0cf24fd73ae067c$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $a0cf24fd73ae067c$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $a0cf24fd73ae067c$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $a0cf24fd73ae067c$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $a0cf24fd73ae067c$var$useDataRouterContext($a0cf24fd73ae067c$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $a0cf24fd73ae067c$var$useDataRouterState($a0cf24fd73ae067c$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$26749e8557646306));
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    let matches = (0, $d9fd026bfea79ab9$export$2378eb7f5ff86053)();
    let navigation = (0, $d9fd026bfea79ab9$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $7fPBF.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $a0cf24fd73ae067c$var$usePageHide($7fPBF.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $a0cf24fd73ae067c$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $a0cf24fd73ae067c$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($a0cf24fd73ae067c$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $7fPBF.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $a0cf24fd73ae067c$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $a0cf24fd73ae067c$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $7fPBF.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($a0cf24fd73ae067c$var$_extends({}, location, {
                    pathname: (0, $55100129ab36ed65$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($a0cf24fd73ae067c$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $7fPBF.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $a0cf24fd73ae067c$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $7fPBF.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $a0cf24fd73ae067c$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $7fPBF.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $a0cf24fd73ae067c$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $d9fd026bfea79ab9$export$b273b3273281a049)(when);
    $7fPBF.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $7fPBF.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $a0cf24fd73ae067c$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $7fPBF.useContext($a0cf24fd73ae067c$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let { basename: basename } = $a0cf24fd73ae067c$var$useDataRouterContext($a0cf24fd73ae067c$var$DataRouterHook.useViewTransitionState);
    let path = (0, $d9fd026bfea79ab9$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $55100129ab36ed65$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $55100129ab36ed65$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $55100129ab36ed65$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $55100129ab36ed65$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



parcelRequire("7fPBF");
function $919ebf39980bf8f3$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $6e5b65c9cbae0db9$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $919ebf39980bf8f3$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}


function $1c481e73824c6361$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1c481e73824c6361$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $1c481e73824c6361$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}




function $75dbb8f78ee65245$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}


function $8901fc92b5563702$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = (0, $75dbb8f78ee65245$export$71511d61b312f219)(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}








// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis
function $b1135d4359ab083e$export$a4e55266d2135a7f() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
}
function $b1135d4359ab083e$var$getDevTools() {
    const w = $b1135d4359ab083e$export$a4e55266d2135a7f();
    if (w.__xstate__) return w.__xstate__;
    return undefined;
}
function $b1135d4359ab083e$export$4d7a7d14704ebc13(service) {
    if (typeof window === 'undefined') return;
    const devTools = $b1135d4359ab083e$var$getDevTools();
    if (devTools) devTools.register(service);
}
const $b1135d4359ab083e$export$3ee8010769463234 = (service)=>{
    if (typeof window === 'undefined') return;
    const devTools = $b1135d4359ab083e$var$getDevTools();
    if (devTools) devTools.register(service);
};


class $7fce67e153198813$var$Mailbox {
    start() {
        this._active = true;
        this.flush();
    }
    clear() {
        // we can't set _current to null because we might be currently processing
        // and enqueue following clear shouldn't start processing the enqueued item immediately
        if (this._current) {
            this._current.next = null;
            this._last = this._current;
        }
    }
    enqueue(event) {
        const enqueued = {
            value: event,
            next: null
        };
        if (this._current) {
            this._last.next = enqueued;
            this._last = enqueued;
            return;
        }
        this._current = enqueued;
        this._last = enqueued;
        if (this._active) this.flush();
    }
    flush() {
        while(this._current){
            // atm the given _process is responsible for implementing proper try/catch handling
            // we assume here that this won't throw in a way that can affect this mailbox
            const consumed = this._current;
            this._process(consumed.value);
            this._current = consumed.next;
        }
        this._last = null;
    }
    constructor(_process){
        this._process = _process;
        this._active = false;
        this._current = null;
        this._last = null;
    }
}
const $7fce67e153198813$export$25ce5a424b770e84 = '.';
const $7fce67e153198813$var$TARGETLESS_KEY = '';
const $7fce67e153198813$export$a07804094c3ecf2d = '';
const $7fce67e153198813$var$STATE_IDENTIFIER = '#';
const $7fce67e153198813$var$WILDCARD = '*';
const $7fce67e153198813$var$XSTATE_INIT = 'xstate.init';
const $7fce67e153198813$export$e7c866399fa523f5 = 'xstate.error';
const $7fce67e153198813$export$78acf4525d8a74c4 = 'xstate.stop';
/**
 * Returns an event that represents an implicit event that is sent after the
 * specified `delay`.
 *
 * @param delayRef The delay in milliseconds
 * @param id The state node ID where this event is handled
 */ function $7fce67e153198813$var$createAfterEvent(delayRef, id) {
    return {
        type: `xstate.after.${delayRef}.${id}`
    };
}
/**
 * Returns an event that represents that a final state node has been reached in
 * the parent state node.
 *
 * @param id The final state node's parent state node `id`
 * @param output The data to pass into the event
 */ function $7fce67e153198813$var$createDoneStateEvent(id, output) {
    return {
        type: `xstate.done.state.${id}`,
        output: output
    };
}
/**
 * Returns an event that represents that an invoked service has terminated.
 *
 * An invoked service is terminated when it has reached a top-level final state
 * node, but not when it is canceled.
 *
 * @param invokeId The invoked service ID
 * @param output The data to pass into the event
 */ function $7fce67e153198813$var$createDoneActorEvent(invokeId, output) {
    return {
        type: `xstate.done.actor.${invokeId}`,
        output: output,
        actorId: invokeId
    };
}
function $7fce67e153198813$export$71cec2538cb2c617(id, error) {
    return {
        type: `xstate.error.actor.${id}`,
        error: error,
        actorId: id
    };
}
function $7fce67e153198813$export$9e5f44173e64f162(input) {
    return {
        type: $7fce67e153198813$var$XSTATE_INIT,
        input: input
    };
}
/**
 * This function makes sure that unhandled errors are thrown in a separate
 * macrotask. It allows those errors to be detected by global error handlers and
 * reported to bug tracking services without interrupting our own stack of
 * execution.
 *
 * @param err Error to be thrown
 */ function $7fce67e153198813$var$reportUnhandledError(err) {
    setTimeout(()=>{
        throw err;
    });
}
const $7fce67e153198813$var$symbolObservable = (()=>typeof Symbol === 'function' && Symbol.observable || '@@observable')();
function $7fce67e153198813$export$b4171a6734a65d42(parentStateId, childStateId) {
    const parentStateValue = $7fce67e153198813$var$toStateValue(parentStateId);
    const childStateValue = $7fce67e153198813$var$toStateValue(childStateId);
    if (typeof childStateValue === 'string') {
        if (typeof parentStateValue === 'string') return childStateValue === parentStateValue;
        // Parent more specific than child
        return false;
    }
    if (typeof parentStateValue === 'string') return parentStateValue in childStateValue;
    return Object.keys(parentStateValue).every((key)=>{
        if (!(key in childStateValue)) return false;
        return $7fce67e153198813$export$b4171a6734a65d42(parentStateValue[key], childStateValue[key]);
    });
}
function $7fce67e153198813$export$90a7f3efeed30595(stateId) {
    if ($7fce67e153198813$var$isArray(stateId)) return stateId;
    const result = [];
    let segment = '';
    for(let i = 0; i < stateId.length; i++){
        const char = stateId.charCodeAt(i);
        switch(char){
            // \
            case 92:
                // consume the next character
                segment += stateId[i + 1];
                // and skip over it
                i++;
                continue;
            // .
            case 46:
                result.push(segment);
                segment = '';
                continue;
        }
        segment += stateId[i];
    }
    result.push(segment);
    return result;
}
function $7fce67e153198813$var$toStateValue(stateValue) {
    if ($7fce67e153198813$export$7f8ddf7c7c20b3cd(stateValue)) return stateValue.value;
    if (typeof stateValue !== 'string') return stateValue;
    const statePath = $7fce67e153198813$export$90a7f3efeed30595(stateValue);
    return $7fce67e153198813$export$3466f893ebf79586(statePath);
}
function $7fce67e153198813$export$3466f893ebf79586(statePath) {
    if (statePath.length === 1) return statePath[0];
    const value = {};
    let marker = value;
    for(let i = 0; i < statePath.length - 1; i++)if (i === statePath.length - 2) marker[statePath[i]] = statePath[i + 1];
    else {
        const previous = marker;
        marker = {};
        previous[statePath[i]] = marker;
    }
    return value;
}
function $7fce67e153198813$export$953cecd6e717a553(collection, iteratee) {
    const result = {};
    const collectionKeys = Object.keys(collection);
    for(let i = 0; i < collectionKeys.length; i++){
        const key = collectionKeys[i];
        result[key] = iteratee(collection[key], key, collection, i);
    }
    return result;
}
function $7fce67e153198813$var$toArrayStrict(value) {
    if ($7fce67e153198813$var$isArray(value)) return value;
    return [
        value
    ];
}
function $7fce67e153198813$export$625550452a3fa3ec(value) {
    if (value === undefined) return [];
    return $7fce67e153198813$var$toArrayStrict(value);
}
function $7fce67e153198813$var$resolveOutput(mapper, context, event, self) {
    if (typeof mapper === 'function') return mapper({
        context: context,
        event: event,
        self: self
    });
    return mapper;
}
function $7fce67e153198813$var$isArray(value) {
    return Array.isArray(value);
}
function $7fce67e153198813$var$isErrorActorEvent(event) {
    return event.type.startsWith('xstate.error.actor');
}
function $7fce67e153198813$export$407448d2b89b1813(configLike) {
    return $7fce67e153198813$var$toArrayStrict(configLike).map((transitionLike)=>{
        if (typeof transitionLike === 'undefined' || typeof transitionLike === 'string') return {
            target: transitionLike
        };
        return transitionLike;
    });
}
function $7fce67e153198813$var$normalizeTarget(target) {
    if (target === undefined || target === $7fce67e153198813$var$TARGETLESS_KEY) return undefined;
    return $7fce67e153198813$export$625550452a3fa3ec(target);
}
function $7fce67e153198813$export$61196ced6d74a310(nextHandler, errorHandler, completionHandler) {
    var _this, _this1, _this2;
    const isObserver = typeof nextHandler === 'object';
    const self = isObserver ? nextHandler : undefined;
    return {
        next: (_this = isObserver ? nextHandler.next : nextHandler) === null || _this === void 0 ? void 0 : _this.bind(self),
        error: (_this1 = isObserver ? nextHandler.error : errorHandler) === null || _this1 === void 0 ? void 0 : _this1.bind(self),
        complete: (_this2 = isObserver ? nextHandler.complete : completionHandler) === null || _this2 === void 0 ? void 0 : _this2.bind(self)
    };
}
function $7fce67e153198813$export$db3b6bfb95261072(stateNodeId, index) {
    return `${index}.${stateNodeId}`;
}
function $7fce67e153198813$export$df995fae86a55f06(machine, src) {
    const match = src.match(/^xstate\.invoke\.(\d+)\.(.*)/);
    if (!match) return machine.implementations.actors[src];
    const [, indexStr, nodeId] = match;
    const node = machine.getStateNodeById(nodeId);
    const invokeConfig = node.config.invoke;
    return (Array.isArray(invokeConfig) ? invokeConfig[indexStr] : invokeConfig).src;
}
function $7fce67e153198813$export$9bb611d729802a56(snapshot) {
    return [
        ...new Set([
            ...snapshot._nodes.flatMap((sn)=>sn.ownEvents)
        ])
    ];
}
function $7fce67e153198813$var$createScheduledEventId(actorRef, id) {
    return `${actorRef.sessionId}.${id}`;
}
let $7fce67e153198813$var$idCounter = 0;
function $7fce67e153198813$var$createSystem(rootActor, options) {
    const children = new Map();
    const keyedActors = new Map();
    const reverseKeyedActors = new WeakMap();
    const inspectionObservers = new Set();
    const timerMap = {};
    const { clock: clock, logger: logger } = options;
    const scheduler = {
        schedule: (source, target, event, delay, id = Math.random().toString(36).slice(2))=>{
            const scheduledEvent = {
                source: source,
                target: target,
                event: event,
                delay: delay,
                id: id,
                startedAt: Date.now()
            };
            const scheduledEventId = $7fce67e153198813$var$createScheduledEventId(source, id);
            system._snapshot._scheduledEvents[scheduledEventId] = scheduledEvent;
            const timeout = clock.setTimeout(()=>{
                delete timerMap[scheduledEventId];
                delete system._snapshot._scheduledEvents[scheduledEventId];
                system._relay(source, target, event);
            }, delay);
            timerMap[scheduledEventId] = timeout;
        },
        cancel: (source, id)=>{
            const scheduledEventId = $7fce67e153198813$var$createScheduledEventId(source, id);
            const timeout = timerMap[scheduledEventId];
            delete timerMap[scheduledEventId];
            delete system._snapshot._scheduledEvents[scheduledEventId];
            if (timeout !== undefined) clock.clearTimeout(timeout);
        },
        cancelAll: (actorRef)=>{
            for(const scheduledEventId in system._snapshot._scheduledEvents){
                const scheduledEvent = system._snapshot._scheduledEvents[scheduledEventId];
                if (scheduledEvent.source === actorRef) scheduler.cancel(actorRef, scheduledEvent.id);
            }
        }
    };
    const sendInspectionEvent = (event)=>{
        if (!inspectionObservers.size) return;
        const resolvedInspectionEvent = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, event), {
            rootId: rootActor.sessionId
        });
        inspectionObservers.forEach((observer)=>{
            var _observer_next;
            return (_observer_next = observer.next) === null || _observer_next === void 0 ? void 0 : _observer_next.call(observer, resolvedInspectionEvent);
        });
    };
    var _ref;
    const system = {
        _snapshot: {
            _scheduledEvents: (_ref = (options === null || options === void 0 ? void 0 : options.snapshot) && options.snapshot.scheduler) !== null && _ref !== void 0 ? _ref : {}
        },
        _bookId: ()=>`x:${$7fce67e153198813$var$idCounter++}`,
        _register: (sessionId, actorRef)=>{
            children.set(sessionId, actorRef);
            return sessionId;
        },
        _unregister: (actorRef)=>{
            children.delete(actorRef.sessionId);
            const systemId = reverseKeyedActors.get(actorRef);
            if (systemId !== undefined) {
                keyedActors.delete(systemId);
                reverseKeyedActors.delete(actorRef);
            }
        },
        get: (systemId)=>{
            return keyedActors.get(systemId);
        },
        _set: (systemId, actorRef)=>{
            const existing = keyedActors.get(systemId);
            if (existing && existing !== actorRef) throw new Error(`Actor with system ID '${systemId}' already exists.`);
            keyedActors.set(systemId, actorRef);
            reverseKeyedActors.set(actorRef, systemId);
        },
        inspect: (observerOrFn)=>{
            const observer = $7fce67e153198813$export$61196ced6d74a310(observerOrFn);
            inspectionObservers.add(observer);
            return {
                unsubscribe () {
                    inspectionObservers.delete(observer);
                }
            };
        },
        _sendInspectionEvent: sendInspectionEvent,
        _relay: (source, target, event)=>{
            system._sendInspectionEvent({
                type: '@xstate.event',
                sourceRef: source,
                actorRef: target,
                event: event
            });
            target._send(event);
        },
        scheduler: scheduler,
        getSnapshot: ()=>{
            return {
                _scheduledEvents: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, system._snapshot._scheduledEvents)
            };
        },
        start: ()=>{
            const scheduledEvents = system._snapshot._scheduledEvents;
            system._snapshot._scheduledEvents = {};
            for(const scheduledId in scheduledEvents){
                const { source: source, target: target, event: event, delay: delay, id: id } = scheduledEvents[scheduledId];
                scheduler.schedule(source, target, event, delay, id);
            }
        },
        _clock: clock,
        _logger: logger
    };
    return system;
}
// those are needed to make JSDoc `@link` work properly
let $7fce67e153198813$var$executingCustomAction = false;
const $7fce67e153198813$export$3d8c2f653ac9d0b9 = 1;
// those values are currently used by @xstate/react directly so it's important to keep the assigned values in sync
let $7fce67e153198813$export$971d5caa766a69d7 = /*#__PURE__*/ function(ProcessingStatus) {
    ProcessingStatus[ProcessingStatus["NotStarted"] = 0] = "NotStarted";
    ProcessingStatus[ProcessingStatus["Running"] = 1] = "Running";
    ProcessingStatus[ProcessingStatus["Stopped"] = 2] = "Stopped";
    return ProcessingStatus;
}({});
const $7fce67e153198813$var$defaultOptions = {
    clock: {
        setTimeout: (fn, ms)=>{
            return setTimeout(fn, ms);
        },
        clearTimeout: (id)=>{
            return clearTimeout(id);
        }
    },
    logger: console.log.bind(console),
    devTools: false
};
/**
 * An Actor is a running process that can receive events, send events and change
 * its behavior based on the events it receives, which can cause effects outside
 * of the actor. When you run a state machine, it becomes an actor.
 */ class $7fce67e153198813$export$ef35774e6d314e91 {
    _initState(persistedState) {
        try {
            var _this_options;
            this._snapshot = persistedState ? this.logic.restoreSnapshot ? this.logic.restoreSnapshot(persistedState, this._actorScope) : persistedState : this.logic.getInitialSnapshot(this._actorScope, (_this_options = this.options) === null || _this_options === void 0 ? void 0 : _this_options.input);
        } catch (err) {
            // if we get here then it means that we assign a value to this._snapshot that is not of the correct type
            // we can't get the true `TSnapshot & { status: 'error'; }`, it's impossible
            // so right now this is a lie of sorts
            this._snapshot = {
                status: 'error',
                output: undefined,
                error: err
            };
        }
    }
    update(snapshot, event) {
        // Update state
        this._snapshot = snapshot;
        // Execute deferred effects
        let deferredFn;
        while(deferredFn = this._deferred.shift())try {
            deferredFn();
        } catch (err) {
            // this error can only be caught when executing *initial* actions
            // it's the only time when we call actions provided by the user through those deferreds
            // when the actor is already running we always execute them synchronously while transitioning
            // no "builtin deferred" should actually throw an error since they are either safe
            // or the control flow is passed through the mailbox and errors should be caught by the `_process` used by the mailbox
            this._deferred.length = 0;
            this._snapshot = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, snapshot), {
                status: 'error',
                error: err
            });
        }
        switch(this._snapshot.status){
            case 'active':
                for (const observer of this.observers)try {
                    var _observer_next;
                    (_observer_next = observer.next) === null || _observer_next === void 0 ? void 0 : _observer_next.call(observer, snapshot);
                } catch (err) {
                    $7fce67e153198813$var$reportUnhandledError(err);
                }
                break;
            case 'done':
                // next observers are meant to be notified about done snapshots
                // this can be seen as something that is different from how observable work
                // but with observables `complete` callback is called without any arguments
                // it's more ergonomic for XState to treat a done snapshot as a "next" value
                // and the completion event as something that is separate,
                // something that merely follows emitting that done snapshot
                for (const observer of this.observers)try {
                    var _observer_next1;
                    (_observer_next1 = observer.next) === null || _observer_next1 === void 0 ? void 0 : _observer_next1.call(observer, snapshot);
                } catch (err) {
                    $7fce67e153198813$var$reportUnhandledError(err);
                }
                this._stopProcedure();
                this._complete();
                this._doneEvent = $7fce67e153198813$var$createDoneActorEvent(this.id, this._snapshot.output);
                if (this._parent) this.system._relay(this, this._parent, this._doneEvent);
                break;
            case 'error':
                this._error(this._snapshot.error);
                break;
        }
        this.system._sendInspectionEvent({
            type: '@xstate.snapshot',
            actorRef: this,
            event: event,
            snapshot: snapshot
        });
    }
    /**
   * Subscribe an observer to an actor’s snapshot values.
   *
   * @remarks
   * The observer will receive the actor’s snapshot value when it is emitted.
   * The observer can be:
   *
   * - A plain function that receives the latest snapshot, or
   * - An observer object whose `.next(snapshot)` method receives the latest
   *   snapshot
   *
   * @example
   *
   * ```ts
   * // Observer as a plain function
   * const subscription = actor.subscribe((snapshot) => {
   *   console.log(snapshot);
   * });
   * ```
   *
   * @example
   *
   * ```ts
   * // Observer as an object
   * const subscription = actor.subscribe({
   *   next(snapshot) {
   *     console.log(snapshot);
   *   },
   *   error(err) {
   *     // ...
   *   },
   *   complete() {
   *     // ...
   *   }
   * });
   * ```
   *
   * The return value of `actor.subscribe(observer)` is a subscription object
   * that has an `.unsubscribe()` method. You can call
   * `subscription.unsubscribe()` to unsubscribe the observer:
   *
   * @example
   *
   * ```ts
   * const subscription = actor.subscribe((snapshot) => {
   *   // ...
   * });
   *
   * // Unsubscribe the observer
   * subscription.unsubscribe();
   * ```
   *
   * When the actor is stopped, all of its observers will automatically be
   * unsubscribed.
   *
   * @param observer - Either a plain function that receives the latest
   *   snapshot, or an observer object whose `.next(snapshot)` method receives
   *   the latest snapshot
   */ subscribe(nextListenerOrObserver, errorListener, completeListener) {
        const observer = $7fce67e153198813$export$61196ced6d74a310(nextListenerOrObserver, errorListener, completeListener);
        if (this._processingStatus !== $7fce67e153198813$export$971d5caa766a69d7.Stopped) this.observers.add(observer);
        else switch(this._snapshot.status){
            case 'done':
                try {
                    var _observer_complete;
                    (_observer_complete = observer.complete) === null || _observer_complete === void 0 ? void 0 : _observer_complete.call(observer);
                } catch (err) {
                    $7fce67e153198813$var$reportUnhandledError(err);
                }
                break;
            case 'error':
                {
                    const err = this._snapshot.error;
                    if (!observer.error) $7fce67e153198813$var$reportUnhandledError(err);
                    else try {
                        observer.error(err);
                    } catch (err) {
                        $7fce67e153198813$var$reportUnhandledError(err);
                    }
                    break;
                }
        }
        return {
            unsubscribe: ()=>{
                this.observers.delete(observer);
            }
        };
    }
    on(type, handler) {
        let listeners = this.eventListeners.get(type);
        if (!listeners) {
            listeners = new Set();
            this.eventListeners.set(type, listeners);
        }
        const wrappedHandler = handler.bind(undefined);
        listeners.add(wrappedHandler);
        return {
            unsubscribe: ()=>{
                listeners.delete(wrappedHandler);
            }
        };
    }
    /** Starts the Actor from the initial state */ start() {
        if (this._processingStatus === $7fce67e153198813$export$971d5caa766a69d7.Running) // Do not restart the service if it is already started
        return this;
        if (this._syncSnapshot) this.subscribe({
            next: (snapshot)=>{
                if (snapshot.status === 'active') this.system._relay(this, this._parent, {
                    type: `xstate.snapshot.${this.id}`,
                    snapshot: snapshot
                });
            },
            error: ()=>{}
        });
        this.system._register(this.sessionId, this);
        if (this._systemId) this.system._set(this._systemId, this);
        this._processingStatus = $7fce67e153198813$export$971d5caa766a69d7.Running;
        // TODO: this isn't correct when rehydrating
        const initEvent = $7fce67e153198813$export$9e5f44173e64f162(this.options.input);
        this.system._sendInspectionEvent({
            type: '@xstate.event',
            sourceRef: this._parent,
            actorRef: this,
            event: initEvent
        });
        const status = this._snapshot.status;
        switch(status){
            case 'done':
                // a state machine can be "done" upon initialization (it could reach a final state using initial microsteps)
                // we still need to complete observers, flush deferreds etc
                this.update(this._snapshot, initEvent);
                // TODO: rethink cleanup of observers, mailbox, etc
                return this;
            case 'error':
                this._error(this._snapshot.error);
                return this;
        }
        if (!this._parent) this.system.start();
        if (this.logic.start) try {
            this.logic.start(this._snapshot, this._actorScope);
        } catch (err) {
            this._snapshot = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._snapshot), {
                status: 'error',
                error: err
            });
            this._error(err);
            return this;
        }
        // TODO: this notifies all subscribers but usually this is redundant
        // there is no real change happening here
        // we need to rethink if this needs to be refactored
        this.update(this._snapshot, initEvent);
        if (this.options.devTools) this.attachDevTools();
        this.mailbox.start();
        return this;
    }
    _process(event) {
        let nextState;
        let caughtError;
        try {
            nextState = this.logic.transition(this._snapshot, event, this._actorScope);
        } catch (err) {
            // we wrap it in a box so we can rethrow it later even if falsy value gets caught here
            caughtError = {
                err: err
            };
        }
        if (caughtError) {
            const { err: err } = caughtError;
            this._snapshot = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._snapshot), {
                status: 'error',
                error: err
            });
            this._error(err);
            return;
        }
        this.update(nextState, event);
        if (event.type === $7fce67e153198813$export$78acf4525d8a74c4) {
            this._stopProcedure();
            this._complete();
        }
    }
    _stop() {
        if (this._processingStatus === $7fce67e153198813$export$971d5caa766a69d7.Stopped) return this;
        this.mailbox.clear();
        if (this._processingStatus === $7fce67e153198813$export$971d5caa766a69d7.NotStarted) {
            this._processingStatus = $7fce67e153198813$export$971d5caa766a69d7.Stopped;
            return this;
        }
        this.mailbox.enqueue({
            type: $7fce67e153198813$export$78acf4525d8a74c4
        });
        return this;
    }
    /** Stops the Actor and unsubscribe all listeners. */ stop() {
        if (this._parent) throw new Error('A non-root actor cannot be stopped directly.');
        return this._stop();
    }
    _complete() {
        for (const observer of this.observers)try {
            var _observer_complete;
            (_observer_complete = observer.complete) === null || _observer_complete === void 0 ? void 0 : _observer_complete.call(observer);
        } catch (err) {
            $7fce67e153198813$var$reportUnhandledError(err);
        }
        this.observers.clear();
    }
    _reportError(err) {
        if (!this.observers.size) {
            if (!this._parent) $7fce67e153198813$var$reportUnhandledError(err);
            return;
        }
        let reportError = false;
        for (const observer of this.observers){
            const errorListener = observer.error;
            reportError || (reportError = !errorListener);
            try {
                errorListener === null || errorListener === void 0 ? void 0 : errorListener(err);
            } catch (err2) {
                $7fce67e153198813$var$reportUnhandledError(err2);
            }
        }
        this.observers.clear();
        if (reportError) $7fce67e153198813$var$reportUnhandledError(err);
    }
    _error(err) {
        this._stopProcedure();
        this._reportError(err);
        if (this._parent) this.system._relay(this, this._parent, $7fce67e153198813$export$71cec2538cb2c617(this.id, err));
    }
    // TODO: atm children don't belong entirely to the actor so
    // in a way - it's not even super aware of them
    // so we can't stop them from here but we really should!
    // right now, they are being stopped within the machine's transition
    // but that could throw and leave us with "orphaned" active actors
    _stopProcedure() {
        if (this._processingStatus !== $7fce67e153198813$export$971d5caa766a69d7.Running) // Actor already stopped; do nothing
        return this;
        // Cancel all delayed events
        this.system.scheduler.cancelAll(this);
        // TODO: mailbox.reset
        this.mailbox.clear();
        // TODO: after `stop` we must prepare ourselves for receiving events again
        // events sent *after* stop signal must be queued
        // it seems like this should be the common behavior for all of our consumers
        // so perhaps this should be unified somehow for all of them
        this.mailbox = new $7fce67e153198813$var$Mailbox(this._process.bind(this));
        this._processingStatus = $7fce67e153198813$export$971d5caa766a69d7.Stopped;
        this.system._unregister(this);
        return this;
    }
    /** @internal */ _send(event) {
        if (this._processingStatus === $7fce67e153198813$export$971d5caa766a69d7.Stopped) return;
        this.mailbox.enqueue(event);
    }
    /**
   * Sends an event to the running Actor to trigger a transition.
   *
   * @param event The event to send
   */ send(event) {
        this.system._relay(undefined, this, event);
    }
    attachDevTools() {
        const { devTools: devTools } = this.options;
        if (devTools) {
            const resolvedDevToolsAdapter = typeof devTools === 'function' ? devTools : (0, $b1135d4359ab083e$export$3ee8010769463234);
            resolvedDevToolsAdapter(this);
        }
    }
    toJSON() {
        return {
            xstate$$type: $7fce67e153198813$export$3d8c2f653ac9d0b9,
            id: this.id
        };
    }
    /**
   * Obtain the internal state of the actor, which can be persisted.
   *
   * @remarks
   * The internal state can be persisted from any actor, not only machines.
   *
   * Note that the persisted state is not the same as the snapshot from
   * {@link Actor.getSnapshot}. Persisted state represents the internal state of
   * the actor, while snapshots represent the actor's last emitted value.
   *
   * Can be restored with {@link ActorOptions.state}
   * @see https://stately.ai/docs/persistence
   */ getPersistedSnapshot(options) {
        return this.logic.getPersistedSnapshot(this._snapshot, options);
    }
    [$7fce67e153198813$var$symbolObservable]() {
        return this;
    }
    /**
   * Read an actor’s snapshot synchronously.
   *
   * @remarks
   * The snapshot represent an actor's last emitted value.
   *
   * When an actor receives an event, its internal state may change. An actor
   * may emit a snapshot when a state transition occurs.
   *
   * Note that some actors, such as callback actors generated with
   * `fromCallback`, will not emit snapshots.
   * @see {@link Actor.subscribe} to subscribe to an actor’s snapshot values.
   * @see {@link Actor.getPersistedSnapshot} to persist the internal state of an actor (which is more than just a snapshot).
   */ getSnapshot() {
        return this._snapshot;
    }
    /**
   * Creates a new actor instance for the given logic with the provided options,
   * if any.
   *
   * @param logic The logic to create an actor from
   * @param options Actor options
   */ constructor(logic, options){
        this.logic = logic;
        /** The current internal state of the actor. */ this._snapshot = void 0;
        /**
     * The clock that is responsible for setting and clearing timeouts, such as
     * delayed events and transitions.
     */ this.clock = void 0;
        this.options = void 0;
        /** The unique identifier for this actor relative to its parent. */ this.id = void 0;
        this.mailbox = new $7fce67e153198813$var$Mailbox(this._process.bind(this));
        this.observers = new Set();
        this.eventListeners = new Map();
        this.logger = void 0;
        /** @internal */ this._processingStatus = $7fce67e153198813$export$971d5caa766a69d7.NotStarted;
        // Actor Ref
        this._parent = void 0;
        /** @internal */ this._syncSnapshot = void 0;
        this.ref = void 0;
        // TODO: add typings for system
        this._actorScope = void 0;
        this._systemId = void 0;
        /** The globally unique process ID for this invocation. */ this.sessionId = void 0;
        /** The system to which this actor belongs. */ this.system = void 0;
        this._doneEvent = void 0;
        this.src = void 0;
        // array of functions to defer
        this._deferred = [];
        const resolvedOptions = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $7fce67e153198813$var$defaultOptions, options);
        const { clock: clock, logger: logger, parent: parent, syncSnapshot: syncSnapshot, id: id, systemId: systemId, inspect: inspect } = resolvedOptions;
        this.system = parent ? parent.system : $7fce67e153198813$var$createSystem(this, {
            clock: clock,
            logger: logger
        });
        if (inspect && !parent) // Always inspect at the system-level
        this.system.inspect($7fce67e153198813$export$61196ced6d74a310(inspect));
        this.sessionId = this.system._bookId();
        this.id = id !== null && id !== void 0 ? id : this.sessionId;
        var _options_logger;
        this.logger = (_options_logger = options === null || options === void 0 ? void 0 : options.logger) !== null && _options_logger !== void 0 ? _options_logger : this.system._logger;
        var _options_clock;
        this.clock = (_options_clock = options === null || options === void 0 ? void 0 : options.clock) !== null && _options_clock !== void 0 ? _options_clock : this.system._clock;
        this._parent = parent;
        this._syncSnapshot = syncSnapshot;
        this.options = resolvedOptions;
        var _resolvedOptions_src;
        this.src = (_resolvedOptions_src = resolvedOptions.src) !== null && _resolvedOptions_src !== void 0 ? _resolvedOptions_src : logic;
        this.ref = this;
        this._actorScope = {
            self: this,
            id: this.id,
            sessionId: this.sessionId,
            logger: this.logger,
            defer: (fn)=>{
                this._deferred.push(fn);
            },
            system: this.system,
            stopChild: (child)=>{
                if (child._parent !== this) throw new Error(`Cannot stop child actor ${child.id} of ${this.id} because it is not a child`);
                child._stop();
            },
            emit: (emittedEvent)=>{
                const listeners = this.eventListeners.get(emittedEvent.type);
                const wildcardListener = this.eventListeners.get('*');
                if (!listeners && !wildcardListener) return;
                const allListeners = [
                    ...listeners ? listeners.values() : [],
                    ...wildcardListener ? wildcardListener.values() : []
                ];
                for (const handler of allListeners)handler(emittedEvent);
            },
            actionExecutor: (action)=>{
                const exec = ()=>{
                    this._actorScope.system._sendInspectionEvent({
                        type: '@xstate.action',
                        actorRef: this,
                        action: {
                            type: action.type,
                            params: action.params
                        }
                    });
                    if (!action.exec) return;
                    const saveExecutingCustomAction = $7fce67e153198813$var$executingCustomAction;
                    try {
                        $7fce67e153198813$var$executingCustomAction = true;
                        action.exec(action.info, action.params);
                    } finally{
                        $7fce67e153198813$var$executingCustomAction = saveExecutingCustomAction;
                    }
                };
                if (this._processingStatus === $7fce67e153198813$export$971d5caa766a69d7.Running) exec();
                else this._deferred.push(exec);
            }
        };
        // Ensure that the send method is bound to this Actor instance
        // if destructured
        this.send = this.send.bind(this);
        this.system._sendInspectionEvent({
            type: '@xstate.actor',
            actorRef: this
        });
        if (systemId) {
            this._systemId = systemId;
            this.system._set(systemId, this);
        }
        var _options_snapshot;
        this._initState((_options_snapshot = options === null || options === void 0 ? void 0 : options.snapshot) !== null && _options_snapshot !== void 0 ? _options_snapshot : options === null || options === void 0 ? void 0 : options.state);
        if (systemId && this._snapshot.status !== 'active') this.system._unregister(this);
    }
}
/**
 * Creates a new actor instance for the given actor logic with the provided
 * options, if any.
 *
 * @remarks
 * When you create an actor from actor logic via `createActor(logic)`, you
 * implicitly create an actor system where the created actor is the root actor.
 * Any actors spawned from this root actor and its descendants are part of that
 * actor system.
 * @example
 *
 * ```ts
 * import { createActor } from 'xstate';
 * import { someActorLogic } from './someActorLogic.ts';
 *
 * // Creating the actor, which implicitly creates an actor system with itself as the root actor
 * const actor = createActor(someActorLogic);
 *
 * actor.subscribe((snapshot) => {
 *   console.log(snapshot);
 * });
 *
 * // Actors must be started by calling `actor.start()`, which will also start the actor system.
 * actor.start();
 *
 * // Actors can receive events
 * actor.send({ type: 'someEvent' });
 *
 * // You can stop root actors by calling `actor.stop()`, which will also stop the actor system and all actors in that system.
 * actor.stop();
 * ```
 *
 * @param logic - The actor logic to create an actor from. For a state machine
 *   actor logic creator, see {@link createMachine}. Other actor logic creators
 *   include {@link fromCallback}, {@link fromEventObservable},
 *   {@link fromObservable}, {@link fromPromise}, and {@link fromTransition}.
 * @param options - Actor options
 */ function $7fce67e153198813$export$ebd11618f299a286(logic, ...[options]) {
    return new $7fce67e153198813$export$ef35774e6d314e91(logic, options);
}
/**
 * Creates a new Interpreter instance for the given machine with the provided
 * options, if any.
 *
 * @deprecated Use `createActor` instead
 * @alias
 */ const $7fce67e153198813$export$e7094788287c5e9b = $7fce67e153198813$export$ebd11618f299a286;
/**
 * @deprecated Use `Actor` instead.
 * @alias
 */ function $7fce67e153198813$var$resolveCancel(_, snapshot, actionArgs, actionParams, { sendId: sendId }) {
    const resolvedSendId = typeof sendId === 'function' ? sendId(actionArgs, actionParams) : sendId;
    return [
        snapshot,
        {
            sendId: resolvedSendId
        },
        undefined
    ];
}
function $7fce67e153198813$var$executeCancel(actorScope, params) {
    actorScope.defer(()=>{
        actorScope.system.scheduler.cancel(actorScope.self, params.sendId);
    });
}
/**
 * Cancels a delayed `sendTo(...)` action that is waiting to be executed. The
 * canceled `sendTo(...)` action will not send its event or execute, unless the
 * `delay` has already elapsed before `cancel(...)` is called.
 *
 * @example
 *
 * ```ts
 * import { createMachine, sendTo, cancel } from 'xstate';
 *
 * const machine = createMachine({
 *   // ...
 *   on: {
 *     sendEvent: {
 *       actions: sendTo(
 *         'some-actor',
 *         { type: 'someEvent' },
 *         {
 *           id: 'some-id',
 *           delay: 1000
 *         }
 *       )
 *     },
 *     cancelEvent: {
 *       actions: cancel('some-id')
 *     }
 *   }
 * });
 * ```
 *
 * @param sendId The `id` of the `sendTo(...)` action to cancel.
 */ function $7fce67e153198813$export$3a1a48c8f6ef640e(sendId) {
    function cancel(_args, _params) {}
    cancel.type = 'xstate.cancel';
    cancel.sendId = sendId;
    cancel.resolve = $7fce67e153198813$var$resolveCancel;
    cancel.execute = $7fce67e153198813$var$executeCancel;
    return cancel;
}
function $7fce67e153198813$var$resolveSpawn(actorScope, snapshot, actionArgs, _actionParams, { id: id, systemId: systemId, src: src, input: input, syncSnapshot: syncSnapshot }) {
    const logic = typeof src === 'string' ? $7fce67e153198813$export$df995fae86a55f06(snapshot.machine, src) : src;
    const resolvedId = typeof id === 'function' ? id(actionArgs) : id;
    let actorRef;
    let resolvedInput = undefined;
    if (logic) {
        resolvedInput = typeof input === 'function' ? input({
            context: snapshot.context,
            event: actionArgs.event,
            self: actorScope.self
        }) : input;
        actorRef = $7fce67e153198813$export$ebd11618f299a286(logic, {
            id: resolvedId,
            src: src,
            parent: actorScope.self,
            syncSnapshot: syncSnapshot,
            systemId: systemId,
            input: resolvedInput
        });
    }
    return [
        $7fce67e153198813$export$3a6d5c9ae78a2c08(snapshot, {
            children: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, snapshot.children), {
                [resolvedId]: actorRef
            })
        }),
        {
            id: id,
            systemId: systemId,
            actorRef: actorRef,
            src: src,
            input: resolvedInput
        },
        undefined
    ];
}
function $7fce67e153198813$var$executeSpawn(actorScope, { actorRef: actorRef }) {
    if (!actorRef) return;
    actorScope.defer(()=>{
        if (actorRef._processingStatus === $7fce67e153198813$export$971d5caa766a69d7.Stopped) return;
        actorRef.start();
    });
}
function $7fce67e153198813$export$56c0d5a1e737357d(...[src, { id: id, systemId: systemId, input: input, syncSnapshot: syncSnapshot = false } = {}]) {
    function spawnChild1(_args, _params) {}
    spawnChild1.type = 'xstate.spawnChild';
    spawnChild1.id = id;
    spawnChild1.systemId = systemId;
    spawnChild1.src = src;
    spawnChild1.input = input;
    spawnChild1.syncSnapshot = syncSnapshot;
    spawnChild1.resolve = $7fce67e153198813$var$resolveSpawn;
    spawnChild1.execute = $7fce67e153198813$var$executeSpawn;
    return spawnChild1;
}
function $7fce67e153198813$var$resolveStop(_, snapshot, args, actionParams, { actorRef: actorRef }) {
    const actorRefOrString = typeof actorRef === 'function' ? actorRef(args, actionParams) : actorRef;
    const resolvedActorRef = typeof actorRefOrString === 'string' ? snapshot.children[actorRefOrString] : actorRefOrString;
    let children = snapshot.children;
    if (resolvedActorRef) {
        children = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, children);
        delete children[resolvedActorRef.id];
    }
    return [
        $7fce67e153198813$export$3a6d5c9ae78a2c08(snapshot, {
            children: children
        }),
        resolvedActorRef,
        undefined
    ];
}
function $7fce67e153198813$var$executeStop(actorScope, actorRef) {
    if (!actorRef) return;
    // we need to eagerly unregister it here so a new actor with the same systemId can be registered immediately
    // since we defer actual stopping of the actor but we don't defer actor creations (and we can't do that)
    // this could throw on `systemId` collision, for example, when dealing with reentering transitions
    actorScope.system._unregister(actorRef);
    // this allows us to prevent an actor from being started if it gets stopped within the same macrostep
    // this can happen, for example, when the invoking state is being exited immediately by an always transition
    if (actorRef._processingStatus !== $7fce67e153198813$export$971d5caa766a69d7.Running) {
        actorScope.stopChild(actorRef);
        return;
    }
    // stopping a child enqueues a stop event in the child actor's mailbox
    // we need for all of the already enqueued events to be processed before we stop the child
    // the parent itself might want to send some events to a child (for example from exit actions on the invoking state)
    // and we don't want to ignore those events
    actorScope.defer(()=>{
        actorScope.stopChild(actorRef);
    });
}
/**
 * Stops a child actor.
 *
 * @param actorRef The actor to stop.
 */ function $7fce67e153198813$export$db202ddc8be9136(actorRef) {
    function stop(_args, _params) {}
    stop.type = 'xstate.stopChild';
    stop.actorRef = actorRef;
    stop.resolve = $7fce67e153198813$var$resolveStop;
    stop.execute = $7fce67e153198813$var$executeStop;
    return stop;
}
/**
 * Stops a child actor.
 *
 * @deprecated Use `stopChild(...)` instead
 * @alias
 */ const $7fce67e153198813$export$3722cfe417b6ed86 = $7fce67e153198813$export$db202ddc8be9136;
function $7fce67e153198813$var$checkStateIn(snapshot, _, { stateValue: stateValue }) {
    if (typeof stateValue === 'string' && $7fce67e153198813$export$efccba1c4a2ef57b(stateValue)) {
        const target = snapshot.machine.getStateNodeById(stateValue);
        return snapshot._nodes.some((sn)=>sn === target);
    }
    return snapshot.matches(stateValue);
}
function $7fce67e153198813$export$2329c99376c9d0a4(stateValue) {
    function stateIn() {
        return false;
    }
    stateIn.check = $7fce67e153198813$var$checkStateIn;
    stateIn.stateValue = stateValue;
    return stateIn;
}
function $7fce67e153198813$var$checkNot(snapshot, { context: context, event: event }, { guards: guards }) {
    return !$7fce67e153198813$export$f1e1789686576879(guards[0], context, event, snapshot);
}
/**
 * Higher-order guard that evaluates to `true` if the `guard` passed to it
 * evaluates to `false`.
 *
 * @category Guards
 * @example
 *
 * ```ts
 * import { setup, not } from 'xstate';
 *
 * const machine = setup({
 *   guards: {
 *     someNamedGuard: () => false
 *   }
 * }).createMachine({
 *   on: {
 *     someEvent: {
 *       guard: not('someNamedGuard'),
 *       actions: () => {
 *         // will be executed if guard in `not(...)`
 *         // evaluates to `false`
 *       }
 *     }
 *   }
 * });
 * ```
 *
 * @returns A guard
 */ function $7fce67e153198813$export$a9c23c6ac3fc3eca(guard) {
    function not(_args, _params) {
        return false;
    }
    not.check = $7fce67e153198813$var$checkNot;
    not.guards = [
        guard
    ];
    return not;
}
function $7fce67e153198813$var$checkAnd(snapshot, { context: context, event: event }, { guards: guards }) {
    return guards.every((guard)=>$7fce67e153198813$export$f1e1789686576879(guard, context, event, snapshot));
}
/**
 * Higher-order guard that evaluates to `true` if all `guards` passed to it
 * evaluate to `true`.
 *
 * @category Guards
 * @example
 *
 * ```ts
 * import { setup, and } from 'xstate';
 *
 * const machine = setup({
 *   guards: {
 *     someNamedGuard: () => true
 *   }
 * }).createMachine({
 *   on: {
 *     someEvent: {
 *       guard: and([({ context }) => context.value > 0, 'someNamedGuard']),
 *       actions: () => {
 *         // will be executed if all guards in `and(...)`
 *         // evaluate to true
 *       }
 *     }
 *   }
 * });
 * ```
 *
 * @returns A guard action object
 */ function $7fce67e153198813$export$96f57966bedc81b4(guards) {
    function and(_args, _params) {
        return false;
    }
    and.check = $7fce67e153198813$var$checkAnd;
    and.guards = guards;
    return and;
}
function $7fce67e153198813$var$checkOr(snapshot, { context: context, event: event }, { guards: guards }) {
    return guards.some((guard)=>$7fce67e153198813$export$f1e1789686576879(guard, context, event, snapshot));
}
/**
 * Higher-order guard that evaluates to `true` if any of the `guards` passed to
 * it evaluate to `true`.
 *
 * @category Guards
 * @example
 *
 * ```ts
 * import { setup, or } from 'xstate';
 *
 * const machine = setup({
 *   guards: {
 *     someNamedGuard: () => true
 *   }
 * }).createMachine({
 *   on: {
 *     someEvent: {
 *       guard: or([({ context }) => context.value > 0, 'someNamedGuard']),
 *       actions: () => {
 *         // will be executed if any of the guards in `or(...)`
 *         // evaluate to true
 *       }
 *     }
 *   }
 * });
 * ```
 *
 * @returns A guard action object
 */ function $7fce67e153198813$export$d66501df72047452(guards) {
    function or(_args, _params) {
        return false;
    }
    or.check = $7fce67e153198813$var$checkOr;
    or.guards = guards;
    return or;
}
// TODO: throw on cycles (depth check should be enough)
function $7fce67e153198813$export$f1e1789686576879(guard, context, event, snapshot) {
    const { machine: machine } = snapshot;
    const isInline = typeof guard === 'function';
    const resolved = isInline ? guard : machine.implementations.guards[typeof guard === 'string' ? guard : guard.type];
    if (!isInline && !resolved) throw new Error(`Guard '${typeof guard === 'string' ? guard : guard.type}' is not implemented.'.`);
    if (typeof resolved !== 'function') return $7fce67e153198813$export$f1e1789686576879(resolved, context, event, snapshot);
    const guardArgs = {
        context: context,
        event: event
    };
    const guardParams = isInline || typeof guard === 'string' ? undefined : 'params' in guard ? typeof guard.params === 'function' ? guard.params({
        context: context,
        event: event
    }) : guard.params : undefined;
    if (!('check' in resolved)) // the existing type of `.guards` assumes non-nullable `TExpressionGuard`
    // inline guards expect `TExpressionGuard` to be set to `undefined`
    // it's fine to cast this here, our logic makes sure that we call those 2 "variants" correctly
    return resolved(guardArgs, guardParams);
    const builtinGuard = resolved;
    return builtinGuard.check(snapshot, guardArgs, resolved // this holds all params
    );
}
const $7fce67e153198813$var$isAtomicStateNode = (stateNode)=>stateNode.type === 'atomic' || stateNode.type === 'final';
function $7fce67e153198813$var$getChildren(stateNode) {
    return Object.values(stateNode.states).filter((sn)=>sn.type !== 'history');
}
function $7fce67e153198813$var$getProperAncestors(stateNode, toStateNode) {
    const ancestors = [];
    if (toStateNode === stateNode) return ancestors;
    // add all ancestors
    let m = stateNode.parent;
    while(m && m !== toStateNode){
        ancestors.push(m);
        m = m.parent;
    }
    return ancestors;
}
function $7fce67e153198813$export$23f2a1d2818174ef(stateNodes) {
    const nodeSet = new Set(stateNodes);
    const adjList = $7fce67e153198813$var$getAdjList(nodeSet);
    // add descendants
    for (const s of nodeSet)// if previously active, add existing child nodes
    if (s.type === 'compound' && (!adjList.get(s) || !adjList.get(s).length)) $7fce67e153198813$var$getInitialStateNodesWithTheirAncestors(s).forEach((sn)=>nodeSet.add(sn));
    else {
        if (s.type === 'parallel') for (const child of $7fce67e153198813$var$getChildren(s)){
            if (child.type === 'history') continue;
            if (!nodeSet.has(child)) {
                const initialStates = $7fce67e153198813$var$getInitialStateNodesWithTheirAncestors(child);
                for (const initialStateNode of initialStates)nodeSet.add(initialStateNode);
            }
        }
    }
    // add all ancestors
    for (const s of nodeSet){
        let m = s.parent;
        while(m){
            nodeSet.add(m);
            m = m.parent;
        }
    }
    return nodeSet;
}
function $7fce67e153198813$var$getValueFromAdj(baseNode, adjList) {
    const childStateNodes = adjList.get(baseNode);
    if (!childStateNodes) return {}; // todo: fix?
    if (baseNode.type === 'compound') {
        const childStateNode = childStateNodes[0];
        if (childStateNode) {
            if ($7fce67e153198813$var$isAtomicStateNode(childStateNode)) return childStateNode.key;
        } else return {};
    }
    const stateValue = {};
    for (const childStateNode of childStateNodes)stateValue[childStateNode.key] = $7fce67e153198813$var$getValueFromAdj(childStateNode, adjList);
    return stateValue;
}
function $7fce67e153198813$var$getAdjList(stateNodes) {
    const adjList = new Map();
    for (const s of stateNodes){
        if (!adjList.has(s)) adjList.set(s, []);
        if (s.parent) {
            if (!adjList.has(s.parent)) adjList.set(s.parent, []);
            adjList.get(s.parent).push(s);
        }
    }
    return adjList;
}
function $7fce67e153198813$var$getStateValue(rootNode, stateNodes) {
    const config = $7fce67e153198813$export$23f2a1d2818174ef(stateNodes);
    return $7fce67e153198813$var$getValueFromAdj(rootNode, $7fce67e153198813$var$getAdjList(config));
}
function $7fce67e153198813$export$882b5998b3b9117c(stateNodeSet, stateNode) {
    if (stateNode.type === 'compound') return $7fce67e153198813$var$getChildren(stateNode).some((s)=>s.type === 'final' && stateNodeSet.has(s));
    if (stateNode.type === 'parallel') return $7fce67e153198813$var$getChildren(stateNode).every((sn)=>$7fce67e153198813$export$882b5998b3b9117c(stateNodeSet, sn));
    return stateNode.type === 'final';
}
const $7fce67e153198813$export$efccba1c4a2ef57b = (str)=>str[0] === $7fce67e153198813$var$STATE_IDENTIFIER;
function $7fce67e153198813$export$dda1d9f60106f0e9(stateNode, receivedEventType) {
    const candidates = stateNode.transitions.get(receivedEventType) || [
        ...stateNode.transitions.keys()
    ].filter((eventDescriptor)=>{
        // check if transition is a wildcard transition,
        // which matches any non-transient events
        if (eventDescriptor === $7fce67e153198813$var$WILDCARD) return true;
        if (!eventDescriptor.endsWith('.*')) return false;
        const partialEventTokens = eventDescriptor.split('.');
        const eventTokens = receivedEventType.split('.');
        for(let tokenIndex = 0; tokenIndex < partialEventTokens.length; tokenIndex++){
            const partialEventToken = partialEventTokens[tokenIndex];
            const eventToken = eventTokens[tokenIndex];
            if (partialEventToken === '*') {
                const isLastToken = tokenIndex === partialEventTokens.length - 1;
                return isLastToken;
            }
            if (partialEventToken !== eventToken) return false;
        }
        return true;
    }).sort((a, b)=>b.length - a.length).flatMap((key)=>stateNode.transitions.get(key));
    return candidates;
}
/** All delayed transitions from the config. */ function $7fce67e153198813$export$39b482c5e57630a8(stateNode) {
    const afterConfig = stateNode.config.after;
    if (!afterConfig) return [];
    const mutateEntryExit = (delay)=>{
        const afterEvent = $7fce67e153198813$var$createAfterEvent(delay, stateNode.id);
        const eventType = afterEvent.type;
        stateNode.entry.push($7fce67e153198813$export$c4ce752e73470fba(afterEvent, {
            id: eventType,
            delay: delay
        }));
        stateNode.exit.push($7fce67e153198813$export$3a1a48c8f6ef640e(eventType));
        return eventType;
    };
    const delayedTransitions = Object.keys(afterConfig).flatMap((delay)=>{
        const configTransition = afterConfig[delay];
        const resolvedTransition = typeof configTransition === 'string' ? {
            target: configTransition
        } : configTransition;
        const resolvedDelay = Number.isNaN(+delay) ? delay : +delay;
        const eventType = mutateEntryExit(resolvedDelay);
        return $7fce67e153198813$export$625550452a3fa3ec(resolvedTransition).map((transition)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, transition), {
                event: eventType,
                delay: resolvedDelay
            }));
    });
    return delayedTransitions.map((delayedTransition)=>{
        const { delay: delay } = delayedTransition;
        return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $7fce67e153198813$export$8b22cf2602fb60ce(stateNode, delayedTransition.event, delayedTransition)), {
            delay: delay
        });
    });
}
function $7fce67e153198813$export$8b22cf2602fb60ce(stateNode, descriptor, transitionConfig) {
    const normalizedTarget = $7fce67e153198813$var$normalizeTarget(transitionConfig.target);
    var _transitionConfig_reenter;
    const reenter = (_transitionConfig_reenter = transitionConfig.reenter) !== null && _transitionConfig_reenter !== void 0 ? _transitionConfig_reenter : false;
    const target = $7fce67e153198813$var$resolveTarget(stateNode, normalizedTarget);
    const transition = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, transitionConfig), {
        actions: $7fce67e153198813$export$625550452a3fa3ec(transitionConfig.actions),
        guard: transitionConfig.guard,
        target: target,
        source: stateNode,
        reenter: reenter,
        eventType: descriptor,
        toJSON: ()=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, transition), {
                source: `#${stateNode.id}`,
                target: target ? target.map((t)=>`#${t.id}`) : undefined
            })
    });
    return transition;
}
function $7fce67e153198813$export$2d1720544b23b823(stateNode) {
    const transitions = new Map();
    if (stateNode.config.on) for (const descriptor of Object.keys(stateNode.config.on)){
        if (descriptor === $7fce67e153198813$export$a07804094c3ecf2d) throw new Error('Null events ("") cannot be specified as a transition key. Use `always: { ... }` instead.');
        const transitionsConfig = stateNode.config.on[descriptor];
        transitions.set(descriptor, $7fce67e153198813$export$407448d2b89b1813(transitionsConfig).map((t)=>$7fce67e153198813$export$8b22cf2602fb60ce(stateNode, descriptor, t)));
    }
    if (stateNode.config.onDone) {
        const descriptor = `xstate.done.state.${stateNode.id}`;
        transitions.set(descriptor, $7fce67e153198813$export$407448d2b89b1813(stateNode.config.onDone).map((t)=>$7fce67e153198813$export$8b22cf2602fb60ce(stateNode, descriptor, t)));
    }
    for (const invokeDef of stateNode.invoke){
        if (invokeDef.onDone) {
            const descriptor = `xstate.done.actor.${invokeDef.id}`;
            transitions.set(descriptor, $7fce67e153198813$export$407448d2b89b1813(invokeDef.onDone).map((t)=>$7fce67e153198813$export$8b22cf2602fb60ce(stateNode, descriptor, t)));
        }
        if (invokeDef.onError) {
            const descriptor = `xstate.error.actor.${invokeDef.id}`;
            transitions.set(descriptor, $7fce67e153198813$export$407448d2b89b1813(invokeDef.onError).map((t)=>$7fce67e153198813$export$8b22cf2602fb60ce(stateNode, descriptor, t)));
        }
        if (invokeDef.onSnapshot) {
            const descriptor = `xstate.snapshot.${invokeDef.id}`;
            transitions.set(descriptor, $7fce67e153198813$export$407448d2b89b1813(invokeDef.onSnapshot).map((t)=>$7fce67e153198813$export$8b22cf2602fb60ce(stateNode, descriptor, t)));
        }
    }
    for (const delayedTransition of stateNode.after){
        let existing = transitions.get(delayedTransition.eventType);
        if (!existing) {
            existing = [];
            transitions.set(delayedTransition.eventType, existing);
        }
        existing.push(delayedTransition);
    }
    return transitions;
}
function $7fce67e153198813$export$4368d992c4eafac0(stateNode, _target) {
    const resolvedTarget = typeof _target === 'string' ? stateNode.states[_target] : _target ? stateNode.states[_target.target] : undefined;
    if (!resolvedTarget && _target) throw new Error(// eslint-disable-next-line @typescript-eslint/restrict-template-expressions, @typescript-eslint/no-base-to-string
    `Initial state node "${_target}" not found on parent state node #${stateNode.id}`);
    const transition = {
        source: stateNode,
        actions: !_target || typeof _target === 'string' ? [] : $7fce67e153198813$export$625550452a3fa3ec(_target.actions),
        eventType: null,
        reenter: false,
        target: resolvedTarget ? [
            resolvedTarget
        ] : [],
        toJSON: ()=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, transition), {
                source: `#${stateNode.id}`,
                target: resolvedTarget ? [
                    `#${resolvedTarget.id}`
                ] : []
            })
    };
    return transition;
}
function $7fce67e153198813$var$resolveTarget(stateNode, targets) {
    if (targets === undefined) // an undefined target signals that the state node should not transition from that state when receiving that event
    return undefined;
    return targets.map((target)=>{
        if (typeof target !== 'string') return target;
        if ($7fce67e153198813$export$efccba1c4a2ef57b(target)) return stateNode.machine.getStateNodeById(target);
        const isInternalTarget = target[0] === $7fce67e153198813$export$25ce5a424b770e84;
        // If internal target is defined on machine,
        // do not include machine key on target
        if (isInternalTarget && !stateNode.parent) return $7fce67e153198813$export$d141bba7fdc215a3(stateNode, target.slice(1));
        const resolvedTarget = isInternalTarget ? stateNode.key + target : target;
        if (stateNode.parent) try {
            const targetStateNode = $7fce67e153198813$export$d141bba7fdc215a3(stateNode.parent, resolvedTarget);
            return targetStateNode;
        } catch (err) {
            throw new Error(`Invalid transition definition for state node '${stateNode.id}':\n${err.message}`);
        }
        else throw new Error(`Invalid target: "${target}" is not a valid target from the root node. Did you mean ".${target}"?`);
    });
}
function $7fce67e153198813$var$resolveHistoryDefaultTransition(stateNode) {
    const normalizedTarget = $7fce67e153198813$var$normalizeTarget(stateNode.config.target);
    if (!normalizedTarget) return stateNode.parent.initial;
    return {
        target: normalizedTarget.map((t)=>typeof t === 'string' ? $7fce67e153198813$export$d141bba7fdc215a3(stateNode.parent, t) : t)
    };
}
function $7fce67e153198813$var$isHistoryNode(stateNode) {
    return stateNode.type === 'history';
}
function $7fce67e153198813$var$getInitialStateNodesWithTheirAncestors(stateNode) {
    const states = $7fce67e153198813$export$3b14a55fb2447963(stateNode);
    for (const initialState of states)for (const ancestor of $7fce67e153198813$var$getProperAncestors(initialState, stateNode))states.add(ancestor);
    return states;
}
function $7fce67e153198813$export$3b14a55fb2447963(stateNode) {
    const set = new Set();
    function iter(descStateNode) {
        if (set.has(descStateNode)) return;
        set.add(descStateNode);
        if (descStateNode.type === 'compound') iter(descStateNode.initial.target[0]);
        else if (descStateNode.type === 'parallel') for (const child of $7fce67e153198813$var$getChildren(descStateNode))iter(child);
    }
    iter(stateNode);
    return set;
}
/** Returns the child state node from its relative `stateKey`, or throws. */ function $7fce67e153198813$var$getStateNode(stateNode, stateKey) {
    if ($7fce67e153198813$export$efccba1c4a2ef57b(stateKey)) return stateNode.machine.getStateNodeById(stateKey);
    if (!stateNode.states) throw new Error(`Unable to retrieve child state '${stateKey}' from '${stateNode.id}'; no child states exist.`);
    const result = stateNode.states[stateKey];
    if (!result) throw new Error(`Child state '${stateKey}' does not exist on '${stateNode.id}'`);
    return result;
}
/**
 * Returns the relative state node from the given `statePath`, or throws.
 *
 * @param statePath The string or string array relative path to the state node.
 */ function $7fce67e153198813$export$d141bba7fdc215a3(stateNode, statePath) {
    if (typeof statePath === 'string' && $7fce67e153198813$export$efccba1c4a2ef57b(statePath)) try {
        return stateNode.machine.getStateNodeById(statePath);
    } catch (e) {
    // try individual paths
    // throw e;
    }
    const arrayStatePath = $7fce67e153198813$export$90a7f3efeed30595(statePath).slice();
    let currentStateNode = stateNode;
    while(arrayStatePath.length){
        const key = arrayStatePath.shift();
        if (!key.length) break;
        currentStateNode = $7fce67e153198813$var$getStateNode(currentStateNode, key);
    }
    return currentStateNode;
}
/**
 * Returns the state nodes represented by the current state value.
 *
 * @param stateValue The state value or State instance
 */ function $7fce67e153198813$export$35e795649ee09318(stateNode, stateValue) {
    if (typeof stateValue === 'string') {
        const childStateNode = stateNode.states[stateValue];
        if (!childStateNode) throw new Error(`State '${stateValue}' does not exist on '${stateNode.id}'`);
        return [
            stateNode,
            childStateNode
        ];
    }
    const childStateKeys = Object.keys(stateValue);
    const childStateNodes = childStateKeys.map((subStateKey)=>$7fce67e153198813$var$getStateNode(stateNode, subStateKey)).filter(Boolean);
    return [
        stateNode.machine.root,
        stateNode
    ].concat(childStateNodes, childStateKeys.reduce((allSubStateNodes, subStateKey)=>{
        const subStateNode = $7fce67e153198813$var$getStateNode(stateNode, subStateKey);
        if (!subStateNode) return allSubStateNodes;
        const subStateNodes = $7fce67e153198813$export$35e795649ee09318(subStateNode, stateValue[subStateKey]);
        return allSubStateNodes.concat(subStateNodes);
    }, []));
}
function $7fce67e153198813$var$transitionAtomicNode(stateNode, stateValue, snapshot, event) {
    const childStateNode = $7fce67e153198813$var$getStateNode(stateNode, stateValue);
    const next = childStateNode.next(snapshot, event);
    if (!next || !next.length) return stateNode.next(snapshot, event);
    return next;
}
function $7fce67e153198813$var$transitionCompoundNode(stateNode, stateValue, snapshot, event) {
    const subStateKeys = Object.keys(stateValue);
    const childStateNode = $7fce67e153198813$var$getStateNode(stateNode, subStateKeys[0]);
    const next = $7fce67e153198813$export$ae1af26003f05816(childStateNode, stateValue[subStateKeys[0]], snapshot, event);
    if (!next || !next.length) return stateNode.next(snapshot, event);
    return next;
}
function $7fce67e153198813$var$transitionParallelNode(stateNode, stateValue, snapshot, event) {
    const allInnerTransitions = [];
    for (const subStateKey of Object.keys(stateValue)){
        const subStateValue = stateValue[subStateKey];
        if (!subStateValue) continue;
        const subStateNode = $7fce67e153198813$var$getStateNode(stateNode, subStateKey);
        const innerTransitions = $7fce67e153198813$export$ae1af26003f05816(subStateNode, subStateValue, snapshot, event);
        if (innerTransitions) allInnerTransitions.push(...innerTransitions);
    }
    if (!allInnerTransitions.length) return stateNode.next(snapshot, event);
    return allInnerTransitions;
}
function $7fce67e153198813$export$ae1af26003f05816(stateNode, stateValue, snapshot, event) {
    // leaf node
    if (typeof stateValue === 'string') return $7fce67e153198813$var$transitionAtomicNode(stateNode, stateValue, snapshot, event);
    // compound node
    if (Object.keys(stateValue).length === 1) return $7fce67e153198813$var$transitionCompoundNode(stateNode, stateValue, snapshot, event);
    // parallel node
    return $7fce67e153198813$var$transitionParallelNode(stateNode, stateValue, snapshot, event);
}
function $7fce67e153198813$var$getHistoryNodes(stateNode) {
    return Object.keys(stateNode.states).map((key)=>stateNode.states[key]).filter((sn)=>sn.type === 'history');
}
function $7fce67e153198813$var$isDescendant(childStateNode, parentStateNode) {
    let marker = childStateNode;
    while(marker.parent && marker.parent !== parentStateNode)marker = marker.parent;
    return marker.parent === parentStateNode;
}
function $7fce67e153198813$var$hasIntersection(s1, s2) {
    const set1 = new Set(s1);
    const set2 = new Set(s2);
    for (const item of set1){
        if (set2.has(item)) return true;
    }
    for (const item of set2){
        if (set1.has(item)) return true;
    }
    return false;
}
function $7fce67e153198813$var$removeConflictingTransitions(enabledTransitions, stateNodeSet, historyValue) {
    const filteredTransitions = new Set();
    for (const t1 of enabledTransitions){
        let t1Preempted = false;
        const transitionsToRemove = new Set();
        for (const t2 of filteredTransitions)if ($7fce67e153198813$var$hasIntersection($7fce67e153198813$var$computeExitSet([
            t1
        ], stateNodeSet, historyValue), $7fce67e153198813$var$computeExitSet([
            t2
        ], stateNodeSet, historyValue))) {
            if ($7fce67e153198813$var$isDescendant(t1.source, t2.source)) transitionsToRemove.add(t2);
            else {
                t1Preempted = true;
                break;
            }
        }
        if (!t1Preempted) {
            for (const t3 of transitionsToRemove)filteredTransitions.delete(t3);
            filteredTransitions.add(t1);
        }
    }
    return Array.from(filteredTransitions);
}
function $7fce67e153198813$var$findLeastCommonAncestor(stateNodes) {
    const [head, ...tail] = stateNodes;
    for (const ancestor of $7fce67e153198813$var$getProperAncestors(head, undefined)){
        if (tail.every((sn)=>$7fce67e153198813$var$isDescendant(sn, ancestor))) return ancestor;
    }
}
function $7fce67e153198813$var$getEffectiveTargetStates(transition, historyValue) {
    if (!transition.target) return [];
    const targets = new Set();
    for (const targetNode of transition.target)if ($7fce67e153198813$var$isHistoryNode(targetNode)) {
        if (historyValue[targetNode.id]) for (const node of historyValue[targetNode.id])targets.add(node);
        else for (const node of $7fce67e153198813$var$getEffectiveTargetStates($7fce67e153198813$var$resolveHistoryDefaultTransition(targetNode), historyValue))targets.add(node);
    } else targets.add(targetNode);
    return [
        ...targets
    ];
}
function $7fce67e153198813$var$getTransitionDomain(transition, historyValue) {
    const targetStates = $7fce67e153198813$var$getEffectiveTargetStates(transition, historyValue);
    if (!targetStates) return;
    if (!transition.reenter && targetStates.every((target)=>target === transition.source || $7fce67e153198813$var$isDescendant(target, transition.source))) return transition.source;
    const lca = $7fce67e153198813$var$findLeastCommonAncestor(targetStates.concat(transition.source));
    if (lca) return lca;
    // at this point we know that it's a root transition since LCA couldn't be found
    if (transition.reenter) return;
    return transition.source.machine.root;
}
function $7fce67e153198813$var$computeExitSet(transitions, stateNodeSet, historyValue) {
    var _t_target;
    const statesToExit = new Set();
    for (const t of transitions)if ((_t_target = t.target) === null || _t_target === void 0 ? void 0 : _t_target.length) {
        const domain = $7fce67e153198813$var$getTransitionDomain(t, historyValue);
        if (t.reenter && t.source === domain) statesToExit.add(domain);
        for (const stateNode of stateNodeSet)if ($7fce67e153198813$var$isDescendant(stateNode, domain)) statesToExit.add(stateNode);
    }
    return [
        ...statesToExit
    ];
}
function $7fce67e153198813$var$areStateNodeCollectionsEqual(prevStateNodes, nextStateNodeSet) {
    if (prevStateNodes.length !== nextStateNodeSet.size) return false;
    for (const node of prevStateNodes){
        if (!nextStateNodeSet.has(node)) return false;
    }
    return true;
}
/** https://www.w3.org/TR/scxml/#microstepProcedure */ function $7fce67e153198813$export$2408f22a0fab9ae5(transitions, currentSnapshot, actorScope, event, isInitial, internalQueue) {
    if (!transitions.length) return currentSnapshot;
    const mutStateNodeSet = new Set(currentSnapshot._nodes);
    let historyValue = currentSnapshot.historyValue;
    const filteredTransitions = $7fce67e153198813$var$removeConflictingTransitions(transitions, mutStateNodeSet, historyValue);
    let nextState = currentSnapshot;
    // Exit states
    if (!isInitial) [nextState, historyValue] = $7fce67e153198813$var$exitStates(nextState, event, actorScope, filteredTransitions, mutStateNodeSet, historyValue, internalQueue, actorScope.actionExecutor);
    // Execute transition content
    nextState = $7fce67e153198813$export$ffb5f4729a158638(nextState, event, actorScope, filteredTransitions.flatMap((t)=>t.actions), internalQueue, undefined);
    // Enter states
    nextState = $7fce67e153198813$var$enterStates(nextState, event, actorScope, filteredTransitions, mutStateNodeSet, internalQueue, historyValue, isInitial);
    const nextStateNodes = [
        ...mutStateNodeSet
    ];
    if (nextState.status === 'done') nextState = $7fce67e153198813$export$ffb5f4729a158638(nextState, event, actorScope, nextStateNodes.sort((a, b)=>b.order - a.order).flatMap((state)=>state.exit), internalQueue, undefined);
    // eslint-disable-next-line no-useless-catch
    try {
        if (historyValue === currentSnapshot.historyValue && $7fce67e153198813$var$areStateNodeCollectionsEqual(currentSnapshot._nodes, mutStateNodeSet)) return nextState;
        return $7fce67e153198813$export$3a6d5c9ae78a2c08(nextState, {
            _nodes: nextStateNodes,
            historyValue: historyValue
        });
    } catch (e) {
        // TODO: Refactor this once proper error handling is implemented.
        // See https://github.com/statelyai/rfcs/pull/4
        throw e;
    }
}
function $7fce67e153198813$var$getMachineOutput(snapshot, event, actorScope, rootNode, rootCompletionNode) {
    if (rootNode.output === undefined) return;
    const doneStateEvent = $7fce67e153198813$var$createDoneStateEvent(rootCompletionNode.id, rootCompletionNode.output !== undefined && rootCompletionNode.parent ? $7fce67e153198813$var$resolveOutput(rootCompletionNode.output, snapshot.context, event, actorScope.self) : undefined);
    return $7fce67e153198813$var$resolveOutput(rootNode.output, snapshot.context, doneStateEvent, actorScope.self);
}
function $7fce67e153198813$var$enterStates(currentSnapshot, event, actorScope, filteredTransitions, mutStateNodeSet, internalQueue, historyValue, isInitial) {
    let nextSnapshot = currentSnapshot;
    const statesToEnter = new Set();
    // those are states that were directly targeted or indirectly targeted by the explicit target
    // in other words, those are states for which initial actions should be executed
    // when we target `#deep_child` initial actions of its ancestors shouldn't be executed
    const statesForDefaultEntry = new Set();
    $7fce67e153198813$var$computeEntrySet(filteredTransitions, historyValue, statesForDefaultEntry, statesToEnter);
    // In the initial state, the root state node is "entered".
    if (isInitial) statesForDefaultEntry.add(currentSnapshot.machine.root);
    const completedNodes = new Set();
    for (const stateNodeToEnter of [
        ...statesToEnter
    ].sort((a, b)=>a.order - b.order)){
        mutStateNodeSet.add(stateNodeToEnter);
        const actions = [];
        // Add entry actions
        actions.push(...stateNodeToEnter.entry);
        for (const invokeDef of stateNodeToEnter.invoke)actions.push($7fce67e153198813$export$56c0d5a1e737357d(invokeDef.src, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, invokeDef), {
            syncSnapshot: !!invokeDef.onSnapshot
        })));
        if (statesForDefaultEntry.has(stateNodeToEnter)) {
            const initialActions = stateNodeToEnter.initial.actions;
            actions.push(...initialActions);
        }
        nextSnapshot = $7fce67e153198813$export$ffb5f4729a158638(nextSnapshot, event, actorScope, actions, internalQueue, stateNodeToEnter.invoke.map((invokeDef)=>invokeDef.id));
        if (stateNodeToEnter.type === 'final') {
            const parent = stateNodeToEnter.parent;
            let ancestorMarker = (parent === null || parent === void 0 ? void 0 : parent.type) === 'parallel' ? parent : parent === null || parent === void 0 ? void 0 : parent.parent;
            let rootCompletionNode = ancestorMarker || stateNodeToEnter;
            if ((parent === null || parent === void 0 ? void 0 : parent.type) === 'compound') internalQueue.push($7fce67e153198813$var$createDoneStateEvent(parent.id, stateNodeToEnter.output !== undefined ? $7fce67e153198813$var$resolveOutput(stateNodeToEnter.output, nextSnapshot.context, event, actorScope.self) : undefined));
            while((ancestorMarker === null || ancestorMarker === void 0 ? void 0 : ancestorMarker.type) === 'parallel' && !completedNodes.has(ancestorMarker) && $7fce67e153198813$export$882b5998b3b9117c(mutStateNodeSet, ancestorMarker)){
                completedNodes.add(ancestorMarker);
                internalQueue.push($7fce67e153198813$var$createDoneStateEvent(ancestorMarker.id));
                rootCompletionNode = ancestorMarker;
                ancestorMarker = ancestorMarker.parent;
            }
            if (ancestorMarker) continue;
            nextSnapshot = $7fce67e153198813$export$3a6d5c9ae78a2c08(nextSnapshot, {
                status: 'done',
                output: $7fce67e153198813$var$getMachineOutput(nextSnapshot, event, actorScope, nextSnapshot.machine.root, rootCompletionNode)
            });
        }
    }
    return nextSnapshot;
}
function $7fce67e153198813$var$computeEntrySet(transitions, historyValue, statesForDefaultEntry, statesToEnter) {
    for (const t of transitions){
        const domain = $7fce67e153198813$var$getTransitionDomain(t, historyValue);
        for (const s of t.target || []){
            if (!$7fce67e153198813$var$isHistoryNode(s) && // if the target is different than the source then it will *definitely* be entered
            (t.source !== s || // we know that the domain can't lie within the source
            // if it's different than the source then it's outside of it and it means that the target has to be entered as well
            t.source !== domain || // reentering transitions always enter the target, even if it's the source itself
            t.reenter)) {
                statesToEnter.add(s);
                statesForDefaultEntry.add(s);
            }
            $7fce67e153198813$var$addDescendantStatesToEnter(s, historyValue, statesForDefaultEntry, statesToEnter);
        }
        const targetStates = $7fce67e153198813$var$getEffectiveTargetStates(t, historyValue);
        for (const s of targetStates){
            const ancestors = $7fce67e153198813$var$getProperAncestors(s, domain);
            if ((domain === null || domain === void 0 ? void 0 : domain.type) === 'parallel') ancestors.push(domain);
            $7fce67e153198813$var$addAncestorStatesToEnter(statesToEnter, historyValue, statesForDefaultEntry, ancestors, !t.source.parent && t.reenter ? undefined : domain);
        }
    }
}
function $7fce67e153198813$var$addDescendantStatesToEnter(stateNode, historyValue, statesForDefaultEntry, statesToEnter) {
    if ($7fce67e153198813$var$isHistoryNode(stateNode)) {
        if (historyValue[stateNode.id]) {
            const historyStateNodes = historyValue[stateNode.id];
            for (const s of historyStateNodes){
                statesToEnter.add(s);
                $7fce67e153198813$var$addDescendantStatesToEnter(s, historyValue, statesForDefaultEntry, statesToEnter);
            }
            for (const s of historyStateNodes)$7fce67e153198813$var$addProperAncestorStatesToEnter(s, stateNode.parent, statesToEnter, historyValue, statesForDefaultEntry);
        } else {
            const historyDefaultTransition = $7fce67e153198813$var$resolveHistoryDefaultTransition(stateNode);
            for (const s of historyDefaultTransition.target){
                var _stateNode_parent;
                statesToEnter.add(s);
                if (historyDefaultTransition === ((_stateNode_parent = stateNode.parent) === null || _stateNode_parent === void 0 ? void 0 : _stateNode_parent.initial)) statesForDefaultEntry.add(stateNode.parent);
                $7fce67e153198813$var$addDescendantStatesToEnter(s, historyValue, statesForDefaultEntry, statesToEnter);
            }
            for (const s of historyDefaultTransition.target)$7fce67e153198813$var$addProperAncestorStatesToEnter(s, stateNode.parent, statesToEnter, historyValue, statesForDefaultEntry);
        }
    } else {
        if (stateNode.type === 'compound') {
            const [initialState] = stateNode.initial.target;
            if (!$7fce67e153198813$var$isHistoryNode(initialState)) {
                statesToEnter.add(initialState);
                statesForDefaultEntry.add(initialState);
            }
            $7fce67e153198813$var$addDescendantStatesToEnter(initialState, historyValue, statesForDefaultEntry, statesToEnter);
            $7fce67e153198813$var$addProperAncestorStatesToEnter(initialState, stateNode, statesToEnter, historyValue, statesForDefaultEntry);
        } else if (stateNode.type === 'parallel') {
            for (const child of $7fce67e153198813$var$getChildren(stateNode).filter((sn)=>!$7fce67e153198813$var$isHistoryNode(sn)))if (![
                ...statesToEnter
            ].some((s)=>$7fce67e153198813$var$isDescendant(s, child))) {
                if (!$7fce67e153198813$var$isHistoryNode(child)) {
                    statesToEnter.add(child);
                    statesForDefaultEntry.add(child);
                }
                $7fce67e153198813$var$addDescendantStatesToEnter(child, historyValue, statesForDefaultEntry, statesToEnter);
            }
        }
    }
}
function $7fce67e153198813$var$addAncestorStatesToEnter(statesToEnter, historyValue, statesForDefaultEntry, ancestors, reentrancyDomain) {
    for (const anc of ancestors){
        if (!reentrancyDomain || $7fce67e153198813$var$isDescendant(anc, reentrancyDomain)) statesToEnter.add(anc);
        if (anc.type === 'parallel') {
            for (const child of $7fce67e153198813$var$getChildren(anc).filter((sn)=>!$7fce67e153198813$var$isHistoryNode(sn)))if (![
                ...statesToEnter
            ].some((s)=>$7fce67e153198813$var$isDescendant(s, child))) {
                statesToEnter.add(child);
                $7fce67e153198813$var$addDescendantStatesToEnter(child, historyValue, statesForDefaultEntry, statesToEnter);
            }
        }
    }
}
function $7fce67e153198813$var$addProperAncestorStatesToEnter(stateNode, toStateNode, statesToEnter, historyValue, statesForDefaultEntry) {
    $7fce67e153198813$var$addAncestorStatesToEnter(statesToEnter, historyValue, statesForDefaultEntry, $7fce67e153198813$var$getProperAncestors(stateNode, toStateNode));
}
function $7fce67e153198813$var$exitStates(currentSnapshot, event, actorScope, transitions, mutStateNodeSet, historyValue, internalQueue, _actionExecutor) {
    let nextSnapshot = currentSnapshot;
    const statesToExit = $7fce67e153198813$var$computeExitSet(transitions, mutStateNodeSet, historyValue);
    statesToExit.sort((a, b)=>b.order - a.order);
    let changedHistory;
    // From SCXML algorithm: https://www.w3.org/TR/scxml/#exitStates
    for (const exitStateNode of statesToExit)for (const historyNode of $7fce67e153198813$var$getHistoryNodes(exitStateNode)){
        let predicate;
        if (historyNode.history === 'deep') predicate = (sn)=>$7fce67e153198813$var$isAtomicStateNode(sn) && $7fce67e153198813$var$isDescendant(sn, exitStateNode);
        else predicate = (sn)=>{
            return sn.parent === exitStateNode;
        };
        changedHistory !== null && changedHistory !== void 0 ? changedHistory : changedHistory = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, historyValue);
        changedHistory[historyNode.id] = Array.from(mutStateNodeSet).filter(predicate);
    }
    for (const s of statesToExit){
        nextSnapshot = $7fce67e153198813$export$ffb5f4729a158638(nextSnapshot, event, actorScope, [
            ...s.exit,
            ...s.invoke.map((def)=>$7fce67e153198813$export$db202ddc8be9136(def.id))
        ], internalQueue, undefined);
        mutStateNodeSet.delete(s);
    }
    return [
        nextSnapshot,
        changedHistory || historyValue
    ];
}
function $7fce67e153198813$var$getAction(machine, actionType) {
    return machine.implementations.actions[actionType];
}
function $7fce67e153198813$var$resolveAndExecuteActionsWithContext(currentSnapshot, event, actorScope, actions, extra, retries) {
    const { machine: machine } = currentSnapshot;
    let intermediateSnapshot = currentSnapshot;
    for (const action of actions){
        const isInline = typeof action === 'function';
        const resolvedAction = isInline ? action : // the existing type of `.actions` assumes non-nullable `TExpressionAction`
        // it's fine to cast this here to get a common type and lack of errors in the rest of the code
        // our logic below makes sure that we call those 2 "variants" correctly
        $7fce67e153198813$var$getAction(machine, typeof action === 'string' ? action : action.type);
        const actionArgs = {
            context: intermediateSnapshot.context,
            event: event,
            self: actorScope.self,
            system: actorScope.system
        };
        const actionParams = isInline || typeof action === 'string' ? undefined : 'params' in action ? typeof action.params === 'function' ? action.params({
            context: intermediateSnapshot.context,
            event: event
        }) : action.params : undefined;
        if (!resolvedAction || !('resolve' in resolvedAction)) {
            actorScope.actionExecutor({
                type: typeof action === 'string' ? action : typeof action === 'object' ? action.type : action.name || '(anonymous)',
                info: actionArgs,
                params: actionParams,
                exec: resolvedAction
            });
            continue;
        }
        const builtinAction = resolvedAction;
        const [nextState, params, actions] = builtinAction.resolve(actorScope, intermediateSnapshot, actionArgs, actionParams, resolvedAction, // this holds all params
        extra);
        intermediateSnapshot = nextState;
        if ('retryResolve' in builtinAction) retries === null || retries === void 0 ? void 0 : retries.push([
            builtinAction,
            params
        ]);
        if ('execute' in builtinAction) actorScope.actionExecutor({
            type: builtinAction.type,
            info: actionArgs,
            params: params,
            exec: builtinAction.execute.bind(null, actorScope, params)
        });
        if (actions) intermediateSnapshot = $7fce67e153198813$var$resolveAndExecuteActionsWithContext(intermediateSnapshot, event, actorScope, actions, extra, retries);
    }
    return intermediateSnapshot;
}
function $7fce67e153198813$export$ffb5f4729a158638(currentSnapshot, event, actorScope, actions, internalQueue, deferredActorIds) {
    const retries = deferredActorIds ? [] : undefined;
    const nextState = $7fce67e153198813$var$resolveAndExecuteActionsWithContext(currentSnapshot, event, actorScope, actions, {
        internalQueue: internalQueue,
        deferredActorIds: deferredActorIds
    }, retries);
    retries === null || retries === void 0 ? void 0 : retries.forEach(([builtinAction, params])=>{
        builtinAction.retryResolve(actorScope, nextState, params);
    });
    return nextState;
}
function $7fce67e153198813$export$7ccc53e8f1e7dfc5(snapshot, event, actorScope, internalQueue) {
    let nextSnapshot = snapshot;
    const microstates = [];
    function addMicrostate(microstate, event, transitions) {
        actorScope.system._sendInspectionEvent({
            type: '@xstate.microstep',
            actorRef: actorScope.self,
            event: event,
            snapshot: microstate,
            _transitions: transitions
        });
        microstates.push(microstate);
    }
    // Handle stop event
    if (event.type === $7fce67e153198813$export$78acf4525d8a74c4) {
        nextSnapshot = $7fce67e153198813$export$3a6d5c9ae78a2c08($7fce67e153198813$var$stopChildren(nextSnapshot, event, actorScope), {
            status: 'stopped'
        });
        addMicrostate(nextSnapshot, event, []);
        return {
            snapshot: nextSnapshot,
            microstates: microstates
        };
    }
    let nextEvent = event;
    // Assume the state is at rest (no raised events)
    // Determine the next state based on the next microstep
    if (nextEvent.type !== $7fce67e153198813$var$XSTATE_INIT) {
        const currentEvent = nextEvent;
        const isErr = $7fce67e153198813$var$isErrorActorEvent(currentEvent);
        const transitions = $7fce67e153198813$var$selectTransitions(currentEvent, nextSnapshot);
        if (isErr && !transitions.length) {
            // TODO: we should likely only allow transitions selected by very explicit descriptors
            // `*` shouldn't be matched, likely `xstate.error.*` shouldn't be either
            // similarly `xstate.error.actor.*` and `xstate.error.actor.todo.*` have to be considered too
            nextSnapshot = $7fce67e153198813$export$3a6d5c9ae78a2c08(snapshot, {
                status: 'error',
                error: currentEvent.error
            });
            addMicrostate(nextSnapshot, currentEvent, []);
            return {
                snapshot: nextSnapshot,
                microstates: microstates
            };
        }
        nextSnapshot = $7fce67e153198813$export$2408f22a0fab9ae5(transitions, snapshot, actorScope, nextEvent, false, // isInitial
        internalQueue);
        addMicrostate(nextSnapshot, currentEvent, transitions);
    }
    let shouldSelectEventlessTransitions = true;
    while(nextSnapshot.status === 'active'){
        let enabledTransitions = shouldSelectEventlessTransitions ? $7fce67e153198813$var$selectEventlessTransitions(nextSnapshot, nextEvent) : [];
        // eventless transitions should always be selected after selecting *regular* transitions
        // by assigning `undefined` to `previousState` we ensure that `shouldSelectEventlessTransitions` gets always computed to true in such a case
        const previousState = enabledTransitions.length ? nextSnapshot : undefined;
        if (!enabledTransitions.length) {
            if (!internalQueue.length) break;
            nextEvent = internalQueue.shift();
            enabledTransitions = $7fce67e153198813$var$selectTransitions(nextEvent, nextSnapshot);
        }
        nextSnapshot = $7fce67e153198813$export$2408f22a0fab9ae5(enabledTransitions, nextSnapshot, actorScope, nextEvent, false, internalQueue);
        shouldSelectEventlessTransitions = nextSnapshot !== previousState;
        addMicrostate(nextSnapshot, nextEvent, enabledTransitions);
    }
    if (nextSnapshot.status !== 'active') $7fce67e153198813$var$stopChildren(nextSnapshot, nextEvent, actorScope);
    return {
        snapshot: nextSnapshot,
        microstates: microstates
    };
}
function $7fce67e153198813$var$stopChildren(nextState, event, actorScope) {
    return $7fce67e153198813$export$ffb5f4729a158638(nextState, event, actorScope, Object.values(nextState.children).map((child)=>$7fce67e153198813$export$db202ddc8be9136(child)), [], undefined);
}
function $7fce67e153198813$var$selectTransitions(event, nextState) {
    return nextState.machine.getTransitionData(nextState, event);
}
function $7fce67e153198813$var$selectEventlessTransitions(nextState, event) {
    const enabledTransitionSet = new Set();
    const atomicStates = nextState._nodes.filter($7fce67e153198813$var$isAtomicStateNode);
    for (const stateNode of atomicStates)loop: for (const s of [
        stateNode
    ].concat($7fce67e153198813$var$getProperAncestors(stateNode, undefined))){
        if (!s.always) continue;
        for (const transition of s.always)if (transition.guard === undefined || $7fce67e153198813$export$f1e1789686576879(transition.guard, nextState.context, event, nextState)) {
            enabledTransitionSet.add(transition);
            break loop;
        }
    }
    return $7fce67e153198813$var$removeConflictingTransitions(Array.from(enabledTransitionSet), new Set(nextState._nodes), nextState.historyValue);
}
/**
 * Resolves a partial state value with its full representation in the state
 * node's machine.
 *
 * @param stateValue The partial state value to resolve.
 */ function $7fce67e153198813$export$43caf9889c228507(rootNode, stateValue) {
    const allStateNodes = $7fce67e153198813$export$23f2a1d2818174ef($7fce67e153198813$export$35e795649ee09318(rootNode, stateValue));
    return $7fce67e153198813$var$getStateValue(rootNode, [
        ...allStateNodes
    ]);
}
function $7fce67e153198813$export$7f8ddf7c7c20b3cd(value) {
    return !!value && typeof value === 'object' && 'machine' in value && 'value' in value;
}
const $7fce67e153198813$var$machineSnapshotMatches = function matches(testValue) {
    return $7fce67e153198813$export$b4171a6734a65d42(testValue, this.value);
};
const $7fce67e153198813$var$machineSnapshotHasTag = function hasTag(tag) {
    return this.tags.has(tag);
};
const $7fce67e153198813$var$machineSnapshotCan = function can(event) {
    const transitionData = this.machine.getTransitionData(this, event);
    return !!(transitionData === null || transitionData === void 0 ? void 0 : transitionData.length) && // Check that at least one transition is not forbidden
    transitionData.some((t)=>t.target !== undefined || t.actions.length);
};
const $7fce67e153198813$var$machineSnapshotToJSON = function toJSON() {
    const _this = this, { _nodes: nodes, tags: tags, machine: machine, getMeta: getMeta, toJSON: toJSON, can: can, hasTag: hasTag, matches: matches } = _this, jsonValues = (0, $8901fc92b5563702$export$71511d61b312f219)(_this, [
        "_nodes",
        "tags",
        "machine",
        "getMeta",
        "toJSON",
        "can",
        "hasTag",
        "matches"
    ]);
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, jsonValues), {
        tags: Array.from(tags)
    });
};
const $7fce67e153198813$var$machineSnapshotGetMeta = function getMeta() {
    return this._nodes.reduce((acc, stateNode)=>{
        if (stateNode.meta !== undefined) acc[stateNode.id] = stateNode.meta;
        return acc;
    }, {});
};
function $7fce67e153198813$export$342063e11d6c3cad(config, machine) {
    return {
        status: config.status,
        output: config.output,
        error: config.error,
        machine: machine,
        context: config.context,
        _nodes: config._nodes,
        value: $7fce67e153198813$var$getStateValue(machine.root, config._nodes),
        tags: new Set(config._nodes.flatMap((sn)=>sn.tags)),
        children: config.children,
        historyValue: config.historyValue || {},
        matches: $7fce67e153198813$var$machineSnapshotMatches,
        hasTag: $7fce67e153198813$var$machineSnapshotHasTag,
        can: $7fce67e153198813$var$machineSnapshotCan,
        getMeta: $7fce67e153198813$var$machineSnapshotGetMeta,
        toJSON: $7fce67e153198813$var$machineSnapshotToJSON
    };
}
function $7fce67e153198813$export$3a6d5c9ae78a2c08(snapshot, config = {}) {
    return $7fce67e153198813$export$342063e11d6c3cad((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, snapshot, config), snapshot.machine);
}
function $7fce67e153198813$var$serializeHistoryValue(historyValue) {
    if (typeof historyValue !== 'object' || historyValue === null) return {};
    const result = {};
    for(const key in historyValue){
        const value = historyValue[key];
        if (Array.isArray(value)) result[key] = value.map((item)=>({
                id: item.id
            }));
    }
    return result;
}
function $7fce67e153198813$export$4a5767248b18ef41(snapshot, options) {
    const { _nodes: nodes, tags: tags, machine: machine, children: children, context: context, can: can, hasTag: hasTag, matches: matches, getMeta: getMeta, toJSON: toJSON } = snapshot, jsonValues = (0, $8901fc92b5563702$export$71511d61b312f219)(snapshot, [
        "_nodes",
        "tags",
        "machine",
        "children",
        "context",
        "can",
        "hasTag",
        "matches",
        "getMeta",
        "toJSON"
    ]);
    const childrenJson = {};
    for(const id in children){
        const child = children[id];
        childrenJson[id] = {
            snapshot: child.getPersistedSnapshot(options),
            src: child.src,
            systemId: child._systemId,
            syncSnapshot: child._syncSnapshot
        };
    }
    const persisted = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, jsonValues), {
        context: $7fce67e153198813$var$persistContext(context),
        children: childrenJson,
        historyValue: $7fce67e153198813$var$serializeHistoryValue(jsonValues.historyValue)
    });
    return persisted;
}
function $7fce67e153198813$var$persistContext(contextPart) {
    let copy;
    for(const key in contextPart){
        const value = contextPart[key];
        if (value && typeof value === 'object') {
            if ('sessionId' in value && 'send' in value && 'ref' in value) {
                copy !== null && copy !== void 0 ? copy : copy = Array.isArray(contextPart) ? contextPart.slice() : (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, contextPart);
                copy[key] = {
                    xstate$$type: $7fce67e153198813$export$3d8c2f653ac9d0b9,
                    id: value.id
                };
            } else {
                const result = $7fce67e153198813$var$persistContext(value);
                if (result !== value) {
                    copy !== null && copy !== void 0 ? copy : copy = Array.isArray(contextPart) ? contextPart.slice() : (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, contextPart);
                    copy[key] = result;
                }
            }
        }
    }
    return copy !== null && copy !== void 0 ? copy : contextPart;
}
function $7fce67e153198813$var$resolveRaise(_, snapshot, args, actionParams, { event: eventOrExpr, id: id, delay: delay }, { internalQueue: internalQueue }) {
    const delaysMap = snapshot.machine.implementations.delays;
    if (typeof eventOrExpr === 'string') throw new Error(// eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    `Only event objects may be used with raise; use raise({ type: "${eventOrExpr}" }) instead`);
    const resolvedEvent = typeof eventOrExpr === 'function' ? eventOrExpr(args, actionParams) : eventOrExpr;
    let resolvedDelay;
    if (typeof delay === 'string') {
        const configDelay = delaysMap && delaysMap[delay];
        resolvedDelay = typeof configDelay === 'function' ? configDelay(args, actionParams) : configDelay;
    } else resolvedDelay = typeof delay === 'function' ? delay(args, actionParams) : delay;
    if (typeof resolvedDelay !== 'number') internalQueue.push(resolvedEvent);
    return [
        snapshot,
        {
            event: resolvedEvent,
            id: id,
            delay: resolvedDelay
        },
        undefined
    ];
}
function $7fce67e153198813$var$executeRaise(actorScope, params) {
    const { event: event, delay: delay, id: id } = params;
    if (typeof delay === 'number') {
        actorScope.defer(()=>{
            const self = actorScope.self;
            actorScope.system.scheduler.schedule(self, self, event, delay, id);
        });
        return;
    }
}
/**
 * Raises an event. This places the event in the internal event queue, so that
 * the event is immediately consumed by the machine in the current step.
 *
 * @param eventType The event to raise.
 */ function $7fce67e153198813$export$c4ce752e73470fba(eventOrExpr, options) {
    function raise(_args, _params) {}
    raise.type = 'xstate.raise';
    raise.event = eventOrExpr;
    raise.id = options === null || options === void 0 ? void 0 : options.id;
    raise.delay = options === null || options === void 0 ? void 0 : options.delay;
    raise.resolve = $7fce67e153198813$var$resolveRaise;
    raise.execute = $7fce67e153198813$var$executeRaise;
    return raise;
}



/**
 * Represents an actor created by `fromTransition`.
 *
 * The type of `self` within the actor's logic.
 *
 * @example
 *
 * ```ts
 * import {
 *   fromTransition,
 *   createActor,
 *   type AnyActorSystem
 * } from 'xstate';
 *
 * //* The actor's stored context.
 * type Context = {
 *   // The current count.
 *   count: number;
 *   // The amount to increase `count` by.
 *   step: number;
 * };
 * // The events the actor receives.
 * type Event = { type: 'increment' };
 * // The actor's input.
 * type Input = { step?: number };
 *
 * // Actor logic that increments `count` by `step` when it receives an event of
 * // type `increment`.
 * const logic = fromTransition<Context, Event, AnyActorSystem, Input>(
 *   (state, event, actorScope) => {
 *     actorScope.self;
 *     //         ^? TransitionActorRef<Context, Event>
 *
 *     if (event.type === 'increment') {
 *       return {
 *         ...state,
 *         count: state.count + state.step
 *       };
 *     }
 *     return state;
 *   },
 *   ({ input, self }) => {
 *     self;
 *     // ^? TransitionActorRef<Context, Event>
 *
 *     return {
 *       count: 0,
 *       step: input.step ?? 1
 *     };
 *   }
 * );
 *
 * const actor = createActor(logic, { input: { step: 10 } });
 * //    ^? TransitionActorRef<Context, Event>
 * ```
 *
 * @see {@link fromTransition}
 */ /**
 * Returns actor logic given a transition function and its initial state.
 *
 * A “transition function” is a function that takes the current `state` and
 * received `event` object as arguments, and returns the next state, similar to
 * a reducer.
 *
 * Actors created from transition logic (“transition actors”) can:
 *
 * - Receive events
 * - Emit snapshots of its state
 *
 * The transition function’s `state` is used as its transition actor’s
 * `context`.
 *
 * Note that the "state" for a transition function is provided by the initial
 * state argument, and is not the same as the State object of an actor or a
 * state within a machine configuration.
 *
 * @example
 *
 * ```ts
 * const transitionLogic = fromTransition(
 *   (state, event) => {
 *     if (event.type === 'increment') {
 *       return {
 *         ...state,
 *         count: state.count + 1
 *       };
 *     }
 *     return state;
 *   },
 *   { count: 0 }
 * );
 *
 * const transitionActor = createActor(transitionLogic);
 * transitionActor.subscribe((snapshot) => {
 *   console.log(snapshot);
 * });
 * transitionActor.start();
 * // => {
 * //   status: 'active',
 * //   context: { count: 0 },
 * //   ...
 * // }
 *
 * transitionActor.send({ type: 'increment' });
 * // => {
 * //   status: 'active',
 * //   context: { count: 1 },
 * //   ...
 * // }
 * ```
 *
 * @param transition The transition function used to describe the transition
 *   logic. It should return the next state given the current state and event.
 *   It receives the following arguments:
 *
 *   - `state` - the current state.
 *   - `event` - the received event.
 *   - `actorScope` - the actor scope object, with properties like `self` and
 *       `system`.
 *
 * @param initialContext The initial state of the transition function, either an
 *   object representing the state, or a function which returns a state object.
 *   If a function, it will receive as its only argument an object with the
 *   following properties:
 *
 *   - `input` - the `input` provided to its parent transition actor.
 *   - `self` - a reference to its parent transition actor.
 *
 * @returns Actor logic
 * @see {@link https://stately.ai/docs/input | Input docs} for more information about how input is passed
 */ function $3a9fcf29fc53ac8b$export$439a4be7208a15ca(transition, initialContext) {
    return {
        config: transition,
        transition: (snapshot, event, actorScope)=>{
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, snapshot), {
                context: transition(snapshot.context, event, actorScope)
            });
        },
        getInitialSnapshot: (_, input)=>{
            return {
                status: 'active',
                output: undefined,
                error: undefined,
                context: typeof initialContext === 'function' ? initialContext({
                    input: input
                }) : initialContext
            };
        },
        getPersistedSnapshot: (snapshot)=>snapshot,
        restoreSnapshot: (snapshot)=>snapshot
    };
}
const $3a9fcf29fc53ac8b$var$instanceStates = /* #__PURE__ */ new WeakMap();
/**
 * Represents an actor created by `fromCallback`.
 *
 * The type of `self` within the actor's logic.
 *
 * @example
 *
 * ```ts
 * import { fromCallback, createActor } from 'xstate';
 *
 * // The events the actor receives.
 * type Event = { type: 'someEvent' };
 * // The actor's input.
 * type Input = { name: string };
 *
 * // Actor logic that logs whenever it receives an event of type `someEvent`.
 * const logic = fromCallback<Event, Input>(({ self, input, receive }) => {
 *   self;
 *   // ^? CallbackActorRef<Event, Input>
 *
 *   receive((event) => {
 *     if (event.type === 'someEvent') {
 *       console.log(`${input.name}: received "someEvent" event`);
 *       // logs 'myActor: received "someEvent" event'
 *     }
 *   });
 * });
 *
 * const actor = createActor(logic, { input: { name: 'myActor' } });
 * //    ^? CallbackActorRef<Event, Input>
 * ```
 *
 * @see {@link fromCallback}
 */ /**
 * An actor logic creator which returns callback logic as defined by a callback
 * function.
 *
 * @remarks
 * Useful for subscription-based or other free-form logic that can send events
 * back to the parent actor.
 *
 * Actors created from callback logic (“callback actors”) can:
 *
 * - Receive events via the `receive` function
 * - Send events to the parent actor via the `sendBack` function
 *
 * Callback actors are a bit different from other actors in that they:
 *
 * - Do not work with `onDone`
 * - Do not produce a snapshot using `.getSnapshot()`
 * - Do not emit values when used with `.subscribe()`
 * - Can not be stopped with `.stop()`
 *
 * @example
 *
 * ```typescript
 * const callbackLogic = fromCallback(({ sendBack, receive }) => {
 *   let lockStatus = 'unlocked';
 *
 *   const handler = (event) => {
 *     if (lockStatus === 'locked') {
 *       return;
 *     }
 *     sendBack(event);
 *   };
 *
 *   receive((event) => {
 *     if (event.type === 'lock') {
 *       lockStatus = 'locked';
 *     } else if (event.type === 'unlock') {
 *       lockStatus = 'unlocked';
 *     }
 *   });
 *
 *   document.body.addEventListener('click', handler);
 *
 *   return () => {
 *     document.body.removeEventListener('click', handler);
 *   };
 * });
 * ```
 *
 * @param callback - The callback function used to describe the callback logic
 *   The callback function is passed an object with the following properties:
 *
 *   - `receive` - A function that can send events back to the parent actor; the
 *       listener is then called whenever events are received by the callback
 *       actor
 *   - `sendBack` - A function that can send events back to the parent actor
 *   - `input` - Data that was provided to the callback actor
 *   - `self` - The parent actor of the callback actor
 *   - `system` - The actor system to which the callback actor belongs The callback
 *       function can (optionally) return a cleanup function, which is called
 *       when the actor is stopped.
 *
 * @returns Callback logic
 * @see {@link CallbackLogicFunction} for more information about the callback function and its object argument
 * @see {@link https://stately.ai/docs/input | Input docs} for more information about how input is passed
 */ function $3a9fcf29fc53ac8b$export$d0deb4828877173(callback) {
    const logic = {
        config: callback,
        start: (state, actorScope)=>{
            const { self: self, system: system, emit: emit } = actorScope;
            const callbackState = {
                receivers: undefined,
                dispose: undefined
            };
            $3a9fcf29fc53ac8b$var$instanceStates.set(self, callbackState);
            callbackState.dispose = callback({
                input: state.input,
                system: system,
                self: self,
                sendBack: (event)=>{
                    if (self.getSnapshot().status === 'stopped') return;
                    if (self._parent) system._relay(self, self._parent, event);
                },
                receive: (listener)=>{
                    var _callbackState;
                    var _receivers;
                    (_receivers = (_callbackState = callbackState).receivers) !== null && _receivers !== void 0 ? _receivers : _callbackState.receivers = new Set();
                    callbackState.receivers.add(listener);
                },
                emit: emit
            });
        },
        transition: (state, event, actorScope)=>{
            var _callbackState_receivers;
            const callbackState = $3a9fcf29fc53ac8b$var$instanceStates.get(actorScope.self);
            if (event.type === (0, $7fce67e153198813$export$78acf4525d8a74c4)) {
                var _callbackState_dispose;
                state = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                    status: 'stopped',
                    error: undefined
                });
                (_callbackState_dispose = callbackState.dispose) === null || _callbackState_dispose === void 0 ? void 0 : _callbackState_dispose.call(callbackState);
                return state;
            }
            (_callbackState_receivers = callbackState.receivers) === null || _callbackState_receivers === void 0 ? void 0 : _callbackState_receivers.forEach((receiver)=>receiver(event));
            return state;
        },
        getInitialSnapshot: (_, input)=>{
            return {
                status: 'active',
                output: undefined,
                error: undefined,
                input: input
            };
        },
        getPersistedSnapshot: (snapshot)=>snapshot,
        restoreSnapshot: (snapshot)=>snapshot
    };
    return logic;
}
const $3a9fcf29fc53ac8b$var$XSTATE_OBSERVABLE_NEXT = 'xstate.observable.next';
const $3a9fcf29fc53ac8b$var$XSTATE_OBSERVABLE_ERROR = 'xstate.observable.error';
const $3a9fcf29fc53ac8b$var$XSTATE_OBSERVABLE_COMPLETE = 'xstate.observable.complete';
/**
 * Represents an actor created by `fromObservable` or `fromEventObservable`.
 *
 * The type of `self` within the actor's logic.
 *
 * @example
 *
 * ```ts
 * import { fromObservable, createActor } from 'xstate';
 * import { interval } from 'rxjs';
 *
 * // The type of the value observed by the actor's logic.
 * type Context = number;
 * // The actor's input.
 * type Input = { period?: number };
 *
 * // Actor logic that observes a number incremented every `input.period`
 * // milliseconds (default: 1_000).
 * const logic = fromObservable<Context, Input>(({ input, self }) => {
 *   self;
 *   // ^? ObservableActorRef<Event, Input>
 *
 *   return interval(input.period ?? 1_000);
 * });
 *
 * const actor = createActor(logic, { input: { period: 2_000 } });
 * //    ^? ObservableActorRef<Event, Input>
 * ```
 *
 * @see {@link fromObservable}
 * @see {@link fromEventObservable}
 */ /**
 * Observable actor logic is described by an observable stream of values. Actors
 * created from observable logic (“observable actors”) can:
 *
 * - Emit snapshots of the observable’s emitted value
 *
 * The observable’s emitted value is used as its observable actor’s `context`.
 *
 * Sending events to observable actors will have no effect.
 *
 * @example
 *
 * ```ts
 * import { fromObservable, createActor } from 'xstate';
 * import { interval } from 'rxjs';
 *
 * const logic = fromObservable((obj) => interval(1000));
 *
 * const actor = createActor(logic);
 *
 * actor.subscribe((snapshot) => {
 *   console.log(snapshot.context);
 * });
 *
 * actor.start();
 * // At every second:
 * // Logs 0
 * // Logs 1
 * // Logs 2
 * // ...
 * ```
 *
 * @param observableCreator A function that creates an observable. It receives
 *   one argument, an object with the following properties:
 *
 *   - `input` - Data that was provided to the observable actor
 *   - `self` - The parent actor
 *   - `system` - The actor system to which the observable actor belongs
 *
 *   It should return a {@link Subscribable}, which is compatible with an RxJS
 *   Observable, although RxJS is not required to create them.
 * @see {@link https://rxjs.dev} for documentation on RxJS Observable and observable creators.
 * @see {@link Subscribable} interface in XState, which is based on and compatible with RxJS Observable.
 */ function $3a9fcf29fc53ac8b$export$4b2432e2d8723823(observableCreator) {
    // TODO: add event types
    const logic = {
        config: observableCreator,
        transition: (snapshot, event)=>{
            if (snapshot.status !== 'active') return snapshot;
            switch(event.type){
                case $3a9fcf29fc53ac8b$var$XSTATE_OBSERVABLE_NEXT:
                    {
                        const newSnapshot = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, snapshot), {
                            context: event.data
                        });
                        return newSnapshot;
                    }
                case $3a9fcf29fc53ac8b$var$XSTATE_OBSERVABLE_ERROR:
                    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, snapshot), {
                        status: 'error',
                        error: event.data,
                        input: undefined,
                        _subscription: undefined
                    });
                case $3a9fcf29fc53ac8b$var$XSTATE_OBSERVABLE_COMPLETE:
                    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, snapshot), {
                        status: 'done',
                        input: undefined,
                        _subscription: undefined
                    });
                case 0, $7fce67e153198813$export$78acf4525d8a74c4:
                    snapshot._subscription.unsubscribe();
                    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, snapshot), {
                        status: 'stopped',
                        input: undefined,
                        _subscription: undefined
                    });
                default:
                    return snapshot;
            }
        },
        getInitialSnapshot: (_, input)=>{
            return {
                status: 'active',
                output: undefined,
                error: undefined,
                context: undefined,
                input: input,
                _subscription: undefined
            };
        },
        start: (state, { self: self, system: system, emit: emit })=>{
            if (state.status === 'done') // Do not restart a completed observable
            return;
            state._subscription = observableCreator({
                input: state.input,
                system: system,
                self: self,
                emit: emit
            }).subscribe({
                next: (value)=>{
                    system._relay(self, self, {
                        type: $3a9fcf29fc53ac8b$var$XSTATE_OBSERVABLE_NEXT,
                        data: value
                    });
                },
                error: (err)=>{
                    system._relay(self, self, {
                        type: $3a9fcf29fc53ac8b$var$XSTATE_OBSERVABLE_ERROR,
                        data: err
                    });
                },
                complete: ()=>{
                    system._relay(self, self, {
                        type: $3a9fcf29fc53ac8b$var$XSTATE_OBSERVABLE_COMPLETE
                    });
                }
            });
        },
        getPersistedSnapshot: (_param)=>{
            var { _subscription: _subscription } = _param, state = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
                "_subscription"
            ]);
            return state;
        },
        restoreSnapshot: (state)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                _subscription: undefined
            })
    };
    return logic;
}
/**
 * Creates event observable logic that listens to an observable that delivers
 * event objects.
 *
 * Event observable actor logic is described by an observable stream of
 * {@link https://stately.ai/docs/transitions#event-objects | event objects}.
 * Actors created from event observable logic (“event observable actors”) can:
 *
 * - Implicitly send events to its parent actor
 * - Emit snapshots of its emitted event objects
 *
 * Sending events to event observable actors will have no effect.
 *
 * @example
 *
 * ```ts
 * import {
 *   fromEventObservable,
 *   Subscribable,
 *   EventObject,
 *   createMachine,
 *   createActor
 * } from 'xstate';
 * import { fromEvent } from 'rxjs';
 *
 * const mouseClickLogic = fromEventObservable(
 *   () => fromEvent(document.body, 'click') as Subscribable<EventObject>
 * );
 *
 * const canvasMachine = createMachine({
 *   invoke: {
 *     // Will send mouse `click` events to the canvas actor
 *     src: mouseClickLogic
 *   }
 * });
 *
 * const canvasActor = createActor(canvasMachine);
 * canvasActor.start();
 * ```
 *
 * @param lazyObservable A function that creates an observable that delivers
 *   event objects. It receives one argument, an object with the following
 *   properties:
 *
 *   - `input` - Data that was provided to the event observable actor
 *   - `self` - The parent actor
 *   - `system` - The actor system to which the event observable actor belongs.
 *
 *   It should return a {@link Subscribable}, which is compatible with an RxJS
 *   Observable, although RxJS is not required to create them.
 */ function $3a9fcf29fc53ac8b$export$32b16bdebc365919(lazyObservable) {
    // TODO: event types
    const logic = {
        config: lazyObservable,
        transition: (state, event)=>{
            if (state.status !== 'active') return state;
            switch(event.type){
                case $3a9fcf29fc53ac8b$var$XSTATE_OBSERVABLE_ERROR:
                    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                        status: 'error',
                        error: event.data,
                        input: undefined,
                        _subscription: undefined
                    });
                case $3a9fcf29fc53ac8b$var$XSTATE_OBSERVABLE_COMPLETE:
                    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                        status: 'done',
                        input: undefined,
                        _subscription: undefined
                    });
                case 0, $7fce67e153198813$export$78acf4525d8a74c4:
                    state._subscription.unsubscribe();
                    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                        status: 'stopped',
                        input: undefined,
                        _subscription: undefined
                    });
                default:
                    return state;
            }
        },
        getInitialSnapshot: (_, input)=>{
            return {
                status: 'active',
                output: undefined,
                error: undefined,
                context: undefined,
                input: input,
                _subscription: undefined
            };
        },
        start: (state, { self: self, system: system, emit: emit })=>{
            if (state.status === 'done') // Do not restart a completed observable
            return;
            state._subscription = lazyObservable({
                input: state.input,
                system: system,
                self: self,
                emit: emit
            }).subscribe({
                next: (value)=>{
                    if (self._parent) system._relay(self, self._parent, value);
                },
                error: (err)=>{
                    system._relay(self, self, {
                        type: $3a9fcf29fc53ac8b$var$XSTATE_OBSERVABLE_ERROR,
                        data: err
                    });
                },
                complete: ()=>{
                    system._relay(self, self, {
                        type: $3a9fcf29fc53ac8b$var$XSTATE_OBSERVABLE_COMPLETE
                    });
                }
            });
        },
        getPersistedSnapshot: (_param)=>{
            var { _subscription: _subscription } = _param, snapshot = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
                "_subscription"
            ]);
            return snapshot;
        },
        restoreSnapshot: (snapshot)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, snapshot), {
                _subscription: undefined
            })
    };
    return logic;
}
const $3a9fcf29fc53ac8b$var$XSTATE_PROMISE_RESOLVE = 'xstate.promise.resolve';
const $3a9fcf29fc53ac8b$var$XSTATE_PROMISE_REJECT = 'xstate.promise.reject';
/**
 * Represents an actor created by `fromPromise`.
 *
 * The type of `self` within the actor's logic.
 *
 * @example
 *
 * ```ts
 * import { fromPromise, createActor } from 'xstate';
 *
 * // The actor's resolved output
 * type Output = string;
 * // The actor's input.
 * type Input = { message: string };
 *
 * // Actor logic that fetches the url of an image of a cat saying `input.message`.
 * const logic = fromPromise<Output, Input>(async ({ input, self }) => {
 *   self;
 *   // ^? PromiseActorRef<Output, Input>
 *
 *   const data = await fetch(
 *     `https://cataas.com/cat/says/${input.message}`
 *   );
 *   const url = await data.json();
 *   return url;
 * });
 *
 * const actor = createActor(logic, { input: { message: 'hello world' } });
 * //    ^? PromiseActorRef<Output, Input>
 * ```
 *
 * @see {@link fromPromise}
 */ const $3a9fcf29fc53ac8b$var$controllerMap = new WeakMap();
/**
 * An actor logic creator which returns promise logic as defined by an async
 * process that resolves or rejects after some time.
 *
 * Actors created from promise actor logic (“promise actors”) can:
 *
 * - Emit the resolved value of the promise
 * - Output the resolved value of the promise
 *
 * Sending events to promise actors will have no effect.
 *
 * @example
 *
 * ```ts
 * const promiseLogic = fromPromise(async () => {
 *   const result = await fetch('https://example.com/...').then((data) =>
 *     data.json()
 *   );
 *
 *   return result;
 * });
 *
 * const promiseActor = createActor(promiseLogic);
 * promiseActor.subscribe((snapshot) => {
 *   console.log(snapshot);
 * });
 * promiseActor.start();
 * // => {
 * //   output: undefined,
 * //   status: 'active'
 * //   ...
 * // }
 *
 * // After promise resolves
 * // => {
 * //   output: { ... },
 * //   status: 'done',
 * //   ...
 * // }
 * ```
 *
 * @param promiseCreator A function which returns a Promise, and accepts an
 *   object with the following properties:
 *
 *   - `input` - Data that was provided to the promise actor
 *   - `self` - The parent actor of the promise actor
 *   - `system` - The actor system to which the promise actor belongs
 *
 * @see {@link https://stately.ai/docs/input | Input docs} for more information about how input is passed
 */ function $3a9fcf29fc53ac8b$export$60f45028237c39d1(promiseCreator) {
    const logic = {
        config: promiseCreator,
        transition: (state, event, scope)=>{
            if (state.status !== 'active') return state;
            switch(event.type){
                case $3a9fcf29fc53ac8b$var$XSTATE_PROMISE_RESOLVE:
                    {
                        const resolvedValue = event.data;
                        return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                            status: 'done',
                            output: resolvedValue,
                            input: undefined
                        });
                    }
                case $3a9fcf29fc53ac8b$var$XSTATE_PROMISE_REJECT:
                    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                        status: 'error',
                        error: event.data,
                        input: undefined
                    });
                case 0, $7fce67e153198813$export$78acf4525d8a74c4:
                    var _controllerMap_get;
                    (_controllerMap_get = $3a9fcf29fc53ac8b$var$controllerMap.get(scope.self)) === null || _controllerMap_get === void 0 ? void 0 : _controllerMap_get.abort();
                    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                        status: 'stopped',
                        input: undefined
                    });
                default:
                    return state;
            }
        },
        start: (state, { self: self, system: system, emit: emit })=>{
            // TODO: determine how to allow customizing this so that promises
            // can be restarted if necessary
            if (state.status !== 'active') return;
            const controller = new AbortController();
            $3a9fcf29fc53ac8b$var$controllerMap.set(self, controller);
            const resolvedPromise = Promise.resolve(promiseCreator({
                input: state.input,
                system: system,
                self: self,
                signal: controller.signal,
                emit: emit
            }));
            resolvedPromise.then((response)=>{
                if (self.getSnapshot().status !== 'active') return;
                $3a9fcf29fc53ac8b$var$controllerMap.delete(self);
                system._relay(self, self, {
                    type: $3a9fcf29fc53ac8b$var$XSTATE_PROMISE_RESOLVE,
                    data: response
                });
            }, (errorData)=>{
                if (self.getSnapshot().status !== 'active') return;
                $3a9fcf29fc53ac8b$var$controllerMap.delete(self);
                system._relay(self, self, {
                    type: $3a9fcf29fc53ac8b$var$XSTATE_PROMISE_REJECT,
                    data: errorData
                });
            });
        },
        getInitialSnapshot: (_, input)=>{
            return {
                status: 'active',
                output: undefined,
                error: undefined,
                input: input
            };
        },
        getPersistedSnapshot: (snapshot)=>snapshot,
        restoreSnapshot: (snapshot)=>snapshot
    };
    return logic;
}
const $3a9fcf29fc53ac8b$var$emptyLogic = $3a9fcf29fc53ac8b$export$439a4be7208a15ca((_)=>undefined, undefined);
function $3a9fcf29fc53ac8b$export$302970cd5518279b() {
    return (0, $7fce67e153198813$export$ebd11618f299a286)($3a9fcf29fc53ac8b$var$emptyLogic);
}





function $218c98dc8c315a3f$var$createSpawner(actorScope, { machine: machine, context: context }, event, spawnedChildren) {
    const spawn = (src, options)=>{
        if (typeof src === 'string') {
            const logic = (0, $7fce67e153198813$export$df995fae86a55f06)(machine, src);
            if (!logic) throw new Error(`Actor logic '${src}' not implemented in machine '${machine.id}'`);
            const actorRef = (0, $7fce67e153198813$export$ebd11618f299a286)(logic, {
                id: options === null || options === void 0 ? void 0 : options.id,
                parent: actorScope.self,
                syncSnapshot: options === null || options === void 0 ? void 0 : options.syncSnapshot,
                input: typeof (options === null || options === void 0 ? void 0 : options.input) === 'function' ? options.input({
                    context: context,
                    event: event,
                    self: actorScope.self
                }) : options === null || options === void 0 ? void 0 : options.input,
                src: src,
                systemId: options === null || options === void 0 ? void 0 : options.systemId
            });
            spawnedChildren[actorRef.id] = actorRef;
            return actorRef;
        } else {
            const actorRef = (0, $7fce67e153198813$export$ebd11618f299a286)(src, {
                id: options === null || options === void 0 ? void 0 : options.id,
                parent: actorScope.self,
                syncSnapshot: options === null || options === void 0 ? void 0 : options.syncSnapshot,
                input: options === null || options === void 0 ? void 0 : options.input,
                src: src,
                systemId: options === null || options === void 0 ? void 0 : options.systemId
            });
            return actorRef;
        }
    };
    return (src, options)=>{
        const actorRef = spawn(src, options); // TODO: fix types
        spawnedChildren[actorRef.id] = actorRef;
        actorScope.defer(()=>{
            if (actorRef._processingStatus === (0, $7fce67e153198813$export$971d5caa766a69d7).Stopped) return;
            actorRef.start();
        });
        return actorRef;
    };
}
function $218c98dc8c315a3f$var$resolveAssign(actorScope, snapshot, actionArgs, actionParams, { assignment: assignment }) {
    if (!snapshot.context) throw new Error('Cannot assign to undefined `context`. Ensure that `context` is defined in the machine config.');
    const spawnedChildren = {};
    const assignArgs = {
        context: snapshot.context,
        event: actionArgs.event,
        spawn: $218c98dc8c315a3f$var$createSpawner(actorScope, snapshot, actionArgs.event, spawnedChildren),
        self: actorScope.self,
        system: actorScope.system
    };
    let partialUpdate = {};
    if (typeof assignment === 'function') partialUpdate = assignment(assignArgs, actionParams);
    else for (const key of Object.keys(assignment)){
        const propAssignment = assignment[key];
        partialUpdate[key] = typeof propAssignment === 'function' ? propAssignment(assignArgs, actionParams) : propAssignment;
    }
    const updatedContext = Object.assign({}, snapshot.context, partialUpdate);
    return [
        (0, $7fce67e153198813$export$3a6d5c9ae78a2c08)(snapshot, {
            context: updatedContext,
            children: Object.keys(spawnedChildren).length ? (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, snapshot.children, spawnedChildren) : snapshot.children
        }),
        undefined,
        undefined
    ];
}
/**
 * Updates the current context of the machine.
 *
 * @example
 *
 * ```ts
 * import { createMachine, assign } from 'xstate';
 *
 * const countMachine = createMachine({
 *   context: {
 *     count: 0,
 *     message: ''
 *   },
 *   on: {
 *     inc: {
 *       actions: assign({
 *         count: ({ context }) => context.count + 1
 *       })
 *     },
 *     updateMessage: {
 *       actions: assign(({ context, event }) => {
 *         return {
 *           message: event.message.trim()
 *         };
 *       })
 *     }
 *   }
 * });
 * ```
 *
 * @param assignment An object that represents the partial context to update, or
 *   a function that returns an object that represents the partial context to
 *   update.
 */ function $218c98dc8c315a3f$export$407448d2b89b1813(assignment) {
    function assign(_args, _params) {}
    assign.type = 'xstate.assign';
    assign.assignment = assignment;
    assign.resolve = $218c98dc8c315a3f$var$resolveAssign;
    return assign;
}
function $218c98dc8c315a3f$var$resolveEmit(_, snapshot, args, actionParams, { event: eventOrExpr }) {
    const resolvedEvent = typeof eventOrExpr === 'function' ? eventOrExpr(args, actionParams) : eventOrExpr;
    return [
        snapshot,
        {
            event: resolvedEvent
        },
        undefined
    ];
}
function $218c98dc8c315a3f$var$executeEmit(actorScope, { event: event }) {
    actorScope.defer(()=>actorScope.emit(event));
}
/**
 * Emits an event to event handlers registered on the actor via `actor.on(event,
 * handler)`.
 *
 * @example
 *
 * ```ts
 * import { emit } from 'xstate';
 *
 * const machine = createMachine({
 *   // ...
 *   on: {
 *     something: {
 *       actions: emit({
 *         type: 'emitted',
 *         some: 'data'
 *       })
 *     }
 *   }
 *   // ...
 * });
 *
 * const actor = createActor(machine).start();
 *
 * actor.on('emitted', (event) => {
 *   console.log(event);
 * });
 *
 * actor.send({ type: 'something' });
 * // logs:
 * // {
 * //   type: 'emitted',
 * //   some: 'data'
 * // }
 * ```
 */ function $218c98dc8c315a3f$export$f1e1789686576879(/** The event to emit, or an expression that returns an event to emit. */ eventOrExpr) {
    function emit(_args, _params) {}
    emit.type = 'xstate.emit';
    emit.event = eventOrExpr;
    emit.resolve = $218c98dc8c315a3f$var$resolveEmit;
    emit.execute = $218c98dc8c315a3f$var$executeEmit;
    return emit;
}
// this is needed to make JSDoc `@link` work properly
/**
 * @remarks
 * `T | unknown` reduces to `unknown` and that can be problematic when it comes
 * to contextual typing. It especially is a problem when the union has a
 * function member, like here:
 *
 * ```ts
 * declare function test(
 *   cbOrVal: ((arg: number) => unknown) | unknown
 * ): void;
 * test((arg) => {}); // oops, implicit any
 * ```
 *
 * This type can be used to avoid this problem. This union represents the same
 * value space as `unknown`.
 */ // https://github.com/microsoft/TypeScript/issues/23182#issuecomment-379091887
// @TODO: we can't use native `NoInfer` as we need those:
// https://github.com/microsoft/TypeScript/pull/61092
// https://github.com/microsoft/TypeScript/pull/61077
// but even with those fixes native NoInfer still doesn't work - further issues have to be reproduced and fixed
/** @deprecated Use the built-in `NoInfer` type instead */ /** The full definition of an event, with a string `type`. */ /**
 * The string or object representing the state value relative to the parent
 * state node.
 *
 * @remarks
 * - For a child atomic state node, this is a string, e.g., `"pending"`.
 * - For complex state nodes, this is an object, e.g., `{ success:
 *   "someChildState" }`.
 */ /** @deprecated Use `AnyMachineSnapshot` instead */ // TODO: possibly refactor this somehow, use even a simpler type, and maybe even make `machine.options` private or something
/** @ignore */ let $218c98dc8c315a3f$export$25ce5a424b770e84 = /*#__PURE__*/ function(SpecialTargets) {
    SpecialTargets["Parent"] = "#_parent";
    SpecialTargets["Internal"] = "#_internal";
    return SpecialTargets;
}({});
/** @deprecated Use `AnyActor` instead. */ // Based on RxJS types
// TODO: in v6, this should only accept AnyActorLogic, like ActorRefFromLogic
/** @deprecated Use `Actor<T>` instead. */ /**
 * Represents logic which can be used by an actor.
 *
 * @template TSnapshot - The type of the snapshot.
 * @template TEvent - The type of the event object.
 * @template TInput - The type of the input.
 * @template TSystem - The type of the actor system.
 */ /** @deprecated */ // TODO: cover all that can be actually returned
function $218c98dc8c315a3f$var$resolveSendTo(actorScope, snapshot, args, actionParams, { to: to, event: eventOrExpr, id: id, delay: delay }, extra) {
    const delaysMap = snapshot.machine.implementations.delays;
    if (typeof eventOrExpr === 'string') throw new Error(// eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    `Only event objects may be used with sendTo; use sendTo({ type: "${eventOrExpr}" }) instead`);
    const resolvedEvent = typeof eventOrExpr === 'function' ? eventOrExpr(args, actionParams) : eventOrExpr;
    let resolvedDelay;
    if (typeof delay === 'string') {
        const configDelay = delaysMap && delaysMap[delay];
        resolvedDelay = typeof configDelay === 'function' ? configDelay(args, actionParams) : configDelay;
    } else resolvedDelay = typeof delay === 'function' ? delay(args, actionParams) : delay;
    const resolvedTarget = typeof to === 'function' ? to(args, actionParams) : to;
    let targetActorRef;
    if (typeof resolvedTarget === 'string') {
        var _extra_deferredActorIds;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
        if (resolvedTarget === $218c98dc8c315a3f$export$25ce5a424b770e84.Parent) targetActorRef = actorScope.self._parent;
        else if (resolvedTarget === $218c98dc8c315a3f$export$25ce5a424b770e84.Internal) targetActorRef = actorScope.self;
        else if (resolvedTarget.startsWith('#_')) // SCXML compatibility: https://www.w3.org/TR/scxml/#SCXMLEventProcessor
        // #_invokeid. If the target is the special term '#_invokeid', where invokeid is the invokeid of an SCXML session that the sending session has created by <invoke>, the Processor must add the event to the external queue of that session.
        targetActorRef = snapshot.children[resolvedTarget.slice(2)];
        else targetActorRef = ((_extra_deferredActorIds = extra.deferredActorIds) === null || _extra_deferredActorIds === void 0 ? void 0 : _extra_deferredActorIds.includes(resolvedTarget)) ? resolvedTarget : snapshot.children[resolvedTarget];
        if (!targetActorRef) throw new Error(`Unable to send event to actor '${resolvedTarget}' from machine '${snapshot.machine.id}'.`);
    } else targetActorRef = resolvedTarget || actorScope.self;
    return [
        snapshot,
        {
            to: targetActorRef,
            targetId: typeof resolvedTarget === 'string' ? resolvedTarget : undefined,
            event: resolvedEvent,
            id: id,
            delay: resolvedDelay
        },
        undefined
    ];
}
function $218c98dc8c315a3f$var$retryResolveSendTo(_, snapshot, params) {
    if (typeof params.to === 'string') params.to = snapshot.children[params.to];
}
function $218c98dc8c315a3f$var$executeSendTo(actorScope, params) {
    // this forms an outgoing events queue
    // thanks to that the recipient actors are able to read the *updated* snapshot value of the sender
    actorScope.defer(()=>{
        const { to: to, event: event, delay: delay, id: id } = params;
        if (typeof delay === 'number') {
            actorScope.system.scheduler.schedule(actorScope.self, to, event, delay, id);
            return;
        }
        actorScope.system._relay(actorScope.self, // at this point, in a deferred task, it should already be mutated by retryResolveSendTo
        // if it initially started as a string
        to, event.type === (0, $7fce67e153198813$export$e7c866399fa523f5) ? (0, $7fce67e153198813$export$71cec2538cb2c617)(actorScope.self.id, event.data) : event);
    });
}
/**
 * Sends an event to an actor.
 *
 * @param actor The `ActorRef` to send the event to.
 * @param event The event to send, or an expression that evaluates to the event
 *   to send
 * @param options Send action options
 *
 *   - `id` - The unique send event identifier (used with `cancel()`).
 *   - `delay` - The number of milliseconds to delay the sending of the event.
 */ function $218c98dc8c315a3f$export$db3b6bfb95261072(to, eventOrExpr, options) {
    function sendTo(_args, _params) {}
    sendTo.type = 'xstate.sendTo';
    sendTo.to = to;
    sendTo.event = eventOrExpr;
    sendTo.id = options === null || options === void 0 ? void 0 : options.id;
    sendTo.delay = options === null || options === void 0 ? void 0 : options.delay;
    sendTo.resolve = $218c98dc8c315a3f$var$resolveSendTo;
    sendTo.retryResolve = $218c98dc8c315a3f$var$retryResolveSendTo;
    sendTo.execute = $218c98dc8c315a3f$var$executeSendTo;
    return sendTo;
}
/**
 * Sends an event to this machine's parent.
 *
 * @param event The event to send to the parent machine.
 * @param options Options to pass into the send event.
 */ function $218c98dc8c315a3f$export$2408f22a0fab9ae5(event, options) {
    return $218c98dc8c315a3f$export$db3b6bfb95261072($218c98dc8c315a3f$export$25ce5a424b770e84.Parent, event, options);
}
/**
 * Forwards (sends) an event to the `target` actor.
 *
 * @param target The target actor to forward the event to.
 * @param options Options to pass into the send action creator.
 */ function $218c98dc8c315a3f$export$2d1720544b23b823(target, options) {
    return $218c98dc8c315a3f$export$db3b6bfb95261072(target, ({ event: event })=>event, options);
}
function $218c98dc8c315a3f$var$resolveEnqueueActions(actorScope, snapshot, args, actionParams, { collect: collect }) {
    const actions = [];
    const enqueue = function enqueue(action) {
        actions.push(action);
    };
    enqueue.assign = (...args)=>{
        actions.push($218c98dc8c315a3f$export$407448d2b89b1813(...args));
    };
    enqueue.cancel = (...args)=>{
        actions.push((0, $7fce67e153198813$export$3a1a48c8f6ef640e)(...args));
    };
    enqueue.raise = (...args)=>{
        // for some reason it fails to infer `TDelay` from `...args` here and picks its default (`never`)
        // then it fails to typecheck that because `...args` use `string` in place of `TDelay`
        actions.push((0, $7fce67e153198813$export$c4ce752e73470fba)(...args));
    };
    enqueue.sendTo = (...args)=>{
        // for some reason it fails to infer `TDelay` from `...args` here and picks its default (`never`)
        // then it fails to typecheck that because `...args` use `string` in place of `TDelay
        actions.push($218c98dc8c315a3f$export$db3b6bfb95261072(...args));
    };
    enqueue.sendParent = (...args)=>{
        actions.push($218c98dc8c315a3f$export$2408f22a0fab9ae5(...args));
    };
    enqueue.spawnChild = (...args)=>{
        actions.push((0, $7fce67e153198813$export$56c0d5a1e737357d)(...args));
    };
    enqueue.stopChild = (...args)=>{
        actions.push((0, $7fce67e153198813$export$db202ddc8be9136)(...args));
    };
    enqueue.emit = (...args)=>{
        actions.push($218c98dc8c315a3f$export$f1e1789686576879(...args));
    };
    collect({
        context: args.context,
        event: args.event,
        enqueue: enqueue,
        check: (guard)=>(0, $7fce67e153198813$export$f1e1789686576879)(guard, snapshot.context, args.event, snapshot),
        self: actorScope.self,
        system: actorScope.system
    }, actionParams);
    return [
        snapshot,
        undefined,
        actions
    ];
}
/**
 * Creates an action object that will execute actions that are queued by the
 * `enqueue(action)` function.
 *
 * @example
 *
 * ```ts
 * import { createMachine, enqueueActions } from 'xstate';
 *
 * const machine = createMachine({
 *   entry: enqueueActions(({ enqueue, check }) => {
 *     enqueue.assign({ count: 0 });
 *
 *     if (check('someGuard')) {
 *       enqueue.assign({ count: 1 });
 *     }
 *
 *     enqueue('someAction');
 *   })
 * });
 * ```
 */ function $218c98dc8c315a3f$export$8b22cf2602fb60ce(collect) {
    function enqueueActions(_args, _params) {}
    enqueueActions.type = 'xstate.enqueueActions';
    enqueueActions.collect = collect;
    enqueueActions.resolve = $218c98dc8c315a3f$var$resolveEnqueueActions;
    return enqueueActions;
}
function $218c98dc8c315a3f$var$resolveLog(_, snapshot, actionArgs, actionParams, { value: value, label: label }) {
    return [
        snapshot,
        {
            value: typeof value === 'function' ? value(actionArgs, actionParams) : value,
            label: label
        },
        undefined
    ];
}
function $218c98dc8c315a3f$var$executeLog({ logger: logger }, { value: value, label: label }) {
    if (label) logger(label, value);
    else logger(value);
}
/**
 * @param expr The expression function to evaluate which will be logged. Takes
 *   in 2 arguments:
 *
 *   - `ctx` - the current state context
 *   - `event` - the event that caused this action to be executed.
 *
 * @param label The label to give to the logged expression.
 */ function $218c98dc8c315a3f$export$882b5998b3b9117c(value = ({ context: context, event: event })=>({
        context: context,
        event: event
    }), label) {
    function log1(_args, _params) {}
    log1.type = 'xstate.log';
    log1.value = value;
    log1.label = label;
    log1.resolve = $218c98dc8c315a3f$var$resolveLog;
    log1.execute = $218c98dc8c315a3f$var$executeLog;
    return log1;
}



/**
 * Asserts that the given event object is of the specified type or types. Throws
 * an error if the event object is not of the specified types.
 *
 * @example
 *
 * ```ts
 * // ...
 * entry: ({ event }) => {
 *   assertEvent(event, 'doNothing');
 *   // event is { type: 'doNothing' }
 * },
 * // ...
 * exit: ({ event }) => {
 *   assertEvent(event, 'greet');
 *   // event is { type: 'greet'; message: string }
 *
 *   assertEvent(event, ['greet', 'notify']);
 *   // event is { type: 'greet'; message: string }
 *   // or { type: 'notify'; message: string; level: 'info' | 'error' }
 * },
 * ```
 */ function $23198f69e99780f2$export$b3e112bfd3a4f448(event, type) {
    const types = (0, $7fce67e153198813$export$625550452a3fa3ec)(type);
    if (!types.includes(event.type)) {
        const typesText = types.length === 1 ? `type "${types[0]}"` : `one of types "${types.join('", "')}"`;
        throw new Error(`Expected event ${JSON.stringify(event)} to have ${typesText}`);
    }
}
const $23198f69e99780f2$var$cache = new WeakMap();
function $23198f69e99780f2$var$memo(object, key, fn) {
    let memoizedData = $23198f69e99780f2$var$cache.get(object);
    if (!memoizedData) {
        memoizedData = {
            [key]: fn()
        };
        $23198f69e99780f2$var$cache.set(object, memoizedData);
    } else if (!(key in memoizedData)) memoizedData[key] = fn();
    return memoizedData[key];
}
const $23198f69e99780f2$var$EMPTY_OBJECT = {};
const $23198f69e99780f2$var$toSerializableAction = (action)=>{
    if (typeof action === 'string') return {
        type: action
    };
    if (typeof action === 'function') {
        if ('resolve' in action) return {
            type: action.type
        };
        return {
            type: action.name
        };
    }
    return action;
};
class $23198f69e99780f2$export$342f24f5edd47b1 {
    /** @internal */ _initialize() {
        this.transitions = (0, $7fce67e153198813$export$2d1720544b23b823)(this);
        if (this.config.always) this.always = (0, $7fce67e153198813$export$407448d2b89b1813)(this.config.always).map((t)=>(0, $7fce67e153198813$export$8b22cf2602fb60ce)(this, (0, $7fce67e153198813$export$a07804094c3ecf2d), t));
        Object.keys(this.states).forEach((key)=>{
            this.states[key]._initialize();
        });
    }
    /** The well-structured state node definition. */ get definition() {
        return {
            id: this.id,
            key: this.key,
            version: this.machine.version,
            type: this.type,
            initial: this.initial ? {
                target: this.initial.target,
                source: this,
                actions: this.initial.actions.map($23198f69e99780f2$var$toSerializableAction),
                eventType: null,
                reenter: false,
                toJSON: ()=>({
                        target: this.initial.target.map((t)=>`#${t.id}`),
                        source: `#${this.id}`,
                        actions: this.initial.actions.map($23198f69e99780f2$var$toSerializableAction),
                        eventType: null
                    })
            } : undefined,
            history: this.history,
            states: (0, $7fce67e153198813$export$953cecd6e717a553)(this.states, (state)=>{
                return state.definition;
            }),
            on: this.on,
            transitions: [
                ...this.transitions.values()
            ].flat().map((t)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, t), {
                    actions: t.actions.map($23198f69e99780f2$var$toSerializableAction)
                })),
            entry: this.entry.map($23198f69e99780f2$var$toSerializableAction),
            exit: this.exit.map($23198f69e99780f2$var$toSerializableAction),
            meta: this.meta,
            order: this.order || -1,
            output: this.output,
            invoke: this.invoke,
            description: this.description,
            tags: this.tags
        };
    }
    /** @internal */ toJSON() {
        return this.definition;
    }
    /** The logic invoked as actors by this state node. */ get invoke() {
        return $23198f69e99780f2$var$memo(this, 'invoke', ()=>(0, $7fce67e153198813$export$625550452a3fa3ec)(this.config.invoke).map((invokeConfig, i)=>{
                const { src: src, systemId: systemId } = invokeConfig;
                var _invokeConfig_id;
                const resolvedId = (_invokeConfig_id = invokeConfig.id) !== null && _invokeConfig_id !== void 0 ? _invokeConfig_id : (0, $7fce67e153198813$export$db3b6bfb95261072)(this.id, i);
                const sourceName = typeof src === 'string' ? src : `xstate.invoke.${(0, $7fce67e153198813$export$db3b6bfb95261072)(this.id, i)}`;
                return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, invokeConfig), {
                    src: sourceName,
                    id: resolvedId,
                    systemId: systemId,
                    toJSON () {
                        const { onDone: onDone, onError: onError } = invokeConfig, invokeDefValues = (0, $8901fc92b5563702$export$71511d61b312f219)(invokeConfig, [
                            "onDone",
                            "onError"
                        ]);
                        return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, invokeDefValues), {
                            type: 'xstate.invoke',
                            src: sourceName,
                            id: resolvedId
                        });
                    }
                });
            }));
    }
    /** The mapping of events to transitions. */ get on() {
        return $23198f69e99780f2$var$memo(this, 'on', ()=>{
            const transitions = this.transitions;
            return [
                ...transitions
            ].flatMap(([descriptor, t])=>t.map((t)=>[
                        descriptor,
                        t
                    ])).reduce((map, [descriptor, transition])=>{
                map[descriptor] = map[descriptor] || [];
                map[descriptor].push(transition);
                return map;
            }, {});
        });
    }
    get after() {
        return $23198f69e99780f2$var$memo(this, 'delayedTransitions', ()=>(0, $7fce67e153198813$export$39b482c5e57630a8)(this));
    }
    get initial() {
        return $23198f69e99780f2$var$memo(this, 'initial', ()=>(0, $7fce67e153198813$export$4368d992c4eafac0)(this, this.config.initial));
    }
    /** @internal */ next(snapshot, event) {
        const eventType = event.type;
        const actions = [];
        let selectedTransition;
        const candidates = $23198f69e99780f2$var$memo(this, `candidates-${eventType}`, ()=>(0, $7fce67e153198813$export$dda1d9f60106f0e9)(this, eventType));
        for (const candidate of candidates){
            const { guard: guard } = candidate;
            const resolvedContext = snapshot.context;
            let guardPassed = false;
            try {
                guardPassed = !guard || (0, $7fce67e153198813$export$f1e1789686576879)(guard, resolvedContext, event, snapshot);
            } catch (err) {
                const guardType = typeof guard === 'string' ? guard : typeof guard === 'object' ? guard.type : undefined;
                throw new Error(`Unable to evaluate guard ${guardType ? `'${guardType}' ` : ''}in transition for event '${eventType}' in state node '${this.id}':\n${err.message}`);
            }
            if (guardPassed) {
                actions.push(...candidate.actions);
                selectedTransition = candidate;
                break;
            }
        }
        return selectedTransition ? [
            selectedTransition
        ] : undefined;
    }
    /** All the event types accepted by this state node and its descendants. */ get events() {
        return $23198f69e99780f2$var$memo(this, 'events', ()=>{
            const { states: states } = this;
            const events = new Set(this.ownEvents);
            if (states) for (const stateId of Object.keys(states)){
                const state = states[stateId];
                if (state.states) for (const event of state.events)events.add(`${event}`);
            }
            return Array.from(events);
        });
    }
    /**
   * All the events that have transitions directly from this state node.
   *
   * Excludes any inert events.
   */ get ownEvents() {
        const events = new Set([
            ...this.transitions.keys()
        ].filter((descriptor)=>{
            return this.transitions.get(descriptor).some((transition)=>!(!transition.target && !transition.actions.length && !transition.reenter));
        }));
        return Array.from(events);
    }
    constructor(/** The raw config used to create the machine. */ config, options){
        this.config = config;
        /**
     * The relative key of the state node, which represents its location in the
     * overall state value.
     */ this.key = void 0;
        /** The unique ID of the state node. */ this.id = void 0;
        /**
     * The type of this state node:
     *
     * - `'atomic'` - no child state nodes
     * - `'compound'` - nested child state nodes (XOR)
     * - `'parallel'` - orthogonal nested child state nodes (AND)
     * - `'history'` - history state node
     * - `'final'` - final state node
     */ this.type = void 0;
        /** The string path from the root machine node to this node. */ this.path = void 0;
        /** The child state nodes. */ this.states = void 0;
        /**
     * The type of history on this state node. Can be:
     *
     * - `'shallow'` - recalls only top-level historical state value
     * - `'deep'` - recalls historical state value at all levels
     */ this.history = void 0;
        /** The action(s) to be executed upon entering the state node. */ this.entry = void 0;
        /** The action(s) to be executed upon exiting the state node. */ this.exit = void 0;
        /** The parent state node. */ this.parent = void 0;
        /** The root machine node. */ this.machine = void 0;
        /**
     * The meta data associated with this state node, which will be returned in
     * State instances.
     */ this.meta = void 0;
        /**
     * The output data sent with the "xstate.done.state._id_" event if this is a
     * final state node.
     */ this.output = void 0;
        /**
     * The order this state node appears. Corresponds to the implicit document
     * order.
     */ this.order = -1;
        this.description = void 0;
        this.tags = [];
        this.transitions = void 0;
        this.always = void 0;
        this.parent = options._parent;
        this.key = options._key;
        this.machine = options._machine;
        this.path = this.parent ? this.parent.path.concat(this.key) : [];
        this.id = this.config.id || [
            this.machine.id,
            ...this.path
        ].join((0, $7fce67e153198813$export$25ce5a424b770e84));
        this.type = this.config.type || (this.config.states && Object.keys(this.config.states).length ? 'compound' : this.config.history ? 'history' : 'atomic');
        this.description = this.config.description;
        this.order = this.machine.idMap.size;
        this.machine.idMap.set(this.id, this);
        this.states = this.config.states ? (0, $7fce67e153198813$export$953cecd6e717a553)(this.config.states, (stateConfig, key)=>{
            const stateNode = new $23198f69e99780f2$export$342f24f5edd47b1(stateConfig, {
                _parent: this,
                _key: key,
                _machine: this.machine
            });
            return stateNode;
        }) : $23198f69e99780f2$var$EMPTY_OBJECT;
        if (this.type === 'compound' && !this.config.initial) throw new Error(`No initial state specified for compound state node "#${this.id}". Try adding { initial: "${Object.keys(this.states)[0]}" } to the state config.`);
        // History config
        this.history = this.config.history === true ? 'shallow' : this.config.history || false;
        this.entry = (0, $7fce67e153198813$export$625550452a3fa3ec)(this.config.entry).slice();
        this.exit = (0, $7fce67e153198813$export$625550452a3fa3ec)(this.config.exit).slice();
        this.meta = this.config.meta;
        this.output = this.type === 'final' || !this.parent ? this.config.output : undefined;
        this.tags = (0, $7fce67e153198813$export$625550452a3fa3ec)(config.tags).slice();
    }
}
const $23198f69e99780f2$var$STATE_IDENTIFIER = '#';
class $23198f69e99780f2$export$cbf2d83d1eab018a {
    /**
   * Clones this state machine with the provided implementations.
   *
   * @param implementations Options (`actions`, `guards`, `actors`, `delays`)
   *   to recursively merge with the existing options.
   * @returns A new `StateMachine` instance with the provided implementations.
   */ provide(implementations) {
        const { actions: actions, guards: guards, actors: actors, delays: delays } = this.implementations;
        return new $23198f69e99780f2$export$cbf2d83d1eab018a(this.config, {
            actions: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, actions, implementations.actions),
            guards: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, guards, implementations.guards),
            actors: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, actors, implementations.actors),
            delays: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, delays, implementations.delays)
        });
    }
    resolveState(config) {
        const resolvedStateValue = (0, $7fce67e153198813$export$43caf9889c228507)(this.root, config.value);
        const nodeSet = (0, $7fce67e153198813$export$23f2a1d2818174ef)((0, $7fce67e153198813$export$35e795649ee09318)(this.root, resolvedStateValue));
        return (0, $7fce67e153198813$export$342063e11d6c3cad)({
            _nodes: [
                ...nodeSet
            ],
            context: config.context || {},
            children: {},
            status: (0, $7fce67e153198813$export$882b5998b3b9117c)(nodeSet, this.root) ? 'done' : config.status || 'active',
            output: config.output,
            error: config.error,
            historyValue: config.historyValue
        }, this);
    }
    /**
   * Determines the next snapshot given the current `snapshot` and received
   * `event`. Calculates a full macrostep from all microsteps.
   *
   * @param snapshot The current snapshot
   * @param event The received event
   */ transition(snapshot, event, actorScope) {
        return (0, $7fce67e153198813$export$7ccc53e8f1e7dfc5)(snapshot, event, actorScope, []).snapshot;
    }
    /**
   * Determines the next state given the current `state` and `event`. Calculates
   * a microstep.
   *
   * @param state The current state
   * @param event The received event
   */ microstep(snapshot, event, actorScope) {
        return (0, $7fce67e153198813$export$7ccc53e8f1e7dfc5)(snapshot, event, actorScope, []).microstates;
    }
    getTransitionData(snapshot, event) {
        return (0, $7fce67e153198813$export$ae1af26003f05816)(this.root, snapshot.value, snapshot, event) || [];
    }
    /**
   * The initial state _before_ evaluating any microsteps. This "pre-initial"
   * state is provided to initial actions executed in the initial state.
   */ getPreInitialState(actorScope, initEvent, internalQueue) {
        const { context: context } = this.config;
        const preInitial = (0, $7fce67e153198813$export$342063e11d6c3cad)({
            context: typeof context !== 'function' && context ? context : {},
            _nodes: [
                this.root
            ],
            children: {},
            status: 'active'
        }, this);
        if (typeof context === 'function') {
            const assignment = ({ spawn: spawn, event: event, self: self })=>context({
                    spawn: spawn,
                    input: event.input,
                    self: self
                });
            return (0, $7fce67e153198813$export$ffb5f4729a158638)(preInitial, initEvent, actorScope, [
                (0, $218c98dc8c315a3f$export$407448d2b89b1813)(assignment)
            ], internalQueue, undefined);
        }
        return preInitial;
    }
    /**
   * Returns the initial `State` instance, with reference to `self` as an
   * `ActorRef`.
   */ getInitialSnapshot(actorScope, input) {
        const initEvent = (0, $7fce67e153198813$export$9e5f44173e64f162)(input); // TODO: fix;
        const internalQueue = [];
        const preInitialState = this.getPreInitialState(actorScope, initEvent, internalQueue);
        const nextState = (0, $7fce67e153198813$export$2408f22a0fab9ae5)([
            {
                target: [
                    ...(0, $7fce67e153198813$export$3b14a55fb2447963)(this.root)
                ],
                source: this.root,
                reenter: true,
                actions: [],
                eventType: null,
                toJSON: null // TODO: fix
            }
        ], preInitialState, actorScope, initEvent, true, internalQueue);
        const { snapshot: macroState } = (0, $7fce67e153198813$export$7ccc53e8f1e7dfc5)(nextState, initEvent, actorScope, internalQueue);
        return macroState;
    }
    start(snapshot) {
        Object.values(snapshot.children).forEach((child)=>{
            if (child.getSnapshot().status === 'active') child.start();
        });
    }
    getStateNodeById(stateId) {
        const fullPath = (0, $7fce67e153198813$export$90a7f3efeed30595)(stateId);
        const relativePath = fullPath.slice(1);
        const resolvedStateId = (0, $7fce67e153198813$export$efccba1c4a2ef57b)(fullPath[0]) ? fullPath[0].slice($23198f69e99780f2$var$STATE_IDENTIFIER.length) : fullPath[0];
        const stateNode = this.idMap.get(resolvedStateId);
        if (!stateNode) throw new Error(`Child state node '#${resolvedStateId}' does not exist on machine '${this.id}'`);
        return (0, $7fce67e153198813$export$d141bba7fdc215a3)(stateNode, relativePath);
    }
    get definition() {
        return this.root.definition;
    }
    toJSON() {
        return this.definition;
    }
    getPersistedSnapshot(snapshot, options) {
        return (0, $7fce67e153198813$export$4a5767248b18ef41)(snapshot, options);
    }
    restoreSnapshot(snapshot, _actorScope) {
        const children = {};
        const snapshotChildren = snapshot.children;
        Object.keys(snapshotChildren).forEach((actorId)=>{
            const actorData = snapshotChildren[actorId];
            const childState = actorData.snapshot;
            const src = actorData.src;
            const logic = typeof src === 'string' ? (0, $7fce67e153198813$export$df995fae86a55f06)(this, src) : src;
            if (!logic) return;
            const actorRef = (0, $7fce67e153198813$export$ebd11618f299a286)(logic, {
                id: actorId,
                parent: _actorScope.self,
                syncSnapshot: actorData.syncSnapshot,
                snapshot: childState,
                src: src,
                systemId: actorData.systemId
            });
            children[actorId] = actorRef;
        });
        function resolveHistoryReferencedState(root, referenced) {
            if (referenced instanceof $23198f69e99780f2$export$342f24f5edd47b1) return referenced;
            try {
                return root.machine.getStateNodeById(referenced.id);
            } catch (e) {}
        }
        function reviveHistoryValue(root, historyValue) {
            if (!historyValue || typeof historyValue !== 'object') return {};
            const revived = {};
            for(const key in historyValue){
                const arr = historyValue[key];
                for (const item of arr){
                    var _revived, _key;
                    const resolved = resolveHistoryReferencedState(root, item);
                    if (!resolved) continue;
                    var _;
                    (_ = (_revived = revived)[_key = key]) !== null && _ !== void 0 ? _ : _revived[_key] = [];
                    revived[key].push(resolved);
                }
            }
            return revived;
        }
        const revivedHistoryValue = reviveHistoryValue(this.root, snapshot.historyValue);
        const restoredSnapshot = (0, $7fce67e153198813$export$342063e11d6c3cad)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, snapshot), {
            children: children,
            _nodes: Array.from((0, $7fce67e153198813$export$23f2a1d2818174ef)((0, $7fce67e153198813$export$35e795649ee09318)(this.root, snapshot.value))),
            historyValue: revivedHistoryValue
        }), this);
        const seen = new Set();
        function reviveContext(contextPart, children) {
            if (seen.has(contextPart)) return;
            seen.add(contextPart);
            for(const key in contextPart){
                const value = contextPart[key];
                if (value && typeof value === 'object') {
                    if ('xstate$$type' in value && value.xstate$$type === (0, $7fce67e153198813$export$3d8c2f653ac9d0b9)) {
                        contextPart[key] = children[value.id];
                        continue;
                    }
                    reviveContext(value, children);
                }
            }
        }
        reviveContext(restoredSnapshot.context, children);
        return restoredSnapshot;
    }
    constructor(/** The raw config used to create the machine. */ config, implementations){
        this.config = config;
        /** The machine's own version. */ this.version = void 0;
        this.schemas = void 0;
        this.implementations = void 0;
        /** @internal */ this.__xstatenode = true;
        /** @internal */ this.idMap = new Map();
        this.root = void 0;
        this.id = void 0;
        this.states = void 0;
        this.events = void 0;
        this.id = config.id || '(machine)';
        var _implementations_actors, _implementations_actions, _implementations_delays, _implementations_guards;
        this.implementations = {
            actors: (_implementations_actors = implementations === null || implementations === void 0 ? void 0 : implementations.actors) !== null && _implementations_actors !== void 0 ? _implementations_actors : {},
            actions: (_implementations_actions = implementations === null || implementations === void 0 ? void 0 : implementations.actions) !== null && _implementations_actions !== void 0 ? _implementations_actions : {},
            delays: (_implementations_delays = implementations === null || implementations === void 0 ? void 0 : implementations.delays) !== null && _implementations_delays !== void 0 ? _implementations_delays : {},
            guards: (_implementations_guards = implementations === null || implementations === void 0 ? void 0 : implementations.guards) !== null && _implementations_guards !== void 0 ? _implementations_guards : {}
        };
        this.version = this.config.version;
        this.schemas = this.config.schemas;
        this.transition = this.transition.bind(this);
        this.getInitialSnapshot = this.getInitialSnapshot.bind(this);
        this.getPersistedSnapshot = this.getPersistedSnapshot.bind(this);
        this.restoreSnapshot = this.restoreSnapshot.bind(this);
        this.start = this.start.bind(this);
        this.root = new $23198f69e99780f2$export$342f24f5edd47b1(config, {
            _key: this.id,
            _machine: this
        });
        this.root._initialize();
        this.states = this.root.states; // TODO: remove!
        this.events = this.root.events;
    }
}
/**
 * Creates a state machine (statechart) with the given configuration.
 *
 * The state machine represents the pure logic of a state machine actor.
 *
 * @example
 *
 * ```ts
 * import { createMachine } from 'xstate';
 *
 * const lightMachine = createMachine({
 *   id: 'light',
 *   initial: 'green',
 *   states: {
 *     green: {
 *       on: {
 *         TIMER: { target: 'yellow' }
 *       }
 *     },
 *     yellow: {
 *       on: {
 *         TIMER: { target: 'red' }
 *       }
 *     },
 *     red: {
 *       on: {
 *         TIMER: { target: 'green' }
 *       }
 *     }
 *   }
 * });
 *
 * const lightActor = createActor(lightMachine);
 * lightActor.start();
 *
 * lightActor.send({ type: 'TIMER' });
 * ```
 *
 * @param config The state machine configuration.
 * @param options DEPRECATED: use `setup({ ... })` or `machine.provide({ ... })`
 *   to provide machine implementations instead.
 */ function $23198f69e99780f2$export$aaa7fa18f8e9b2e8(config, implementations) {
    return new $23198f69e99780f2$export$cbf2d83d1eab018a(config, implementations);
}
/** @internal */ function $23198f69e99780f2$var$createInertActorScope(actorLogic) {
    const self = (0, $7fce67e153198813$export$ebd11618f299a286)(actorLogic);
    const inertActorScope = {
        self: self,
        defer: ()=>{},
        id: '',
        logger: ()=>{},
        sessionId: '',
        stopChild: ()=>{},
        system: self.system,
        emit: ()=>{},
        actionExecutor: ()=>{}
    };
    return inertActorScope;
}
/** @deprecated Use `initialTransition(…)` instead. */ function $23198f69e99780f2$export$e1c3f9a97f5088ae(actorLogic, ...[input]) {
    const actorScope = $23198f69e99780f2$var$createInertActorScope(actorLogic);
    return actorLogic.getInitialSnapshot(actorScope, input);
}
/**
 * Determines the next snapshot for the given `actorLogic` based on the given
 * `snapshot` and `event`.
 *
 * If the `snapshot` is `undefined`, the initial snapshot of the `actorLogic` is
 * used.
 *
 * @deprecated Use `transition(…)` instead.
 * @example
 *
 * ```ts
 * import { getNextSnapshot } from 'xstate';
 * import { trafficLightMachine } from './trafficLightMachine.ts';
 *
 * const nextSnapshot = getNextSnapshot(
 *   trafficLightMachine, // actor logic
 *   undefined, // snapshot (or initial state if undefined)
 *   { type: 'TIMER' }
 * ); // event object
 *
 * console.log(nextSnapshot.value);
 * // => 'yellow'
 *
 * const nextSnapshot2 = getNextSnapshot(
 *   trafficLightMachine, // actor logic
 *   nextSnapshot, // snapshot
 *   { type: 'TIMER' }
 * ); // event object
 *
 * console.log(nextSnapshot2.value);
 * // =>'red'
 * ```
 */ function $23198f69e99780f2$export$3629c64713e6dfd7(actorLogic, snapshot, event) {
    const inertActorScope = $23198f69e99780f2$var$createInertActorScope(actorLogic);
    inertActorScope.self._snapshot = snapshot;
    return actorLogic.transition(snapshot, event, inertActorScope);
}
// at the moment we allow extra actors - ones that are not specified by `children`
// this could be reconsidered in the future
function $23198f69e99780f2$export$de27182ff8187d6c({ schemas: schemas, actors: actors, actions: actions, guards: guards, delays: delays }) {
    return {
        createMachine: (config)=>$23198f69e99780f2$export$aaa7fa18f8e9b2e8((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, config), {
                schemas: schemas
            }), {
                actors: actors,
                actions: actions,
                guards: guards,
                delays: delays
            })
    };
}
// eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging
// eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging
class $23198f69e99780f2$export$7413adad607e2cdf {
    now() {
        return this._now;
    }
    getId() {
        return this._id++;
    }
    setTimeout(fn, timeout) {
        this._flushingInvalidated = this._flushing;
        const id = this.getId();
        this.timeouts.set(id, {
            start: this.now(),
            timeout: timeout,
            fn: fn
        });
        return id;
    }
    clearTimeout(id) {
        this._flushingInvalidated = this._flushing;
        this.timeouts.delete(id);
    }
    set(time) {
        if (this._now > time) throw new Error('Unable to travel back in time');
        this._now = time;
        this.flushTimeouts();
    }
    flushTimeouts() {
        if (this._flushing) {
            this._flushingInvalidated = true;
            return;
        }
        this._flushing = true;
        const sorted = [
            ...this.timeouts
        ].sort(([_idA, timeoutA], [_idB, timeoutB])=>{
            const endA = timeoutA.start + timeoutA.timeout;
            const endB = timeoutB.start + timeoutB.timeout;
            return endB > endA ? -1 : 1;
        });
        for (const [id, timeout] of sorted){
            if (this._flushingInvalidated) {
                this._flushingInvalidated = false;
                this._flushing = false;
                this.flushTimeouts();
                return;
            }
            if (this.now() - timeout.start >= timeout.timeout) {
                this.timeouts.delete(id);
                timeout.fn.call(null);
            }
        }
        this._flushing = false;
    }
    increment(ms) {
        this._now += ms;
        this.flushTimeouts();
    }
    constructor(){
        this.timeouts = new Map();
        this._now = 0;
        this._id = 0;
        this._flushing = false;
        this._flushingInvalidated = false;
    }
}
/**
 * Returns a promise that resolves to the `output` of the actor when it is done.
 *
 * @example
 *
 * ```ts
 * const machine = createMachine({
 *   // ...
 *   output: {
 *     count: 42
 *   }
 * });
 *
 * const actor = createActor(machine);
 *
 * actor.start();
 *
 * const output = await toPromise(actor);
 *
 * console.log(output);
 * // logs { count: 42 }
 * ```
 */ function $23198f69e99780f2$export$4dbaaf6c79705e6c(actor) {
    return new Promise((resolve, reject)=>{
        actor.subscribe({
            complete: ()=>{
                resolve(actor.getSnapshot().output);
            },
            error: reject
        });
    });
}
/**
 * Given actor `logic`, a `snapshot`, and an `event`, returns a tuple of the
 * `nextSnapshot` and `actions` to execute.
 *
 * This is a pure function that does not execute `actions`.
 */ function $23198f69e99780f2$export$66bb15e2994e6a26(logic, snapshot, event) {
    const executableActions = [];
    const actorScope = $23198f69e99780f2$var$createInertActorScope(logic);
    actorScope.actionExecutor = (action)=>{
        executableActions.push(action);
    };
    const nextSnapshot = logic.transition(snapshot, event, actorScope);
    return [
        nextSnapshot,
        executableActions
    ];
}
/**
 * Given actor `logic` and optional `input`, returns a tuple of the
 * `nextSnapshot` and `actions` to execute from the initial transition (no
 * previous state).
 *
 * This is a pure function that does not execute `actions`.
 */ function $23198f69e99780f2$export$5f4d25c77127242(logic, ...[input]) {
    const executableActions = [];
    const actorScope = $23198f69e99780f2$var$createInertActorScope(logic);
    actorScope.actionExecutor = (action)=>{
        executableActions.push(action);
    };
    const nextSnapshot = logic.getInitialSnapshot(actorScope, input);
    return [
        nextSnapshot,
        executableActions
    ];
}
const $23198f69e99780f2$var$defaultWaitForOptions = {
    timeout: Infinity // much more than 10 seconds
};
/**
 * Subscribes to an actor ref and waits for its emitted value to satisfy a
 * predicate, and then resolves with that value. Will throw if the desired state
 * is not reached after an optional timeout. (defaults to Infinity).
 *
 * @example
 *
 * ```js
 * const state = await waitFor(someService, (state) => {
 *   return state.hasTag('loaded');
 * });
 *
 * state.hasTag('loaded'); // true
 * ```
 *
 * @param actorRef The actor ref to subscribe to
 * @param predicate Determines if a value matches the condition to wait for
 * @param options
 * @returns A promise that eventually resolves to the emitted value that matches
 *   the condition
 */ function $23198f69e99780f2$export$9bbfceb27f687c1b(actorRef, predicate, options) {
    const resolvedOptions = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $23198f69e99780f2$var$defaultWaitForOptions, options);
    return new Promise((res, rej)=>{
        const { signal: signal } = resolvedOptions;
        if (signal === null || signal === void 0 ? void 0 : signal.aborted) {
            // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
            rej(signal.reason);
            return;
        }
        let done = false;
        const handle = resolvedOptions.timeout === Infinity ? undefined : setTimeout(()=>{
            dispose();
            rej(new Error(`Timeout of ${resolvedOptions.timeout} ms exceeded`));
        }, resolvedOptions.timeout);
        const dispose = ()=>{
            clearTimeout(handle);
            done = true;
            sub === null || sub === void 0 ? void 0 : sub.unsubscribe();
            if (abortListener) signal.removeEventListener('abort', abortListener);
        };
        function checkEmitted(emitted) {
            if (predicate(emitted)) {
                dispose();
                res(emitted);
            }
        }
        /**
     * If the `signal` option is provided, this will be the listener for its
     * `abort` event
     */ let abortListener;
        // eslint-disable-next-line prefer-const
        let sub; // avoid TDZ when disposing synchronously
        // See if the current snapshot already matches the predicate
        checkEmitted(actorRef.getSnapshot());
        if (done) return;
        // only define the `abortListener` if the `signal` option is provided
        if (signal) {
            abortListener = ()=>{
                dispose();
                // XState does not "own" the signal, so we should reject with its reason (if any)
                // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
                rej(signal.reason);
            };
            signal.addEventListener('abort', abortListener);
        }
        sub = actorRef.subscribe({
            next: checkEmitted,
            error: (err)=>{
                dispose();
                // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
                rej(err);
            },
            complete: ()=>{
                dispose();
                rej(new Error(`Actor terminated without satisfying predicate`));
            }
        });
        if (done) sub.unsubscribe();
    });
}





var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
var $e93368a04bf55514$export$2e2bcd8739ae039 = (0, $7fPBF.useLayoutEffect);



var $4124aa6d0b2d559b$exports = {};
'use strict';

$4124aa6d0b2d559b$exports = (parcelRequire("gAJjf"));



var $hL6ll = parcelRequire("hL6ll");
const $83b16362225de870$var$forEachActor = (actorRef, callback)=>{
    callback(actorRef);
    const children = actorRef.getSnapshot().children;
    if (children) Object.values(children).forEach((child)=>{
        $83b16362225de870$var$forEachActor(child, callback);
    });
};
function $83b16362225de870$var$stopRootWithRehydration(actorRef) {
    var _actorRef_system_getSnapshot, _actorRef_system;
    // persist snapshot here in a custom way allows us to persist inline actors and to preserve actor references
    // we do it to avoid setState in useEffect when the effect gets "reconnected"
    // this currently only happens in Strict Effects but it simulates the Offscreen aka Activity API
    // it also just allows us to end up with a somewhat more predictable behavior for the users
    const persistedSnapshots = [];
    $83b16362225de870$var$forEachActor(actorRef, (ref)=>{
        persistedSnapshots.push([
            ref,
            ref.getSnapshot()
        ]);
        // muting observers allow us to avoid `useSelector` from being notified about the stopped snapshot
        // React reconnects its subscribers (from the useSyncExternalStore) on its own
        // and userland subscribers should basically always do the same anyway
        // as each subscription should have its own cleanup logic and that should be called each such reconnect
        ref.observers = new Set();
    });
    const systemSnapshot = (_actorRef_system_getSnapshot = (_actorRef_system = actorRef.system).getSnapshot) === null || _actorRef_system_getSnapshot === void 0 ? void 0 : _actorRef_system_getSnapshot.call(_actorRef_system);
    actorRef.stop();
    actorRef.system._snapshot = systemSnapshot;
    persistedSnapshots.forEach(([ref, snapshot])=>{
        ref._processingStatus = 0;
        ref._snapshot = snapshot;
    });
}
function $83b16362225de870$var$useIdleActorRef(logic, ...[options]) {
    let [[currentConfig, actorRef], setCurrent] = (0, $7fPBF.useState)(()=>{
        const actorRef = (0, $7fce67e153198813$export$ebd11618f299a286)(logic, options);
        return [
            logic.config,
            actorRef
        ];
    });
    if (logic.config !== currentConfig) {
        const newActorRef = (0, $7fce67e153198813$export$ebd11618f299a286)(logic, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, options), {
            snapshot: actorRef.getPersistedSnapshot({
                __unsafeAllowInlineActors: true
            })
        }));
        setCurrent([
            logic.config,
            newActorRef
        ]);
        actorRef = newActorRef;
    }
    // TODO: consider using `useAsapEffect` that would do this in `useInsertionEffect` is that's available
    (0, $e93368a04bf55514$export$2e2bcd8739ae039)(()=>{
        actorRef.logic.implementations = logic.implementations;
    });
    return actorRef;
}
function $83b16362225de870$export$e92bd910f9c89ff6(machine, ...[options, observerOrListener]) {
    const actorRef = $83b16362225de870$var$useIdleActorRef(machine, options);
    (0, $7fPBF.useEffect)(()=>{
        if (!observerOrListener) return;
        const sub = actorRef.subscribe((0, $7fce67e153198813$export$61196ced6d74a310)(observerOrListener));
        return ()=>{
            sub.unsubscribe();
        };
    }, [
        observerOrListener
    ]);
    (0, $7fPBF.useEffect)(()=>{
        actorRef.start();
        return ()=>{
            $83b16362225de870$var$stopRootWithRehydration(actorRef);
        };
    }, [
        actorRef
    ]);
    return actorRef;
}
function $83b16362225de870$var$defaultCompare(a, b) {
    return a === b;
}
function $83b16362225de870$export$2105062e25df4afe(actor, selector, compare = $83b16362225de870$var$defaultCompare) {
    const subscribe = (0, $7fPBF.useCallback)((handleStoreChange)=>{
        if (!actor) return ()=>{};
        const { unsubscribe: unsubscribe } = actor.subscribe(handleStoreChange);
        return unsubscribe;
    }, [
        actor
    ]);
    const boundGetSnapshot = (0, $7fPBF.useCallback)(()=>actor === null || actor === void 0 ? void 0 : actor.getSnapshot(), [
        actor
    ]);
    const selectedSnapshot = (0, $4124aa6d0b2d559b$exports.useSyncExternalStoreWithSelector)(subscribe, boundGetSnapshot, boundGetSnapshot, selector, compare);
    return selectedSnapshot;
}
function $83b16362225de870$export$72ba36f8308928ab(actorLogic, actorOptions) {
    const ReactContext = /*#__PURE__*/ $7fPBF.createContext(null);
    const OriginalProvider = ReactContext.Provider;
    function Provider({ children: children, logic: providedLogic = actorLogic, machine: machine, options: providedOptions }) {
        if (machine) throw new Error(`The "machine" prop has been deprecated. Please use "logic" instead.`);
        const actor = $83b16362225de870$export$e92bd910f9c89ff6(providedLogic, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, actorOptions, providedOptions));
        return /*#__PURE__*/ $7fPBF.createElement(OriginalProvider, {
            value: actor,
            children: children
        });
    }
    // TODO: add properties to actor ref to make more descriptive
    Provider.displayName = `ActorProvider`;
    function useContext() {
        const actor = $7fPBF.useContext(ReactContext);
        if (!actor) throw new Error(`You used a hook from "${Provider.displayName}" but it's not inside a <${Provider.displayName}> component.`);
        return actor;
    }
    function useSelector$1(selector, compare) {
        const actor = useContext();
        return $83b16362225de870$export$2105062e25df4afe(actor, selector, compare);
    }
    return {
        Provider: Provider,
        useActorRef: useContext,
        useSelector: useSelector$1
    };
}
// From https://github.com/reduxjs/react-redux/blob/720f0ba79236cdc3e1115f4ef9a7760a21784b48/src/utils/shallowEqual.ts
function $83b16362225de870$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $83b16362225de870$export$d36bdfa510afb180(objA, objB) {
    if ($83b16362225de870$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$83b16362225de870$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
function $83b16362225de870$export$25c4ab29592aabd9(logic, ...[options]) {
    const actorRef = $83b16362225de870$var$useIdleActorRef(logic, options);
    const getSnapshot = (0, $7fPBF.useCallback)(()=>{
        return actorRef.getSnapshot();
    }, [
        actorRef
    ]);
    const subscribe = (0, $7fPBF.useCallback)((handleStoreChange)=>{
        const { unsubscribe: unsubscribe } = actorRef.subscribe(handleStoreChange);
        return unsubscribe;
    }, [
        actorRef
    ]);
    const actorSnapshot = (0, $hL6ll.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    (0, $7fPBF.useEffect)(()=>{
        actorRef.start();
        return ()=>{
            $83b16362225de870$var$stopRootWithRehydration(actorRef);
        };
    }, [
        actorRef
    ]);
    return [
        actorSnapshot,
        actorRef.send,
        actorRef
    ];
}
/** @alias useActor */ function $83b16362225de870$export$e0338c4153421160(machine, ...[options]) {
    return $83b16362225de870$export$25c4ab29592aabd9(machine, options);
}


const $033df157c314480c$var$localKeys = {
    user: 'identity#user',
    deviceCode: 'identity#deviceCode',
    auth: 'identity#auth'
};
const $033df157c314480c$export$eaefaacc687c1c9a = ()=>{
    const storedUser = localStorage.getItem($033df157c314480c$var$localKeys.user);
    return storedUser ? JSON.parse(storedUser) : null;
};
const $033df157c314480c$export$40e2ef2cb1e7c393 = (value)=>{
    localStorage.setItem($033df157c314480c$var$localKeys.user, JSON.stringify(value || null));
};
const $033df157c314480c$export$76f4495f2a1cab8b = ()=>{
    const storedAuth = localStorage.getItem($033df157c314480c$var$localKeys.auth);
    if (!storedAuth || storedAuth === 'null') return null;
    return JSON.parse(storedAuth || '') || null;
};
const $033df157c314480c$export$bda481e852aceef9 = (value)=>{
    if (!value) localStorage.removeItem($033df157c314480c$var$localKeys.auth);
    localStorage.setItem($033df157c314480c$var$localKeys.auth, JSON.stringify(value));
};
const $033df157c314480c$export$8ff70dd3d41bfa4e = ()=>{
    const storedDeviceCode = localStorage.getItem($033df157c314480c$var$localKeys.deviceCode);
    return storedDeviceCode ? storedDeviceCode : null;
};
const $033df157c314480c$export$6e737441ff4c4a88 = (value)=>{
    localStorage.setItem($033df157c314480c$var$localKeys.deviceCode, value || '');
};





var $c6ba0193c6fadd6f$exports = {};

$c6ba0193c6fadd6f$exports = (parcelRequire("a04va"));






var $7fPBF = parcelRequire("7fPBF");
function $e2e9f7015a5aa268$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $e2e9f7015a5aa268$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $e2e9f7015a5aa268$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $e2e9f7015a5aa268$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $e2e9f7015a5aa268$export$2e2bcd8739ae039 = $e2e9f7015a5aa268$export$4f5d2d50c9deca37;


'use client';
const $de77e498e07914bf$var$u = (t)=>"number" == typeof t && !isNaN(t), $de77e498e07914bf$var$d = (t)=>"string" == typeof t, $de77e498e07914bf$var$p = (t)=>"function" == typeof t, $de77e498e07914bf$var$m = (t)=>$de77e498e07914bf$var$d(t) || $de77e498e07914bf$var$p(t) ? t : null, $de77e498e07914bf$var$f = (t)=>(0, $7fPBF.isValidElement)(t) || $de77e498e07914bf$var$d(t) || $de77e498e07914bf$var$p(t) || $de77e498e07914bf$var$u(t);
function $de77e498e07914bf$export$184cca501f1aed7f(t, e, n) {
    void 0 === n && (n = 300);
    const { scrollHeight: o, style: s } = t;
    requestAnimationFrame(()=>{
        s.minHeight = "initial", s.height = o + "px", s.transition = `all ${n}ms`, requestAnimationFrame(()=>{
            s.height = "0", s.padding = "0", s.margin = "0", setTimeout(e, n);
        });
    });
}
function $de77e498e07914bf$export$3ff7dc44d332d222(e) {
    let { enter: a, exit: r, appendPosition: i = !1, collapse: l = !0, collapseDuration: c = 300 } = e;
    return function(e) {
        let { children: u, position: d, preventExitTransition: p, done: m, nodeRef: f, isIn: h } = e;
        const y = i ? `${a}--${d}` : a, v = i ? `${r}--${d}` : r, T = (0, $7fPBF.useRef)(0);
        return (0, $7fPBF.useLayoutEffect)(()=>{
            const t = f.current, e = y.split(" "), n = (o)=>{
                o.target === f.current && (t.dispatchEvent(new Event("d")), t.removeEventListener("animationend", n), t.removeEventListener("animationcancel", n), 0 === T.current && "animationcancel" !== o.type && t.classList.remove(...e));
            };
            t.classList.add(...e), t.addEventListener("animationend", n), t.addEventListener("animationcancel", n);
        }, []), (0, $7fPBF.useEffect)(()=>{
            const t = f.current, e = ()=>{
                t.removeEventListener("animationend", e), l ? $de77e498e07914bf$export$184cca501f1aed7f(t, m, c) : m();
            };
            h || (p ? e() : (T.current = 1, t.className += ` ${v}`, t.addEventListener("animationend", e)));
        }, [
            h
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, u);
    };
}
function $de77e498e07914bf$var$y(t, e) {
    return null != t ? {
        content: t.content,
        containerId: t.props.containerId,
        id: t.props.toastId,
        theme: t.props.theme,
        type: t.props.type,
        data: t.props.data || {},
        isLoading: t.props.isLoading,
        icon: t.props.icon,
        status: e
    } : {};
}
const $de77e498e07914bf$var$v = {
    list: new Map,
    emitQueue: new Map,
    on (t, e) {
        return this.list.has(t) || this.list.set(t, []), this.list.get(t).push(e), this;
    },
    off (t, e) {
        if (e) {
            const n = this.list.get(t).filter((t)=>t !== e);
            return this.list.set(t, n), this;
        }
        return this.list.delete(t), this;
    },
    cancelEmit (t) {
        const e = this.emitQueue.get(t);
        return e && (e.forEach(clearTimeout), this.emitQueue.delete(t)), this;
    },
    emit (t) {
        this.list.has(t) && this.list.get(t).forEach((e)=>{
            const n = setTimeout(()=>{
                e(...[].slice.call(arguments, 1));
            }, 0);
            this.emitQueue.has(t) || this.emitQueue.set(t, []), this.emitQueue.get(t).push(n);
        });
    }
}, $de77e498e07914bf$var$T = (e)=>{
    let { theme: n, type: o } = e, s = (0, $8901fc92b5563702$export$71511d61b312f219)(e, [
        "theme",
        "type"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        fill: "colored" === n ? "currentColor" : `var(--toastify-icon-color-${o})`
    }, s));
}, $de77e498e07914bf$export$4f13f83fd8bb1dac = {
    info: function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($de77e498e07914bf$var$T, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, e), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
            d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
        }));
    },
    warning: function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($de77e498e07914bf$var$T, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, e), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
            d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
        }));
    },
    success: function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($de77e498e07914bf$var$T, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, e), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
            d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
        }));
    },
    error: function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($de77e498e07914bf$var$T, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, e), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
            d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
        }));
    },
    spinner: function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "Toastify__spinner"
        });
    }
};
function $de77e498e07914bf$export$b262e13ca2dd2381(t) {
    const [, o] = (0, $7fPBF.useReducer)((t)=>t + 1, 0), [l, c] = (0, $7fPBF.useState)([]), g = (0, $7fPBF.useRef)(null), h = (0, $7fPBF.useRef)(new Map).current, T = (t)=>-1 !== l.indexOf(t), C = (0, $7fPBF.useRef)({
        toastKey: 1,
        displayedToast: 0,
        count: 0,
        queue: [],
        props: t,
        containerId: null,
        isToastActive: T,
        getToast: (t)=>h.get(t)
    }).current;
    function b(t) {
        let { containerId: e } = t;
        const { limit: n } = C.props;
        !n || e && C.containerId !== e || (C.count -= C.queue.length, C.queue = []);
    }
    function I(t) {
        c((e)=>null == t ? [] : e.filter((e)=>e !== t));
    }
    function _() {
        const { toastContent: t, toastProps: e, staleId: n } = C.queue.shift();
        O(t, e, n);
    }
    function L(t, n) {
        let { delay: s, staleId: r } = n, i = (0, $8901fc92b5563702$export$71511d61b312f219)(n, [
            "delay",
            "staleId"
        ]);
        if (!$de77e498e07914bf$var$f(t) || function(t) {
            return !g.current || C.props.enableMultiContainer && t.containerId !== C.props.containerId || h.has(t.toastId) && null == t.updateId;
        }(i)) return;
        const { toastId: l, updateId: c, data: T } = i, { props: b } = C, L = ()=>I(l), N = null == c;
        N && C.count++;
        const M = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, b), {
            style: b.toastStyle,
            key: C.toastKey++
        }), Object.fromEntries(Object.entries(i).filter((t)=>{
            let [e, n] = t;
            return null != n;
        }))), {
            toastId: l,
            updateId: c,
            data: T,
            closeToast: L,
            isIn: !1,
            className: $de77e498e07914bf$var$m(i.className || b.toastClassName),
            bodyClassName: $de77e498e07914bf$var$m(i.bodyClassName || b.bodyClassName),
            progressClassName: $de77e498e07914bf$var$m(i.progressClassName || b.progressClassName),
            autoClose: !i.isLoading && (R = i.autoClose, w = b.autoClose, !1 === R || $de77e498e07914bf$var$u(R) && R > 0 ? R : w),
            deleteToast () {
                const t = $de77e498e07914bf$var$y(h.get(l), "removed");
                h.delete(l), $de77e498e07914bf$var$v.emit(4, t);
                const e = C.queue.length;
                if (C.count = null == l ? C.count - C.displayedToast : C.count - 1, C.count < 0 && (C.count = 0), e > 0) {
                    const t = null == l ? C.props.limit : 1;
                    if (1 === e || 1 === t) C.displayedToast++, _();
                    else {
                        const n = t > e ? e : t;
                        C.displayedToast = n;
                        for(let t = 0; t < n; t++)_();
                    }
                } else o();
            }
        });
        var R, w;
        M.iconOut = function(t) {
            let { theme: n, type: o, isLoading: s, icon: r } = t, i = null;
            const l = {
                theme: n,
                type: o
            };
            return !1 === r || ($de77e498e07914bf$var$p(r) ? i = r(l) : (0, $7fPBF.isValidElement)(r) ? i = (0, $7fPBF.cloneElement)(r, l) : $de77e498e07914bf$var$d(r) || $de77e498e07914bf$var$u(r) ? i = r : s ? i = $de77e498e07914bf$export$4f13f83fd8bb1dac.spinner() : ((t)=>t in $de77e498e07914bf$export$4f13f83fd8bb1dac)(o) && (i = $de77e498e07914bf$export$4f13f83fd8bb1dac[o](l))), i;
        }(M), $de77e498e07914bf$var$p(i.onOpen) && (M.onOpen = i.onOpen), $de77e498e07914bf$var$p(i.onClose) && (M.onClose = i.onClose), M.closeButton = b.closeButton, !1 === i.closeButton || $de77e498e07914bf$var$f(i.closeButton) ? M.closeButton = i.closeButton : !0 === i.closeButton && (M.closeButton = !$de77e498e07914bf$var$f(b.closeButton) || b.closeButton);
        let x = t;
        (0, $7fPBF.isValidElement)(t) && !$de77e498e07914bf$var$d(t.type) ? x = (0, $7fPBF.cloneElement)(t, {
            closeToast: L,
            toastProps: M,
            data: T
        }) : $de77e498e07914bf$var$p(t) && (x = t({
            closeToast: L,
            toastProps: M,
            data: T
        })), b.limit && b.limit > 0 && C.count > b.limit && N ? C.queue.push({
            toastContent: x,
            toastProps: M,
            staleId: r
        }) : $de77e498e07914bf$var$u(s) ? setTimeout(()=>{
            O(x, M, r);
        }, s) : O(x, M, r);
    }
    function O(t, e, n) {
        const { toastId: o } = e;
        n && h.delete(n);
        const s = {
            content: t,
            props: e
        };
        h.set(o, s), c((t)=>[
                ...t,
                o
            ].filter((t)=>t !== n)), $de77e498e07914bf$var$v.emit(4, $de77e498e07914bf$var$y(s, null == s.props.updateId ? "added" : "updated"));
    }
    return (0, $7fPBF.useEffect)(()=>(C.containerId = t.containerId, $de77e498e07914bf$var$v.cancelEmit(3).on(0, L).on(1, (t)=>g.current && I(t)).on(5, b).emit(2, C), ()=>{
            h.clear(), $de77e498e07914bf$var$v.emit(3, C);
        }), []), (0, $7fPBF.useEffect)(()=>{
        C.props = t, C.isToastActive = T, C.displayedToast = l.length;
    }), {
        getToastToRender: function(e) {
            const n = new Map, o = Array.from(h.values());
            return t.newestOnTop && o.reverse(), o.forEach((t)=>{
                const { position: e } = t.props;
                n.has(e) || n.set(e, []), n.get(e).push(t);
            }), Array.from(n, (t)=>e(t[0], t[1]));
        },
        containerRef: g,
        isToastActive: T
    };
}
function $de77e498e07914bf$var$b(t) {
    return t.targetTouches && t.targetTouches.length >= 1 ? t.targetTouches[0].clientX : t.clientX;
}
function $de77e498e07914bf$var$I(t) {
    return t.targetTouches && t.targetTouches.length >= 1 ? t.targetTouches[0].clientY : t.clientY;
}
function $de77e498e07914bf$export$a407b657d3044108(t) {
    const [o, a] = (0, $7fPBF.useState)(!1), [r, l] = (0, $7fPBF.useState)(!1), c = (0, $7fPBF.useRef)(null), u = (0, $7fPBF.useRef)({
        start: 0,
        x: 0,
        y: 0,
        delta: 0,
        removalDistance: 0,
        canCloseOnClick: !0,
        canDrag: !1,
        boundingRect: null,
        didMove: !1
    }).current, d = (0, $7fPBF.useRef)(t), { autoClose: m, pauseOnHover: f, closeToast: g, onClick: h, closeOnClick: y } = t;
    function v(e) {
        if (t.draggable) {
            "touchstart" === e.nativeEvent.type && e.nativeEvent.preventDefault(), u.didMove = !1, document.addEventListener("mousemove", _), document.addEventListener("mouseup", L), document.addEventListener("touchmove", _), document.addEventListener("touchend", L);
            const n = c.current;
            u.canCloseOnClick = !0, u.canDrag = !0, u.boundingRect = n.getBoundingClientRect(), n.style.transition = "", u.x = $de77e498e07914bf$var$b(e.nativeEvent), u.y = $de77e498e07914bf$var$I(e.nativeEvent), "x" === t.draggableDirection ? (u.start = u.x, u.removalDistance = n.offsetWidth * (t.draggablePercent / 100)) : (u.start = u.y, u.removalDistance = n.offsetHeight * (80 === t.draggablePercent ? 1.5 * t.draggablePercent : t.draggablePercent / 100));
        }
    }
    function T(e) {
        if (u.boundingRect) {
            const { top: n, bottom: o, left: s, right: a } = u.boundingRect;
            "touchend" !== e.nativeEvent.type && t.pauseOnHover && u.x >= s && u.x <= a && u.y >= n && u.y <= o ? C() : E();
        }
    }
    function E() {
        a(!0);
    }
    function C() {
        a(!1);
    }
    function _(e) {
        const n = c.current;
        u.canDrag && n && (u.didMove = !0, o && C(), u.x = $de77e498e07914bf$var$b(e), u.y = $de77e498e07914bf$var$I(e), u.delta = "x" === t.draggableDirection ? u.x - u.start : u.y - u.start, u.start !== u.x && (u.canCloseOnClick = !1), n.style.transform = `translate${t.draggableDirection}(${u.delta}px)`, n.style.opacity = "" + (1 - Math.abs(u.delta / u.removalDistance)));
    }
    function L() {
        document.removeEventListener("mousemove", _), document.removeEventListener("mouseup", L), document.removeEventListener("touchmove", _), document.removeEventListener("touchend", L);
        const e = c.current;
        if (u.canDrag && u.didMove && e) {
            if (u.canDrag = !1, Math.abs(u.delta) > u.removalDistance) return l(!0), void t.closeToast();
            e.style.transition = "transform 0.2s, opacity 0.2s", e.style.transform = `translate${t.draggableDirection}(0)`, e.style.opacity = "1";
        }
    }
    (0, $7fPBF.useEffect)(()=>{
        d.current = t;
    }), (0, $7fPBF.useEffect)(()=>(c.current && c.current.addEventListener("d", E, {
            once: !0
        }), $de77e498e07914bf$var$p(t.onOpen) && t.onOpen((0, $7fPBF.isValidElement)(t.children) && t.children.props), ()=>{
            const t = d.current;
            $de77e498e07914bf$var$p(t.onClose) && t.onClose((0, $7fPBF.isValidElement)(t.children) && t.children.props);
        }), []), (0, $7fPBF.useEffect)(()=>(t.pauseOnFocusLoss && (document.hasFocus() || C(), window.addEventListener("focus", E), window.addEventListener("blur", C)), ()=>{
            t.pauseOnFocusLoss && (window.removeEventListener("focus", E), window.removeEventListener("blur", C));
        }), [
        t.pauseOnFocusLoss
    ]);
    const O = {
        onMouseDown: v,
        onTouchStart: v,
        onMouseUp: T,
        onTouchEnd: T
    };
    return m && f && (O.onMouseEnter = C, O.onMouseLeave = E), y && (O.onClick = (t)=>{
        h && h(t), u.canCloseOnClick && g();
    }), {
        playToast: E,
        pauseToast: C,
        isRunning: o,
        preventExitTransition: r,
        toastRef: c,
        eventHandlers: O
    };
}
function $de77e498e07914bf$var$L(e) {
    let { closeToast: n, theme: o, ariaLabel: s = "close" } = e;
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("button", {
        className: `Toastify__close-button Toastify__close-button--${o}`,
        type: "button",
        onClick: (t)=>{
            t.stopPropagation(), n(t);
        },
        "aria-label": s
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 14 16"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        fillRule: "evenodd",
        d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
    })));
}
function $de77e498e07914bf$var$O(e) {
    let { delay: n, isRunning: o, closeToast: s, type: a = "default", hide: r, className: i, style: l, controlledProgress: u, progress: d, rtl: m, isIn: f, theme: g } = e;
    const h = r || u && 0 === d, y = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, l), {
        animationDuration: `${n}ms`,
        animationPlayState: o ? "running" : "paused",
        opacity: h ? 0 : 1
    });
    u && (y.transform = `scaleX(${d})`);
    const v = (0, $e2e9f7015a5aa268$export$2e2bcd8739ae039)("Toastify__progress-bar", u ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${g}`, `Toastify__progress-bar--${a}`, {
        "Toastify__progress-bar--rtl": m
    }), T = $de77e498e07914bf$var$p(i) ? i({
        rtl: m,
        type: a,
        defaultClassName: v
    }) : (0, $e2e9f7015a5aa268$export$2e2bcd8739ae039)(v, i);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        role: "progressbar",
        "aria-hidden": h ? "true" : "false",
        "aria-label": "notification timer",
        className: T,
        style: y,
        [u && d >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: u && d < 1 ? null : ()=>{
            f && s();
        }
    });
}
const $de77e498e07914bf$var$N = (n)=>{
    const { isRunning: o, preventExitTransition: s, toastRef: r, eventHandlers: i } = $de77e498e07914bf$export$a407b657d3044108(n), { closeButton: l, children: u, autoClose: d, onClick: m, type: f, hideProgressBar: g, closeToast: h, transition: y, position: v, className: T, style: E, bodyClassName: C, bodyStyle: b, progressClassName: I, progressStyle: N, updateId: M, role: R, progress: w, rtl: x, toastId: $, deleteToast: k, isIn: P, isLoading: B, iconOut: D, closeOnClick: A, theme: z } = n, F = (0, $e2e9f7015a5aa268$export$2e2bcd8739ae039)("Toastify__toast", `Toastify__toast-theme--${z}`, `Toastify__toast--${f}`, {
        "Toastify__toast--rtl": x
    }, {
        "Toastify__toast--close-on-click": A
    }), H = $de77e498e07914bf$var$p(T) ? T({
        rtl: x,
        position: v,
        type: f,
        defaultClassName: F
    }) : (0, $e2e9f7015a5aa268$export$2e2bcd8739ae039)(F, T), S = !!w || !d, q = {
        closeToast: h,
        type: f,
        theme: z
    };
    let Q = null;
    return !1 === l || (Q = $de77e498e07914bf$var$p(l) ? l(q) : (0, $7fPBF.isValidElement)(l) ? (0, $7fPBF.cloneElement)(l, q) : $de77e498e07914bf$var$L(q)), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(y, {
        isIn: P,
        done: k,
        position: v,
        preventExitTransition: s,
        nodeRef: r
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        id: $,
        onClick: m,
        className: H
    }, i), {
        style: E,
        ref: r
    }), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, P && {
        role: R
    }), {
        className: $de77e498e07914bf$var$p(C) ? C({
            type: f
        }) : (0, $e2e9f7015a5aa268$export$2e2bcd8739ae039)("Toastify__toast-body", C),
        style: b
    }), null != D && (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        className: (0, $e2e9f7015a5aa268$export$2e2bcd8739ae039)("Toastify__toast-icon", {
            "Toastify--animate-icon Toastify__zoom-enter": !B
        })
    }, D), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", null, u)), Q, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($de77e498e07914bf$var$O, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, M && !S ? {
        key: `pb-${M}`
    } : {}), {
        rtl: x,
        theme: z,
        delay: d,
        isRunning: o,
        isIn: P,
        closeToast: h,
        hide: g,
        type: f,
        style: N,
        className: I,
        controlledProgress: S,
        progress: w || 0
    }))));
}, $de77e498e07914bf$var$M = function(t, e) {
    return void 0 === e && (e = !1), {
        enter: `Toastify--animate Toastify__${t}-enter`,
        exit: `Toastify--animate Toastify__${t}-exit`,
        appendPosition: e
    };
}, $de77e498e07914bf$export$d20e79fdc3899e95 = $de77e498e07914bf$export$3ff7dc44d332d222($de77e498e07914bf$var$M("bounce", !0)), $de77e498e07914bf$export$d8dc01b5c85a37b9 = $de77e498e07914bf$export$3ff7dc44d332d222($de77e498e07914bf$var$M("slide", !0)), $de77e498e07914bf$export$65cfd44a2050f99 = $de77e498e07914bf$export$3ff7dc44d332d222($de77e498e07914bf$var$M("zoom")), $de77e498e07914bf$export$4d2fae537bd90431 = $de77e498e07914bf$export$3ff7dc44d332d222($de77e498e07914bf$var$M("flip")), $de77e498e07914bf$export$f2815235e76a62b9 = (0, $7fPBF.forwardRef)((e, n)=>{
    const { getToastToRender: o, containerRef: a, isToastActive: r } = $de77e498e07914bf$export$b262e13ca2dd2381(e), { className: i, style: l, rtl: u, containerId: d } = e;
    function f(t) {
        const e = (0, $e2e9f7015a5aa268$export$2e2bcd8739ae039)("Toastify__toast-container", `Toastify__toast-container--${t}`, {
            "Toastify__toast-container--rtl": u
        });
        return $de77e498e07914bf$var$p(i) ? i({
            position: t,
            rtl: u,
            defaultClassName: e
        }) : (0, $e2e9f7015a5aa268$export$2e2bcd8739ae039)(e, $de77e498e07914bf$var$m(i));
    }
    return (0, $7fPBF.useEffect)(()=>{
        n && (n.current = a.current);
    }, []), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        ref: a,
        className: "Toastify",
        id: d
    }, o((e, n)=>{
        const o = n.length ? (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, l) : (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, l), {
            pointerEvents: "none"
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: f(e),
            style: o,
            key: `container-${e}`
        }, n.map((e, o)=>{
            let { content: s, props: a } = e;
            return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($de77e498e07914bf$var$N, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, a), {
                isIn: r(a.toastId),
                style: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, a.style), {
                    "--nth": o + 1,
                    "--len": n.length
                }),
                key: `toast-${a.key}`
            }), s);
        }));
    }));
});
$de77e498e07914bf$export$f2815235e76a62b9.displayName = "ToastContainer", $de77e498e07914bf$export$f2815235e76a62b9.defaultProps = {
    position: "top-right",
    transition: $de77e498e07914bf$export$d20e79fdc3899e95,
    autoClose: 5e3,
    closeButton: $de77e498e07914bf$var$L,
    pauseOnHover: !0,
    pauseOnFocusLoss: !0,
    closeOnClick: !0,
    draggable: !0,
    draggablePercent: 80,
    draggableDirection: "x",
    role: "alert",
    theme: "light"
};
let $de77e498e07914bf$var$P, $de77e498e07914bf$var$B = new Map, $de77e498e07914bf$var$D = [], $de77e498e07914bf$var$A = 1;
function $de77e498e07914bf$var$z() {
    return "" + $de77e498e07914bf$var$A++;
}
function $de77e498e07914bf$var$F(t) {
    return t && ($de77e498e07914bf$var$d(t.toastId) || $de77e498e07914bf$var$u(t.toastId)) ? t.toastId : $de77e498e07914bf$var$z();
}
function $de77e498e07914bf$var$H(t, e) {
    return $de77e498e07914bf$var$B.size > 0 ? $de77e498e07914bf$var$v.emit(0, t, e) : $de77e498e07914bf$var$D.push({
        content: t,
        options: e
    }), e.toastId;
}
function $de77e498e07914bf$var$S(t, e) {
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, e), {
        type: e && e.type || t,
        toastId: $de77e498e07914bf$var$F(e)
    });
}
function $de77e498e07914bf$var$q(t) {
    return (e, n)=>$de77e498e07914bf$var$H(e, $de77e498e07914bf$var$S(t, n));
}
function $de77e498e07914bf$export$b410431fab84fa58(t, e) {
    return $de77e498e07914bf$var$H(t, $de77e498e07914bf$var$S("default", e));
}
$de77e498e07914bf$export$b410431fab84fa58.loading = (t, e)=>$de77e498e07914bf$var$H(t, $de77e498e07914bf$var$S("default", (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        isLoading: !0,
        autoClose: !1,
        closeOnClick: !1,
        closeButton: !1,
        draggable: !1
    }, e))), $de77e498e07914bf$export$b410431fab84fa58.promise = function(t, e, n) {
    let o, { pending: s, error: a, success: r } = e;
    s && (o = $de77e498e07914bf$var$d(s) ? $de77e498e07914bf$export$b410431fab84fa58.loading(s, n) : $de77e498e07914bf$export$b410431fab84fa58.loading(s.render, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, n, s)));
    const i = {
        isLoading: null,
        autoClose: null,
        closeOnClick: null,
        closeButton: null,
        draggable: null
    }, l = (t, e, s)=>{
        if (null == e) return void $de77e498e07914bf$export$b410431fab84fa58.dismiss(o);
        const a = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            type: t
        }, i, n), {
            data: s
        }), r = $de77e498e07914bf$var$d(e) ? {
            render: e
        } : e;
        return o ? $de77e498e07914bf$export$b410431fab84fa58.update(o, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, a, r)) : $de77e498e07914bf$export$b410431fab84fa58(r.render, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, a, r)), s;
    }, c = $de77e498e07914bf$var$p(t) ? t() : t;
    return c.then((t)=>l("success", r, t)).catch((t)=>l("error", a, t)), c;
}, $de77e498e07914bf$export$b410431fab84fa58.success = $de77e498e07914bf$var$q("success"), $de77e498e07914bf$export$b410431fab84fa58.info = $de77e498e07914bf$var$q("info"), $de77e498e07914bf$export$b410431fab84fa58.error = $de77e498e07914bf$var$q("error"), $de77e498e07914bf$export$b410431fab84fa58.warning = $de77e498e07914bf$var$q("warning"), $de77e498e07914bf$export$b410431fab84fa58.warn = $de77e498e07914bf$export$b410431fab84fa58.warning, $de77e498e07914bf$export$b410431fab84fa58.dark = (t, e)=>$de77e498e07914bf$var$H(t, $de77e498e07914bf$var$S("default", (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        theme: "dark"
    }, e))), $de77e498e07914bf$export$b410431fab84fa58.dismiss = (t)=>{
    $de77e498e07914bf$var$B.size > 0 ? $de77e498e07914bf$var$v.emit(1, t) : $de77e498e07914bf$var$D = $de77e498e07914bf$var$D.filter((e)=>null != t && e.options.toastId !== t);
}, $de77e498e07914bf$export$b410431fab84fa58.clearWaitingQueue = function(t) {
    return void 0 === t && (t = {}), $de77e498e07914bf$var$v.emit(5, t);
}, $de77e498e07914bf$export$b410431fab84fa58.isActive = (t)=>{
    let e = !1;
    return $de77e498e07914bf$var$B.forEach((n)=>{
        n.isToastActive && n.isToastActive(t) && (e = !0);
    }), e;
}, $de77e498e07914bf$export$b410431fab84fa58.update = function(t, e) {
    void 0 === e && (e = {}), setTimeout(()=>{
        const n = function(t, e) {
            let { containerId: n } = e;
            const o = $de77e498e07914bf$var$B.get(n || $de77e498e07914bf$var$P);
            return o && o.getToast(t);
        }(t, e);
        if (n) {
            const { props: o, content: s } = n, a = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                delay: 100
            }, o, e), {
                toastId: e.toastId || t,
                updateId: $de77e498e07914bf$var$z()
            });
            a.toastId !== t && (a.staleId = t);
            const r = a.render || s;
            delete a.render, $de77e498e07914bf$var$H(r, a);
        }
    }, 0);
}, $de77e498e07914bf$export$b410431fab84fa58.done = (t)=>{
    $de77e498e07914bf$export$b410431fab84fa58.update(t, {
        progress: 1
    });
}, $de77e498e07914bf$export$b410431fab84fa58.onChange = (t)=>($de77e498e07914bf$var$v.on(4, t), ()=>{
        $de77e498e07914bf$var$v.off(4, t);
    }), $de77e498e07914bf$export$b410431fab84fa58.POSITION = {
    TOP_LEFT: "top-left",
    TOP_RIGHT: "top-right",
    TOP_CENTER: "top-center",
    BOTTOM_LEFT: "bottom-left",
    BOTTOM_RIGHT: "bottom-right",
    BOTTOM_CENTER: "bottom-center"
}, $de77e498e07914bf$export$b410431fab84fa58.TYPE = {
    INFO: "info",
    SUCCESS: "success",
    WARNING: "warning",
    ERROR: "error",
    DEFAULT: "default"
}, $de77e498e07914bf$var$v.on(2, (t)=>{
    $de77e498e07914bf$var$P = t.containerId || t, $de77e498e07914bf$var$B.set($de77e498e07914bf$var$P, t), $de77e498e07914bf$var$D.forEach((t)=>{
        $de77e498e07914bf$var$v.emit(0, t.content, t.options);
    }), $de77e498e07914bf$var$D = [];
}).on(3, (t)=>{
    $de77e498e07914bf$var$B.delete(t.containerId || t), 0 === $de77e498e07914bf$var$B.size && $de77e498e07914bf$var$v.off(0).off(1).off(5);
});


var $aba38a333ca575f4$export$243e62d78d3b544d = /*#__PURE__*/ function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["INFO"] = 1] = "INFO";
    LogLevel[LogLevel["WARN"] = 2] = "WARN";
    LogLevel[LogLevel["ERROR"] = 3] = "ERROR";
    return LogLevel;
}({});
const $aba38a333ca575f4$export$12dbaabc76fb091a = (level)=>{
    switch(level.toUpperCase()){
        case 'DEBUG':
            return 0;
        case 'INFO':
            return 1;
        case 'WARN':
            return 2;
        case 'ERROR':
            return 3;
        default:
            return 1;
    }
};
class $aba38a333ca575f4$export$efa9a398d6368992 {
    static debug(message) {
        $aba38a333ca575f4$export$efa9a398d6368992.level == 0 && console.debug(message);
    }
    static info(message) {
        $aba38a333ca575f4$export$efa9a398d6368992.level <= 1 && console.info(message);
    }
    static warn(message) {
        $aba38a333ca575f4$export$efa9a398d6368992.level <= 3 && console.warn(message);
    }
    static error(message) {
        console.error(message);
    }
}
$aba38a333ca575f4$export$efa9a398d6368992.level = 1;
const $aba38a333ca575f4$export$456217d509c3213e = {
    toastId: 'error-toast',
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
    progress: undefined,
    theme: 'colored',
    transition: (0, $de77e498e07914bf$export$65cfd44a2050f99)
};
const $aba38a333ca575f4$export$2a283cfcdfa3d711 = (message)=>{
    (0, $de77e498e07914bf$export$b410431fab84fa58)(message, $aba38a333ca575f4$export$456217d509c3213e);
};



const $0c9ab1c6c858b47d$export$d69db95f4df4095d = {
    noAuthorization: true
};
const $0c9ab1c6c858b47d$export$299ba2dee77727e9 = async (domain, path, body, options)=>{
    (0, $aba38a333ca575f4$export$efa9a398d6368992).debug(`posting ${domain}/${path} with ${JSON.stringify(body)}`);
    const config = $0c9ab1c6c858b47d$var$buildConfig(options);
    const response = await (0, (/*@__PURE__*/$parcel$interopDefault($c6ba0193c6fadd6f$exports))).post(`${domain}/${path}`, body, config);
    (0, $aba38a333ca575f4$export$efa9a398d6368992).debug(`post response was ${JSON.stringify(response)}`);
    return response.data;
};
const $0c9ab1c6c858b47d$export$3988ae62b71be9a3 = async (domain, path, options)=>{
    (0, $aba38a333ca575f4$export$efa9a398d6368992).debug(`getting  ${domain}/${path}`);
    const config = $0c9ab1c6c858b47d$var$buildConfig(options);
    const response = await (0, (/*@__PURE__*/$parcel$interopDefault($c6ba0193c6fadd6f$exports))).get(`${domain}/${path}`, config);
    return response.data;
};
const $0c9ab1c6c858b47d$export$93e5c64e4cc246c8 = async (url, options)=>{
    (0, $aba38a333ca575f4$export$efa9a398d6368992).debug(`getting ${url}`);
    const config = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $0c9ab1c6c858b47d$var$buildConfig(options)), {
        responseType: 'blob'
    });
    const response = await (0, (/*@__PURE__*/$parcel$interopDefault($c6ba0193c6fadd6f$exports))).get(`${url}`, config);
    return response.data;
};
const $0c9ab1c6c858b47d$export$8d8542dbbc23fe1a = async (domain, path, options)=>{
    (0, $aba38a333ca575f4$export$efa9a398d6368992).debug(`deleting  ${domain}/${path}`);
    const config = $0c9ab1c6c858b47d$var$buildConfig(options);
    await (0, (/*@__PURE__*/$parcel$interopDefault($c6ba0193c6fadd6f$exports))).delete(`${domain}/${path}`, config);
};
function $0c9ab1c6c858b47d$var$buildConfig(options) {
    if (options.noAuthorization) return $0c9ab1c6c858b47d$var$getEmptyConfig();
    if (!options.sessionToken) throw new Error('sessionToken not provided in buildConfig');
    if (!options.userId) throw new Error('userId not provided in buildConfig');
    const apparentDeviceCode = options.deviceCode || (0, $033df157c314480c$export$8ff70dd3d41bfa4e)();
    if (!apparentDeviceCode) throw new Error('no apparent deviceCode available in buildConfig');
    return $0c9ab1c6c858b47d$var$getAuthorizedConfig($0c9ab1c6c858b47d$var$getEmptyConfig(), options.userId, apparentDeviceCode, options.sessionToken);
}
function $0c9ab1c6c858b47d$var$getEmptyConfig() {
    return {
        headers: {}
    };
}
function $0c9ab1c6c858b47d$var$getAuthorizedConfig(config, userId, deviceCode, sessionToken) {
    const authorization = `${userId}#${deviceCode}#${sessionToken}`;
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, config), {
        headers: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, config.headers || {}), {
            Authorization: `Bearer ${authorization}`
        })
    });
}
const $0c9ab1c6c858b47d$export$a9c162a9e81d4a06 = (authClient, deviceCode)=>{
    return {
        userId: authClient.user.userId || '',
        deviceCode: deviceCode,
        sessionToken: authClient.sessionToken
    };
};


const $7ddfa7eb44375504$var$getAppRequestOptions = async (options)=>{
    if (options === null || options === void 0 ? void 0 : options.noAuthorization) return options;
    if (!options || !options.sessionToken || !options.userId || !options.deviceCode) return (0, $97cadf28d7015811$export$209d0cb5060b8e69)();
    return options;
};
const $7ddfa7eb44375504$export$dc890958d2b428da = {
    post: async (domain, path, body, options)=>{
        return (0, $0c9ab1c6c858b47d$export$299ba2dee77727e9)(domain, path, body, await $7ddfa7eb44375504$var$getAppRequestOptions(options));
    },
    get: async (domain, path, options)=>{
        return (0, $0c9ab1c6c858b47d$export$3988ae62b71be9a3)(domain, path, await $7ddfa7eb44375504$var$getAppRequestOptions(options));
    },
    getImage: async (url, options)=>{
        return (0, $0c9ab1c6c858b47d$export$93e5c64e4cc246c8)(url, await $7ddfa7eb44375504$var$getAppRequestOptions(options));
    },
    deleteItem: async (domain, path, options)=>{
        return (0, $0c9ab1c6c858b47d$export$8d8542dbbc23fe1a)(domain, path, await $7ddfa7eb44375504$var$getAppRequestOptions(options));
    }
};


var $0ad3711e2390627b$export$38b05b4ee2d2caef = /*#__PURE__*/ function(AuthSource) {
    AuthSource["guest"] = "guest";
    AuthSource["magicLink"] = "magicLink";
    return AuthSource;
}({});
const $0ad3711e2390627b$export$fe0294c75de58802 = 'https://med93mwkuc.execute-api.us-east-1.amazonaws.com/dev/apiv2';
const $0ad3711e2390627b$export$69b4912dd0d3ff2e = `identity/guest-auth/handle`;
const $0ad3711e2390627b$export$a0bbdd0781f8d4de = `identity/guest-session/request`;
const $0ad3711e2390627b$export$88fb49dac348ef8e = `identity/magic-link/new-user`;
const $0ad3711e2390627b$export$ca60928511fee483 = `identity/magic-link/request`;
const $0ad3711e2390627b$export$6a54539c821f69c4 = `identity/magic-link/redeem-for-session`;
const $0ad3711e2390627b$export$ad79f082c23e7971 = `identity/device-code`;
const $0ad3711e2390627b$export$e1fd3975c7b35415 = `identity/healthcheck`;
const $0ad3711e2390627b$export$b7b861670b8332b3 = `healthcheck`;



const $96df24f4563b5dd5$export$2f4c5886d2314005 = async ()=>{
    const previous = (0, $033df157c314480c$export$8ff70dd3d41bfa4e)();
    if (previous) return previous;
    const { deviceCode: deviceCode } = await (0, $7ddfa7eb44375504$export$dc890958d2b428da).get((0, $0ad3711e2390627b$export$fe0294c75de58802), (0, $0ad3711e2390627b$export$ad79f082c23e7971), {
        noAuthorization: true
    });
    (0, $033df157c314480c$export$6e737441ff4c4a88)(deviceCode);
    return deviceCode;
};








const $59115c410ae6cbf5$export$db40b73adfa065e8 = async ()=>{
    const response = await (0, $0c9ab1c6c858b47d$export$3988ae62b71be9a3)((0, $0ad3711e2390627b$export$fe0294c75de58802), (0, $0ad3711e2390627b$export$69b4912dd0d3ff2e), {
        noAuthorization: true
    });
    return response.handle;
};
const $59115c410ae6cbf5$export$efbf511f9a384bf6 = async (deviceCode, handle)=>{
    if (!deviceCode) throw new Error('can not request auth without deviceCode');
    const request = {
        deviceCode: deviceCode,
        handle: handle
    };
    const sessionResponse = await (0, $7ddfa7eb44375504$export$dc890958d2b428da).post((0, $0ad3711e2390627b$export$fe0294c75de58802), (0, $0ad3711e2390627b$export$a0bbdd0781f8d4de), request, {
        noAuthorization: true
    });
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, sessionResponse), {
        authSource: (0, $0ad3711e2390627b$export$38b05b4ee2d2caef).guest
    });
};
const $59115c410ae6cbf5$export$a65659cbf019a8b3 = async (handle)=>{
    (0, $aba38a333ca575f4$export$efa9a398d6368992).warn(`update handle not implemented - handle was ${handle}`);
    return;
};
const $59115c410ae6cbf5$export$ca6ebab9f76f31f5 = async (user, sessionToken, deviceCode)=>{
    if (!user) {
        (0, $aba38a333ca575f4$export$efa9a398d6368992).debug(`identity healthcheck failure - without comparison user`);
        throw new Error(`identity healthcheck failure - without comparison user`);
    }
    if (!sessionToken) {
        (0, $aba38a333ca575f4$export$efa9a398d6368992).debug(`identity healthcheck failure - without sessionToken`);
        throw new Error(`identity healthcheck failure - without sessionToken`);
    }
    try {
        var _result_info;
        const result = await (0, $7ddfa7eb44375504$export$dc890958d2b428da).get((0, $0ad3711e2390627b$export$fe0294c75de58802), (0, $0ad3711e2390627b$export$e1fd3975c7b35415), {
            userId: user.userId,
            sessionToken: sessionToken,
            deviceCode: deviceCode || undefined
        });
        if ((result === null || result === void 0 ? void 0 : (_result_info = result.info) === null || _result_info === void 0 ? void 0 : _result_info.userId) !== user.userId) {
            var _result_info1, _result_info2;
            (0, $aba38a333ca575f4$export$efa9a398d6368992).debug(`expected user ${user.handle} - ${user.userId} but got ${result === null || result === void 0 ? void 0 : (_result_info1 = result.info) === null || _result_info1 === void 0 ? void 0 : _result_info1.handle} - ${result === null || result === void 0 ? void 0 : (_result_info2 = result.info) === null || _result_info2 === void 0 ? void 0 : _result_info2.userId}`);
            throw new Error(`identity healthcheck failure - did not find expected user`);
        }
        return result;
    } catch (ex) {
        const result = await $59115c410ae6cbf5$export$f6339471d6a6a0c7() // throw this if neither succeeds, ie API is down
        ;
        return result;
    }
};
const $59115c410ae6cbf5$export$f6339471d6a6a0c7 = async ()=>{
    try {
        const healthResponse = await (0, $7ddfa7eb44375504$export$dc890958d2b428da).get((0, $0ad3711e2390627b$export$fe0294c75de58802), (0, $0ad3711e2390627b$export$b7b861670b8332b3), {
            noAuthorization: true
        });
        if (!(healthResponse === null || healthResponse === void 0 ? void 0 : healthResponse.health)) throw new Error('healthcheck failure');
        return healthResponse;
    } catch (ex) {
        throw new Error(`healthcheck failure`);
    }
};



function $fd4f404b5352696d$export$5464853d700fc7c4(items) {
    return items[Math.floor(Math.random() * items.length)];
}
function $fd4f404b5352696d$export$673b4ccd6b20e752() {
    return Math.floor(1000 + Math.random() * 9000);
}
function $fd4f404b5352696d$export$d83fcf4d803be328(keys, source) {
    keys.forEach((key)=>{
        (0, $aba38a333ca575f4$export$efa9a398d6368992).debug(`storage at ${source || 'unknown'} for key ${key} has ${JSON.stringify(localStorage.getItem(key))}`);
    });
}
const $fd4f404b5352696d$export$a57e9bef4b3b52d0 = (ms)=>{
    return new Promise((resolve)=>setTimeout(resolve, ms));
};




var $e0f6ede31c4671a1$exports = {};
var $e0f6ede31c4671a1$var$_globalThis;

if (typeof globalThis === 'object') $e0f6ede31c4671a1$var$_globalThis = globalThis;
else try {
    $e0f6ede31c4671a1$var$_globalThis = (parcelRequire("aqFA5"));
} catch (error) {} finally{
    if (!$e0f6ede31c4671a1$var$_globalThis && typeof window !== 'undefined') $e0f6ede31c4671a1$var$_globalThis = window;
    if (!$e0f6ede31c4671a1$var$_globalThis) throw new Error('Could not determine global this');
}
var $e0f6ede31c4671a1$var$NativeWebSocket = $e0f6ede31c4671a1$var$_globalThis.WebSocket || $e0f6ede31c4671a1$var$_globalThis.MozWebSocket;
var $73e50f32276ecb65$exports = {};

$73e50f32276ecb65$exports = (parcelRequire("7qKYm")).version;


/**
 * Expose a W3C WebSocket class with just one or two arguments.
 */ function $e0f6ede31c4671a1$var$W3CWebSocket(uri, protocols) {
    var native_instance;
    if (protocols) native_instance = new $e0f6ede31c4671a1$var$NativeWebSocket(uri, protocols);
    else native_instance = new $e0f6ede31c4671a1$var$NativeWebSocket(uri);
    /**
	 * 'native_instance' is an instance of nativeWebSocket (the browser's WebSocket
	 * class). Since it is an Object it will be returned as it is when creating an
	 * instance of W3CWebSocket via 'new W3CWebSocket()'.
	 *
	 * ECMAScript 5: http://bclary.com/2004/11/07/#a-13.2.2
	 */ return native_instance;
}
if ($e0f6ede31c4671a1$var$NativeWebSocket) [
    'CONNECTING',
    'OPEN',
    'CLOSING',
    'CLOSED'
].forEach(function(prop) {
    Object.defineProperty($e0f6ede31c4671a1$var$W3CWebSocket, prop, {
        get: function() {
            return $e0f6ede31c4671a1$var$NativeWebSocket[prop];
        }
    });
});
/**
 * Module exports.
 */ $e0f6ede31c4671a1$exports = {
    'w3cwebsocket': $e0f6ede31c4671a1$var$NativeWebSocket ? $e0f6ede31c4671a1$var$W3CWebSocket : null,
    'version': $73e50f32276ecb65$exports
};



const $b93fbb979342838e$export$75df8273cd15a834 = (channel, target)=>channel + '$' + target;
const $b93fbb979342838e$export$b29887217a473c6 = (channels, channel)=>!!channels.find((ch)=>ch.channel === channel.channel && ch.topic === channel.topic);
const $b93fbb979342838e$var$getOutboundMessageString = (message)=>JSON.stringify((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, message), {
        sent: Date.now()
    }));
const $b93fbb979342838e$export$7ba24559de2e3800 = 'wss://17th2f1o5l.execute-api.us-east-1.amazonaws.com/dev';
const $b93fbb979342838e$var$closingStatuses = [
    (0, $e0f6ede31c4671a1$exports.w3cwebsocket).CLOSED,
    (0, $e0f6ede31c4671a1$exports.w3cwebsocket).CLOSING
];
var $b93fbb979342838e$export$e324594224ef24da = /*#__PURE__*/ function(actions) {
    actions["sendChat"] = "sendChat";
    actions["sendAuthTicket"] = "sendAuthTicket";
    actions["sendHeartbeat"] = "sendHeartbeat";
    return actions;
}({});
var $b93fbb979342838e$export$ff0f8bd07799254c = /*#__PURE__*/ function(defaultChannels) {
    defaultChannels["global"] = "GLOBAL";
    defaultChannels["heartbeat"] = "HEARTBEAT";
    defaultChannels["chat"] = "CHAT";
    defaultChannels["auth"] = "AUTH";
    defaultChannels["game"] = "GAME";
    return defaultChannels;
}({});
const $b93fbb979342838e$export$465cb47180de50f0 = (socket, action, message, auth, channel)=>{
    if (!socket || $b93fbb979342838e$var$closingStatuses.includes(socket === null || socket === void 0 ? void 0 : socket.readyState)) throw new Error('Attempted to send message with closed socket');
    if (auth.noAuthorization) throw new Error('attempted send message with no auth');
    const outString = $b93fbb979342838e$var$getOutboundMessageString({
        action: action,
        channel: channel,
        message: message,
        userId: auth.userId,
        deviceCode: auth.deviceCode || '',
        session: auth.sessionToken
    });
    (0, $aba38a333ca575f4$export$efa9a398d6368992).debug(`mb sending string to socket ${outString}`);
    socket.send(outString);
};
const $b93fbb979342838e$export$eecdf3e0575eed66 = (socket, auth)=>{
    if (auth.noAuthorization) throw new Error('attempted sendAuthTicket with noAuthorization');
    const authTicket = {
        userId: auth.userId,
        deviceCode: auth.deviceCode || '',
        session: auth.sessionToken
    };
    (0, $aba38a333ca575f4$export$efa9a398d6368992).debug(`sending authticket ${JSON.stringify(authTicket)}`);
    $b93fbb979342838e$export$465cb47180de50f0(socket, "sendAuthTicket", authTicket, auth, "AUTH");
};
const $b93fbb979342838e$export$b0ad1624411f5644 = (socket, auth)=>{
    (0, $aba38a333ca575f4$export$efa9a398d6368992).debug(`sending heartbeat`);
    const message = {
        heartbeatTimeStamp: Date.now()
    };
    $b93fbb979342838e$export$465cb47180de50f0(socket, "sendHeartbeat", message, auth, "HEARTBEAT");
};





const $97cadf28d7015811$export$412d2991813e589a = 'connection';
const $97cadf28d7015811$var$getInitialSocket = ()=>({
        client: null,
        retries: 0,
        retryInterval: 1000,
        retryTick: 1,
        heartbeatTimer: 0,
        heartbeatInterval: 10000,
        timeUntilNextRetry: 1000
    });
const $97cadf28d7015811$var$getInitialContext = ()=>({
        deviceCode: (0, $033df157c314480c$export$8ff70dd3d41bfa4e)(),
        user: (0, $033df157c314480c$export$eaefaacc687c1c9a)(),
        authClient: (0, $033df157c314480c$export$76f4495f2a1cab8b)(),
        auth_error: '',
        inboundMessages: [],
        outboundMessages: [],
        messageClients: {},
        socket: $97cadf28d7015811$var$getInitialSocket()
    });
const $97cadf28d7015811$export$34b7050a0afc2406 = (0, $23198f69e99780f2$export$aaa7fa18f8e9b2e8)({
    // predictableActionArguments: true,
    // preserveActionOrder: true,
    id: $97cadf28d7015811$export$412d2991813e589a,
    types: {},
    type: 'parallel',
    context: $97cadf28d7015811$var$getInitialContext(),
    on: {
        LOGOUT: {
            target: '.auth.logging_out'
        },
        '*': {
            actions: [
                'logUnhandledEvent'
            ]
        }
    },
    states: {
        auth: {
            initial: 'disconnected',
            states: {
                disconnected: {
                    // authentication unknown or missing
                    always: [
                        {
                            target: 'awaiting_device_code',
                            guard: 'isDeviceCodeUnset'
                        },
                        {
                            target: 'awaiting_identity_validity_check',
                            guard: 'isAuthAppearValid'
                        },
                        {
                            target: 'logging_in'
                        }
                    ],
                    entry: [],
                    exit: []
                },
                awaiting_device_code: {
                    invoke: {
                        id: 'await_device_code',
                        src: (0, $3a9fcf29fc53ac8b$export$60f45028237c39d1)(()=>(0, $96df24f4563b5dd5$export$2f4c5886d2314005)()),
                        onDone: {
                            target: 'disconnected',
                            actions: [
                                'logEvent',
                                (0, $218c98dc8c315a3f$export$407448d2b89b1813)({
                                    deviceCode: ({ event: event })=>event.output,
                                    user: ()=>null,
                                    authClient: ()=>null
                                })
                            ]
                        },
                        onError: {
                            target: 'api_down'
                        }
                    }
                },
                api_down: {
                    entry: [
                        'logEvent'
                    ],
                    after: {
                        3000: {
                            target: 'disconnected'
                        }
                    }
                },
                awaiting_identity_validity_check: {
                    invoke: {
                        id: 'try_validity_check',
                        src: (0, $3a9fcf29fc53ac8b$export$60f45028237c39d1)(async ({ input: input })=>(0, $59115c410ae6cbf5$export$ca6ebab9f76f31f5)(input.authClient.user, input.authClient.sessionToken, input.deviceCode)),
                        input: ({ context: context })=>context,
                        onDone: [
                            {
                                target: 'valid',
                                guard: 'wasIdentityHealthCheckSuccessful'
                            },
                            {
                                target: 'logging_out'
                            }
                        ],
                        onError: {
                            actions: (0, $218c98dc8c315a3f$export$407448d2b89b1813)({
                                auth_error: ({ event: event })=>event.error.message
                            }),
                            target: 'api_down'
                        }
                    }
                },
                logging_out: {
                    always: [
                        {
                            actions: [
                                'logEvent',
                                'logout',
                                'closeSocket',
                                (0, $218c98dc8c315a3f$export$407448d2b89b1813)({
                                    user: ()=>null,
                                    authClient: ()=>null,
                                    socket: ()=>$97cadf28d7015811$var$getInitialSocket()
                                })
                            ],
                            target: 'logging_in'
                        }
                    ]
                },
                logging_in: {
                    // substate controlled by login page
                    on: {
                        AUTH_RESPONSE_RECEIVED: {
                            target: 'valid',
                            actions: [
                                'logEvent',
                                (0, $218c98dc8c315a3f$export$407448d2b89b1813)({
                                    user: ({ event: event })=>event.value.user,
                                    authClient: ({ event: event })=>event.value
                                }),
                                'storeAuthInfo'
                            ]
                        }
                    }
                },
                valid: {
                    on: {
                        AUTH_USE_ERROR: {
                            target: 'corrupt'
                        }
                    },
                    initial: 'ready',
                    states: {
                        ready: {
                            entry: [
                                (0, $7fce67e153198813$export$c4ce752e73470fba)({
                                    type: 'AUTH_IS_VALID'
                                }),
                                'logEvent'
                            ]
                        }
                    }
                },
                corrupt: {
                    entry: [
                        'logEvent'
                    ]
                }
            }
        },
        socket: {
            initial: 'disconnected',
            on: {
                SEND: {
                    actions: [
                        'logEvent',
                        (0, $218c98dc8c315a3f$export$407448d2b89b1813)({
                            outboundMessages: ({ context: context, event: event })=>[
                                    event.value,
                                    ...context.outboundMessages
                                ]
                        }),
                        (0, $7fce67e153198813$export$c4ce752e73470fba)({
                            type: 'SOCKET_SEND_MESSAGE_ENQUEUED'
                        })
                    ]
                },
                SOCKET_MESSAGE: {
                    actions: [
                        'logEvent',
                        (0, $218c98dc8c315a3f$export$407448d2b89b1813)({
                            inboundMessages: ({ context: context, event: event })=>{
                                return [
                                    event.value,
                                    ...context.inboundMessages
                                ];
                            }
                        })
                    ],
                    target: '.connected.getMessage'
                },
                SOCKET_CLOSED: [
                    {
                        actions: [
                            'logEvent'
                        ],
                        target: '.disconnected.connecting',
                        guard: 'isAuthAppearValid'
                    },
                    {
                        actions: [
                            'logEvent'
                        ],
                        target: '.disconnected.noauth'
                    }
                ],
                SOCKET_SUBSCRIBE: {
                    actions: [
                        'logEvent',
                        (0, $218c98dc8c315a3f$export$407448d2b89b1813)({
                            messageClients: ({ context: context, event: event })=>{
                                const client = event.value;
                                return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, context.messageClients), {
                                    [client.clientId]: client
                                });
                            }
                        })
                    ]
                },
                SOCKET_UNSUBSCRIBE: {
                    actions: [
                        'logEvent',
                        (0, $218c98dc8c315a3f$export$407448d2b89b1813)({
                            messageClients: ({ context: context, event: event })=>{
                                const clientId = event.value;
                                if (context.messageClients[clientId]) {
                                    const filteredClients = {};
                                    for(const key in context.messageClients)if (key !== clientId) filteredClients[key] = context.messageClients[key];
                                    return filteredClients;
                                }
                                return context.messageClients;
                            }
                        })
                    ]
                }
            },
            states: {
                disconnected: {
                    initial: 'noauth',
                    on: {
                        SOCKET_AUTH_RESPONSE: {
                            target: 'connected'
                        },
                        AUTH_IS_VALID: {
                            actions: [
                                'logEvent'
                            ],
                            target: '.connecting'
                        }
                    },
                    states: {
                        noauth: {
                            on: {
                                SOCKET_SEND_MESSAGE_ENQUEUED: {
                                    actions: [
                                        'logEvent'
                                    ],
                                    target: 'connecting'
                                },
                                AUTH_IS_VALID: {
                                    actions: [
                                        'logEvent'
                                    ],
                                    target: 'connecting'
                                }
                            }
                        },
                        awaitRetry: {
                            after: {
                                1000: {
                                    actions: [
                                        'logEvent'
                                    ],
                                    target: 'connecting'
                                }
                            }
                        },
                        connecting: {
                            invoke: {
                                id: 'connectingWebSocket',
                                src: (0, $3a9fcf29fc53ac8b$export$60f45028237c39d1)(async ({ input: input })=>{
                                    const parent = input.parent;
                                    (0, $aba38a333ca575f4$export$efa9a398d6368992).debug('connectingWebSocket');
                                    const socketClient = new (0, $e0f6ede31c4671a1$exports.w3cwebsocket)((0, $b93fbb979342838e$export$7ba24559de2e3800));
                                    socketClient.onopen = ()=>{
                                        var _input_authClient;
                                        if ((_input_authClient = input.authClient) === null || _input_authClient === void 0 ? void 0 : _input_authClient.sessionToken) (0, $b93fbb979342838e$export$eecdf3e0575eed66)(socketClient, (0, $0c9ab1c6c858b47d$export$a9c162a9e81d4a06)(input.authClient, input.deviceCode));
                                    };
                                    socketClient.onmessage = (received)=>{
                                        var _received_data, _received_data1;
                                        (0, $aba38a333ca575f4$export$efa9a398d6368992).debug(`Message received in low level handler: ${JSON.stringify(received)}  ... data is ${JSON.stringify(received === null || received === void 0 ? void 0 : (_received_data = received.data) === null || _received_data === void 0 ? void 0 : _received_data.toString())}`);
                                        const messageText = (received === null || received === void 0 ? void 0 : (_received_data1 = received.data) === null || _received_data1 === void 0 ? void 0 : _received_data1.toString()) || null;
                                        if (!messageText) {
                                            (0, $aba38a333ca575f4$export$efa9a398d6368992).debug('empty socket message?');
                                            return;
                                        }
                                        const message = JSON.parse(messageText);
                                        if (message.channel === (0, $b93fbb979342838e$export$ff0f8bd07799254c).heartbeat) {
                                            (0, $aba38a333ca575f4$export$efa9a398d6368992).debug('got heartbeat');
                                            parent.send({
                                                type: 'SOCKET_RECEIVED_HEARTBEAT'
                                            });
                                            return;
                                        }
                                        if (message.channel === (0, $b93fbb979342838e$export$ff0f8bd07799254c).auth) {
                                            (0, $aba38a333ca575f4$export$efa9a398d6368992).debug('sending SOCKET_AUTH_RESPONSE from connecting');
                                            parent.send({
                                                type: 'SOCKET_AUTH_RESPONSE'
                                            });
                                            return;
                                        }
                                        parent.send({
                                            type: 'SOCKET_MESSAGE',
                                            value: message
                                        });
                                        return;
                                    };
                                    socketClient.onclose = ()=>parent.send({
                                            type: 'SOCKET_CLOSED'
                                        });
                                    socketClient.onerror = ()=>parent.send({
                                            type: 'SOCKET_CLOSED'
                                        });
                                    return socketClient;
                                }),
                                input: ({ context: context, self: self })=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, context), {
                                        parent: self
                                    }),
                                onDone: {
                                    target: 'waitingAuthResponse',
                                    actions: [
                                        'logEvent',
                                        (0, $218c98dc8c315a3f$export$407448d2b89b1813)({
                                            socket: ({ context: context, event: event })=>{
                                                return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, context.socket), {
                                                    client: event.output
                                                });
                                            }
                                        })
                                    ]
                                },
                                onError: {
                                    actions: [
                                        'logEvent'
                                    ],
                                    target: 'noauth'
                                }
                            }
                        },
                        waitingAuthResponse: {
                            after: {
                                10000: {
                                    target: 'awaitRetry'
                                }
                            }
                        }
                    }
                },
                connected: {
                    on: {
                        SOCKET_SEND_ERROR: {
                            actions: [
                                'logEvent'
                            ],
                            target: 'disconnected.connecting'
                        },
                        SOCKET_AUTH_RESPONSE: {
                            actions: [
                                'logEvent'
                            ]
                        }
                    },
                    initial: 'ready',
                    states: {
                        ready: {
                            on: {
                                SOCKET_SEND_MESSAGE_ENQUEUED: {
                                    actions: [
                                        'logEvent'
                                    ],
                                    target: 'sendMessage'
                                }
                            },
                            after: {
                                60000: {
                                    target: 'sendHeartbeat'
                                }
                            }
                        },
                        sendMessage: {
                            always: {
                                target: 'ready',
                                actions: [
                                    (0, $218c98dc8c315a3f$export$407448d2b89b1813)({
                                        outboundMessages: ({ context: context })=>{
                                            var _context_socket, _context_authClient, _context_socket_client, _context_socket1, _context_socket_client1, _context_socket2;
                                            if (!(context === null || context === void 0 ? void 0 : (_context_socket = context.socket) === null || _context_socket === void 0 ? void 0 : _context_socket.client)) {
                                                const message = 'Tried to process messages when socket unintialized';
                                                (0, $aba38a333ca575f4$export$efa9a398d6368992).debug(message);
                                                throw new Error(message);
                                            }
                                            if (!(context === null || context === void 0 ? void 0 : (_context_authClient = context.authClient) === null || _context_authClient === void 0 ? void 0 : _context_authClient.sessionToken)) {
                                                const message = 'Tried to process messages when session unready';
                                                (0, $aba38a333ca575f4$export$efa9a398d6368992).debug(message);
                                                throw new Error(message);
                                            }
                                            if ((context === null || context === void 0 ? void 0 : (_context_socket1 = context.socket) === null || _context_socket1 === void 0 ? void 0 : (_context_socket_client = _context_socket1.client) === null || _context_socket_client === void 0 ? void 0 : _context_socket_client.readyState) !== (context === null || context === void 0 ? void 0 : (_context_socket2 = context.socket) === null || _context_socket2 === void 0 ? void 0 : (_context_socket_client1 = _context_socket2.client) === null || _context_socket_client1 === void 0 ? void 0 : _context_socket_client1.OPEN)) {
                                                const message = 'Tried to process messages when socket not open';
                                                (0, $aba38a333ca575f4$export$efa9a398d6368992).debug(message);
                                                throw new Error(message);
                                            }
                                            (0, $aba38a333ca575f4$export$efa9a398d6368992).debug(`connected and sending ${context.outboundMessages.length}`);
                                            const outboundQueue = [
                                                ...context.outboundMessages
                                            ];
                                            const outboundErrored = [];
                                            while(outboundQueue.length > 0){
                                                const message = outboundQueue.shift();
                                                if (!message) {
                                                    (0, $aba38a333ca575f4$export$efa9a398d6368992).debug('skipping blank message');
                                                    continue;
                                                }
                                                try {
                                                    (0, $b93fbb979342838e$export$465cb47180de50f0)(context.socket.client, message.action, message.message, {
                                                        userId: context.authClient.user.userId,
                                                        deviceCode: context.deviceCode || '',
                                                        sessionToken: context.authClient.sessionToken
                                                    }, message.channel);
                                                } catch (ex) {
                                                    (0, $aba38a333ca575f4$export$efa9a398d6368992).error(`error sending sending message ${ex.message}`);
                                                    outboundErrored.unshift(message);
                                                }
                                            }
                                            return outboundErrored;
                                        }
                                    })
                                ]
                            }
                        },
                        getMessage: {
                            always: {
                                target: 'ready',
                                actions: [
                                    (0, $218c98dc8c315a3f$export$407448d2b89b1813)({
                                        inboundMessages: ({ context: context })=>{
                                            if (!context.inboundMessages.length) {
                                                (0, $aba38a333ca575f4$export$efa9a398d6368992).debug('connectedProcessMessages but nothing to process');
                                                return [];
                                            }
                                            (0, $aba38a333ca575f4$export$efa9a398d6368992).debug(`connected and processing ${context.inboundMessages.length} inbound`);
                                            const inboundMessages = [
                                                ...context.inboundMessages
                                            ];
                                            while(inboundMessages.length){
                                                const message = inboundMessages.shift();
                                                if (!message) {
                                                    (0, $aba38a333ca575f4$export$efa9a398d6368992).debug('connectedProcessMessages: encountered a null message');
                                                    continue;
                                                }
                                                if (message.channel === (0, $b93fbb979342838e$export$ff0f8bd07799254c).auth) {
                                                    (0, $aba38a333ca575f4$export$efa9a398d6368992).debug('got auth message in connectedProcessMessages');
                                                    continue;
                                                }
                                                if (message.channel === (0, $b93fbb979342838e$export$ff0f8bd07799254c).heartbeat) {
                                                    (0, $aba38a333ca575f4$export$efa9a398d6368992).debug('got heartbeat message in connectedProcessMessages');
                                                    continue;
                                                }
                                                try {
                                                    const clientArray = Object.values(context.messageClients);
                                                    let callBackFound = false;
                                                    clientArray.forEach((client)=>{
                                                        console.log(`inspecting message with ${message.channel}, ${message.topic}`);
                                                        if (client.callback && (0, $b93fbb979342838e$export$b29887217a473c6)(client.channels, {
                                                            channel: message.channel,
                                                            topic: message.topic
                                                        })) {
                                                            callBackFound = true;
                                                            client.callback(message);
                                                        }
                                                    });
                                                    if (!callBackFound) throw new Error(`could not find client for message on channel ${message.channel} topic ${message.topic}`);
                                                } catch (ex) {
                                                    (0, $aba38a333ca575f4$export$efa9a398d6368992).error(`error receiving message ${ex.message}`);
                                                }
                                            }
                                            return [];
                                        }
                                    })
                                ]
                            }
                        },
                        sendHeartbeat: {
                            always: {
                                actions: [
                                    'logEvent',
                                    ({ context: context })=>{
                                        if (!context.socket.client) throw new Error('attempted to send heartbeat when socket.client was null');
                                        if (!(context === null || context === void 0 ? void 0 : context.authClient)) throw new Error('attempted to send heartbeat when authClient was null');
                                        (0, $b93fbb979342838e$export$b0ad1624411f5644)(context.socket.client, (0, $0c9ab1c6c858b47d$export$a9c162a9e81d4a06)(context.authClient, context.deviceCode || ''));
                                    }
                                ],
                                target: 'ready'
                            }
                        }
                    }
                },
                corrupt: {
                    // socket open, but auth is bad
                    on: {
                        SOCKET_CLOSED: {
                            target: 'disconnected.noauth'
                        }
                    }
                }
            }
        }
    }
}, {
    guards: {
        isDeviceCodeUnset: ({ context: context })=>{
            return !context.deviceCode;
        },
        isAuthAppearValid: ({ context: context })=>{
            if (!context.authClient) {
                (0, $aba38a333ca575f4$export$efa9a398d6368992).info('auth invalid: no authclient');
                return false;
            }
            return true;
        },
        wasIdentityHealthCheckSuccessful: ({ event: event })=>{
            var _response_info;
            const response = event === null || event === void 0 ? void 0 : event.output;
            return !!(response === null || response === void 0 ? void 0 : (_response_info = response.info) === null || _response_info === void 0 ? void 0 : _response_info.userId);
        },
        isGetUserRejected: ({ context: context, event: event })=>{
            (0, $aba38a333ca575f4$export$efa9a398d6368992).debug(`isGetUserRejected: auth_error: ${JSON.stringify(context.auth_error)}, event: ${JSON.stringify(event)}`);
            return false;
        }
    },
    actions: {
        logEvent: ({ event: event })=>{
            (0, $aba38a333ca575f4$export$efa9a398d6368992).debug(`connectionState logEvent sees event: ${JSON.stringify(event)}`);
        },
        logUnhandledEvent: ({ event: event })=>{
            (0, $aba38a333ca575f4$export$efa9a398d6368992).debug(`unhandled event: ${JSON.stringify(event)}`);
        },
        closeSocket: ({ context: context })=>{
            context.socket.client && context.socket.client.close();
        },
        logout: ()=>{
            (0, $033df157c314480c$export$bda481e852aceef9)(null);
            (0, $033df157c314480c$export$40e2ef2cb1e7c393)(null);
        },
        storeAuthInfo: ({ context: context, event: event })=>{
            var _typedEvent_value;
            const typedEvent = event;
            if ((_typedEvent_value = typedEvent.value) === null || _typedEvent_value === void 0 ? void 0 : _typedEvent_value.user) {
                (0, $033df157c314480c$export$bda481e852aceef9)(typedEvent.value);
                (0, $033df157c314480c$export$40e2ef2cb1e7c393)(typedEvent.value.user);
            } else {
                (0, $033df157c314480c$export$bda481e852aceef9)(context.authClient);
                (0, $033df157c314480c$export$40e2ef2cb1e7c393)(context.user);
            }
        }
    }
});
const $97cadf28d7015811$export$af54d3055d90c64e = (0, $83b16362225de870$export$72ba36f8308928ab)($97cadf28d7015811$export$34b7050a0afc2406);
const $97cadf28d7015811$export$dc37312681b1d526 = (state)=>{
    var _state_context_authClient_user, _state_context_authClient, _state_context_authClient1;
    return {
        userId: ((_state_context_authClient = state.context.authClient) === null || _state_context_authClient === void 0 ? void 0 : (_state_context_authClient_user = _state_context_authClient.user) === null || _state_context_authClient_user === void 0 ? void 0 : _state_context_authClient_user.userId) || '',
        deviceCode: state.context.deviceCode || undefined,
        sessionToken: ((_state_context_authClient1 = state.context.authClient) === null || _state_context_authClient1 === void 0 ? void 0 : _state_context_authClient1.sessionToken) || ''
    };
};
const $97cadf28d7015811$export$c2f2062409a9bb62 = (state)=>{
    (0, $aba38a333ca575f4$export$efa9a398d6368992).debug('rebuilding set of message subscriptions');
    return new Set(Object.keys(state.context.messageClients));
};
const $97cadf28d7015811$export$209d0cb5060b8e69 = async ()=>{
    let { authClient: authClient, deviceCode: deviceCode } = $97cadf28d7015811$export$af54d3055d90c64e.useSelector((state)=>({
            authClient: state.context.authClient,
            deviceCode: state.context.deviceCode
        }));
    let delay = 50;
    while(!authClient && delay < 1000){
        (0, $aba38a333ca575f4$export$efa9a398d6368992).debug(`getAuth - could not find authClient on context, retrying after ${delay}`);
        await (0, $fd4f404b5352696d$export$a57e9bef4b3b52d0)(delay);
        delay = delay * 2;
        authClient = $97cadf28d7015811$export$af54d3055d90c64e.useSelector((state)=>state.context.authClient);
    }
    if (!authClient) throw new Error(`no authClient to get: ${JSON.stringify($97cadf28d7015811$export$af54d3055d90c64e.useSelector((state)=>state.context))}`);
    return {
        userId: authClient.user.userId,
        deviceCode: deviceCode || '',
        sessionToken: authClient.sessionToken
    };
};
const $97cadf28d7015811$export$3283fab48c574712 = (state)=>{
    return state.matches({
        auth: 'valid'
    }) || state.matches({
        auth: 'awaiting_identity_validity_check'
    });
};
const $97cadf28d7015811$export$83a0b2c8b56b6a6e = (state)=>{
    return state.context.deviceCode;
};
const $97cadf28d7015811$export$210c0a88ec4709b = (state)=>{
    const user = state.context.user;
    if (!user) throw new Error('attempted to get user when not logged in');
    return user;
};






var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
var $7444594dc418e4bf$var$localKeys = /*#__PURE__*/ function(localKeys) {
    localKeys["targetPath"] = "targetPath";
    return localKeys;
}($7444594dc418e4bf$var$localKeys || {});
function $7444594dc418e4bf$var$getTargetPath() {
    return localStorage.getItem("targetPath") || '/';
}
function $7444594dc418e4bf$var$setTargetPath(targetPath) {
    localStorage.setItem("targetPath", targetPath || '');
}
let $7444594dc418e4bf$var$showDevOutput = false;
const $7444594dc418e4bf$var$doShowDevOutput = ()=>{
    return $7444594dc418e4bf$var$showDevOutput;
};
window.toggleDevOutput = ()=>{
    $7444594dc418e4bf$var$showDevOutput = !$7444594dc418e4bf$var$showDevOutput;
};
const $7444594dc418e4bf$export$dfe60afd992a4bb4 = {
    getTargetPath: $7444594dc418e4bf$var$getTargetPath,
    setTargetPath: $7444594dc418e4bf$var$setTargetPath,
    doShowDevOutput: $7444594dc418e4bf$var$doShowDevOutput
};
const $7444594dc418e4bf$export$122994dc05ba4308 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext($7444594dc418e4bf$export$dfe60afd992a4bb4);




const $2c7da3fbd9998db5$export$6586c12bbf6d0c20 = {
    ERROR_MUST_PROVIDE_EMAIL_AND_DEVICE_CODE_FOR_MAGIC_LINK: 'must provide email and deviceCode to get magic link',
    ERROR_USER_FOR_EMAIL_ALREADY_EXISTS: 'different user already exists with this email address',
    ERROR_USER_FOR_EMAIL_NOT_FOUND: 'user for email address not found',
    MAGIC_LINK_NOT_FOUND: 'could not find a magic link for that email address...',
    MAGIC_LINK_HASH_DID_NOT_MATCH: 'MagicLink hash did not match',
    ERROR_STORAGE_OPERATION: 'Unknown storage failure'
};


var $a9bcab544e716c31$export$53b73d8fd52108b8;
(function(Pronouns) {
    Pronouns["They"] = "They";
    Pronouns["He"] = "He";
    Pronouns["She"] = "She";
})($a9bcab544e716c31$export$53b73d8fd52108b8 || ($a9bcab544e716c31$export$53b73d8fd52108b8 = {}));
const $a9bcab544e716c31$export$c1a09d4ded678080 = {
    They: {
        s: 'they',
        o: 'them',
        p: 'their',
        pp: 'theirs',
        r: 'themself'
    },
    He: {
        s: 'he',
        o: 'him',
        p: 'his',
        pp: 'his',
        r: 'himself'
    },
    She: {
        s: 'she',
        o: 'her',
        p: 'her',
        pp: 'hers',
        r: 'herself'
    }
};







const $01b2e30d67ce3ce6$export$84e10d496f51e7c5 = {
    front: {
        chatRoomId: 'chrm-front',
        chatroomName: 'chrm-front'
    },
    echo: {
        chatRoomId: 'chrm-echo',
        chatroomName: 'chrm-echo'
    }
};
// TODO prod environment
const $01b2e30d67ce3ce6$var$chatServiceUrl = 'https://med93mwkuc.execute-api.us-east-1.amazonaws.com/dev/apiv2';
const $01b2e30d67ce3ce6$var$chatRoomPath = 'chatroom';
const $01b2e30d67ce3ce6$export$fc85a86f73777664 = (message, chatRoomId, fromUid, fromHandle, auth)=>{
    const chatData = {
        text: message,
        fromMember: {
            uid: fromUid,
            handle: fromHandle,
            pronouns: (0, $a9bcab544e716c31$export$53b73d8fd52108b8).They
        },
        toChatRoomId: chatRoomId,
        dateOrigin: new Date()
    };
    if (auth.noAuthorization) throw new Error('attempted buildOutboundChatMessage with noAuthorization');
    const outboundMessage = {
        action: (0, $b93fbb979342838e$export$e324594224ef24da).sendChat,
        message: chatData,
        channel: (0, $b93fbb979342838e$export$ff0f8bd07799254c).chat,
        userId: auth.userId,
        deviceCode: auth.deviceCode || '',
        session: auth.sessionToken
    };
    return outboundMessage;
};
const $01b2e30d67ce3ce6$export$b70413ad874db7ca = (message)=>{
    if (message.channel !== (0, $b93fbb979342838e$export$ff0f8bd07799254c).chat) return null;
    const data = message.data;
    return {
        text: data.text,
        userId: data.fromMember.uid,
        displayName: data.fromMember.handle,
        timeReceived: new Date()
    };
};
const $01b2e30d67ce3ce6$var$getChatRoom = async (options, chatRoomId = $01b2e30d67ce3ce6$export$84e10d496f51e7c5.front.chatRoomId)=>{
    const chatRoom = await (0, $7ddfa7eb44375504$export$dc890958d2b428da).get($01b2e30d67ce3ce6$var$chatServiceUrl, `${$01b2e30d67ce3ce6$var$chatRoomPath}/${encodeURIComponent(chatRoomId)}`, options);
    if (!chatRoom) {
        (0, $aba38a333ca575f4$export$efa9a398d6368992).error(`chatroom was missing / empty: ${JSON.stringify(chatRoom)}`);
        return null;
    }
    const chatLog = chatRoom.chatLog ? chatRoom.chatLog.map((chatData)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, chatData), {
            dateOrigin: new Date(chatData.dateOrigin),
            dateSent: chatData.dateSent && new Date(chatData.dateSent)
        })) : [];
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, chatRoom), {
        chatLog: chatLog
    });
};
const $01b2e30d67ce3ce6$export$dff023ac822ce342 = async (options, chatRoomId)=>{
    const chatRoom = await $01b2e30d67ce3ce6$var$getChatRoom(options, chatRoomId);
    if (!chatRoom || !chatRoom.chatLog) return [];
    return chatRoom.chatLog.map((chatData)=>({
            text: chatData.text,
            userId: chatData.fromMember.uid,
            displayName: chatData.fromMember.handle,
            timeReceived: chatData.dateOrigin
        }));
};
const $01b2e30d67ce3ce6$export$4332053a30844e0e = {
    getChatRoomMessages: $01b2e30d67ce3ce6$export$dff023ac822ce342,
    buildOutboundChatMessage: $01b2e30d67ce3ce6$export$fc85a86f73777664,
    convertInboundMessageToChatMessage: $01b2e30d67ce3ce6$export$b70413ad874db7ca
};





var $f7f4e2622939e64e$var$chatLogReducerOptions = /*#__PURE__*/ function(chatLogReducerOptions) {
    chatLogReducerOptions["add"] = "add";
    chatLogReducerOptions["replace"] = "replace";
    return chatLogReducerOptions;
}($f7f4e2622939e64e$var$chatLogReducerOptions || {});
const $f7f4e2622939e64e$var$initialState = {
    messages: []
};
const $f7f4e2622939e64e$var$chatLogReducer = (state, action)=>{
    (0, $aba38a333ca575f4$export$efa9a398d6368992).debug(`chatbox reducer executing`);
    switch(action.type){
        case "add":
            {
                const lastTenChats = state.messages.slice(-99);
                const nextChat = action.messages[0];
                const nextState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                    messages: [
                        ...lastTenChats,
                        nextChat
                    ]
                });
                (0, $aba38a333ca575f4$export$efa9a398d6368992).debug(`chatbox newState ${JSON.stringify(nextState)}`);
                return nextState;
            }
        case "replace":
            {
                const lastTenChats = action.messages.slice(-99);
                const nextState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                    messages: [
                        ...lastTenChats
                    ]
                });
                return nextState;
            }
        default:
            (0, $aba38a333ca575f4$export$efa9a398d6368992).debug('invalid reducer action in chatLogReducer');
            return state;
    }
};
const $f7f4e2622939e64e$var$ChatBox = ({ chatRoomId: chatRoomId, chatroomName: chatroomName })=>{
    const chatBoxClientId = (0, $b93fbb979342838e$export$75df8273cd15a834)((0, $b93fbb979342838e$export$ff0f8bd07799254c).chat, chatRoomId);
    (0, $aba38a333ca575f4$export$efa9a398d6368992).debug(`chatbot entry with props ${JSON.stringify({
        chatRoomId: chatRoomId,
        chatroomName: chatroomName
    })}`);
    const [chatLogState, chatLogDispatch] = (0, $7fPBF.useReducer)($f7f4e2622939e64e$var$chatLogReducer, $f7f4e2622939e64e$var$initialState);
    const context = (0, $7fPBF.useContext)((0, $7444594dc418e4bf$export$122994dc05ba4308));
    const user = (0, $97cadf28d7015811$export$af54d3055d90c64e).useSelector((0, $97cadf28d7015811$export$210c0a88ec4709b));
    const auth = (0, $97cadf28d7015811$export$af54d3055d90c64e).useSelector((0, $97cadf28d7015811$export$dc37312681b1d526));
    const connection = (0, $97cadf28d7015811$export$af54d3055d90c64e).useActorRef();
    const onMessage = (0, $7fPBF.useCallback)((message)=>{
        const chatMessage = (0, $01b2e30d67ce3ce6$export$4332053a30844e0e).convertInboundMessageToChatMessage(message);
        if (!chatMessage) return;
        (0, $aba38a333ca575f4$export$efa9a398d6368992).debug(`chatbox calling dispatch with ${JSON.stringify(message)}`);
        const action = {
            type: "add",
            messages: [
                chatMessage
            ]
        };
        chatLogDispatch(action);
    }, [
        chatLogDispatch
    ]);
    const lastItemRef = (0, $7fPBF.useRef)(null);
    (0, $7fPBF.useEffect)(()=>{
        var _lastItemRef_current;
        lastItemRef === null || lastItemRef === void 0 ? void 0 : (_lastItemRef_current = lastItemRef.current) === null || _lastItemRef_current === void 0 ? void 0 : _lastItemRef_current.scrollIntoView({
            behavior: 'smooth'
        });
    });
    (0, $7fPBF.useEffect)(()=>{
        const client = {
            clientId: chatBoxClientId,
            callback: onMessage,
            channels: [
                {
                    channel: (0, $b93fbb979342838e$export$ff0f8bd07799254c).chat,
                    topic: chatRoomId
                }
            ]
        };
        connection.send({
            type: 'SOCKET_SUBSCRIBE',
            value: client
        });
        return ()=>{
            connection.send({
                type: 'SOCKET_UNSUBSCRIBE',
                value: chatBoxClientId
            });
        };
    }, [
        context,
        onMessage
    ]);
    (0, $7fPBF.useEffect)(()=>{
        (0, $01b2e30d67ce3ce6$export$4332053a30844e0e).getChatRoomMessages(auth, chatRoomId).then((chatMessages)=>{
            const action = {
                type: "replace",
                messages: chatMessages
            };
            chatLogDispatch(action);
        });
    }, [
        context,
        onMessage
    ]);
    const textEntryField = (0, $7fPBF.useRef)(null);
    const handleSubmit = (e)=>{
        var _textEntryField_current;
        e.preventDefault();
        const text = (textEntryField === null || textEntryField === void 0 ? void 0 : (_textEntryField_current = textEntryField.current) === null || _textEntryField_current === void 0 ? void 0 : _textEntryField_current.value) || '';
        const chatMessage = (0, $01b2e30d67ce3ce6$export$4332053a30844e0e).buildOutboundChatMessage(text, chatRoomId, user.userId, user.handle, auth);
        (0, $aba38a333ca575f4$export$efa9a398d6368992).debug(`sending message ${text} from chatbox`);
        connection.send({
            type: 'SEND',
            value: chatMessage
        });
        textEntryField.current && (textEntryField.current.value = '');
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "bg-classicgray-dark m-3 p-2 pb-1 md:p-6 w-full md:w-6/12 max-w-md rounded-md flex-col content-between",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                children: "chat"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: `h-90v md:h-60v text-left overflow-y-auto md:overflow-y-scroll scrollbar justify-start items-center flex-col`,
                children: [
                    chatLogState.messages.map($f7f4e2622939e64e$var$getChatline),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        ref: lastItemRef
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("form", {
                className: "p-2 pb-0",
                onSubmit: handleSubmit,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                    className: "mt-3 w-full",
                    type: "text",
                    placeholder: "what's on your mind, friend?",
                    id: "customTextField",
                    ref: textEntryField
                })
            })
        ]
    });
};
function $f7f4e2622939e64e$var$getChatline(message, index) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "w-full",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                className: "bg-white text-xs font-bold",
                children: message.displayName
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("span", {
                className: "text-xs font-light",
                children: [
                    ' ',
                    message.timeReceived.toLocaleTimeString(undefined, {
                        hour: '2-digit',
                        minute: '2-digit'
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: message.text
            })
        ]
    }, 'chatline-' + index);
}
var $f7f4e2622939e64e$export$2e2bcd8739ae039 = $f7f4e2622939e64e$var$ChatBox;






var $7fPBF = parcelRequire("7fPBF");

var $08d136cf68240767$export$23c7328964450bd2;
(function(GameStatus) {
    GameStatus["Ready"] = "READY";
    GameStatus["InProgress"] = "IN PROGRESS";
    GameStatus["Complete"] = "COMPLETE";
    GameStatus["Abandoned"] = "ABANDONED";
})($08d136cf68240767$export$23c7328964450bd2 || ($08d136cf68240767$export$23c7328964450bd2 = {}));



function $18c9db29067a6763$export$575af816820586e9(options) {
    return {
        userId: options === null || options === void 0 ? void 0 : options.userId,
        handle: options === null || options === void 0 ? void 0 : options.handle,
        pronouns: (options === null || options === void 0 ? void 0 : options.pronouns) || (0, $a9bcab544e716c31$export$53b73d8fd52108b8).They,
        didExit: (options === null || options === void 0 ? void 0 : options.didExit) || false,
        kickReason: (options === null || options === void 0 ? void 0 : options.kickReason) || null,
        computerPlayerId: (options === null || options === void 0 ? void 0 : options.computerPlayerId) || null
    };
}
function $18c9db29067a6763$export$619527419c138fe8(item) {
    const gamePlayer = item;
    return !!(gamePlayer.userId && gamePlayer.handle);
}
function $18c9db29067a6763$export$b292b45d4ef547a(player) {
    return !player.didExit;
}
function $18c9db29067a6763$export$32353e708aedd27a(currentPlayerId, players) {
    const currentPlayerIndex = players.findIndex((player)=>player.userId === currentPlayerId);
    if (currentPlayerIndex === -1) throw new Error('currentPlayerId not in players in getNextPlayer');
    let nextIndex = (currentPlayerIndex + 1) % players.length;
    while(nextIndex !== currentPlayerIndex){
        if ($18c9db29067a6763$export$b292b45d4ef547a(players[nextIndex])) return players[nextIndex].userId;
        nextIndex = (nextIndex + 1) % players.length;
    }
    throw new Error('could not find active player for next turn');
}





const $ddd3e9f1fac9bf4b$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $ddd3e9f1fac9bf4b$export$2e2bcd8739ae039 = {
    randomUUID: $ddd3e9f1fac9bf4b$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $04aaa3a4a5e0e39d$var$getRandomValues;
const $04aaa3a4a5e0e39d$var$rnds8 = new Uint8Array(16);
function $04aaa3a4a5e0e39d$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$04aaa3a4a5e0e39d$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $04aaa3a4a5e0e39d$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$04aaa3a4a5e0e39d$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $04aaa3a4a5e0e39d$var$getRandomValues($04aaa3a4a5e0e39d$var$rnds8);
}


var $e18e2bf11b1d83f9$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $ff3c3e4ee5a7ce16$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $e18e2bf11b1d83f9$export$2e2bcd8739ae039).test(uuid);
}
var $ff3c3e4ee5a7ce16$export$2e2bcd8739ae039 = $ff3c3e4ee5a7ce16$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $e390be88bb0b6c61$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$e390be88bb0b6c61$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $e390be88bb0b6c61$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $e390be88bb0b6c61$var$byteToHex[arr[offset + 0]] + $e390be88bb0b6c61$var$byteToHex[arr[offset + 1]] + $e390be88bb0b6c61$var$byteToHex[arr[offset + 2]] + $e390be88bb0b6c61$var$byteToHex[arr[offset + 3]] + '-' + $e390be88bb0b6c61$var$byteToHex[arr[offset + 4]] + $e390be88bb0b6c61$var$byteToHex[arr[offset + 5]] + '-' + $e390be88bb0b6c61$var$byteToHex[arr[offset + 6]] + $e390be88bb0b6c61$var$byteToHex[arr[offset + 7]] + '-' + $e390be88bb0b6c61$var$byteToHex[arr[offset + 8]] + $e390be88bb0b6c61$var$byteToHex[arr[offset + 9]] + '-' + $e390be88bb0b6c61$var$byteToHex[arr[offset + 10]] + $e390be88bb0b6c61$var$byteToHex[arr[offset + 11]] + $e390be88bb0b6c61$var$byteToHex[arr[offset + 12]] + $e390be88bb0b6c61$var$byteToHex[arr[offset + 13]] + $e390be88bb0b6c61$var$byteToHex[arr[offset + 14]] + $e390be88bb0b6c61$var$byteToHex[arr[offset + 15]];
}
function $e390be88bb0b6c61$var$stringify(arr, offset = 0) {
    const uuid = $e390be88bb0b6c61$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $ff3c3e4ee5a7ce16$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $e390be88bb0b6c61$export$2e2bcd8739ae039 = $e390be88bb0b6c61$var$stringify;


function $67067ff092058c03$var$v4(options, buf, offset) {
    if ((0, $ddd3e9f1fac9bf4b$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $ddd3e9f1fac9bf4b$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $04aaa3a4a5e0e39d$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $e390be88bb0b6c61$export$8fb373d660548968)(rnds);
}
var $67067ff092058c03$export$2e2bcd8739ae039 = $67067ff092058c03$var$v4;




const $86486bb7b4b55757$export$e1f75a2fa907d754 = {
    PLAYER_KICKED: 'PLAYER_KICKED'
};
function $86486bb7b4b55757$export$d19e8b8895ec9a55(options, gamePlayerOptions) {
    if (!options.gameRuleSetName) throw new Error('No game ruleset suggested');
    if (!options.cmdType) throw new Error('No game command suggested');
    if (!gamePlayerOptions) throw new Error('No game command player provided');
    return {
        cmdId: (options === null || options === void 0 ? void 0 : options.cmdId) || (0, $67067ff092058c03$export$2e2bcd8739ae039)(),
        gameId: (options === null || options === void 0 ? void 0 : options.gameId) || '',
        gameRuleSetName: options.gameRuleSetName,
        cmdType: options === null || options === void 0 ? void 0 : options.cmdType,
        player: (0, $18c9db29067a6763$export$575af816820586e9)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, gamePlayerOptions)),
        cmdData: (options === null || options === void 0 ? void 0 : options.cmdData) || {}
    };
}
function $86486bb7b4b55757$export$171a248565a0e9b0(cmdTypeString, cmdEnum) {
    return !!(cmdTypeString && Object.values(cmdEnum).includes(cmdTypeString));
}
var $86486bb7b4b55757$export$121ef92b42134ced;
(function(BaseGameCmdTypes) {
    BaseGameCmdTypes["Create"] = "CREATE";
    BaseGameCmdTypes["Start"] = "START";
    BaseGameCmdTypes["Join"] = "JOIN";
    BaseGameCmdTypes["GetPlayerState"] = "GET_PLAYER_STATE";
    BaseGameCmdTypes["Exit"] = "EXIT";
    BaseGameCmdTypes["Error"] = "ERROR";
    BaseGameCmdTypes["Kick"] = "KICK";
})($86486bb7b4b55757$export$121ef92b42134ced || ($86486bb7b4b55757$export$121ef92b42134ced = {}));
const $86486bb7b4b55757$var$createGame = (_prevGame, cmd)=>{
    throw new Error('not implemented');
};
const $86486bb7b4b55757$var$joinGame = (prevGame, cmd)=>{
    const cmdData = cmd.cmdData;
    const buildComputerPlayer = (cmd)=>{
        const data = cmd.cmdData || {};
        if (!data.handle) throw new Error('must provide handle for computer player in cmdData');
        if (!data.computerPlayerId) throw new Error('must provide computerPlayerId for computer player in cmdData');
        return (0, $18c9db29067a6763$export$575af816820586e9)({
            userId: (0, $67067ff092058c03$export$2e2bcd8739ae039)(),
            handle: data.handle,
            pronouns: (0, $a9bcab544e716c31$export$53b73d8fd52108b8).They,
            computerPlayerId: data.computerPlayerId,
            didExit: false
        });
    };
    const buildHumanPlayer = (cmd)=>(0, $18c9db29067a6763$export$575af816820586e9)({
            userId: cmd.player.userId,
            handle: cmd.player.handle,
            pronouns: cmd.player.pronouns
        });
    const player = (cmdData === null || cmdData === void 0 ? void 0 : cmdData.computerPlayerId) ? buildComputerPlayer(cmd) : buildHumanPlayer(cmd);
    if (prevGame.status && prevGame.status !== (0, $08d136cf68240767$export$23c7328964450bd2).Ready) throw new Error('Game can only be joined in Ready status');
    const players = [
        ...prevGame.players
    ];
    if (!players.find((previousPlayer)=>previousPlayer.userId === player.userId)) players.push(player);
    const game = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, prevGame), {
        players: players
    });
    return {
        game: game,
        events: []
    };
};
const $86486bb7b4b55757$var$getPlayerState = (prevGame, cmd)=>{
    return {
        game: prevGame,
        events: []
    };
};
const $86486bb7b4b55757$var$startGame = (prevGame, cmd)=>{
    const hostUserId = cmd.player.userId;
    if (prevGame.hostUserId && prevGame.hostUserId !== hostUserId) throw new Error(`Game can not be started by nonhost, host was ${prevGame.hostUserId} vs user ${hostUserId}`);
    const game = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, prevGame), {
        status: (0, $08d136cf68240767$export$23c7328964450bd2).InProgress
    });
    return {
        game: game,
        events: []
    };
};
const $86486bb7b4b55757$var$buildPlayersWithExitedPlayer = (prevGame, exitingPlayerId, kickReason)=>{
    const players = [
        ...prevGame.players
    ];
    const exitingPlayerIndex = players.findIndex((player)=>player.userId === exitingPlayerId);
    if (exitingPlayerIndex !== -1) {
        const exitedPlayer = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, players[exitingPlayerIndex]), {
            didExit: true,
            kickReason: kickReason || null
        });
        players.splice(exitingPlayerIndex, 1, exitedPlayer);
    }
    return players;
};
const $86486bb7b4b55757$var$exitGame = (prevGame, cmd)=>{
    const players = $86486bb7b4b55757$var$buildPlayersWithExitedPlayer(prevGame, cmd.player.userId, null);
    const stillPlaying = players.filter((player)=>!player.didExit);
    const game = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, prevGame), {
        players: players,
        status: stillPlaying.length === 0 ? (0, $08d136cf68240767$export$23c7328964450bd2).Abandoned : prevGame.status
    });
    return {
        game: game,
        events: []
    };
};
const $86486bb7b4b55757$var$kickPlayer = (prevGame, cmd)=>{
    var _cmd_player;
    if (!cmd.cmdData) throw new Error('Can not kick player with empty KickPlayerCmdData');
    if (!(cmd === null || cmd === void 0 ? void 0 : (_cmd_player = cmd.player) === null || _cmd_player === void 0 ? void 0 : _cmd_player.userId)) throw new Error('Can not kick player with missing command userId');
    const kickData = cmd.cmdData;
    if (cmd.player.userId !== prevGame.hostUserId) throw new Error('only host can kick');
    if (kickData.kickedPlayerId === prevGame.hostUserId) throw new Error('Can not kick host');
    const exitingUserId = kickData.kickedPlayerId;
    const players = $86486bb7b4b55757$var$buildPlayersWithExitedPlayer(prevGame, exitingUserId, kickData.kickReason);
    const game = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, prevGame), {
        players: players
    });
    const playerKicked = {
        eventId: (0, $67067ff092058c03$export$2e2bcd8739ae039)(),
        gameId: game.gameId,
        eventType: 'PLAYER_KICKED',
        eventData: {
            kickedPlayerId: exitingUserId
        }
    };
    return {
        game: game,
        events: [
            playerKicked
        ]
    };
};
const $86486bb7b4b55757$export$d49d2d752c6baf94 = {
    createGame: $86486bb7b4b55757$var$createGame,
    startGame: $86486bb7b4b55757$var$startGame,
    joinGame: $86486bb7b4b55757$var$joinGame,
    getPlayerState: $86486bb7b4b55757$var$getPlayerState,
    kickPlayer: $86486bb7b4b55757$var$kickPlayer,
    exitGame: $86486bb7b4b55757$var$exitGame
};


const $aae5ebb9cd41d808$export$ffff4fea9205621 = (game)=>({
        gameId: game.gameId,
        description: game.gameRuleSetName,
        hostName: game.hostHandle,
        hostUserId: game.hostUserId,
        createDate: game.createDate,
        status: game.status,
        playerCount: game.players.length,
        maxPlayers: game.maxPlayers,
        gameRuleSetName: game.gameRuleSetName
    });






function $a8d1dd573118ab03$export$1ac444d24d8cbc4a(suit1, suit2) {
    if (!suit1 || !suit2) return false;
    return suit1.suitName == suit2.suitName;
}
function $a8d1dd573118ab03$export$9f8ddb69ddf3acf9(card1, card2) {
    return $a8d1dd573118ab03$export$1ac444d24d8cbc4a(card1.suit, card2.suit) && card1.cardValue === card2.cardValue;
}
const $a8d1dd573118ab03$var$MAX_CARD_REF = 500;
const $a8d1dd573118ab03$export$25161dc7863e1c87 = (value)=>{
    return typeof value === 'number' && value >= 0 && value <= $a8d1dd573118ab03$var$MAX_CARD_REF;
};
function $a8d1dd573118ab03$export$32d4528f0e558529(cards) {
    const card = cards.shift();
    if (!$a8d1dd573118ab03$export$25161dc7863e1c87(card)) throw new Error('tried to get card from empty deck');
    return card;
}
function $a8d1dd573118ab03$export$95de09fb6c4151bf(deck) {
    return deck.suits.find((suit)=>suit.suitName === deck.trumpSuitName);
}


const $971299d4b2107ff9$export$b1accc4ae1c798c7 = {
    deckName: 'Smith Waite Tarot Deck',
    entity: 'Deck',
    suits: [
        {
            suitName: 'trumps',
            suitEmoji: "\u2728"
        },
        {
            suitName: 'pentacles',
            suitEmoji: "\u26E5"
        },
        {
            suitName: 'cups',
            suitEmoji: "\uD83C\uDF77"
        },
        {
            suitName: 'swords',
            suitEmoji: "\uD83D\uDDE1\uFE0F"
        },
        {
            suitName: 'wands',
            suitEmoji: "\uD83E\uDE84"
        }
    ],
    trumpSuitName: 'trumps',
    cards: [
        {
            smallUrl: '/sw/sm/i4Vii8I0LRvs.jpg',
            largeUrl: '',
            cardValue: 0,
            cardValueName: 'The Fool',
            suit: {
                suitName: 'trumps',
                suitEmoji: "\u2728"
            },
            cardEmoji: "\uD83C\uDCCF"
        },
        {
            smallUrl: '/sw/sm/0xJV8YjoOdjn.jpg',
            largeUrl: '',
            cardValue: 1,
            cardValueName: 'The Magician',
            suit: {
                suitName: 'trumps',
                suitEmoji: "\u2728"
            },
            cardEmoji: "\uD83E\uDDD9"
        },
        {
            smallUrl: '/sw/sm/tPq3F82WgXnT.jpg',
            largeUrl: '',
            cardValue: 2,
            cardValueName: 'The High Priestess',
            suit: {
                suitName: 'trumps',
                suitEmoji: "\u2728"
            },
            cardEmoji: "\uD83D\uDC69\u200D\u2696\uFE0F"
        },
        {
            smallUrl: '/sw/sm/v4Muu7hKU1au.jpg',
            largeUrl: '',
            cardValue: 3,
            cardValueName: 'The Empress',
            suit: {
                suitName: 'trumps',
                suitEmoji: "\u2728"
            },
            cardEmoji: "\uD83D\uDC70\u200D"
        },
        {
            smallUrl: '/sw/sm/20Uni5EEnSxY.jpg',
            largeUrl: '',
            cardValue: 4,
            cardValueName: 'The Emperor',
            suit: {
                suitName: 'trumps',
                suitEmoji: "\u2728"
            },
            cardEmoji: "\uD83D\uDC51"
        },
        {
            smallUrl: '/sw/sm/V4Ts9SJNQCzQ.jpg',
            largeUrl: '',
            cardValue: 5,
            cardValueName: 'The Hierophant',
            suit: {
                suitName: 'trumps',
                suitEmoji: "\u2728"
            },
            cardEmoji: "\uD83D\uDC68\u200D\uD83C\uDFEB"
        },
        {
            smallUrl: '/sw/sm/w6q5nBY9X235.jpg',
            largeUrl: '',
            cardValue: 6,
            cardValueName: 'The Lovers',
            suit: {
                suitName: 'trumps',
                suitEmoji: "\u2728"
            },
            cardEmoji: "\uD83D\uDC6F\u200D\u2640\uFE0F"
        },
        {
            smallUrl: '/sw/sm/3Os5XobEyqv7.jpg',
            largeUrl: '',
            cardValue: 7,
            cardValueName: 'The Chariot',
            suit: {
                suitName: 'trumps',
                suitEmoji: "\u2728"
            },
            cardEmoji: "\uD83C\uDFC7"
        },
        {
            smallUrl: '/sw/sm/5DZ3dqji8yRI.jpg',
            largeUrl: '',
            cardValue: 8,
            cardValueName: 'Strength',
            suit: {
                suitName: 'trumps',
                suitEmoji: "\u2728"
            },
            cardEmoji: "\uD83E\uDD81"
        },
        {
            smallUrl: '/sw/sm/Ua96qzOVKbly.jpg',
            largeUrl: '',
            cardValue: 9,
            cardValueName: 'The Hermit',
            suit: {
                suitName: 'trumps',
                suitEmoji: "\u2728"
            },
            cardEmoji: "\uD83E\uDDD3"
        },
        {
            smallUrl: '/sw/sm/Rptj4l7xrk1Q.jpg',
            largeUrl: '',
            cardValue: 10,
            cardValueName: 'The Wheel of Fortune',
            suit: {
                suitName: 'trumps',
                suitEmoji: "\u2728"
            },
            cardEmoji: "\uD83C\uDFB0"
        },
        {
            smallUrl: '/sw/sm/5Bw58NbK2vFz.jpg',
            largeUrl: '',
            cardValue: 11,
            cardValueName: 'Justice',
            suit: {
                suitName: 'trumps',
                suitEmoji: "\u2728"
            },
            cardEmoji: "\u2696\uFE0F"
        },
        {
            smallUrl: '/sw/sm/yC5y7fhdEByW.jpg',
            largeUrl: '',
            cardValue: 12,
            cardValueName: 'The Hanged Man',
            suit: {
                suitName: 'trumps',
                suitEmoji: "\u2728"
            },
            cardEmoji: "\uD83E\uDD38"
        },
        {
            smallUrl: '/sw/sm/97HWjScnPNKj.jpg',
            largeUrl: '',
            cardValue: 13,
            cardValueName: 'Death',
            suit: {
                suitName: 'trumps',
                suitEmoji: "\u2728"
            },
            cardEmoji: "\uD83D\uDC80"
        },
        {
            smallUrl: '/sw/sm/d81Gzc1zRu2z.jpg',
            largeUrl: '',
            cardValue: 14,
            cardValueName: 'Temperance',
            suit: {
                suitName: 'trumps',
                suitEmoji: "\u2728"
            },
            cardEmoji: "\uD83C\uDF0A"
        },
        {
            smallUrl: '/sw/sm/7G5VgqEzQ9aM.jpg',
            largeUrl: '',
            cardValue: 15,
            cardValueName: 'The Devil',
            suit: {
                suitName: 'trumps',
                suitEmoji: "\u2728"
            },
            cardEmoji: "\uD83D\uDE08"
        },
        {
            smallUrl: '/sw/sm/s00VCEIsyGnE.jpg',
            largeUrl: '',
            cardValue: 16,
            cardValueName: 'The Tower',
            suit: {
                suitName: 'trumps',
                suitEmoji: "\u2728"
            },
            cardEmoji: "\uD83C\uDFE2"
        },
        {
            smallUrl: '/sw/sm/l59QrCsXdCGa.jpg',
            largeUrl: '',
            cardValue: 17,
            cardValueName: 'The Star',
            suit: {
                suitName: 'trumps',
                suitEmoji: "\u2728"
            },
            cardEmoji: "\uD83C\uDF1F"
        },
        {
            smallUrl: '/sw/sm/7x7A8sREKkab.jpg',
            largeUrl: '',
            cardValue: 18,
            cardValueName: 'The Moon',
            suit: {
                suitName: 'trumps',
                suitEmoji: "\u2728"
            },
            cardEmoji: "\uD83C\uDF12"
        },
        {
            smallUrl: '/sw/sm/Wo435nRGOs6v.jpg',
            largeUrl: '',
            cardValue: 19,
            cardValueName: 'The Sun',
            suit: {
                suitName: 'trumps',
                suitEmoji: "\u2728"
            },
            cardEmoji: "\u2600\uFE0F"
        },
        {
            smallUrl: '/sw/sm/SgU3D87kOK04.jpg',
            largeUrl: '',
            cardValue: 20,
            cardValueName: 'Judgement',
            suit: {
                suitName: 'trumps',
                suitEmoji: "\u2728"
            },
            cardEmoji: "\uD83D\uDCEF"
        },
        {
            smallUrl: '/sw/sm/qG06f7Z7Sjin.jpg',
            largeUrl: '',
            cardValue: 21,
            cardValueName: 'The World',
            suit: {
                suitName: 'trumps',
                suitEmoji: "\u2728"
            },
            cardEmoji: "\uD83C\uDF0D"
        },
        {
            smallUrl: '/sw/sm/Cq20XQ1LujmV.jpg',
            largeUrl: '',
            cardValue: 2,
            cardValueName: 'two',
            suit: {
                suitName: 'swords',
                suitEmoji: "\uD83D\uDDE1\uFE0F"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/0Pa46indePXW.jpg',
            largeUrl: '',
            cardValue: 3,
            cardValueName: 'three',
            suit: {
                suitName: 'swords',
                suitEmoji: "\uD83D\uDDE1\uFE0F"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/Ob82Y6VTazEe.jpg',
            largeUrl: '',
            cardValue: 4,
            cardValueName: 'four',
            suit: {
                suitName: 'swords',
                suitEmoji: "\uD83D\uDDE1\uFE0F"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/jO9Vs9LmZD2x.jpg',
            largeUrl: '',
            cardValue: 5,
            cardValueName: 'five',
            suit: {
                suitName: 'swords',
                suitEmoji: "\uD83D\uDDE1\uFE0F"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/F48jWJw6EoBi.jpg',
            largeUrl: '',
            cardValue: 6,
            cardValueName: 'six',
            suit: {
                suitName: 'swords',
                suitEmoji: "\uD83D\uDDE1\uFE0F"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/Ups93ZCKARJD.jpg',
            largeUrl: '',
            cardValue: 7,
            cardValueName: 'seven',
            suit: {
                suitName: 'swords',
                suitEmoji: "\uD83D\uDDE1\uFE0F"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/Vh78iNpCiJO7.jpg',
            largeUrl: '',
            cardValue: 8,
            cardValueName: 'eight',
            suit: {
                suitName: 'swords',
                suitEmoji: "\uD83D\uDDE1\uFE0F"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/4M5tY3uEsTeU.jpg',
            largeUrl: '',
            cardValue: 9,
            cardValueName: 'nine',
            suit: {
                suitName: 'swords',
                suitEmoji: "\uD83D\uDDE1\uFE0F"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/l6FY6ISPUcTG.jpg',
            largeUrl: '',
            cardValue: 10,
            cardValueName: 'ten',
            suit: {
                suitName: 'swords',
                suitEmoji: "\uD83D\uDDE1\uFE0F"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/5idMzSOy89rz.jpg',
            largeUrl: '',
            cardValue: 11,
            cardValueName: 'page',
            suit: {
                suitName: 'swords',
                suitEmoji: "\uD83D\uDDE1\uFE0F"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/lA7Gl7V3GNZr.jpg',
            largeUrl: '',
            cardValue: 12,
            cardValueName: 'knight',
            suit: {
                suitName: 'swords',
                suitEmoji: "\uD83D\uDDE1\uFE0F"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/5iMiL0ys3Z2D.jpg',
            largeUrl: '',
            cardValue: 13,
            cardValueName: 'queen',
            suit: {
                suitName: 'swords',
                suitEmoji: "\uD83D\uDDE1\uFE0F"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/1tZk0UbCKTnr.jpg',
            largeUrl: '',
            cardValue: 14,
            cardValueName: 'king',
            suit: {
                suitName: 'swords',
                suitEmoji: "\uD83D\uDDE1\uFE0F"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/Z7qn786YdbLv.jpg',
            largeUrl: '',
            cardValue: 15,
            cardValueName: 'ace',
            suit: {
                suitName: 'swords',
                suitEmoji: "\uD83D\uDDE1\uFE0F"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/2Ad3EeuNpfk8.jpg',
            largeUrl: '',
            cardValue: 2,
            cardValueName: 'two',
            suit: {
                suitName: 'pentacles',
                suitEmoji: "\u26E5"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/wRqDD21fULaH.jpg',
            largeUrl: '',
            cardValue: 3,
            cardValueName: 'three',
            suit: {
                suitName: 'pentacles',
                suitEmoji: "\u26E5"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/Vz869fBVLKKw.jpg',
            largeUrl: '',
            cardValue: 4,
            cardValueName: 'four',
            suit: {
                suitName: 'pentacles',
                suitEmoji: "\u26E5"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/b5X4EHtUco1x.jpg',
            largeUrl: '',
            cardValue: 5,
            cardValueName: 'five',
            suit: {
                suitName: 'pentacles',
                suitEmoji: "\u26E5"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/8vHG6GvOOCT8.jpg',
            largeUrl: '',
            cardValue: 6,
            cardValueName: 'six',
            suit: {
                suitName: 'pentacles',
                suitEmoji: "\u26E5"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/S9s10WtrwjPF.jpg',
            largeUrl: '',
            cardValue: 7,
            cardValueName: 'seven',
            suit: {
                suitName: 'pentacles',
                suitEmoji: "\u26E5"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/3r1FROk85gqF.jpg',
            largeUrl: '',
            cardValue: 8,
            cardValueName: 'eight',
            suit: {
                suitName: 'pentacles',
                suitEmoji: "\u26E5"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/i0HR7w68vUfv.jpg',
            largeUrl: '',
            cardValue: 9,
            cardValueName: 'nine',
            suit: {
                suitName: 'pentacles',
                suitEmoji: "\u26E5"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/Cy98FT9iwliD.jpg',
            largeUrl: '',
            cardValue: 10,
            cardValueName: 'ten',
            suit: {
                suitName: 'pentacles',
                suitEmoji: "\u26E5"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/9vZt48lHXYcc.jpg',
            largeUrl: '',
            cardValue: 11,
            cardValueName: 'page',
            suit: {
                suitName: 'pentacles',
                suitEmoji: "\u26E5"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/4rH0GVSjhRWX.jpg',
            largeUrl: '',
            cardValue: 12,
            cardValueName: 'knight',
            suit: {
                suitName: 'pentacles',
                suitEmoji: "\u26E5"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/2MEm2NZITvD6.jpg',
            largeUrl: '',
            cardValue: 13,
            cardValueName: 'queen',
            suit: {
                suitName: 'pentacles',
                suitEmoji: "\u26E5"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/4Je7IkyePJ04.jpg',
            largeUrl: '',
            cardValue: 14,
            cardValueName: 'king',
            suit: {
                suitName: 'pentacles',
                suitEmoji: "\u26E5"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/l2mHC7j44Ng7.jpg',
            largeUrl: '',
            cardValue: 15,
            cardValueName: 'ace',
            suit: {
                suitName: 'pentacles',
                suitEmoji: "\u26E5"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/Hy244dlKVQ1r.jpg',
            largeUrl: '',
            cardValue: 2,
            cardValueName: 'two',
            suit: {
                suitName: 'wands',
                suitEmoji: "\uD83E\uDE84"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/4gk6FMESnCwI.jpg',
            largeUrl: '',
            cardValue: 3,
            cardValueName: 'three',
            suit: {
                suitName: 'wands',
                suitEmoji: "\uD83E\uDE84"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/o1Wa0hutmduk.jpg',
            largeUrl: '',
            cardValue: 4,
            cardValueName: 'four',
            suit: {
                suitName: 'wands',
                suitEmoji: "\uD83E\uDE84"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/8C37MYxiSQ4R.jpg',
            largeUrl: '',
            cardValue: 5,
            cardValueName: 'five',
            suit: {
                suitName: 'wands',
                suitEmoji: "\uD83E\uDE84"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/rf7wXs28O2tB.jpg',
            largeUrl: '',
            cardValue: 6,
            cardValueName: 'six',
            suit: {
                suitName: 'wands',
                suitEmoji: "\uD83E\uDE84"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/Mu641ei6VaZJ.jpg',
            largeUrl: '',
            cardValue: 7,
            cardValueName: 'seven',
            suit: {
                suitName: 'wands',
                suitEmoji: "\uD83E\uDE84"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/z1HY22q3QViO.jpg',
            largeUrl: '',
            cardValue: 8,
            cardValueName: 'eight',
            suit: {
                suitName: 'wands',
                suitEmoji: "\uD83E\uDE84"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/Fd76MUbNGcMS.jpg',
            largeUrl: '',
            cardValue: 9,
            cardValueName: 'nine',
            suit: {
                suitName: 'wands',
                suitEmoji: "\uD83E\uDE84"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/yA9046MZ3WIh.jpg',
            largeUrl: '',
            cardValue: 10,
            cardValueName: 'ten',
            suit: {
                suitName: 'wands',
                suitEmoji: "\uD83E\uDE84"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/S0cAj0RRH1d5.jpg',
            largeUrl: '',
            cardValue: 11,
            cardValueName: 'page',
            suit: {
                suitName: 'wands',
                suitEmoji: "\uD83E\uDE84"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/7yHQ03zB0ClN.jpg',
            largeUrl: '',
            cardValue: 12,
            cardValueName: 'knight',
            suit: {
                suitName: 'wands',
                suitEmoji: "\uD83E\uDE84"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/sMX71FTI3KR7.jpg',
            largeUrl: '',
            cardValue: 13,
            cardValueName: 'queen',
            suit: {
                suitName: 'wands',
                suitEmoji: "\uD83E\uDE84"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/uNT2t2618YPU.jpg',
            largeUrl: '',
            cardValue: 14,
            cardValueName: 'king',
            suit: {
                suitName: 'wands',
                suitEmoji: "\uD83E\uDE84"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/Hs9lBj1GhLpR.jpg',
            largeUrl: '',
            cardValue: 15,
            cardValueName: 'ace',
            suit: {
                suitName: 'wands',
                suitEmoji: "\uD83E\uDE84"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/7Zlkx8w6XQB3.jpg',
            largeUrl: '',
            cardValue: 2,
            cardValueName: 'two',
            suit: {
                suitName: 'cups',
                suitEmoji: "\uD83C\uDF77"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/61bWTi1YhCfk.jpg',
            largeUrl: '',
            cardValue: 3,
            cardValueName: 'three',
            suit: {
                suitName: 'cups',
                suitEmoji: "\uD83C\uDF77"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/K76iuBhLBSjt.jpg',
            largeUrl: '',
            cardValue: 4,
            cardValueName: 'four',
            suit: {
                suitName: 'cups',
                suitEmoji: "\uD83C\uDF77"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/Db7TV56MHYVz.jpg',
            largeUrl: '',
            cardValue: 5,
            cardValueName: 'five',
            suit: {
                suitName: 'cups',
                suitEmoji: "\uD83C\uDF77"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/6Y6Hg7BSafKC.jpg',
            largeUrl: '',
            cardValue: 6,
            cardValueName: 'six',
            suit: {
                suitName: 'cups',
                suitEmoji: "\uD83C\uDF77"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/G5E5o5wyGQll.jpg',
            largeUrl: '',
            cardValue: 7,
            cardValueName: 'seven',
            suit: {
                suitName: 'cups',
                suitEmoji: "\uD83C\uDF77"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/2iO6LECaUqOu.jpg',
            largeUrl: '',
            cardValue: 8,
            cardValueName: 'eight',
            suit: {
                suitName: 'cups',
                suitEmoji: "\uD83C\uDF77"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/At9WZvqn9c4K.jpg',
            largeUrl: '',
            cardValue: 9,
            cardValueName: 'nine',
            suit: {
                suitName: 'cups',
                suitEmoji: "\uD83C\uDF77"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/9XyOxk32mv5O.jpg',
            largeUrl: '',
            cardValue: 10,
            cardValueName: 'ten',
            suit: {
                suitName: 'cups',
                suitEmoji: "\uD83C\uDF77"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/2l2PIf6YU6aV.jpg',
            largeUrl: '',
            cardValue: 11,
            cardValueName: 'page',
            suit: {
                suitName: 'cups',
                suitEmoji: "\uD83C\uDF77"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/BiJ07LVV6cFC.jpg',
            largeUrl: '',
            cardValue: 12,
            cardValueName: 'knight',
            suit: {
                suitName: 'cups',
                suitEmoji: "\uD83C\uDF77"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/37bUWqZo1Lyi.jpg',
            largeUrl: '',
            cardValue: 13,
            cardValueName: 'queen',
            suit: {
                suitName: 'cups',
                suitEmoji: "\uD83C\uDF77"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/7a8Y4zIK6v5v.jpg',
            largeUrl: '',
            cardValue: 14,
            cardValueName: 'king',
            suit: {
                suitName: 'cups',
                suitEmoji: "\uD83C\uDF77"
            },
            cardEmoji: undefined
        },
        {
            smallUrl: '/sw/sm/V72yPJZVP6dN.jpg',
            largeUrl: '',
            cardValue: 15,
            cardValueName: 'ace',
            suit: {
                suitName: 'cups',
                suitEmoji: "\uD83C\uDF77"
            },
            cardEmoji: undefined
        }
    ]
};




const $8dea006c8e654182$var$baseSuits = [
    {
        suitName: 'spades',
        suitEmoji: "\u2660\uFE0F"
    },
    {
        suitName: 'diamonds',
        suitEmoji: "\u2666\uFE0F"
    },
    {
        suitName: 'clubs',
        suitEmoji: "\u2663\uFE0F"
    },
    {
        suitName: 'hearts',
        suitEmoji: "\u2665\uFE0F"
    }
];
const $8dea006c8e654182$var$baseCards = [
    {
        cardValue: 2,
        cardValueName: 'two'
    },
    {
        cardValue: 3,
        cardValueName: 'three'
    },
    {
        cardValue: 4,
        cardValueName: 'four'
    },
    {
        cardValue: 5,
        cardValueName: 'five'
    },
    {
        cardValue: 6,
        cardValueName: 'six'
    },
    {
        cardValue: 7,
        cardValueName: 'seven'
    },
    {
        cardValue: 8,
        cardValueName: 'eight'
    },
    {
        cardValue: 9,
        cardValueName: 'nine'
    },
    {
        cardValue: 10,
        cardValueName: 'ten'
    },
    {
        cardValue: 11,
        cardValueName: 'jack'
    },
    {
        cardValue: 12,
        cardValueName: 'queen'
    },
    {
        cardValue: 13,
        cardValueName: 'king'
    },
    {
        cardValue: 14,
        cardValueName: 'ace'
    }
];
const $8dea006c8e654182$var$cards = $8dea006c8e654182$var$baseSuits.reduce((cards, suit)=>{
    const suitCards = $8dea006c8e654182$var$baseCards.map((card)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, card), {
            suit: suit,
            smallUrl: `/std/${suit.suitName}_${card.cardValue <= 10 ? card.cardValue.toString() : card.cardValueName}.svg`,
            largeUrl: ''
        }));
    return cards.concat(suitCards);
}, []);
const $8dea006c8e654182$export$5e183895170cab29 = {
    deckName: 'Standard Deck',
    entity: 'Deck',
    suits: $8dea006c8e654182$var$baseSuits,
    trumpSuitName: undefined,
    cards: $8dea006c8e654182$var$cards
};


var $dddf98aa62f65ae7$export$3b8b72609a1ddc98;
(function(DeckCode) {
    DeckCode["TarotSW"] = "swtd";
    DeckCode["AcesHigh"] = "stdah";
})($dddf98aa62f65ae7$export$3b8b72609a1ddc98 || ($dddf98aa62f65ae7$export$3b8b72609a1ddc98 = {}));
const $dddf98aa62f65ae7$export$c95ca51a280479c4 = {
    [$dddf98aa62f65ae7$export$3b8b72609a1ddc98.TarotSW]: (0, $971299d4b2107ff9$export$b1accc4ae1c798c7),
    [$dddf98aa62f65ae7$export$3b8b72609a1ddc98.AcesHigh]: (0, $8dea006c8e654182$export$5e183895170cab29)
};
const $dddf98aa62f65ae7$export$a1ed25fc414718b7 = (param)=>{
    return (param === null || param === void 0 ? void 0 : param.deckCode) || param;
};
const $dddf98aa62f65ae7$export$28b7351bf4b200b9 = (param)=>{
    const deckCode = $dddf98aa62f65ae7$export$a1ed25fc414718b7(param);
    return $dddf98aa62f65ae7$export$c95ca51a280479c4[deckCode];
};
const $dddf98aa62f65ae7$export$574ca6466190d4b4 = (param, cardRef)=>{
    const deckCode = $dddf98aa62f65ae7$export$a1ed25fc414718b7(param);
    const deck = $dddf98aa62f65ae7$export$28b7351bf4b200b9(deckCode);
    if (!deck || cardRef < 0 || cardRef >= deck.cards.length) throw new Error(`cardRef ${cardRef} not valid for deck ${deckCode}`);
    return deck.cards[cardRef];
};
const $dddf98aa62f65ae7$export$82cbab171d4b5138 = (deckParam, cardValue, suitName)=>{
    const deck = deckParam.cards ? deckParam : $dddf98aa62f65ae7$export$28b7351bf4b200b9(deckParam);
    const cardRef = deck.cards.findIndex((card)=>card.cardValue === cardValue && card.suit.suitName === suitName);
    if (cardRef === -1) throw new Error(`getCardRef - could not find card suit ${suitName} value ${cardValue}`);
    return cardRef;
};
function $dddf98aa62f65ae7$export$448332262467e042(deckCode) {
    const deck = $dddf98aa62f65ae7$export$28b7351bf4b200b9(deckCode);
    const indices = deck.cards.map((_card, idx)=>idx);
    var randomNumbers = indices.map(Math.random);
    return indices.sort((a, b)=>{
        return randomNumbers[a] - randomNumbers[b];
    });
}




var $b498b75d9b5e135f$export$890274e3d5170b8b;
(function(GameRuleSets) {
    GameRuleSets["Base"] = "Base";
    GameRuleSets["WinThisGame"] = "Win This Game";
    GameRuleSets["OhHell"] = "Oh Hell";
})($b498b75d9b5e135f$export$890274e3d5170b8b || ($b498b75d9b5e135f$export$890274e3d5170b8b = {}));
var $b498b75d9b5e135f$export$3bc0a1d11e157185;
(function(CmdResultTypes) {
    CmdResultTypes["Success"] = "SUCCESS";
    CmdResultTypes["Failure"] = "FAILURE";
})($b498b75d9b5e135f$export$3bc0a1d11e157185 || ($b498b75d9b5e135f$export$3bc0a1d11e157185 = {}));
function $b498b75d9b5e135f$export$b0ac3e614a309be3(result) {
    return result.result === $b498b75d9b5e135f$export$3bc0a1d11e157185.Success;
}






function $c4491d29e9046e32$export$b74c481617709292(array) {
    if (!array || !Array.isArray(array)) throw new Error('cant pick element from empty or non array');
    return array[Math.floor(Math.random() * array.length)];
}











function $8d3c56edba7f9068$export$ea7aef3efcc571b6(state) {
    return state && state.deckCode && Array.isArray(state.players) && Array.isArray(state.completedRounds);
}
function $8d3c56edba7f9068$export$350bfa81fecdb6f3(state) {
    return !!(state === null || state === void 0 ? void 0 : state.currentRound);
}
var $8d3c56edba7f9068$export$c114e6986ab7a2c0;
(function(OhHellCmdType) {
    OhHellCmdType["Start"] = "START";
    OhHellCmdType["GetPlayerState"] = "GET_PLAYER_STATE";
    OhHellCmdType["DealCards"] = "DEAL";
    OhHellCmdType["PlaceBid"] = "PLACE_BID";
    OhHellCmdType["PlayCard"] = "PLAY_CARD";
    OhHellCmdType["Exit"] = "EXIT";
    OhHellCmdType["Kick"] = "KICK";
})($8d3c56edba7f9068$export$c114e6986ab7a2c0 || ($8d3c56edba7f9068$export$c114e6986ab7a2c0 = {}));
function $8d3c56edba7f9068$export$b0ac3e614a309be3(result) {
    return result.result === (0, $b498b75d9b5e135f$export$3bc0a1d11e157185).Success;
}
function $8d3c56edba7f9068$export$67a229608f85c16b(message) {
    return {
        result: (0, $b498b75d9b5e135f$export$3bc0a1d11e157185).Failure,
        message: message
    };
}
function $8d3c56edba7f9068$export$fd970e467a2a8344(state, events = []) {
    return {
        result: (0, $b498b75d9b5e135f$export$3bc0a1d11e157185).Success,
        state: state,
        events: events
    };
}
var $8d3c56edba7f9068$export$796ce39b90311506;
(function(OhHellEventName) {
    OhHellEventName["Start"] = "START";
    OhHellEventName["Dealt"] = "DEALT";
    OhHellEventName["BidPlaced"] = "BID_PLACED";
    OhHellEventName["BiddingComplete"] = "BIDDING_COMPLETE";
    OhHellEventName["CardPlayed"] = "CARD_PLAYED";
    OhHellEventName["TrickComplete"] = "TRICK_COMPLETE";
    OhHellEventName["RoundComplete"] = "ROUND_COMPLETE";
    OhHellEventName["EndOfGame"] = "END_OF_GAME";
})($8d3c56edba7f9068$export$796ce39b90311506 || ($8d3c56edba7f9068$export$796ce39b90311506 = {}));
var $8d3c56edba7f9068$export$1d858bc500864334;
(function(OhHellRulesMessage) {
    OhHellRulesMessage["NotDealPhase"] = "Game is not in deal phase";
    OhHellRulesMessage["NotBidPhase"] = "Game is not in Bid phase";
    OhHellRulesMessage["NotPlayPhase"] = "Game is not in play phase";
    OhHellRulesMessage["NotPlayersTurn"] = "Not player's turn";
    OhHellRulesMessage["BidIsNotValid"] = "Bid is not valid";
    OhHellRulesMessage["DealerGetsScrewed"] = "Dealer gets screwed";
    OhHellRulesMessage["CardNotInHand"] = "Played card not in hand";
    OhHellRulesMessage["TrumpsNotBroken"] = "Can not lead trump suit until trump suit broken or voided of others";
    OhHellRulesMessage["MustFollowSuit"] = "Played card does not match led suit, but suited card is in hand";
    OhHellRulesMessage["CantKickLastPlayer"] = "Can not kick last player";
})($8d3c56edba7f9068$export$1d858bc500864334 || ($8d3c56edba7f9068$export$1d858bc500864334 = {}));
function $8d3c56edba7f9068$export$3c76c02ac8524459(state) {
    return {
        eventName: $8d3c56edba7f9068$export$796ce39b90311506.Dealt,
        details: {
            dealerPlayerId: state.currentRound.dealerPlayerId
        }
    };
}
function $8d3c56edba7f9068$export$cc79536b982b9701(state) {
    const bids = state.currentRound.bids;
    return {
        eventName: $8d3c56edba7f9068$export$796ce39b90311506.BidPlaced,
        details: {
            bid: bids[bids.length - 1]
        }
    };
}
function $8d3c56edba7f9068$export$52e654f5691a9633(state) {
    return {
        eventName: $8d3c56edba7f9068$export$796ce39b90311506.BiddingComplete,
        details: {
            bids: state.currentRound.bids
        }
    };
}
function $8d3c56edba7f9068$export$cf23a2045594f247(state) {
    var _state_currentRound_currentTrick_cards, _state_currentRound_currentTrick, _state_currentRound;
    if (!((_state_currentRound = state.currentRound) === null || _state_currentRound === void 0 ? void 0 : (_state_currentRound_currentTrick = _state_currentRound.currentTrick) === null || _state_currentRound_currentTrick === void 0 ? void 0 : (_state_currentRound_currentTrick_cards = _state_currentRound_currentTrick.cards) === null || _state_currentRound_currentTrick_cards === void 0 ? void 0 : _state_currentRound_currentTrick_cards.length)) throw new Error('expected a card in play');
    const cards = state.currentRound.currentTrick.cards;
    return {
        eventName: $8d3c56edba7f9068$export$796ce39b90311506.CardPlayed,
        details: {
            playerCard: cards[cards.length - 1]
        }
    };
}
function $8d3c56edba7f9068$export$60818a302f8d608d(state) {
    const tricks = state.currentRound.completedTricks;
    return {
        eventName: $8d3c56edba7f9068$export$796ce39b90311506.TrickComplete,
        details: {
            trick: tricks[tricks.length - 1]
        }
    };
}
function $8d3c56edba7f9068$export$36c8d512b3c8a514(state) {
    const score = $8d3c56edba7f9068$export$bed6ab87e2e89fc(state);
    if (!score) throw new Error('expected a score here');
    return {
        eventName: $8d3c56edba7f9068$export$796ce39b90311506.RoundComplete,
        details: {
            score: score
        }
    };
}
function $8d3c56edba7f9068$export$33020c772c6fdc63(param, trick, trumpSuit) {
    const deck = (0, $dddf98aa62f65ae7$export$a1ed25fc414718b7)(param);
    if (!trick.cards.length) throw new Error('need to be cards in the trick');
    if (trumpSuit) {
        const highestTrumpPlayed = trick.cards.filter((playedCard)=>(0, $a8d1dd573118ab03$export$1ac444d24d8cbc4a)((0, $dddf98aa62f65ae7$export$574ca6466190d4b4)(deck, playedCard.card).suit, trumpSuit)).reduce((maxPlayerCard, nextPlayerCard)=>{
            if (!maxPlayerCard || (0, $dddf98aa62f65ae7$export$574ca6466190d4b4)(deck, maxPlayerCard.card).cardValue < (0, $dddf98aa62f65ae7$export$574ca6466190d4b4)(deck, nextPlayerCard.card).cardValue) return nextPlayerCard;
            return maxPlayerCard;
        }, undefined);
        if (highestTrumpPlayed) return highestTrumpPlayed.playerId;
    }
    const leadSuit = (0, $dddf98aa62f65ae7$export$574ca6466190d4b4)(deck, trick.cards[0].card).suit;
    const highestSuitedPlayed = trick.cards.filter((playedCard)=>(0, $a8d1dd573118ab03$export$1ac444d24d8cbc4a)((0, $dddf98aa62f65ae7$export$574ca6466190d4b4)(deck, playedCard.card).suit, leadSuit)).reduce((maxPlayerCard, nextPlayerCard)=>{
        if (!maxPlayerCard || (0, $dddf98aa62f65ae7$export$574ca6466190d4b4)(deck, maxPlayerCard.card).cardValue < (0, $dddf98aa62f65ae7$export$574ca6466190d4b4)(deck, nextPlayerCard.card).cardValue) return nextPlayerCard;
        return maxPlayerCard;
    }, undefined) || trick.cards[0];
    return highestSuitedPlayed.playerId;
}
function $8d3c56edba7f9068$export$f34789753b32aca0(state) {
    const round = Object.assign({}, state.currentRound);
    const trickToClose = Object.assign({}, state.currentRound.currentTrick);
    const winnerId = $8d3c56edba7f9068$export$33020c772c6fdc63(state.deckCode, trickToClose, state.currentRound.trumpSuit);
    const completedTricks = [
        ...round.completedTricks,
        {
            cards: trickToClose.cards,
            winnerId: winnerId
        }
    ];
    const updatedBids = round.bids.map((bid)=>bid.playerId === winnerId ? (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, bid), {
            wonTricks: bid.wonTricks + 1
        }) : bid);
    const currentRound = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, round), {
        completedTricks: completedTricks,
        turnPlayerId: winnerId,
        currentTrick: {
            cards: []
        },
        bids: updatedBids
    });
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
        currentRound: currentRound
    });
}
function $8d3c56edba7f9068$export$bed6ab87e2e89fc(state) {
    const lastRound = state.completedRounds[state.completedRounds.length - 1];
    if (!lastRound) return undefined;
    return lastRound.bids;
}
function $8d3c56edba7f9068$export$49482af99cf6723b(state) {
    const previousScore = $8d3c56edba7f9068$export$bed6ab87e2e89fc(state) || [];
    const score = state.currentRound.bids.map((bid)=>{
        const bidScore = (0, $380f0e1eb48d5610$export$947363cddeff0a3d)(bid.bidTricks, bid.wonTricks);
        const prevScore = previousScore.find((score)=>score.playerId === bid.playerId);
        return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, bid), {
            roundScore: bidScore,
            netScore: bidScore + ((prevScore === null || prevScore === void 0 ? void 0 : prevScore.netScore) || 0)
        });
    });
    const prevRound = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state.currentRound), {
        bids: score,
        currentTrick: undefined
    });
    const dealerPlayerId = (0, $18c9db29067a6763$export$32353e708aedd27a)(prevRound.dealerPlayerId, state.players);
    const completedRounds = [
        ...state.completedRounds,
        prevRound
    ];
    const currentRound = prevRound.roundNumber < state.roundsToPlay ? (0, $380f0e1eb48d5610$export$6262438e3046493b)(state.deckCode, state.players, prevRound.roundNumber + 1, dealerPlayerId) : undefined;
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
        completedRounds: completedRounds,
        currentRound: currentRound
    });
}


function $380f0e1eb48d5610$export$fd30f2bf6d6c85fe(bids) {
    return bids.reduce((sum, bid)=>{
        return sum + bid.bidTricks;
    }, 0);
}
function $380f0e1eb48d5610$export$6dc9c6d298ba25c8(placedBid, previousScore = 0) {
    const score = $380f0e1eb48d5610$export$947363cddeff0a3d(placedBid.bidTricks, placedBid.wonTricks);
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, placedBid), {
        roundScore: score,
        netScore: previousScore + score
    });
}
function $380f0e1eb48d5610$export$947363cddeff0a3d(bidTricks, wonTricks) {
    if (bidTricks !== wonTricks) {
        const offBy = Math.abs(bidTricks - wonTricks);
        return -1 * offBy * (5 + 5 * offBy) / 2;
    }
    return 10 + bidTricks * bidTricks;
}
function $380f0e1eb48d5610$export$8783a03aa3e336a5(round) {
    return round && round.deck && Array.isArray(round.players) && Array.isArray(round.hands) && !round.currentRound;
}
function $380f0e1eb48d5610$export$6262438e3046493b(deckCode, players, roundNumber, dealerPlayerId) {
    return {
        players: players.filter((player)=>!player.didExit),
        dealerPlayerId: dealerPlayerId,
        turnPlayerId: dealerPlayerId,
        deckCode: deckCode,
        deck: (0, $dddf98aa62f65ae7$export$448332262467e042)(deckCode),
        bids: [],
        hands: [],
        roundNumber: roundNumber,
        numberOfCards: roundNumber,
        completedTricks: [],
        roundName: undefined,
        currentTrick: undefined,
        trumpSuit: undefined,
        trumpCard: undefined,
        readyForCommands: [
            (0, $8d3c56edba7f9068$export$c114e6986ab7a2c0).DealCards
        ]
    };
}
function $380f0e1eb48d5610$export$a696ce95dd612ddd(round, eventType) {
    return round.readyForCommands && round.readyForCommands.includes(eventType);
}
function $380f0e1eb48d5610$export$472a5cb762ff2eab(round, playerId) {
    return round.turnPlayerId === playerId;
}
function $380f0e1eb48d5610$export$3cdb6899d1b318d5(round) {
    for (let trick of [
        ...round.completedTricks,
        round.currentTrick
    ])for (let playedCard of (trick === null || trick === void 0 ? void 0 : trick.cards) || []){
        if ((0, $a8d1dd573118ab03$export$1ac444d24d8cbc4a)(round.trumpSuit, (0, $dddf98aa62f65ae7$export$574ca6466190d4b4)(round, playedCard.card).suit)) return true;
    }
    return false;
}



function $4047d50c541b80cf$export$bc03ba615e47b5f3(state, deal) {
    if (!(0, $8d3c56edba7f9068$export$350bfa81fecdb6f3)(state) || !(0, $380f0e1eb48d5610$export$a696ce95dd612ddd)(state.currentRound, (0, $8d3c56edba7f9068$export$c114e6986ab7a2c0).DealCards)) return (0, $8d3c56edba7f9068$export$67a229608f85c16b)((0, $8d3c56edba7f9068$export$1d858bc500864334).NotDealPhase);
    const round = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state.currentRound, $4047d50c541b80cf$var$preselectTrump(state.currentRound));
    if (round.dealerPlayerId !== deal.playerId) return (0, $8d3c56edba7f9068$export$67a229608f85c16b)((0, $8d3c56edba7f9068$export$1d858bc500864334).NotPlayersTurn);
    const dealerIndex = round.players.findIndex((player)=>player.userId === round.dealerPlayerId);
    if (dealerIndex === -1) throw new Error('Requested dealer is not a player.');
    const deck = (0, $dddf98aa62f65ae7$export$448332262467e042)(round.deckCode);
    const hands = round.players.map((player)=>({
            playerId: player.userId,
            cards: []
        }));
    const cardsToDeal = hands.length * round.numberOfCards;
    if ((0, $dddf98aa62f65ae7$export$28b7351bf4b200b9)(round).cards.length < cardsToDeal) throw new Error('Do not have enough cards in deck to deal to game!');
    for(let i = 0; i < cardsToDeal; i++){
        const dealToHandIndex = (dealerIndex + i + 1) % hands.length;
        const card = (0, $a8d1dd573118ab03$export$32d4528f0e558529)(deck); // mutate deck.cards
        hands[dealToHandIndex].cards.push(card);
    }
    const turnPlayerId = (0, $18c9db29067a6763$export$32353e708aedd27a)(round.dealerPlayerId, round.players);
    const postDealRound = $4047d50c541b80cf$var$postSelectTrump((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, round), {
        deck: deck,
        hands: hands,
        turnPlayerId: turnPlayerId,
        readyForCommands: [
            (0, $8d3c56edba7f9068$export$c114e6986ab7a2c0).PlaceBid
        ]
    }));
    const postDealState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
        currentRound: postDealRound
    });
    return {
        result: (0, $b498b75d9b5e135f$export$3bc0a1d11e157185).Success,
        state: postDealState,
        events: [
            (0, $8d3c56edba7f9068$export$3c76c02ac8524459)(postDealState)
        ]
    };
}
function $4047d50c541b80cf$var$preselectTrump(round) {
    const deck = (0, $dddf98aa62f65ae7$export$28b7351bf4b200b9)(round);
    if (deck.trumpSuitName) return {
        deckCode: round.deckCode,
        trumpSuit: (0, $a8d1dd573118ab03$export$95de09fb6c4151bf)(deck),
        trumpCard: undefined
    };
    if (round.numberOfCards * round.players.length >= deck.cards.length) return {
        deckCode: round.deckCode,
        trumpSuit: (0, $c4491d29e9046e32$export$b74c481617709292)(deck.suits),
        trumpCard: undefined
    };
    return {
        deckCode: round.deckCode,
        trumpSuit: undefined,
        trumpCard: undefined
    };
}
function $4047d50c541b80cf$var$postSelectTrump(round) {
    if (round.trumpSuit) return round;
    const deck = [
        ...round.deck
    ];
    if (round.deck.length === 0) throw new Error('tried to get trump from empty deck');
    const trumpCard = (0, $a8d1dd573118ab03$export$32d4528f0e558529)(deck); // mutate deck
    const trumpSuit = (0, $dddf98aa62f65ae7$export$574ca6466190d4b4)(round, trumpCard).suit;
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, round), {
        deck: deck,
        trumpCard: trumpCard,
        trumpSuit: trumpSuit
    });
}




const $07431d7a0343b038$export$ba43bf67f3d48107 = {
    rounds: 12,
    deckCode: (0, $dddf98aa62f65ae7$export$3b8b72609a1ddc98).TarotSW
};
function $07431d7a0343b038$export$2cd8252107eb640b(players, hostId, options = $07431d7a0343b038$export$ba43bf67f3d48107) {
    const deckCode = options.deckCode;
    return {
        deckCode: deckCode,
        players: players,
        roundsToPlay: options.rounds,
        completedRounds: [],
        currentRound: (0, $380f0e1eb48d5610$export$6262438e3046493b)(deckCode, players, 1, hostId)
    };
}









function $2c396b0bcae9f8c8$export$1b7942156a0edb3e() {
    return {
        cards: []
    };
}
function $2c396b0bcae9f8c8$export$7e3e97498d6e1ec6(hands, playerId) {
    const hand = hands.find((hand)=>hand.playerId === playerId);
    if (!hand) throw new Error('could not find players hand');
    return hand;
}
function $2c396b0bcae9f8c8$export$4027d614a2c8db2a(param, trick) {
    const deckCode = (0, $dddf98aa62f65ae7$export$a1ed25fc414718b7)(param);
    if (!(trick === null || trick === void 0 ? void 0 : trick.cards.length)) return undefined;
    const card = (0, $dddf98aa62f65ae7$export$574ca6466190d4b4)(deckCode, trick.cards[0].card);
    return card.suit;
}


function $4f74c04b15a79e4d$export$6d65a5902ff15306(state, bid) {
    if (!(0, $8d3c56edba7f9068$export$350bfa81fecdb6f3)(state)) return (0, $8d3c56edba7f9068$export$67a229608f85c16b)((0, $8d3c56edba7f9068$export$1d858bc500864334).NotBidPhase);
    const bidFailure = $4f74c04b15a79e4d$var$checkForFailure(state, bid);
    if (bidFailure) return bidFailure;
    const currentRound = state.currentRound;
    const placedBid = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, bid), {
        wonTricks: 0
    });
    const round = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, currentRound), {
        turnPlayerId: (0, $18c9db29067a6763$export$32353e708aedd27a)(bid.playerId, state.currentRound.players),
        bids: [
            ...currentRound.bids,
            placedBid
        ]
    });
    const bidState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
        currentRound: round
    });
    const events = [
        (0, $8d3c56edba7f9068$export$cc79536b982b9701)(bidState)
    ];
    if (!$4f74c04b15a79e4d$var$isBiddingComplete(round)) return (0, $8d3c56edba7f9068$export$fd970e467a2a8344)(bidState, events);
    const bidCompleteState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, bidState), {
        currentRound: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, bidState.currentRound), {
            readyForCommands: [
                (0, $8d3c56edba7f9068$export$c114e6986ab7a2c0).PlayCard
            ],
            currentTrick: (0, $2c396b0bcae9f8c8$export$1b7942156a0edb3e)()
        })
    });
    events.push((0, $8d3c56edba7f9068$export$52e654f5691a9633)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
        currentRound: round
    })));
    return (0, $8d3c56edba7f9068$export$fd970e467a2a8344)(bidCompleteState, events);
}
function $4f74c04b15a79e4d$var$checkForFailure(state, bid) {
    const currentRound = state.currentRound;
    return $4f74c04b15a79e4d$var$ensureIsReadyForCommand(currentRound) || $4f74c04b15a79e4d$var$ensureIsPlayersTurn(currentRound, bid) || $4f74c04b15a79e4d$var$ensureDealerGetsScrewed(currentRound, bid) || false;
}
function $4f74c04b15a79e4d$var$ensureDealerGetsScrewed(round, bid) {
    if (bid.playerId === round.dealerPlayerId) {
        const sumOfBids = (0, $380f0e1eb48d5610$export$fd30f2bf6d6c85fe)([
            ...round.bids,
            bid
        ]);
        if (sumOfBids === round.numberOfCards) return {
            result: (0, $b498b75d9b5e135f$export$3bc0a1d11e157185).Failure,
            message: (0, $8d3c56edba7f9068$export$1d858bc500864334).DealerGetsScrewed
        };
    }
    return false;
}
function $4f74c04b15a79e4d$var$ensureIsReadyForCommand(round) {
    return !(0, $380f0e1eb48d5610$export$a696ce95dd612ddd)(round, (0, $8d3c56edba7f9068$export$c114e6986ab7a2c0).PlaceBid) && (0, $8d3c56edba7f9068$export$67a229608f85c16b)((0, $8d3c56edba7f9068$export$1d858bc500864334).NotBidPhase);
}
function $4f74c04b15a79e4d$var$ensureIsPlayersTurn(round, bid) {
    return !(0, $380f0e1eb48d5610$export$472a5cb762ff2eab)(round, bid.playerId) && (0, $8d3c56edba7f9068$export$67a229608f85c16b)((0, $8d3c56edba7f9068$export$1d858bc500864334).NotPlayersTurn);
}
function $4f74c04b15a79e4d$var$isBiddingComplete(round) {
    const activePlayers = round.players.filter((0, $18c9db29067a6763$export$b292b45d4ef547a));
    return !!(round.bids.length === activePlayers.length);
}









function $423e312ab66c20fe$export$317a6377ae525e39(state, playedCard) {
    if (!(0, $8d3c56edba7f9068$export$350bfa81fecdb6f3)(state)) return {
        result: (0, $b498b75d9b5e135f$export$3bc0a1d11e157185).Failure,
        message: (0, $8d3c56edba7f9068$export$1d858bc500864334).NotPlayPhase
    };
    const failure = $423e312ab66c20fe$var$checkForFailure(state.currentRound, playedCard);
    if (failure) return failure;
    const cardHasBeenPlayed = $423e312ab66c20fe$var$getStateWithCardMovedToTrick(state, playedCard);
    const cardEvent = (0, $8d3c56edba7f9068$export$cf23a2045594f247)(cardHasBeenPlayed);
    if (!$423e312ab66c20fe$export$1f5ca9c016f18119(cardHasBeenPlayed)) return (0, $8d3c56edba7f9068$export$fd970e467a2a8344)(cardHasBeenPlayed, [
        cardEvent
    ]);
    const trickHasBeenClosed = (0, $8d3c56edba7f9068$export$f34789753b32aca0)(cardHasBeenPlayed);
    const trickEvent = (0, $8d3c56edba7f9068$export$60818a302f8d608d)(trickHasBeenClosed);
    if (!$423e312ab66c20fe$export$5af218a4e03a9a01(trickHasBeenClosed)) return (0, $8d3c56edba7f9068$export$fd970e467a2a8344)(trickHasBeenClosed, [
        cardEvent,
        trickEvent
    ]);
    const roundHasBeenClosed = (0, $8d3c56edba7f9068$export$49482af99cf6723b)(trickHasBeenClosed);
    const roundEvent = (0, $8d3c56edba7f9068$export$36c8d512b3c8a514)(roundHasBeenClosed);
    // add endGame event here if no current round
    return (0, $8d3c56edba7f9068$export$fd970e467a2a8344)(roundHasBeenClosed, [
        cardEvent,
        trickEvent,
        roundEvent
    ]);
}
function $423e312ab66c20fe$export$1f5ca9c016f18119(state) {
    // check that every active player has played a card
    const activePlayerIds = state.currentRound.players.filter((player)=>(0, $18c9db29067a6763$export$b292b45d4ef547a)(player)).map((player)=>player.userId);
    if (!activePlayerIds || !state.currentRound.currentTrick || activePlayerIds.length > (state.currentRound.currentTrick.cards.length || 0)) return false;
    const havePlayed = new Set(state.currentRound.currentTrick.cards.map((playedCard)=>playedCard.playerId) || []);
    return activePlayerIds.every((playerId)=>havePlayed.has(playerId));
}
function $423e312ab66c20fe$export$5af218a4e03a9a01(state) {
    const trickCount = state.currentRound.completedTricks.length;
    const numCardsInRound = state.currentRound.numberOfCards;
    return trickCount === numCardsInRound;
}
function $423e312ab66c20fe$var$checkForFailure(round, playedCard) {
    if (!(0, $380f0e1eb48d5610$export$a696ce95dd612ddd)(round, (0, $8d3c56edba7f9068$export$c114e6986ab7a2c0).PlayCard)) return {
        result: (0, $b498b75d9b5e135f$export$3bc0a1d11e157185).Failure,
        message: (0, $8d3c56edba7f9068$export$1d858bc500864334).NotPlayPhase
    };
    if (!(0, $380f0e1eb48d5610$export$472a5cb762ff2eab)(round, playedCard.playerId)) return {
        result: (0, $b498b75d9b5e135f$export$3bc0a1d11e157185).Failure,
        message: (0, $8d3c56edba7f9068$export$1d858bc500864334).NotPlayersTurn
    };
    const { isValid: isValid, message: message } = $423e312ab66c20fe$export$396588a3d914f313(round, playedCard);
    if (!isValid) return {
        result: (0, $b498b75d9b5e135f$export$3bc0a1d11e157185).Failure,
        message: message || (0, $8d3c56edba7f9068$export$1d858bc500864334).CardNotInHand
    };
    return false;
}
function $423e312ab66c20fe$var$getStateWithCardMovedToTrick(state, playedCard) {
    const round = Object.assign({}, state.currentRound);
    if (!round.currentTrick) throw new Error('can not move card to non-existent trick');
    const { handsPostPlay: handsPostPlay, trickPlusPlayedCard: trickPlusPlayedCard } = $423e312ab66c20fe$var$getPostPlayTrickAndHand(round.hands, round.currentTrick, playedCard);
    const nextPlayerId = (0, $18c9db29067a6763$export$32353e708aedd27a)(playedCard.playerId, round.players);
    const currentRound = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, round), {
        turnPlayerId: nextPlayerId,
        currentTrick: trickPlusPlayedCard,
        hands: handsPostPlay
    });
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
        currentRound: currentRound
    });
}
function $423e312ab66c20fe$export$a2c7264fd050ba12(round, hand) {
    if (!(0, $380f0e1eb48d5610$export$472a5cb762ff2eab)(round, hand.playerId)) throw new Error('can not choose playable cards if not player turn');
    const trick = round.currentTrick;
    if (!trick) throw new Error('can not play cards if no trick');
    if (!trick.cards.length) return $423e312ab66c20fe$export$8ba73eaf88476750(round, hand);
    return $423e312ab66c20fe$export$8bc840739d042634(round.deckCode, trick, hand);
}
function $423e312ab66c20fe$export$8bc840739d042634(deckCode, trick, hand) {
    if (!trick) throw new Error('expected a trick here');
    const ledCard = trick.cards[0];
    const cardsMatchingSuit = hand.cards.filter((card)=>(0, $a8d1dd573118ab03$export$1ac444d24d8cbc4a)((0, $dddf98aa62f65ae7$export$574ca6466190d4b4)(deckCode, card).suit, (0, $dddf98aa62f65ae7$export$574ca6466190d4b4)(deckCode, ledCard.card).suit));
    return cardsMatchingSuit.length > 0 ? cardsMatchingSuit : hand.cards;
}
function $423e312ab66c20fe$var$getPostPlayTrickAndHand(hands, trick, playedCard) {
    const { playerId: playerId, card: card } = playedCard;
    const playerHand = (0, $2c396b0bcae9f8c8$export$7e3e97498d6e1ec6)(hands, playerId);
    const playerHandMinusPlayedCard = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, playerHand), {
        cards: playerHand.cards.filter((handCard)=>card !== handCard)
    });
    if (playerHandMinusPlayedCard.cards.length !== playerHand.cards.length - 1) // if someone has mutated cards, this will eventually happen.
    throw new Error('failure to move single card from hand to trick');
    const handsPostPlay = hands.map((hand)=>hand.playerId === playerHand.playerId ? playerHandMinusPlayedCard : hand);
    const trickPlusPlayedCard = {
        cards: [
            ...trick.cards || [],
            playedCard
        ]
    };
    return {
        handsPostPlay: handsPostPlay,
        trickPlusPlayedCard: trickPlusPlayedCard
    };
}
function $423e312ab66c20fe$export$8ba73eaf88476750(round, hand) {
    const trumpCount = hand.cards.filter((card)=>(0, $a8d1dd573118ab03$export$1ac444d24d8cbc4a)((0, $dddf98aa62f65ae7$export$574ca6466190d4b4)(round, card).suit, round.trumpSuit)).length;
    if (trumpCount === 0 || trumpCount === hand.cards.length || (0, $380f0e1eb48d5610$export$3cdb6899d1b318d5)(round)) return hand.cards;
    return hand.cards.filter((card)=>!(0, $a8d1dd573118ab03$export$1ac444d24d8cbc4a)((0, $dddf98aa62f65ae7$export$574ca6466190d4b4)(round, card).suit, round.trumpSuit));
}
function $423e312ab66c20fe$export$396588a3d914f313(round, { card: card, playerId: playerId }) {
    const successResult = {
        isValid: true
    };
    if (!round.currentTrick) return $423e312ab66c20fe$var$invalidPlay((0, $8d3c56edba7f9068$export$1d858bc500864334).NotPlayPhase);
    if (playerId != round.turnPlayerId) return $423e312ab66c20fe$var$invalidPlay((0, $8d3c56edba7f9068$export$1d858bc500864334).NotPlayersTurn);
    const hand = (0, $2c396b0bcae9f8c8$export$7e3e97498d6e1ec6)(round.hands, playerId);
    if (!hand || hand.cards.find((handCard)=>handCard === card) === undefined) return $423e312ab66c20fe$var$invalidPlay((0, $8d3c56edba7f9068$export$1d858bc500864334).CardNotInHand);
    const trump = round.trumpSuit;
    if (round.currentTrick.cards.length === 0) {
        if ((0, $a8d1dd573118ab03$export$1ac444d24d8cbc4a)((0, $dddf98aa62f65ae7$export$574ca6466190d4b4)(round, card).suit, trump)) {
            const anyNonTrumpInHand = hand.cards.filter((card)=>!(0, $a8d1dd573118ab03$export$1ac444d24d8cbc4a)((0, $dddf98aa62f65ae7$export$574ca6466190d4b4)(round, card).suit, trump)).length > 0;
            if (!(0, $380f0e1eb48d5610$export$3cdb6899d1b318d5)(round) && anyNonTrumpInHand) return $423e312ab66c20fe$var$invalidPlay((0, $8d3c56edba7f9068$export$1d858bc500864334).TrumpsNotBroken);
        }
        return successResult;
    }
    const ledSuit = (0, $2c396b0bcae9f8c8$export$4027d614a2c8db2a)(round.deckCode, round.currentTrick);
    const playedSuit = (0, $dddf98aa62f65ae7$export$574ca6466190d4b4)(round, card).suit;
    const playerHand = (0, $2c396b0bcae9f8c8$export$7e3e97498d6e1ec6)(round.hands, playerId);
    if (ledSuit && !(0, $a8d1dd573118ab03$export$1ac444d24d8cbc4a)(playedSuit, ledSuit) && !!playerHand.cards.find((card)=>(0, $a8d1dd573118ab03$export$1ac444d24d8cbc4a)((0, $dddf98aa62f65ae7$export$574ca6466190d4b4)(round, card).suit, ledSuit))) return $423e312ab66c20fe$var$invalidPlay((0, $8d3c56edba7f9068$export$1d858bc500864334).MustFollowSuit);
    return successResult;
}
function $423e312ab66c20fe$var$invalidPlay(message) {
    return {
        isValid: false,
        message: message
    };
}




function $3be81abe8690f361$export$e0537c06191f98e8(state, playerId) {
    if (!(0, $8d3c56edba7f9068$export$350bfa81fecdb6f3)(state)) return state;
    const currentRound = $3be81abe8690f361$export$e9c61d33784f14ab(state.currentRound, playerId);
    return {
        players: state.players,
        roundsToPlay: state.roundsToPlay,
        completedRounds: state.completedRounds,
        currentRound: currentRound,
        playerId: playerId
    };
}
function $3be81abe8690f361$export$3a32ebf721fa1ab8(state) {
    return !!state.playerId;
}
function $3be81abe8690f361$export$e9c61d33784f14ab(round, playerId) {
    const hand = (0, $2c396b0bcae9f8c8$export$7e3e97498d6e1ec6)(round.hands, playerId);
    const trickWinnerIds = round.completedTricks.map((trick)=>trick.winnerId);
    return {
        deckCode: round.deckCode,
        players: round.players,
        dealerPlayerId: round.dealerPlayerId,
        turnPlayerId: round.turnPlayerId,
        bids: round.bids,
        hand: hand,
        trickWinnerIds: trickWinnerIds,
        completedTricks: round.completedTricks,
        currentTrick: round.currentTrick,
        readyForCommands: round.readyForCommands,
        trumpCard: round.trumpCard,
        trumpSuit: round.trumpSuit,
        roundNumber: round.roundNumber,
        roundName: round.roundName,
        numberOfCards: round.numberOfCards
    };
}






function $940c288544ecaea5$export$91088ae7d82e77d2(state, kickData) {
    if (!state.players || state.players.length < 2) return (0, $8d3c56edba7f9068$export$67a229608f85c16b)((0, $8d3c56edba7f9068$export$1d858bc500864334).CantKickLastPlayer);
    const exitingUserId = kickData.kickedPlayerId;
    const players = $940c288544ecaea5$var$buildPlayersWithExitedPlayer(state, exitingUserId, kickData.kickReason);
    const kickedState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
        players: players
    });
    return (0, $8d3c56edba7f9068$export$fd970e467a2a8344)(kickedState, []);
}
const $940c288544ecaea5$var$buildPlayersWithExitedPlayer = (state, exitingPlayerId, kickReason)=>{
    const players = [
        ...state.players
    ];
    const exitingPlayerIndex = players.findIndex((player)=>player.userId === exitingPlayerId);
    if (exitingPlayerIndex !== -1) {
        const exitedPlayer = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, players[exitingPlayerIndex]), {
            didExit: true,
            kickReason: kickReason || null
        });
        players.splice(exitingPlayerIndex, 1, exitedPlayer);
    }
    return players;
};





var $2f6b4ba8d816453d$export$1fb280ffe73d8b88;
(function(ExpertIds) {
    ExpertIds["thirsty"] = "thirsty";
    ExpertIds["cautious"] = "cautious";
    ExpertIds["random"] = "random";
})($2f6b4ba8d816453d$export$1fb280ffe73d8b88 || ($2f6b4ba8d816453d$export$1fb280ffe73d8b88 = {}));
function $2f6b4ba8d816453d$export$4dc5ad5b393ab716(state) {
    var _state_currentRound;
    if (state.playerId !== ((_state_currentRound = state.currentRound) === null || _state_currentRound === void 0 ? void 0 : _state_currentRound.turnPlayerId)) throw new Error('attempted to take action for non turn player');
}
function $2f6b4ba8d816453d$export$639d2f49a1dda311(param, trickState) {
    const deckCode = (0, $dddf98aa62f65ae7$export$a1ed25fc414718b7)(param);
    const ledSuit = (0, $2c396b0bcae9f8c8$export$4027d614a2c8db2a)(deckCode, trickState.trick);
    const followingCards = trickState.handCards.filter((card)=>(0, $a8d1dd573118ab03$export$1ac444d24d8cbc4a)(card.suit, ledSuit));
    return followingCards.length ? followingCards : undefined;
}
function $2f6b4ba8d816453d$var$getWinnerOfTwoCards(param, cardRef1, cardRef2, trump, ledSuit) {
    const card1 = (0, $dddf98aa62f65ae7$export$574ca6466190d4b4)(param, cardRef1);
    const card2 = (0, $dddf98aa62f65ae7$export$574ca6466190d4b4)(param, cardRef2);
    if ((0, $a8d1dd573118ab03$export$1ac444d24d8cbc4a)(card1.suit, card2.suit)) return $2f6b4ba8d816453d$var$getCardOfHigherValue(param, cardRef1, cardRef2);
    if ((0, $a8d1dd573118ab03$export$1ac444d24d8cbc4a)(card1.suit, trump)) return cardRef1;
    if ((0, $a8d1dd573118ab03$export$1ac444d24d8cbc4a)(card2.suit, trump)) return cardRef2;
    if ((0, $a8d1dd573118ab03$export$1ac444d24d8cbc4a)(card1.suit, ledSuit)) return cardRef1;
    if ((0, $a8d1dd573118ab03$export$1ac444d24d8cbc4a)(card2.suit, ledSuit)) return cardRef2;
    return cardRef1;
}
function $2f6b4ba8d816453d$var$getCardOfHigherValue(param, cardRef1, cardRef2) {
    const card1 = (0, $dddf98aa62f65ae7$export$574ca6466190d4b4)(param, cardRef1);
    const card2 = (0, $dddf98aa62f65ae7$export$574ca6466190d4b4)(param, cardRef2);
    if (!(0, $a8d1dd573118ab03$export$1ac444d24d8cbc4a)(card1.suit, card2.suit)) throw new Error('cards must be same suit');
    return card1.cardValue > card2.cardValue ? cardRef1 : cardRef2;
}
function $2f6b4ba8d816453d$export$ad01196f8d177b3b(param, trickState) {
    if (!trickState.trick.cards.length) return undefined;
    const ledSuit = (0, $2c396b0bcae9f8c8$export$4027d614a2c8db2a)(param, trickState.trick);
    if (!ledSuit) return undefined;
    return trickState.trick.cards.reduce((winningCard, nextCard)=>{
        if (!winningCard) return nextCard;
        const winnerCardValue = $2f6b4ba8d816453d$var$getWinnerOfTwoCards(param, winningCard.card, nextCard.card, trickState.trumpSuit, ledSuit);
        return (0, $a8d1dd573118ab03$export$9f8ddb69ddf3acf9)((0, $dddf98aa62f65ae7$export$574ca6466190d4b4)(param, winnerCardValue), (0, $dddf98aa62f65ae7$export$574ca6466190d4b4)(param, nextCard.card)) ? nextCard : winningCard;
    }, undefined);
}
function $2f6b4ba8d816453d$export$4ce4e071f9bd0342(trickState) {
    throw new Error('not implemented');
}
function $2f6b4ba8d816453d$export$8e17bef0972f5359(trickState) {
    throw new Error('not implemented');
}
function $2f6b4ba8d816453d$export$6e09d6052e703a31(trickState) {
    throw new Error('not implemented');
}
function $2f6b4ba8d816453d$export$d60a05ecbd52ffad(trickState) {
    throw new Error('not implemented');
}
function $2f6b4ba8d816453d$export$f8d234f78160df12(trickState) {
    throw new Error('not implemented');
}
function $2f6b4ba8d816453d$export$a638d9b3214cf13(trickState) {
    throw new Error('not implemented');
}
function $2f6b4ba8d816453d$export$459135e1d86642ec(trickState) {
    throw new Error('not implemented');
}


const $615a5fef101c2207$var$getGameEvent = (game, event)=>({
        eventId: (0, $67067ff092058c03$export$2e2bcd8739ae039)(),
        gameId: game.gameId,
        eventType: event.eventName,
        eventData: event.details
    });
const $615a5fef101c2207$var$handleOhHellResult = (game, result)=>{
    if ((0, $8d3c56edba7f9068$export$b0ac3e614a309be3)(result)) return {
        game: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, game), {
            gameState: result.state
        }),
        events: result.events.map((event)=>$615a5fef101c2207$var$getGameEvent(game, event))
    };
    throw new Error(result.message);
};
const $615a5fef101c2207$export$90bdd454961e74d3 = {
    start: (prevGame, cmd)=>{
        const cmdData = cmd.cmdData || {};
        const options = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $07431d7a0343b038$export$ba43bf67f3d48107), cmdData);
        if (!options.deckCode || !options.rounds) throw new Error('invalid options for start OhHell');
        const gameState = (0, $07431d7a0343b038$export$2cd8252107eb640b)(prevGame.players, prevGame.hostUserId, options);
        const startEvent = $615a5fef101c2207$var$getGameEvent(prevGame, {
            eventName: (0, $8d3c56edba7f9068$export$796ce39b90311506).Start,
            details: {}
        });
        return {
            game: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, prevGame), {
                gameState: gameState
            }),
            events: [
                startEvent
            ]
        };
    },
    getPlayerState: (prevGame, cmd)=>{
        var _cmd_player, _state_currentRound_hands, _state_currentRound;
        if (!(cmd === null || cmd === void 0 ? void 0 : (_cmd_player = cmd.player) === null || _cmd_player === void 0 ? void 0 : _cmd_player.userId)) throw new Error('must provide player to getPlayerState in cmd');
        const playerId = cmd.player.userId;
        const state = prevGame.gameState;
        if (!(state === null || state === void 0 ? void 0 : state.currentRound) || !(state === null || state === void 0 ? void 0 : (_state_currentRound = state.currentRound) === null || _state_currentRound === void 0 ? void 0 : (_state_currentRound_hands = _state_currentRound.hands) === null || _state_currentRound_hands === void 0 ? void 0 : _state_currentRound_hands.length)) return {
            game: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, prevGame), {
                gameState: state
            }),
            events: []
        };
        const ohHellState = (0, $3be81abe8690f361$export$e0537c06191f98e8)(state, playerId);
        return {
            game: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, prevGame), {
                gameState: ohHellState
            }),
            events: []
        };
    },
    dealCards: (prevGame, cmd)=>{
        const deal = cmd === null || cmd === void 0 ? void 0 : cmd.cmdData;
        if (!(deal === null || deal === void 0 ? void 0 : deal.playerId)) throw new Error(`missing deal data in DealCards; cmd was ${JSON.stringify(cmd)} `);
        const result = (0, $4047d50c541b80cf$export$bc03ba615e47b5f3)(prevGame.gameState, deal);
        return $615a5fef101c2207$var$handleOhHellResult(prevGame, result);
    },
    placeBid: (prevGame, cmd)=>{
        const bid = cmd === null || cmd === void 0 ? void 0 : cmd.cmdData;
        if (!bid || !bid.bidTricks && bid.bidTricks !== 0 || !bid.playerId) throw new Error(`missing bid data in placeBid; cmd was ${JSON.stringify(cmd)} `);
        const result = (0, $4f74c04b15a79e4d$export$6d65a5902ff15306)(prevGame.gameState, bid);
        return $615a5fef101c2207$var$handleOhHellResult(prevGame, result);
    },
    playCard: (prevGame, cmd)=>{
        const card = cmd === null || cmd === void 0 ? void 0 : cmd.cmdData;
        if (!card || !(0, $a8d1dd573118ab03$export$25161dc7863e1c87)(card.card) || !card.playerId) throw new Error(`missing card data in playCard; cmd was ${JSON.stringify(cmd)} `);
        const result = (0, $423e312ab66c20fe$export$317a6377ae525e39)(prevGame.gameState, card);
        return $615a5fef101c2207$var$handleOhHellResult(prevGame, result);
    },
    kickPlayer: (prevGame, cmd)=>{
        const kickData = cmd.cmdData;
        if (!kickData) throw new Error(`missing kick player data in kickPlayer; cmd was ${JSON.stringify(cmd)} `);
        const result = (0, $940c288544ecaea5$export$91088ae7d82e77d2)(prevGame.gameState, kickData);
        return $615a5fef101c2207$var$handleOhHellResult(prevGame, result);
    }
};







var $f954a6ee3393cf06$export$d7398a4842a89c0a;
(function(WinGameCmdTypes) {
    WinGameCmdTypes["Win"] = "WIN";
})($f954a6ee3393cf06$export$d7398a4842a89c0a || ($f954a6ee3393cf06$export$d7398a4842a89c0a = {}));
const $f954a6ee3393cf06$var$winGame = (game, cmd)=>{
    const gameId = cmd.gameId;
    const winnerUserId = cmd.player.userId;
    if (game.status !== (0, $08d136cf68240767$export$23c7328964450bd2).InProgress) throw new Error('Game can only be won if in progress.');
    const gameState = {
        score: game.players.map((player)=>({
                playerId: player.userId,
                score: player.userId === winnerUserId ? 1 : 0
            }))
    };
    const winEvent = {
        eventId: (0, $67067ff092058c03$export$2e2bcd8739ae039)(),
        gameId: gameId,
        gameRuleSetName: game.gameRuleSetName,
        eventType: $f954a6ee3393cf06$export$d7398a4842a89c0a.Win,
        eventData: {}
    };
    const resultGame = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, game), {
        gameState: gameState,
        status: (0, $08d136cf68240767$export$23c7328964450bd2).Complete
    });
    const result = {
        game: resultGame,
        events: [
            winEvent
        ]
    };
    return result;
};
const $f954a6ee3393cf06$export$8873c4eb9de2dcd8 = {
    winGame: $f954a6ee3393cf06$var$winGame
};


const $23e6958b90184520$var$gameCmdHandlers = {
    [(0, $b498b75d9b5e135f$export$890274e3d5170b8b).Base]: {
        [(0, $86486bb7b4b55757$export$121ef92b42134ced).Create]: (prev, cmdData)=>({
                game: prev,
                events: []
            }),
        [(0, $86486bb7b4b55757$export$121ef92b42134ced).Start]: (0, $86486bb7b4b55757$export$d49d2d752c6baf94).startGame,
        [(0, $86486bb7b4b55757$export$121ef92b42134ced).Join]: (0, $86486bb7b4b55757$export$d49d2d752c6baf94).joinGame,
        [(0, $86486bb7b4b55757$export$121ef92b42134ced).GetPlayerState]: (0, $86486bb7b4b55757$export$d49d2d752c6baf94).getPlayerState,
        [(0, $86486bb7b4b55757$export$121ef92b42134ced).Exit]: (0, $86486bb7b4b55757$export$d49d2d752c6baf94).exitGame,
        [(0, $86486bb7b4b55757$export$121ef92b42134ced).Error]: (prevGame, cmdData)=>{
            throw new Error(`Error command is not implemented. Command data was ${cmdData}`);
        },
        [(0, $86486bb7b4b55757$export$121ef92b42134ced).Kick]: (0, $86486bb7b4b55757$export$d49d2d752c6baf94).kickPlayer
    },
    [(0, $b498b75d9b5e135f$export$890274e3d5170b8b).WinThisGame]: {
        [(0, $f954a6ee3393cf06$export$d7398a4842a89c0a).Win]: (0, $f954a6ee3393cf06$export$8873c4eb9de2dcd8).winGame
    },
    [(0, $b498b75d9b5e135f$export$890274e3d5170b8b).OhHell]: {
        [(0, $8d3c56edba7f9068$export$c114e6986ab7a2c0).Start]: (0, $615a5fef101c2207$export$90bdd454961e74d3).start,
        [(0, $8d3c56edba7f9068$export$c114e6986ab7a2c0).GetPlayerState]: (0, $615a5fef101c2207$export$90bdd454961e74d3).getPlayerState,
        [(0, $8d3c56edba7f9068$export$c114e6986ab7a2c0).DealCards]: (0, $615a5fef101c2207$export$90bdd454961e74d3).dealCards,
        [(0, $8d3c56edba7f9068$export$c114e6986ab7a2c0).PlaceBid]: (0, $615a5fef101c2207$export$90bdd454961e74d3).placeBid,
        [(0, $8d3c56edba7f9068$export$c114e6986ab7a2c0).PlayCard]: (0, $615a5fef101c2207$export$90bdd454961e74d3).playCard,
        [(0, $8d3c56edba7f9068$export$c114e6986ab7a2c0).Kick]: (0, $615a5fef101c2207$export$90bdd454961e74d3).kickPlayer
    }
};
const $23e6958b90184520$var$getBaseGameCmdResult = (prevGame, gameCmd)=>{
    if (!$23e6958b90184520$var$gameCmdHandlers[(0, $b498b75d9b5e135f$export$890274e3d5170b8b).Base][gameCmd.cmdType]) return {
        game: prevGame,
        events: []
    };
    return $23e6958b90184520$var$gameCmdHandlers[(0, $b498b75d9b5e135f$export$890274e3d5170b8b).Base][gameCmd.cmdType](prevGame, gameCmd);
};
const $23e6958b90184520$export$1c90534e29578eb8 = (game, player)=>({
        player: player,
        cmdId: '',
        gameId: game.gameId,
        gameRuleSetName: game.gameRuleSetName,
        cmdType: (0, $86486bb7b4b55757$export$121ef92b42134ced).GetPlayerState,
        cmdData: {}
    });
const $23e6958b90184520$export$708590cef5427b5c = (game, player)=>{
    const cmd = $23e6958b90184520$export$1c90534e29578eb8(game, player);
    const result = $23e6958b90184520$export$8d4e4f6fc6cf64e7(game, cmd);
    if (!result.game) throw new Error('Expected to get a game on the response for get player state command');
    return result.game;
};
const $23e6958b90184520$export$8d4e4f6fc6cf64e7 = (prevGame, gameCmd)=>{
    const gameRuleSetName = gameCmd.gameRuleSetName || '';
    const gameCmdHandler = $23e6958b90184520$var$gameCmdHandlers[gameRuleSetName];
    if (!gameCmdHandler) throw new Error(`processGameCommand - Configuration error.  Game ruleset not supported.
          Supported rulesets are ${JSON.stringify(Object.keys($23e6958b90184520$var$gameCmdHandlers))}`);
    if (gameRuleSetName !== prevGame.gameRuleSetName) throw new Error(`attempted to use cmd for ${gameRuleSetName} when game was ${prevGame.gameRuleSetName}`);
    const baseHandler = $23e6958b90184520$var$gameCmdHandlers.Base[gameCmd.cmdType];
    const handler = gameCmdHandler[gameCmd.cmdType];
    if (!handler && !baseHandler) throw new Error('getGameProcessor - Configuration error.  Game command not supported for ruleset.');
    const baseResult = $23e6958b90184520$var$getBaseGameCmdResult(prevGame, gameCmd);
    if (gameRuleSetName === (0, $b498b75d9b5e135f$export$890274e3d5170b8b).Base || !baseResult.game || !handler) return baseResult;
    return handler(baseResult.game, gameCmd);
};






function $637257b73fac4bc7$var$getBid(state) {
    (0, $2f6b4ba8d816453d$export$4dc5ad5b393ab716)(state);
    const playerId = state.playerId;
    const cardsInRound = state.currentRound.numberOfCards;
    const bidTricks = 1 + Math.floor(1.25 * state.currentRound.numberOfCards / state.currentRound.players.length);
    const plannedTotalBid = (0, $380f0e1eb48d5610$export$fd30f2bf6d6c85fe)(state.currentRound.bids) + bidTricks;
    if (state.currentRound.dealerPlayerId === state.playerId && plannedTotalBid === cardsInRound) return {
        playerId: playerId,
        bidTricks: bidTricks === 0 ? 1 : bidTricks - 1
    };
    return {
        playerId: playerId,
        bidTricks: bidTricks
    };
}
function $637257b73fac4bc7$var$getPlayerCard(state) {
    (0, $2f6b4ba8d816453d$export$4dc5ad5b393ab716)(state);
    const playerId = state.playerId;
    const playerHand = state.currentRound.hand;
    const chooseable = (0, $423e312ab66c20fe$export$a2c7264fd050ba12)(state.currentRound, playerHand);
    if (chooseable.length === 0) throw new Error('expected to find chooseable cards');
    return {
        card: chooseable[0],
        playerId: playerId
    }; // effectively random
}
const $637257b73fac4bc7$export$78155241984a007a = {
    getBid: $637257b73fac4bc7$var$getBid,
    getPlayerCard: $637257b73fac4bc7$var$getPlayerCard,
    computerPlayerId: (0, $2f6b4ba8d816453d$export$1fb280ffe73d8b88).thirsty
};





function $1f9fad3d9ade5357$var$getBid(state) {
    (0, $2f6b4ba8d816453d$export$4dc5ad5b393ab716)(state);
    const playerId = state.playerId;
    const cardsInRound = state.currentRound.numberOfCards;
    const bidTricks = 1 + Math.floor(1.25 * state.currentRound.numberOfCards / state.currentRound.players.length);
    const plannedTotalBid = (0, $380f0e1eb48d5610$export$fd30f2bf6d6c85fe)(state.currentRound.bids) + bidTricks;
    if (state.currentRound.dealerPlayerId === state.playerId && plannedTotalBid === cardsInRound) return {
        playerId: playerId,
        bidTricks: bidTricks === 0 ? 1 : bidTricks - 1
    };
    return {
        playerId: playerId,
        bidTricks: bidTricks
    };
}
function $1f9fad3d9ade5357$var$getPlayerCard(state) {
    (0, $2f6b4ba8d816453d$export$4dc5ad5b393ab716)(state);
    const playerId = state.playerId;
    const playerHand = state.currentRound.hand;
    const chooseable = (0, $423e312ab66c20fe$export$a2c7264fd050ba12)(state.currentRound, playerHand);
    if (chooseable.length === 0) throw new Error('expected to find chooseable cards');
    return {
        card: chooseable[0],
        playerId: playerId
    }; // effectively random
}
const $1f9fad3d9ade5357$export$a7389ee914c26785 = {
    getBid: $1f9fad3d9ade5357$var$getBid,
    getPlayerCard: $1f9fad3d9ade5357$var$getPlayerCard,
    computerPlayerId: (0, $2f6b4ba8d816453d$export$1fb280ffe73d8b88).cautious
};





function $125737285b5d1b20$var$getBid(state) {
    (0, $2f6b4ba8d816453d$export$4dc5ad5b393ab716)(state);
    const playerId = state.playerId;
    const cardsInRound = state.currentRound.numberOfCards;
    const bidTricks = Math.floor(state.currentRound.numberOfCards / state.currentRound.players.length);
    const plannedTotalBid = (0, $380f0e1eb48d5610$export$fd30f2bf6d6c85fe)(state.currentRound.bids) + bidTricks;
    if (state.currentRound.dealerPlayerId === state.playerId && plannedTotalBid === cardsInRound) return {
        playerId: playerId,
        bidTricks: bidTricks === 0 ? 1 : bidTricks - 1
    };
    return {
        playerId: playerId,
        bidTricks: bidTricks
    };
}
function $125737285b5d1b20$var$getPlayerCard(state) {
    (0, $2f6b4ba8d816453d$export$4dc5ad5b393ab716)(state);
    const playerId = state.playerId;
    const playerHand = state.currentRound.hand;
    const chooseable = (0, $423e312ab66c20fe$export$a2c7264fd050ba12)(state.currentRound, playerHand);
    if (chooseable.length === 0) throw new Error('expected to find chooseable cards');
    return {
        card: chooseable[0],
        playerId: playerId
    }; // effectively random
}
const $125737285b5d1b20$export$db40a8dcef2754bb = {
    getBid: $125737285b5d1b20$var$getBid,
    getPlayerCard: $125737285b5d1b20$var$getPlayerCard,
    computerPlayerId: (0, $2f6b4ba8d816453d$export$1fb280ffe73d8b88).random
};





const $512967eb3a408490$var$getOhHellDealCards = (state)=>({
        playerId: state.currentRound.dealerPlayerId
    });
const $512967eb3a408490$var$gameExpertCommandRequestRouter = {
    [(0, $b498b75d9b5e135f$export$890274e3d5170b8b).Base]: undefined,
    [(0, $b498b75d9b5e135f$export$890274e3d5170b8b).WinThisGame]: undefined,
    [(0, $b498b75d9b5e135f$export$890274e3d5170b8b).OhHell]: {
        [(0, $2f6b4ba8d816453d$export$1fb280ffe73d8b88).thirsty]: {
            [(0, $8d3c56edba7f9068$export$c114e6986ab7a2c0).DealCards]: $512967eb3a408490$var$getOhHellDealCards,
            [(0, $8d3c56edba7f9068$export$c114e6986ab7a2c0).PlaceBid]: (0, $125737285b5d1b20$export$db40a8dcef2754bb).getBid,
            [(0, $8d3c56edba7f9068$export$c114e6986ab7a2c0).PlayCard]: (0, $125737285b5d1b20$export$db40a8dcef2754bb).getPlayerCard,
            [(0, $8d3c56edba7f9068$export$c114e6986ab7a2c0).Start]: undefined,
            [(0, $8d3c56edba7f9068$export$c114e6986ab7a2c0).GetPlayerState]: undefined
        },
        [(0, $2f6b4ba8d816453d$export$1fb280ffe73d8b88).cautious]: {
            [(0, $8d3c56edba7f9068$export$c114e6986ab7a2c0).DealCards]: $512967eb3a408490$var$getOhHellDealCards,
            [(0, $8d3c56edba7f9068$export$c114e6986ab7a2c0).PlaceBid]: (0, $1f9fad3d9ade5357$export$a7389ee914c26785).getBid,
            [(0, $8d3c56edba7f9068$export$c114e6986ab7a2c0).PlayCard]: (0, $1f9fad3d9ade5357$export$a7389ee914c26785).getPlayerCard,
            [(0, $8d3c56edba7f9068$export$c114e6986ab7a2c0).Start]: undefined,
            [(0, $8d3c56edba7f9068$export$c114e6986ab7a2c0).GetPlayerState]: undefined
        },
        [(0, $2f6b4ba8d816453d$export$1fb280ffe73d8b88).random]: {
            [(0, $8d3c56edba7f9068$export$c114e6986ab7a2c0).DealCards]: $512967eb3a408490$var$getOhHellDealCards,
            [(0, $8d3c56edba7f9068$export$c114e6986ab7a2c0).PlaceBid]: (0, $637257b73fac4bc7$export$78155241984a007a).getBid,
            [(0, $8d3c56edba7f9068$export$c114e6986ab7a2c0).PlayCard]: (0, $637257b73fac4bc7$export$78155241984a007a).getPlayerCard,
            [(0, $8d3c56edba7f9068$export$c114e6986ab7a2c0).Start]: undefined,
            [(0, $8d3c56edba7f9068$export$c114e6986ab7a2c0).GetPlayerState]: undefined
        }
    }
};
const $512967eb3a408490$export$3ac1f0df21b0b428 = (game, commandRequest)=>{
    const gameRuleSetName = game.gameRuleSetName;
    const expertPlayerId = commandRequest.computerPlayerId;
    const { commandName: commandName } = commandRequest;
    const expertRouter = $512967eb3a408490$var$gameExpertCommandRequestRouter[gameRuleSetName];
    const expertRequestRouter = expertRouter && expertRouter[expertPlayerId];
    const requestHandler = expertRequestRouter && expertRequestRouter[commandName];
    if (!requestHandler) return undefined;
    const cmdData = requestHandler(game.gameState);
    return {
        player: commandRequest.player,
        cmdId: (0, $67067ff092058c03$export$2e2bcd8739ae039)(),
        gameId: game.gameId,
        gameRuleSetName: gameRuleSetName,
        cmdType: commandName,
        cmdData: cmdData
    };
};







// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $2bcaa466815aa8a5$var$getRandomValues;
var $2bcaa466815aa8a5$var$rnds8 = new Uint8Array(16);
function $2bcaa466815aa8a5$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$2bcaa466815aa8a5$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        $2bcaa466815aa8a5$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);
        if (!$2bcaa466815aa8a5$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $2bcaa466815aa8a5$var$getRandomValues($2bcaa466815aa8a5$var$rnds8);
}


var $7709510a2fca9f72$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $8df89a4d60889f85$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $7709510a2fca9f72$export$2e2bcd8739ae039).test(uuid);
}
var $8df89a4d60889f85$export$2e2bcd8739ae039 = $8df89a4d60889f85$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $ee13ceee8d9f46c4$var$byteToHex = [];
for(var $ee13ceee8d9f46c4$var$i = 0; $ee13ceee8d9f46c4$var$i < 256; ++$ee13ceee8d9f46c4$var$i)$ee13ceee8d9f46c4$var$byteToHex.push(($ee13ceee8d9f46c4$var$i + 0x100).toString(16).substr(1));
function $ee13ceee8d9f46c4$var$stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = ($ee13ceee8d9f46c4$var$byteToHex[arr[offset + 0]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 1]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 2]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 3]] + '-' + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 4]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 5]] + '-' + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 6]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 7]] + '-' + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 8]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 9]] + '-' + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 10]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 11]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 12]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 13]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 14]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $8df89a4d60889f85$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $ee13ceee8d9f46c4$export$2e2bcd8739ae039 = $ee13ceee8d9f46c4$var$stringify;


function $6810e10b84975c3e$var$v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, $2bcaa466815aa8a5$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $ee13ceee8d9f46c4$export$2e2bcd8739ae039)(rnds);
}
var $6810e10b84975c3e$export$2e2bcd8739ae039 = $6810e10b84975c3e$var$v4;



const $f5f9da123b542c26$var$gameServiceUrl = 'https://med93mwkuc.execute-api.us-east-1.amazonaws.com/dev/apiv2';
const $f5f9da123b542c26$var$gameCommandPath = 'games/commands';
const $f5f9da123b542c26$var$gameCreatePath = 'games';
const $f5f9da123b542c26$var$gamesPath = 'games';
const $f5f9da123b542c26$var$randomCardPath = 'games/decks/sw/cards/random';
const $f5f9da123b542c26$export$96d3abf11742854f = (game)=>{
    const path = {
        [(0, $b498b75d9b5e135f$export$890274e3d5170b8b).OhHell]: '/ohhell',
        [(0, $b498b75d9b5e135f$export$890274e3d5170b8b).WinThisGame]: '/win',
        [(0, $b498b75d9b5e135f$export$890274e3d5170b8b).Base]: ''
    }[game.gameRuleSetName];
    if (!path) throw new Error('expected a path to be defined for all possible rulesets');
    return path.concat(`?gameId=${game.gameId}`);
};
const $f5f9da123b542c26$export$919851e9ef085f96 = async (options)=>{
    return (0, $7ddfa7eb44375504$export$dc890958d2b428da).get($f5f9da123b542c26$var$gameServiceUrl, `${$f5f9da123b542c26$var$gamesPath}/ready`, options);
};
const $f5f9da123b542c26$export$f0ef3bf9dcd2773e = async (options)=>{
    return (0, $7ddfa7eb44375504$export$dc890958d2b428da).get($f5f9da123b542c26$var$gameServiceUrl, `${$f5f9da123b542c26$var$gamesPath}/mine`, options);
};
const $f5f9da123b542c26$export$7707b149e6c1007 = async (gameId, options)=>{
    return (0, $7ddfa7eb44375504$export$dc890958d2b428da).get($f5f9da123b542c26$var$gameServiceUrl, `${$f5f9da123b542c26$var$gamesPath}/${gameId}`, options);
};
const $f5f9da123b542c26$export$e5d662caddcef523 = async (gameId, options)=>{
    return (0, $7ddfa7eb44375504$export$dc890958d2b428da).deleteItem($f5f9da123b542c26$var$gameServiceUrl, `${$f5f9da123b542c26$var$gamesPath}/${gameId}`, options);
};
const $f5f9da123b542c26$export$f9a7495c0485b4ed = async (options)=>{
    return (0, $7ddfa7eb44375504$export$dc890958d2b428da).get($f5f9da123b542c26$var$gameServiceUrl, $f5f9da123b542c26$var$randomCardPath, options);
};
const $f5f9da123b542c26$export$ae6a2b2157712ea7 = async (url, options)=>{
    return (0, $7ddfa7eb44375504$export$dc890958d2b428da).getImage(url, options);
};
const $f5f9da123b542c26$export$14c67565e54181b6 = async (cmd, options)=>{
    const apiResponse = await (0, $7ddfa7eb44375504$export$dc890958d2b428da).post($f5f9da123b542c26$var$gameServiceUrl, $f5f9da123b542c26$var$gameCommandPath, cmd, options);
    if (!apiResponse) throw new Error('could not send game command');
    return apiResponse;
};
const $f5f9da123b542c26$export$5e032988b71f6158 = async (gameOptions, options)=>{
    const event = {
        cmdId: (0, $6810e10b84975c3e$export$2e2bcd8739ae039)(),
        gameRuleSetName: gameOptions.gameRuleSetName,
        cmdType: (0, $86486bb7b4b55757$export$121ef92b42134ced).Create,
        cmdData: {}
    };
    const apiResponse = await (0, $7ddfa7eb44375504$export$dc890958d2b428da).post($f5f9da123b542c26$var$gameServiceUrl, $f5f9da123b542c26$var$gameCreatePath, event, options);
    if (!apiResponse) throw new Error('could not host game');
    return apiResponse;
};
const $f5f9da123b542c26$export$f72d34273529eb62 = {
    getGameNavigationPath: $f5f9da123b542c26$export$96d3abf11742854f,
    getActiveGames: $f5f9da123b542c26$export$919851e9ef085f96,
    getOwnGames: $f5f9da123b542c26$export$f0ef3bf9dcd2773e,
    getGame: $f5f9da123b542c26$export$7707b149e6c1007,
    deleteGame: $f5f9da123b542c26$export$e5d662caddcef523,
    getRandomCard: $f5f9da123b542c26$export$f9a7495c0485b4ed,
    getCardImage: $f5f9da123b542c26$export$ae6a2b2157712ea7,
    sendCmd: $f5f9da123b542c26$export$14c67565e54181b6,
    host: $f5f9da123b542c26$export$5e032988b71f6158
};



/* eslint @typescript-eslint/ban-ts-comment: 0*/ // @ts-nocheck
// Opera 8.0+
// const isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
// import { hasUncaughtExceptionCaptureCallback } from "process";
// Firefox 1.0+
const $72dde077e274c16a$var$isFirefox = typeof InstallTrigger !== 'undefined';
// Safari 3.0+ "[object HTMLElementConstructor]"
// const isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));
// Internet Explorer 6-11
const $72dde077e274c16a$var$isIE = !!document.documentMode;
// Edge 20+
const $72dde077e274c16a$var$isEdge = !$72dde077e274c16a$var$isIE && !!window.StyleMedia;
// Chrome 1 - 71
const $72dde077e274c16a$var$isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
function $72dde077e274c16a$export$67f08a1dc9952e1e() {
    if ($72dde077e274c16a$var$isChrome || $72dde077e274c16a$var$isEdge) return 'scroll-width-webkit';
    if ($72dde077e274c16a$var$isFirefox) return 'scroll-width-firefox';
    return 'scroll-width-webkit';
}
function $72dde077e274c16a$export$135f4a39ba5738c7() {
    return `pr-${$72dde077e274c16a$export$67f08a1dc9952e1e()}`;
}




const $087b69220d91312a$export$acbba7ab47b0f200 = (options)=>{
    return {
        cmdId: (0, $6810e10b84975c3e$export$2e2bcd8739ae039)(),
        gameId: options.gameId,
        gameRuleSetName: options.gameRuleSetName,
        cmdType: (0, $86486bb7b4b55757$export$121ef92b42134ced).Join,
        cmdData: {}
    };
};
const $087b69220d91312a$export$52fd62628ec8a67c = (options)=>{
    return {
        cmdId: (0, $6810e10b84975c3e$export$2e2bcd8739ae039)(),
        gameId: options.gameId,
        gameRuleSetName: options.gameRuleSetName,
        cmdType: (0, $86486bb7b4b55757$export$121ef92b42134ced).Start,
        cmdData: {}
    };
};
const $087b69220d91312a$export$b400b51e63b0346b = (options)=>{
    return {
        cmdId: (0, $6810e10b84975c3e$export$2e2bcd8739ae039)(),
        gameId: options.gameId,
        gameRuleSetName: options.gameRuleSetName,
        cmdType: (0, $86486bb7b4b55757$export$121ef92b42134ced).Exit,
        cmdData: {}
    };
};





function $d62177e9e5b8a1fe$export$8a4d0c6f4149686a(user) {
    return user.roles.map((role)=>role.roleName);
}
function $d62177e9e5b8a1fe$export$7811f1a8180ca63(user, roleName) {
    return user.roles.some((role)=>role.roleName === roleName);
}


var $b0939690de4cdce3$export$d1d9e451800db729 = /*#__PURE__*/ function(Roles) {
    Roles["guest"] = "guest";
    Roles["user"] = "user";
    Roles["admin"] = "admin";
    return Roles;
}({});


const $f6d57640c92e77f0$export$5a5da87b6c91b285 = (game, user, handleJoinGame, handleDeleteGame)=>{
    const rowKey = `game-row-${game.gameId}`;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "flex flex-row w-full text-left py-1 flex-shrink-0 flex-grow-0",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "w-4/12",
                children: [
                    Math.round((Date.now() - new Date(game.createDate).valueOf()) / 60000),
                    ' ',
                    "min ago"
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "w-4/12",
                children: game.hostName
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "w-2/12",
                children: [
                    game.playerCount,
                    "/",
                    game.maxPlayers
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "w-2/12 flex justify-center flex-shrink-0",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        className: "m-0 px-1 border border-black",
                        type: "submit",
                        value: game.gameId,
                        onClick: handleJoinGame,
                        children: "join"
                    }),
                    (0, $d62177e9e5b8a1fe$export$7811f1a8180ca63)(user, (0, $b0939690de4cdce3$export$d1d9e451800db729).admin) ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        className: "mx-0 px-1 border border-black",
                        type: "submit",
                        value: game.gameId,
                        onClick: handleDeleteGame,
                        children: "del"
                    }) : ''
                ]
            })
        ]
    }, rowKey);
};





const $ab989dfbe6fa3ecd$export$8888c17d0e7e9485 = (game, user, handleJoinGame, handleDeleteGame)=>{
    const rowKey = `inprogress-row-${game.gameId}`;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "flex flex-row w-full text-left py-1 flex-shrink-0 flex-grow-0",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "w-4/12",
                children: [
                    Math.round((Date.now() - new Date(game.createDate).valueOf()) / 60000),
                    ' ',
                    "min ago"
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "w-4/12",
                children: game.hostName
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "w-2/12",
                children: [
                    game.playerCount,
                    "/",
                    game.maxPlayers
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "w-2/12 flex justify-center flex-shrink-0",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        className: "m-0 px-1 border border-black",
                        type: "submit",
                        value: game.gameId,
                        onClick: handleJoinGame,
                        children: "join"
                    }),
                    (0, $d62177e9e5b8a1fe$export$7811f1a8180ca63)(user, (0, $b0939690de4cdce3$export$d1d9e451800db729).admin) ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        className: "mx-0 px-1 border border-black",
                        type: "submit",
                        value: game.gameId,
                        onClick: handleDeleteGame,
                        children: "del"
                    }) : ''
                ]
            })
        ]
    }, rowKey);
};


const $4b4bd711ffee1398$var$defaultState = {
    myGames: [],
    readyGames: [],
    readyGamesLastId: '#',
    pageSize: 0,
    fetchState: 'INIT'
};
const $4b4bd711ffee1398$var$GamesTracker = ()=>{
    const user = (0, $97cadf28d7015811$export$af54d3055d90c64e).useSelector((0, $97cadf28d7015811$export$210c0a88ec4709b));
    const auth = (0, $97cadf28d7015811$export$af54d3055d90c64e).useSelector((0, $97cadf28d7015811$export$dc37312681b1d526));
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const [state, setState] = (0, $7fPBF.useState)($4b4bd711ffee1398$var$defaultState);
    const refreshActiveGames = (0, $7fPBF.useCallback)(()=>{
        if (state.fetchState === 'FETCHING') return;
        setState((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
            fetchState: 'FETCHING'
        }));
        const allGames = Promise.all([
            (0, $f5f9da123b542c26$export$f72d34273529eb62).getActiveGames(auth),
            (0, $f5f9da123b542c26$export$f72d34273529eb62).getOwnGames(auth)
        ]);
        allGames.then((result)=>{
            var _result_, _result_1;
            const myGames = ((_result_ = result[1]) === null || _result_ === void 0 ? void 0 : _result_.games) || [];
            const ownGameIdSet = new Set(myGames.map((game)=>game.gameId));
            const readyGames = (((_result_1 = result[0]) === null || _result_1 === void 0 ? void 0 : _result_1.games) || []).filter((game)=>!ownGameIdSet.has(game.gameId));
            const readyGamesLastId = result[0].lastId;
            const pageSize = result[0].pageSize;
            setState({
                myGames: myGames,
                readyGames: readyGames,
                readyGamesLastId: readyGamesLastId,
                pageSize: pageSize,
                fetchState: 'FETCHED'
            });
        }).catch((reason)=>{
            (0, $aba38a333ca575f4$export$efa9a398d6368992).debug(`error on GamesTracker init: ${reason.message || JSON.stringify(reason)}`);
            setState((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                fetchState: 'FETCHED'
            }));
        });
    }, [
        auth
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (state.fetchState === 'INIT') refreshActiveGames();
    }, [
        state,
        setState,
        refreshActiveGames
    ]);
    const handleHostGame = async (e)=>{
        e.preventDefault();
        navigate(`/host/`);
    };
    const handleRefreshTracker = async (e)=>{
        e.preventDefault();
        refreshActiveGames();
    };
    const handleJoinGame = (game)=>()=>{
            if (!game) {
                console.error('expected a game in handleJoinGame');
                return;
            }
            const path = (0, $f5f9da123b542c26$export$f72d34273529eb62).getGameNavigationPath(game);
            if (game.status === (0, $08d136cf68240767$export$23c7328964450bd2).InProgress) {
                navigate(path);
                return;
            }
            const cmd = (0, $087b69220d91312a$export$acbba7ab47b0f200)(game);
            (0, $f5f9da123b542c26$export$f72d34273529eb62).sendCmd(cmd, auth).then(()=>{
                (0, $aba38a333ca575f4$export$efa9a398d6368992).debug('joined');
                navigate(path);
            });
        };
    const handleDeleteGame = (game)=>()=>{
            const gameId = game === null || game === void 0 ? void 0 : game.gameId;
            if (!gameId) {
                console.error('expected a gameId in handleDeleteGame');
                return;
            }
            (0, $f5f9da123b542c26$export$f72d34273529eb62).deleteGame(gameId, auth).then(()=>{
                setState((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                    myGames: state.myGames.filter((game)=>game.gameId !== gameId) || [],
                    readyGames: state.readyGames.filter((game)=>game.gameId !== gameId) || []
                }));
                (0, $aba38a333ca575f4$export$efa9a398d6368992).debug('deleted');
            });
        };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "bg-classicgray-dark m-3 p-2 md:p-6 w-full md:w-6/12 rounded-md flex-col content-between",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("section", {
                className: "section",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                        children: "games tracker"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        className: "m-2 px-3 border border-black",
                        type: "submit",
                        value: "host a game",
                        onClick: handleHostGame,
                        children: "host game"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        className: "m-2 px-3 border border-black",
                        type: "submit",
                        value: "refresh",
                        onClick: handleRefreshTracker,
                        children: "refresh"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "flex flex-col h-90v md:h-60v overflow-y-scroll",
                children: [
                    !!state.myGames.length && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: `flex flex-col text-left flex-shrink-0 ${(0, $72dde077e274c16a$export$135f4a39ba5738c7)()}`,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: `flex flex-col `,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                        children: "in play"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "flex flex-row w-full text-left flex-shrink-0",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: "w-4/12",
                                                children: "created"
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: "w-4/12",
                                                children: "host"
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: "w-2/12",
                                                children: "players/max"
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: "w-2/12"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: `flex flex-col w-full text-left flex-shrink-1 scrollbar`,
                                children: state === null || state === void 0 ? void 0 : state.myGames.map((game)=>(0, $ab989dfbe6fa3ecd$export$8888c17d0e7e9485)(game, user, handleJoinGame(game), handleDeleteGame(game)))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "flex flex-col",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                children: "ready to join"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: `flex flex-col text-left flex-shrink-0 ${(0, $72dde077e274c16a$export$135f4a39ba5738c7)()}`,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "flex flex-row w-full text-left flex-shrink-0",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "w-4/12",
                                            children: "created"
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "w-4/12",
                                            children: "host"
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "w-2/12",
                                            children: "players/max"
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "w-2/12"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: `flex flex-col w-full text-left flex-shrink-1 scrollbar`,
                                children: state === null || state === void 0 ? void 0 : state.readyGames.map((game)=>(0, $f6d57640c92e77f0$export$5a5da87b6c91b285)(game, user, handleJoinGame(game), handleDeleteGame(game)))
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $4b4bd711ffee1398$export$2e2bcd8739ae039 = $4b4bd711ffee1398$var$GamesTracker;




// import GamesTracker from '../widgets/GamesTracker'
const $23d43ae99e1b6b9b$var$Lobby = ()=>{
    (0, $aba38a333ca575f4$export$efa9a398d6368992).debug('lobby render');
    const user = (0, $97cadf28d7015811$export$af54d3055d90c64e).useSelector((0, $97cadf28d7015811$export$210c0a88ec4709b));
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "container mx-auto",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("h1", {
                children: [
                    "welcome to the lobby, ",
                    user.handle
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "md:flex",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7f4e2622939e64e$export$2e2bcd8739ae039), {
                        chatRoomId: (0, $01b2e30d67ce3ce6$export$84e10d496f51e7c5).front.chatRoomId,
                        chatroomName: (0, $01b2e30d67ce3ce6$export$84e10d496f51e7c5).front.chatroomName
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4b4bd711ffee1398$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
};
var $23d43ae99e1b6b9b$export$2e2bcd8739ae039 = $23d43ae99e1b6b9b$var$Lobby;






var $7fPBF = parcelRequire("7fPBF");



const $980dafbea53ad318$var$Profile = ()=>{
    (0, $aba38a333ca575f4$export$efa9a398d6368992).debug('profile render');
    const user = (0, $97cadf28d7015811$export$af54d3055d90c64e).useSelector((0, $97cadf28d7015811$export$210c0a88ec4709b));
    const initialProfileState = {
        userId: user.userId,
        handle: user.handle,
        responseText: ''
    };
    const [profileState, setProfileState] = (0, $7fPBF.useState)(initialProfileState);
    const HandleEntryField = (0, $7fPBF.useRef)(null);
    const ResponseSpan = (0, $7fPBF.useRef)(null);
    function startResponseFadeout(delay = 2000) {
        if (!ResponseSpan || !ResponseSpan.current) return;
        ResponseSpan.current.classList.remove('opacity-0');
        ResponseSpan.current.classList.add('opacity-100');
        setTimeout(()=>{
            if (!ResponseSpan || !ResponseSpan.current) return;
            ResponseSpan.current.classList.remove('opacity-100');
            ResponseSpan.current.classList.add('opacity-0');
        }, delay);
    }
    const handleSubmit = (e)=>{
        var _HandleEntryField_current;
        e.preventDefault();
        const userHandle = HandleEntryField === null || HandleEntryField === void 0 ? void 0 : (_HandleEntryField_current = HandleEntryField.current) === null || _HandleEntryField_current === void 0 ? void 0 : _HandleEntryField_current.value;
        if (!userHandle) {
            startResponseFadeout();
            setProfileState((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, profileState), {
                responseText: 'gotta give us a name to work with, friend'
            }));
            return;
        }
        (0, $59115c410ae6cbf5$export$a65659cbf019a8b3)(userHandle);
        startResponseFadeout();
        setProfileState((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, profileState), {
            responseText: 'saved'
        }));
    };
    function getUpdater(stateFieldName) {
        return (e)=>setProfileState((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, profileState), {
                [stateFieldName]: e.target.value
            }));
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "container mx-auto",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("h1", {
                children: [
                    "tell me about yourself, ",
                    profileState.handle
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "mt-10 md:mt-20 md:flex mx-auto",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "mx-auto md:w-6/12 bg-classicgray-dark m-2 p-2 md:p-6 rounded-md",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
                        className: "biz-form",
                        onSubmit: handleSubmit,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("ul", {
                                className: "mb-10",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("li", {
                                    className: "px-1",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                            className: "inline-block text-right mr-1 w-20",
                                            htmlFor: "handleTextField",
                                            children: "Handle"
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                            className: "inline-block text-left w-1/5 pl-1",
                                            type: "text",
                                            id: "handleTextField",
                                            ref: HandleEntryField,
                                            value: profileState.handle,
                                            onChange: getUpdater('handle')
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "flex-row text-right",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                        ref: ResponseSpan,
                                        className: "inline-block m-2 px-3 transition-all duration-1000 ease-in-out",
                                        children: profileState.responseText
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                        className: "inline-block m-2 px-3 border-2 border-black",
                                        type: "submit",
                                        value: "save",
                                        children: "save"
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var $980dafbea53ad318$export$2e2bcd8739ae039 = $980dafbea53ad318$var$Profile;






var $7fPBF = parcelRequire("7fPBF");



const $e6f11aad72bc1edc$var$Nothing = ()=>{
    const [state, setState] = (0, $7fPBF.useState)({});
    console.info(`loading nowhere with state ${JSON.stringify(state)}`);
    const getCardState = (0, $7fPBF.useCallback)(async ()=>{
        try {
            if (!state.lastCardRequest || Date.now() - state.lastCardRequest.getTime() < 1000) {
                const lastCardRequest = new Date();
                const card = await (0, $f5f9da123b542c26$export$f72d34273529eb62).getRandomCard((0, $0c9ab1c6c858b47d$export$d69db95f4df4095d));
                const cardImage = await (0, $f5f9da123b542c26$export$f72d34273529eb62).getCardImage(card.smallUrl, (0, $0c9ab1c6c858b47d$export$d69db95f4df4095d));
                const cardImageLocation = URL.createObjectURL(cardImage);
                setState({
                    card: card,
                    cardImage: cardImage,
                    cardImageLocation: cardImageLocation,
                    lastCardRequest: lastCardRequest
                });
            }
        } catch (err) {
            (0, $aba38a333ca575f4$export$efa9a398d6368992).debug(`got an error when i tried to get a card: ${JSON.stringify(err)}`);
        }
    }, [
        state
    ]);
    (0, $7fPBF.useEffect)(()=>{
        getCardState();
    }, []);
    function getCardDescription(card) {
        if (!card.suit.suitName) return '';
        return card.suit.suitName === 'trumps' ? card.cardValueName : `${card.cardValueName} of ${card.suit.suitName}`;
    }
    if (state.error) {
        (0, $aba38a333ca575f4$export$2a283cfcdfa3d711)(state.error.message);
        setState((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
            error: undefined
        }));
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "text-center",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                onClick: ()=>setState((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                        error: new Error('nowhere')
                    })),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                    children: "nada"
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: "this is the nothing component route. you are nowhere."
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                children: state.card && state.cardImageLocation ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                    className: "mx-auto",
                    src: state.cardImageLocation,
                    alt: getCardDescription(state.card),
                    crossOrigin: "anonymous"
                }) : null
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                children: state.card ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                    children: getCardDescription(state.card)
                }) : null
            })
        ]
    });
};
var $e6f11aad72bc1edc$export$2e2bcd8739ae039 = $e6f11aad72bc1edc$var$Nothing;




var $7fPBF = parcelRequire("7fPBF");






const $22e14437cf5ff2dc$export$a0d683d9311c8b4b = (options)=>{
    return {
        cmdId: (0, $6810e10b84975c3e$export$2e2bcd8739ae039)(),
        gameId: options.gameId,
        gameRuleSetName: (0, $b498b75d9b5e135f$export$890274e3d5170b8b).WinThisGame,
        cmdType: (0, $f954a6ee3393cf06$export$d7398a4842a89c0a).Win,
        cmdData: {}
    };
};






const $56dafa00af6a4d90$var$gameRuleSetName = (0, $b498b75d9b5e135f$export$890274e3d5170b8b).WinThisGame;
const $56dafa00af6a4d90$var$Win = ()=>{
    const context = (0, $7fPBF.useContext)((0, $7444594dc418e4bf$export$122994dc05ba4308));
    const connection = (0, $97cadf28d7015811$export$af54d3055d90c64e).useActorRef();
    const user = (0, $97cadf28d7015811$export$af54d3055d90c64e).useSelector((0, $97cadf28d7015811$export$210c0a88ec4709b));
    const auth = (0, $97cadf28d7015811$export$af54d3055d90c64e).useSelector((0, $97cadf28d7015811$export$dc37312681b1d526));
    const location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    const [state, setState] = (0, $7fPBF.useState)(location.state);
    const gameId = state.gameId;
    const gameMessageClientId = gameId ? (0, $b93fbb979342838e$export$75df8273cd15a834)((0, $b93fbb979342838e$export$ff0f8bd07799254c).game, gameId) : '';
    const setStatusFromGame = (0, $7fPBF.useCallback)((game)=>{
        const gameState = game === null || game === void 0 ? void 0 : game.gameState;
        const score = (gameState === null || gameState === void 0 ? void 0 : gameState.score) || [];
        const newState = {
            winnerUserHandle: undefined,
            winnerUserId: undefined,
            gameStatus: game.status,
            hostUserId: game.hostUserId,
            hostHandle: game.hostHandle,
            gameId: game.gameId
        };
        if ((0, $08d136cf68240767$export$23c7328964450bd2).Complete && score.length) {
            const highScoringPlayerScore = score.reduce((winner, next)=>{
                return !winner || winner.score > next.score ? winner : next;
            }, score[0]);
            const highScoringPlayer = game.players.find((player)=>player.userId === highScoringPlayerScore.playerId);
            if (game.status === (0, $08d136cf68240767$export$23c7328964450bd2).Complete) {
                (0, $aba38a333ca575f4$export$efa9a398d6368992).debug(`highscoring player score is ${JSON.stringify(highScoringPlayerScore)}
                    with player ${JSON.stringify(highScoringPlayer)}`);
                (0, $aba38a333ca575f4$export$efa9a398d6368992).debug(`all players were ${JSON.stringify(game.players)}`);
            }
            newState.winnerUserHandle = (highScoringPlayer === null || highScoringPlayer === void 0 ? void 0 : highScoringPlayer.handle) || undefined;
            newState.winnerUserId = (highScoringPlayer === null || highScoringPlayer === void 0 ? void 0 : highScoringPlayer.userId) || undefined;
        }
        setState(newState);
    }, []);
    const onGameMessage = (0, $7fPBF.useCallback)((message)=>{
        const gameMessage = message.channel === (0, $b93fbb979342838e$export$ff0f8bd07799254c).game ? message.data : undefined;
        if (!gameMessage) // TODO this check should happen in subscription
        return;
        (0, $aba38a333ca575f4$export$efa9a398d6368992).debug(`got game message ${JSON.stringify(gameMessage)}`);
        setStatusFromGame(gameMessage);
    }, [
        setStatusFromGame
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (gameId && !state.gameStatus) (0, $f5f9da123b542c26$export$f72d34273529eb62).getGame(gameId, auth).then((game)=>{
            setStatusFromGame(game);
        });
    }, [
        auth
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!gameId) return ()=>{};
        (0, $aba38a333ca575f4$export$efa9a398d6368992).debug('subscribing to game');
        const client = {
            clientId: gameMessageClientId,
            callback: onGameMessage,
            channels: [
                {
                    channel: (0, $b93fbb979342838e$export$ff0f8bd07799254c).game,
                    topic: gameId
                }
            ]
        };
        connection.send({
            type: 'SOCKET_SUBSCRIBE',
            value: client
        });
        return ()=>{
            (0, $aba38a333ca575f4$export$efa9a398d6368992).debug('unsubscribing to game');
            connection.send({
                type: 'SOCKET_UNSUBSCRIBE',
                value: gameMessageClientId
            });
        };
    }, [
        context,
        onGameMessage,
        gameMessageClientId
    ]);
    if (!gameId) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                children: "oh weird"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: "not sure what happened, but it's not clear which game you're trying to play"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: "maybe hit up the lobby, i guess"
            })
        ]
    });
    const handleStartGame = async (e)=>{
        e.preventDefault();
        const cmd = (0, $087b69220d91312a$export$52fd62628ec8a67c)({
            gameId: gameId,
            gameRuleSetName: $56dafa00af6a4d90$var$gameRuleSetName
        });
        await (0, $f5f9da123b542c26$export$f72d34273529eb62).sendCmd(cmd, auth);
    };
    const handleWinGame = async (e)=>{
        e.preventDefault();
        const cmd = (0, $22e14437cf5ff2dc$export$a0d683d9311c8b4b)({
            gameId: gameId
        });
        await (0, $f5f9da123b542c26$export$f72d34273529eb62).sendCmd(cmd, auth);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("h1", {
                children: [
                    "WIN GAME ",
                    gameId
                ]
            }),
            state.gameStatus === (0, $08d136cf68240767$export$23c7328964450bd2).Ready && user.userId !== state.hostUserId && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "text-center text-xl m-5",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("span", {
                    children: [
                        "waiting for ",
                        state.hostHandle,
                        " to start the game"
                    ]
                })
            }, "wait for host"),
            state.gameStatus === (0, $08d136cf68240767$export$23c7328964450bd2).Ready && user.userId === state.hostUserId && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "text-center text-xl m-5",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                    className: "p-3 m-3 text-larger border-black border-2 text-center",
                    type: "submit",
                    onClick: handleStartGame,
                    children: "start the game"
                })
            }, "start button"),
            state.gameStatus === (0, $08d136cf68240767$export$23c7328964450bd2).InProgress && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "text-center text-xl m-5",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            children: "to push is to win"
                        })
                    }, "instructions"),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            className: "p-3 m-3 text-larger border-black border-2 text-center",
                            type: "submit",
                            onClick: handleWinGame,
                            children: "PUSH BUTTON"
                        })
                    }, "win button")
                ]
            }),
            state.gameStatus === (0, $08d136cf68240767$export$23c7328964450bd2).Complete && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "text-center text-xl m-5",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        role: "img",
                        "aria-label": "PARTY PARTY PARTY",
                        children: "\uD83C\uDF89\uD83C\uDF89\uD83C\uDF89\uD83C\uDF89\uD83C\uDF89\uD83C\uDF89\uD83C\uDF89\uD83C\uDF89"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("h1", {
                        children: [
                            "winner is ",
                            state.winnerUserHandle
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        role: "img",
                        "aria-label": "PARTY PARTY PARTY",
                        children: "\uD83C\uDF89\uD83C\uDF89\uD83C\uDF89\uD83C\uDF89\uD83C\uDF89\uD83C\uDF89\uD83C\uDF89\uD83C\uDF89"
                    })
                ]
            }, "congrats"),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {})
        ]
    });
};
var $56dafa00af6a4d90$export$2e2bcd8739ae039 // gameplay component for win-this-game
 = $56dafa00af6a4d90$var$Win;





var $7fPBF = parcelRequire("7fPBF");




function $43424e6e7309dcf2$var$buildNonLoginPath(pathname, search) {
    if (pathname.toUpperCase() === '/LOGIN') return '/';
    return pathname.concat(search);
}
function $43424e6e7309dcf2$var$RequireAuth({ children: children }) {
    const isAuthorized = (0, $97cadf28d7015811$export$af54d3055d90c64e).useSelector((0, $97cadf28d7015811$export$3283fab48c574712));
    const connection = (0, $97cadf28d7015811$export$af54d3055d90c64e).useSelector((state)=>state);
    const context = (0, $7fPBF.useContext)((0, $7444594dc418e4bf$export$122994dc05ba4308));
    const { pathname: pathname, search: search } = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    const url = $43424e6e7309dcf2$var$buildNonLoginPath(pathname, search);
    context.setTargetPath(url);
    (0, $aba38a333ca575f4$export$efa9a398d6368992).debug(`caching path ${context.getTargetPath()}`);
    if (!isAuthorized) {
        (0, $aba38a333ca575f4$export$efa9a398d6368992).debug(`RequireAuth says not authorized: ${JSON.stringify(connection.value)}, redirecting to login`);
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$444b3ab0cb9aec40), {
            to: "/login"
        });
    }
    return children;
}
var $43424e6e7309dcf2$export$2e2bcd8739ae039 = $43424e6e7309dcf2$var$RequireAuth;






var $7fPBF = parcelRequire("7fPBF");












const $b59da26f9964ad5a$var$validChars = [
    ...Array.from(new Array(26), (x, i)=>String.fromCharCode('A'.charCodeAt(0) + i % 26)),
    ...Array.from(new Array(26), (x, i)=>String.fromCharCode('a'.charCodeAt(0) + i % 26)),
    ...Array.from(new Array(10), (x, i)=>String.fromCharCode('0'.charCodeAt(0) + i % 10))
].filter((c)=>![
        'o',
        'O'
    ].includes(c));
const $b59da26f9964ad5a$export$59af1c4deb0894c4 = (magicLinkEntry)=>{
    const rawKeyGroupLength = 5;
    const keyGroupLength = rawKeyGroupLength - 1;
    const numKeyGroups = 4;
    const keyValuesOnly = magicLinkEntry.replace(/[^0-9a-np-zA-OP-Z]/gi, '');
    const rawKeyGroups = [];
    for(let i = 0; i < rawKeyGroupLength * numKeyGroups; i += rawKeyGroupLength)rawKeyGroups.push(keyValuesOnly.slice(i, i + rawKeyGroupLength));
    const keyOnly = rawKeyGroups.map((rawKeyGroup)=>rawKeyGroup.slice(0, keyGroupLength)).join('');
    const keyGroupStatuses = rawKeyGroups.map((rawKeyGroup)=>$b59da26f9964ad5a$var$getModulo60CheckCharacter(rawKeyGroup.substring(0, rawKeyGroup.length - 1)) === rawKeyGroup.slice(-1));
    (0, $aba38a333ca575f4$export$efa9a398d6368992).debug(`keyOnly is ${keyOnly}`);
    return {
        authCode: keyOnly,
        keyGroupStatuses: keyGroupStatuses,
        isPostReady: keyOnly.length === numKeyGroups * keyGroupLength && keyGroupStatuses.every((keyGroupStatus)=>!!keyGroupStatus),
        redemptionInFlight: false
    };
};
const $b59da26f9964ad5a$export$5a4565e8c5233d51 = async (email, deviceCode)=>{
    if (!deviceCode) throw new Error('can not request auth without deviceCode');
    if (!email) throw new Error('can not request auth without email');
    const request = {
        email: email,
        deviceCode: deviceCode
    };
    await (0, $0c9ab1c6c858b47d$export$299ba2dee77727e9)((0, $0ad3711e2390627b$export$fe0294c75de58802), (0, $0ad3711e2390627b$export$ca60928511fee483), request, {
        noAuthorization: true
    });
};
const $b59da26f9964ad5a$export$f7361f0b00358d26 = async (email, deviceCode, handle)=>{
    if (!deviceCode) throw new Error('can not request auth without deviceCode');
    if (!email) throw new Error('can not request auth without email');
    if (!handle) throw new Error('can not request auth without handle');
    const request = {
        handle: handle,
        email: email,
        deviceCode: deviceCode
    };
    await (0, $7ddfa7eb44375504$export$dc890958d2b428da).post((0, $0ad3711e2390627b$export$fe0294c75de58802), (0, $0ad3711e2390627b$export$88fb49dac348ef8e), request, {
        noAuthorization: true
    });
};
const $b59da26f9964ad5a$export$f0ab9fb43ae770d7 = async (email, authCode)=>{
    const deviceCode = (0, $033df157c314480c$export$8ff70dd3d41bfa4e)();
    if (!deviceCode) throw new Error('can not request auth without deviceCode');
    if (!email) throw new Error('can not request auth without email');
    if (!authCode) throw new Error('can not request auth without authCode');
    const request = {
        email: email,
        authCode: authCode,
        deviceCode: deviceCode
    };
    const sessionResponse = await (0, $7ddfa7eb44375504$export$dc890958d2b428da).post((0, $0ad3711e2390627b$export$fe0294c75de58802), (0, $0ad3711e2390627b$export$6a54539c821f69c4), request, {
        noAuthorization: true
    });
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, sessionResponse), {
        authSource: (0, $0ad3711e2390627b$export$38b05b4ee2d2caef).magicLink
    });
};
function $b59da26f9964ad5a$var$getCodeGroupValue(codeGroup) {
    return Array.from(codeGroup).map((char)=>$b59da26f9964ad5a$var$validChars.indexOf(char)).reduce((sum, next)=>{
        return sum + next;
    }, 0);
}
function $b59da26f9964ad5a$var$getModulo60CheckCharacter(codeGroup) {
    const moduloValue = $b59da26f9964ad5a$var$getCodeGroupValue(codeGroup) % $b59da26f9964ad5a$var$validChars.length;
    return $b59da26f9964ad5a$var$validChars[($b59da26f9964ad5a$var$validChars.length - moduloValue) % $b59da26f9964ad5a$var$validChars.length];
}






var $20dc0d100ee0f619$var$PageModes = /*#__PURE__*/ function(PageModes) {
    PageModes[PageModes["initial"] = 0] = "initial";
    PageModes[PageModes["continueAsGuest"] = 1] = "continueAsGuest";
    PageModes[PageModes["continueNewUser"] = 2] = "continueNewUser";
    PageModes[PageModes["continueViaEmail"] = 3] = "continueViaEmail";
    PageModes[PageModes["emailHasBeenSent"] = 4] = "emailHasBeenSent";
    PageModes[PageModes["enterMagicLinkCode"] = 5] = "enterMagicLinkCode";
    PageModes[PageModes["inboundMagicLink"] = 6] = "inboundMagicLink";
    return PageModes;
}($20dc0d100ee0f619$var$PageModes || {});
var $20dc0d100ee0f619$var$ReducerOptions = /*#__PURE__*/ function(ReducerOptions) {
    ReducerOptions["error"] = "error";
    ReducerOptions["parseUrlComplete"] = "parseUrlComplete";
    ReducerOptions["initGuest"] = "initGuest";
    ReducerOptions["initNewUser"] = "initNewUser";
    ReducerOptions["initEmailLogin"] = "initEmailLogin";
    ReducerOptions["emailSent"] = "emailSent";
    ReducerOptions["setUser"] = "setUser";
    ReducerOptions["setHandle"] = "setHandle";
    ReducerOptions["setEmail"] = "setEmail";
    ReducerOptions["setMagicLinkCode"] = "setMagicLinkCode";
    ReducerOptions["promptForMagicLinkCode"] = "promptForMagicLinkCode";
    ReducerOptions["inboundMagicLink"] = "inboundMagicLink";
    ReducerOptions["redeemingMagicLink"] = "redeemingMagicLink";
    return ReducerOptions;
}($20dc0d100ee0f619$var$ReducerOptions || {});
const $20dc0d100ee0f619$var$initialState = {
    urlParsed: false,
    user: {
        email: '',
        handle: ''
    },
    errorMessage: '',
    pageMode: 0,
    magicLinkEntry: '',
    magicLinkState: {
        authCode: '',
        keyGroupStatuses: [],
        isPostReady: false,
        redemptionInFlight: false
    }
};
const $20dc0d100ee0f619$var$loginStateReducer = (state, action)=>{
    (0, $aba38a333ca575f4$export$efa9a398d6368992).debug(`loginState reducer executing with state ${JSON.stringify(state)} action ${JSON.stringify(action)}`);
    switch(action.type){
        case "error":
            {
                const data = action.data;
                (0, $aba38a333ca575f4$export$efa9a398d6368992).error(`Login error: ${data.errorMessage || 'unknown error in reducer'}`);
                return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                    errorMessage: data.errorMessage || 'unknown error in reducer'
                });
            }
        case "parseUrlComplete":
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                urlParsed: true
            });
        case "initGuest":
            {
                const data = action.data;
                return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                    user: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state.user, data.user || {}),
                    pageMode: 1,
                    errorMessage: ''
                });
            }
        case "initNewUser":
            {
                const data = action.data;
                return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                    user: data.user,
                    pageMode: 2,
                    errorMessage: ''
                });
            }
        case "initEmailLogin":
            {
                const data = action.data;
                return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                    user: data.user,
                    pageMode: 3,
                    errorMessage: ''
                });
            }
        case "emailSent":
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                pageMode: 4,
                errorMessage: ''
            });
        case "promptForMagicLinkCode":
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                pageMode: 5,
                errorMessage: ''
            });
        case "setUser":
            {
                const data = action.data;
                if (!data.user) {
                    (0, $aba38a333ca575f4$export$efa9a398d6368992).error('did not specify user when setting user');
                    return state;
                }
                return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                    user: data.user,
                    errorMessage: ''
                });
            }
        case "setHandle":
            {
                const data = action.data;
                if (!data.handle || typeof data.handle !== 'string') {
                    (0, $aba38a333ca575f4$export$efa9a398d6368992).error(`did not specify handle when setting handle ${JSON.stringify(action)} ${typeof data.handle} `);
                    return state;
                }
                return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                    user: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state.user), {
                        handle: data.handle
                    }),
                    errorMessage: ''
                });
            }
        case "setEmail":
            {
                const data = action.data;
                if (!data.email && data.email !== '' || typeof data.email !== 'string') {
                    (0, $aba38a333ca575f4$export$efa9a398d6368992).error(`did not specify email when setting email ${JSON.stringify(action)} ${typeof data.handle} `);
                    return state;
                }
                return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                    user: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state.user || {
                        userId: '',
                        handle: '',
                        pronouns: (0, $a9bcab544e716c31$export$53b73d8fd52108b8).They
                    }), {
                        email: data.email
                    }),
                    errorMessage: ''
                });
            }
        case "setMagicLinkCode":
            {
                const data = action.data;
                if (!data.magicLinkState) {
                    (0, $aba38a333ca575f4$export$efa9a398d6368992).error(`did not specify magicLinkState`);
                    return state;
                }
                const magicLinkEntry = data.magicLinkEntry;
                const magicLinkState = data.magicLinkState;
                return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                    magicLinkEntry: magicLinkEntry,
                    magicLinkState: magicLinkState,
                    errorMessage: ''
                });
            }
        case "inboundMagicLink":
            {
                const data = action.data;
                if (!data.code || !data.email) {
                    (0, $aba38a333ca575f4$export$efa9a398d6368992).error('malformed magic link');
                    return state;
                }
                return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                    urlParsed: true,
                    pageMode: 6,
                    user: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state.user), {
                        email: data.email
                    }),
                    magicLinkState: {
                        authCode: data.code,
                        keyGroupStatuses: [],
                        isPostReady: true,
                        redemptionInFlight: false
                    }
                });
            }
        case "redeemingMagicLink":
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                magicLinkState: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state.magicLinkState), {
                    redemptionInFlight: true
                })
            });
    }
    return state;
};
const $20dc0d100ee0f619$var$Login = ()=>{
    var _state_user, _state_magicLinkState;
    (0, $aba38a333ca575f4$export$efa9a398d6368992).debug('login function entry');
    const [state, dispatch] = (0, $7fPBF.useReducer)($20dc0d100ee0f619$var$loginStateReducer, $20dc0d100ee0f619$var$initialState);
    const appContext = (0, $7fPBF.useContext)((0, $7444594dc418e4bf$export$122994dc05ba4308));
    const connection = (0, $97cadf28d7015811$export$af54d3055d90c64e).useActorRef();
    const isAuthorized = (0, $97cadf28d7015811$export$af54d3055d90c64e).useSelector((0, $97cadf28d7015811$export$3283fab48c574712), (0, $83b16362225de870$export$d36bdfa510afb180));
    const deviceCode = (0, $97cadf28d7015811$export$af54d3055d90c64e).useSelector((0, $97cadf28d7015811$export$83a0b2c8b56b6a6e));
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    (0, $aba38a333ca575f4$export$efa9a398d6368992).debug(`login function executing with state ${JSON.stringify(state)} }`);
    const setValidConnection = (0, $7fPBF.useCallback)((authClient)=>{
        (0, $aba38a333ca575f4$export$efa9a398d6368992).debug('in setValidConnection setting connection to valid');
        connection.send({
            type: 'AUTH_RESPONSE_RECEIVED',
            value: authClient
        });
        (0, $aba38a333ca575f4$export$efa9a398d6368992).debug('in setValidConnection raised AUTH_RESPONSE_RECEIVED');
    }, [
        connection,
        (0, $033df157c314480c$export$bda481e852aceef9),
        (0, $033df157c314480c$export$40e2ef2cb1e7c393)
    ]);
    const continueToDestination = (0, $7fPBF.useCallback)(()=>{
        (0, $aba38a333ca575f4$export$efa9a398d6368992).debug('navigating...');
        const destination = appContext.getTargetPath();
        appContext.setTargetPath(null);
        (0, $aba38a333ca575f4$export$efa9a398d6368992).debug(`moving to ${destination}`);
        navigate(destination);
    }, [
        appContext,
        navigate
    ]);
    const continueFromMagicLink = (0, $7fPBF.useCallback)(()=>{
        var _state_user;
        (0, $aba38a333ca575f4$export$efa9a398d6368992).debug(`redeeming magic link....`);
        dispatch({
            type: "redeemingMagicLink",
            data: {}
        });
        (0, $b59da26f9964ad5a$export$f0ab9fb43ae770d7)((_state_user = state.user) === null || _state_user === void 0 ? void 0 : _state_user.email, state.magicLinkState.authCode).then((result)=>{
            setValidConnection(result);
        // continueToDestination()
        }).catch((ex)=>{
            dispatch({
                type: "error",
                data: {
                    errorMessage: ex.message || 'Unknown error while redeeming magic link.  Please try again.'
                }
            });
        });
    }, [
        state,
        setValidConnection,
        (0, $b59da26f9964ad5a$export$f0ab9fb43ae770d7),
        dispatch
    ]);
    const ResponseSpan = (0, $7fPBF.useRef)(null);
    function startResponseFadeout(delay = 2000) {
        if (!ResponseSpan || !ResponseSpan.current) return;
        ResponseSpan.current.classList.remove('opacity-0');
        ResponseSpan.current.classList.add('opacity-100');
        setTimeout(()=>{
            if (!ResponseSpan || !ResponseSpan.current) return;
            ResponseSpan.current.classList.remove('opacity-100');
            ResponseSpan.current.classList.add('opacity-0');
            setTimeout(()=>{});
        }, delay);
    }
    (0, $7fPBF.useEffect)(()=>{
        if (state.errorMessage) startResponseFadeout();
    }, [
        state.errorMessage
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (isAuthorized) {
            (0, $aba38a333ca575f4$export$efa9a398d6368992).debug('useEffect - continuing to destination');
            continueToDestination();
        }
    }, [
        isAuthorized,
        continueToDestination
    ]);
    (0, $7fPBF.useEffect)(()=>{
        var _state_user, _state_magicLinkState;
        if (state.magicLinkState.isPostReady && ((_state_user = state.user) === null || _state_user === void 0 ? void 0 : _state_user.email) && !((_state_magicLinkState = state.magicLinkState) === null || _state_magicLinkState === void 0 ? void 0 : _state_magicLinkState.redemptionInFlight)) continueFromMagicLink();
    }, [
        state.magicLinkState.isPostReady,
        (_state_user = state.user) === null || _state_user === void 0 ? void 0 : _state_user.email,
        (_state_magicLinkState = state.magicLinkState) === null || _state_magicLinkState === void 0 ? void 0 : _state_magicLinkState.redemptionInFlight,
        continueFromMagicLink
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!state.urlParsed) {
            const query = new URLSearchParams(location.search);
            const email = query.get('email');
            const code = query.get('code');
            if (!email && !code) dispatch({
                type: "parseUrlComplete",
                data: {}
            });
            if (email && !code || code && !email) dispatch({
                type: "error",
                data: {
                    errorMessage: 'Magic link was corrupted; needs to provide both email and auth code'
                }
            });
            if (email && code) dispatch({
                type: "inboundMagicLink",
                data: {
                    email: email,
                    code: code
                }
            });
        }
    }, [
        state.urlParsed,
        dispatch
    ]);
    function beginGuestLogin() {
        if (!state.user.handle) {
            (0, $59115c410ae6cbf5$export$db40b73adfa065e8)().then((handle)=>dispatch({
                    type: "initGuest",
                    data: {
                        user: {
                            handle: handle
                        }
                    }
                })).catch((ex)=>dispatch({
                    type: "error",
                    data: {
                        errorMessage: ex.message
                    }
                }));
            return;
        } else dispatch({
            type: "initGuest",
            data: {}
        });
    }
    function continueAsGuest() {
        var _state_user, _state_user1;
        if (!((_state_user = state.user) === null || _state_user === void 0 ? void 0 : _state_user.handle)) return dispatch({
            type: "error",
            data: {
                errorMessage: 'can not continue as guest without handle'
            }
        });
        (0, $59115c410ae6cbf5$export$efbf511f9a384bf6)(deviceCode, (_state_user1 = state.user) === null || _state_user1 === void 0 ? void 0 : _state_user1.handle).then((result)=>{
            setValidConnection(result);
        // continueToDestination()
        }).catch((ex)=>{
            return dispatch({
                type: "error",
                data: {
                    errorMessage: ex.message
                }
            });
        });
    }
    function beginCreateAccount() {
        dispatch({
            type: "initNewUser",
            data: {}
        });
    }
    function beginMagicLinkLogin() {
        dispatch({
            type: "initEmailLogin",
            data: {}
        });
    }
    async function getDifferentRandomName() {
        return (0, $59115c410ae6cbf5$export$db40b73adfa065e8)().then((handle)=>{
            dispatch({
                type: "setHandle",
                data: {
                    handle: handle
                }
            });
        }).catch((ex)=>{
            dispatch({
                type: "error",
                data: {
                    errorMessage: ex.message || 'unknown error occurred'
                }
            });
        });
    }
    function updateHandle(e) {
        const handleValue = e.target.value || '';
        dispatch({
            type: "setHandle",
            data: {
                handle: handleValue
            }
        });
    }
    function updateEmail(e) {
        const emailValue = e.target.value || '';
        dispatch({
            type: "setEmail",
            data: {
                email: emailValue
            }
        });
    }
    function updateMagicLinkEntry(e) {
        const magicLinkEntry = e.target.value || '';
        const magicLinkState = (0, $b59da26f9964ad5a$export$59af1c4deb0894c4)(magicLinkEntry);
        (0, $aba38a333ca575f4$export$efa9a398d6368992).debug(JSON.stringify(magicLinkState));
        dispatch({
            type: "setMagicLinkCode",
            data: {
                magicLinkEntry: magicLinkEntry,
                magicLinkState: magicLinkState
            }
        });
    }
    function requestMagicLinkNewUser() {
        (0, $b59da26f9964ad5a$export$f7361f0b00358d26)(state.user.email, deviceCode, state.user.handle).then(()=>{
            dispatch({
                type: "emailSent",
                data: {}
            });
        }).catch((ex)=>{
            dispatch({
                type: "error",
                data: {
                    errorMessage: ex.message
                }
            });
        });
    }
    function requestMagicLinkEmail() {
        if (!state.user) {
            (0, $aba38a333ca575f4$export$efa9a398d6368992).debug(`WIP: can not request magic link if user is not defined`);
            return;
        }
        (0, $b59da26f9964ad5a$export$5a4565e8c5233d51)(state.user.email, deviceCode).then(()=>dispatch({
                type: "emailSent",
                data: {}
            })).catch((ex)=>{
            if ((0, (/*@__PURE__*/$parcel$interopDefault($c6ba0193c6fadd6f$exports))).isAxiosError(ex)) {
                var _ex_response;
                const serverMessage = (_ex_response = ex.response) === null || _ex_response === void 0 ? void 0 : _ex_response.data // error: "Bad Request" message:  "user for email address not found" statusCode : 400
                ;
                dispatch({
                    type: "error",
                    data: {
                        errorMessage: serverMessage.message
                    }
                });
                return;
            }
            dispatch({
                type: "error",
                data: {
                    errorMessage: ex.message
                }
            });
        });
    }
    function enterMagicLinkCode() {
        dispatch({
            type: "promptForMagicLinkCode",
            data: {}
        });
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "text-center flex flex-col items-center mb-10",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                children: "hello stranger"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "flex flex-col items-center",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    className: "my-2",
                    children: "haven't seen you here before"
                })
            }),
            state.pageMode === 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "bg-classicgray-dark my-6 p-2 md:p-6 w-full rounded-md flex flex-col items-center",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            className: "my-2 mx-4 px-2 border border-black",
                            onClick: beginGuestLogin,
                            children: "continue as guest"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            className: "my-2 mx-4 px-2 border border-black",
                            onClick: beginCreateAccount,
                            children: "create an account"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            className: "my-2 mx-4 px-2 border border-black",
                            onClick: beginMagicLinkLogin,
                            children: "login via magic link email"
                        })
                    ]
                })
            }),
            state.pageMode === 1 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "bg-classicgray-dark my-6 p-2 md:p-6 w-full rounded-md flex flex-col items-center",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            children: `how about we call you... ${state.user && state.user.handle || `... guess I'm at a loss`}`
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            className: "my-2 px-2 border border-black",
                            onClick: getDifferentRandomName,
                            children: "no, different random name, please"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            className: "my-2 px-2 border border-black",
                            onClick: continueAsGuest,
                            children: "yep, that'll do"
                        })
                    ]
                })
            }),
            state.pageMode === 2 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "bg-classicgray-dark my-6 p-2 md:p-6 w-full rounded-md flex flex-col items-center",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            children: `enter a handle`
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                            className: "text-left w-48 pl-1",
                            type: "text",
                            id: "handleTextField",
                            value: state.user && state.user.handle || '',
                            onChange: updateHandle
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            children: `enter your email address`
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                            className: "text-left w-48 pl-1",
                            type: "text",
                            id: "handleTextField",
                            value: state.user && state.user.email || '',
                            onChange: updateEmail
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            className: "my-2 px-2 border border-black",
                            onClick: requestMagicLinkNewUser,
                            children: "send me an email please"
                        })
                    ]
                })
            }),
            state.pageMode === 3 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "bg-classicgray-dark my-6 p-2 md:p-6 w-full rounded-md flex flex-col items-center",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            children: `great, let's send a magic link to your email...`
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            children: `remind me where you get your mail again?`
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                            className: "text-left w-48 pl-1",
                            type: "text",
                            id: "handleTextField",
                            value: state.user && state.user.email || '',
                            onChange: updateEmail
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            className: "my-2 px-2 border border-black",
                            onClick: requestMagicLinkEmail,
                            children: "send me an email please"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            className: "my-2 mx-4 px-2 border border-black",
                            onClick: enterMagicLinkCode,
                            children: "enter link code from email"
                        })
                    ]
                })
            }),
            state.pageMode === 4 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "bg-classicgray-dark my-6 p-2 md:p-6 w-full rounded-md flex flex-col items-center",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            children: `email with further instructions will be at your mailbox within some seconds`
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            children: `like, within ten seconds or our integration tests are fucked again`
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            children: `note that you need to click that link from within the browser you want to log in to...`
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            className: "my-2 px-2 border border-black",
                            onClick: enterMagicLinkCode,
                            children: "or else, click here to manually enter your code"
                        })
                    ]
                })
            }),
            state.pageMode === 5 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "bg-classicgray-dark my-6 p-2 md:p-6 w-full rounded-md flex flex-col items-center",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            children: `enter your email address`
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                            className: "text-left w-48 pl-1",
                            type: "text",
                            id: "handleTextField",
                            value: state.user && state.user.email || '',
                            onChange: updateEmail
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            children: `enter the code from your email`
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                            className: "text-left w-48 pl-1",
                            type: "text",
                            id: "handleTextField",
                            value: state.magicLinkEntry || '',
                            onChange: updateMagicLinkEntry
                        }),
                        state.magicLinkState.isPostReady ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            children: "code looks valid, let's assess the grade of yer hash...."
                        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            className: "my-2 px-2 border border-black",
                            onClick: requestMagicLinkEmail,
                            children: "click here to try sending another email"
                        })
                    ]
                })
            }),
            state.pageMode === 6 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "bg-classicgray-dark my-6 p-2 md:p-6 w-full rounded-md flex flex-col items-center",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        children: `I see you've clicked a magic link... logging you in...`
                    })
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                ref: ResponseSpan,
                className: "inline-block m-2 px-3 transition-all duration-1000 ease-in-out",
                children: state.errorMessage
            })
        ]
    });
};
var $20dc0d100ee0f619$export$2e2bcd8739ae039 = $20dc0d100ee0f619$var$Login;




var $7fPBF = parcelRequire("7fPBF");





const $911b334883a2df86$var$goodbyeText = (0, $fd4f404b5352696d$export$5464853d700fc7c4)([
    'next time, friend',
    "it's been fun",
    'cheers',
    'goodbye, friend'
]);
const $911b334883a2df86$var$loginMatcher = {
    auth: 'logging_in'
};
const $911b334883a2df86$var$logoutMatcher = {
    auth: 'logging_out'
};
const $911b334883a2df86$var$Logout = ()=>{
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const connectionState = (0, $97cadf28d7015811$export$af54d3055d90c64e).useSelector((state)=>state);
    const connection = (0, $97cadf28d7015811$export$af54d3055d90c64e).useActorRef();
    (0, $7fPBF.useEffect)(()=>{
        const authClient = (0, $033df157c314480c$export$76f4495f2a1cab8b)();
        setTimeout(()=>{
            const isLoggingOut = connectionState.matches($911b334883a2df86$var$logoutMatcher);
            const isLoggingIn = connectionState.matches($911b334883a2df86$var$loginMatcher);
            if (!isLoggingOut && !isLoggingIn) {
                (0, $aba38a333ca575f4$export$efa9a398d6368992).debug(`Logout: state is ${JSON.stringify(connectionState.value)} with authClient ${JSON.stringify(authClient)}`);
                connection.send({
                    type: 'LOGOUT'
                });
            }
        }, 200);
        setTimeout(()=>{
            navigate('/Login');
        }, 3000);
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "text-center",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
            children: $911b334883a2df86$var$goodbyeText
        })
    });
};
var $911b334883a2df86$export$2e2bcd8739ae039 = $911b334883a2df86$var$Logout;






var $7fPBF = parcelRequire("7fPBF");





const $98c445d6f7bf367a$var$HostGame = ()=>{
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const auth = (0, $97cadf28d7015811$export$af54d3055d90c64e).useSelector((0, $97cadf28d7015811$export$dc37312681b1d526));
    const defaultState = {
        selectedGame: (0, $b498b75d9b5e135f$export$890274e3d5170b8b).OhHell
    };
    const [state, setState] = (0, $7fPBF.useState)(defaultState);
    const setSelectedGame = (value)=>{
        if (Object.values((0, $b498b75d9b5e135f$export$890274e3d5170b8b)).includes(value)) setState((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
            selectedGame: value
        }));
    };
    const createGame = async (e)=>{
        e.preventDefault();
        if (!state.selectedGame) (0, $aba38a333ca575f4$export$efa9a398d6368992).error(`error: could not create game - no ruleset specified`);
        const game = await (0, $f5f9da123b542c26$export$f72d34273529eb62).host({
            gameRuleSetName: state.selectedGame
        }, auth);
        if (!game) {
            (0, $aba38a333ca575f4$export$efa9a398d6368992).error(`error: could not create game`);
            return;
        }
        const path = (0, $f5f9da123b542c26$export$f72d34273529eb62).getGameNavigationPath(game);
        navigate(path);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                children: "Choose game options."
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "container mx-auto max-w-md py-10 bg-classicgray-dark m-3 p-2 md:p-6 w-full md:w-6/12 rounded-md flex-col content-between",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("label", {
                            children: [
                                "Let's play:",
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    children: " "
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("select", {
                                    value: state.selectedGame,
                                    name: "selectedGame",
                                    onChange: (e)=>setSelectedGame(e.target.value),
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                        value: (0, $b498b75d9b5e135f$export$890274e3d5170b8b).OhHell,
                                        children: "Oh Hell"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "py-10",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            disabled: !state.selectedGame,
                            className: "my-2 mx-4 px-2 border border-black float-right",
                            onClick: createGame,
                            children: "Create"
                        })
                    })
                ]
            })
        ]
    });
};
var $98c445d6f7bf367a$export$2e2bcd8739ae039 = $98c445d6f7bf367a$var$HostGame;






var $7fPBF = parcelRequire("7fPBF");






const $71a1a8566b618f5d$export$829c4b56865ef99a = 'game';
const $71a1a8566b618f5d$export$623508f30360caf0 = 'help';
const $71a1a8566b618f5d$export$e6e380aa2f411931 = 'host';
const $71a1a8566b618f5d$export$3146f5ea4c252119 = (gameState, user)=>{
    var _gameState_players_find;
    const turnPlayerId = gameState.currentRound.turnPlayerId;
    const isMyTurn = turnPlayerId === user.userId;
    const turnPlayerHandle = ((_gameState_players_find = gameState.players.find((player)=>player.userId === turnPlayerId)) === null || _gameState_players_find === void 0 ? void 0 : _gameState_players_find.handle) || '';
    return {
        turnPlayerId: turnPlayerId,
        isMyTurn: isMyTurn,
        turnPlayerHandle: turnPlayerHandle
    };
};
function $71a1a8566b618f5d$export$5464853d700fc7c4(items) {
    return items[Math.floor(Math.random() * items.length)];
}
const $71a1a8566b618f5d$export$d84f1e30a37e52e8 = (game, cmdType, cmdData)=>({
        cmdId: (0, $6810e10b84975c3e$export$2e2bcd8739ae039)(),
        gameId: game.gameId,
        gameRuleSetName: game.gameRuleSetName,
        cmdType: cmdType,
        cmdData: cmdData
    });
const $71a1a8566b618f5d$export$196dc871aaeae306 = (currentRound)=>[
        (0, $8d3c56edba7f9068$export$c114e6986ab7a2c0).DealCards,
        (0, $8d3c56edba7f9068$export$c114e6986ab7a2c0).PlaceBid,
        (0, $8d3c56edba7f9068$export$c114e6986ab7a2c0).PlayCard
    ].find((item)=>currentRound.readyForCommands.includes(item));
const $71a1a8566b618f5d$export$987ae613d2bbcdd4 = (game)=>{
    var _game_gameState;
    const currentRound = game === null || game === void 0 ? void 0 : (_game_gameState = game.gameState) === null || _game_gameState === void 0 ? void 0 : _game_gameState.currentRound;
    const turnPlayerId = currentRound === null || currentRound === void 0 ? void 0 : currentRound.turnPlayerId;
    const computerTurnPlayer = currentRound === null || currentRound === void 0 ? void 0 : currentRound.players.find((player)=>player.userId === turnPlayerId && player.computerPlayerId);
    const cmdType = $71a1a8566b618f5d$export$196dc871aaeae306(currentRound);
    if (!computerTurnPlayer || !cmdType) return undefined;
    const cmd = $71a1a8566b618f5d$export$d84f1e30a37e52e8(game, cmdType, undefined);
    cmd.onBehalfOfPlayerId = computerTurnPlayer.userId;
    return cmd;
};
const $71a1a8566b618f5d$export$d83b8a97c979a589 = (value)=>{
    if (value === 0) return String(value);
    return value ? String(value) : '-';
};
const $71a1a8566b618f5d$export$f34c9ed2963553c7 = (trick, round)=>{
    var _round_players_find;
    if (!trick.winnerId) return '';
    const completed = trick;
    return ((_round_players_find = round.players.find((player)=>player.userId === completed.winnerId)) === null || _round_players_find === void 0 ? void 0 : _round_players_find.handle) || '';
};
const $71a1a8566b618f5d$export$c8947bfd0e2acab9 = (round)=>{
    var _round_completedTricks, _round_currentTrick;
    const isTrickComplete = ((_round_completedTricks = round.completedTricks) === null || _round_completedTricks === void 0 ? void 0 : _round_completedTricks.length) > 0 && !((_round_currentTrick = round.currentTrick) === null || _round_currentTrick === void 0 ? void 0 : _round_currentTrick.cards.length);
    const trick = isTrickComplete ? round.completedTricks[round.completedTricks.length - 1] : round.currentTrick || {
        cards: []
    };
    return {
        isTrickComplete: isTrickComplete,
        trick: trick
    };
};


const $c7a877e6228e3ef5$var$getComputerIndicator = (player)=>{
    return player.computerPlayerId || player.isComputer ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
        role: "img",
        "aria-label": "computer player",
        children: "\uD83D\uDDA5\uFE0F"
    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
        role: "img",
        "aria-label": "human player",
        children: "\u2687"
    });
};
const $c7a877e6228e3ef5$var$Roster = ({ isUserHost: isUserHost, players: players, status: status, doToggleHelp: doToggleHelp, doToggleHost: doToggleHost })=>{
    const getPlayerClassname = (player)=>{
        if (player.kickReason) return 'line-through';
        if (player.didExit) return 'line-through';
        if (player.isPlayerTurn) return 'font-bold';
        return '';
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "bg-classicgray-dark p-2 pb-1 md:p-6 m-1 w-full md:w-2/12 max-w-sm rounded-md flex flex-col",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                children: "players"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                children: (players === null || players === void 0 ? void 0 : players.map((player, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "flex-col",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "flex",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "w-7 text-center",
                                        children: $c7a877e6228e3ef5$var$getComputerIndicator(player)
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: getPlayerClassname(player),
                                        children: `${player.handle}${player.isHost ? ' (host)' : ''}`
                                    })
                                ]
                            }),
                            status === (0, $08d136cf68240767$export$23c7328964450bd2).InProgress ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "ml-5 h-5 text-xs",
                                children: [
                                    `bid  ${(0, $71a1a8566b618f5d$export$d83b8a97c979a589)(player.tricksBid)}`,
                                    " /",
                                    ' ',
                                    `won  ${(0, $71a1a8566b618f5d$export$d83b8a97c979a589)(player.tricksWon)} `,
                                    (player.netScore || player.netScore === 0) && ` score ${player.netScore}`
                                ]
                            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "h-5"
                            })
                        ]
                    }, `rosterKey${index}`))) || /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    children: "no players to display"
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "flex-1 flex flex-col-reverse",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "flex justify-center",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            className: "p-1 m-1 text-xs",
                            onClick: doToggleHelp,
                            children: "show help"
                        })
                    }),
                    isUserHost && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "flex justify-center",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            className: "p-1 m-1 text-xs",
                            onClick: doToggleHost,
                            children: "host actions"
                        })
                    })
                ]
            })
        ]
    });
};
var $c7a877e6228e3ef5$export$2e2bcd8739ae039 = $c7a877e6228e3ef5$var$Roster;







var $7fPBF = parcelRequire("7fPBF");








const $17d7ef1dc4b3dc65$export$401da802c3451ef8 = ()=>{};
const $17d7ef1dc4b3dc65$export$58659c54b0f30876 = (options)=>{
    const cmd = (0, $087b69220d91312a$export$52fd62628ec8a67c)({
        gameId: options.gameId,
        gameRuleSetName: options.gameRuleSetName
    });
    const cmdData = {};
    if (options.deckCode) cmdData.deckCode = options.deckCode;
    if (options.roundsToPlay) cmdData.rounds = options.roundsToPlay;
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, cmd), {
        cmdData: cmdData
    });
};


const $3c3bee137f6365c5$var$getRandomOpponentName = ()=>{
    const descriptors = [
        'worthless',
        'awful',
        'miserable',
        'wontlick',
        'driftless',
        'stupid',
        'pointless',
        'shifty',
        'hapless',
        'wreck-ed',
        'inconsolable',
        'dirty',
        'foul',
        'disgusting',
        'despicable',
        'mirthless',
        'riotous',
        'crumbsheet',
        'putrid',
        'crusty',
        'fragrent',
        'gaseous',
        'gropeless',
        'thankless',
        'dreary',
        'sketchy',
        'vacant'
    ];
    const names = [
        'garvin',
        'timblit',
        'wilmaw',
        'stusan',
        'sneet',
        'pamma',
        'blaiden',
        'gerald',
        'stebbin',
        'merrelle',
        'sacklet',
        'steve',
        'pudley',
        'mickwin',
        'boocha',
        'treverly',
        'charlkin',
        'gustaf',
        'kentry',
        'lenkel',
        'deen',
        'dwendel',
        'noncey',
        'ruebert'
    ];
    return `${(0, $71a1a8566b618f5d$export$5464853d700fc7c4)(descriptors)} ${(0, $71a1a8566b618f5d$export$5464853d700fc7c4)(names)}`;
};
const $3c3bee137f6365c5$var$getMaxRounds = (cards, players)=>Math.floor(cards / players);
const $3c3bee137f6365c5$var$getRoundOptions = (deckCode, game)=>{
    (0, $dddf98aa62f65ae7$export$c95ca51a280479c4)[deckCode].cards.length;
    const maxRounds = $3c3bee137f6365c5$var$getMaxRounds((0, $dddf98aa62f65ae7$export$c95ca51a280479c4)[deckCode].cards.length, game.players.length);
    if (!maxRounds || maxRounds < 1) {
        (0, $aba38a333ca575f4$export$efa9a398d6368992).warn(`maxRounds was ${JSON.stringify(maxRounds)}`);
        return [
            1
        ];
    }
    const rounds = Math.min(maxRounds, 20);
    return Array.from(Array(rounds || 12).keys()).map((val)=>val + 1);
};
const $3c3bee137f6365c5$var$Ready = (props)=>{
    const game = props.game;
    const user = (0, $97cadf28d7015811$export$af54d3055d90c64e).useSelector((0, $97cadf28d7015811$export$210c0a88ec4709b));
    const auth = (0, $97cadf28d7015811$export$af54d3055d90c64e).useSelector((0, $97cadf28d7015811$export$dc37312681b1d526));
    const [state, setState] = (0, $7fPBF.useState)({
        computerPlayerName: $3c3bee137f6365c5$var$getRandomOpponentName(),
        selectedExpert: (0, $2f6b4ba8d816453d$export$1fb280ffe73d8b88).random,
        selectedDeck: (0, $dddf98aa62f65ae7$export$3b8b72609a1ddc98).TarotSW,
        roundsToPlay: '12'
    });
    const gameState = game.gameState;
    const setSelectedExpert = (expert)=>{
        setState((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
            selectedExpert: expert
        }));
    };
    const setSelectedDeck = (selectedDeckCode)=>{
        if (selectedDeckCode) setState((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
            selectedDeck: selectedDeckCode
        }));
    };
    const setRoundsToPlay = (roundsToPlay)=>{
        setState((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
            roundsToPlay: roundsToPlay
        }));
    };
    const getNewRandomName = async ()=>{
        setState((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
            computerPlayerName: $3c3bee137f6365c5$var$getRandomOpponentName()
        }));
    };
    const joinComputerPlayer = async ()=>{
        const cmd = (0, $087b69220d91312a$export$acbba7ab47b0f200)(game);
        if (!state.computerPlayerName) {
            (0, $aba38a333ca575f4$export$efa9a398d6368992).debug('no computer name specified');
            return;
        }
        if (!state.selectedExpert) {
            (0, $aba38a333ca575f4$export$efa9a398d6368992).debug('no expert specified');
            return;
        }
        const cmdData = {
            handle: state.computerPlayerName,
            computerPlayerId: state.selectedExpert
        };
        cmd.cmdData = cmdData;
        (0, $f5f9da123b542c26$export$f72d34273529eb62).sendCmd(cmd, auth).then(()=>{
            (0, $aba38a333ca575f4$export$efa9a398d6368992).debug(`joined ${state.computerPlayerName}`);
            setState((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                computerPlayerName: $3c3bee137f6365c5$var$getRandomOpponentName()
            }));
        });
    };
    const handleStartGame = async (e)=>{
        e.preventDefault();
        const deckCode = state.selectedDeck;
        const roundsToPlay = parseInt(state.roundsToPlay) || null;
        const cmd = (0, $17d7ef1dc4b3dc65$export$58659c54b0f30876)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props.game), {
            deckCode: deckCode,
            roundsToPlay: roundsToPlay
        }));
        await (0, $f5f9da123b542c26$export$f72d34273529eb62).sendCmd(cmd, auth);
    };
    const getLabel = (value)=>{
        return ({
            [(0, $2f6b4ba8d816453d$export$1fb280ffe73d8b88).cautious]: 'cautious',
            [(0, $2f6b4ba8d816453d$export$1fb280ffe73d8b88).random]: 'random',
            [(0, $2f6b4ba8d816453d$export$1fb280ffe73d8b88).thirsty]: 'thirsty'
        })[value];
    };
    /*
            <option value={ExpertIds.cautious}>{getLabel(ExpertIdsca.}</option>
            <option value={ExpertIds.random}>random</option>
            <option value={ExpertIds.thirsty}>thirsty</option>
            */ return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "bg-classicgray-dark p-2 pb-1 m-2 md:p-6 w-full md:w-10/12 max-w-lg rounded-md flex-col",
        children: [
            user.userId === game.hostUserId && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "my-5 text-xs",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        children: "ready to start"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "my-5 mx-5 flex justify-left",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("label", {
                            children: [
                                "Choose a deck:",
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    children: " "
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("select", {
                                    value: state.selectedDeck,
                                    name: "selectedDeck",
                                    onChange: (e)=>setSelectedDeck(e.target.value),
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                            value: (0, $dddf98aa62f65ae7$export$3b8b72609a1ddc98).TarotSW,
                                            children: "Pamela Smith Tarot Deck"
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                            value: (0, $dddf98aa62f65ae7$export$3b8b72609a1ddc98).AcesHigh,
                                            children: "Dan Tek Eye Standard Deck"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "my-5 mx-5 flex justify-left",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("label", {
                            children: [
                                "How many rounds?",
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    children: " "
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("select", {
                                    value: state.roundsToPlay,
                                    onChange: (e)=>setRoundsToPlay(e.target.value),
                                    className: "w-10 text-center",
                                    children: $3c3bee137f6365c5$var$getRoundOptions(state.selectedDeck, game).map((value)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                            value: value,
                                            children: value
                                        }))
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "mt-10 mb-1 mx-5 flex justify-left",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            children: "Add a computer player?"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "my-5 mx-5 flex justify-left",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("span", {
                                children: [
                                    "How about ",
                                    state.computerPlayerName,
                                    ", a "
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("select", {
                                className: "ml-1",
                                defaultValue: state.selectedExpert,
                                name: "selectedGame",
                                onChange: (e)=>setSelectedExpert(e.target.value),
                                children: Object.keys((0, $2f6b4ba8d816453d$export$1fb280ffe73d8b88)).map((id)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                        value: id,
                                        children: getLabel(id)
                                    }, `expertOption${id}`))
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                children: "opponent?"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "my-2 flex justify-center",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                    className: "mx-1 px-1 border border-black",
                                    onClick: getNewRandomName,
                                    children: "different name"
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                    className: "mx-1 px-1 border border-black",
                                    onClick: joinComputerPlayer,
                                    children: "add"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "flex justify-center text-xl m-5",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            className: "p-3 m-3 text-larger border-black border-2 text-center",
                            type: "submit",
                            onClick: handleStartGame,
                            children: "start the game"
                        })
                    })
                ]
            }),
            user.userId !== game.hostUserId && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("span", {
                children: [
                    "waiting for host ",
                    game.hostHandle,
                    " ",
                    gameState
                ]
            })
        ]
    });
};
var $3c3bee137f6365c5$export$2e2bcd8739ae039 = $3c3bee137f6365c5$var$Ready;











const $01dea572f0f5d10a$var$ScoreWidget = (props)=>{
    if (!props.lastCompleteRound) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {});
    const round = props.lastCompleteRound;
    const players = props.players.reduce((playerMap, player)=>{
        playerMap[player.userId] = player;
        return playerMap;
    }, {});
    const getRow = (score)=>{
        const playerHandle = players[score.playerId].handle;
        const bidWon = `${(0, $71a1a8566b618f5d$export$d83b8a97c979a589)(score.bidTricks)} / ${(0, $71a1a8566b618f5d$export$d83b8a97c979a589)(score.wonTricks)}`;
        const roundScore = score.roundScore;
        const totalScore = score.netScore;
        const rowKey = `swhandle${score.playerId}`;
        return [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                children: playerHandle
            }, rowKey),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                children: bidWon
            }, `${rowKey}-won`),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                children: roundScore
            }, `${rowKey}-score`),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                children: totalScore
            }, `${rowKey}-total`)
        ];
    };
    const getTable = (scores)=>{
        const rowArray = scores.map((score)=>getRow(score));
        const header = [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "font-bold",
                children: "player"
            }, "swheaderName"),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "font-bold",
                children: "bid / won"
            }, "swheaderBidWon"),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "font-bold",
                children: "score"
            }, "swheaderRoundScore"),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "font-bold",
                children: "total"
            }, "swheaderTotal")
        ];
        return header.concat(...rowArray);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "grid grid-cols-4 gap-4 gap-y-2",
        children: getTable(round.bids)
    });
};
var $01dea572f0f5d10a$export$2e2bcd8739ae039 = $01dea572f0f5d10a$var$ScoreWidget;








const $57373b72dae59769$var$ohHellSmImages = {
    [(0, $dddf98aa62f65ae7$export$3b8b72609a1ddc98).TarotSW]: {},
    [(0, $dddf98aa62f65ae7$export$3b8b72609a1ddc98).AcesHigh]: {}
};
const $57373b72dae59769$var$imageDomain = `https://ohellimages.my-lr.net`;
const $57373b72dae59769$var$requestImage = (url)=>{
    const image = new Image();
    image.src = url;
    return image;
};
function $57373b72dae59769$var$getCardDescription(param, cardRef) {
    const card = (0, $dddf98aa62f65ae7$export$574ca6466190d4b4)((0, $dddf98aa62f65ae7$export$a1ed25fc414718b7)(param), cardRef);
    if (!card.suit.suitName) return '';
    return card.suit.suitName === 'trumps' ? card.cardValueName : `${card.cardValueName} of ${card.suit.suitName}`;
}
const $57373b72dae59769$export$673b764489494bbf = ()=>{
    if (Object.keys($57373b72dae59769$var$ohHellSmImages[(0, $dddf98aa62f65ae7$export$3b8b72609a1ddc98).TarotSW]).length > 0) return;
    (0, $aba38a333ca575f4$export$efa9a398d6368992).debug('prewarming smith');
    for(let i = 0; i < (0, $971299d4b2107ff9$export$b1accc4ae1c798c7).cards.length; i++)if (!$57373b72dae59769$var$ohHellSmImages[(0, $dddf98aa62f65ae7$export$3b8b72609a1ddc98).TarotSW][i]) {
        const imageUrl = $57373b72dae59769$var$imageDomain.concat((0, $971299d4b2107ff9$export$b1accc4ae1c798c7).cards[i].smallUrl);
        const image = $57373b72dae59769$var$requestImage(imageUrl);
        $57373b72dae59769$var$ohHellSmImages[(0, $dddf98aa62f65ae7$export$3b8b72609a1ddc98).TarotSW][i] = image;
    }
};
const $57373b72dae59769$export$fabd456b669fe9ab = ()=>{
    if (Object.keys($57373b72dae59769$var$ohHellSmImages[(0, $dddf98aa62f65ae7$export$3b8b72609a1ddc98).AcesHigh]).length > 0) return;
    (0, $aba38a333ca575f4$export$efa9a398d6368992).debug('prewarming aces high');
    for(let i = 0; i < (0, $8dea006c8e654182$export$5e183895170cab29).cards.length; i++)if (!$57373b72dae59769$var$ohHellSmImages[(0, $dddf98aa62f65ae7$export$3b8b72609a1ddc98).AcesHigh][i]) {
        const imageUrl = $57373b72dae59769$var$imageDomain.concat((0, $8dea006c8e654182$export$5e183895170cab29).cards[i].smallUrl);
        const image = $57373b72dae59769$var$requestImage(imageUrl);
        $57373b72dae59769$var$ohHellSmImages[(0, $dddf98aa62f65ae7$export$3b8b72609a1ddc98).AcesHigh][i] = image;
    }
};
const $57373b72dae59769$export$28b7351bf4b200b9 = (deckCode)=>{
    switch(deckCode){
        case (0, $dddf98aa62f65ae7$export$3b8b72609a1ddc98).AcesHigh:
            return 0, $8dea006c8e654182$export$5e183895170cab29;
        case (0, $dddf98aa62f65ae7$export$3b8b72609a1ddc98).TarotSW:
            return 0, $971299d4b2107ff9$export$b1accc4ae1c798c7;
    }
    throw new Error(`Could not find deck for deck code ${$57373b72dae59769$export$28b7351bf4b200b9}`);
};
const $57373b72dae59769$export$57ba431ca58665fc = (param, cardRef, width)=>{
    const deckCode = (0, $dddf98aa62f65ae7$export$a1ed25fc414718b7)(param);
    const deck = $57373b72dae59769$export$28b7351bf4b200b9(deckCode);
    const imageUrl = $57373b72dae59769$var$imageDomain.concat(deck.cards[cardRef].smallUrl);
    if (!$57373b72dae59769$var$ohHellSmImages[deckCode][cardRef]) {
        const image = $57373b72dae59769$var$requestImage(imageUrl);
        $57373b72dae59769$var$ohHellSmImages[deckCode][cardRef] = image;
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
        src: imageUrl,
        alt: $57373b72dae59769$var$getCardDescription(param, cardRef),
        width: width
    });
};



const $ca6ad2c19374c117$var$getCardCaption = (round, cardRef)=>{
    var _round_trumpSuit;
    const card = (0, $dddf98aa62f65ae7$export$574ca6466190d4b4)(round, cardRef);
    if (((_round_trumpSuit = round.trumpSuit) === null || _round_trumpSuit === void 0 ? void 0 : _round_trumpSuit.suitName) === card.suit.suitName) return `${card.suit.suitEmoji}${card.cardValue} - ${card.cardValueName} ${card.suit.suitEmoji}`;
    return `${card.suit.suitEmoji}${card.cardValueName || card.cardValue} of ${card.suit.suitName}${card.suit.suitEmoji}`;
};
const $ca6ad2c19374c117$var$TrickCards = (props)=>{
    var _trick_cards;
    const round = props.round;
    const { trick: trick } = (0, $71a1a8566b618f5d$export$c8947bfd0e2acab9)(round);
    const cards = trick.cards;
    const winnerId = (trick === null || trick === void 0 ? void 0 : (_trick_cards = trick.cards) === null || _trick_cards === void 0 ? void 0 : _trick_cards.length) ? (0, $8d3c56edba7f9068$export$33020c772c6fdc63)(round, trick, round.trumpSuit) : '';
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "my-5 flex",
        children: cards.map((playedCard, index)=>{
            var _round_players_find;
            const cardRef = playedCard.card;
            const playerHandle = ((_round_players_find = round.players.find((player)=>player.userId === playedCard.playerId)) === null || _round_players_find === void 0 ? void 0 : _round_players_find.handle) || '';
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "flex-col mx-3",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "flex justify-center items-center",
                        children: (0, $57373b72dae59769$export$57ba431ca58665fc)(round, cardRef, 75)
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "text-sm text-center",
                        children: $ca6ad2c19374c117$var$getCardCaption(round, cardRef)
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: `text-sm text-center ${(playedCard === null || playedCard === void 0 ? void 0 : playedCard.playerId) === winnerId ? 'font-bold' : 'py-0.5'} `,
                        children: playerHandle
                    })
                ]
            }, `handCard${index}`);
        })
    });
};
var $ca6ad2c19374c117$export$2e2bcd8739ae039 = $ca6ad2c19374c117$var$TrickCards;



const $e11ee6b306e4c4a1$var$PlayDeal = (props)=>{
    const game = props.game;
    const user = (0, $97cadf28d7015811$export$af54d3055d90c64e).useSelector((0, $97cadf28d7015811$export$210c0a88ec4709b));
    const auth = (0, $97cadf28d7015811$export$af54d3055d90c64e).useSelector((0, $97cadf28d7015811$export$dc37312681b1d526));
    const gameState = game.gameState;
    const handleDealCards = async (e)=>{
        e.preventDefault();
        const cmdData = {
            playerId: user.userId
        };
        const cmd = {
            cmdData: cmdData,
            cmdId: (0, $6810e10b84975c3e$export$2e2bcd8739ae039)(),
            gameId: game.gameId,
            gameRuleSetName: game.gameRuleSetName,
            cmdType: (0, $8d3c56edba7f9068$export$c114e6986ab7a2c0).DealCards
        };
        await (0, $f5f9da123b542c26$export$f72d34273529eb62).sendCmd(cmd, auth);
    };
    const { isMyTurn: isMyTurn, turnPlayerHandle: turnPlayerHandle } = (0, $71a1a8566b618f5d$export$3146f5ea4c252119)(gameState, user);
    const getLastCompletedRound = ()=>{
        return gameState.completedRounds[gameState.completedRounds.length - 1];
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "flex-col",
        children: [
            !isMyTurn && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "justify-center text-center font-bold",
                children: [
                    "waiting for ",
                    turnPlayerHandle,
                    " to deal"
                ]
            }),
            gameState.completedRounds.length ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "flex items-center justify-center",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ca6ad2c19374c117$export$2e2bcd8739ae039), {
                    round: getLastCompletedRound()
                })
            }) : '',
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $01dea572f0f5d10a$export$2e2bcd8739ae039), {
                lastCompleteRound: getLastCompletedRound(),
                players: game.players
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "flex justify-center mt-20",
                children: isMyTurn && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                    className: "p-3 m-3 text-larger border-black border-2 text-center",
                    type: "submit",
                    onClick: handleDealCards,
                    children: [
                        "Deal Round ",
                        gameState.currentRound.roundNumber
                    ]
                })
            })
        ]
    });
};
var $e11ee6b306e4c4a1$export$2e2bcd8739ae039 = $e11ee6b306e4c4a1$var$PlayDeal;












const $c66e8c61fdc94721$var$getCardCaption = (round, cardRef)=>{
    var _round_trumpSuit;
    const card = (0, $dddf98aa62f65ae7$export$574ca6466190d4b4)(round, cardRef);
    if (((_round_trumpSuit = round.trumpSuit) === null || _round_trumpSuit === void 0 ? void 0 : _round_trumpSuit.suitName) === card.suit.suitName) return `${card.suit.suitEmoji}${card.cardValue} - ${card.cardValueName} ${card.suit.suitEmoji}`;
    return `${card.suit.suitEmoji}${card.cardValueName || card.cardValue} of ${card.suit.suitName}${card.suit.suitEmoji}`;
};
const $c66e8c61fdc94721$var$HandCards = (props)=>{
    var _round_hand;
    const user = (0, $97cadf28d7015811$export$af54d3055d90c64e).useSelector((0, $97cadf28d7015811$export$210c0a88ec4709b));
    const auth = (0, $97cadf28d7015811$export$af54d3055d90c64e).useSelector((0, $97cadf28d7015811$export$dc37312681b1d526));
    const game = props.game;
    const round = game.gameState.currentRound;
    const currentUserId = user.userId;
    const currentUserTurn = currentUserId === round.turnPlayerId;
    const cards = (round === null || round === void 0 ? void 0 : (_round_hand = round.hand) === null || _round_hand === void 0 ? void 0 : _round_hand.cards) || [];
    const playableCards = currentUserTurn && (round === null || round === void 0 ? void 0 : round.hand) && round.currentTrick ? (0, $423e312ab66c20fe$export$a2c7264fd050ba12)(round, round.hand) : [];
    const getPlayCardHandler = (card)=>async ()=>{
            const cmdData = {
                playerId: currentUserId,
                card: (0, $dddf98aa62f65ae7$export$82cbab171d4b5138)(round, card.cardValue, card.suit.suitName)
            };
            const cmd = {
                cmdId: (0, $6810e10b84975c3e$export$2e2bcd8739ae039)(),
                gameId: game.gameId,
                gameRuleSetName: game.gameRuleSetName,
                cmdType: (0, $8d3c56edba7f9068$export$c114e6986ab7a2c0).PlayCard,
                cmdData: cmdData
            };
            await (0, $f5f9da123b542c26$export$f72d34273529eb62).sendCmd(cmd, auth);
        };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "flex items-center",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: "flex flex-wrap justify-center items-center",
            children: cards.map((cardRef, index)=>{
                const card = (0, $dddf98aa62f65ae7$export$574ca6466190d4b4)(round, cardRef);
                const isPlayable = playableCards.includes(cardRef);
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "flex-col mx-3",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "flex justify-center items-center",
                            onClick: getPlayCardHandler(card),
                            children: (0, $57373b72dae59769$export$57ba431ca58665fc)(round, cardRef, 75)
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: `text-sm ${isPlayable ? 'font-bold' : 'py-0.5'} `,
                            children: $c66e8c61fdc94721$var$getCardCaption(round, cardRef)
                        })
                    ]
                }, `handCard${index}`);
            })
        })
    });
};
var $c66e8c61fdc94721$export$2e2bcd8739ae039 = $c66e8c61fdc94721$var$HandCards;







const $1088b5d16048da00$var$getCardCaption = (round, cardRef)=>{
    if (!cardRef) {
        const suit = round.trumpSuit;
        return suit ? `${suit.suitEmoji}${suit.suitName}${suit.suitEmoji}` : 'no trump';
    }
    const card = (0, $dddf98aa62f65ae7$export$574ca6466190d4b4)(round, cardRef);
    return `${card.suit.suitEmoji}${card.cardValueName || card.cardValue} of ${card.suit.suitName}${card.suit.suitEmoji}`;
};
const $1088b5d16048da00$var$deckHasNoDefaultTrump = (deck)=>{
    return !deck.trumpSuitName;
};
const $1088b5d16048da00$var$TrumpCard = (props)=>{
    const game = props.game;
    const round = game.gameState.currentRound;
    const trumpRef = round.trumpCard;
    const hasTrumpCard = typeof trumpRef === 'number';
    const noDefaultTrump = $1088b5d16048da00$var$deckHasNoDefaultTrump((0, $dddf98aa62f65ae7$export$c95ca51a280479c4)[round.deckCode]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        children: (hasTrumpCard || noDefaultTrump) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: "flex items-center",
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "flex-col mx-3",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: `font-bold}`,
                        children: "trump"
                    }),
                    hasTrumpCard && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "flex justify-center items-center",
                        children: (0, $57373b72dae59769$export$57ba431ca58665fc)(round, trumpRef, 75)
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: `text-sm font-bold}`,
                        children: $1088b5d16048da00$var$getCardCaption(round, trumpRef)
                    })
                ]
            })
        }) || /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {})
    });
};
var $1088b5d16048da00$export$2e2bcd8739ae039 = $1088b5d16048da00$var$TrumpCard;


const $8630726fbad515b0$var$PlayBidButtons = (props)=>{
    const game = props.game;
    const user = (0, $97cadf28d7015811$export$af54d3055d90c64e).useSelector((0, $97cadf28d7015811$export$210c0a88ec4709b));
    const auth = (0, $97cadf28d7015811$export$af54d3055d90c64e).useSelector((0, $97cadf28d7015811$export$dc37312681b1d526));
    const gameState = game.gameState;
    const { isMyTurn: isMyTurn, turnPlayerHandle: turnPlayerHandle } = (0, $71a1a8566b618f5d$export$3146f5ea4c252119)(gameState, user);
    const getPlayBidHandler = (bidValue)=>async (e)=>{
            e.preventDefault();
            if (isNaN(bidValue)) return;
            const cmdData = {
                playerId: user.userId,
                bidTricks: Number(bidValue)
            };
            const cmd = {
                cmdId: (0, $6810e10b84975c3e$export$2e2bcd8739ae039)(),
                gameId: game.gameId,
                gameRuleSetName: game.gameRuleSetName,
                cmdType: (0, $8d3c56edba7f9068$export$c114e6986ab7a2c0).PlaceBid,
                cmdData: cmdData
            };
            await (0, $f5f9da123b542c26$export$f72d34273529eb62).sendCmd(cmd, auth);
        };
    // zero to cards in round
    const zeroToCardsInRound = Array.from(Array(gameState.currentRound.numberOfCards + 1).keys());
    // add bid to rosters
    // if not player's turn, waiting for xyz
    // say place bid in an amusing way
    // brief rule explainer
    // if placing bid, type number of your bid into the box, then click Place Bid button
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "flex-col",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1088b5d16048da00$export$2e2bcd8739ae039), {
                game: game
            }),
            !isMyTurn && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "justify-center text-center font-bold",
                children: [
                    "waiting for ",
                    turnPlayerHandle,
                    "'s bid"
                ]
            }) || /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "flex justify-center",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "text-center font-bold",
                        children: "What's your bid?"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "flex justify-center flex-wrap",
                        children: zeroToCardsInRound.map((bidValue)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "flex",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                    className: "p-3 m-3 text-larger border-black border-2 text-center",
                                    type: "submit",
                                    onClick: getPlayBidHandler(bidValue),
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                            className: "text-larger font-bold",
                                            children: bidValue
                                        }),
                                        " -",
                                        ' ',
                                        10 + bidValue * bidValue,
                                        " points"
                                    ]
                                })
                            }, `playBidButton-${bidValue}`))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                children: "your hand"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "flex-grow",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c66e8c61fdc94721$export$2e2bcd8739ae039), {
                    game: game
                })
            })
        ]
    });
};
var $8630726fbad515b0$export$2e2bcd8739ae039 = $8630726fbad515b0$var$PlayBidButtons;








const $bbe2a2bd97a6e55c$var$PlayCard = (props)=>{
    const game = props.game;
    const user = (0, $97cadf28d7015811$export$af54d3055d90c64e).useSelector((0, $97cadf28d7015811$export$210c0a88ec4709b));
    const gameState = game.gameState;
    const round = gameState.currentRound;
    const { isMyTurn: isMyTurn, turnPlayerHandle: turnPlayerHandle } = (0, $71a1a8566b618f5d$export$3146f5ea4c252119)(gameState, user);
    const { isTrickComplete: isTrickComplete, trick: trick } = (0, $71a1a8566b618f5d$export$c8947bfd0e2acab9)(gameState.currentRound);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "flex-col h-full",
        children: [
            !isMyTurn && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "justify-center text-center font-bold",
                children: [
                    "waiting for ",
                    turnPlayerHandle,
                    "'s play"
                ]
            }),
            isMyTurn && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "justify-center text-center font-bold",
                children: "your turn"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "flex-col justify-center items-center",
                children: [
                    isTrickComplete ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        children: `${(0, $71a1a8566b618f5d$export$f34c9ed2963553c7)(trick, round)} gets the trick!`
                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        children: "the trick"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1088b5d16048da00$export$2e2bcd8739ae039), {
                        game: game
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "flex items-center justify-center",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ca6ad2c19374c117$export$2e2bcd8739ae039), {
                            round: gameState.currentRound
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                children: "your hand"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "flex",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c66e8c61fdc94721$export$2e2bcd8739ae039), {
                    game: game
                })
            })
        ]
    });
};
var $bbe2a2bd97a6e55c$export$2e2bcd8739ae039 = $bbe2a2bd97a6e55c$var$PlayCard;


const $a623c73ccb16e9f6$var$InProgress = (props)=>{
    var _game_gameState_currentRound, _game_gameState;
    const game = props.game;
    const readyForCommands = (game === null || game === void 0 ? void 0 : (_game_gameState = game.gameState) === null || _game_gameState === void 0 ? void 0 : (_game_gameState_currentRound = _game_gameState.currentRound) === null || _game_gameState_currentRound === void 0 ? void 0 : _game_gameState_currentRound.readyForCommands) || [];
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "bg-classicgray-dark p-2 pb-1 m-1 md:p-6 w-full md:w-10/12 rounded-md flex-col",
        children: readyForCommands.find((item)=>item === (0, $8d3c56edba7f9068$export$c114e6986ab7a2c0).DealCards) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e11ee6b306e4c4a1$export$2e2bcd8739ae039), {
            game: game
        }) || readyForCommands.find((item)=>item === (0, $8d3c56edba7f9068$export$c114e6986ab7a2c0).PlaceBid) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8630726fbad515b0$export$2e2bcd8739ae039), {
            game: game
        }) || readyForCommands.find((item)=>item === (0, $8d3c56edba7f9068$export$c114e6986ab7a2c0).PlayCard) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbe2a2bd97a6e55c$export$2e2bcd8739ae039), {
            game: game
        })
    });
};
var $a623c73ccb16e9f6$export$2e2bcd8739ae039 = $a623c73ccb16e9f6$var$InProgress;





const $420671a3b864ab64$var$Complete = (props)=>{
    const game = props.game;
    const gameState = game.gameState;
    const getLastCompletedRound = ()=>{
        return gameState.completedRounds[gameState.completedRounds.length - 1];
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "bg-classicgray-dark p-2 pb-1 m-1 md:p-6 w-full md:w-10/12 rounded-md flex-col",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "my-5 text-xs",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    children: "complete!"
                })
            }),
            gameState.completedRounds.length && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ca6ad2c19374c117$export$2e2bcd8739ae039), {
                round: getLastCompletedRound()
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $01dea572f0f5d10a$export$2e2bcd8739ae039), {
                lastCompleteRound: getLastCompletedRound(),
                players: game.players
            })
        ]
    });
};
var $420671a3b864ab64$export$2e2bcd8739ae039 = $420671a3b864ab64$var$Complete;








const $3590b693a0b61159$var$Help = ({ doToggleHelp: doToggleHelp })=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "bg-classicgray-dark p-2 pb-1 m-1 md:p-6 w-full md:w-10/12 rounded-md flex flex-col justify-center items-center",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "w-6/12 h-70v md:h-70v p-2 m-1 text-left overflow-y-auto md:overflow-y-scroll scrollbar",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        children: "The game is Oh Hell."
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                        children: [
                            "If this looks too complicated, just dive in. There's on-screen hints, and you can get back here by clicking HELP. Cards you can play are",
                            ' ',
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: "bolded."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        children: "Oh Hell is a trick taking game, about halfway between bridge and spades. A trick is where each player plays one card on their turn and the winner takes the trick."
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        children: "The game is played in a series of rounds."
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        children: "The dealer rotates with each round. They deal out the cards at the start of each Round, in order counter clockwise. Round one, everyone has one card and there's one trick. Round two, everyone has two cards and there's two tricks. You keep playing until you can't deal out another card or everyone wanders off."
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        children: "Get points by taking exactly the number of tricks you bid"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        children: "The goal is to get the most points by bidding on how many tricks you think you can win at the start of the round, and winning exactly that number. If you go over or under, you lose points. The rules guarantee that someone loses points every round. You can definitely end up with less than zero points, it happens all the time. Not typically to the winner."
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        children: "Each trick starts with someone leading a card. For the first trick of a round, this is the person after the dealer. The winner of a trick leads the next trick, and everyone has to follow them. Winning a trick means you set the pace for the next one."
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        children: "You have to follow suit."
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        children: 'In a trick, you must follow suit if you are able! You must play a card that matches the suit that was led. If you don\'t have any of that suit (if you "void" in that suit) you can play whatever you want.'
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        children: "The highest card of the led suit wins the trick, aces high. Playing off suit means you are intentionally getting rid of a card you don't want to win with. UNLESS someone plays a trump. If someone plays a trump during a trick, highest trump wins. Some decks (Tarot) have a designated trump suit. With others, you cut to determine trump before bidding."
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        children: 'You can\'t lead with a trump until someone else is void in the led suit and "breaks trump" by playing a trump card.'
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        children: "Bidding happens at start of every round"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        children: "Bidding follows the play order; player counter clockwise of the dealer bids first. Dealer bids last. The sum of the bids can not be the same as the number of cards in the round. This may prevent the dealer from bidding what they want, and ensures someone always loses points every round."
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        children: "Bid more score more, unless you miss"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        children: "The score is updated at the end of each round. If you get exactly what you bid you get points. If you're off by some cards, you lose points. If you are over or under your bid, you lose 5 points if off by one, 15 points if off by two, 30 points if off by three etc. If you make your bid, you get ten points plus the number bid squared: 10 for a bid of zero, 11 for a bid of one, 14 for a bid of two, 19 for a bid of three, 26 for a bid of four etc. The scoring is complicated because... we were high and mathematics is the language of the universe."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "w-6/12 p-2 flex justify-center",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                    className: "p-1 m-1 text-xs",
                    onClick: doToggleHelp,
                    children: "exit"
                })
            })
        ]
    });
};
var $3590b693a0b61159$export$2e2bcd8739ae039 = $3590b693a0b61159$var$Help;







var $7fPBF = parcelRequire("7fPBF");




const $0984deb758fae6e8$var$getInitialState = (game)=>({
        selectedKickPlayerId: game.hostUserId,
        kickReason: 'they are tiresome'
    });
const $0984deb758fae6e8$var$HostActions = ({ doToggleHost: doToggleHost, game: game })=>{
    const [state, setState] = (0, $7fPBF.useState)($0984deb758fae6e8$var$getInitialState(game));
    const auth = (0, $97cadf28d7015811$export$af54d3055d90c64e).useSelector((0, $97cadf28d7015811$export$dc37312681b1d526));
    const handleChangeselectedKickPlayerId = (value)=>{
        setState((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
            selectedKickPlayerId: value
        }));
    };
    const doRemoveFromGame = (event)=>{
        event.stopPropagation();
        if (state.selectedKickPlayerId === game.hostUserId) {
            alert(`can't kick host`);
            return;
        }
        alert(`kick player ${state.selectedKickPlayerId} because ${state.kickReason}`);
        sendKickCommand(state.selectedKickPlayerId, state.kickReason, game.gameId).catch((e)=>{
            throw e;
        });
    };
    const sendKickCommand = async (playerId, kickReason, gameId)=>{
        const cmdData = {
            kickedPlayerId: playerId,
            kickReason: kickReason
        };
        const cmd = {
            cmdId: (0, $6810e10b84975c3e$export$2e2bcd8739ae039)(),
            gameId: gameId,
            gameRuleSetName: game.gameRuleSetName,
            cmdType: (0, $8d3c56edba7f9068$export$c114e6986ab7a2c0).Kick,
            cmdData: cmdData
        };
        await (0, $f5f9da123b542c26$export$f72d34273529eb62).sendCmd(cmd, auth);
    };
    const updateKickReason = (event)=>{
        event.stopPropagation();
        setState((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
            kickReason: event.target.value
        }));
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "bg-classicgray-dark p-2 pb-1 m-1 md:p-6 w-full md:w-10/12 rounded-md flex flex-col justify-center items-center",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "w-10/12 h-70v md:h-70v p-2 m-1 text-left overflow-y-auto md:overflow-y-scroll scrollbar flex-col",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            children: "Host Actions."
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "flex-row",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                children: "kick "
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("select", {
                                value: state.selectedKickPlayerId,
                                name: "selectedKickPlayer",
                                onChange: (e)=>handleChangeselectedKickPlayerId(e.target.value),
                                children: game.players.map((player)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                        value: player.userId,
                                        children: player.handle
                                    }))
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                children: " because "
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                defaultValue: state.kickReason,
                                onChange: updateKickReason
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                onClick: doRemoveFromGame,
                                className: "m-1 px-2 border border-black",
                                children: "remove from game"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "w-6/12 p-2 flex justify-center",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                    className: "p-1 m-1 text-xs",
                    onClick: doToggleHost,
                    children: "exit"
                })
            })
        ]
    });
};
var $0984deb758fae6e8$export$2e2bcd8739ae039 = $0984deb758fae6e8$var$HostActions;


const $71a155b2c0330589$var$getRosterPlayers = (game)=>{
    if (!game) return [];
    const players = game.players;
    const gameState = game.gameState;
    if (gameState === null || gameState === void 0 ? void 0 : gameState.players) {
        var _gameState_completedRounds;
        const completedRound = ((_gameState_completedRounds = gameState.completedRounds) === null || _gameState_completedRounds === void 0 ? void 0 : _gameState_completedRounds.length) > 0 && gameState.completedRounds[gameState.completedRounds.length - 1];
        const round = gameState.currentRound || completedRound;
        const bidInfoByPlayer = ((round === null || round === void 0 ? void 0 : round.bids) || []).reduce((bidInfo, bid)=>{
            bidInfo[bid.playerId] = bid;
            return bidInfo;
        }, {});
        const completeBidInfoByPlayer = completedRound && ((completedRound === null || completedRound === void 0 ? void 0 : completedRound.bids) || []).reduce((bidInfo, bid)=>{
            bidInfo[bid.playerId] = bid;
            return bidInfo;
        }, {}) || {};
        return gameState.players.map((player)=>{
            var _bidInfoByPlayer_player_userId, _bidInfoByPlayer_player_userId1, _completeBidInfoByPlayer_player_userId;
            return {
                handle: player.handle,
                isComputer: !!player.computerPlayerId,
                computerPlayerId: player.computerPlayerId,
                isHost: player.userId === game.hostUserId,
                userId: player.userId,
                isPlayerTurn: player.userId === (round === null || round === void 0 ? void 0 : round.turnPlayerId),
                tricksBid: (_bidInfoByPlayer_player_userId = bidInfoByPlayer[player.userId]) === null || _bidInfoByPlayer_player_userId === void 0 ? void 0 : _bidInfoByPlayer_player_userId.bidTricks,
                tricksWon: (_bidInfoByPlayer_player_userId1 = bidInfoByPlayer[player.userId]) === null || _bidInfoByPlayer_player_userId1 === void 0 ? void 0 : _bidInfoByPlayer_player_userId1.wonTricks,
                netScore: (_completeBidInfoByPlayer_player_userId = completeBidInfoByPlayer[player.userId]) === null || _completeBidInfoByPlayer_player_userId === void 0 ? void 0 : _completeBidInfoByPlayer_player_userId.netScore,
                didExit: player.didExit,
                kickReason: player.kickReason
            };
        });
    }
    return players.map((player)=>({
            handle: player.handle,
            isComputer: !!player.computerPlayerId,
            computerPlayerId: player.computerPlayerId,
            isHost: player.userId === game.hostUserId,
            userId: player.userId,
            didExit: player.didExit,
            kickReason: player.kickReason
        }));
};
const $71a155b2c0330589$var$buildInitialState = (location, searchParams)=>{
    const searchParamGameId = searchParams.get('gameId');
    const initialState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, location.state), {
        rosterPlayers: [],
        panelMode: (0, $71a1a8566b618f5d$export$829c4b56865ef99a)
    });
    initialState.gameId = searchParamGameId || initialState.gameId;
    initialState.rosterPlayers = $71a155b2c0330589$var$getRosterPlayers(initialState.game);
    return initialState;
};
const $71a155b2c0330589$var$OhHell = ()=>{
    var _state_game, _state_game1;
    const connection = (0, $97cadf28d7015811$export$af54d3055d90c64e).useActorRef();
    const user = (0, $97cadf28d7015811$export$af54d3055d90c64e).useSelector((0, $97cadf28d7015811$export$210c0a88ec4709b));
    const auth = (0, $97cadf28d7015811$export$af54d3055d90c64e).useSelector((0, $97cadf28d7015811$export$dc37312681b1d526));
    const messageSubscriptions = (0, $97cadf28d7015811$export$af54d3055d90c64e).useSelector((0, $97cadf28d7015811$export$c2f2062409a9bb62));
    const location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    const [searchParams] = (0, $a0cf24fd73ae067c$export$f1a78c17382fe22a)();
    const initialState = $71a155b2c0330589$var$buildInitialState(location, searchParams);
    const [state, setState] = (0, $7fPBF.useState)(initialState);
    const gameId = state === null || state === void 0 ? void 0 : state.gameId;
    const gameState = (_state_game = state.game) === null || _state_game === void 0 ? void 0 : _state_game.gameState;
    const gameMessageClientId = (0, $b93fbb979342838e$export$75df8273cd15a834)((0, $b93fbb979342838e$export$ff0f8bd07799254c).game, gameId);
    const requestComputerMove = async (game)=>{
        var _gameState_currentRound;
        const gameState = game.gameState;
        (0, $aba38a333ca575f4$export$efa9a398d6368992).debug('checking if computer play...');
        if (!game || !(gameState === null || gameState === void 0 ? void 0 : (_gameState_currentRound = gameState.currentRound) === null || _gameState_currentRound === void 0 ? void 0 : _gameState_currentRound.turnPlayerId)) {
            (0, $aba38a333ca575f4$export$efa9a398d6368992).debug('checking if computer play...');
            return;
        }
        (0, $aba38a333ca575f4$export$efa9a398d6368992).debug('requesting computer play...');
        const cmd = (0, $71a1a8566b618f5d$export$987ae613d2bbcdd4)(game);
        cmd && await (0, $f5f9da123b542c26$export$f72d34273529eb62).sendCmd(cmd, auth);
    };
    const setStatusFromGame = (0, $7fPBF.useCallback)((game)=>{
        const ohGame = game;
        if (state.gameId && ohGame.gameId !== state.gameId) return;
        const newState = {
            game: ohGame,
            gameId: ohGame.gameId,
            rosterPlayers: $71a155b2c0330589$var$getRosterPlayers(ohGame),
            panelMode: state.panelMode,
            panelModeDetailId: ''
        };
        setState(newState);
        const nextTurnPlayer = ohGame.players.find((player)=>{
            var _ohGame_gameState_currentRound, _ohGame_gameState;
            return player.userId === ((_ohGame_gameState = ohGame.gameState) === null || _ohGame_gameState === void 0 ? void 0 : (_ohGame_gameState_currentRound = _ohGame_gameState.currentRound) === null || _ohGame_gameState_currentRound === void 0 ? void 0 : _ohGame_gameState_currentRound.turnPlayerId);
        });
        if ((user === null || user === void 0 ? void 0 : user.userId) === (ohGame === null || ohGame === void 0 ? void 0 : ohGame.hostUserId) && (nextTurnPlayer === null || nextTurnPlayer === void 0 ? void 0 : nextTurnPlayer.computerPlayerId)) {
            var _ohGame_gameState, _currentRound_readyForCommands, _currentRound_completedTricks, _currentRound_currentTrick;
            const currentRound = ohGame === null || ohGame === void 0 ? void 0 : (_ohGame_gameState = ohGame.gameState) === null || _ohGame_gameState === void 0 ? void 0 : _ohGame_gameState.currentRound;
            const isDealable = (currentRound === null || currentRound === void 0 ? void 0 : (_currentRound_readyForCommands = currentRound.readyForCommands) === null || _currentRound_readyForCommands === void 0 ? void 0 : _currentRound_readyForCommands.includes((0, $8d3c56edba7f9068$export$c114e6986ab7a2c0).DealCards)) || false;
            const isTrickEnded = (currentRound === null || currentRound === void 0 ? void 0 : (_currentRound_completedTricks = currentRound.completedTricks) === null || _currentRound_completedTricks === void 0 ? void 0 : _currentRound_completedTricks.length) > 0 && !(currentRound === null || currentRound === void 0 ? void 0 : (_currentRound_currentTrick = currentRound.currentTrick) === null || _currentRound_currentTrick === void 0 ? void 0 : _currentRound_currentTrick.cards.length);
            const delayMs = isDealable || isTrickEnded ? 5000 : 500;
            setTimeout(()=>requestComputerMove(ohGame).catch((e)=>(0, $aba38a333ca575f4$export$efa9a398d6368992).debug(JSON.stringify(e))), delayMs);
        } else (0, $aba38a333ca575f4$export$efa9a398d6368992).debug('no need to request computer play...');
    }, [
        setState,
        requestComputerMove
    ]);
    const onGameMessage = (0, $7fPBF.useCallback)((message)=>{
        const game = message === null || message === void 0 ? void 0 : message.data;
        game && setStatusFromGame(game);
    }, [
        setStatusFromGame
    ]);
    (0, $7fPBF.useEffect)(()=>{
        (0, $57373b72dae59769$export$673b764489494bbf)();
        (0, $57373b72dae59769$export$fabd456b669fe9ab)();
        if (gameId && !state.game) (0, $f5f9da123b542c26$export$f72d34273529eb62).getGame(gameId, auth).then((game)=>{
            setStatusFromGame(game);
        });
    });
    (0, $7fPBF.useEffect)(()=>{
        (0, $aba38a333ca575f4$export$efa9a398d6368992).debug('subscribing to game');
        if (!messageSubscriptions.has(gameMessageClientId)) {
            const client = {
                clientId: gameMessageClientId,
                callback: onGameMessage,
                channels: [
                    {
                        channel: (0, $b93fbb979342838e$export$ff0f8bd07799254c).game,
                        topic: gameId
                    }
                ]
            };
            connection.send({
                type: 'SOCKET_SUBSCRIBE',
                value: client
            });
        }
    }, [
        gameMessageClientId
    ]);
    if (!gameId) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                children: "oh weird"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: "not sure what happened, but it's not clear which game you're trying to play"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: "maybe hit up the lobby, i guess"
            })
        ]
    });
    const mainPanelToggleBuilder = (panelMode, panelModeDetailId)=>(event)=>{
            event.stopPropagation();
            setState((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                panelMode: state.panelMode === (0, $71a1a8566b618f5d$export$829c4b56865ef99a) ? panelMode : (0, $71a1a8566b618f5d$export$829c4b56865ef99a),
                panelModeDetailId: state.panelMode === (0, $71a1a8566b618f5d$export$829c4b56865ef99a) ? panelModeDetailId || '' : ''
            }));
        };
    const hostToggler = mainPanelToggleBuilder((0, $71a1a8566b618f5d$export$e6e380aa2f411931), '');
    const helpToggler = mainPanelToggleBuilder((0, $71a1a8566b618f5d$export$623508f30360caf0), '');
    const panelState = state.panelMode === (0, $71a1a8566b618f5d$export$e6e380aa2f411931) || state.panelMode === (0, $71a1a8566b618f5d$export$623508f30360caf0) ? state.panelMode : state === null || state === void 0 ? void 0 : (_state_game1 = state.game) === null || _state_game1 === void 0 ? void 0 : _state_game1.status;
    const isGameMode = state.panelMode === (0, $71a1a8566b618f5d$export$829c4b56865ef99a);
    const isHelpMode = state.panelMode === (0, $71a1a8566b618f5d$export$623508f30360caf0);
    const isHostMode = state.panelMode === (0, $71a1a8566b618f5d$export$e6e380aa2f411931);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "container mx-auto mb-3 h-80v w-90v",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                children: "Oh hell."
            }),
            state.game && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "md:flex mx-auto h-full w-full justify-center",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c7a877e6228e3ef5$export$2e2bcd8739ae039), {
                        isUserHost: true,
                        players: state.rosterPlayers,
                        status: state.game.status,
                        doToggleHelp: mainPanelToggleBuilder((0, $71a1a8566b618f5d$export$623508f30360caf0)),
                        doToggleHost: mainPanelToggleBuilder((0, $71a1a8566b618f5d$export$e6e380aa2f411931))
                    }),
                    isHelpMode && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3590b693a0b61159$export$2e2bcd8739ae039), {
                        doToggleHelp: helpToggler
                    }),
                    isHostMode && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0984deb758fae6e8$export$2e2bcd8739ae039), {
                        doToggleHost: hostToggler,
                        game: state.game
                    }),
                    isGameMode && state.game.status === (0, $08d136cf68240767$export$23c7328964450bd2).Ready && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3c3bee137f6365c5$export$2e2bcd8739ae039), {
                        game: state.game
                    }),
                    panelState === (0, $08d136cf68240767$export$23c7328964450bd2).InProgress && gameState.currentRound && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a623c73ccb16e9f6$export$2e2bcd8739ae039), {
                        game: state.game
                    }),
                    panelState === (0, $08d136cf68240767$export$23c7328964450bd2).InProgress && !gameState.currentRound && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $420671a3b864ab64$export$2e2bcd8739ae039), {
                        game: state.game
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7f4e2622939e64e$export$2e2bcd8739ae039), {
                        chatRoomId: $71a155b2c0330589$var$getChatRoomId(state.game),
                        chatroomName: $71a155b2c0330589$var$getChatRoomChannel()
                    })
                ]
            })
        ]
    });
};
var $71a155b2c0330589$export$2e2bcd8739ae039 = $71a155b2c0330589$var$OhHell;
function $71a155b2c0330589$var$getChatRoomId(game) {
    return game.gameId;
}
function $71a155b2c0330589$var$getChatRoomChannel() {
    return 'game chat';
}




parcelRequire("7fPBF");

const $c9d4391632bf044f$var$AuthSpinner = ()=>{
    const cnState = (0, $97cadf28d7015811$export$af54d3055d90c64e).useSelector((state)=>state);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "font-mono text-xs m-2.5 px-5 w-200",
        children: [
            "booting up auth, state is ",
            JSON.stringify(cnState.value)
        ]
    });
};
var $c9d4391632bf044f$export$2e2bcd8739ae039 = $c9d4391632bf044f$var$AuthSpinner;



const $6751a9fb820f7fe4$var$helpMessage = `
help(): display this message
logLevel('DEBUG' | 'INFO' | 'WARN' | 'ERROR')
logstate(): output current statemachine state
`;
const $6751a9fb820f7fe4$export$6f7f5ce9dcbf3b14 = (state)=>{
    window.help = ()=>console.info($6751a9fb820f7fe4$var$helpMessage);
    window.logLevel = (level)=>(0, $aba38a333ca575f4$export$efa9a398d6368992).level = (0, $aba38a333ca575f4$export$12dbaabc76fb091a)(level);
    window.logState = ()=>console.info({
            context: state.context,
            value: state.value
        });
    window.Logger = (0, $aba38a333ca575f4$export$efa9a398d6368992);
};







var $7fPBF = parcelRequire("7fPBF");





const $80ff0d33b75baa64$var$MAX_THREAD_REQUEST = 100;
const $80ff0d33b75baa64$var$DEFAULT_THREAD_REQUEST = 5;
const $80ff0d33b75baa64$var$MAX_POST_REQUEST = 100;
const $80ff0d33b75baa64$var$sampleThreads = [
    {
        id: '080a67e7-74ff-4e5d-8e73-778f51f3d631',
        title: 'is this thing on?',
        threadType: 'discussion',
        tags: [
            'art',
            'philosophy'
        ],
        topicPost: 'i\'m just not sure one way or the other',
        createDate: new Date(2025, 11, 23),
        authorId: '080a67e7-74ff-4e5d-8e73-778f51f3d631',
        authorHandle: 'mr yes',
        postList: {
            start: 0,
            end: 3,
            posts: [
                {
                    authorId: '080a67e7-74ff-4e5d-8e73-778f51f3d631',
                    authorHandle: 'mr yes',
                    body: 'yes',
                    postDate: new Date(),
                    postId: "",
                    threadId: ""
                },
                {
                    authorId: 'd6cf86a6-49f4-4c52-aa72-b245cfc6e707',
                    authorHandle: 'mr no',
                    body: 'no',
                    postDate: new Date(),
                    postId: "",
                    threadId: ""
                },
                {
                    authorId: '080a67e7-74ff-4e5d-8e73-778f51f3d631',
                    authorHandle: 'mr yes',
                    body: 'what do you mean??',
                    postDate: new Date(),
                    postId: "",
                    threadId: ""
                }
            ]
        }
    },
    {
        id: '080a67e7-74ff-4e5d-8e73-778f51f3d631',
        title: 'is this thing on yet?',
        threadType: 'discussion',
        tags: [
            'art',
            'philosophy'
        ],
        topicPost: 'i\'m just not sure one way or the other',
        createDate: new Date(2025, 11, 22),
        authorId: '080a67e7-74ff-4e5d-8e73-778f51f3d631',
        authorHandle: 'mr yes',
        postList: {
            start: 0,
            end: 3,
            posts: [
                {
                    authorId: '080a67e7-74ff-4e5d-8e73-778f51f3d631',
                    authorHandle: 'mr yes',
                    body: 'yes',
                    postDate: new Date(),
                    postId: "",
                    threadId: ""
                },
                {
                    authorId: 'd6cf86a6-49f4-4c52-aa72-b245cfc6e707',
                    authorHandle: 'mr no',
                    body: 'no',
                    postDate: new Date(),
                    postId: "",
                    threadId: ""
                },
                {
                    authorId: '080a67e7-74ff-4e5d-8e73-778f51f3d631',
                    authorHandle: 'mr yes',
                    body: 'what do you mean??',
                    postDate: new Date(),
                    postId: "",
                    threadId: ""
                }
            ]
        }
    },
    {
        id: 'c3c1b5b9-4e4f-4b21-8e1f-1b4a2b99f310',
        title: 'favorite recent noise sets in the cities?',
        threadType: 'discussion',
        tags: [
            'music',
            'noise',
            'local'
        ],
        topicPost: 'AI generated sample text.  anyone catch that basement noise triple-bill in longfellow last night? my ears are still politely screaming.',
        createDate: new Date(2025, 1, 14, 18, 32),
        authorId: '19a6ce19-0f48-4cf6-982c-55a214e8df61',
        authorHandle: 'river_aster',
        postList: {
            start: 0,
            end: 10,
            posts: [
                {
                    authorId: '19a6ce19-0f48-4cf6-982c-55a214e8df61',
                    authorHandle: 'river_aster',
                    body: 'opening act sounded like a dishwasher being exorcised and i mean that as the highest compliment.',
                    postDate: new Date(2025, 1, 14, 18, 35),
                    postId: "",
                    threadId: ""
                },
                {
                    authorId: '7bd4e41c-3375-4e1b-8ede-f5cb252df240',
                    authorHandle: 'trash_harp',
                    body: `i was there! the strobes were brutal but the contact-mic-on-metal-bowl thing? chef's kiss.`,
                    postDate: new Date(2025, 1, 14, 18, 41),
                    postId: "",
                    threadId: ""
                },
                {
                    authorId: '0c6db928-dbbe-4b45-9f1f-6c0cca0a4aa3',
                    authorHandle: 'mossmoth',
                    body: `couldn't make it, was at the midtown greenhouse set. vines + modular drones = transcendence.`,
                    postDate: new Date(2025, 1, 14, 19, 2),
                    postId: "",
                    threadId: ""
                },
                {
                    authorId: '5c428e81-d44b-4359-9a9d-3f3c8a8b9c3e',
                    authorHandle: 'redflag_rye',
                    body: `longfellow basement squad is undefeated. also whoever brought the cauldron (??) for percussion deserves a medal.`,
                    postDate: new Date(2025, 1, 14, 19, 20),
                    postId: "",
                    threadId: ""
                },
                {
                    authorId: '7bd4e41c-3375-4e1b-8ede-f5cb252df240',
                    authorHandle: 'trash_harp',
                    body: "it WAS a cauldron, i asked. they said \u201Cwitchy but practical\u201D which seems like a life philosophy honestly.",
                    postDate: new Date(2025, 1, 14, 19, 25),
                    postId: "",
                    threadId: ""
                },
                {
                    authorId: '19a6ce19-0f48-4cf6-982c-55a214e8df61',
                    authorHandle: 'river_aster',
                    body: 'lol i love our scene. every show is 30% art school, 30% coven, 30% communist potluck energy.',
                    postDate: new Date(2025, 1, 14, 19, 31),
                    postId: "",
                    threadId: ""
                },
                {
                    authorId: '0c6db928-dbbe-4b45-9f1f-6c0cca0a4aa3',
                    authorHandle: 'mossmoth',
                    body: `speaking of potlucks: anyone going to the noise brunch at moon palace on sunday? i'll bring muffins.`,
                    postDate: new Date(2025, 1, 14, 20, 4),
                    postId: "",
                    threadId: ""
                },
                {
                    authorId: '5c428e81-d44b-4359-9a9d-3f3c8a8b9c3e',
                    authorHandle: 'redflag_rye',
                    body: 'planning to! hoping someone does a set entirely with broken keyboards again. that ruled last time.',
                    postDate: new Date(2025, 1, 14, 20, 17),
                    postId: "",
                    threadId: ""
                },
                {
                    authorId: '7bd4e41c-3375-4e1b-8ede-f5cb252df240',
                    authorHandle: 'trash_harp',
                    body: 'i can loan out two thrift-store casios if anyone wants to get weird.',
                    postDate: new Date(2025, 1, 14, 20, 25),
                    postId: "",
                    threadId: ""
                },
                {
                    authorId: '19a6ce19-0f48-4cf6-982c-55a214e8df61',
                    authorHandle: 'river_aster',
                    body: `ok now i'm definitely going. nothing like brunch with friends and dissonance.`,
                    postDate: new Date(2025, 1, 14, 20, 29),
                    postId: "",
                    threadId: ""
                },
                {
                    authorId: '3f2c52b0-1c1a-4f4e-a3f0-0a5f2cbe88b0',
                    authorHandle: 'ghost_crayon',
                    body: `hi i'm new here\u{2014}was anyone at that riverside warehouse thing where a dude was literally fishing broken glass out of the trash to scrape over a homemade mic???`,
                    postDate: new Date(2025, 1, 14, 20, 41),
                    postId: "",
                    threadId: ""
                },
                {
                    authorId: '3f2c52b0-1c1a-4f4e-a3f0-0a5f2cbe88b0',
                    authorHandle: 'ghost_crayon',
                    body: 'i swear it sounded like a raccoon doing foley work for a horror movie. incredible but also so bad. like spiritually bad.',
                    postDate: new Date(2025, 1, 14, 20, 42),
                    postId: "",
                    threadId: ""
                },
                {
                    authorId: '3f2c52b0-1c1a-4f4e-a3f0-0a5f2cbe88b0',
                    authorHandle: 'ghost_crayon',
                    body: `also i met someone there and they were super sweet but i was a little too drunk and cannot remember their name at all. i think it started with M? or maybe B? i'm mortified lol.`,
                    postDate: new Date(2025, 1, 14, 20, 46),
                    postId: "",
                    threadId: ""
                },
                {
                    authorId: '7bd4e41c-3375-4e1b-8ede-f5cb252df240',
                    authorHandle: 'trash_harp',
                    body: `LMAO i know exactly who you mean\u{2014}was the glass guy wearing a reflective safety vest? that's glint_lord. he's a menace.`,
                    postDate: new Date(2025, 1, 14, 20, 52),
                    postId: "",
                    threadId: ""
                },
                {
                    authorId: '5c428e81-d44b-4359-9a9d-3f3c8a8b9c3e',
                    authorHandle: 'redflag_rye',
                    body: "oh noooooo the drunk-name-forgetting curse. i once introduced someone as \u201Cmy friend whose name i will remember in five minutes\u201D and then never remembered.",
                    postDate: new Date(2025, 1, 14, 20, 55),
                    postId: "",
                    threadId: ""
                },
                {
                    authorId: '0c6db928-dbbe-4b45-9f1f-6c0cca0a4aa3',
                    authorHandle: 'mossmoth',
                    body: "same, i had a whole conversation with someone about their cat and then found out 2 months later their name was not \u201Cdandelion guy.\u201D",
                    postDate: new Date(2025, 1, 14, 21, 1),
                    postId: "",
                    threadId: ""
                },
                {
                    authorId: '19a6ce19-0f48-4cf6-982c-55a214e8df61',
                    authorHandle: 'river_aster',
                    body: `tbh half the twin cities scene could just wear name tags that say \u{201C}sorry i forgot already\u{201D} and it'd save us all time.`,
                    postDate: new Date(2025, 1, 14, 21, 4),
                    postId: "",
                    threadId: ""
                },
                {
                    authorId: '3f2c52b0-1c1a-4f4e-a3f0-0a5f2cbe88b0',
                    authorHandle: 'ghost_crayon',
                    body: `\u{201C}glint_lord\u{201D} omg. that fits too well. at one point he bowed the glass like it was a violin and i thought the amp was going to cry.`,
                    postDate: new Date(2025, 1, 14, 21, 10),
                    postId: "",
                    threadId: ""
                },
                {
                    authorId: '7bd4e41c-3375-4e1b-8ede-f5cb252df240',
                    authorHandle: 'trash_harp',
                    body: `the amp DID cry. that feedback spiral? that was the sound of regret.`,
                    postDate: new Date(2025, 1, 14, 21, 12),
                    postId: "",
                    threadId: ""
                },
                {
                    authorId: '5c428e81-d44b-4359-9a9d-3f3c8a8b9c3e',
                    authorHandle: 'redflag_rye',
                    body: `i once watched someone mic up a busted ceramic pot. the entire set was just crunchy pottery heartbreak.`,
                    postDate: new Date(2025, 1, 14, 21, 18),
                    postId: "",
                    threadId: ""
                },
                {
                    authorId: '19a6ce19-0f48-4cf6-982c-55a214e8df61',
                    authorHandle: 'river_aster',
                    body: `that actually sounds beautiful in a \u{201C}my soul lives in a thrift store\u{201D} kinda way.`,
                    postDate: new Date(2025, 1, 14, 21, 20),
                    postId: "",
                    threadId: ""
                },
                {
                    authorId: '3f2c52b0-1c1a-4f4e-a3f0-0a5f2cbe88b0',
                    authorHandle: 'ghost_crayon',
                    body: 'this board is making me feel so much better about the name thing lol. community amnesia is apparently normal.',
                    postDate: new Date(2025, 1, 14, 21, 25),
                    postId: "",
                    threadId: ""
                },
                {
                    authorId: '0c6db928-dbbe-4b45-9f1f-6c0cca0a4aa3',
                    authorHandle: 'mossmoth',
                    body: `seriously\u{2014}half the time i remember people by their gear. \u{201C}oh yeah you're the reel-to-reel wizard.\u{201D}`,
                    postDate: new Date(2025, 1, 14, 21, 30),
                    postId: "",
                    threadId: ""
                },
                {
                    authorId: '7bd4e41c-3375-4e1b-8ede-f5cb252df240',
                    authorHandle: 'trash_harp',
                    body: "same. someone once recognized me only as \u201Cthat person with the angry harp.\u201D fair.",
                    postDate: new Date(2025, 1, 14, 21, 33),
                    postId: "",
                    threadId: ""
                },
                {
                    authorId: '19a6ce19-0f48-4cf6-982c-55a214e8df61',
                    authorHandle: 'river_aster',
                    body: 'angry harp is iconic tbh.',
                    postDate: new Date(2025, 1, 14, 21, 35),
                    postId: "",
                    threadId: ""
                },
                {
                    authorId: '5c428e81-d44b-4359-9a9d-3f3c8a8b9c3e',
                    authorHandle: 'redflag_rye',
                    body: `i once forgot someone's name so thoroughly i introduced them to someone else *by describing their jacket*. it worked, astonishingly.`,
                    postDate: new Date(2025, 1, 14, 21, 41),
                    postId: "",
                    threadId: ""
                },
                {
                    authorId: '3f2c52b0-1c1a-4f4e-a3f0-0a5f2cbe88b0',
                    authorHandle: 'ghost_crayon',
                    body: `this is reassuring. also i'm now picturing glint_lord storing glass shards like pokemon.`,
                    postDate: new Date(2025, 1, 14, 21, 44),
                    postId: "",
                    threadId: ""
                },
                {
                    authorId: '7bd4e41c-3375-4e1b-8ede-f5cb252df240',
                    authorHandle: 'trash_harp',
                    body: 'do NOT give him ideas.',
                    postDate: new Date(2025, 1, 14, 21, 45),
                    postId: "",
                    threadId: ""
                },
                {
                    authorId: '0c6db928-dbbe-4b45-9f1f-6c0cca0a4aa3',
                    authorHandle: 'mossmoth',
                    body: 'too late, he definitely already has a system.',
                    postDate: new Date(2025, 1, 14, 21, 47),
                    postId: "",
                    threadId: ""
                },
                {
                    authorId: '19a6ce19-0f48-4cf6-982c-55a214e8df61',
                    authorHandle: 'river_aster',
                    body: "okay now i want to book a \u201Cfound object showdown\u201D night. bring your weirdest noise-making thing.",
                    postDate: new Date(2025, 1, 14, 21, 55),
                    postId: "",
                    threadId: ""
                },
                {
                    authorId: 'a1b4d2f0-62c3-42e0-9c77-9df0ebc441aa',
                    authorHandle: 'glint_lord',
                    body: `hey. someone said Javascript javascript my name in here a while back so i figured i'd finally crawl out of ****whatever dimension**** i was in and contribute.[some text](javascript:alert('xss'))


### okay. glass.
people think it's all the same but no\u{2014}different shards have [different personalities](https://google.com). the thick-bottom bottle chunks? those give you that deep, resonant \u{201C}doom scrape,\u{201D} kinda like a glacier clearing its throat. ![glacier pic!!](https://nsidc.org/sites/default/files/styles/article_image_large/public/images/Exploring%20the%20Perito%20Moreno%20Glacier_Bruce%20Raup_2019-12-19-33_6329.jpg.webp?itok=cvyKga-f) the curved stuff from old casserole dishes is great for tremolo grinding if you angle it just right. and the really thin, almost paper-like fragments you get from busted picture frames? absolute chaos. they flutter on the mic like evil butterflies.

another tip: don't clean the glass too much. a little grime does wonders for texture. dust adds hiss, dried soda adds stick-slip crackle, and whatever unidentifiable goo lives in alley bins gives you that signature \u{201C}what-is-that-and-should-I-be-worried\u{201D} timbre.

also: use the whole surface. everyone goes for the edges, but the flat plane can do these weird resonant drags if you press it against the mic casing instead of the pickup. gross sounds. terrible. beautiful.

anyway if anyone saw me at that warehouse show: sorry i wasn't at my best. went on a bit of a\u{2026} let's call it an \u{201C}ill-advised spiral.\u{201D} pretty sure it involved pcp, because the last thing i remember is deciding i needed to \u{201C}follow the true frequency path,\u{201D} and then boom\u{2014}five days later i woke up in milwaukee wearing only one boot and a shirt i'm 90% sure wasn't mine. not my proudest moment. please do not do what i did. honestly no one should.

![enormous glacier](https://upload.wikimedia.org/wikipedia/commons/5/55/Glaciar_Lamplugh%2C_Parque_Nacional_Bah%C3%ADa_del_Glaciar%2C_Alaska%2C_Estados_Unidos%2C_2017-08-19%2C_DD_154.jpg)

but yeah. happy scraping.`,
                    postDate: new Date(2025, 1, 29, 16, 12),
                    textMode: 'markdown',
                    postId: "",
                    threadId: ""
                },
                {
                    authorId: '3f2c52b0-1c1a-4f4e-a3f0-0a5f2cbe88b0',
                    authorHandle: 'ghost_crayon',
                    body: 'GLINT LORD WHAT. i was not prepared for literally any part of this update omg are you okay??? javascript ![spooky!!](https://www.google.com/url?sa=i&url=https%3A%2F%2Fwww.pinterest.com%2Fideas%2Fdancing-skeleton-gif%2F908019841987%2F&psig=AOvVaw0ha8zpFF0GrIyzGFOr-E7Z&ust=1764906227721000&source=images&opi=89978449)',
                    postDate: new Date(2025, 1, 29, 16, 14),
                    textMode: 'markdown',
                    postId: "",
                    threadId: ""
                }
            ]
        }
    }
];
const $80ff0d33b75baa64$export$1ab060d62ab3aa6b = async (options)=>{
    const opts = $80ff0d33b75baa64$var$getThreadsOptionsWithDefaults(options);
    await (0, $fd4f404b5352696d$export$a57e9bef4b3b52d0)(1000);
    if ((options === null || options === void 0 ? void 0 : options.searchText) == 'error') throw new Error('asked for error');
    if (options === null || options === void 0 ? void 0 : options.searchText) return Promise.resolve($80ff0d33b75baa64$var$sampleThreads.filter((thread)=>thread.title.includes(options.searchText || '')).slice(0, Math.min(opts.count, $80ff0d33b75baa64$var$sampleThreads.length)));
    return Promise.resolve($80ff0d33b75baa64$var$sampleThreads.slice(0, Math.min(opts.count, $80ff0d33b75baa64$var$sampleThreads.length)));
};
const $80ff0d33b75baa64$export$50f8d0ec9c6605e5 = async (options)=>{
    const opts = $80ff0d33b75baa64$var$getThreadOptionsWithDefaults(options);
    await (0, $fd4f404b5352696d$export$a57e9bef4b3b52d0)(1000);
    (0, $aba38a333ca575f4$export$efa9a398d6368992).info(`getThread with options ${JSON.stringify(options)} ${JSON.stringify(opts)}`);
    return Promise.resolve($80ff0d33b75baa64$var$sampleThreads.filter((thread)=>thread.id === opts.threadId)[0]);
};
const $80ff0d33b75baa64$export$5c0c7399b5e4fa32 = async (opts)=>{
    const thread = $80ff0d33b75baa64$var$sampleThreads.filter((thread)=>thread.id === opts.threadId)[0];
    const post = {
        authorId: 'db47e77a-f1f0-4091-81b4-639ea0bea75e',
        authorHandle: 'migf',
        postDate: new Date(),
        body: opts.body,
        postId: "",
        threadId: ""
    };
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, thread), {
        postList: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, thread.postList), {
            posts: thread.postList.posts.concat(post)
        })
    });
};
const $80ff0d33b75baa64$export$923edb1ec4cf1c8a = async (opts)=>{
    const thread = $80ff0d33b75baa64$var$sampleThreads.filter((thread)=>thread.id === opts.threadId)[0];
    const post = {
        authorId: 'db47e77a-f1f0-4091-81b4-639ea0bea75e',
        authorHandle: 'migf',
        postDate: new Date(),
        body: opts.body,
        postId: "",
        threadId: ""
    };
    thread.postList.posts.push(post);
    return $80ff0d33b75baa64$export$50f8d0ec9c6605e5({
        threadId: opts.threadId
    });
};
const $80ff0d33b75baa64$var$getThreadsOptionsWithDefaults = (options)=>{
    const opts = options || {
        count: $80ff0d33b75baa64$var$DEFAULT_THREAD_REQUEST
    };
    const optionsCount = Math.floor(opts.count || 0);
    const count = optionsCount > $80ff0d33b75baa64$var$MAX_THREAD_REQUEST ? $80ff0d33b75baa64$var$MAX_THREAD_REQUEST : optionsCount || $80ff0d33b75baa64$var$DEFAULT_THREAD_REQUEST;
    return {
        count: count
    };
};
const $80ff0d33b75baa64$var$getThreadOptionsWithDefaults = (options)=>{
    const opts = {
        count: $80ff0d33b75baa64$var$MAX_POST_REQUEST,
        threadId: options.threadId
    };
    const optionsCount = Math.floor(opts.count || 0);
    const count = optionsCount > $80ff0d33b75baa64$var$MAX_POST_REQUEST ? $80ff0d33b75baa64$var$MAX_POST_REQUEST : optionsCount || $80ff0d33b75baa64$var$MAX_POST_REQUEST;
    return {
        count: count,
        threadId: opts.threadId
    };
};



const $a1ebeddfa23eef40$var$bubbleColors = {
    art: '#f2c0fa',
    philosophy: '#e7a0ffff',
    music: '#f2c0fa',
    local: '#9de8ffff',
    noise: '#d67272ff',
    events: '#9de8ffff',
    news: '#9e9e9eff',
    woowoo: '#e7a0ffff',
    default: '#d2fac0'
};
const $a1ebeddfa23eef40$var$getBubbleColor = (bubbleText)=>{
    var _Object_entries_find;
    return $a1ebeddfa23eef40$var$bubbleColors[bubbleText] || ((_Object_entries_find = Object.entries($a1ebeddfa23eef40$var$bubbleColors).find((entry)=>bubbleText.startsWith(entry[0]))) === null || _Object_entries_find === void 0 ? void 0 : _Object_entries_find[1]) || $a1ebeddfa23eef40$var$bubbleColors.default;
};
const $a1ebeddfa23eef40$var$TagBubble = ({ bubbleText: bubbleText })=>{
    const bubbleColor = $a1ebeddfa23eef40$var$getBubbleColor(bubbleText);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
        className: "align-middle mx-1 px-2 text-xs bg-indigo-200 rounded",
        style: {
            backgroundColor: bubbleColor
        },
        children: bubbleText
    });
};
var $a1ebeddfa23eef40$export$2e2bcd8739ae039 = $a1ebeddfa23eef40$var$TagBubble;




var $7fPBF = parcelRequire("7fPBF");

const $cb2440ccedb084f5$var$ThreadSearchBox = ({ handleSearchResults: handleSearchResults })=>{
    const searchEntryField = (0, $7fPBF.useRef)(null);
    const handleSubmit = (e)=>{
        var _searchEntryField_current;
        e.preventDefault();
        handleSearchResults({
            data: [],
            isSearching: true,
            errorText: ''
        });
        (0, $80ff0d33b75baa64$export$1ab060d62ab3aa6b)({
            searchText: (searchEntryField === null || searchEntryField === void 0 ? void 0 : (_searchEntryField_current = searchEntryField.current) === null || _searchEntryField_current === void 0 ? void 0 : _searchEntryField_current.value) || ''
        }).then((data)=>handleSearchResults({
                data: data,
                isSearching: false,
                errorText: ''
            })).catch((reason)=>handleSearchResults({
                data: [],
                isSearching: false,
                errorText: (reason === null || reason === void 0 ? void 0 : reason.message) || 'unknown error'
            }));
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "w-full flex",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("form", {
            className: "p-2 w-full",
            onSubmit: handleSubmit,
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                className: "w-96",
                type: "text",
                placeholder: "search threads",
                id: "customSearchField",
                ref: searchEntryField
            })
        })
    });
};
var $cb2440ccedb084f5$export$2e2bcd8739ae039 = $cb2440ccedb084f5$var$ThreadSearchBox;




const $4b8394bab55ada7c$var$NavlinkOutline = ({ toPath: toPath, linkText: linkText })=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "flex-none",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0cf24fd73ae067c$export$b0d92dbee9b5b60d), {
            className: "m-1 px-2 align-middle grow-0 border border-black",
            to: toPath,
            children: linkText
        })
    });
};
var $4b8394bab55ada7c$export$2e2bcd8739ae039 = $4b8394bab55ada7c$var$NavlinkOutline;


const $e1a760571d0383c0$var$initialState = {
    threads: [],
    isSearching: true,
    isError: false
};
const $e1a760571d0383c0$var$Board = ()=>{
    var _state_threads;
    (0, $aba38a333ca575f4$export$efa9a398d6368992).debug('board render');
    const [state, setState] = (0, $7fPBF.useState)($e1a760571d0383c0$var$initialState);
    (0, $7fPBF.useEffect)(()=>{
        (0, $80ff0d33b75baa64$export$1ab060d62ab3aa6b)().then((threads)=>setState({
                threads: threads,
                isSearching: false,
                isError: false
            })).catch((reason)=>setState({
                threads: [],
                isSearching: false,
                isError: true,
                errorText: reason
            }));
    }, [
        (0, $80ff0d33b75baa64$export$1ab060d62ab3aa6b)
    ]);
    const handleSearchResults = (params)=>{
        setState({
            threads: params.data,
            isSearching: params.isSearching,
            isError: !!params.errorText,
            errorText: params.errorText
        });
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "container mx-auto",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "flex align-left",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb2440ccedb084f5$export$2e2bcd8739ae039), {
                            handleSearchResults: handleSearchResults
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "ml-10 p-2 flex",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4b8394bab55ada7c$export$2e2bcd8739ae039), {
                            toPath: "/board-help",
                            linkText: "help"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "mb-10 flex",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4b8394bab55ada7c$export$2e2bcd8739ae039), {
                    toPath: "/new-thread",
                    linkText: "post a new thread"
                })
            }),
            (state === null || state === void 0 ? void 0 : state.isSearching) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "my-10",
                children: "getting the stuff..."
            }),
            !(state === null || state === void 0 ? void 0 : state.isSearching) && !(state === null || state === void 0 ? void 0 : (_state_threads = state.threads) === null || _state_threads === void 0 ? void 0 : _state_threads.length) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "my-10",
                children: "didn't find threads?"
            }),
            (state === null || state === void 0 ? void 0 : state.isError) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "my-10",
                children: [
                    "Error: ",
                    state.errorText
                ]
            }),
            !(state === null || state === void 0 ? void 0 : state.isSearching) && state.threads.map($e1a760571d0383c0$var$getThreadSummaryLine)
        ]
    });
};
function $e1a760571d0383c0$var$getThreadSummaryLine(thread, index) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "w-full",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "bg-white text-s font-bold flex items-center",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                        href: "thread/" + thread.id,
                        children: thread.title
                    }),
                    (thread.tags || []).map((tag, idx)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a1ebeddfa23eef40$export$2e2bcd8739ae039), {
                            bubbleText: tag
                        }, 'thread-' + thread.id + '-tags-' + idx))
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "text-xs font-light",
                children: [
                    ' ',
                    thread.authorHandle,
                    ' ',
                    thread.createDate.toLocaleDateString(undefined, {
                        dateStyle: 'long'
                    })
                ]
            })
        ]
    }, 'chatline-' + index);
}
var $e1a760571d0383c0$export$2e2bcd8739ae039 = $e1a760571d0383c0$var$Board;






var $7fPBF = parcelRequire("7fPBF");



var $c667ec5950b1e0aa$exports = {};
'use strict';

var $7fPBF = parcelRequire("7fPBF");
var $eaf6b2f6c220a664$exports = {};
'use strict';

$eaf6b2f6c220a664$exports = (parcelRequire("4Fkp4"));


var $54c383ef10bfa5a4$exports = {};
'use strict';
var $2fd75206f7b34a41$exports = {};
'use strict';
$2fd75206f7b34a41$exports = $2fd75206f7b34a41$var$bail;
function $2fd75206f7b34a41$var$bail(err) {
    if (err) throw err;
}



var $1KitT = parcelRequire("1KitT");
var $ce3b58bef1324512$exports = {};
'use strict';
var $ce3b58bef1324512$var$hasOwn = Object.prototype.hasOwnProperty;
var $ce3b58bef1324512$var$toStr = Object.prototype.toString;
var $ce3b58bef1324512$var$defineProperty = Object.defineProperty;
var $ce3b58bef1324512$var$gOPD = Object.getOwnPropertyDescriptor;
var $ce3b58bef1324512$var$isArray = function isArray(arr) {
    if (typeof Array.isArray === 'function') return Array.isArray(arr);
    return $ce3b58bef1324512$var$toStr.call(arr) === '[object Array]';
};
var $ce3b58bef1324512$var$isPlainObject = function isPlainObject(obj) {
    if (!obj || $ce3b58bef1324512$var$toStr.call(obj) !== '[object Object]') return false;
    var hasOwnConstructor = $ce3b58bef1324512$var$hasOwn.call(obj, 'constructor');
    var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && $ce3b58bef1324512$var$hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
    // Not own constructor property must be Object
    if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) return false;
    // Own properties are enumerated firstly, so to speed up,
    // if last one is own, then all properties are own.
    var key;
    for(key in obj);
    return typeof key === 'undefined' || $ce3b58bef1324512$var$hasOwn.call(obj, key);
};
// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var $ce3b58bef1324512$var$setProperty = function setProperty(target, options) {
    if ($ce3b58bef1324512$var$defineProperty && options.name === '__proto__') $ce3b58bef1324512$var$defineProperty(target, options.name, {
        enumerable: true,
        configurable: true,
        value: options.newValue,
        writable: true
    });
    else target[options.name] = options.newValue;
};
// Return undefined instead of __proto__ if '__proto__' is not an own property
var $ce3b58bef1324512$var$getProperty = function getProperty(obj, name) {
    if (name === '__proto__') {
        if (!$ce3b58bef1324512$var$hasOwn.call(obj, name)) return void 0;
        else if ($ce3b58bef1324512$var$gOPD) // In early versions of node, obj['__proto__'] is buggy when obj has
        // __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
        return $ce3b58bef1324512$var$gOPD(obj, name).value;
    }
    return obj[name];
};
$ce3b58bef1324512$exports = function extend() {
    var options, name, src, copy, copyIsArray, clone;
    var target = arguments[0];
    var i = 1;
    var length = arguments.length;
    var deep = false;
    // Handle a deep copy situation
    if (typeof target === 'boolean') {
        deep = target;
        target = arguments[1] || {};
        // skip the boolean and the target
        i = 2;
    }
    if (target == null || typeof target !== 'object' && typeof target !== 'function') target = {};
    for(; i < length; ++i){
        options = arguments[i];
        // Only deal with non-null/undefined values
        if (options != null) // Extend the base object
        for(name in options){
            src = $ce3b58bef1324512$var$getProperty(target, name);
            copy = $ce3b58bef1324512$var$getProperty(options, name);
            // Prevent never-ending loop
            if (target !== copy) {
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && ($ce3b58bef1324512$var$isPlainObject(copy) || (copyIsArray = $ce3b58bef1324512$var$isArray(copy)))) {
                    if (copyIsArray) {
                        copyIsArray = false;
                        clone = src && $ce3b58bef1324512$var$isArray(src) ? src : [];
                    } else clone = src && $ce3b58bef1324512$var$isPlainObject(src) ? src : {};
                    // Never move original objects, clone them
                    $ce3b58bef1324512$var$setProperty(target, {
                        name: name,
                        newValue: extend(deep, clone, copy)
                    });
                // Don't bring in undefined values
                } else if (typeof copy !== 'undefined') $ce3b58bef1324512$var$setProperty(target, {
                    name: name,
                    newValue: copy
                });
            }
        }
    }
    // Return the modified object
    return target;
};


var $89bf888846328aa6$exports = {};
'use strict';
$89bf888846328aa6$exports = (value)=>{
    if (Object.prototype.toString.call(value) !== '[object Object]') return false;
    const prototype = Object.getPrototypeOf(value);
    return prototype === null || prototype === Object.prototype;
};


var $8524fb273383fb8d$exports = {};
'use strict';
var $3a797ccf0b79b816$exports = {};
'use strict';
var $3a797ccf0b79b816$var$slice = [].slice;
$3a797ccf0b79b816$exports = $3a797ccf0b79b816$var$wrap;
// Wrap `fn`.
// Can be sync or async; return a promise, receive a completion handler, return
// new values and errors.
function $3a797ccf0b79b816$var$wrap(fn, callback) {
    var invoked;
    return wrapped;
    function wrapped() {
        var params = $3a797ccf0b79b816$var$slice.call(arguments, 0);
        var callback = fn.length > params.length;
        var result;
        if (callback) params.push(done);
        try {
            result = fn.apply(null, params);
        } catch (error) {
            // Well, this is quite the pickle.
            // `fn` received a callback and invoked it (thus continuing the pipeline),
            // but later also threw an error.
            // We’re not about to restart the pipeline again, so the only thing left
            // to do is to throw the thing instead.
            if (callback && invoked) throw error;
            return done(error);
        }
        if (!callback) {
            if (result && typeof result.then === 'function') result.then(then, done);
            else if (result instanceof Error) done(result);
            else then(result);
        }
    }
    // Invoke `next`, only once.
    function done() {
        if (!invoked) {
            invoked = true;
            callback.apply(null, arguments);
        }
    }
    // Invoke `done` with one value.
    // Tracks if an error is passed, too.
    function then(value) {
        done(null, value);
    }
}


$8524fb273383fb8d$exports = $8524fb273383fb8d$var$trough;
$8524fb273383fb8d$var$trough.wrap = $3a797ccf0b79b816$exports;
var $8524fb273383fb8d$var$slice = [].slice;
// Create new middleware.
function $8524fb273383fb8d$var$trough() {
    var fns = [];
    var middleware = {};
    middleware.run = run;
    middleware.use = use;
    return middleware;
    // Run `fns`.  Last argument must be a completion handler.
    function run() {
        var index = -1;
        var input = $8524fb273383fb8d$var$slice.call(arguments, 0, -1);
        var done = arguments[arguments.length - 1];
        if (typeof done !== 'function') throw new Error('Expected function as last argument, not ' + done);
        next.apply(null, [
            null
        ].concat(input));
        // Run the next `fn`, if any.
        function next(err) {
            var fn = fns[++index];
            var params = $8524fb273383fb8d$var$slice.call(arguments, 0);
            var values = params.slice(1);
            var length = input.length;
            var pos = -1;
            if (err) {
                done(err);
                return;
            }
            // Copy non-nully input into values.
            while(++pos < length)if (values[pos] === null || values[pos] === undefined) values[pos] = input[pos];
            input = values;
            // Next or done.
            if (fn) $3a797ccf0b79b816$exports(fn, next).apply(null, input);
            else done.apply(null, [
                null
            ].concat(input));
        }
    }
    // Add `fn` to the list.
    function use(fn) {
        if (typeof fn !== 'function') throw new Error('Expected `fn` to be a function, not ' + fn);
        fns.push(fn);
        return middleware;
    }
}



// Expose a frozen processor.
$54c383ef10bfa5a4$exports = $54c383ef10bfa5a4$var$unified().freeze();
var $54c383ef10bfa5a4$var$slice = [].slice;
var $54c383ef10bfa5a4$var$own = {}.hasOwnProperty;
// Process pipeline.
var $54c383ef10bfa5a4$var$pipeline = $8524fb273383fb8d$exports().use($54c383ef10bfa5a4$var$pipelineParse).use($54c383ef10bfa5a4$var$pipelineRun).use($54c383ef10bfa5a4$var$pipelineStringify);
function $54c383ef10bfa5a4$var$pipelineParse(p, ctx) {
    ctx.tree = p.parse(ctx.file);
}
function $54c383ef10bfa5a4$var$pipelineRun(p, ctx, next) {
    p.run(ctx.tree, ctx.file, done);
    function done(error, tree, file) {
        if (error) next(error);
        else {
            ctx.tree = tree;
            ctx.file = file;
            next();
        }
    }
}
function $54c383ef10bfa5a4$var$pipelineStringify(p, ctx) {
    var result = p.stringify(ctx.tree, ctx.file);
    if (result === undefined || result === null) ;
    else if (typeof result === 'string' || $1KitT(result)) {
        if ('value' in ctx.file) ctx.file.value = result;
        ctx.file.contents = result;
    } else ctx.file.result = result;
}
// Function to create the first processor.
function $54c383ef10bfa5a4$var$unified() {
    var attachers = [];
    var transformers = $8524fb273383fb8d$exports();
    var namespace = {};
    var freezeIndex = -1;
    var frozen;
    // Data management.
    processor.data = data;
    // Lock.
    processor.freeze = freeze;
    // Plugins.
    processor.attachers = attachers;
    processor.use = use;
    // API.
    processor.parse = parse;
    processor.stringify = stringify;
    processor.run = run;
    processor.runSync = runSync;
    processor.process = process;
    processor.processSync = processSync;
    // Expose.
    return processor;
    // Create a new processor based on the processor in the current scope.
    function processor() {
        var destination = $54c383ef10bfa5a4$var$unified();
        var index = -1;
        while(++index < attachers.length)destination.use.apply(null, attachers[index]);
        destination.data($ce3b58bef1324512$exports(true, {}, namespace));
        return destination;
    }
    // Freeze: used to signal a processor that has finished configuration.
    //
    // For example, take unified itself: it’s frozen.
    // Plugins should not be added to it.
    // Rather, it should be extended, by invoking it, before modifying it.
    //
    // In essence, always invoke this when exporting a processor.
    function freeze() {
        var values;
        var transformer;
        if (frozen) return processor;
        while(++freezeIndex < attachers.length){
            values = attachers[freezeIndex];
            if (values[1] === false) continue;
            if (values[1] === true) values[1] = undefined;
            transformer = values[0].apply(processor, values.slice(1));
            if (typeof transformer === 'function') transformers.use(transformer);
        }
        frozen = true;
        freezeIndex = Infinity;
        return processor;
    }
    // Data management.
    // Getter / setter for processor-specific informtion.
    function data(key, value) {
        if (typeof key === 'string') {
            // Set `key`.
            if (arguments.length === 2) {
                $54c383ef10bfa5a4$var$assertUnfrozen('data', frozen);
                namespace[key] = value;
                return processor;
            }
            // Get `key`.
            return $54c383ef10bfa5a4$var$own.call(namespace, key) && namespace[key] || null;
        }
        // Set space.
        if (key) {
            $54c383ef10bfa5a4$var$assertUnfrozen('data', frozen);
            namespace = key;
            return processor;
        }
        // Get space.
        return namespace;
    }
    // Plugin management.
    //
    // Pass it:
    // *   an attacher and options,
    // *   a preset,
    // *   a list of presets, attachers, and arguments (list of attachers and
    //     options).
    function use(value) {
        var settings;
        $54c383ef10bfa5a4$var$assertUnfrozen('use', frozen);
        if (value === null || value === undefined) ;
        else if (typeof value === 'function') addPlugin.apply(null, arguments);
        else if (typeof value === 'object') {
            if ('length' in value) addList(value);
            else addPreset(value);
        } else throw new Error('Expected usable value, not `' + value + '`');
        if (settings) namespace.settings = $ce3b58bef1324512$exports(namespace.settings || {}, settings);
        return processor;
        function addPreset(result) {
            addList(result.plugins);
            if (result.settings) settings = $ce3b58bef1324512$exports(settings || {}, result.settings);
        }
        function add(value) {
            if (typeof value === 'function') addPlugin(value);
            else if (typeof value === 'object') {
                if ('length' in value) addPlugin.apply(null, value);
                else addPreset(value);
            } else throw new Error('Expected usable value, not `' + value + '`');
        }
        function addList(plugins) {
            var index = -1;
            if (plugins === null || plugins === undefined) ;
            else if (typeof plugins === 'object' && 'length' in plugins) while(++index < plugins.length)add(plugins[index]);
            else throw new Error('Expected a list of plugins, not `' + plugins + '`');
        }
        function addPlugin(plugin, value) {
            var entry = find(plugin);
            if (entry) {
                if ($89bf888846328aa6$exports(entry[1]) && $89bf888846328aa6$exports(value)) value = $ce3b58bef1324512$exports(true, entry[1], value);
                entry[1] = value;
            } else attachers.push($54c383ef10bfa5a4$var$slice.call(arguments));
        }
    }
    function find(plugin) {
        var index = -1;
        while(++index < attachers.length){
            if (attachers[index][0] === plugin) return attachers[index];
        }
    }
    // Parse a file (in string or vfile representation) into a unist node using
    // the `Parser` on the processor.
    function parse(doc) {
        var file = $eaf6b2f6c220a664$exports(doc);
        var Parser;
        freeze();
        Parser = processor.Parser;
        $54c383ef10bfa5a4$var$assertParser('parse', Parser);
        if ($54c383ef10bfa5a4$var$newable(Parser, 'parse')) return new Parser(String(file), file).parse();
        return Parser(String(file), file) // eslint-disable-line new-cap
        ;
    }
    // Run transforms on a unist node representation of a file (in string or
    // vfile representation), async.
    function run(node, file, cb) {
        $54c383ef10bfa5a4$var$assertNode(node);
        freeze();
        if (!cb && typeof file === 'function') {
            cb = file;
            file = null;
        }
        if (!cb) return new Promise(executor);
        executor(null, cb);
        function executor(resolve, reject) {
            transformers.run(node, $eaf6b2f6c220a664$exports(file), done);
            function done(error, tree, file) {
                tree = tree || node;
                if (error) reject(error);
                else if (resolve) resolve(tree);
                else cb(null, tree, file);
            }
        }
    }
    // Run transforms on a unist node representation of a file (in string or
    // vfile representation), sync.
    function runSync(node, file) {
        var result;
        var complete;
        run(node, file, done);
        $54c383ef10bfa5a4$var$assertDone('runSync', 'run', complete);
        return result;
        function done(error, tree) {
            complete = true;
            result = tree;
            $2fd75206f7b34a41$exports(error);
        }
    }
    // Stringify a unist node representation of a file (in string or vfile
    // representation) into a string using the `Compiler` on the processor.
    function stringify(node, doc) {
        var file = $eaf6b2f6c220a664$exports(doc);
        var Compiler;
        freeze();
        Compiler = processor.Compiler;
        $54c383ef10bfa5a4$var$assertCompiler('stringify', Compiler);
        $54c383ef10bfa5a4$var$assertNode(node);
        if ($54c383ef10bfa5a4$var$newable(Compiler, 'compile')) return new Compiler(node, file).compile();
        return Compiler(node, file) // eslint-disable-line new-cap
        ;
    }
    // Parse a file (in string or vfile representation) into a unist node using
    // the `Parser` on the processor, then run transforms on that node, and
    // compile the resulting node using the `Compiler` on the processor, and
    // store that result on the vfile.
    function process(doc, cb) {
        freeze();
        $54c383ef10bfa5a4$var$assertParser('process', processor.Parser);
        $54c383ef10bfa5a4$var$assertCompiler('process', processor.Compiler);
        if (!cb) return new Promise(executor);
        executor(null, cb);
        function executor(resolve, reject) {
            var file = $eaf6b2f6c220a664$exports(doc);
            $54c383ef10bfa5a4$var$pipeline.run(processor, {
                file: file
            }, done);
            function done(error) {
                if (error) reject(error);
                else if (resolve) resolve(file);
                else cb(null, file);
            }
        }
    }
    // Process the given document (in string or vfile representation), sync.
    function processSync(doc) {
        var file;
        var complete;
        freeze();
        $54c383ef10bfa5a4$var$assertParser('processSync', processor.Parser);
        $54c383ef10bfa5a4$var$assertCompiler('processSync', processor.Compiler);
        file = $eaf6b2f6c220a664$exports(doc);
        process(file, done);
        $54c383ef10bfa5a4$var$assertDone('processSync', 'process', complete);
        return file;
        function done(error) {
            complete = true;
            $2fd75206f7b34a41$exports(error);
        }
    }
}
// Check if `value` is a constructor.
function $54c383ef10bfa5a4$var$newable(value, name) {
    return typeof value === 'function' && value.prototype && // A function with keys in its prototype is probably a constructor.
    // Classes’ prototype methods are not enumerable, so we check if some value
    // exists in the prototype.
    ($54c383ef10bfa5a4$var$keys(value.prototype) || name in value.prototype);
}
// Check if `value` is an object with keys.
function $54c383ef10bfa5a4$var$keys(value) {
    var key;
    for(key in value)return true;
    return false;
}
// Assert a parser is available.
function $54c383ef10bfa5a4$var$assertParser(name, Parser) {
    if (typeof Parser !== 'function') throw new Error('Cannot `' + name + '` without `Parser`');
}
// Assert a compiler is available.
function $54c383ef10bfa5a4$var$assertCompiler(name, Compiler) {
    if (typeof Compiler !== 'function') throw new Error('Cannot `' + name + '` without `Compiler`');
}
// Assert the processor is not frozen.
function $54c383ef10bfa5a4$var$assertUnfrozen(name, frozen) {
    if (frozen) throw new Error('Cannot invoke `' + name + '` on a frozen processor.\nCreate a new processor first, by invoking it: use `processor()` instead of `processor`.');
}
// Assert `node` is a unist node.
function $54c383ef10bfa5a4$var$assertNode(node) {
    if (!node || typeof node.type !== 'string') throw new Error('Expected node, got `' + node + '`');
}
// Assert that `complete` is `true`.
function $54c383ef10bfa5a4$var$assertDone(name, asyncName, complete) {
    if (!complete) throw new Error('`' + name + '` finished async. Use `' + asyncName + '` instead');
}


var $25f56eac28db4d8b$exports = {};
'use strict';
$25f56eac28db4d8b$exports = $25f56eac28db4d8b$var$parse;
var $3b6012969593a72a$exports = {};
'use strict';

$3b6012969593a72a$exports = (parcelRequire("l8YWZ"));


function $25f56eac28db4d8b$var$parse(options) {
    var self = this;
    this.Parser = parse;
    function parse(doc) {
        return $3b6012969593a72a$exports(doc, Object.assign({}, self.data('settings'), options, {
            // Note: these options are not in the readme.
            // The goal is for them to be set by plugins on `data` instead of being
            // passed by users.
            extensions: self.data('micromarkExtensions') || [],
            mdastExtensions: self.data('fromMarkdownExtensions') || []
        }));
    }
}


var $4a1785e53c97ab0a$exports = {};
'use strict';
var $ab7a00b70b92bf31$exports = {};
'use strict';

$ab7a00b70b92bf31$exports = (parcelRequire("5N7qR"));


$4a1785e53c97ab0a$exports = $4a1785e53c97ab0a$var$remark2rehype;
// Attacher.
// If a destination is given, runs the destination with the new hast tree
// (bridge mode).
// Without destination, returns the tree: further plugins run on that tree
// (mutate mode).
function $4a1785e53c97ab0a$var$remark2rehype(destination, options) {
    if (destination && !destination.process) {
        options = destination;
        destination = null;
    }
    return destination ? $4a1785e53c97ab0a$var$bridge(destination, options) : $4a1785e53c97ab0a$var$mutate(options);
}
// Bridge mode.
// Runs the destination with the new hast tree.
function $4a1785e53c97ab0a$var$bridge(destination, options) {
    return transformer;
    function transformer(node, file, next) {
        destination.run($ab7a00b70b92bf31$exports(node, options), file, done);
        function done(error) {
            next(error);
        }
    }
}
// Mutate-mode.
// Further transformers run on the hast tree.
function $4a1785e53c97ab0a$var$mutate(options) {
    return transformer;
    function transformer(node) {
        return $ab7a00b70b92bf31$exports(node, options);
    }
}


var $1bfc5778dcd4841a$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1bfc5778dcd4841a$var$ReactIs, $1bfc5778dcd4841a$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$1bfc5778dcd4841a$exports = (parcelRequire("iDep4"))();


var $08f3dd16e830a549$exports = {};
'use strict';
var $f22be46171b10c63$exports = {};
'use strict';
var $7abb6251c8c91105$exports = {};
$7abb6251c8c91105$exports = $7abb6251c8c91105$var$extend;
var $7abb6251c8c91105$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $7abb6251c8c91105$var$extend() {
    var target = {};
    for(var i = 0; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if ($7abb6251c8c91105$var$hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
}


var $3f644418d59ec988$exports = {};
'use strict';
$3f644418d59ec988$exports = $3f644418d59ec988$var$Schema;
var $3f644418d59ec988$var$proto = $3f644418d59ec988$var$Schema.prototype;
$3f644418d59ec988$var$proto.space = null;
$3f644418d59ec988$var$proto.normal = {};
$3f644418d59ec988$var$proto.property = {};
function $3f644418d59ec988$var$Schema(property, normal, space) {
    this.property = property;
    this.normal = normal;
    if (space) this.space = space;
}


$f22be46171b10c63$exports = $f22be46171b10c63$var$merge;
function $f22be46171b10c63$var$merge(definitions) {
    var length = definitions.length;
    var property = [];
    var normal = [];
    var index = -1;
    var info;
    var space;
    while(++index < length){
        info = definitions[index];
        property.push(info.property);
        normal.push(info.normal);
        space = info.space;
    }
    return new $3f644418d59ec988$exports($7abb6251c8c91105$exports.apply(null, property), $7abb6251c8c91105$exports.apply(null, normal), space);
}


var $f7b1fe9153b66aca$exports = {};
'use strict';
var $9241b59662c8e4b9$exports = {};
'use strict';
var $3995591220cdf091$exports = {};
'use strict';
$3995591220cdf091$exports = $3995591220cdf091$var$normalize;
function $3995591220cdf091$var$normalize(value) {
    return value.toLowerCase();
}



var $e9abde33d3611e8d$exports = {};
'use strict';
var $f5a64e1dc26e2922$exports = {};
'use strict';
$f5a64e1dc26e2922$exports = $f5a64e1dc26e2922$var$Info;
var $f5a64e1dc26e2922$var$proto = $f5a64e1dc26e2922$var$Info.prototype;
$f5a64e1dc26e2922$var$proto.space = null;
$f5a64e1dc26e2922$var$proto.attribute = null;
$f5a64e1dc26e2922$var$proto.property = null;
$f5a64e1dc26e2922$var$proto.boolean = false;
$f5a64e1dc26e2922$var$proto.booleanish = false;
$f5a64e1dc26e2922$var$proto.overloadedBoolean = false;
$f5a64e1dc26e2922$var$proto.number = false;
$f5a64e1dc26e2922$var$proto.commaSeparated = false;
$f5a64e1dc26e2922$var$proto.spaceSeparated = false;
$f5a64e1dc26e2922$var$proto.commaOrSpaceSeparated = false;
$f5a64e1dc26e2922$var$proto.mustUseProperty = false;
$f5a64e1dc26e2922$var$proto.defined = false;
function $f5a64e1dc26e2922$var$Info(property, attribute) {
    this.property = property;
    this.attribute = attribute;
}


var $6327116045afe73c$exports = {};

$parcel$export($6327116045afe73c$exports, "boolean", function () { return $6327116045afe73c$export$4a21f16c33752377; }, function (v) { return $6327116045afe73c$export$4a21f16c33752377 = v; });
$parcel$export($6327116045afe73c$exports, "booleanish", function () { return $6327116045afe73c$export$55e9e1fbc638dc8f; }, function (v) { return $6327116045afe73c$export$55e9e1fbc638dc8f = v; });
$parcel$export($6327116045afe73c$exports, "overloadedBoolean", function () { return $6327116045afe73c$export$242ac3d3042558aa; }, function (v) { return $6327116045afe73c$export$242ac3d3042558aa = v; });
$parcel$export($6327116045afe73c$exports, "number", function () { return $6327116045afe73c$export$98e628dec113755e; }, function (v) { return $6327116045afe73c$export$98e628dec113755e = v; });
$parcel$export($6327116045afe73c$exports, "spaceSeparated", function () { return $6327116045afe73c$export$ab8645c862eb5a3e; }, function (v) { return $6327116045afe73c$export$ab8645c862eb5a3e = v; });
$parcel$export($6327116045afe73c$exports, "commaSeparated", function () { return $6327116045afe73c$export$9c8d678629b3d3; }, function (v) { return $6327116045afe73c$export$9c8d678629b3d3 = v; });
$parcel$export($6327116045afe73c$exports, "commaOrSpaceSeparated", function () { return $6327116045afe73c$export$2ad25cfebf36cacd; }, function (v) { return $6327116045afe73c$export$2ad25cfebf36cacd = v; });
var $6327116045afe73c$export$4a21f16c33752377;
var $6327116045afe73c$export$55e9e1fbc638dc8f;
var $6327116045afe73c$export$242ac3d3042558aa;
var $6327116045afe73c$export$98e628dec113755e;
var $6327116045afe73c$export$ab8645c862eb5a3e;
var $6327116045afe73c$export$9c8d678629b3d3;
var $6327116045afe73c$export$2ad25cfebf36cacd;
'use strict';
var $6327116045afe73c$var$powers = 0;
$6327116045afe73c$export$4a21f16c33752377 = $6327116045afe73c$var$increment();
$6327116045afe73c$export$55e9e1fbc638dc8f = $6327116045afe73c$var$increment();
$6327116045afe73c$export$242ac3d3042558aa = $6327116045afe73c$var$increment();
$6327116045afe73c$export$98e628dec113755e = $6327116045afe73c$var$increment();
$6327116045afe73c$export$ab8645c862eb5a3e = $6327116045afe73c$var$increment();
$6327116045afe73c$export$9c8d678629b3d3 = $6327116045afe73c$var$increment();
$6327116045afe73c$export$2ad25cfebf36cacd = $6327116045afe73c$var$increment();
function $6327116045afe73c$var$increment() {
    return Math.pow(2, ++$6327116045afe73c$var$powers);
}


$e9abde33d3611e8d$exports = $e9abde33d3611e8d$var$DefinedInfo;
$e9abde33d3611e8d$var$DefinedInfo.prototype = new $f5a64e1dc26e2922$exports();
$e9abde33d3611e8d$var$DefinedInfo.prototype.defined = true;
var $e9abde33d3611e8d$var$checks = [
    'boolean',
    'booleanish',
    'overloadedBoolean',
    'number',
    'commaSeparated',
    'spaceSeparated',
    'commaOrSpaceSeparated'
];
var $e9abde33d3611e8d$var$checksLength = $e9abde33d3611e8d$var$checks.length;
function $e9abde33d3611e8d$var$DefinedInfo(property, attribute, mask, space) {
    var index = -1;
    var check;
    $e9abde33d3611e8d$var$mark(this, 'space', space);
    $f5a64e1dc26e2922$exports.call(this, property, attribute);
    while(++index < $e9abde33d3611e8d$var$checksLength){
        check = $e9abde33d3611e8d$var$checks[index];
        $e9abde33d3611e8d$var$mark(this, check, (mask & $6327116045afe73c$exports[check]) === $6327116045afe73c$exports[check]);
    }
}
function $e9abde33d3611e8d$var$mark(values, key, value) {
    if (value) values[key] = value;
}


$9241b59662c8e4b9$exports = $9241b59662c8e4b9$var$create;
function $9241b59662c8e4b9$var$create(definition) {
    var space = definition.space;
    var mustUseProperty = definition.mustUseProperty || [];
    var attributes = definition.attributes || {};
    var props = definition.properties;
    var transform = definition.transform;
    var property = {};
    var normal = {};
    var prop;
    var info;
    for(prop in props){
        info = new $e9abde33d3611e8d$exports(prop, transform(attributes, prop), props[prop], space);
        if (mustUseProperty.indexOf(prop) !== -1) info.mustUseProperty = true;
        property[prop] = info;
        normal[$3995591220cdf091$exports(prop)] = prop;
        normal[$3995591220cdf091$exports(info.attribute)] = prop;
    }
    return new $3f644418d59ec988$exports(property, normal, space);
}


$f7b1fe9153b66aca$exports = $9241b59662c8e4b9$exports({
    space: 'xlink',
    transform: $f7b1fe9153b66aca$var$xlinkTransform,
    properties: {
        xLinkActuate: null,
        xLinkArcRole: null,
        xLinkHref: null,
        xLinkRole: null,
        xLinkShow: null,
        xLinkTitle: null,
        xLinkType: null
    }
});
function $f7b1fe9153b66aca$var$xlinkTransform(_, prop) {
    return 'xlink:' + prop.slice(5).toLowerCase();
}


var $2258d34ea2045e6e$exports = {};
'use strict';

$2258d34ea2045e6e$exports = $9241b59662c8e4b9$exports({
    space: 'xml',
    transform: $2258d34ea2045e6e$var$xmlTransform,
    properties: {
        xmlLang: null,
        xmlBase: null,
        xmlSpace: null
    }
});
function $2258d34ea2045e6e$var$xmlTransform(_, prop) {
    return 'xml:' + prop.slice(3).toLowerCase();
}


var $d677600be62c9ee2$exports = {};
'use strict';

var $f66392ca00ae8b5e$exports = {};
'use strict';
var $57102789fbb4388b$exports = {};
'use strict';
$57102789fbb4388b$exports = $57102789fbb4388b$var$caseSensitiveTransform;
function $57102789fbb4388b$var$caseSensitiveTransform(attributes, attribute) {
    return attribute in attributes ? attributes[attribute] : attribute;
}


$f66392ca00ae8b5e$exports = $f66392ca00ae8b5e$var$caseInsensitiveTransform;
function $f66392ca00ae8b5e$var$caseInsensitiveTransform(attributes, property) {
    return $57102789fbb4388b$exports(attributes, property.toLowerCase());
}


$d677600be62c9ee2$exports = $9241b59662c8e4b9$exports({
    space: 'xmlns',
    attributes: {
        xmlnsxlink: 'xmlns:xlink'
    },
    transform: $f66392ca00ae8b5e$exports,
    properties: {
        xmlns: null,
        xmlnsXLink: null
    }
});


var $f6c2d7ac952f45ea$exports = {};
'use strict';


var $f6c2d7ac952f45ea$var$booleanish = $6327116045afe73c$export$55e9e1fbc638dc8f;
var $f6c2d7ac952f45ea$var$number = $6327116045afe73c$export$98e628dec113755e;
var $f6c2d7ac952f45ea$var$spaceSeparated = $6327116045afe73c$export$ab8645c862eb5a3e;
$f6c2d7ac952f45ea$exports = $9241b59662c8e4b9$exports({
    transform: $f6c2d7ac952f45ea$var$ariaTransform,
    properties: {
        ariaActiveDescendant: null,
        ariaAtomic: $f6c2d7ac952f45ea$var$booleanish,
        ariaAutoComplete: null,
        ariaBusy: $f6c2d7ac952f45ea$var$booleanish,
        ariaChecked: $f6c2d7ac952f45ea$var$booleanish,
        ariaColCount: $f6c2d7ac952f45ea$var$number,
        ariaColIndex: $f6c2d7ac952f45ea$var$number,
        ariaColSpan: $f6c2d7ac952f45ea$var$number,
        ariaControls: $f6c2d7ac952f45ea$var$spaceSeparated,
        ariaCurrent: null,
        ariaDescribedBy: $f6c2d7ac952f45ea$var$spaceSeparated,
        ariaDetails: null,
        ariaDisabled: $f6c2d7ac952f45ea$var$booleanish,
        ariaDropEffect: $f6c2d7ac952f45ea$var$spaceSeparated,
        ariaErrorMessage: null,
        ariaExpanded: $f6c2d7ac952f45ea$var$booleanish,
        ariaFlowTo: $f6c2d7ac952f45ea$var$spaceSeparated,
        ariaGrabbed: $f6c2d7ac952f45ea$var$booleanish,
        ariaHasPopup: null,
        ariaHidden: $f6c2d7ac952f45ea$var$booleanish,
        ariaInvalid: null,
        ariaKeyShortcuts: null,
        ariaLabel: null,
        ariaLabelledBy: $f6c2d7ac952f45ea$var$spaceSeparated,
        ariaLevel: $f6c2d7ac952f45ea$var$number,
        ariaLive: null,
        ariaModal: $f6c2d7ac952f45ea$var$booleanish,
        ariaMultiLine: $f6c2d7ac952f45ea$var$booleanish,
        ariaMultiSelectable: $f6c2d7ac952f45ea$var$booleanish,
        ariaOrientation: null,
        ariaOwns: $f6c2d7ac952f45ea$var$spaceSeparated,
        ariaPlaceholder: null,
        ariaPosInSet: $f6c2d7ac952f45ea$var$number,
        ariaPressed: $f6c2d7ac952f45ea$var$booleanish,
        ariaReadOnly: $f6c2d7ac952f45ea$var$booleanish,
        ariaRelevant: null,
        ariaRequired: $f6c2d7ac952f45ea$var$booleanish,
        ariaRoleDescription: $f6c2d7ac952f45ea$var$spaceSeparated,
        ariaRowCount: $f6c2d7ac952f45ea$var$number,
        ariaRowIndex: $f6c2d7ac952f45ea$var$number,
        ariaRowSpan: $f6c2d7ac952f45ea$var$number,
        ariaSelected: $f6c2d7ac952f45ea$var$booleanish,
        ariaSetSize: $f6c2d7ac952f45ea$var$number,
        ariaSort: null,
        ariaValueMax: $f6c2d7ac952f45ea$var$number,
        ariaValueMin: $f6c2d7ac952f45ea$var$number,
        ariaValueNow: $f6c2d7ac952f45ea$var$number,
        ariaValueText: null,
        role: null
    }
});
function $f6c2d7ac952f45ea$var$ariaTransform(_, prop) {
    return prop === 'role' ? prop : 'aria-' + prop.slice(4).toLowerCase();
}


var $aed0b684443ef64e$exports = {};
'use strict';



var $aed0b684443ef64e$var$boolean = $6327116045afe73c$export$4a21f16c33752377;
var $aed0b684443ef64e$var$overloadedBoolean = $6327116045afe73c$export$242ac3d3042558aa;
var $aed0b684443ef64e$var$booleanish = $6327116045afe73c$export$55e9e1fbc638dc8f;
var $aed0b684443ef64e$var$number = $6327116045afe73c$export$98e628dec113755e;
var $aed0b684443ef64e$var$spaceSeparated = $6327116045afe73c$export$ab8645c862eb5a3e;
var $aed0b684443ef64e$var$commaSeparated = $6327116045afe73c$export$9c8d678629b3d3;
$aed0b684443ef64e$exports = $9241b59662c8e4b9$exports({
    space: 'html',
    attributes: {
        acceptcharset: 'accept-charset',
        classname: 'class',
        htmlfor: 'for',
        httpequiv: 'http-equiv'
    },
    transform: $f66392ca00ae8b5e$exports,
    mustUseProperty: [
        'checked',
        'multiple',
        'muted',
        'selected'
    ],
    properties: {
        // Standard Properties.
        abbr: null,
        accept: $aed0b684443ef64e$var$commaSeparated,
        acceptCharset: $aed0b684443ef64e$var$spaceSeparated,
        accessKey: $aed0b684443ef64e$var$spaceSeparated,
        action: null,
        allow: null,
        allowFullScreen: $aed0b684443ef64e$var$boolean,
        allowPaymentRequest: $aed0b684443ef64e$var$boolean,
        allowUserMedia: $aed0b684443ef64e$var$boolean,
        alt: null,
        as: null,
        async: $aed0b684443ef64e$var$boolean,
        autoCapitalize: null,
        autoComplete: $aed0b684443ef64e$var$spaceSeparated,
        autoFocus: $aed0b684443ef64e$var$boolean,
        autoPlay: $aed0b684443ef64e$var$boolean,
        capture: $aed0b684443ef64e$var$boolean,
        charSet: null,
        checked: $aed0b684443ef64e$var$boolean,
        cite: null,
        className: $aed0b684443ef64e$var$spaceSeparated,
        cols: $aed0b684443ef64e$var$number,
        colSpan: null,
        content: null,
        contentEditable: $aed0b684443ef64e$var$booleanish,
        controls: $aed0b684443ef64e$var$boolean,
        controlsList: $aed0b684443ef64e$var$spaceSeparated,
        coords: $aed0b684443ef64e$var$number | $aed0b684443ef64e$var$commaSeparated,
        crossOrigin: null,
        data: null,
        dateTime: null,
        decoding: null,
        default: $aed0b684443ef64e$var$boolean,
        defer: $aed0b684443ef64e$var$boolean,
        dir: null,
        dirName: null,
        disabled: $aed0b684443ef64e$var$boolean,
        download: $aed0b684443ef64e$var$overloadedBoolean,
        draggable: $aed0b684443ef64e$var$booleanish,
        encType: null,
        enterKeyHint: null,
        form: null,
        formAction: null,
        formEncType: null,
        formMethod: null,
        formNoValidate: $aed0b684443ef64e$var$boolean,
        formTarget: null,
        headers: $aed0b684443ef64e$var$spaceSeparated,
        height: $aed0b684443ef64e$var$number,
        hidden: $aed0b684443ef64e$var$boolean,
        high: $aed0b684443ef64e$var$number,
        href: null,
        hrefLang: null,
        htmlFor: $aed0b684443ef64e$var$spaceSeparated,
        httpEquiv: $aed0b684443ef64e$var$spaceSeparated,
        id: null,
        imageSizes: null,
        imageSrcSet: $aed0b684443ef64e$var$commaSeparated,
        inputMode: null,
        integrity: null,
        is: null,
        isMap: $aed0b684443ef64e$var$boolean,
        itemId: null,
        itemProp: $aed0b684443ef64e$var$spaceSeparated,
        itemRef: $aed0b684443ef64e$var$spaceSeparated,
        itemScope: $aed0b684443ef64e$var$boolean,
        itemType: $aed0b684443ef64e$var$spaceSeparated,
        kind: null,
        label: null,
        lang: null,
        language: null,
        list: null,
        loading: null,
        loop: $aed0b684443ef64e$var$boolean,
        low: $aed0b684443ef64e$var$number,
        manifest: null,
        max: null,
        maxLength: $aed0b684443ef64e$var$number,
        media: null,
        method: null,
        min: null,
        minLength: $aed0b684443ef64e$var$number,
        multiple: $aed0b684443ef64e$var$boolean,
        muted: $aed0b684443ef64e$var$boolean,
        name: null,
        nonce: null,
        noModule: $aed0b684443ef64e$var$boolean,
        noValidate: $aed0b684443ef64e$var$boolean,
        onAbort: null,
        onAfterPrint: null,
        onAuxClick: null,
        onBeforePrint: null,
        onBeforeUnload: null,
        onBlur: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onContextMenu: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFormData: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLanguageChange: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadEnd: null,
        onLoadStart: null,
        onMessage: null,
        onMessageError: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRejectionHandled: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onSecurityPolicyViolation: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onSlotChange: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnhandledRejection: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onWheel: null,
        open: $aed0b684443ef64e$var$boolean,
        optimum: $aed0b684443ef64e$var$number,
        pattern: null,
        ping: $aed0b684443ef64e$var$spaceSeparated,
        placeholder: null,
        playsInline: $aed0b684443ef64e$var$boolean,
        poster: null,
        preload: null,
        readOnly: $aed0b684443ef64e$var$boolean,
        referrerPolicy: null,
        rel: $aed0b684443ef64e$var$spaceSeparated,
        required: $aed0b684443ef64e$var$boolean,
        reversed: $aed0b684443ef64e$var$boolean,
        rows: $aed0b684443ef64e$var$number,
        rowSpan: $aed0b684443ef64e$var$number,
        sandbox: $aed0b684443ef64e$var$spaceSeparated,
        scope: null,
        scoped: $aed0b684443ef64e$var$boolean,
        seamless: $aed0b684443ef64e$var$boolean,
        selected: $aed0b684443ef64e$var$boolean,
        shape: null,
        size: $aed0b684443ef64e$var$number,
        sizes: null,
        slot: null,
        span: $aed0b684443ef64e$var$number,
        spellCheck: $aed0b684443ef64e$var$booleanish,
        src: null,
        srcDoc: null,
        srcLang: null,
        srcSet: $aed0b684443ef64e$var$commaSeparated,
        start: $aed0b684443ef64e$var$number,
        step: null,
        style: null,
        tabIndex: $aed0b684443ef64e$var$number,
        target: null,
        title: null,
        translate: null,
        type: null,
        typeMustMatch: $aed0b684443ef64e$var$boolean,
        useMap: null,
        value: $aed0b684443ef64e$var$booleanish,
        width: $aed0b684443ef64e$var$number,
        wrap: null,
        // Legacy.
        // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
        align: null,
        aLink: null,
        archive: $aed0b684443ef64e$var$spaceSeparated,
        axis: null,
        background: null,
        bgColor: null,
        border: $aed0b684443ef64e$var$number,
        borderColor: null,
        bottomMargin: $aed0b684443ef64e$var$number,
        cellPadding: null,
        cellSpacing: null,
        char: null,
        charOff: null,
        classId: null,
        clear: null,
        code: null,
        codeBase: null,
        codeType: null,
        color: null,
        compact: $aed0b684443ef64e$var$boolean,
        declare: $aed0b684443ef64e$var$boolean,
        event: null,
        face: null,
        frame: null,
        frameBorder: null,
        hSpace: $aed0b684443ef64e$var$number,
        leftMargin: $aed0b684443ef64e$var$number,
        link: null,
        longDesc: null,
        lowSrc: null,
        marginHeight: $aed0b684443ef64e$var$number,
        marginWidth: $aed0b684443ef64e$var$number,
        noResize: $aed0b684443ef64e$var$boolean,
        noHref: $aed0b684443ef64e$var$boolean,
        noShade: $aed0b684443ef64e$var$boolean,
        noWrap: $aed0b684443ef64e$var$boolean,
        object: null,
        profile: null,
        prompt: null,
        rev: null,
        rightMargin: $aed0b684443ef64e$var$number,
        rules: null,
        scheme: null,
        scrolling: $aed0b684443ef64e$var$booleanish,
        standby: null,
        summary: null,
        text: null,
        topMargin: $aed0b684443ef64e$var$number,
        valueType: null,
        version: null,
        vAlign: null,
        vLink: null,
        vSpace: $aed0b684443ef64e$var$number,
        // Non-standard Properties.
        allowTransparency: null,
        autoCorrect: null,
        autoSave: null,
        disablePictureInPicture: $aed0b684443ef64e$var$boolean,
        disableRemotePlayback: $aed0b684443ef64e$var$boolean,
        prefix: null,
        property: null,
        results: $aed0b684443ef64e$var$number,
        security: null,
        unselectable: null
    }
});


$08f3dd16e830a549$exports = $f22be46171b10c63$exports([
    $2258d34ea2045e6e$exports,
    $f7b1fe9153b66aca$exports,
    $d677600be62c9ee2$exports,
    $f6c2d7ac952f45ea$exports,
    $aed0b684443ef64e$exports
]);


var $9852ba2d35e49b48$exports = {};

var $6Ddhl = parcelRequire("6Ddhl");
$9852ba2d35e49b48$exports = $9852ba2d35e49b48$var$rehypeFilter;
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').Element} Element
 *
 * @callback AllowElement
 * @param {Element} element
 * @param {number} index
 * @param {Element|Root} parent
 * @returns {boolean|undefined}
 *
 * @typedef RehypeFilterOptions
 * @property {Array.<string>} [allowedElements]
 * @property {Array.<string>} [disallowedElements=[]]
 * @property {AllowElement} [allowElement]
 * @property {boolean} [unwrapDisallowed=false]
 */ /**
 * @type {import('unified').Plugin<[RehypeFilterOptions]>}
 */ function $9852ba2d35e49b48$var$rehypeFilter(options) {
    if (options.allowedElements && options.disallowedElements) throw new TypeError('Only one of `allowedElements` and `disallowedElements` should be defined');
    if (options.allowedElements || options.disallowedElements || options.allowElement) return (tree)=>{
        const node = /** @type {Root} */ tree;
        $6Ddhl(node, 'element', onelement);
    };
    /**
   * @param {Node} node_
   * @param {number|null|undefined} index
   * @param {Node|null|undefined} parent_
   * @returns {number|void}
   */ function onelement(node_, index, parent_) {
        const node = /** @type {Element} */ node_;
        const parent = /** @type {Element|Root} */ parent_;
        /** @type {boolean|undefined} */ let remove;
        if (options.allowedElements) remove = !options.allowedElements.includes(node.tagName);
        else if (options.disallowedElements) remove = options.disallowedElements.includes(node.tagName);
        if (!remove && options.allowElement && typeof index === 'number') remove = !options.allowElement(node, index, parent);
        if (remove && typeof index === 'number') {
            if (options.unwrapDisallowed && node.children) parent.children.splice(index, 1, ...node.children);
            else parent.children.splice(index, 1);
            return index;
        }
        return undefined;
    }
}


var $ca710e916d97a4ec$exports = {};
const $ca710e916d97a4ec$var$protocols = [
    'http',
    'https',
    'mailto',
    'tel'
];
$ca710e916d97a4ec$exports = $ca710e916d97a4ec$var$uriTransformer;
/**
 * @param {string} uri
 * @returns {string}
 */ function $ca710e916d97a4ec$var$uriTransformer(uri) {
    const url = (uri || '').trim();
    const first = url.charAt(0);
    if (first === '#' || first === '/') return url;
    const colon = url.indexOf(':');
    if (colon === -1) return url;
    let index = -1;
    while(++index < $ca710e916d97a4ec$var$protocols.length){
        const protocol = $ca710e916d97a4ec$var$protocols[index];
        if (colon === protocol.length && url.slice(0, protocol.length).toLowerCase() === protocol) return url;
    }
    index = url.indexOf('?');
    if (index !== -1 && colon > index) return url;
    index = url.indexOf('#');
    if (index !== -1 && colon > index) return url;
    // eslint-disable-next-line no-script-url
    return 'javascript:void(0)';
}


var $52703c8b864cc4f5$export$d8abd7e5fb6871f9;
var $52703c8b864cc4f5$export$d88ad6fc8b890afd;
'use strict';

var $7fPBF = parcelRequire("7fPBF");
var $1d7e3e099a09dc30$exports = {};
'use strict';

$1d7e3e099a09dc30$exports = (parcelRequire("8TZ45"));


var $971c06519461f1fa$exports = {};
'use strict';





var $098f3c17bccabf6d$exports = {};
'use strict';



var $098f3c17bccabf6d$var$boolean = $6327116045afe73c$export$4a21f16c33752377;
var $098f3c17bccabf6d$var$number = $6327116045afe73c$export$98e628dec113755e;
var $098f3c17bccabf6d$var$spaceSeparated = $6327116045afe73c$export$ab8645c862eb5a3e;
var $098f3c17bccabf6d$var$commaSeparated = $6327116045afe73c$export$9c8d678629b3d3;
var $098f3c17bccabf6d$var$commaOrSpaceSeparated = $6327116045afe73c$export$2ad25cfebf36cacd;
$098f3c17bccabf6d$exports = $9241b59662c8e4b9$exports({
    space: 'svg',
    attributes: {
        accentHeight: 'accent-height',
        alignmentBaseline: 'alignment-baseline',
        arabicForm: 'arabic-form',
        baselineShift: 'baseline-shift',
        capHeight: 'cap-height',
        className: 'class',
        clipPath: 'clip-path',
        clipRule: 'clip-rule',
        colorInterpolation: 'color-interpolation',
        colorInterpolationFilters: 'color-interpolation-filters',
        colorProfile: 'color-profile',
        colorRendering: 'color-rendering',
        crossOrigin: 'crossorigin',
        dataType: 'datatype',
        dominantBaseline: 'dominant-baseline',
        enableBackground: 'enable-background',
        fillOpacity: 'fill-opacity',
        fillRule: 'fill-rule',
        floodColor: 'flood-color',
        floodOpacity: 'flood-opacity',
        fontFamily: 'font-family',
        fontSize: 'font-size',
        fontSizeAdjust: 'font-size-adjust',
        fontStretch: 'font-stretch',
        fontStyle: 'font-style',
        fontVariant: 'font-variant',
        fontWeight: 'font-weight',
        glyphName: 'glyph-name',
        glyphOrientationHorizontal: 'glyph-orientation-horizontal',
        glyphOrientationVertical: 'glyph-orientation-vertical',
        hrefLang: 'hreflang',
        horizAdvX: 'horiz-adv-x',
        horizOriginX: 'horiz-origin-x',
        horizOriginY: 'horiz-origin-y',
        imageRendering: 'image-rendering',
        letterSpacing: 'letter-spacing',
        lightingColor: 'lighting-color',
        markerEnd: 'marker-end',
        markerMid: 'marker-mid',
        markerStart: 'marker-start',
        navDown: 'nav-down',
        navDownLeft: 'nav-down-left',
        navDownRight: 'nav-down-right',
        navLeft: 'nav-left',
        navNext: 'nav-next',
        navPrev: 'nav-prev',
        navRight: 'nav-right',
        navUp: 'nav-up',
        navUpLeft: 'nav-up-left',
        navUpRight: 'nav-up-right',
        onAbort: 'onabort',
        onActivate: 'onactivate',
        onAfterPrint: 'onafterprint',
        onBeforePrint: 'onbeforeprint',
        onBegin: 'onbegin',
        onCancel: 'oncancel',
        onCanPlay: 'oncanplay',
        onCanPlayThrough: 'oncanplaythrough',
        onChange: 'onchange',
        onClick: 'onclick',
        onClose: 'onclose',
        onCopy: 'oncopy',
        onCueChange: 'oncuechange',
        onCut: 'oncut',
        onDblClick: 'ondblclick',
        onDrag: 'ondrag',
        onDragEnd: 'ondragend',
        onDragEnter: 'ondragenter',
        onDragExit: 'ondragexit',
        onDragLeave: 'ondragleave',
        onDragOver: 'ondragover',
        onDragStart: 'ondragstart',
        onDrop: 'ondrop',
        onDurationChange: 'ondurationchange',
        onEmptied: 'onemptied',
        onEnd: 'onend',
        onEnded: 'onended',
        onError: 'onerror',
        onFocus: 'onfocus',
        onFocusIn: 'onfocusin',
        onFocusOut: 'onfocusout',
        onHashChange: 'onhashchange',
        onInput: 'oninput',
        onInvalid: 'oninvalid',
        onKeyDown: 'onkeydown',
        onKeyPress: 'onkeypress',
        onKeyUp: 'onkeyup',
        onLoad: 'onload',
        onLoadedData: 'onloadeddata',
        onLoadedMetadata: 'onloadedmetadata',
        onLoadStart: 'onloadstart',
        onMessage: 'onmessage',
        onMouseDown: 'onmousedown',
        onMouseEnter: 'onmouseenter',
        onMouseLeave: 'onmouseleave',
        onMouseMove: 'onmousemove',
        onMouseOut: 'onmouseout',
        onMouseOver: 'onmouseover',
        onMouseUp: 'onmouseup',
        onMouseWheel: 'onmousewheel',
        onOffline: 'onoffline',
        onOnline: 'ononline',
        onPageHide: 'onpagehide',
        onPageShow: 'onpageshow',
        onPaste: 'onpaste',
        onPause: 'onpause',
        onPlay: 'onplay',
        onPlaying: 'onplaying',
        onPopState: 'onpopstate',
        onProgress: 'onprogress',
        onRateChange: 'onratechange',
        onRepeat: 'onrepeat',
        onReset: 'onreset',
        onResize: 'onresize',
        onScroll: 'onscroll',
        onSeeked: 'onseeked',
        onSeeking: 'onseeking',
        onSelect: 'onselect',
        onShow: 'onshow',
        onStalled: 'onstalled',
        onStorage: 'onstorage',
        onSubmit: 'onsubmit',
        onSuspend: 'onsuspend',
        onTimeUpdate: 'ontimeupdate',
        onToggle: 'ontoggle',
        onUnload: 'onunload',
        onVolumeChange: 'onvolumechange',
        onWaiting: 'onwaiting',
        onZoom: 'onzoom',
        overlinePosition: 'overline-position',
        overlineThickness: 'overline-thickness',
        paintOrder: 'paint-order',
        panose1: 'panose-1',
        pointerEvents: 'pointer-events',
        referrerPolicy: 'referrerpolicy',
        renderingIntent: 'rendering-intent',
        shapeRendering: 'shape-rendering',
        stopColor: 'stop-color',
        stopOpacity: 'stop-opacity',
        strikethroughPosition: 'strikethrough-position',
        strikethroughThickness: 'strikethrough-thickness',
        strokeDashArray: 'stroke-dasharray',
        strokeDashOffset: 'stroke-dashoffset',
        strokeLineCap: 'stroke-linecap',
        strokeLineJoin: 'stroke-linejoin',
        strokeMiterLimit: 'stroke-miterlimit',
        strokeOpacity: 'stroke-opacity',
        strokeWidth: 'stroke-width',
        tabIndex: 'tabindex',
        textAnchor: 'text-anchor',
        textDecoration: 'text-decoration',
        textRendering: 'text-rendering',
        typeOf: 'typeof',
        underlinePosition: 'underline-position',
        underlineThickness: 'underline-thickness',
        unicodeBidi: 'unicode-bidi',
        unicodeRange: 'unicode-range',
        unitsPerEm: 'units-per-em',
        vAlphabetic: 'v-alphabetic',
        vHanging: 'v-hanging',
        vIdeographic: 'v-ideographic',
        vMathematical: 'v-mathematical',
        vectorEffect: 'vector-effect',
        vertAdvY: 'vert-adv-y',
        vertOriginX: 'vert-origin-x',
        vertOriginY: 'vert-origin-y',
        wordSpacing: 'word-spacing',
        writingMode: 'writing-mode',
        xHeight: 'x-height',
        // These were camelcased in Tiny. Now lowercased in SVG 2
        playbackOrder: 'playbackorder',
        timelineBegin: 'timelinebegin'
    },
    transform: $57102789fbb4388b$exports,
    properties: {
        about: $098f3c17bccabf6d$var$commaOrSpaceSeparated,
        accentHeight: $098f3c17bccabf6d$var$number,
        accumulate: null,
        additive: null,
        alignmentBaseline: null,
        alphabetic: $098f3c17bccabf6d$var$number,
        amplitude: $098f3c17bccabf6d$var$number,
        arabicForm: null,
        ascent: $098f3c17bccabf6d$var$number,
        attributeName: null,
        attributeType: null,
        azimuth: $098f3c17bccabf6d$var$number,
        bandwidth: null,
        baselineShift: null,
        baseFrequency: null,
        baseProfile: null,
        bbox: null,
        begin: null,
        bias: $098f3c17bccabf6d$var$number,
        by: null,
        calcMode: null,
        capHeight: $098f3c17bccabf6d$var$number,
        className: $098f3c17bccabf6d$var$spaceSeparated,
        clip: null,
        clipPath: null,
        clipPathUnits: null,
        clipRule: null,
        color: null,
        colorInterpolation: null,
        colorInterpolationFilters: null,
        colorProfile: null,
        colorRendering: null,
        content: null,
        contentScriptType: null,
        contentStyleType: null,
        crossOrigin: null,
        cursor: null,
        cx: null,
        cy: null,
        d: null,
        dataType: null,
        defaultAction: null,
        descent: $098f3c17bccabf6d$var$number,
        diffuseConstant: $098f3c17bccabf6d$var$number,
        direction: null,
        display: null,
        dur: null,
        divisor: $098f3c17bccabf6d$var$number,
        dominantBaseline: null,
        download: $098f3c17bccabf6d$var$boolean,
        dx: null,
        dy: null,
        edgeMode: null,
        editable: null,
        elevation: $098f3c17bccabf6d$var$number,
        enableBackground: null,
        end: null,
        event: null,
        exponent: $098f3c17bccabf6d$var$number,
        externalResourcesRequired: null,
        fill: null,
        fillOpacity: $098f3c17bccabf6d$var$number,
        fillRule: null,
        filter: null,
        filterRes: null,
        filterUnits: null,
        floodColor: null,
        floodOpacity: null,
        focusable: null,
        focusHighlight: null,
        fontFamily: null,
        fontSize: null,
        fontSizeAdjust: null,
        fontStretch: null,
        fontStyle: null,
        fontVariant: null,
        fontWeight: null,
        format: null,
        fr: null,
        from: null,
        fx: null,
        fy: null,
        g1: $098f3c17bccabf6d$var$commaSeparated,
        g2: $098f3c17bccabf6d$var$commaSeparated,
        glyphName: $098f3c17bccabf6d$var$commaSeparated,
        glyphOrientationHorizontal: null,
        glyphOrientationVertical: null,
        glyphRef: null,
        gradientTransform: null,
        gradientUnits: null,
        handler: null,
        hanging: $098f3c17bccabf6d$var$number,
        hatchContentUnits: null,
        hatchUnits: null,
        height: null,
        href: null,
        hrefLang: null,
        horizAdvX: $098f3c17bccabf6d$var$number,
        horizOriginX: $098f3c17bccabf6d$var$number,
        horizOriginY: $098f3c17bccabf6d$var$number,
        id: null,
        ideographic: $098f3c17bccabf6d$var$number,
        imageRendering: null,
        initialVisibility: null,
        in: null,
        in2: null,
        intercept: $098f3c17bccabf6d$var$number,
        k: $098f3c17bccabf6d$var$number,
        k1: $098f3c17bccabf6d$var$number,
        k2: $098f3c17bccabf6d$var$number,
        k3: $098f3c17bccabf6d$var$number,
        k4: $098f3c17bccabf6d$var$number,
        kernelMatrix: $098f3c17bccabf6d$var$commaOrSpaceSeparated,
        kernelUnitLength: null,
        keyPoints: null,
        keySplines: null,
        keyTimes: null,
        kerning: null,
        lang: null,
        lengthAdjust: null,
        letterSpacing: null,
        lightingColor: null,
        limitingConeAngle: $098f3c17bccabf6d$var$number,
        local: null,
        markerEnd: null,
        markerMid: null,
        markerStart: null,
        markerHeight: null,
        markerUnits: null,
        markerWidth: null,
        mask: null,
        maskContentUnits: null,
        maskUnits: null,
        mathematical: null,
        max: null,
        media: null,
        mediaCharacterEncoding: null,
        mediaContentEncodings: null,
        mediaSize: $098f3c17bccabf6d$var$number,
        mediaTime: null,
        method: null,
        min: null,
        mode: null,
        name: null,
        navDown: null,
        navDownLeft: null,
        navDownRight: null,
        navLeft: null,
        navNext: null,
        navPrev: null,
        navRight: null,
        navUp: null,
        navUpLeft: null,
        navUpRight: null,
        numOctaves: null,
        observer: null,
        offset: null,
        onAbort: null,
        onActivate: null,
        onAfterPrint: null,
        onBeforePrint: null,
        onBegin: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnd: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFocusIn: null,
        onFocusOut: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadStart: null,
        onMessage: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onMouseWheel: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRepeat: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onShow: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onZoom: null,
        opacity: null,
        operator: null,
        order: null,
        orient: null,
        orientation: null,
        origin: null,
        overflow: null,
        overlay: null,
        overlinePosition: $098f3c17bccabf6d$var$number,
        overlineThickness: $098f3c17bccabf6d$var$number,
        paintOrder: null,
        panose1: null,
        path: null,
        pathLength: $098f3c17bccabf6d$var$number,
        patternContentUnits: null,
        patternTransform: null,
        patternUnits: null,
        phase: null,
        ping: $098f3c17bccabf6d$var$spaceSeparated,
        pitch: null,
        playbackOrder: null,
        pointerEvents: null,
        points: null,
        pointsAtX: $098f3c17bccabf6d$var$number,
        pointsAtY: $098f3c17bccabf6d$var$number,
        pointsAtZ: $098f3c17bccabf6d$var$number,
        preserveAlpha: null,
        preserveAspectRatio: null,
        primitiveUnits: null,
        propagate: null,
        property: $098f3c17bccabf6d$var$commaOrSpaceSeparated,
        r: null,
        radius: null,
        referrerPolicy: null,
        refX: null,
        refY: null,
        rel: $098f3c17bccabf6d$var$commaOrSpaceSeparated,
        rev: $098f3c17bccabf6d$var$commaOrSpaceSeparated,
        renderingIntent: null,
        repeatCount: null,
        repeatDur: null,
        requiredExtensions: $098f3c17bccabf6d$var$commaOrSpaceSeparated,
        requiredFeatures: $098f3c17bccabf6d$var$commaOrSpaceSeparated,
        requiredFonts: $098f3c17bccabf6d$var$commaOrSpaceSeparated,
        requiredFormats: $098f3c17bccabf6d$var$commaOrSpaceSeparated,
        resource: null,
        restart: null,
        result: null,
        rotate: null,
        rx: null,
        ry: null,
        scale: null,
        seed: null,
        shapeRendering: null,
        side: null,
        slope: null,
        snapshotTime: null,
        specularConstant: $098f3c17bccabf6d$var$number,
        specularExponent: $098f3c17bccabf6d$var$number,
        spreadMethod: null,
        spacing: null,
        startOffset: null,
        stdDeviation: null,
        stemh: null,
        stemv: null,
        stitchTiles: null,
        stopColor: null,
        stopOpacity: null,
        strikethroughPosition: $098f3c17bccabf6d$var$number,
        strikethroughThickness: $098f3c17bccabf6d$var$number,
        string: null,
        stroke: null,
        strokeDashArray: $098f3c17bccabf6d$var$commaOrSpaceSeparated,
        strokeDashOffset: null,
        strokeLineCap: null,
        strokeLineJoin: null,
        strokeMiterLimit: $098f3c17bccabf6d$var$number,
        strokeOpacity: $098f3c17bccabf6d$var$number,
        strokeWidth: null,
        style: null,
        surfaceScale: $098f3c17bccabf6d$var$number,
        syncBehavior: null,
        syncBehaviorDefault: null,
        syncMaster: null,
        syncTolerance: null,
        syncToleranceDefault: null,
        systemLanguage: $098f3c17bccabf6d$var$commaOrSpaceSeparated,
        tabIndex: $098f3c17bccabf6d$var$number,
        tableValues: null,
        target: null,
        targetX: $098f3c17bccabf6d$var$number,
        targetY: $098f3c17bccabf6d$var$number,
        textAnchor: null,
        textDecoration: null,
        textRendering: null,
        textLength: null,
        timelineBegin: null,
        title: null,
        transformBehavior: null,
        type: null,
        typeOf: $098f3c17bccabf6d$var$commaOrSpaceSeparated,
        to: null,
        transform: null,
        u1: null,
        u2: null,
        underlinePosition: $098f3c17bccabf6d$var$number,
        underlineThickness: $098f3c17bccabf6d$var$number,
        unicode: null,
        unicodeBidi: null,
        unicodeRange: null,
        unitsPerEm: $098f3c17bccabf6d$var$number,
        values: null,
        vAlphabetic: $098f3c17bccabf6d$var$number,
        vMathematical: $098f3c17bccabf6d$var$number,
        vectorEffect: null,
        vHanging: $098f3c17bccabf6d$var$number,
        vIdeographic: $098f3c17bccabf6d$var$number,
        version: null,
        vertAdvY: $098f3c17bccabf6d$var$number,
        vertOriginX: $098f3c17bccabf6d$var$number,
        vertOriginY: $098f3c17bccabf6d$var$number,
        viewBox: null,
        viewTarget: null,
        visibility: null,
        width: null,
        widths: null,
        wordSpacing: null,
        writingMode: null,
        x: null,
        x1: null,
        x2: null,
        xChannelSelector: null,
        xHeight: $098f3c17bccabf6d$var$number,
        y: null,
        y1: null,
        y2: null,
        yChannelSelector: null,
        z: null,
        zoomAndPan: null
    }
});


$971c06519461f1fa$exports = $f22be46171b10c63$exports([
    $2258d34ea2045e6e$exports,
    $f7b1fe9153b66aca$exports,
    $d677600be62c9ee2$exports,
    $f6c2d7ac952f45ea$exports,
    $098f3c17bccabf6d$exports
]);


var $e701fdb7c14d65dc$exports = {};
'use strict';



var $e701fdb7c14d65dc$var$data = 'data';
$e701fdb7c14d65dc$exports = $e701fdb7c14d65dc$var$find;
var $e701fdb7c14d65dc$var$valid = /^data[-\w.:]+$/i;
var $e701fdb7c14d65dc$var$dash = /-[a-z]/g;
var $e701fdb7c14d65dc$var$cap = /[A-Z]/g;
function $e701fdb7c14d65dc$var$find(schema, value) {
    var normal = $3995591220cdf091$exports(value);
    var prop = value;
    var Type = $f5a64e1dc26e2922$exports;
    if (normal in schema.normal) return schema.property[schema.normal[normal]];
    if (normal.length > 4 && normal.slice(0, 4) === $e701fdb7c14d65dc$var$data && $e701fdb7c14d65dc$var$valid.test(value)) {
        // Attribute or property.
        if (value.charAt(4) === '-') prop = $e701fdb7c14d65dc$var$datasetToProperty(value);
        else value = $e701fdb7c14d65dc$var$datasetToAttribute(value);
        Type = $e9abde33d3611e8d$exports;
    }
    return new Type(prop, value);
}
function $e701fdb7c14d65dc$var$datasetToProperty(attribute) {
    var value = attribute.slice(5).replace($e701fdb7c14d65dc$var$dash, $e701fdb7c14d65dc$var$camelcase);
    return $e701fdb7c14d65dc$var$data + value.charAt(0).toUpperCase() + value.slice(1);
}
function $e701fdb7c14d65dc$var$datasetToAttribute(property) {
    var value = property.slice(4);
    if ($e701fdb7c14d65dc$var$dash.test(value)) return property;
    value = value.replace($e701fdb7c14d65dc$var$cap, $e701fdb7c14d65dc$var$kebab);
    if (value.charAt(0) !== '-') value = '-' + value;
    return $e701fdb7c14d65dc$var$data + value;
}
function $e701fdb7c14d65dc$var$kebab($0) {
    return '-' + $0.toLowerCase();
}
function $e701fdb7c14d65dc$var$camelcase($0) {
    return $0.charAt(1).toUpperCase();
}


var $062158be0ade3460$exports = {};
$062158be0ade3460$exports = JSON.parse("{\"classId\":\"classID\",\"dataType\":\"datatype\",\"itemId\":\"itemID\",\"strokeDashArray\":\"strokeDasharray\",\"strokeDashOffset\":\"strokeDashoffset\",\"strokeLineCap\":\"strokeLinecap\",\"strokeLineJoin\":\"strokeLinejoin\",\"strokeMiterLimit\":\"strokeMiterlimit\",\"typeOf\":\"typeof\",\"xLinkActuate\":\"xlinkActuate\",\"xLinkArcRole\":\"xlinkArcrole\",\"xLinkHref\":\"xlinkHref\",\"xLinkRole\":\"xlinkRole\",\"xLinkShow\":\"xlinkShow\",\"xLinkTitle\":\"xlinkTitle\",\"xLinkType\":\"xlinkType\",\"xmlnsXLink\":\"xmlnsXlink\"}");


var $0d98344a9bfa0653$exports = {};

$parcel$export($0d98344a9bfa0653$exports, "parse", function () { return $0d98344a9bfa0653$export$98e6a39c04603d36; }, function (v) { return $0d98344a9bfa0653$export$98e6a39c04603d36 = v; });
$parcel$export($0d98344a9bfa0653$exports, "stringify", function () { return $0d98344a9bfa0653$export$fac44ee5b035f737; }, function (v) { return $0d98344a9bfa0653$export$fac44ee5b035f737 = v; });
var $0d98344a9bfa0653$export$98e6a39c04603d36;
var $0d98344a9bfa0653$export$fac44ee5b035f737;
'use strict';
$0d98344a9bfa0653$export$98e6a39c04603d36 = $0d98344a9bfa0653$var$parse;
$0d98344a9bfa0653$export$fac44ee5b035f737 = $0d98344a9bfa0653$var$stringify;
var $0d98344a9bfa0653$var$empty = '';
var $0d98344a9bfa0653$var$space = ' ';
var $0d98344a9bfa0653$var$whiteSpace = /[ \t\n\r\f]+/g;
function $0d98344a9bfa0653$var$parse(value) {
    var input = String(value || $0d98344a9bfa0653$var$empty).trim();
    return input === $0d98344a9bfa0653$var$empty ? [] : input.split($0d98344a9bfa0653$var$whiteSpace);
}
function $0d98344a9bfa0653$var$stringify(values) {
    return values.join($0d98344a9bfa0653$var$space).trim();
}


var $9323934601145f2e$exports = {};

$parcel$export($9323934601145f2e$exports, "parse", function () { return $9323934601145f2e$export$98e6a39c04603d36; }, function (v) { return $9323934601145f2e$export$98e6a39c04603d36 = v; });
$parcel$export($9323934601145f2e$exports, "stringify", function () { return $9323934601145f2e$export$fac44ee5b035f737; }, function (v) { return $9323934601145f2e$export$fac44ee5b035f737 = v; });
var $9323934601145f2e$export$98e6a39c04603d36;
var $9323934601145f2e$export$fac44ee5b035f737;
'use strict';
$9323934601145f2e$export$98e6a39c04603d36 = $9323934601145f2e$var$parse;
$9323934601145f2e$export$fac44ee5b035f737 = $9323934601145f2e$var$stringify;
var $9323934601145f2e$var$comma = ',';
var $9323934601145f2e$var$space = ' ';
var $9323934601145f2e$var$empty = '';
// Parse comma-separated tokens to an array.
function $9323934601145f2e$var$parse(value) {
    var values = [];
    var input = String(value || $9323934601145f2e$var$empty);
    var index = input.indexOf($9323934601145f2e$var$comma);
    var lastIndex = 0;
    var end = false;
    var val;
    while(!end){
        if (index === -1) {
            index = input.length;
            end = true;
        }
        val = input.slice(lastIndex, index).trim();
        if (val || !end) values.push(val);
        lastIndex = index + 1;
        index = input.indexOf($9323934601145f2e$var$comma, lastIndex);
    }
    return values;
}
// Compile an array to comma-separated tokens.
// `options.padLeft` (default: `true`) pads a space left of each token, and
// `options.padRight` (default: `false`) pads a space to the right of each token.
function $9323934601145f2e$var$stringify(values, options) {
    var settings = options || {};
    var left = settings.padLeft === false ? $9323934601145f2e$var$empty : $9323934601145f2e$var$space;
    var right = settings.padRight ? $9323934601145f2e$var$space : $9323934601145f2e$var$empty;
    // Ensure the last empty entry is seen.
    if (values[values.length - 1] === $9323934601145f2e$var$empty) values = values.concat($9323934601145f2e$var$empty);
    return values.join(right + $9323934601145f2e$var$comma + left).trim();
}


var $42244e7baa0fa7b3$exports = {};
var $0c74a7282689820a$exports = {};
// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var $0c74a7282689820a$var$COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
var $0c74a7282689820a$var$NEWLINE_REGEX = /\n/g;
var $0c74a7282689820a$var$WHITESPACE_REGEX = /^\s*/;
// declaration
var $0c74a7282689820a$var$PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var $0c74a7282689820a$var$COLON_REGEX = /^:\s*/;
var $0c74a7282689820a$var$VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var $0c74a7282689820a$var$SEMICOLON_REGEX = /^[;\s]*/;
// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var $0c74a7282689820a$var$TRIM_REGEX = /^\s+|\s+$/g;
// strings
var $0c74a7282689820a$var$NEWLINE = '\n';
var $0c74a7282689820a$var$FORWARD_SLASH = '/';
var $0c74a7282689820a$var$ASTERISK = '*';
var $0c74a7282689820a$var$EMPTY_STRING = '';
// types
var $0c74a7282689820a$var$TYPE_COMMENT = 'comment';
var $0c74a7282689820a$var$TYPE_DECLARATION = 'declaration';
/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */ $0c74a7282689820a$exports = function(style, options) {
    if (typeof style !== 'string') throw new TypeError('First argument must be a string');
    if (!style) return [];
    options = options || {};
    /**
   * Positional.
   */ var lineno = 1;
    var column = 1;
    /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */ function updatePosition(str) {
        var lines = str.match($0c74a7282689820a$var$NEWLINE_REGEX);
        if (lines) lineno += lines.length;
        var i = str.lastIndexOf($0c74a7282689820a$var$NEWLINE);
        column = ~i ? str.length - i : column + str.length;
    }
    /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */ function position() {
        var start = {
            line: lineno,
            column: column
        };
        return function(node) {
            node.position = new Position(start);
            whitespace();
            return node;
        };
    }
    /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */ function Position(start) {
        this.start = start;
        this.end = {
            line: lineno,
            column: column
        };
        this.source = options.source;
    }
    /**
   * Non-enumerable source string.
   */ Position.prototype.content = style;
    var errorsList = [];
    /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */ function error(msg) {
        var err = new Error(options.source + ':' + lineno + ':' + column + ': ' + msg);
        err.reason = msg;
        err.filename = options.source;
        err.line = lineno;
        err.column = column;
        err.source = style;
        if (options.silent) errorsList.push(err);
        else throw err;
    }
    /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */ function match(re) {
        var m = re.exec(style);
        if (!m) return;
        var str = m[0];
        updatePosition(str);
        style = style.slice(str.length);
        return m;
    }
    /**
   * Parse whitespace.
   */ function whitespace() {
        match($0c74a7282689820a$var$WHITESPACE_REGEX);
    }
    /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */ function comments(rules) {
        var c;
        rules = rules || [];
        while(c = comment())if (c !== false) rules.push(c);
        return rules;
    }
    /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */ function comment() {
        var pos = position();
        if ($0c74a7282689820a$var$FORWARD_SLASH != style.charAt(0) || $0c74a7282689820a$var$ASTERISK != style.charAt(1)) return;
        var i = 2;
        while($0c74a7282689820a$var$EMPTY_STRING != style.charAt(i) && ($0c74a7282689820a$var$ASTERISK != style.charAt(i) || $0c74a7282689820a$var$FORWARD_SLASH != style.charAt(i + 1)))++i;
        i += 2;
        if ($0c74a7282689820a$var$EMPTY_STRING === style.charAt(i - 1)) return error('End of comment missing');
        var str = style.slice(2, i - 2);
        column += 2;
        updatePosition(str);
        style = style.slice(i);
        column += 2;
        return pos({
            type: $0c74a7282689820a$var$TYPE_COMMENT,
            comment: str
        });
    }
    /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */ function declaration() {
        var pos = position();
        // prop
        var prop = match($0c74a7282689820a$var$PROPERTY_REGEX);
        if (!prop) return;
        comment();
        // :
        if (!match($0c74a7282689820a$var$COLON_REGEX)) return error("property missing ':'");
        // val
        var val = match($0c74a7282689820a$var$VALUE_REGEX);
        var ret = pos({
            type: $0c74a7282689820a$var$TYPE_DECLARATION,
            property: $0c74a7282689820a$var$trim(prop[0].replace($0c74a7282689820a$var$COMMENT_REGEX, $0c74a7282689820a$var$EMPTY_STRING)),
            value: val ? $0c74a7282689820a$var$trim(val[0].replace($0c74a7282689820a$var$COMMENT_REGEX, $0c74a7282689820a$var$EMPTY_STRING)) : $0c74a7282689820a$var$EMPTY_STRING
        });
        // ;
        match($0c74a7282689820a$var$SEMICOLON_REGEX);
        return ret;
    }
    /**
   * Parse declarations.
   *
   * @return {Object[]}
   */ function declarations() {
        var decls = [];
        comments(decls);
        // declarations
        var decl;
        while(decl = declaration())if (decl !== false) {
            decls.push(decl);
            comments(decls);
        }
        return decls;
    }
    whitespace();
    return declarations();
};
/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */ function $0c74a7282689820a$var$trim(str) {
    return str ? str.replace($0c74a7282689820a$var$TRIM_REGEX, $0c74a7282689820a$var$EMPTY_STRING) : $0c74a7282689820a$var$EMPTY_STRING;
}


/**
 * Parses inline style to object.
 *
 * @example
 * // returns { 'line-height': '42' }
 * StyleToObject('line-height: 42;');
 *
 * @param  {String}      style      - The inline style.
 * @param  {Function}    [iterator] - The iterator function.
 * @return {null|Object}
 */ function $42244e7baa0fa7b3$var$StyleToObject(style, iterator) {
    var output = null;
    if (!style || typeof style !== 'string') return output;
    var declaration;
    var declarations = $0c74a7282689820a$exports(style);
    var hasIterator = typeof iterator === 'function';
    var property;
    var value;
    for(var i = 0, len = declarations.length; i < len; i++){
        declaration = declarations[i];
        property = declaration.property;
        value = declaration.value;
        if (hasIterator) iterator(property, value, declaration);
        else if (value) {
            output || (output = {});
            output[property] = value;
        }
    }
    return output;
}
$42244e7baa0fa7b3$exports = $42244e7baa0fa7b3$var$StyleToObject;


$52703c8b864cc4f5$export$d8abd7e5fb6871f9 = $52703c8b864cc4f5$var$toReact;
$52703c8b864cc4f5$export$d88ad6fc8b890afd = $52703c8b864cc4f5$var$childrenToReact;
/**
 * @typedef {JSX.IntrinsicElements} IntrinsicElements
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('unist').Position} Position
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').Text} Text
 * @typedef {import('hast').Comment} Comment
 * @typedef {import('hast').DocType} Doctype
 */ /**
 * @typedef Info
 * @property {string?} space
 * @property {string?} attribute
 * @property {string?} property
 * @property {boolean} boolean
 * @property {boolean} booleanish
 * @property {boolean} overloadedBoolean
 * @property {boolean} number
 * @property {boolean} commaSeparated
 * @property {boolean} spaceSeparated
 * @property {boolean} commaOrSpaceSeparated
 * @property {boolean} mustUseProperty
 * @property {boolean} defined
 *
 * @typedef Schema
 * @property {Object.<string, Info>} property
 * @property {Object.<string, string>} normal
 * @property {string?} space
 *
 * @typedef Raw
 * @property {'raw'} type
 * @property {string} value
 *
 * @typedef Context
 * @property {TransformOptions} options
 * @property {Schema} schema
 * @property {number} listDepth
 *
 * @callback TransformLink
 * @param {string} href
 * @param {Array.<Comment|Element|Text>} children
 * @param {string?} title
 * @returns {string}
 *
 * @callback TransformImage
 * @param {string} src
 * @param {string} alt
 * @param {string?} title
 * @returns {string}
 *
 * @callback TransformLinkTarget
 * @param {string} href
 * @param {Array.<Comment|Element|Text>} children
 * @param {string?} title
 * @returns {string|undefined}
 *
 * @typedef {keyof IntrinsicElements} ReactMarkdownNames
 *
 * To do: is `data-sourcepos` typeable?
 *
 * @typedef ReactMarkdownProps
 * @property {Element} node
 * @property {string} key
 * @property {ReactNode[]} children
 * @property {Position?} [sourcePosition] Passed when `options.rawSourcePos` is given
 * @property {number} [index] Passed when `options.includeElementIndex` is given
 * @property {number} [siblingCount] Passed when `options.includeElementIndex` is given
 *
 * @callback CodeComponent
 * @param {JSX.IntrinsicElements['code'] & ReactMarkdownProps & {inline?: boolean}} props
 * @returns {ReactNode}
 *
 * @callback HeadingComponent
 * @param {JSX.IntrinsicElements['h1'] & ReactMarkdownProps & {level: number}} props
 * @returns {ReactNode}
 *
 * @callback LiComponent
 * @param {JSX.IntrinsicElements['li'] & ReactMarkdownProps & {checked: boolean|null, index: number, ordered: boolean}} props
 * @returns {ReactNode}
 *
 * @callback OrderedListComponent
 * @param {JSX.IntrinsicElements['ol'] & ReactMarkdownProps & {depth: number, ordered: true}} props
 * @returns {ReactNode}
 *
 * @callback TableCellComponent
 * @param {JSX.IntrinsicElements['table'] & ReactMarkdownProps & {style?: Object.<string, unknown>, isHeader: boolean}} props
 * @returns {ReactNode}
 *
 * @callback TableRowComponent
 * @param {JSX.IntrinsicElements['tr'] & ReactMarkdownProps & {isHeader: boolean}} props
 * @returns {ReactNode}
 *
 * @callback UnorderedListComponent
 * @param {JSX.IntrinsicElements['ul'] & ReactMarkdownProps & {depth: number, ordered: false}} props
 * @returns {ReactNode}
 *
 * @typedef SpecialComponents
 * @property {CodeComponent|ReactMarkdownNames} code
 * @property {HeadingComponent|ReactMarkdownNames} h1
 * @property {HeadingComponent|ReactMarkdownNames} h2
 * @property {HeadingComponent|ReactMarkdownNames} h3
 * @property {HeadingComponent|ReactMarkdownNames} h4
 * @property {HeadingComponent|ReactMarkdownNames} h5
 * @property {HeadingComponent|ReactMarkdownNames} h6
 * @property {LiComponent|ReactMarkdownNames} li
 * @property {OrderedListComponent|ReactMarkdownNames} ol
 * @property {TableCellComponent|ReactMarkdownNames} td
 * @property {TableCellComponent|ReactMarkdownNames} th
 * @property {TableRowComponent|ReactMarkdownNames} tr
 * @property {UnorderedListComponent|ReactMarkdownNames} ul
 *
 * @typedef {{[TagName in keyof IntrinsicElements]: TagName | ((props: IntrinsicElements[TagName] & ReactMarkdownProps) => ReactNode)}} NormalComponents
 * @typedef {Partial<Omit<NormalComponents, keyof SpecialComponents> & SpecialComponents>} Components
 */ /**
 * @typedef TransformOptions
 * @property {boolean} [sourcePos=false]
 * @property {boolean} [rawSourcePos=false]
 * @property {boolean} [skipHtml=false]
 * @property {boolean} [includeElementIndex=false]
 * @property {null|false|TransformLink} [transformLinkUri]
 * @property {TransformImage} [transformImageUri]
 * @property {string|TransformLinkTarget} [linkTarget]
 * @property {Components} [components]
 */ const $52703c8b864cc4f5$var$own = {}.hasOwnProperty;
// The table-related elements that must not contain whitespace text according
// to React.
const $52703c8b864cc4f5$var$tableElements = new Set([
    'table',
    'thead',
    'tbody',
    'tfoot',
    'tr'
]);
/**
 * @param {Context} context
 * @param {Element|Root} node
 */ function $52703c8b864cc4f5$var$childrenToReact(context, node) {
    /** @type {Array.<ReactNode>} */ const children = [];
    let childIndex = -1;
    /** @type {Comment|Doctype|Element|Raw|Text} */ let child;
    while(++childIndex < node.children.length){
        child = node.children[childIndex];
        if (child.type === 'element') children.push($52703c8b864cc4f5$var$toReact(context, child, childIndex, node));
        else if (child.type === 'text') // React does not permit whitespace text elements as children of table:
        // cf. https://github.com/remarkjs/react-markdown/issues/576
        {
            if (node.type !== 'element' || !$52703c8b864cc4f5$var$tableElements.has(node.tagName) || child.value !== '\n') children.push(child.value);
        } else if (child.type === 'raw' && !context.options.skipHtml) // Default behavior is to show (encoded) HTML.
        // @ts-expect-error `raw` nodes are non-standard
        children.push(child.value);
    }
    return children;
}
/**
 * @param {Context} context
 * @param {Element} node
 * @param {number} index
 * @param {Element|Root} parent
 */ function $52703c8b864cc4f5$var$toReact(context, node, index, parent) {
    const options = context.options;
    const parentSchema = context.schema;
    /** @type {ReactMarkdownNames} */ // @ts-expect-error assume a known HTML/SVG element.
    const name = node.tagName;
    /** @type {Object.<string, unknown>} */ const properties = {};
    let schema = parentSchema;
    /** @type {string} */ let property;
    if (parentSchema.space === 'html' && name === 'svg') {
        schema = $971c06519461f1fa$exports;
        context.schema = schema;
    }
    /* istanbul ignore else - types say they’re optional. */ if (node.properties) {
        for(property in node.properties)/* istanbul ignore else - prototype polution. */ if ($52703c8b864cc4f5$var$own.call(node.properties, property)) $52703c8b864cc4f5$var$addProperty(properties, property, node.properties[property], context);
    }
    if (name === 'ol' || name === 'ul') context.listDepth++;
    const children = $52703c8b864cc4f5$var$childrenToReact(context, node);
    if (name === 'ol' || name === 'ul') context.listDepth--;
    // Restore parent schema.
    context.schema = parentSchema;
    // Nodes created by plugins do not have positional info, in which case we use
    // an object that matches the positon interface.
    const position = node.position || {
        start: {
            line: null,
            column: null,
            offset: null
        },
        end: {
            line: null,
            column: null,
            offset: null
        }
    };
    const component = options.components && $52703c8b864cc4f5$var$own.call(options.components, name) ? options.components[name] : name;
    const basic = typeof component === 'string' || component === $7fPBF.Fragment;
    if (!$1d7e3e099a09dc30$exports.isValidElementType(component)) throw new TypeError(`Component for name \`${name}\` not defined or is not renderable`);
    properties.key = [
        name,
        position.start.line,
        position.start.column,
        index
    ].join('-');
    if (name === 'a' && options.linkTarget) properties.target = typeof options.linkTarget === 'function' ? options.linkTarget(properties.href, node.children, properties.title) : options.linkTarget;
    if (name === 'a' && options.transformLinkUri) properties.href = options.transformLinkUri(// @ts-expect-error assume `href` is a string
    properties.href, node.children, properties.title);
    if (!basic && name === 'code' && parent.type === 'element' && parent.tagName !== 'pre') properties.inline = true;
    if (!basic && (name === 'h1' || name === 'h2' || name === 'h3' || name === 'h4' || name === 'h5' || name === 'h6')) properties.level = parseInt(name.charAt(1), 10);
    if (name === 'img' && options.transformImageUri) properties.src = options.transformImageUri(// @ts-expect-error assume `src` is a string
    properties.src, properties.alt, properties.title);
    if (!basic && name === 'li' && parent.type === 'element') {
        const input = $52703c8b864cc4f5$var$getInputElement(node);
        properties.checked = input && input.properties ? Boolean(input.properties.checked) : null;
        properties.index = $52703c8b864cc4f5$var$getElementsBeforeCount(parent, node);
        properties.ordered = parent.tagName === 'ol';
    }
    if (!basic && (name === 'ol' || name === 'ul')) {
        properties.ordered = name === 'ol';
        properties.depth = context.listDepth;
    }
    if (name === 'td' || name === 'th') {
        if (properties.align) {
            if (!properties.style) properties.style = {};
            // @ts-expect-error assume `style` is an object
            properties.style.textAlign = properties.align;
            delete properties.align;
        }
        if (!basic) properties.isHeader = name === 'th';
    }
    if (!basic && name === 'tr' && parent.type === 'element') properties.isHeader = Boolean(parent.tagName === 'thead');
    // If `sourcePos` is given, pass source information (line/column info from markdown source).
    if (options.sourcePos) properties['data-sourcepos'] = $52703c8b864cc4f5$var$flattenPosition(position);
    if (!basic && options.rawSourcePos) properties.sourcePosition = node.position;
    // If `includeElementIndex` is given, pass node index info to components.
    if (!basic && options.includeElementIndex) {
        properties.index = $52703c8b864cc4f5$var$getElementsBeforeCount(parent, node);
        properties.siblingCount = $52703c8b864cc4f5$var$getElementsBeforeCount(parent);
    }
    if (!basic) properties.node = node;
    // Ensure no React warnings are emitted for void elements w/ children.
    return children.length > 0 ? $7fPBF.createElement(component, properties, children) : $7fPBF.createElement(component, properties);
}
/**
 * @param {Element|Root} node
 * @returns {Element?}
 */ function $52703c8b864cc4f5$var$getInputElement(node) {
    let index = -1;
    while(++index < node.children.length){
        const child = node.children[index];
        if (child.type === 'element' && child.tagName === 'input') return child;
    }
    return null;
}
/**
 * @param {Element|Root} parent
 * @param {Element} [node]
 * @returns {number}
 */ function $52703c8b864cc4f5$var$getElementsBeforeCount(parent, node) {
    let index = -1;
    let count = 0;
    while(++index < parent.children.length){
        if (parent.children[index] === node) break;
        if (parent.children[index].type === 'element') count++;
    }
    return count;
}
/**
 * @param {Object.<string, unknown>} props
 * @param {string} prop
 * @param {unknown} value
 * @param {Context} ctx
 */ function $52703c8b864cc4f5$var$addProperty(props, prop, value, ctx) {
    /** @type {Info} */ const info = $e701fdb7c14d65dc$exports(ctx.schema, prop);
    let result = value;
    // Ignore nullish and `NaN` values.
    // eslint-disable-next-line no-self-compare
    if (result === null || result === undefined || result !== result) return;
    // Accept `array`.
    // Most props are space-separated.
    if (result && typeof result === 'object' && 'length' in result) // type-coverage:ignore-next-line remove when typed.
    result = (info.commaSeparated ? $9323934601145f2e$exports : $0d98344a9bfa0653$exports).stringify(result);
    if (info.property === 'style' && typeof result === 'string') result = $52703c8b864cc4f5$var$parseStyle(result);
    /* istanbul ignore else - types say they’re optional. */ if (info.space && info.property) props[$52703c8b864cc4f5$var$own.call($062158be0ade3460$exports, info.property) ? $062158be0ade3460$exports[info.property] : info.property] = result;
    else if (info.attribute) props[info.attribute] = result;
}
/**
 * @param {string} value
 * @returns {Object.<string, string>}
 */ function $52703c8b864cc4f5$var$parseStyle(value) {
    /** @type {Object.<string, string>} */ const result = {};
    try {
        $42244e7baa0fa7b3$exports(value, iterator);
    } catch (/** @type {unknown} */ _) {
    // Silent.
    }
    return result;
    /**
   * @param {string} name
   * @param {string} v
   */ function iterator(name, v) {
        const k = name.slice(0, 4) === '-ms-' ? `ms-${name.slice(4)}` : name;
        result[k.replace(/-([a-z])/g, $52703c8b864cc4f5$var$styleReplacer)] = v;
    }
}
/**
 * @param {unknown} _
 * @param {string} $1
 */ function $52703c8b864cc4f5$var$styleReplacer(_, $1) {
    return $1.toUpperCase();
}
/**
 * @param {Position|{start: {line: null, column: null, offset: null}, end: {line: null, column: null, offset: null}}} pos
 * @returns {string}
 */ function $52703c8b864cc4f5$var$flattenPosition(pos) {
    return [
        pos.start.line,
        ':',
        pos.start.column,
        '-',
        pos.end.line,
        ':',
        pos.end.column
    ].map((d)=>String(d)).join('');
}


var $c667ec5950b1e0aa$require$childrenToReact = $52703c8b864cc4f5$export$d88ad6fc8b890afd;
/**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('react').ReactElement<{}>} ReactElement
 * @typedef {import('unified').PluggableList} PluggableList
 * @typedef {import('hast').Root} Root
 * @typedef {import('./rehype-filter.js').RehypeFilterOptions} FilterOptions
 * @typedef {import('./ast-to-react.js').TransformOptions} TransformOptions
 *
 * @typedef CoreOptions
 * @property {string} children
 *
 * @typedef PluginOptions
 * @property {PluggableList} [plugins=[]] **deprecated**: use `remarkPlugins` instead
 * @property {PluggableList} [remarkPlugins=[]]
 * @property {PluggableList} [rehypePlugins=[]]
 *
 * @typedef LayoutOptions
 * @property {string} [className]
 *
 * @typedef {CoreOptions & PluginOptions & LayoutOptions & FilterOptions & TransformOptions} ReactMarkdownOptions
 */ $c667ec5950b1e0aa$exports = $c667ec5950b1e0aa$var$ReactMarkdown;
const $c667ec5950b1e0aa$var$own = {}.hasOwnProperty;
const $c667ec5950b1e0aa$var$changelog = 'https://github.com/remarkjs/react-markdown/blob/main/changelog.md';
/**
 * @typedef Deprecation
 * @property {string} id
 * @property {string} [to]
 */ /**
 * @type {Object.<string, Deprecation>}
 */ const $c667ec5950b1e0aa$var$deprecated = {
    renderers: {
        to: 'components',
        id: 'change-renderers-to-components'
    },
    astPlugins: {
        id: 'remove-buggy-html-in-markdown-parser'
    },
    allowDangerousHtml: {
        id: 'remove-buggy-html-in-markdown-parser'
    },
    escapeHtml: {
        id: 'remove-buggy-html-in-markdown-parser'
    },
    source: {
        to: 'children',
        id: 'change-source-to-children'
    },
    allowNode: {
        to: 'allowElement',
        id: 'replace-allownode-allowedtypes-and-disallowedtypes'
    },
    allowedTypes: {
        to: 'allowedElements',
        id: 'replace-allownode-allowedtypes-and-disallowedtypes'
    },
    disallowedTypes: {
        to: 'disallowedElements',
        id: 'replace-allownode-allowedtypes-and-disallowedtypes'
    },
    includeNodeIndex: {
        to: 'includeElementIndex',
        id: 'change-includenodeindex-to-includeelementindex'
    }
};
/**
 * @param {ReactMarkdownOptions} options
 * @returns {ReactElement}
 */ function $c667ec5950b1e0aa$var$ReactMarkdown(options) {
    for(const key in $c667ec5950b1e0aa$var$deprecated)if ($c667ec5950b1e0aa$var$own.call($c667ec5950b1e0aa$var$deprecated, key) && $c667ec5950b1e0aa$var$own.call(options, key)) {
        /** @type {Deprecation} */ const deprecation = $c667ec5950b1e0aa$var$deprecated[key];
        console.warn(`[react-markdown] Warning: please ${deprecation.to ? `use \`${deprecation.to}\` instead of` : 'remove'} \`${key}\` (see <${$c667ec5950b1e0aa$var$changelog}#${deprecation.id}> for more info)`);
        delete $c667ec5950b1e0aa$var$deprecated[key];
    }
    const processor = $54c383ef10bfa5a4$exports().use($25f56eac28db4d8b$exports)// TODO: deprecate `plugins` in v7.0.0.
    .use(options.remarkPlugins || options.plugins || []).use($4a1785e53c97ab0a$exports, {
        allowDangerousHtml: true
    }).use(options.rehypePlugins || []).use($9852ba2d35e49b48$exports, options);
    /** @type {vfile} */ let file;
    if (typeof options.children === 'string') file = $eaf6b2f6c220a664$exports(options.children);
    else {
        if (options.children !== undefined && options.children !== null) console.warn(`[react-markdown] Warning: please pass a string as \`children\` (not: \`${options.children}\`)`);
        file = $eaf6b2f6c220a664$exports();
    }
    /** @type {Root} */ // @ts-expect-error we’ll throw if it isn’t a root next.
    const hastNode = processor.runSync(processor.parse(file), file);
    if (hastNode.type !== 'root') throw new TypeError('Expected a `root` node');
    /** @type {ReactElement} */ let result = $7fPBF.createElement($7fPBF.Fragment, {}, $c667ec5950b1e0aa$require$childrenToReact({
        options: options,
        schema: $08f3dd16e830a549$exports,
        listDepth: 0
    }, hastNode));
    if (options.className) result = $7fPBF.createElement('div', {
        className: options.className
    }, result);
    return result;
}
$c667ec5950b1e0aa$var$ReactMarkdown.defaultProps = {
    transformLinkUri: $ca710e916d97a4ec$exports
};
$c667ec5950b1e0aa$var$ReactMarkdown.propTypes = {
    // Core options:
    children: $1bfc5778dcd4841a$exports.string,
    // Layout options:
    className: $1bfc5778dcd4841a$exports.string,
    // Filter options:
    allowElement: $1bfc5778dcd4841a$exports.func,
    allowedElements: $1bfc5778dcd4841a$exports.arrayOf($1bfc5778dcd4841a$exports.string),
    disallowedElements: $1bfc5778dcd4841a$exports.arrayOf($1bfc5778dcd4841a$exports.string),
    unwrapDisallowed: $1bfc5778dcd4841a$exports.bool,
    // Plugin options:
    // type-coverage:ignore-next-line
    remarkPlugins: $1bfc5778dcd4841a$exports.arrayOf($1bfc5778dcd4841a$exports.oneOfType([
        $1bfc5778dcd4841a$exports.object,
        $1bfc5778dcd4841a$exports.func,
        $1bfc5778dcd4841a$exports.arrayOf($1bfc5778dcd4841a$exports.oneOfType([
            $1bfc5778dcd4841a$exports.object,
            $1bfc5778dcd4841a$exports.func
        ]))
    ])),
    // type-coverage:ignore-next-line
    rehypePlugins: $1bfc5778dcd4841a$exports.arrayOf($1bfc5778dcd4841a$exports.oneOfType([
        $1bfc5778dcd4841a$exports.object,
        $1bfc5778dcd4841a$exports.func,
        $1bfc5778dcd4841a$exports.arrayOf($1bfc5778dcd4841a$exports.oneOfType([
            $1bfc5778dcd4841a$exports.object,
            $1bfc5778dcd4841a$exports.func
        ]))
    ])),
    // Transform options:
    sourcePos: $1bfc5778dcd4841a$exports.bool,
    rawSourcePos: $1bfc5778dcd4841a$exports.bool,
    skipHtml: $1bfc5778dcd4841a$exports.bool,
    includeElementIndex: $1bfc5778dcd4841a$exports.bool,
    transformLinkUri: $1bfc5778dcd4841a$exports.oneOfType([
        $1bfc5778dcd4841a$exports.func,
        $1bfc5778dcd4841a$exports.bool
    ]),
    linkTarget: $1bfc5778dcd4841a$exports.oneOfType([
        $1bfc5778dcd4841a$exports.func,
        $1bfc5778dcd4841a$exports.string
    ]),
    transformImageUri: $1bfc5778dcd4841a$exports.func,
    components: $1bfc5778dcd4841a$exports.object
};
$c667ec5950b1e0aa$var$ReactMarkdown.uriTransformer = $ca710e916d97a4ec$exports;



const $951b7574116f6854$var$SubmitButton = ({ clickHandler: clickHandler, buttonText: buttonText })=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
        className: "my-2 mx-4 px-2 border border-black float-right",
        onClick: clickHandler,
        children: buttonText
    });
};
var $951b7574116f6854$export$2e2bcd8739ae039 = $951b7574116f6854$var$SubmitButton;



function $06dd75ab501b6458$export$3e8ae21f3aa88941(text) {
    return (text || '').replace(/javascript|script/gmi, 'manananggal');
}


const $5df3f14f88e06d0f$var$Thread = ()=>{
    var _state_thread;
    const params = (0, $d9fd026bfea79ab9$export$99eaa27ddbbb95ef)();
    const [state, setState] = (0, $7fPBF.useState)({
        threadId: params['threadId'],
        wasPreviewPost: false
    });
    (0, $aba38a333ca575f4$export$efa9a398d6368992).info(`thread render - ${JSON.stringify(location)} ${JSON.stringify(state)} `);
    (0, $7fPBF.useEffect)(()=>{
        (0, $80ff0d33b75baa64$export$50f8d0ec9c6605e5)({
            threadId: state.threadId
        }).then((thread)=>setState((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                thread: thread
            })));
    }, [
        (0, $80ff0d33b75baa64$export$1ab060d62ab3aa6b),
        state.threadId
    ]);
    const textEntryField = (0, $7fPBF.useRef)(null);
    const handleSubmit = (e)=>{
        e.preventDefault();
    };
    const handlePostClick = (e)=>{
        var _textEntryField_current;
        e.preventDefault();
        const body = (textEntryField === null || textEntryField === void 0 ? void 0 : (_textEntryField_current = textEntryField.current) === null || _textEntryField_current === void 0 ? void 0 : _textEntryField_current.value) || '';
        (0, $80ff0d33b75baa64$export$923edb1ec4cf1c8a)({
            threadId: state.threadId,
            body: body
        }).then((thread)=>{
            setState((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                thread: thread,
                wasPreviewPost: false
            }));
        });
        textEntryField.current && (textEntryField.current.value = '');
    };
    const handlePreviewClick = (e)=>{
        var _textEntryField_current;
        e.preventDefault();
        const body = (textEntryField === null || textEntryField === void 0 ? void 0 : (_textEntryField_current = textEntryField.current) === null || _textEntryField_current === void 0 ? void 0 : _textEntryField_current.value) || '';
        (0, $80ff0d33b75baa64$export$5c0c7399b5e4fa32)({
            threadId: state.threadId,
            body: body
        }).then((thread)=>{
            setState((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                thread: thread,
                wasPreviewPost: true
            }));
        });
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "container mx-auto",
        children: [
            !state.thread && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                children: "loading"
            }),
            state.thread && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                        children: state.thread.title
                    }),
                    (_state_thread = state.thread) === null || _state_thread === void 0 ? void 0 : _state_thread.postList.posts.map($5df3f14f88e06d0f$var$getPostLine),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "w-full flex",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("form", {
                            className: "p-2 pb-0 w-full flex",
                            onSubmit: handleSubmit,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                className: "mt-3 flex-grow max-w-96",
                                type: "text",
                                placeholder: "what's on your mind, friend?",
                                id: "customTextField",
                                ref: textEntryField
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "pt-10 ",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4b8394bab55ada7c$export$2e2bcd8739ae039), {
                                toPath: "/board",
                                linkText: "back to the shit..."
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $951b7574116f6854$export$2e2bcd8739ae039), {
                                clickHandler: handlePostClick,
                                buttonText: "post"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $951b7574116f6854$export$2e2bcd8739ae039), {
                                clickHandler: handlePreviewClick,
                                buttonText: "preview"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
function $5df3f14f88e06d0f$var$getPostLine(post, index) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "w-full pt-6",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "mx-10 text-xs font-bold",
                children: [
                    post.authorHandle,
                    ' - ',
                    post.postDate.toLocaleDateString(undefined, {
                        hour: '2-digit',
                        minute: '2-digit'
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "text-s font-light",
                children: post.textMode === 'markdown' ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c667ec5950b1e0aa$exports))), {
                    children: (0, $06dd75ab501b6458$export$3e8ae21f3aa88941)(post.body)
                }) : (0, $06dd75ab501b6458$export$3e8ae21f3aa88941)(post.body)
            })
        ]
    }, 'chatline-' + index);
}
var $5df3f14f88e06d0f$export$2e2bcd8739ae039 = $5df3f14f88e06d0f$var$Thread;




const $756369d12db55733$var$BoardHelp = ()=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                    children: "halp"
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4b8394bab55ada7c$export$2e2bcd8739ae039), {
                    toPath: "/board",
                    linkText: "back to the shit..."
                })
            })
        ]
    });
};
var $756369d12db55733$export$2e2bcd8739ae039 = $756369d12db55733$var$BoardHelp;






var $7fPBF = parcelRequire("7fPBF");





const $b02d31956f836ac1$var$NewThread = ()=>{
    const params = (0, $d9fd026bfea79ab9$export$99eaa27ddbbb95ef)();
    const [state, setState] = (0, $7fPBF.useState)({
        threadId: params['threadId'],
        wasPreviewPost: false
    });
    (0, $aba38a333ca575f4$export$efa9a398d6368992).info(`thread render - ${JSON.stringify(location)} ${JSON.stringify(state)} `);
    (0, $7fPBF.useEffect)(()=>{
        (0, $80ff0d33b75baa64$export$50f8d0ec9c6605e5)({
            threadId: state.threadId
        }).then((thread)=>setState((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                thread: thread
            })));
    }, [
        (0, $80ff0d33b75baa64$export$1ab060d62ab3aa6b),
        state.threadId
    ]);
    const textEntryField = (0, $7fPBF.useRef)(null);
    const handleSubmit = (e)=>{
        e.preventDefault();
    };
    const handlePostClick = (e)=>{
        var _textEntryField_current;
        e.preventDefault();
        const body = (textEntryField === null || textEntryField === void 0 ? void 0 : (_textEntryField_current = textEntryField.current) === null || _textEntryField_current === void 0 ? void 0 : _textEntryField_current.value) || '';
        (0, $80ff0d33b75baa64$export$923edb1ec4cf1c8a)({
            threadId: state.threadId,
            body: body
        }).then((thread)=>{
            setState((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                thread: thread,
                wasPreviewPost: false
            }));
        });
        textEntryField.current && (textEntryField.current.value = '');
    };
    const handlePreviewClick = (e)=>{
        var _textEntryField_current;
        e.preventDefault();
        const body = (textEntryField === null || textEntryField === void 0 ? void 0 : (_textEntryField_current = textEntryField.current) === null || _textEntryField_current === void 0 ? void 0 : _textEntryField_current.value) || '';
        (0, $80ff0d33b75baa64$export$5c0c7399b5e4fa32)({
            threadId: state.threadId,
            body: body
        }).then((thread)=>{
            setState((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                thread: thread,
                wasPreviewPost: true
            }));
        });
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "container mx-auto",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                    children: "awwwww yeah, a new thread, cool"
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "w-full flex",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("form", {
                        className: "p-2 pb-0 w-full flex",
                        onSubmit: handleSubmit,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                            className: "mt-3 flex-grow max-w-96",
                            type: "text",
                            placeholder: "what's on your mind, friend?",
                            id: "customTextField",
                            ref: textEntryField
                        })
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "pt-10 ",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4b8394bab55ada7c$export$2e2bcd8739ae039), {
                            toPath: "/board",
                            linkText: "back to the shit..."
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $951b7574116f6854$export$2e2bcd8739ae039), {
                            clickHandler: handlePostClick,
                            buttonText: "post"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $951b7574116f6854$export$2e2bcd8739ae039), {
                            clickHandler: handlePreviewClick,
                            buttonText: "preview"
                        })
                    ]
                })
            ]
        })
    });
};
var $b02d31956f836ac1$export$2e2bcd8739ae039 = $b02d31956f836ac1$var$NewThread;


const $5c121a02b943fe91$export$85d9b6fcaff03f4e = 30;
const $5c121a02b943fe91$var$initialState = {
    authSpinner: 'refreshing tokens...',
    globalSubscribeComplete: false
};
function $5c121a02b943fe91$var$App() {
    (0, $aba38a333ca575f4$export$efa9a398d6368992).debug('app render');
    const [state] = (0, $7fPBF.useState)($5c121a02b943fe91$var$initialState);
    (0, $aba38a333ca575f4$export$efa9a398d6368992).debug(`app render - state is ${state.authSpinner}`);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7444594dc418e4bf$export$122994dc05ba4308).Provider, {
        value: (0, $7444594dc418e4bf$export$dfe60afd992a4bb4),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $97cadf28d7015811$export$af54d3055d90c64e).Provider, {
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($5c121a02b943fe91$var$TopLevel, {})
        })
    });
}
const $5c121a02b943fe91$var$TopLevel = ()=>{
    const offlineStates = [
        'auth.validity_check_error',
        'auth.awaiting_validity_check',
        'auth.awaiting_device_code',
        'auth.disconnected'
    ];
    const cnState = (0, $97cadf28d7015811$export$af54d3055d90c64e).useSelector((state)=>state);
    (0, $6751a9fb820f7fe4$export$6f7f5ce9dcbf3b14)(cnState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "App bg-classicgray",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $de77e498e07914bf$export$f2815235e76a62b9), {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "mb-1 mt-px",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0cf24fd73ae067c$export$b0d92dbee9b5b60d), {
                        className: "m-1 px-2 border border-black",
                        to: "/",
                        children: "lobby"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0cf24fd73ae067c$export$b0d92dbee9b5b60d), {
                        className: "m-1 px-2 border border-black",
                        to: "/profile",
                        children: "profile"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0cf24fd73ae067c$export$b0d92dbee9b5b60d), {
                        className: "m-1 px-2 border border-black",
                        to: "/nowhere",
                        children: "nowhere"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0cf24fd73ae067c$export$b0d92dbee9b5b60d), {
                        className: "m-1 px-2 border border-black float-right",
                        to: "/logout",
                        children: "logout"
                    })
                ]
            }),
            offlineStates.some((item)=>cnState.matches(item)) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9d4391632bf044f$export$2e2bcd8739ae039), {}) || /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $d9fd026bfea79ab9$export$3565eb3d00ca5a74), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                        path: "/",
                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $43424e6e7309dcf2$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $23d43ae99e1b6b9b$export$2e2bcd8739ae039), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                        path: "/login",
                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $20dc0d100ee0f619$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                        path: "/logout",
                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $911b334883a2df86$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                        path: "/profile",
                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $43424e6e7309dcf2$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $980dafbea53ad318$export$2e2bcd8739ae039), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                        path: "/host",
                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $43424e6e7309dcf2$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $98c445d6f7bf367a$export$2e2bcd8739ae039), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                        path: "/board",
                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $43424e6e7309dcf2$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e1a760571d0383c0$export$2e2bcd8739ae039), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                        path: "/board-help",
                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $43424e6e7309dcf2$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $756369d12db55733$export$2e2bcd8739ae039), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                        path: "/new-thread",
                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $43424e6e7309dcf2$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b02d31956f836ac1$export$2e2bcd8739ae039), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                        path: "/thread/:threadId",
                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $43424e6e7309dcf2$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5df3f14f88e06d0f$export$2e2bcd8739ae039), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                        path: "/win/:gameId",
                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $43424e6e7309dcf2$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $56dafa00af6a4d90$export$2e2bcd8739ae039), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                        path: "/win",
                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $43424e6e7309dcf2$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $56dafa00af6a4d90$export$2e2bcd8739ae039), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                        path: "/ohhell/:gameId",
                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $43424e6e7309dcf2$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $71a155b2c0330589$export$2e2bcd8739ae039), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                        path: "/ohhell",
                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $43424e6e7309dcf2$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $71a155b2c0330589$export$2e2bcd8739ae039), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                        path: "/default",
                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$444b3ab0cb9aec40), {
                            to: '/'
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                        path: "*",
                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e6f11aad72bc1edc$export$2e2bcd8739ae039), {})
                    })
                ]
            })
        ]
    });
};
var $5c121a02b943fe91$export$2e2bcd8739ae039 = $5c121a02b943fe91$var$App;






var $7fPBF = parcelRequire("7fPBF");

class $a149a0df64210f0c$var$ErrorBoundary extends (0, $7fPBF.Component) {
    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        (0, $aba38a333ca575f4$export$efa9a398d6368992).error(`oh my.  getting derived state after: ${JSON.stringify(error)}`);
        return {
            hasError: true,
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        (0, $aba38a333ca575f4$export$efa9a398d6368992).error(`oh my.  We caught: ${JSON.stringify(error)}, ${JSON.stringify(errorInfo)}`);
        this.setState({
            hasError: true,
            error: error
        });
    }
    render() {
        var _this_state_error;
        if (this.state.hasError) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("h1", {
            children: [
                "Error. $",
                (_this_state_error = this.state.error) === null || _this_state_error === void 0 ? void 0 : _this_state_error.message,
                ". Try a page refresh?"
            ]
        });
        return this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false,
            error: undefined
        };
    }
}
var $a149a0df64210f0c$export$2e2bcd8739ae039 = $a149a0df64210f0c$var$ErrorBoundary;


document.body.classList.add('Baseline');
(0, (/*@__PURE__*/$parcel$interopDefault($b4ba1c853f6e1116$exports))).render(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).StrictMode, {
    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a149a0df64210f0c$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0cf24fd73ae067c$export$9ba4e89fdfa1fc54), {
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5c121a02b943fe91$export$2e2bcd8739ae039), {})
        })
    })
}), document.getElementById('root'));


//# sourceMappingURL=client.e877b5bf.js.map
